const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Tsukuyomi Background",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Failed to publish due to excessive scene assets. Please delete some assets and try again.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Currently no permission to access membership-related features",
  T_12_I_GIFT_SENDER_BELL: "Clopoțel",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: `Ba îl vezi, ba nu îl vezi!
 [FFB300](Ascunde Casca)[-]`,
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Mască Old Man's",
  T_12_L_COS_PINKMAN: "Pink Dino",
  T_12_L_COS_POLAR: "Polar Bear",
  T_12_L_COS_RENDER: "Rainbow Dino",
  T_12_L_COS_TIGER: "Costum Tiger",
  T_12_L_MALE_BOTTOM_COS_ELF: "Winter Elf (Pantaloni)",
  T_12_L_MALE_COS_SANTA: "Grumpy Old Man",
  T_12_L_MALE_HAIR_COS_ELF: "Winter Elf (Cap)",
  T_12_L_MALE_SHOE_COS_ELF: "Winter Elf (Pantofi)",
  T_12_L_MALE_TOP_COS_ELF: "Winter Elf (Haină)",
  T_12_O_CAT_NAME: "Kitty",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014-Winterlands",
  T_12_O_MACHETE_GOLD_NAME: "Golden Blade",
  T_12_O_PET_TITLE: "ANIMAL",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Pantofi de săritură",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Pantofi realizați folosind tehnologii moderne. Permit utilizatorului să facă salturi duble.",
  T_12_Q_ITEM_FLYSHOE: "Pantofi Jet Pack",
  T_12_Q_ITEM_FLYSHOE_DESC: "Pantofi care permit utilizatorului să zboare. Încearcă să nu rămâi fără combustibil în aer.",
  T_12_Q_ITEM_STOCK1: "Stock Nivel 1",
  T_12_Q_ITEM_STOCK2: "Stock Nivel 2",
  T_12_Q_ITEM_STOCK3: "Stock Nivel 3",
  T_12_Q_ITEM_TREATMENTGUN: "Pistol de tratament",
  T_12_Q_ITEM_VEST4: "Vestă Nivel 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Shoot Dance",
  T_12_R_EMOTE_WAVE_NAME: "Arm Wave",
  T_12_R_SKILL_NAME_GANGLEADER: "Spiritul gangsterului",
  T_12_R_SKILL_NAME_MONKEYGOD: "Camuflaj",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Mașină amfibie",
  T_13_I_COLLECTION_V_JEEP: "Jeep",
  T_13_I_COLLECTION_V_MONSTER: "Monster Truck",
  T_13_I_COLLECTION_V_MOTOBIKE: "Motocicletă",
  T_13_I_COLLECTION_V_ROADSTER: "Mașină sport",
  T_13_I_COLLECTION_V_SUV: "Camionetă",
  T_13_I_COLLECTION_V_TUTU: "Tuk Tuk",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Arctic Blue (Mască)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Love in the Air (Pantaloni)",
  T_13_L_MALE_HAIR_COS_BJD: "Arctic Blue (Cap)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Love in the Air (Haină)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Armă",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Skin: Detective Kitty",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR- Cupid",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Baby Shark",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Push-up",
  T_13_R_EMOTE_EGYPT_NAME: "Mummy Dance",
  T_13_R_PVE_WEAPON_SLOT: "SLOT ARMĂ",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Raza efectivă",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Rata de tragere",
  T_13_R_SKILL_DESC_HACKERGIRL: "Marchează inamicii loviți timp de {0} secunde. Informația va fi partajată cu coechipierii.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Ochiul hacker-ului",
  T_13_Z_KICKOFF_BAN: "INTERDICȚIE",
  T_13_Z_ROOM_MORNING: "Zi",
  T_13_Z_ROOM_NIGHT: "Noapte",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "SPLASH!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Cubic Bunny",
  T_14_L_COS_EASTER: "Observer 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Lady of Flame (Pantofi)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Bunny Warrior (Mască)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47- Water Balloon",
  T_14_O_DOG_NAME: "Cățeluș mecanic",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Skin: Full Steel Pup",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Skin: Lightning Pup",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Skin: Magnetic Pup",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Skin: Night Kitty",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR-Blood Moon",
  T_14_O_SCAR_SHARK_NAME: "SCAR- Shark Attack",
  T_14_Q_ITEM_RGS50: "Lansator anti-material",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "Cu fiecare {0}% sustrase din valoarea HP maximă, penetrarea armurii crește cu {1}%.",
  T_14_R_SKILL_NAME_SAMURAI: "Bushido",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Hunger Strike (Mască)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Venom Touch (Mască)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Hunger Strike (Pantaloni)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Venom Touch (Pantaloni)",
  T_15_L_MALE_SHOE_COS_FAIM: "Hunger Strike (Pantofi)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Venom Touch (Pantofi)",
  T_15_L_MALE_TOP_COS_FAIM: "Hunger Strike (Haină)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Venom Touch (Haină)",
  T_15_L_TOP_COS_MOTHERSDAY: "Best Mom",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94- Cataclysm",
  T_15_O_BASEBALLBAT_VIKING_NAME: "The Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014- Cataclysm",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1- Cataclysm",
  T_15_O_PANTHER_NAME: "Night Panther",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Skin: Captain",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Skin: Golden Leopard",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Skin: Domination",
  T_15_O_SKS_DEATH_NAME: "SKS- Death Wish",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP- Cataclysm",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "Gatling",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Shake With Me",
  T_15_R_SKILL_DESC_AGENT: "Precizia crește cu {0}% când se folosește vizorul.",
  T_15_R_SKILL_NAME_AGENT: "Țintaș",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Purple Wings",
  T_16_B_ITEM_GRAPPLINGHOOK: "Cârlig de cățărare",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Armă cu cârlig de cățărare",
  T_16_L_MALE_COS_LEGO: "Mad Brickman",
  T_16_L_MALE_SHOE_COS_SUMMER: "Summer Holidays (Pantofi)",
  T_16_P_MANUAL_MONSTER: "Monster Truck",
  T_16_P_MANUAL_MUSHROOM1: "Ciupercă nivel 1",
  T_16_P_MANUAL_MUSHROOM2: "Ciupercă nivel 2",
  T_16_P_MANUAL_MUSHROOM3: "Ciupercă nivel 3",
  T_16_P_MANUAL_MUSHROOM4: "Ciupercă nivel 4",
  T_16_P_MANUAL_ROADSTER_DESC: "Mașină sport elegantă. Nivel HP scăzut, dar are o viteză maximă nebună. Poate transporta până la 2 jucători.",
  T_16_P_MANUAL_STROP: "Tiroliană",
  T_16_P_MANUAL_SUV: "Camionetă",
  T_16_P_MANUAL_SUV_DESC: "Vehiculul Free Fire par excellence. Armură medie și viteză maximă. Poate transporta până la 2 jucători.",
  T_16_P_MANUAL_TUTU_DESC: "Un vehicul cu nivel HP scăzut și mișcare lentă. Poate transporta până la 3 jucători.",
  T_16_P_MANUAL_WEAPON_AR: "Pușcă de asalt",
  T_16_P_MANUAL_WEAPON_BOMB: "Grenade",
  T_16_P_MANUAL_WEAPON_PISTOL: "Pistol",
  T_16_P_MANUAL_WEAPON_SG: "Pușcă",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "Sniper",
  T_16_Q_MINISENTRY: "Mini-turele",
  T_16_Q_MINISENTRY_DESC: "Turelă automată proiectată folosind tehnologii moderne. Acesta va scana și ataca inamicii din apropiere.",
  T_16_R_EMOTE_DESERT_NAME: "Furious Slam",
  T_16_R_EMOTE_EPHUNTER_NAME: "Battle Dance",
  T_16_R_EMOTE_EPHUNTER2_NAME: "High Five",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Moon Flip",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Wiggle walk",
  T_16_W_AK_FIRE_NAME: "AK47- Flaming Red",
  T_16_W_SCAR_LLENN_NAME: "SCAR- Pink Devil",
  T_16_W_SCAR_WATER_NAME: "SCAR- Water Elemental",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Detectiv Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Skin: Wild Panda",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Skin: Skull Panda",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Skin: Lightning Panda",
  T_17_B_CS_MODE_NAME: "Clash Squad",
  T_17_C_SKILL_NAME_PLAYBOY: "Mișcare nebunească",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Royal Jester (Mască)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Bloody Mistress (Mască)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Bloody Mistress (Pantaloni)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Magical Fox (Cap)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Bloody Mistress (Pantofi)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Bloody Mistress (Haină)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vampire's Revenge (Mască)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Street Thug (Pantaloni)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vampire's Revenge (Pantaloni)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Purple Shade (Cap)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "The Gentleman (Pantofi)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vampire's Revenge (Pantofi)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vampire's Revenge (Haină)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Golden Shade (Haină)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Skin: Meow Princess",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Skin: Golden Tale",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Skin: Deep Blue",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Skin: Lucky Green",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Planor",
  T_17_Q_FOLDWINGS_DESC: "Îți permite să planezi prin aer de la înălțimi mari",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Party Dance",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS- Vampire",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR- Phantom Assassin",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR- Old Fashioned",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Nume",
  T_17_Z_ROOM_JUMP_SWITCH: "Înălțime săritură",
  T_17_Z_ROOM_SPEED_SWITCH: "Viteză de mișcare",
  T_18_B_THROWINGKNIFE_NAME: "Cuțit FF",
  T_18_C_DUMMY_NAME: "Grenadă falsă",
  T_18_C_SKILL_DESC_DJMALE: "Creează o aură de {1}m care mărește viteza de mișcare cu {3}% și reface {2} HP pe secundă timp de {0}sec. Efectele nu se cumulează. Timp de reactivare: {4}sec.",
  T_18_C_SKILL_NAME_DJMALE: "Ține ritmul",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Reciclare echipament",
  T_18_L_COS_INDIANEWYEAR: "Diwali Dino",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Frowny Face",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Flaming Red (Mască)",
  T_18_O_FOX_NAME: "Spirit Fox",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Skin: Battle Fox",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Skin: Blue Fox",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Skin: Lava Pumpkin",
  T_18_O_PETSKIN_PINKFOX_NAME: "Skin: Red Fox",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Skin: Spirit",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1- Flaming Skull",
  T_18_W_UMP_GEISHA_N: "UMP- Art of War",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Placă de surf electrică",
  T_19_C_ICE_GUN_NAME: "Armă cu gheață",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Daunele provocate de armele explozive cresc cu {0}%; raza acestora crește cu {1}%",
  T_19_C_SKILL_DESC_TOMBOY: "Atunci când conduci un vehicul, reface viața tuturor coechipierilor din vehicul cu {1} HP în fiecare {0}sec. Efectele nu se cumulează.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Arta demolării",
  T_19_C_SKILL_NAME_TOMBOY: "Binecuvântarea pilotului",
  T_19_I_EVENT_INFI_ITEM: "Nelimitat",
  T_19_L_A_ICEFESTIVAL19_B: "Last Laugh",
  T_19_L_F_S_ICEFESTIVAL: "Snowy Servitude (Pantofi)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disco Fiasco (Pantaloni)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disco Fiasco (Cap)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disco Fiasco (Haină)",
  T_19_O_PETSKIN_NAME: "Skin: Implicit",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Skin: Hiphop Panda",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Skin: Polar Panda",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Skin: Pharaoh's Robo",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Skin: Spring Festival Robo",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Skin: Snowy Robo",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Skin: Hiphop Shiba",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "Team Deathmatch",
  T_19_R_EMOTE_MIGUEL_NAME: "Break dance",
  T_19_S_SECOND_WEAPON_TITLE: "Armă secundară",
  T_19_S_VEST_TITLE: "Vestă antiglonț",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Încărcător dublu",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA- Tagger's Revolt",
  T_19_W_M60_ICEFESTIVAL_N: "M60- Santa's Choice",
  T_19_W_MP40_PARK_N: "MP40- Carnival Carnage",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR- Aurous Dragon",
  T_19_X_PVE_SAMURAINAME: "Samuraiul Gardian",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inhalator",
  T_20_C_SKILL_DESC_PARKOURGUY: "Când folosești arme, lovirea unui inamic îți reface puțină viață, iar doborârea acestuia îți reface {0}% din HP.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Refugiu pictat",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Viteză mortală",
  T_20_C_SKILL_NAME_PARKOURGUY: "Raiduri susținute",
  T_20_L_A_APRILFOOL2020: "Doggo",
  T_20_L_F_A_METALHEAD_RED: "Ms. Fiery Imp-Head (Mască)",
  T_20_L_F_B_THAIGIRL: "Phoenix Accession (Pantaloni)",
  T_20_L_F_H_KILLERCUPID: "Sweetheart Cupid (Cap)",
  T_20_L_F_H_THAIGIRL: "Phoenix Accession (Cap)",
  T_20_L_F_S_THAIGIRL: "Phoenix Accession (Pantofi)",
  T_20_L_F_T_METALHEAD_RED: "Ms. Fiery Imp-Head (Haină)",
  T_20_L_F_T_THAIGIRL: "Phoenix Accession (Haină)",
  T_20_L_JEANDINO: "Denim Dino",
  T_20_L_M_A_METALHEAD_RED: "Mr. Fiery Imp-Head (Mască)",
  T_20_L_M_T_METALHEAD_RED: "Mr. Fiery Imp-Head (Haină)",
  T_20_L_M_T_STOCKING: "Gentle-man (Haină)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Skin: Valentine's Fox",
  T_20_P_CHANNEL_G: "Clan",
  T_20_P_WORLD_SSPEAKER: "Difuzor",
  T_20_S_CSROOM_COIN: "Monedă implicită",
  T_20_U_SHIELD_GUN_NAME: "Armă scut",
  T_20_W_AN94_METALHEAD_N: "AN94- Carrot Imp-Head",
  T_20_W_P90_EVILBONE_N: "P90- The Punishers",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly "the Swift"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Emană fum și e excelentă pentru manevre de jalonare și învăluire",
  T_21_B_SMOKEGRENADE_NAME: "Grenadă fumigenă",
  T_21_C_AUTOPICKUP_AVERAGE: "Implicit",
  T_21_C_SKILL_DESC_KPOPSINGER: "Crește efectele articolelor de vindecare cu {0}% și abilitățile de vindecare cu {1}%. Reduce cu {2}% pierderea de HP a aliaților atunci când sunt doborâți. Efectele nu se cumulează.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Fiecare inamic ucis crește nr. maxim de HP cu {0}, până la {1}.",
  T_21_C_SKILL_NAME_KPOPSINGER: "Cântec tămăduitor",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Hat-trick",
  T_21_L_ANGELICAL: "Angel Dino",
  T_21_L_S_VNSLIPPER: "Papuci vietnamezi",
  T_21_O_OTTER_NAME: "Ottero",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Skin: Radioactive Ottero",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Skin: Sakura Ottero",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Skin: Neon Ottero",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Skin: Master of Death",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Skin: Lightning Bolt",
  T_21_R_EMOTE_SORROW_NAME: "Why? Oh Why?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Rucsac Punkster",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Death's Final Strike",
  T_21_W_M79_RABBITKILLER_N: "M79- Hipster Bunny",
  T_21_W_PAN_VOLCANO_N: "Tigaie- Volcanic Fury",
  T_21_W_XM8_RAINBOW_N: "XM8- Abyssal",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Localizează poziția inamicilor care se află în raza de {0}m și nu sunt în poziția culcat sau ghemuit. Durează {1}sec. Timp de reactivare: {2}sec. Pozițiile pot fi văzute și de coechipieri.",
  T_22_C_SKILL_NAME_DETECTIVE: "Pe urme",
  T_22_C_SKILL_NAME_STREAMERGUY: "Limelight",
  T_22_L_F_H_COLLEGE: "Bloodshot Junior (Cap)",
  T_22_L_F_S_SUMMER20: "Summer Darling (Pantofi)",
  T_22_L_M_A_GREENCOAT: "Lush Clubber (Mască)",
  T_22_L_M_A_PINKFUR: "Sakura Clubber (Mască)",
  T_22_L_M_A_PLAGUE2: "Plague Phantom (Mască)",
  T_22_L_M_B_FAIM2: "Famine Felon (Pantaloni)",
  T_22_L_M_B_GREENCOAT: "Lush Clubber (Pantaloni)",
  T_22_L_M_B_PINKFUR: "Sakura Clubber (Pantaloni)",
  T_22_L_M_B_PLAGUE2: "Plague Phantom (Pantaloni)",
  T_22_L_M_B_REDPANTS: "Trendy Clubber (Pantaloni)",
  T_22_L_M_B_TIGERSTRIPE: "Tiger Clubber (Pantaloni)",
  T_22_L_M_H_COLLEGE: "Bloodshot Senior (Cap)",
  T_22_L_M_H_FAIM2: "Famine Felon (Cap)",
  T_22_L_M_H_GREENCOAT: "Lush Clubber (Cap)",
  T_22_L_M_H_PINKFUR: "Sakura Clubber (Cap)",
  T_22_L_M_H_PLAGUE2: "Plague Phantom (Cap)",
  T_22_L_M_H_REDPANTS: "Trendy Clubber (Cap)",
  T_22_L_M_H_TIGERSTRIPE: "Tiger Clubber (Cap)",
  T_22_L_M_S_FAIM2: "Famine Felon (Pantofi)",
  T_22_L_M_S_PLAGUE2: "Plague Phantom (Pantofi)",
  T_22_L_M_T_FAIM2: "Famine Felon (Haină)",
  T_22_L_M_T_GREENCOAT: "Lush Clubber (Haină)",
  T_22_L_M_T_PINKFUR: "Sakura Clubber (Haină)",
  T_22_L_M_T_PLAGUE2: "Plague Phantom (Haină)",
  T_22_L_M_T_REDPANTS: "Trendy Clubber (Haină)",
  T_22_L_M_T_TIGERSTRIPE: "Tiger Clubber (Haină)",
  T_22_LC_KAR98K_COLLEGE_N: "KAR98K- Rebel Academy",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Tigaie- Watermelon",
  T_22_LC_SCAR_HERMIT_N: "SCAR- Mystic Seeker",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Pistol de tratament- Lifebeam",
  T_22_O_HAWK_NAME: "Falco",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Skin: Apocalypse Fox",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Skin: Hellfire Falco",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Skin: Evergreen Falco",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Skin: Sunshine Shiba",
  T_22_Q_BOMB_PLIERS: "Clește pentru dezamorsare",
  T_22_R_EMOTE_SHIMMY_NAME: "Shimmy",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Penetrare armură",
  T_22_U_WPNSKN_SPEED_RUN: "Viteză de mișcare",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Horizaline",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Arta tăișului",
  T_23_C_SKILL_NAME_SWATGUY: "Reîncărcare furioasă",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Firebrand"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Big Bucks Vibe (Pantaloni)",
  T_23_L_F_B_MIKOGIRL: "Arcticfire Priestess (Pantaloni)",
  T_23_L_F_B_NAVYGIRL: "Navy Girl (Pantaloni)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Big Bucks Vibe (Cap)",
  T_23_L_F_H_MIKOGIRL: "Arcticfire Priestess (Cap)",
  T_23_L_F_H_NAVYGIRL: "Navy Girl (Cap)",
  T_23_L_F_S_MIKOGIRL: "Arcticfire Priestess (Pantofi)",
  T_23_L_F_S_ORDERCHALLENGER: "Heist Mastermind (Pantofi)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Big Bucks Vibe (Haină)",
  T_23_L_F_T_MIKOGIRL: "Arcticfire Priestess (Haină)",
  T_23_L_F_T_NAVYGIRL: "Navy Girl (Haină)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Big Bucks Rapper (Mască)",
  T_23_L_M_B_FOXGUY: "Arcticfire Priest (Pantaloni)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Big Bucks Rapper (Pantaloni)",
  T_23_L_M_H_FOXGUY: "Arcticfire Priest (Cap)",
  T_23_LC_SKS_GEMINI_N: "SKS- Hysteria",
  T_23_O_PENGUIN_NAME: "Mr. Waggor",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Skin: Party Waggor",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Skin: Cyber Waggor",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Skin: Gold Waggor",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Clash Squad",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Personaj",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "AVERTISMENT",
  T_24_C_FLAMETHROWER_NAME: "Aruncător de flăcări",
  T_24_C_SKILL_DESC_PROFESSOR: "Valoarea max. EP crește cu {0}. Mod Jiu-jitsu: Aliații în raza de {2}m beneficiază de o creștere de {1}% a ratei de conversie EP. Mod Psihologie: recuperezi {5} EP la fiecare {4}sec, până la {6} EP. Timp de reactivare pentru comutare mod: {3}sec.",
  T_24_C_SKILL_NAME_PARTYGIRL: "Petrecerea continuă",
  T_24_C_SKILL_NAME_PROFESSOR: "Maestru atotputernic",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "Pantaloni MAX",
  T_24_L_H_PUMPKIN2020_A: "Twisted Pumpkin (Cap)",
  T_24_L_T_TSHIRT_COMEDIAN: "Last Shot Hero",
  T_24_LC_MP5_RICHBOXER_N: "MP5- Champion Boxer",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR- Party Animal",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- Swordsman Legends",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Scor total",
  T_24_V_TRAINING_BOX_ATTACH: "Atașamente",
  T_24_V_TRAINING_BOX_WEAPON: "Arme",
  T_24_W_ARMORY: "Armă",
  T_24_W_ARMOTY_MELEE: "Melee",
  T_24_W_ARMOTY_PISTOL: "Pistol",
  T_24_W_ARMOTY_RIFLE: "Pușcă de asalt",
  T_24_W_ARMOTY_SHOTGUN: "Pușcă",
  T_24_W_ARMOTY_SNIPER: "Sniper",
  T_24_W_ARMOTY_SPECIAL: "Altele",
  T_24_W_ARMOTY_SUBMACHINE: "SMG",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Skin: Booyah Panda",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Skin: Skeleton Rockie",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Skin: Party Rockie",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Skin: Undead Rockie",
  T_24_W_RACCOON_N: "Rockie",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Clepsidra timpului",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Prestabilit 1",
  T_25_E_HUD_02: "Prestabilit 2",
  T_25_L_F_B_DEMONKILLER: "Frenzy Junior (Pantaloni)",
  T_25_L_F_H_DEMONKILLER: "Frenzy Junior (Cap)",
  T_25_L_F_S_DEMONKILLER: "Frenzy Junior (Pantofi)",
  T_25_L_F_T_DEMONKILLER: "Frenzy Junior (Haină)",
  T_25_L_HA_FP_EVIL: "Evil (Vopsea pentru față)",
  T_25_L_M_H_ANIMEHAIR: "Breezy (Păr)",
  T_25_L_S_MAXSNEAKERS: "MAX Sneakers",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "Gloo Wall- Winterlands 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887- Winterlands 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Cyber Blade",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90- Tune Blaster Green",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- Tune Blaster Red",
  T_25_LC_PAN_BOUNTY_N: "Tigaie- Cyber Bounty Hunter",
  T_25_R_LEGEND_REMIND: "Memento",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Coasă",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Beaston",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Skin: Glacier Beaston",
  T_25_W_PETSKIN_BABOON_HELL_N: "Skin: Blazing Beaston",
  T_25_W_PETSKIN_BABOON_PURE_N: "Skin: Great White Beaston",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Skin: Snow Panther",
  T_25_Z_R_SIMULATOR_OFF: "Nu permite",
  T_26_C_SKILL_DESC_SUPERSTAR: "Dezlănțuie frontal o undă sonoră, afectând {1} Gloo Wall-uri în raza de {0}m. Timp de reactivare: {2}sec. În plus, fiecare Gloo Wall activ va accelera recuperarea de HP începând cu {3} puncte. Efectele de recuperare nu se cumulează.",
  T_26_C_SKILL_NAME_SUPERSTAR: "Ritmul mareei",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "Dronă ușoară",
  T_26_L_A_FLAMING_PREM: "Infernal Soldier (Mască)",
  T_26_L_A_SANTAMODE: "Snowman Bob (Mască)",
  T_26_L_B_SANTAMODE: "Snowman Bob (Pantaloni)",
  T_26_L_F_B_WATERFEST21_A: "Summer Breeze (Pantaloni)",
  T_26_L_F_H_WATERFEST21_A: "Summer Breeze (Cap)",
  T_26_L_F_S_WATERFEST21_A: "Summer Breeze (Pantofi)",
  T_26_L_F_T_WATERFEST21_A: "Summer Breeze (Haină)",
  T_26_L_M_A_EGGDAY2021: "Cyber Bunny (Mască)",
  T_26_L_M_B_EGGDAY2021: "Cyber Bunny (Pantaloni)",
  T_26_L_M_B_PAIRING: "Dynamic Duo M (Pantaloni)",
  T_26_L_M_B_WATERFEST21_A: "Summer Wave (Pantaloni)",
  T_26_L_M_H_EGGDAY2021: "Cyber Bunny (Cap)",
  T_26_L_M_H_PAIRING: "Dynamic Duo M (Cap)",
  T_26_L_M_H_WATERFEST21_A: "Summer Wave (Cap)",
  T_26_L_M_S_EGGDAY2021: "Cyber Bunny (Pantofi)",
  T_26_L_M_S_PAIRING: "Dynamic Duo M (Pantofi)",
  T_26_L_M_S_WATERFEST21_A: "Summer Wave (Pantofi)",
  T_26_L_M_T_EGGDAY2021: "Cyber Bunny (Haină)",
  T_26_L_M_T_PAIRING: "Dynamic Duo M (Haină)",
  T_26_L_M_T_WATERFEST21_A: "Summer Wave (Haină)",
  T_26_L_S_SANTAMODE: "Snowman Bob (Pantofi)",
  T_26_L_T_SANTAMODE: "Snowman Bob (Haină)",
  T_26_LC_AWM_KOICARP_N: "AWM- Lucky Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana- Season of Pink",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Mașină sport- Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "Daune provocate",
  T_26_V_TRAINING_BHH: "Ciocan elegant",
  T_26_V_TRAINING_DICE: "Zaruri uriașe",
  T_26_W_DRAGON_N: "Dreki",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Skin: Splashy Dreki",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Skin: Zapping Dreki",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Skin: Galaxy Dreki",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Skin: Waggor in Love",
  T_26_XL_SETTING_TEAMMATE_INFO: "Info coechipier",
  T_26_YP_HISTORY_WIN: "Victorie",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Feminin",
  T_26_YP_SOCIAL_GENDER_MALE: "Masculin",
  T_26_YP_SOCIAL_NAME: "Pseudonim",
  T_27_C_SKILL_DESC__RACERGIRL: "Viteza de conducere crește cu {0}%. Atunci când se află în vehicul, personajul este mai greu de luat în vizor, iar daunele suferite se reduc cu {1}%.",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Creează un câmp de forță impenetrabil care blochează {0} daune. Cât timp se află înăuntru, personajul nu poate să atace inamicii din afara câmpului. Toate efectele durează {1}sec. Timp de reactivare: {2}sec.",
  T_27_C_SKILL_DESC_FALCONER: "Daunele cresc odată cu distanța, până la {0}%. Daunele provocate inamicilor marcați cresc cu {1}%.",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Awakening: Reduce daunele frontale cu {1}% pentru fiecare {0}% din pierderea maximă de HP.",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Awakening: Sprintează timp de {0}s pentru activare. După activare, prima împușcătură {2} provoacă {1}% daune. Durează {3} secunde.",
  T_27_C_SKILL_NAME_FALCONER: "Fervoarea șoimului",
  T_27_C_SKILL_NAME_XTREME: "Confruntare extremă",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "the Fierce"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "Luptă cu stil!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "Tiger Papercut (Mască)",
  T_27_L_B_CARDBOARD_REG: "Grizzly Papercut (Pantaloni)",
  T_27_L_M_S_KAZAKHSTAN: "The Baghatur (Pantofi)",
  T_27_L_S_CARDBOARD_REG: "Grizzly Papercut (Pantofi)",
  T_27_L_T_CARDBOARD_REG: "Grizzly Papercut (Haină)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector- FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Monster Truck- FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Motocicletă- K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Mașină sport- Emerald Flash",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Camionetă- Flame Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "Mortal de silențios",
  T_27_R_EMOTE_GREETING_NAME: "Greetings",
  T_27_R_VEHICLE_ACCELERATION: "Accelerație",
  T_27_R_VEHICLE_HP: "Durabilitate",
  T_27_R_VEHICLE_SPEED: "Viteză maximă",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Trezire: reducerea daunelor armurii a crescut cu {0}%. Reducere suplimentară de 15% daune de la fiecare coechipier care deține această abilitate.",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Haită de lupi",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Moony",
  T_27_W_ARMOTY_DMR: "Pușcă de lunetist",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Skin: Crystal Moony",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Skin: Gamer Moony",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Skin: Hipster Moony",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Skin: FFWS 2021 Pup",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Skin: FFWS 2021 Panda",
  T_27_XC_REPLAY_DIE: "Moarte",
  T_27_XC_REPLAY_KILL: "Kill",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Repară",
  T_28_C_G_ICE_NAME: "Îngheț brusc",
  T_28_C_SKILL_DESC_STREETBEAT: "Atunci când tragi în timpul mișcării, te deplasezi cu {0}% mai repede, iar precizia ta crește cu {1}%.",
  T_28_C_SKILL_NAME_STREETBEAT: "Ritmul gloanțelor",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "No.23 Soccer Jersey (Pantaloni)",
  T_28_L_B_BRJERSEY_B: "No.10 Soccer Jersey (Pantaloni)",
  T_28_L_B_BRJERSEY_C: "No.24 Soccer Jersey (Pantaloni)",
  T_28_L_B_BRJERSEY_D: "No.30 Soccer Jersey (Pantaloni)",
  T_28_L_B_BRJERSEY_E: "No.1 Soccer Jersey (Pantaloni)",
  T_28_L_B_BRJERSEY_F: "No.20 Soccer Jersey (Pantaloni)",
  T_28_L_F_B_FOURSYMBOLS_C: "Vermilion Whirlwind (Pantaloni)",
  T_28_L_F_H_FOURSYMBOLS_C: "Vermilion Whirlwind (Cap)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Vermilion Whirlwind (Vopsea pentru față)",
  T_28_L_F_S_FOURSYMBOLS_C: "Vermilion Whirlwind (Pantofi)",
  T_28_L_F_T_FOURSYMBOLS_C: "Vermilion Whirlwind (Haină)",
  T_28_L_HA_THUNDER: "Lightning Eye (Vopsea pentru față)",
  T_28_L_M_A_SPORTSUIT: "Ballsy Skaterboi (Mască)",
  T_28_L_M_B_FOURSYMBOLS_D: "Shadow Earthshaker (Pantaloni)",
  T_28_L_M_B_SPORTSUIT: "Ballsy Skaterboi (Pantaloni)",
  T_28_L_M_H_FOURSYMBOLS_D: "Shadow Earthshaker (Cap)",
  T_28_L_M_H_SPORTSUIT: "Ballsy Skaterboi (Cap)",
  T_28_L_M_S_FOURSYMBOLS_D: "Shadow Earthshaker (Pantofi)",
  T_28_L_M_S_SPORTSUIT: "Ballsy Skaterboi (Pantofi)",
  T_28_L_M_T_FALLWINTER: "Sauce Swagger (Haină)",
  T_28_L_M_T_FOURSYMBOLS_D: "Shadow Earthshaker (Haină)",
  T_28_L_M_T_SPORTSUIT: "Ballsy Skaterboi (Haină)",
  T_28_L_T_BRJERSEY_A: "No.23 Soccer Jersey (Haină)",
  T_28_L_T_BRJERSEY_B: "No.10 Soccer Jersey (Haină)",
  T_28_L_T_BRJERSEY_C: "No.24 Soccer Jersey (Haină)",
  T_28_L_T_BRJERSEY_D: "No.30 Soccer Jersey (Haină)",
  T_28_L_T_BRJERSEY_E: "No.1 Soccer Jersey (Haină)",
  T_28_L_T_BRJERSEY_F: "No.20 Soccer Jersey (Haină)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94- Ruby Bride",
  T_28_LC_GLOO_FALLWINTER_N: "Gloo Wall- Sauce Swagger",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Gloo Wall- Stormbringer",
  T_28_LC_KORD_SHINOBI_N: "Kord- Killspark Shinobi",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker- Merciless Necromancer",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - Lethal Finstooth",
  T_28_LC_PAN_FOURSYMBOLS_N: "Tigaie- Earthshaker Stomp",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep- Stormbringer",
  T_28_T_WS_ITEM1: "Cutie pătrată",
  T_28_T_WS_ITEM10: "Colibă",
  T_28_T_WS_ITEM11: "Turn de apărare",
  T_28_T_WS_ITEM12: "Avanpost",
  T_28_T_WS_ITEM13: "Casa A",
  T_28_T_WS_ITEM14: "Casa B",
  T_28_T_WS_ITEM15: "Casa C",
  T_28_T_WS_ITEM16: "Structură din nisip",
  T_28_T_WS_ITEM17: "Fântână",
  T_28_T_WS_ITEM18: "Cherry Blossom",
  T_28_T_WS_ITEM19: "Bananier",
  T_28_T_WS_ITEM2: "Cutie lungă",
  T_28_T_WS_ITEM20: "Vas de toaletă",
  T_28_T_WS_ITEM21: "Gard",
  T_28_T_WS_ITEM3: "Arbust",
  T_28_T_WS_ITEM4: "Căpiță de fân",
  T_28_T_WS_ITEM5: "Mașină",
  T_28_T_WS_ITEM6: "Autobuz",
  T_28_T_WS_ITEM7: "Container A",
  T_28_T_WS_ITEM8: "Container B",
  T_28_T_WS_ITEM9: "Container C",
  T_28_T_WS_TYPE1: "Obiecte",
  T_28_T_WS_TYPE4: "Decorațiuni",
  T_28_W_DUCK_N: "Dr. Beanie",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Skin: Mythos Dreki",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Skin: Sgt. Beanie",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Skin: Gangster Beanie",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Skin: DJ Beanie",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Awakening: Marcajele de pe inamicii loviți rămân vizibile mai mult timp atunci când aceștia sunt în mișcare - până la {0}sec.",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Ochiul enigmei",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Vibrații vitale",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Pulsație tămăduitoare",
  T_29_D_CHARACTER_AMOCO_N: 'Moco "Enigma"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Striped Soccer Jersey (Pantaloni)",
  T_29_L_M_A_FALCONER_C: "Moody Lavisher (Mască)",
  T_29_L_M_A_JUNGLE_GREEN: "Camou War-Turtle (Mască)",
  T_29_L_M_B_FALCONER_C: "Moody Lavisher (Pantaloni)",
  T_29_L_M_B_JUNGLE_GREEN: "Camou War-Turtle (Pantaloni)",
  T_29_L_M_H_FALCONER_C: "Moody Lavisher (Cap)",
  T_29_L_M_H_JUNGLE_GREEN: "Camou War-Turtle (Cap)",
  T_29_L_M_S_FALCONER_C: "Moody Lavisher (Pantofi)",
  T_29_L_M_S_JUNGLE_GREEN: "Camou War-Turtle (Pantofi)",
  T_29_L_M_T_FALCONER_C: "Moody Lavisher (Haină)",
  T_29_L_M_T_JUNGLE_GREEN: "Camou War-Turtle (Haină)",
  T_29_L_T_TRJERSEY: "Striped Soccer Jersey (Haină)",
  T_29_M_WS_ITEM22: "Container solid",
  T_29_M_WS_ITEM23: "Gard solid",
  T_29_M_WS_ITEM24: "Punct de spawn A",
  T_29_M_WS_ITEM25: "Punct de spawn B",
  T_29_M_WS_TYPE5: "Interactive",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Skin: Earth Sensei Tig",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Skin: Fire Sensei Tig",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Skin: Cyber Falco",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Skin: Party Panda",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Skin: Ice Sensei Tig",
  T_29_W_TIGER_NINJA_N: "Sensei Tig",
  T_29_YF_MACHETE_MUSICFEST_N: "Soundwave Thrasher",
  T_29_YF_MAGEZINE_CHAIN_N: "Încărcător AR",
  T_29_YF_MUZZLE_CRASH_N: "Compensator SMG",
  T_29_YF_MUZZLE_WIDE_N: "Compensator pentru pușcă",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- Cosmic Teleportia",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi- Amber Megacypher",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Monster Truck- Gnawing Rager",
  T_30_AD_RP_ROUNDEND: "FINALUL RUNDEI",
  T_30_AD_TRAINING_SNOWBALL: "Bulgare de zăpada",
  T_30_AD_TRAINING_SNOWBALL_DES: "Să începem o luptă cu bulgări de zăpadă!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] after being attacked, recover [FFB300]{1}HP[-]/s for [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Jucător-bătător",
  T_30_C_SKILL_NAME_MUERTOGUY: "Ceață de memorie",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Microcipul lui Jai",
  T_30_L_A_BRMASCOT_ADULT: "Angry Chick Head",
  T_30_L_A_BRMASCOT_KIDS: "Adorable Chick Head",
  T_30_L_A_SUGARSKULL21_BANDANA: "Death Bite Mask",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Pantaloni)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Pantaloni)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Pantaloni)",
  T_30_L_B_BRUNIFORM: "Little Canary (Pantaloni)",
  T_30_L_F_A_SUGARSKULL21: "Goldrim Queen (Mască)",
  T_30_L_F_B_SUGARSKULL21: "Goldrim Queen (Pantaloni)",
  T_30_L_F_B_THASIAN: "Coral Trouble (Pantaloni)",
  T_30_L_F_H_CATEARS: "Kawaii Ears",
  T_30_L_F_H_SUGARSKULL21: "Goldrim Queen (Cap)",
  T_30_L_F_H_THASIAN: "Coral Trouble (Cap)",
  T_30_L_F_S_SUGARSKULL21: "Goldrim Queen (Pantofi)",
  T_30_L_F_S_THASIAN: "Coral Trouble (Pantofi)",
  T_30_L_F_T_SUGARSKULL21: "Goldrim Queen (Haină)",
  T_30_L_F_T_THASIAN: "Coral Trouble (Haină)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Dolphin Head",
  T_30_L_H_CHILDRENSDAY_RED: "Elephant Head",
  T_30_L_H_CLOWNHAT: "Pălărie Circus - Galbenă",
  T_30_L_H_ZASCARF: "Eșarfă Bold Gold",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Desi Gangster (Mască)",
  T_30_L_M_A_SUGARSKULL21: "Goldrim King (Mască)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Desi Gangster (Pantaloni)",
  T_30_L_M_B_PKCRICKET: "Champ In Green (Pantaloni)",
  T_30_L_M_B_SUGARSKULL21: "Goldrim King (Pantaloni)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Wind Racer (Pantaloni)",
  T_30_L_M_B_THASIAN: "Coral Rebel (Pantaloni)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Desi Gangster (Cap)",
  T_30_L_M_H_SUGARSKULL21: "Goldrim King (Cap)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Wind Racer (Cap)",
  T_30_L_M_H_THASIAN: "Coral Rebel (Cap)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Alpha Flameborn (Vopsea pentru față)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Desi Gangster (Pantofi)",
  T_30_L_M_S_PKCRICKET: "Champ In Green (Pantofi)",
  T_30_L_M_S_SUGARSKULL21: "Goldrim King (Pantofi)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Wind Racer (Pantofi)",
  T_30_L_M_S_THASIAN: "Coral Rebel (Pantofi)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Desi Gangster (Haină)",
  T_30_L_M_T_PKCRICKET: "Champ In Green (Haină)",
  T_30_L_M_T_SUGARSKULL21: "Goldrim King (Haină)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Wind Racer (Haină)",
  T_30_L_M_T_THASIAN: "Coral Rebel (Haină)",
  T_30_L_S_BRUNIFORM: "Little Canary (Pantofi)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Haină)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Haină)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Haină)",
  T_30_L_T_BRUNIFORM: "Little Canary (Haină)",
  T_30_M_WS_PARTY_MODE: "Locul de joacă",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Challenger",
  T_30_R_EMOTE_MAX_NAME: "Rap Swag",
  T_30_R_LEGEND_HALO_NAME: "Cerc de căldură",
  T_30_T_WS_DEFAULTDESCRIPTION: "O hartă interesantă în Free Fire Craftland",
  T_30_T_WS_ITEM26: "Cauciucuri",
  T_30_T_WS_ITEM27: "Cauciucuri uzate A",
  T_30_T_WS_ITEM28: "Cauciucuri uzate B",
  T_30_T_WS_ITEM29: "Cauciucuri uzate C",
  T_30_T_WS_ITEM30: "Mașinuță bușitoare",
  T_30_T_WS_ITEM31: "Mașină amfibie",
  T_30_T_WS_ITEM32: "Jeep",
  T_30_T_WS_ITEM33: "Coș de gunoi",
  T_30_T_WS_ITEM34: "Copertină",
  T_30_T_WS_ITEM35: "Cort medical",
  T_30_T_WS_ITEM36: "Garaj",
  T_30_T_WS_ITEM37: "Pereți vopsiți",
  T_30_T_WS_ITEM38: "Porți japoneze",
  T_30_T_WS_ITEM39: "Platformă de fier",
  T_30_T_WS_ITEM40: "Colibă",
  T_30_T_WS_ITEM41: "Trailer",
  T_30_T_WS_ITEM42: "Perete A",
  T_30_T_WS_ITEM43: "Perete B",
  T_30_T_WS_ITEM44: "Perete C",
  T_30_T_WS_ITEM45: "Perete D",
  T_30_T_WS_ITEM46: "Perete E",
  T_30_T_WS_ITEM47: "Perete F",
  T_30_U_ATTACHMENT_1: "Booster HP Vestă",
  T_30_U_ATTACHMENT_4: "Dilatator Vestă",
  T_30_U_ATTACHMENT_5: "Etanșor Cască",
  T_30_U_ATTACHMENT_6: "Etanșor Vestă",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Skin: Skull Beaston",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Skin: Punk Waggor",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Skin: Bullseye Agent Hop",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Skin: Carnival Agent Hop",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Skin: Cyber Agent Hop",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Skin: Nazar Robo",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Skin: Green Freeze Robo",
  T_30_W_RABBIT_N: "Agent Hop",
  T_30_XH_PCMAP_P17: "Factory",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Gloo Wall- BOOYAH DAY 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Grenadă- BOOYAH DAY 2021",
  T_30_YF_Healinggun_Sniper_N: "Sniper de tratament",
  T_30_YF_MINI_LIGHTFEST_N: "AC80- Royal Warrior",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL- Crimson Heir",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR- Royal Warrior",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Goldrim Tribute",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Mașină sport- Skull Punker",
  T_31_C_SKILL_NAME_WINTERGUY: "Ghețar de oțel",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Winter Basher",
  T_31_HQ_GLOO_EAGLE_N: "Gloo Wall- Heatbound Desert",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Sniper de tratament- Ice Bones",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana- Snow Doom",
  T_31_HQ_PAN_WINTERFEST21_N: "Tigaie- Snow Doom",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Skin: Snow Ottero",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Skin: Waggor On Ice",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Skin: Tribal Yeti",
  T_31_HQ_PETSKIN_YETI_RED_N: "Skin: Fiery Yeti",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Scythe of Snow",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Motocicletă- Ice Blossoms",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "Ladă cu provizii",
  T_31_KK_WINTER_SANJITOU: "Cască",
  T_31_L_A_BDCRICKET: "Victory Batter (Mască)",
  T_31_L_A_WINTERFEST21: "Reindeer Cover",
  T_31_L_B_BDCRICKET: "Victory Batter (Pantaloni)",
  T_31_L_B_MEJERSEY_10: "No. 10 Ruby Jersey (Pantaloni)",
  T_31_L_B_MEJERSEY_11: "No. 11 Red Jersey (Pantaloni)",
  T_31_L_B_MEJERSEY_13: "No. 13 White Jersey (Pantaloni)",
  T_31_L_B_MEJERSEY_18G: "No. 18 Green Jersey (Pantaloni)",
  T_31_L_B_MEJERSEY_18R: "No. 18 Maroon Jersey (Pantaloni)",
  T_31_L_B_MEJERSEY_7: "No. 7 Basil Jersey (Pantaloni)",
  T_31_L_F_B_RUMUSICIAN: "Strapped Trance (Pantaloni)",
  T_31_L_F_B_THAGENT: "Night Provocateur (Pantaloni)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Up Here (F)",
  T_31_L_F_H_RUMUSICIAN: "Strapped Trance (Cap)",
  T_31_L_F_H_THAGENT: "Night Provocateur (Cap)",
  T_31_L_F_HA_RUMUSICIAN: "Strapped Trance (Vopsea pentru față)",
  T_31_L_F_S_RUMUSICIAN: "Strapped Trance (Pantofi)",
  T_31_L_F_S_THAGENT: "Night Provocateur (Pantofi)",
  T_31_L_F_T_RUMUSICIAN: "Strapped Trance (Haină)",
  T_31_L_F_T_THAGENT: "Night Provocateur (Haină)",
  T_31_L_HA_RUMUSICIAN_MU: "Strap Trap (Vopsea pentru față)",
  T_31_L_HA_WINTERFEST21_BLUE: "Vopsea pentru față Frozen Clown",
  T_31_L_HA_WINTERFEST21_PINK: "Vopsea pentru față Pink Firesparks",
  T_31_L_M_A_REGGAETON_B: "Everything Goes (Mască)",
  T_31_L_M_A_REGGAETON_P: "Prismatic Energy (Mască)",
  T_31_L_M_A_RUMUSICIAN: "Strapped Trap (Mască)",
  T_31_L_M_A_THAGENT: "Night Scouter (Mască)",
  T_31_L_M_B_PKCOSTUME: "Smart in Green (Pantaloni)",
  T_31_L_M_B_REGGAETON_B: "Everything Goes (Pantaloni)",
  T_31_L_M_B_REGGAETON_P: "Prismatic Energy (Pantaloni)",
  T_31_L_M_B_RUMUSICIAN: "Strapped Trap (Pantaloni)",
  T_31_L_M_B_THAGENT: "Night Scouter (Pantaloni)",
  T_31_L_M_H_GREENCAP: "Winner Cap",
  T_31_L_M_H_PKCOSTUME: "Smart in Green (Cap)",
  T_31_L_M_H_REGGAETON_B: "Everything Goes (Cap)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Up Here (M)",
  T_31_L_M_H_REGGAETON_P: "Prismatic Energy (Cap)",
  T_31_L_M_H_RUMUSICIAN: "Strapped Trap (Cap)",
  T_31_L_M_H_THAGENT: "Night Scouter (Cap)",
  T_31_L_M_S_PKCOSTUME: "Smart in Green (Pantofi)",
  T_31_L_M_S_REGGAETON_B: "Everything Goes (Pantofi)",
  T_31_L_M_S_REGGAETON_P: "Prismatic Energy (Pantofi)",
  T_31_L_M_S_RUMUSICIAN: "Strapped Trap (Pantofi)",
  T_31_L_M_S_THAGENT: "Night Scouter (Pantofi)",
  T_31_L_M_T_PKCOSTUME: "Smart in Green (Haină)",
  T_31_L_M_T_REGGAETON_B: "Everything Goes (Haină)",
  T_31_L_M_T_REGGAETON_P: "Prismatic Energy (Haină)",
  T_31_L_M_T_REGGAETON_TATOO: "This Is Me",
  T_31_L_M_T_RUMUSICIAN: "Strapped Trap (Haină)",
  T_31_L_M_T_THAGENT: "Night Scouter (Haină)",
  T_31_L_S_BDCRICKET: "Victory Batter (Pantofi)",
  T_31_L_T_BDCRICKET: "Victory Batter (Haină)",
  T_31_L_T_BRBANK: "Maroon Bomber",
  T_31_L_T_MEJERSEY_10: "No. 10 Ruby Jersey (Haină)",
  T_31_L_T_MEJERSEY_11: "No. 11 Red Jersey (Haină)",
  T_31_L_T_MEJERSEY_13: "No. 13 White Jersey (Haină)",
  T_31_L_T_MEJERSEY_18G: "No. 18 Green Jersey (Haină)",
  T_31_L_T_MEJERSEY_18R: "No. 18 Maroon Jersey (Haină)",
  T_31_L_T_MEJERSEY_7: "No. 7 Basil Jersey (Haină)",
  T_31_L_T_PKMOBILE: "Tricou Infinix",
  T_31_L_T_REGGAETON_HOOD: "For My People",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Number 1",
  T_31_RW_COMBINEMACHINE_2: "Activator Akimbo (avansat)",
  T_31_RW_VIBRATION_EXPLOSION: "Explozii",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Arme cu rază scurtă de acțiune",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Alte arme",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Echipă",
  T_31_T_WS_5PLAYERTEAM: "Versus 5",
  T_31_T_WS_6PLAYERTEAM: "Versus 6",
  T_31_T_WS_BUFFTIME_TITLE: "Timp de reîncărcare",
  T_31_T_WS_BUFFTYPE_AMMO: "Muniție",
  T_31_T_WS_BUFFTYPE_ARMOR: "Armură",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "Aleatoriu",
  T_31_T_WS_BUFFTYPE_TITLE: "Tip buff",
  T_31_T_WS_DESC48: "Te duce în alt loc, în câteva milisecunde",
  T_31_T_WS_DESC49: "Creează sunetul unei taste de pian",
  T_31_T_WS_DESC51: "Creează sunetul unei tobe",
  T_31_T_WS_DESC53: "Creează sunetul unui sintetizator",
  T_31_T_WS_DESC59: "Un dispozitiv care generează periodic un buff. Colectează-l pentru a obține o îmbunătățire",
  T_31_T_WS_DRUMTYPE_CLAPS: "Aplauze",
  T_31_T_WS_DRUMTYPE_HIHATS: "Hi-hat",
  T_31_T_WS_DRUMTYPE_KICK: "Tobă de picior",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Hi-hat de deschidere",
  T_31_T_WS_DRUMTYPE_RIDES: "Chimval",
  T_31_T_WS_DRUMTYPE_SNARES: "Tobă mică",
  T_31_T_WS_EARLYSHRINK: "Micșorare rapidă",
  T_31_T_WS_ITEM48: "Portal",
  T_31_T_WS_ITEM49: "Notă de pian",
  T_31_T_WS_ITEM51: "Notă de tobă",
  T_31_T_WS_ITEM53: "Notă Combo A",
  T_31_T_WS_ITEM55: "Notă Combo B",
  T_31_T_WS_ITEM57: "Notă Combo C",
  T_31_T_WS_ITEM59: "Generator buff-uri",
  T_31_T_WS_LATESHRINK: "Micșorare întârziată",
  T_31_T_WS_ME_DAMAGE: "Daune cauzate",
  T_31_T_WS_ME_DAMAGED: "Daune primite",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Proporția EP inițială",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Raza primei Zone sigure",
  T_31_T_WS_ME_EPQUICKRESTORE: "Recuperare EP rapidă",
  T_31_T_WS_ME_FLOW: "Mod",
  T_31_T_WS_ME_GENERALSETTING: "General",
  T_31_T_WS_ME_INRANDOMSPAWN: "Punct spawn aleatoriu",
  T_31_T_WS_ME_KILLSCORE: "Bonus pentru kill-uri",
  T_31_T_WS_ME_MAXEP: "Maxim EP",
  T_31_T_WS_ME_MAXHP: "Maxim HP",
  T_31_T_WS_ME_NEARTEAM: "Lângă coechipieri",
  T_31_T_WS_ME_REBIRTH: "Timp de așteptare respawn",
  T_31_T_WS_ME_REBIRTHLOCATION: "Locație respawn",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Timp inițiere micșorare zonă",
  T_31_T_WS_ME_WINSCORE: "Scor câștigător",
  T_31_T_WS_MINIZONE: "Zonă mini",
  T_31_T_WS_MUSICTYPE_TITLE: "Tip de muzică",
  T_31_T_WS_UNLIMITEDAMMO: "Muniție nelimitată",
  T_31_WT_WS_DESC1: "O cutie pătrată din lemn care poate fi stivuită",
  T_31_WT_WS_DESC10: "O colibă dărăpănată, cu scări de lemn pe care poți urca",
  T_31_WT_WS_DESC11: "Construită cu multe ferestre care îți permit să tragi mai ușor",
  T_31_WT_WS_DESC12: "Fabricată din metal; conține uși și ferestre",
  T_31_WT_WS_DESC13: "O casă cu un etaj, cu uși și ferestre",
  T_31_WT_WS_DESC14: "O casă cu două etaje, cu terasă",
  T_31_WT_WS_DESC15: "O casă cu două etaje, cu un acoperiș închis",
  T_31_WT_WS_DESC16: "Decor - o statuie de nisip în formă de inimă",
  T_31_WT_WS_DESC17: "Decor - o fântână cu apă cristalină",
  T_31_WT_WS_DESC18: "Decor - un copac cu flori roz",
  T_31_WT_WS_DESC19: "Decor - un mic bananier fără banane",
  T_31_WT_WS_DESC2: "O cutie dreptunghiulară din lemn care poate fi stivuită",
  T_31_WT_WS_DESC20: "Un mobilier de baie alb care poate fi amplasat în interior",
  T_31_WT_WS_DESC21: "Un gard mic care poate fi folosit pentru a împărți zonele",
  T_31_WT_WS_DESC22: "Placa de lemn laterală a acestui container poate fi ruptă cu forța",
  T_31_WT_WS_DESC23: "Un mic gard care poate fi dărâmat cu forța",
  T_31_WT_WS_DESC24: "Zonă de spawn pentru echipa A (Valabil doar în modurile Clash Squad, Team Deathmatch și Playground)",
  T_31_WT_WS_DESC25: "Zonă de spawn pentru echipa B (Valabil doar în modurile Clash Squad, Team Deathmatch și Playground)",
  T_31_WT_WS_DESC26: "Îi aruncă pe jucători în direcția din fața lor, pe o distanță scurtă",
  T_31_WT_WS_DESC27: "Îi aruncă pe jucători în direcția prestabilită, pe o distanță scurtă",
  T_31_WT_WS_DESC28: "Îi aruncă pe jucători în direcția prestabilită, pe o distanță medie",
  T_31_WT_WS_DESC29: "Îi aruncă pe jucători în direcția prestabilită, pe o distanță lungă",
  T_31_WT_WS_DESC3: "Împodobit cu flori roșii și galbene care îți pot lumina câmpul de luptă",
  T_31_WT_WS_DESC30: "O mașinuță bușitoare care poate fi condusă",
  T_31_WT_WS_DESC31: "O mașină amfibie care poate fi condusă",
  T_31_WT_WS_DESC32: "Un jeep care poate fi condus",
  T_31_WT_WS_DESC33: "Umplut cu gunoi. Mai scund decât un om, dar poate oferi o anumită acoperire",
  T_31_WT_WS_DESC34: "Un adăpost metalic în aer liber pe pista de curse",
  T_31_WT_WS_DESC35: "Un cort de dimensiuni medii cu două uși, dar fără ferestre",
  T_31_WT_WS_DESC36: "Un garaj mare construit din cărămizi",
  T_31_WT_WS_DESC37: "Un zid mare de cărămidă care poate fi folosit pentru a împărți zonele",
  T_31_WT_WS_DESC38: "Un reper util",
  T_31_WT_WS_DESC39: "O platformă metalică mare care poate fi folosită ca arenă principală de luptă",
  T_31_WT_WS_DESC4: "Mai înaltă decât un om și, prin urmare, poate fi folosită ca acoperire",
  T_31_WT_WS_DESC40: "Arată ca un vehicul de agrement; are mai multe uși și ferestre",
  T_31_WT_WS_DESC41: "Arată ca un vehicul de agrement; are o ușă și mai multe ferestre",
  T_31_WT_WS_DESC42: "Un perete unilateral cu intrare",
  T_31_WT_WS_DESC43: "Un perete unilateral obișnuit",
  T_31_WT_WS_DESC44: "Un colț de perete",
  T_31_WT_WS_DESC45: "Un colț de perete neuniform",
  T_31_WT_WS_DESC46: "Un colț de perete neuniform",
  T_31_WT_WS_DESC47: "Un colț de perete cu ferestre",
  T_31_WT_WS_DESC5: "O mașină abandonată care este puțin mai mică decât un om, însă poate oferi o acoperire",
  T_31_WT_WS_DESC6: "Mai înaltă decât un om și, prin urmare, poate fi folosită ca acoperire",
  T_31_WT_WS_DESC7: "Deschis la ambele capete și poate fi aranjat pentru a forma căi sau pentru a împărți zone",
  T_31_WT_WS_DESC8: "Deschis la un capăt și poate fi folosit pentru a împărți zone",
  T_31_WT_WS_DESC9: "Sigilat la ambele capete și poate fi folosit pentru a împărți zonele",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Vehicul",
  T_31_Z_OB_UAV: "Dronă",
  T_32_C_SKILL_DESC_YAKUZA: "Se deplasează înainte cu o viteză rapidă timp de {0} s. Timp de reaprovizionare: {1} s. Această abilitate poate fi acumulată pentru până la {2} utilizări, cu un timp de răcire de 5 secunde între fiecare utilizare.",
  T_32_C_SKILL_NAME_YAKUZA: "Rebel Rush",
  T_32_HQ_AUG_VNSTREET_N: "AUG- Roaring Gunfighter",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Rucsac Dawnlit Drago",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- Vampire Malevolence",
  T_32_HQ_GLOO_DUNHUANG_N: "Gloo Wall- Frozen Platinum",
  T_32_HQ_GLOO_HURRICANE_2_N: "Gloo Wall- Aurora Core",
  T_32_HQ_GRENADE_HURRICANE_N: "Grenadă- Brassy Mic",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10- Frozen Platinum",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Skin: Red Beanie",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Skin: Cyber Flash",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Skin: Gamer Flash",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Skin: Festive Flash",
  T_32_HQ_TORTOISE_N: "Flash",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Mașină sport- Buried Purpledust",
  T_32_L_F_A_PHARAOH: "Goldcoated Cleo (Mască)",
  T_32_L_F_B_PHARAOH: "Goldcoated Cleo (Pantaloni)",
  T_32_L_F_H_PHARAOH: "Goldcoated Cleo (Cap)",
  T_32_L_F_HA_PHARAOH: "Goldcoated Cleo (Vopsea pentru față)",
  T_32_L_F_S_PHARAOH: "Goldcoated Cleo (Pantofi)",
  T_32_L_F_T_PHARAOH: "Goldcoated Cleo (Haină)",
  T_32_L_M_A_JUNKFOOD: "Burger Lad (Mască)",
  T_32_L_M_A_PHARAOH: "Goldlined Mummy (Mască)",
  T_32_L_M_B_JUNKFOOD: "Burger Lad (Pantaloni)",
  T_32_L_M_B_PHARAOH: "Goldlined Mummy (Pantaloni)",
  T_32_L_M_H_JUNKFOOD: "Burger Lad (Cap)",
  T_32_L_M_H_PHARAOH: "Goldlined Mummy (Cap)",
  T_32_L_M_S_JUNKFOOD: "Burger Lad (Pantofi)",
  T_32_L_M_S_PHARAOH: "Goldlined Mummy (Pantofi)",
  T_32_L_M_T_JUNKFOOD: "Burger Lad (Haină)",
  T_32_L_M_T_PHARAOH: "Goldlined Mummy (Haină)",
  T_32_L_T_WHITESWEATER: "Pulover pe gât alb",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "Zona nemuririi",
  T_32_LO_WS_ITEM60: "Conductă",
  T_32_LO_WS_ITEM60_DESC: "Un tunel prin care poți trece",
  T_32_LO_WS_ITEM61: "Conductă de tip T",
  T_32_LO_WS_ITEM61_DESC: "Un tunel de tip T prin care poți trece",
  T_32_LO_WS_ITEM62: "Intersecție (conductă)",
  T_32_LO_WS_ITEM62_DESC: "Un tunel de intersecție prin care poți trece",
  T_32_LO_WS_ITEM63: "Cot de conductă",
  T_32_LO_WS_ITEM63_DESC: "Un tunel unghiular prin care poți trece",
  T_32_LO_WS_ITEM64: "Food Truck",
  T_32_LO_WS_ITEM64_DESC: "Oprește-te aici să mănânci ceva",
  T_32_LO_WS_ITEM65: "Ciupercă-umbră",
  T_32_LO_WS_ITEM65_DESC: "O ciupercă mare care poate transporta un om",
  T_32_LO_WS_ITEM66: "Cuier",
  T_32_LO_WS_ITEM66_DESC: "Întâlnit frecvent în zonele rezidențiale",
  T_32_LO_WS_ITEM67: "Scândură de lemn",
  T_32_LO_WS_ITEM67_DESC: "Folosește-o pentru a construi un pod simplu din lemn",
  T_32_LO_WS_ITEM68: "Panou grilaj",
  T_32_LO_WS_ITEM68_DESC: "Un pic de orientalism",
  T_32_LO_WS_ITEM69: "Stâlp",
  T_32_LO_WS_ITEM69_DESC: "Întâlnit frecvent pe șantierele de construcții",
  T_32_LO_WS_ITEM70: "Cactus",
  T_32_LO_WS_ITEM70_DESC: "Foarte mare, însă nu înțeapă",
  T_32_LO_WS_ITEM71: "Copac fără frunze",
  T_32_LO_WS_ITEM71_DESC: "Un copac care trăiește de secole",
  T_32_LO_WS_ITEM72: "Felinar de piatră",
  T_32_LO_WS_ITEM72_DESC: "Decor pitoresc în grădinile imperiale",
  T_32_LO_WS_ITEM73: "Felinar",
  T_32_LO_WS_ITEM73_DESC: "Întâlnit frecvent pe străzi",
  T_32_LO_WS_ITEM74: "Panou solar",
  T_32_LO_WS_ITEM74_DESC: "Absoarbe energia din lumina soarelui",
  T_32_LO_WS_ITEM75: "Aer condiționat",
  T_32_LO_WS_ITEM75_DESC: "Stai la răcoare în arșiță",
  T_32_LO_WS_ITEM76: "Ventilator",
  T_32_LO_WS_ITEM77: "Tigaie de zbor",
  T_32_LO_WS_ITEM78: "Cub",
  T_32_LO_WS_ITEM79: "Inel",
  T_32_LO_WS_ITEM80: "Ciocan",
  T_32_LO_WS_ITEM81: "Placă",
  T_32_LO_WS_ITEM82: "Țintă de tragere",
  T_32_LO_WS_ITEM83: "Zid flexibil",
  T_32_LO_WS_ITEM84AMMO: "Loot Point cu muniție",
  T_32_LO_WS_ITEM84AMMO_DESC: "Tipul de muniție selectat va apărea acolo unde este plasat",
  T_32_LO_WS_ITEM84AR: "Loot Point cu armură",
  T_32_LO_WS_ITEM84AR_DESC: "Tipul de armură selectat va apărea acolo unde este plasat",
  T_32_LO_WS_ITEM84ARLV1: "Armură niv. 1",
  T_32_LO_WS_ITEM84ARLV2: "Armură niv. 2",
  T_32_LO_WS_ITEM84ARLV3: "Armură niv. 3",
  T_32_LO_WS_ITEM84CO: "Loot Point cu consumabile",
  T_32_LO_WS_ITEM84CO_DESC: "Tipul de consumabile selectat va apărea acolo unde este plasat",
  T_32_LO_WS_ITEM84JA: "Loot Point cu aruncabile",
  T_32_LO_WS_ITEM84JA_DESC: "Tipul de aruncabile selectat va apărea acolo unde este plasat",
  T_32_LO_WS_ITEM84TE: "Loot Point cu lunete",
  T_32_LO_WS_ITEM84TE_DESC: "Tipul de lunetă selectat va apărea acolo unde este plasat",
  T_32_LO_WS_ITEM84W: "Loot Point cu arme",
  T_32_LO_WS_ITEM84W_DESC: "Tipul de armă selectat va apărea acolo unde este plasat",
  T_32_LO_WS_ITEM85: "Declanșator",
  T_32_LO_WS_ITEM85_DESC: "Când sunt plasați, jucătorii care intră în zona de declanșare vor experimenta un efect specificat fie de nemuritor, fie de doom. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_32_LO_WS_ITEM85CP: "Punct de control",
  T_32_LO_WS_ITEM85CP_DESC: "Un articol folosit pentru a construi jocul în modul Parkour. Pentru ca punctul de control final să apară, jucătorii trebuie să treacă pe lângă fiecare punct de control unul câte unul. Când este eliminat, iar apoi reapare, jucătorul poate alege să reapară la ultimul punct de control pe care a trecut. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_32_LO_WS_ITEM85TM: "Punct de finalizare",
  T_32_LO_WS_ITEM85TM_DESC: "Un articol folosit pentru a construi jocul în modul Parkour. Jucătorii trebuie să ajungă în interiorul liniei de sosire pentru ca obiectivul să fie finalizat. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_32_LO_WS_ITEM86: "Punct de spawn",
  T_32_LO_WS_ITEM86_DESC: "Nicio echipă anume nu va fi repartizată în acest punct. Când este plasată, o echipă aleatorie va apărea aici. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_32_LO_WS_ITEM86L: "Punct de spawn - mare",
  T_32_LO_WS_ITEM86L_DESC: "Un punct mare de apariție recomandat pentru modul Parkour, unde toți jucătorii vor apărea la rând. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_32_LO_WS_ITEM87: "Bloc",
  T_32_LO_WS_ITEM87_DESC: "Permite personalizarea dimensiunilor",
  T_32_LO_WS_ITEM88: "Pantă",
  T_32_LO_WS_ITEM88_DESC: "Permite personalizarea dimensiunilor",
  T_32_LO_WS_ITEMLINE: "Deplasează",
  T_32_LO_WS_ITEMMOVE: "Setări declanșator",
  T_32_LO_WS_ITEMROT: "Rotește",
  T_32_LO_WS_ITEMSCALE: "Scară",
  T_32_LO_WS_KILLZONE: "Zonă de moarte",
  T_32_LO_WS_LOOT_AMMOTYPE: "Muniție",
  T_32_LO_WS_LOOT_ARTYPE: "Armură",
  T_32_LO_WS_LOOT_COTYPE: "Consumabil",
  T_32_LO_WS_LOOT_JATYPE: "Aruncabil",
  T_32_LO_WS_LOOT_RANDOM: "Aleatoriu",
  T_32_LO_WS_LOOT_TETYPE: "Lunetă",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Armă",
  T_32_LO_WS_SCALEX: "Lungime",
  T_32_LO_WS_SCALEY: "Înălțime",
  T_32_LO_WS_SCALEZ: "Lărgime",
  T_32_LO_WS_TRIGGERH: "Ascunde",
  T_32_LO_WS_TRIGGERHORP: "Arată/Ascunde declanșatoare",
  T_32_LO_WS_TRIGGERP: "Arată",
  T_32_LO_WS_TRIGGERTYPE: "Tip declanșator",
  T_32_M_WS_MODE_ANNIHILATE: "Nimicește",
  T_32_M_WS_MODE_SCORE: "Goana după puncte",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "Luptă cu mai multe echipe",
  T_32_M_WS_ROUNDS: "Runde",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Switching Steps",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Zona periculoasă",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Daune",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Zona periculoasă",
  T_32_T_WS_ME_CUSTOM: "Personalizează",
  T_32_T_WS_ME_ENDTYPE1: "Nimicește",
  T_32_T_WS_ME_ENDTYPE2: "Goana după puncte",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "Fiți ultima echipă care supraviețuiește",
  T_32_T_WS_ME_ENDTYPEDESC2: "Prima echipă care atinge scorul necesar câștigă",
  T_32_T_WS_ME_ENDTYPEDESC3: "Prima echipă ai cărei membri ajung la punctul final câștigă",
  T_32_T_WS_ME_MATCHTIME: "Timp meci",
  T_32_T_WS_ME_MECHANIC: "Mecanism",
  T_32_T_WS_ME_NEARCHECKPOINT: "Lângă punctul de control",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Nu poți avea mai mult de 12 jucători în total",
  T_32_T_WS_ME_PREGAMETIME: "Timp de pregătire",
  T_32_T_WS_ME_RESPAWN: "Respawn-uri",
  T_32_T_WS_ME_RESPAWNSETTING: "Respawn-uri",
  T_32_T_WS_ME_ROUNDNUM: "Număr de runde",
  T_32_T_WS_ME_ROUNDOPEN: "Activează runde multiple",
  T_32_T_WS_ME_ROUNDRESET: "Resetări rundă",
  T_32_T_WS_ME_ROUNDSETTING: "Runde",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Durata de micșorare a zonei",
  T_32_T_WS_ME_SCORESETTING: "Scor",
  T_32_T_WS_ME_TEAMMATENUM: "Membri pe echipă",
  T_32_T_WS_ME_TEAMNUM: "Numărul de echipe",
  T_32_T_WS_ME_TEAMSETTING: "Echipă",
  T_32_U_ATTACHMENT_8: "Pungă",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Cip de upgrade",
  T_32_WT_WS_BARRIER: "Bariere",
  T_32_WT_WS_BDS: "Clădiri",
  T_32_WT_WS_MMINVALIDERROR: "Cod hartă nevalid",
  T_32_WT_WS_TRGS: "Declanșatoare",
  T_32_YF_CHARGESHOT_N: "Charge Buster",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Daune suplimentare",
  T_32_YS_WEAPON_TAG_3: "Rata de tragere",
  T_32_YS_WEAPON_TAG_36: "Perforator de armură",
  T_32_YS_WEAPON_TAG_39: "Suportă Mânuirea duală",
  T_32_YS_WEAPON_TAG_42: "Ice Wall",
  T_33_C_SKILL_DESC_GRAFFITIST: "Creează o zonă de {0} metri care blochează aruncabilele. Aliații din zonă își vor restabili {1}% din durabilitatea armurii în fiecare secundă, iar daunele provocate de muniția inamicului se vor reduce cu {2}%. Durata: {3} secunde. Timp de reactivare: {4} secunde. Efectele nu se cumulează.",
  T_33_C_SKILL_DESC_HITMAN: "Când folosiți lunetiste și puști Marksman, sunetul de tragere este redus la tăcere, iar inamicii doborâți de utilizator sângerează cu {0}% mai repede.",
  T_33_C_SKILL_DESC_KENTA: "Formează un scut frontal cu o lățime de {0} metri care reduce cu {1}% daunele provocate de armele din față. Scutul rămâne activ timp de {2} secunde și se resetează atunci când utilizatorul deschide focul. Timp de reactivare: {3} secunde.",
  T_33_C_SKILL_DESC_MADEMANA: "Eliberează o undă electromagnetică de {0}m care dezactivează inamicii' activarea abilităților, provoacă {3} daune și întrerupe numărătoarea inversă a interacțiunii lor. Durează {1} secunde. Timp de cooldown: {2} s.",
  T_33_C_SKILL_NAME_BODYGUARD: "Expert în arme de foc",
  T_33_C_SKILL_NAME_KENTA: "Furia spadasinului",
  T_33_C_SKILL_NAME_MADEMANA: "Plăcerea luptei",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Skin: Fruity Zasil",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Skin: FFWS Beanie",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Skin: Blooming Falco",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Deadly Baguette",
  T_33_HQ_EMOTE_SONGKRAN_N: "Come and Dance",
  T_33_HQ_G18_CYBERTHIEF_N: "G18- Hypercore Blues",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Grenadă- Hypercore Blues",
  T_33_HQ_M14_SPIDERLILY_N: "M14- Burning Lily",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7- Shadow Rogue",
  T_33_HQ_MP40_FFWS03_N: "MP40- Haven Warrior",
  T_33_HQ_SCAR_FFWS03_N: "SCAR- Haven Warrior",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Coasă Emerald Power",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Pumnal Haven Warrior",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector- Hypercore Blues",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jeep- Emerald Shimmer",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Monster Truck- Bonebruiser Scorch",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Camionetă- Haven Guardian",
  T_33_LO_WS_BHPARA_A: "Activ",
  T_33_LO_WS_BHPARA_ATKMODE: "Tip atac",
  T_33_LO_WS_BHPARA_GROUP: "Echipă",
  T_33_LO_WS_BHPARA_NA: "Fără atac",
  T_33_LO_WS_BHPARA_P: "Pasiv",
  T_33_LO_WS_DICE_DESC: "Un zar care îți îmbunătățește săriturile și poate fi folosit în diferite situații de joc",
  T_33_LO_WS_DICEVXZ: "Viteză orizontală",
  T_33_LO_WS_DICEVY: "Viteză verticală",
  T_33_LO_WS_DTOWER: "Turn",
  T_33_LO_WS_DTOWER_DESC: "Atacă automat inamicii care se află la o anumită distanță de structura defensivă. Este dezactivat dacă nivelul HP ajunge la zero. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_33_LO_WS_FORT: "Fortăreață",
  T_33_LO_WS_FORT_DESC: "Atacă automat inamicii care se află la o anumită distanță de structura critică. Este dezactivată dacă nivelul HP ajunge la zero. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_33_LO_WS_ITEM89: "Rezervor de rafinărie",
  T_33_LO_WS_ITEM89_DESC: "O structură în care este stocată apa",
  T_33_LO_WS_ITEM90: "Cușcă pentru câine",
  T_33_LO_WS_ITEM90_DESC: "O casă pentru cățeluși",
  T_33_LO_WS_ITEM91: "Stație de autobuz",
  T_33_LO_WS_ITEM91_DESC: "O stație obișnuită de autobuz",
  T_33_LO_WS_ITEM92: "Zid cu graffiti",
  T_33_LO_WS_ITEM92_DESC: "Un zid vopsit cu spray-ul",
  T_33_LO_WS_ITEM93: "Grajd",
  T_33_LO_WS_ITEM93_DESC: "O structură de bază din fân",
  T_33_LO_WS_ITEM94: "Bancă",
  T_33_LO_WS_ITEM94_DESC: "O bancă din parc",
  T_33_LO_WS_ITEM95: "Pod de piatră",
  T_33_LO_WS_ITEM95_DESC: "Un pod construit din blocuri de piatră",
  T_33_LO_WS_ITEM96: "Parasolar",
  T_33_LO_WS_ITEM96_DESC: "Prevină arsurile solare cu ajutorul unei umbrele",
  T_33_LO_WS_ITEM97: "Arc pentru linia de sosire",
  T_33_LO_WS_ITEM97_DESC: "Indică linia de sosire",
  T_33_LO_WS_ITEM98: "Panou publicitar",
  T_33_LO_WS_ITEM98_DESC: "Un banner obișnuit pentru reclame",
  T_33_LO_WS_PARA_DM: "Daune",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "Distanța de scanare a inamicului",
  T_33_LO_WS_PARA_SP: "Viteză",
  T_33_LO_WS_ZBPARA_AMOUNT: "Zombi per val",
  T_33_LO_WS_ZBPARA_INTERVAL: "Interval valuri",
  T_33_LO_WS_ZBPARA_ROUND: "Nr. de valuri",
  T_33_LO_WS_ZBSPAWNER: "Spawn Zombi",
  T_33_LO_WS_ZBSPAWNER_DESC: "Zombii apar automat în funcție de configurări. Comportamentul lor poate fi configurat folosind meniul drop-down. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Crește nivel",
  T_33_RW_SKILL_DESC_GANGGIRL: "Crește rata de tragere cu {0}%. Atunci când utilizatorul lovește un inamic, maximum {1}% din rata de tragere se transformă în viteză de mișcare. Abilitatea se resetează atunci când utilizatorul supraviețuiește luptei.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Luptă sau fugi",
  T_33_WT_WS_BASICSET1: "De bază",
  T_33_WT_WS_QCEPRTIP: "Transformă EP în HP mai rapid",
  T_33_WT_WS_SKILLSET_TAG: "Abilitate nelimitată",
  T_33_WT_WS_SKILLSET1: "Setări abilitate",
  T_33_WT_WS_SKILLSET10: "Clepsidra timpului (Chrono)",
  T_33_WT_WS_SKILLSET11: "Ritmul Riptide (Skyler)",
  T_33_WT_WS_SKILLSET12: "Confruntare extremă (Xayne)",
  T_33_WT_WS_SKILLSET13: "Pulsație tămăduitoare (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Abilități pasive",
  T_33_WT_WS_SKILLSET2_TIP: "Activează/dezactivează abilitățile pasive",
  T_33_WT_WS_SKILLSET3: "Abilități active(porniți pentru a regla timpul de încărcare)",
  T_33_WT_WS_SKILLSET3_TIP: "Activați/dezactivați abilitățile active. Dacă este activat, timpul de încărcare al diferitelor abilități active poate fi configurat mai jos.",
  T_33_WT_WS_SKILLSET4: "Camuflaj (Wukong)",
  T_33_WT_WS_SKILLSET5: "Plăcerea luptei (A124)",
  T_33_WT_WS_SKILLSET6: "Drop the Beat (Alok)",
  T_33_WT_WS_SKILLSET7: "Refugiu pictat (Steffie)",
  T_33_WT_WS_SKILLSET8: "Urmărirea pașilor (Clu)",
  T_33_WT_WS_SKILLSET9: "Maestru atotputernic (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "sec",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Raindoll (Pantaloni)",
  T_33_YS_H_ONIGIRI: "Glugă Onigiri",
  T_33_YS_H_RAINCOAT: "Raindoll (Cap)",
  T_33_YS_HA_CRYINGFACE: "Crying Emote (Vopsea pentru față)",
  T_33_YS_M_H_FROGKING: "Șapcă Frog King",
  T_33_YS_S_RAINCOAT: "Raindoll (Pantofi)",
  T_33_YS_T_BLACKHOLE: "Hanorac The Doppler Shift",
  T_33_YS_T_RAINCOAT: "Raindoll (Haină)",
  T_33_YS_T_SOCCER_GREEN: "Electrified Kick (Jersey)",
  T_33_YS_T_SOCCER_YELLOW: "Energized Kick (Jersey)",
  T_33_YS_T_WIFI: "Tricou Net n' Next",
  T_34_C_SKILL_DESC_STREAMERGUY: "Fiecare eliminare va adăuga un spectator, iar numărul de spectatori nu se va reduce. Cu fiecare spectator suplimentar, daunele primite de la loviturile la cap se reduc cu {0}% (max. {1}%), iar daunele aduse inamicilor prin loviturile la cap cresc cu {2}% (max. {3}%).",
  T_34_C_SKILL_DESC_TRACKER: "Lansează o dronă către cel mai apropiat inamic pe o distanță frontală de 100m, creând o explozie de impuls cu diametrul de 5m care reduce viteza de mișcare cu  {0}% și viteza de tragere cu {1}%. Durează {3} secunde. Creează {2} daune. Timp de cooldown: {4}s.",
  T_34_C_SKILL_NAME_TRACKER: "Undă de șoc Senses",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Pet Skin: Angry Surfer Finn",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Pet Skin: Deep Ocean Finn",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Pet Skin: Thunderstorm Finn",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Pet Skin: Digital Tig",
  T_34_DY_SURFSHARK_N: "Finn",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Marele Conductor",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Energetic",
  T_34_HQ_EMOTE_RIDICULE_N: "Ridicol",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Camionul - Inginerul malefic",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk- Cățeluș Husky",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle- Explozie hibridă",
  T_34_JL_G36_MADBIONIC_N: "G36- Flaring Bionica",
  T_34_JL_GRENADE_BIS_N: "Grenadă- Soldier Pixel",
  T_34_JL_MACHETE_RAMPAGE4_N: "Tăișul nopții",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Pumnal Banana",
  T_34_JL_UMP45_BIS_N: "UMP- Digital Dasher",
  T_34_LY_WS_ABS_DESC: "Obține valoarea absolută a acestui număr",
  T_34_LY_WS_ADD_DESC: "Adăugați un nou element la sfârșitul unei liste",
  T_34_LY_WS_AUTO_A: "Scanează automat inamicii",
  T_34_LY_WS_BOT: "Obișnuit",
  T_34_LY_WS_BOT_PATH: "Cale",
  T_34_LY_WS_BOT_TYPE: "Tip",
  T_34_LY_WS_BOT4: "Ax",
  T_34_LY_WS_BOT5: "Aruncă",
  T_34_LY_WS_BOT6: "Self-explode",
  T_34_LY_WS_BOT8: "Măcelar",
  T_34_LY_WS_COL_DESC: "Selectează o culoare",
  T_34_LY_WS_DEL_DESC: "Ștergeți elementul corespunzător al unui index desemnat dintr-o listă",
  T_34_LY_WS_DF_PER: "Apărare %",
  T_34_LY_WS_FORT_INTERVAL: "Timp de interval de atac",
  T_34_LY_WS_GET: "Obține",
  T_34_LY_WS_GET_DESC: "Obțineți elementul corespunzător al unui index desemnat într-o listă",
  T_34_LY_WS_GLEN_ARR_DESC: "Obține numărul de elemente din lista curentă",
  T_34_LY_WS_GLEN_DESC: "Obțineți lungimea acestui șir de text",
  T_34_LY_WS_GVX: "Obține x componenta vectorială",
  T_34_LY_WS_GVX_DESC: "Obține prima componentă a unui vector",
  T_34_LY_WS_GVY: "Obține componenta vectorială y",
  T_34_LY_WS_GVY_DESC: "Obține a doua componentă a unui vector",
  T_34_LY_WS_GVZ: "Se obține componenta vectorială z",
  T_34_LY_WS_GVZ_DESC: "Obține a treia componentă a unui vector",
  T_34_LY_WS_INDEX: "Index",
  T_34_LY_WS_JOIN: "Conectează",
  T_34_LY_WS_NEG_DESC: "Obține valoarea negativă a acestui număr",
  T_34_LY_WS_PATH: "Path Setter",
  T_34_LY_WS_PATH_DESC: "Utilizează pentru a adăuga/șterge trasee de călătorie ale obiectelor vii speciale. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_34_LY_WS_POINT: "Marker",
  T_34_LY_WS_POINT_DESC: "Utilizați pentru a marca locația poziției curente. (Nu este valabil în modurile Clash Squad, Team Deathmatch și Playground)",
  T_34_LY_WS_RANGE_F: "Departe",
  T_34_LY_WS_RANGE_M: "Medium",
  T_34_LY_WS_RANGE_N: "Aproape",
  T_34_LY_WS_RNDF_DESC: "Generați o zecimală aleatorie dintr-un interval",
  T_34_LY_WS_RNDI_DESC: "Generați un număr întreg aleatoriu dintr-un interval",
  T_34_LY_WS_SET: "Set",
  T_34_LY_WS_SET_DESC: "Setați elementul corespunzător al unui index desemnat într-o listă",
  T_34_LY_WS_SQRT_DESC: "Obține rădăcina pătrată a acestui număr",
  T_34_LY_WS_STRC_DESC: "Conectați două șiruri de texte",
  T_34_LY_WS_SVX: "Setați x componentă vectorială",
  T_34_LY_WS_SVX_DESC: "Setați prima componentă a unui vector",
  T_34_LY_WS_SVY: "Setați componenta vectorială y",
  T_34_LY_WS_SVY_DESC: "Setați a doua componentă a unui vector",
  T_34_LY_WS_SVZ: "Setați componenta vectorială z",
  T_34_LY_WS_SVZ_DESC: "Setați a treia componentă a unui vector",
  T_34_LY_WS_VADD: "Adăugarea vectorului",
  T_34_LY_WS_VADD_DESC: "Adaugă doi vectori",
  T_34_LY_WS_VAL_DESC: "Introduceți un număr întreg sau zecimal în funcție de scenariu",
  T_34_LY_WS_VANG_DESC: "Calculați unghiul dintre doi vectori",
  T_34_LY_WS_VCP: "Produs încrucișat",
  T_34_LY_WS_VCP_DESC: "Calculați produsul încrucișat a doi vectori",
  T_34_LY_WS_VDIS_DESC: "Calculați distanța dintre doi vectori",
  T_34_LY_WS_VDP: "Punct produs",
  T_34_LY_WS_VDP_DESC: "Calculați produsul scalar a doi vectori",
  T_34_LY_WS_VFX1: "Sferic",
  T_34_LY_WS_VFX2: "Cilindric",
  T_34_LY_WS_VFX3: "Inel",
  T_34_LY_WS_VFX4: "Boom",
  T_34_LY_WS_VFX5: "Pixels",
  T_34_LY_WS_VFX6: "Sparks",
  T_34_LY_WS_VMOD_DESC: "Calculați mărimea unui vector",
  T_34_LY_WS_VMUL: "Înmulțirea vectorială",
  T_34_LY_WS_VMUL_DESC: "Înmulțiți doi vectori",
  T_34_LY_WS_VNOR_DESC: "Normalizați un vector",
  T_34_LY_WS_VSUB: "Scădere vectorială",
  T_34_LY_WS_VSUB_DESC: "Scădeți doi vectori",
  T_34_M_WS_ANGLE: "Rotește unghiul",
  T_34_M_WS_ARRAY: "Listă",
  T_34_M_WS_ATT: "Proprietate",
  T_34_M_WS_BOOL: "Boolean",
  T_34_M_WS_COLORARRAY: "Matrice de culori",
  T_34_M_WS_COLOUR: "Culoare",
  T_34_M_WS_CONFRONBANNER: "Banner de luptă",
  T_34_M_WS_COORDINATE: "Coordonate",
  T_34_M_WS_CUSTOMINF: "HUD personalizat",
  T_34_M_WS_CUSTOMMODEDESC: "Personalizare completă. Creează și joacă după regulile tale.",
  T_34_M_WS_DAMAGETYPE: "Tip de damage",
  T_34_M_WS_DAMAGETYPEDESC: "Tipul de damage setat în prezent de sistem",
  T_34_M_WS_DESCTEXT: "Text descriptiv",
  T_34_M_WS_DURACTION: "Durată",
  T_34_M_WS_ECAMODE: "Personalizați modul",
  T_34_M_WS_ENDPHASEDESC: "Încheie imediat etapa actuală și treci la următoarea",
  T_34_M_WS_ENTITY: "Entitate",
  T_34_M_WS_FLOAT: "Zecimal",
  T_34_M_WS_GAME: "Joc",
  T_34_M_WS_GAMERESULTS: "Rezultatul meciului",
  T_34_M_WS_GETCONTROL2: "Obține o entitate de control din interfața jucătorilor pentru a edita proprietățile entității (inclusiv design, culoare, conținut etc.)",
  T_34_M_WS_HEIGHT: "Înălţime",
  T_34_M_WS_HUDBUTTONWIDGET: "Controlul butonului",
  T_34_M_WS_HUDEMPTYWIDGET: "Pivot gol",
  T_34_M_WS_HUDIMAGEWIDGET: "Controlul imaginii",
  T_34_M_WS_HUDINPUTWIDGET: "Control caseta de text",
  T_34_M_WS_HUDLABELWIDGET: "Controlul textului",
  T_34_M_WS_ICON: "Icon",
  T_34_M_WS_ICON_AIM: "Țintă",
  T_34_M_WS_ICON_ARROW: "Săgeată",
  T_34_M_WS_ICON_BLAST: "Explozie",
  T_34_M_WS_ICON_CIRCULAR: "Cerc",
  T_34_M_WS_ICON_CLOTH: "palmier",
  T_34_M_WS_ICON_COLLIMATION: "Crosshair",
  T_34_M_WS_ICON_CORPSE: "Zombie",
  T_34_M_WS_ICON_CROSS: "Cruce",
  T_34_M_WS_ICON_DAY: "Soare",
  T_34_M_WS_ICON_DEFENSE: "Scut",
  T_34_M_WS_ICON_DIALOGUE: "DIalog",
  T_34_M_WS_ICON_DIAMONDS: "Diamant",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Semn de exclamație",
  T_34_M_WS_ICON_FLAG: "Steag",
  T_34_M_WS_ICON_FOLDER: "Folder",
  T_34_M_WS_ICON_GLASSES: "Ochi",
  T_34_M_WS_ICON_GUN: "Pistol",
  T_34_M_WS_ICON_HEART: "Inimă",
  T_34_M_WS_ICON_HEXAGON: "Hexagon",
  T_34_M_WS_ICON_HOURGLASS: "Clepsidră",
  T_34_M_WS_ICON_HOUSE: "casă",
  T_34_M_WS_ICON_KEY: "cheie",
  T_34_M_WS_ICON_LIGHTNING: "Fulger",
  T_34_M_WS_ICON_LOCK: "Lacăt",
  T_34_M_WS_ICON_LOOP: "Buclă",
  T_34_M_WS_ICON_MAGNIFIER: "Lupă",
  T_34_M_WS_ICON_MONEY: "Banu",
  T_34_M_WS_ICON_MONTH: "Lună",
  T_34_M_WS_ICON_OPENFOLDER: "Deschide folder",
  T_34_M_WS_ICON_PLUS: "Plus",
  T_34_M_WS_ICON_QUADRI: "Patrulater",
  T_34_M_WS_ICON_QUESTIONMARK: "Semnul întrebării",
  T_34_M_WS_ICON_RECYCLING: "Reciclează",
  T_34_M_WS_ICON_REFRESH: "Reîmprospătează",
  T_34_M_WS_ICON_REST: "Odihnă",
  T_34_M_WS_ICON_RETURN: "Înapoi",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Trapezul drept",
  T_34_M_WS_ICON_SCISSORS: "Foarfece",
  T_34_M_WS_ICON_SETUP: "Setare",
  T_34_M_WS_ICON_SIGN: "Semn",
  T_34_M_WS_ICON_SIGNOUT: "Ieșire",
  T_34_M_WS_ICON_SQUARE: "Pătrat",
  T_34_M_WS_ICON_STAR: "Stea",
  T_34_M_WS_ICON_STONE: "Piatră",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Colac de înot",
  T_34_M_WS_ICON_TAGGING: "Pin",
  T_34_M_WS_ICON_THESWORD: "Sabie",
  T_34_M_WS_ICON_TRAPEZOID: "Trapez",
  T_34_M_WS_ICON_TRASHCAN: "Coș de gunoi",
  T_34_M_WS_ICON_TRIANGLE: "Triunghi",
  T_34_M_WS_ICON_TROPHY: "Trofeu",
  T_34_M_WS_ICON_UP: "Bravo",
  T_34_M_WS_ICON_WRONG: "Greșit",
  T_34_M_WS_ICON_YES: "Dreapta",
  T_34_M_WS_ICONNAME: "Numele pictogramei",
  T_34_M_WS_INT: "Întreg",
  T_34_M_WS_KILLZONE: "Zona Doom",
  T_34_M_WS_LEFTCOLOR: "Culoarea stângă",
  T_34_M_WS_LEFTTEAMINDEX: "Indexul echipei stangi",
  T_34_M_WS_LEFTTEAMSCORE: "Scorul echipei stângi",
  T_34_M_WS_LOCSWITCH: "Comutator de localizare",
  T_34_M_WS_MAX: "Maximum",
  T_34_M_WS_MIN: "Minimum",
  T_34_M_WS_NUMBER: "Număr",
  T_34_M_WS_OBJECT: "Entitate",
  T_34_M_WS_OPEN: "On",
  T_34_M_WS_OPENSATUS: "Activați starea",
  T_34_M_WS_PICTURE: "Grafică",
  T_34_M_WS_RANKARRAY: "Matrice de rang",
  T_34_M_WS_RESULTS: "Rezultate",
  T_34_M_WS_RIGHTCOLOR: "Culoarea dreapta",
  T_34_M_WS_RIGHTTEAMINDEX: "Indexul echipei drepte",
  T_34_M_WS_RIGHTTEAMSCORE: "Scorul echipei din dreapta",
  T_34_M_WS_ROUNDBANNER: "Banner de rundă",
  T_34_M_WS_ROUNDDESC: "Descriere rotundă",
  T_34_M_WS_ROUNDHUD: "Număr rotund",
  T_34_M_WS_ROUNDPARAMS: "matrice de numere rotunde",
  T_34_M_WS_SAME_NAME: "Nume există deja. Vă rugăm să încercați unul nou.",
  T_34_M_WS_SCOREARRAY: "Matrice de scor",
  T_34_M_WS_SCORINGTYPE: "Tip de scor",
  T_34_M_WS_SCORINGTYPEDECS: "Tipul de scor pe care l-ar putea obține jucătorii. Suporta personalizarea scorului.",
  T_34_M_WS_SCUFFLESCORING: "Scorul pentru mai multe echipe",
  T_34_M_WS_SETATTRIBUTES: "Setări de proprietate",
  T_34_M_WS_SHUT: "Off",
  T_34_M_WS_SOUND: "Efecte sonore",
  T_34_M_WS_SOUNDCLICK: "Click",
  T_34_M_WS_SOUNDDD: "Numărătoare inversă",
  T_34_M_WS_SOUNDFEMALEA: "Rănită (femeie)",
  T_34_M_WS_SOUNDM: "Împuşcătură",
  T_34_M_WS_SOUNDMALEA: "Rănit (bărbat)",
  T_34_M_WS_SOUNDUAV: "Explozie",
  T_34_M_WS_ST_ASSISTCOUNT: "Asistență",
  T_34_M_WS_ST_CHECKPROGRESS: "Progres Checkpoint",
  T_34_M_WS_ST_DAMAGESUM: "Damage",
  T_34_M_WS_ST_FINISHCOUNT: "Cantitatea de obiective atinse",
  T_34_M_WS_ST_FINISHORDER: "Ordinea obiectivelor atinse",
  T_34_M_WS_ST_FINISHTIME: "Timpul obiectivelor atinse",
  T_34_M_WS_ST_KILLCOUNT: "Ucideri",
  T_34_M_WS_ST_MAINSCORE: "Scor target",
  T_34_M_WS_ST_RANKSCORE: "Scor de rank",
  T_34_M_WS_ST_SURVIVALDURACTION: "Timp de supraviețuire",
  T_34_M_WS_ST_UNKOWN: "Necunoscut",
  T_34_M_WS_STARTBANNER: "Banner de start",
  T_34_M_WS_STARTTIME: "Timp de start",
  T_34_M_WS_STRING: "Text",
  T_34_M_WS_STUDIO: "STUDIO",
  T_34_M_WS_TEAMARRAY: "Matrice de echipe",
  T_34_M_WS_TEXTCONTENT: "Conținut",
  T_34_M_WS_THEMECOLOR: "Culoare tematică",
  T_34_M_WS_TIME: "Numărătoare inversă",
  T_34_M_WS_TITLETEXT: "Text titlu",
  T_34_M_WS_TYPE: "Tip",
  T_34_M_WS_UODATETYPE: "Tip de update",
  T_34_M_WS_VARNAME: "Nume variabil",
  T_34_M_WS_VECTOR: "Vector",
  T_34_M_WS_VFX: "Efecte vizuale",
  T_34_M_WS_WIDTH: "lăţime",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "Foc",
  T_34_SP_WS_BLOCK1_NAME: "Schimbă stage-ul",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Schimbă etapa unui meci pentru a intra în etapa (sau runda) dorită. Rundele au și indici de etapă și sunt un tip special de etapă.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "Indicele etapei țintă",
  T_34_SP_WS_BLOCK10_NAME: "Creați efecte vizuale",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Creați o pictogramă folosind efectele vizuale desemnate. Mai multe proprietăți ale efectului vizual pot fi configurate prin ajustarea proprietăților efectelor vizuale ale entității .",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Efect vizual",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Tipurile de efecte vizuale care pot fi aplicate",
  T_34_SP_WS_BLOCK12_NAME: "Ștergeți efectele vizuale",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Ștergeți efectul vizual desemnat",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Entitate cu efecte vizuale",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "Entitatea cu efect vizual care trebuie ștearsă",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Ordonați clientului să joace efectul vizual",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Lista jucătorilor",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "Jucătorii care vor primi mesajul",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Calea resursei",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "Calea resurselor de sistem este în:cale. Calea personalizată a resursei este out:path. Goală în mod implicit.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "Canal RGBA, fiecare canal care are o valoare între 0 și 255 salvat în int32. Culoarea implicită este alb (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Zoom",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Scală Zoom; implicit este 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Poziția afișajului exprimată în coordonate globale. Vector3(0) implicit.",
  T_34_SP_WS_BLOCK14_NAME: "Redați efectul sonor",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Ordonați clientului să joace efectul sonor",
  T_34_SP_WS_BLOCK15_NAME: "Jurnal de ieșire",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Distribuiți conținut în interfața de jurnal",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Porniți pentru a activa daunele aduse jucătorilor din afara zonei de siguranță",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "Punctul central al zonei de siguranță",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Radius",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "Raza zonei de siguranță",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "Numărătoarea inversă pentru când Zona de siguranță va începe să se micșoreze",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "Durata zonei de siguranță se micșorează",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "Valoarea daunelor suferite în afara zonei de siguranță",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Când Zona de pericol este dezactivată, jucătorii din afara zonei de siguranță nu vor primi damage",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Utilizați pentru a întârzia o acțiune ulterioară pentru un timp stabilit",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "Durata așteptării, măsurată în milisecunde",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Utilizează pentru a amâna o acțiune ulterioară la următorul cadru",
  T_34_SP_WS_BLOCK6_NAME: "Creați HUD personalizat",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Creați un HUD personalizat desemnat",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "Un nume care este folosit pentru crearea unei entități HUD. Variabila locală căreia îi corespunde este entitatea HUD-ului creat.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Jucător",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "Entitatea unui anumit jucător. Vizibil doar pentru respectivul jucător.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "Index-ul unic al unui HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Creați un HUD implicit, care este vizibil numai pentru jucătorii desemnați",
  T_34_SP_WS_BLOCK8_NAMEDESC: "Când este șters, HUD-ul implicit nu va fi văzut pe client (fie ascuns, fie eliminat)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "Entitate HUD",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "Entitatea HUD care urmează să fie ștearsă",
  T_34_SP_WS_BLOCK9_NAMEDESC: "Când este șters, HUD-ul personalizat nu va fi văzut pe client (fie ascuns, fie eliminat)",
  T_34_T_WS_BLOCK1_NAMEDESC: "Incidentul se declanșează atunci când începe meciul",
  T_34_T_WS_BLOCK10_NAMEDESC: "Incidentul se declanșează atunci când un jucător este eliminat",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "Jucătorul eliminat care va declanșa incidentul",
  T_34_T_WS_BLOCK13_NAMEDESC: "Incidentul se declanșează atunci când un jucător asistă un alt jucător",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "Jucătorul care este eliminat",
  T_34_T_WS_BLOCK14_NAMEDESC: "Incidentul se declanșează atunci când un jucător provoacă damage",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "Jucătorul care primește damage-ul",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "Tipul de damage cauzat",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "Valoarea de damage cauzată",
  T_34_T_WS_BLOCK15_NAMEDESC: "Incidentul se declanșează atunci când un jucător elimină un alt jucător",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "Jucătorul care este eliminat",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "Tipul de daune care provoacă eliminarea",
  T_34_T_WS_BLOCK16_NAMEDESC: "Incidentul se declanșează atunci când un jucător se alătură meciului",
  T_34_T_WS_BLOCK17_NAMEDESC: "Incidentul se declanșează atunci când un jucător este reînviat",
  T_34_T_WS_BLOCK18_NAMEDESC: "Incidentul se declanșează atunci când o echipă este eliminată",
  T_34_T_WS_BLOCK19_NAMEDESC: "Incidentul se declanșează atunci când este adăugată o echipă",
  T_34_T_WS_BLOCK2_NAMEDESC: "Incidentul se declanșează când meciul se termină",
  T_34_T_WS_BLOCK20_NAMEDESC: "Incidentul se declanșează atunci când o echipă este eliminată",
  T_34_T_WS_BLOCK3_NAMEDESC: "Incidentul se declanșează când începe fiecare rundă",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "Numărul rotund începe de la 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Round index",
  T_34_T_WS_BLOCK4_NAMEDESC: "Incidentul se declanșează când fiecare rundă se termină",
  T_34_T_WS_BLOCK5_NAMEDESC: "Incidentul se declanșează atunci când începe etapa",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "Numărul etapei începe de la 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Entitate scenă",
  T_34_T_WS_BLOCK6_NAMEDESC: "Incidentul se declanșează când etapa se termină",
  T_34_T_WS_BLOCK7_NAMEDESC: "Incidentul se declanșează atunci când un jucător iese din meci",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "Jucătorul care va declanșa incidentul",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Jucător care declanșează",
  T_34_T_WS_BLOCK8_NAMEDESC: "Incidentul se declanșează atunci când scorul unui jucător se modifică",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "Tipul scorului modificat",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "Valoarea scorului după modificare",
  T_34_T_WS_BLOCK9_NAMEDESC: "Incidentul se declanșează atunci când scorul unei echipe se modifică",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "Echipa care va declanșa incidentul",
  T_34_WT_WS_BORNENTITY_PARAM1: "Punct Spawn",
  T_34_WT_WS_BORNENTITY_PARAM2: "Coordonate disponibile",
  T_34_WT_WS_BORNENTITY_PARAM3: "Setați ca punct implicit de apariție",
  T_34_WT_WS_BORNENTITY_PARAM4: "Granițe strălucitoare",
  T_34_WT_WS_BORNENTITY_PARAM5: "În uz sau nu",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Managementul punctelor de control",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Status deschis",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Status trigger",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Declanșator de eliminare sau nu",
  T_34_WT_WS_ENTITY_PARAM1: "Entitate joc",
  T_34_WT_WS_ENTITY_PARAM10: "# de echipe",
  T_34_WT_WS_ENTITY_PARAM11: "# de membri ai echipei",
  T_34_WT_WS_ENTITY_PARAM12: "Resetarea echipamentului în fiecare rundă",
  T_34_WT_WS_ENTITY_PARAM13: "Activați damage-ul în afara zonei",
  T_34_WT_WS_ENTITY_PARAM14: "Dimensiunea zonei",
  T_34_WT_WS_ENTITY_PARAM15: "Ora de începere a micșorării zonei",
  T_34_WT_WS_ENTITY_PARAM16: "Durată de micșorare a zonei",
  T_34_WT_WS_ENTITY_PARAM17: "Daune în afara zonei",
  T_34_WT_WS_ENTITY_PARAM18: "Scorul țintă",
  T_34_WT_WS_ENTITY_PARAM19: "Scor de eliminare",
  T_34_WT_WS_ENTITY_PARAM2: "Status invalid",
  T_34_WT_WS_ENTITY_PARAM20: "Tip de înviere",
  T_34_WT_WS_ENTITY_PARAM21: "Criterii de clasare a scorului rundei (jucător)",
  T_34_WT_WS_ENTITY_PARAM22: "Importanța criteriilor (jucător)",
  T_34_WT_WS_ENTITY_PARAM23: "Criterii de clasare a scorului rundei (echipă)",
  T_34_WT_WS_ENTITY_PARAM24: "Importanța criteriilor (echipă)",
  T_34_WT_WS_ENTITY_PARAM25: "Criterii de clasare a scorurilor (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Importanța criteriilor (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Scorul de clasare al rundei",
  T_34_WT_WS_ENTITY_PARAM28: "Afișați criteriile pe pagina de rezultate",
  T_34_WT_WS_ENTITY_PARAM29: "Total # runde",
  T_34_WT_WS_ENTITY_PARAM3: "Timp joc",
  T_34_WT_WS_ENTITY_PARAM4: "Index-ul round curent",
  T_34_WT_WS_ENTITY_PARAM5: "Current stage index",
  T_34_WT_WS_ENTITY_PARAM6: "Mode template ID",
  T_34_WT_WS_ENTITY_PARAM7: "Activați învierea jucătorului",
  T_34_WT_WS_ENTITY_PARAM8: "Activați reînvierea bot-ului",
  T_34_WT_WS_ENTITY_PARAM9: "Timp de înviere",
  T_34_WT_WS_ENTITY1_NAME: "Entitate curentă",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Reveniți la entitatea curentă",
  T_34_WT_WS_ENTITY10_NAME: "Eliminați pictograma",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Eliminați o pictogramă desemnată",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Selectați pictograma pe care doriți să o eliminați",
  T_34_WT_WS_ENTITY11_NAME: "Eliminați textul",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Eliminați o entitate text",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Selectați textul pe care doriți să îl eliminați",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Adăugați un articol pentru un jucător desemnat",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Jucătorii care vor primi articolul",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "ID-ul articolului specific care trebuie obținut",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "Cantitatea de articole care trebuie oferite",
  T_34_WT_WS_ENTITY12_PARAM3: "Cantitate",
  T_34_WT_WS_ENTITY13_PARAM1: "Tip",
  T_34_WT_WS_ENTITY13_PARAM2: "Locație",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "Coordonatele locației de apariție a obiectului",
  T_34_WT_WS_ENTITY13_PARAM4: "Obiect",
  T_34_WT_WS_ENTITY14_NAME: "Elimină obiectul",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Eliminați un obiect desemnat",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Șterge obiectul",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Obțineți toate entitățile jucătorului",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Achiziționați toate entitățile echipei",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Recuperați o cantitate desemnată de HP pentru jucătorii desemnați. Dacă valoarea recuperată depășește valoarea maximă HP, HP-ul se va recupera doar la maximum.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Jucători ale căror fluctuații HP sunt configurate",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "Cantitatea de HP desemnată care trebuie recuperată",
  T_34_WT_WS_ENTITY18_NAME: "Obține coordonate aleatorii de apariție",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Configurați locația unde jucătorii desemnați vor aparea și la care trebuie să se întoarcă",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Jucători care vor apărea aleatoriu din această locație",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Coordonatele locației în care jucătorul va fi repartizat",
  T_34_WT_WS_ENTITY19_NAME: "Obțineți scorul jucătorului",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Obțineți anumite scoruri ale jucătorilor desemnați",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Obțineți entitatea de scor a acestui jucător(i)",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Obțineți tipul de scor",
  T_34_WT_WS_ENTITY19_RETURNDESC: "Valoarea specifică a punctajului de obținut",
  T_34_WT_WS_ENTITY2_NAME: "Setați proprietatea",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Configurați valoarea unei proprietăți, unde tipul de proprietate a fost deja selectat",
  T_34_WT_WS_ENTITY2_PARAM1: "Entitate",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "Valoarea proprietății entității de joc",
  T_34_WT_WS_ENTITY2_PARAM3: "Proprietate",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "O anumită proprietate a acestei entități de joc",
  T_34_WT_WS_ENTITY2_PARAM4: "Valoare",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "O valoare specifică a unei proprietăți. Asigurați-vă că tipul de proprietate se aliniază cu cel selectat și se potrivește cu tipul configurat în blocurile aferente.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Configurați anumite scoruri ale jucătorilor desemnați",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Configurați entitatea de scor a acestui jucător(i)",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Configurați tipul de scor",
  T_34_WT_WS_ENTITY20_PARAM3: "Scor",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "Se setează valoarea punctajului specific",
  T_34_WT_WS_ENTITY21_NAME: "Scorul total obținut de echipă",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Obțineți anumite scoruri totale ale echipelor desemnate",
  T_34_WT_WS_ENTITY21_PARAM1: "Echipă",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Obțineți entitatea de scor a acestei echipe (echipe)",
  T_34_WT_WS_ENTITY22_NAME: "Setați scorul rundei curente pentru echipa",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Configurați un anumit tip de scoruri ale rundei curente ale echipelor desemnate",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Configurați scorul (scorurile) acestei echipe",
  T_34_WT_WS_ENTITY23_NAME: "Obține scorul rundei jucătorului",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Obține anumite scoruri dintr-o anumită rundă pentru jucătorii desemnați",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Obțineți scorul (scorurile) rundei acestui jucător(i)",
  T_34_WT_WS_ENTITY23_PARAM2: "Rundă",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Obțineți scorul din această rundă",
  T_34_WT_WS_ENTITY24_NAME: "Obține scorul rundei echipei",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Obține anumite scoruri dintr-o anumită rundă pentru echipele desemnate",
  T_34_WT_WS_ENTITY25_NAME: "Teleportează-te",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Teleportați jucătorii desemnați într-o locație desemnată",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Jucători care se vor teleporta",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Coordonatele locului în care jucătorul (jucătorii) vor fi teleportați",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Permiteți jucătorilor desemnați să provoace damage țintelor desemnate. Dacă nu este selectat niciun jucător atacator, țintele desemnate vor primi damage din partea sistemului.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entitățile care vor primi damage-ul",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "Valoarea damage-ului făcut",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Reînvie jucătorii desemnați",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Jucători entități care pot fi reînviați",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Configurați tipul blocului",
  T_34_WT_WS_ENTITY3_PARAM1: "ca",
  T_34_WT_WS_ENTITY4_NAME: "Obține proprietatea",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Obține o proprietate specifică a unei entități",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Obține entitatea de joc specifică pentru valoarea proprietății",
  T_34_WT_WS_ENTITY4_RETURNDESC: "Valoarea specifică a proprietății care trebuie obținută",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Configurați capacitatea de mișcare pentru toți jucătorii",
  T_34_WT_WS_ENTITY6_NAME: "Creați pictogramă",
  T_34_WT_WS_ENTITY6_PARAM1: "pictograma",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "O imagine afișată pe HUD. Alege din mai multe, diverse modele.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Selectați pictograma pe care trebuie aplicat designul",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Creați o pictogramă HUD pentru jucătorii desemnați. Dacă nu este selectată nicio entitate de jucător, HUD-ul va fi creat pentru toți jucătorii.",
  T_34_WT_WS_ENTITY7_PARAM1: "Jucător",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Creați o pictogramă HUD pentru jucătorii selectați",
  T_34_WT_WS_ENTITY8_NAME: "Crează text",
  T_34_WT_WS_ENTITY8_PARAM1: "Text",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "Conținutul textului specific trebuie creat din această comandă",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "Entitatea text care este creată în prezent",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Adăugați o linie de text HUD pentru jucătorii desemnați. Dacă nu este selectată nicio entitate de jucător, textul va fi creat în HUD-ul tuturor jucătorilor.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Adăugați un text HUD pentru jucători selectați",
  T_34_WT_WS_ICONENTITY_PARAM1: "Entitate pictogramă",
  T_34_WT_WS_ICONENTITY_PARAM2: "Design",
  T_34_WT_WS_ICONENTITY_PARAM3: "Culoare",
  T_34_WT_WS_ICONENTITY_PARAM4: "Scală",
  T_34_WT_WS_ICONENTITY_PARAM5: "Poziția afișajului",
  T_34_WT_WS_ICONENTITY_PARAM6: "Urmăriți ținta",
  T_34_WT_WS_ICONENTITY_PARAM7: "Vizibil prin pereți",
  T_34_WT_WS_ICONENTITY_PARAM8: "Întotdeauna pe ecran",
  T_34_WT_WS_ONETEAM_TAG: "O singură echipă",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Entitate etapă",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Indice de etapă",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Timpul de începere",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Sfârșitul timpului",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Durată",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Entitate jucător",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Punct de înviere",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Damage-ul armei %",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Model caracter 3D",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Identitate",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "HP-ul curent",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Statusul jucătorului",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Timp de supraviețuire",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Invulnerabil",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Echipa",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "Target checkpoint ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Punct spawn",
  T_34_WT_WS_PROCIRCLE_ICON: "Icon",
  T_34_WT_WS_PVEDESC1: "Dacă cel puțin un jucător ajunge la linia de sosire înainte de expirarea timpului, echipa câștigă. Dacă toți jucătorii sunt eliminați în același timp, jocul se termină.",
  T_34_WT_WS_PVEDESC2: "Supraviețuiește pentru un timp stabilit pentru a câștiga. Dacă toți jucătorii sunt eliminați în același timp, jocul se termină.",
  T_34_WT_WS_PVENAME1: "Grăbește-te",
  T_34_WT_WS_PVENAME2: "Rezistență",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "Current checkpoint ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Numărul punctului de control al modului Parkour",
  T_34_WT_WS_SKILLSET14: "Mânia spadasinului (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Entitate echipă",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Ace",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Toți membrii",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Trigger regular",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Tip de aspect",
  T_34_WT_WS_TXTENTITY_PARAM1: "Entitate text",
  T_34_WT_WS_TXTENTITY_PARAM2: "Conţinut",
  T_34_WT_WS_VFXENTITY_PARAM1: "Entitate cu efecte vizuale",
  T_34_WZ_WS_LOGIC10_NAME: "Continuați cu următoarea",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Omiteți iterația curentă a buclei și executați următoarea",
  T_34_WZ_WS_LOGIC11_NAME: "Înapoi",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Termină execuția curentă și revine la programul principal. Permite trimiterea înapoi a datelor la întoarcere.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Valoare returnată",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Datele vor fi trimise înapoi în programul principal",
  T_34_WZ_WS_LOGIC2_NAME: "Compară",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Comparați 2 valori folosind un operator desemnat",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Valoarea din stânga",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "Valoarea din stânga folosită pentru comparație",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Funcția de comparație",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Selectați cum doriți să comparați valorile. Operatorii acceptați sunt: >, >=,==, !=, <=, <, AND (numai Boolean), SAU (numai Boolean)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Valoarea dreaptă",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "Valoarea din partea dreaptă utilizată pentru comparație",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Rezultatul comparației",
  T_34_WZ_WS_LOGIC3_NAME: "NU",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Oferă inversul unei valori logice",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "Valoarea pe care doriți să utilizați operatorul NOT",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Result of the NOT operation",
  T_34_WZ_WS_LOGIC4_NAME: "Check empty",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Verifică dacă o entitate este goală/nulă",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entitate",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "Entitatea pentru care se verifică golul",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Indiferent dacă entitatea este sau nu goală",
  T_34_WZ_WS_LOGIC5_NAME: "Declarații condiționale",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Se execută în funcție de îndeplinirea sau nu a condițiilor. Subprocesele sunt aceleași cu ramurile logice ulterioare.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Valoare",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "Numărul de condiții și numărul de subprocese (ramuri logice) trebuie să fie același",
  T_34_WZ_WS_LOGIC6_NAME: "Bucla de interval întreg",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Buclă de la x la y cu un pas de z. Sub-procesul este bucla în sine.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "Numele indexului buclei care poate fi folosit pentru a extrage valoarea indexului buclei unei variabile locale",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Valoarea de început",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "Valoarea la care începe bucla",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Valoarea finală",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "Valoarea la care se termină bucla",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Etapă",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "Pasul fiecărei bucle. Când valoarea de început este mai mică decât valoarea finală, pasul ar trebui să fie mai mare decât 0. Când valoarea de început este mai mare decât valoarea finală, pasul ar trebui să fie mai mic de 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Bucla fiecărui element",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Permite traversarea unui container de date pentru a extrage fiecare sub-element din acesta. Sub-procesul este bucla în sine.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Element",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Trecerea la acest nume va extrage valoarea subelementului variabilei locale",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Container de date",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "Containerul de date de parcurs. În prezent, acceptă tipuri de liste.",
  T_34_WZ_WS_LOGIC8_NAME: "Buclă condiționată",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "O buclă condiționată se repetă până când este îndeplinită o condiție. Bucla se oprește când condiția este falsă.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Condiție",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Repetă bucla dacă condiția este adevărată și se oprește până când condiția este falsă",
  T_34_WZ_WS_LOGIC9_NAME: "Break loop",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Oprește procesul curent al buclei și iese din buclă",
  T_34_Y_B_DINOSAURS: "Dinosaur Illusion (Pantaloni)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Pure Angel (F)",
  T_34_YS_F_B_PANDACATTLE: "Moo Zoo (Pantaloni)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Aqua Rogue (Pantaloni)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Aqua Rogue (Cap)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Aqua Rogue (Vopsea de față)",
  T_34_YS_F_S_PANDACATTLE: "Moo Zoo (Pantofi)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Aqua Rogue (Pantofi)",
  T_34_YS_F_T_PANDACATTLE: "Moo Zoo (haină)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Aqua Rogue (haină)",
  T_34_YS_M_B_ANGEL_BW: "Pure Angel (M)",
  T_34_YS_M_B_PANDACATTLE: "Panda Pyjamas (Pantaloni)",
  T_34_YS_M_H_PANDACATTLE: "Panda Pyjamas (Cap)",
  T_34_YS_M_S_PANDACATTLE: "Panda Pyjamas (Pantofi)",
  T_34_YS_M_T_PANDACATTLE: "Panda Pyjamas (Haină)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Câștigă {0} EP doborând un inamic.",
  T_35_DY_PET_OWL_N: "Hoot",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Pet Skin: Spaceship Moony",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Pet Skin: Azulcrema Trace Zasil",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Pet Skin: Agui Blue",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Pet Skin: Hoot On Fire",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Pet Skin: Nocturnal Hoot",
  T_35_DY_PETSKIN_OWL_STORM_N: "Pet Skin: Frosty Hoot",
  T_35_JL_KNOCKEDDOWN: "este doborât",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "Pentru {1} s, tragerea cu succes într-un Gloo Wall va marca inamicii pe o rază de {3} m de acesta și va pătrunde în Gloo Wall-ul pentru a provoca daune inamicilor marcați (daunele cauzate vor fi mai mici decât de obicei). Eficient pe {0} Gloo Walls max. Timp de cooldown: {2} s.",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Wall Brawl",
  T_35_KY_INFECTION_MAPNAME: "Wasteland",
  T_35_M_WS_BUTTONCLICKDESC: "Declanșează incidentul atunci când este apăsat butonul corespunzător. Declanșatorul poate fi obținut folosind parametri.",
  T_35_M_WS_GETTEAMMATEPOS: "Obține coechipieri din apropiere' locații",
  T_35_M_WS_ROUND2: "Val curent",
  T_35_PD_Infection_HUMANSELECT: "Alege o armă",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "Obiect",
  T_35_QX_WS_ICONTYPE_NATURE: "Forme ale naturii",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geometric",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Simbol",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Armă",
  T_35_R_EMOTE_TAG_MUSIC_N: "Muzică",
  T_35_RW_SKILL_DESC_Singers: "Utilizatorul de abilități și aliații din {0}m pot bloca daune cu {1}% folosind EP. În acest caz, suma de EP dedusă de la aliați va fi adăugată la EP al utilizatorului de abilități.",
  T_35_RW_SKILL_NAME_Singers: "Santinelă silențioasă",
  T_35_SP_WS_COMMENTKEY_01: "Dificultate adecvată",
  T_35_SP_WS_COMMENTKEY_02: "Creativ",
  T_35_SP_WS_COMMENTKEY_03: "Joc Interesant",
  T_35_SP_WS_COMMENTKEY_04: "Poate fi jucat în mod repetat",
  T_35_SP_WS_COMMENTKEY_05: "Poveste intrigantă",
  T_35_SP_WS_COMMENTKEY_06: "Bine echilibrat",
  T_35_SP_WS_COMMENTKEY_07: "Experiență plăcută",
  T_35_SP_WS_COMMENTKEY_08: "Flexibil",
  T_35_SP_WS_COMMENTKEY_09: "Plăcut estetic",
  T_35_SP_WS_COMMENTKEY_10: "Prea dificil",
  T_35_SP_WS_COMMENTKEY_11: "Prea ușor",
  T_35_SP_WS_COMMENTKEY_12: "Plictisitor",
  T_35_SP_WS_COMMENTKEY_13: "Prea lung",
  T_35_SP_WS_COMMENTKEY_14: "Dezechilibrat",
  T_35_SP_WS_COMMENTKEY_15: "Experiență neplăcută",
  T_35_SP_WS_IMAGE03: "Textură",
  T_35_SP_WS_IMAGE04: "Ramă",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buster- Lava Lustre",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Grenadă- Crystal Eerie",
  T_35_SY_GRENADE_PIRATES_N: "Grenadă- Rowdy Searuler",
  T_35_SY_GRENADE_RIDERS_N: "Grenadă- Grim Rider",
  T_35_SY_M24_KUN_N: "M24- Riverdust Splasher",
  T_35_SY_SCAR_PARKOUR_N: "SCAR- Gusto Freerunner",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jeep- Monochrome Jigsaw",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Bucurați-vă de sărbătoare!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Motocicletă - Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Structură & Decor",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Structuri",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Altele",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Arhitectură",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Case Mari",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Case Medium",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Obiecte de joc",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Esențiale ale modului",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Muzică",
  T_35_WT_WS_PVEMODE_TAG: "Mod de Supravietuire",
  T_35_WZY_WS_BECRE_NAMEDESC: "Se declanșează atunci când această entitate este creată",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Se declanșează atunci când această entitate este eliminată. Sursa atacului poate fi identificată folosind "Trigger Entity" iar tipul de atac poate fi identificat folosind "Tipul de daune”".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "Entitatea care declanșează incidentul",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Creați un tip de articol sau un set de articole într-o anumită locație. Când creați un tip de articol, suma este numărul articolului respectiv. La crearea unui set de articole, suma este lista de sume care corespunde listei de articole. Elementele create vor depinde de unitățile hărții.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "O listă care conține elementele care vor fi create. De asemenea, poate consta dintr-un singur articol.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "O listă de sume care corespunde listei de articole. Poate conține doar cantitatea unui tip de articol.",
  T_35_WZY_WS_DAMTYPE_CAR: "Vehicul",
  T_35_WZY_WS_DAMTYPE_FALL: "Cădere",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Pistol",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Grenadă",
  T_35_WZY_WS_DAMTYPE_MELEE: "corp la corp",
  T_35_WZY_WS_DAMTYPE_ZONE: "În afara zonei",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Șterge un anumit număr de articole ale anumitor jucători",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Intră în zona de declanșare",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Se declanșează atunci când o "Trigger Entity" intră într-o zonă de declanșare',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "Jucătorul să obțină entitatea. Când este conectată cu jucătorul, informațiile entității vor fi actualizate numai pentru respectivul jucător. Când niciun jucător nu este conectat, toți jucătorii vor primi informațiile despre entitate.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Entitate Luptă",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Obține toate obiectele de un tip specificat. Rezultatul returnat este o listă.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Tipul obiectului",
  T_35_WZY_WS_HUDWIDGET_NAME: "Control UI",
  T_35_WZY_WS_HURT_NAMEDESC: 'Se declanșează atunci când această entitate primește daune. Sursa atacului poate fi identificată folosind "Trigger Entity".',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "Tipul articolului",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Obiect de scenă",
  T_35_WZY_WS_OBKILL_NAMEDESC: "Se declanșează atunci când această entitate elimină o altă entitate. Tipul de entitate care este eliminată poate fi identificat utilizând „Entitate eliminată”.",
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "Entitatea care este eliminată",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Se declanșează atunci când o entitate provoacă daune",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "Entitatea care provoacă daune",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Entitate dăunătoare",
  T_35_WZY_WS_PREFABID_NAME: "ID șablon",
  T_35_WZY_WS_PROPERTY_EPNOW: "EP Curent",
  T_35_WZY_WS_PROPERTY_JUMP: "Înălțimea săriturii",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Ieși din zona de declanșare",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Se declanșează atunci când o "Trigger Entity" iese dintr-o zonă de declanșare',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Elimină un anumit element dintr-o listă. [Lista] este lista în care se află elementul. [Element] este elementul care trebuie eliminat.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Valoarea elementului",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "Valoarea elementului care trebuie eliminat",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Entitate rotundă",
  T_35_WZY_WS_TOWER_PARAM1: "Turnul și Fortăreața",
  T_35_WZY_WS_TOWER_PARAM2: "ID-ul Echipei",
  T_35_WZY_WS_TOWER_PARAM3: "HP Curent",
  T_35_WZY_WS_TOWER_PARAM4: "Max. HP",
  T_35_WZY_WS_TOWER_PARAM5: "Damage",
  T_35_WZY_WS_TOWER_PARAM6: "Interval de atac",
  T_35_WZY_WS_TOWER_PARAM7: "Rază de atac",
  T_35_WZY_WS_TOWER_PARAM8: "Apărare %",
  T_35_XYL_PDM_REVENGE: "Răzbunat",
  T_35_XYL_WS_BISPARTERRE: "Graffiti Flowerbed",
  T_35_XYL_WS_BISPARTERRE_DESC: "Un pat de flori din piatră cu tematică Battle-In-Style",
  T_35_XYL_WS_BISWALL: "Graffiti Wall",
  T_35_XYL_WS_BISWALL_DESC: "Un perete cu tematică Battle-In-Style care poate fi combinat",
  T_35_XYL_WS_BOTDROP: "Activați/dezactivați aruncare pradă",
  T_35_XYL_WS_CUSTOMTRIGGER: "Declanșator personalizat",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Plasați un obiect care declanșează un anumit efect special personalizat atunci când un jucător îl activează. Efectul trebuie configurat în script. (Numai în modul Personalizat.)",
  T_35_XYL_WS_DOUBLEDOOR: "Poartă",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "O poartă care s-a deschis",
  T_35_XYL_WS_RESET: "Resetați la fiecare rundă",
  T_35_XYL_WS_RESETN: "Nu",
  T_35_XYL_WS_RESETY: "Da",
  T_35_XYL_WS_ROADBLOCK: "Blocaj rutier",
  T_35_XYL_WS_ROADBLOCK_DESC: "Împiedică trecerea",
  T_35_XYL_WS_STAIRS: "Scări",
  T_35_XYL_WS_STAIRS_DESC: "Scări care pot fi combinate cu paliere",
  T_35_XYL_WS_STAIRSL: "Landing B",
  T_35_XYL_WS_STAIRSL_DESC: "O platformă care poate fi combinată cu scări",
  T_35_XYL_WS_STAIRSZ: "Landing A",
  T_35_XYL_WS_STAIRSZ_DESC: "O platformă care poate fi combinată cu scări",
  T_35_XYL_WS_TBOOTH: "Phone Booth",
  T_35_XYL_WS_TBOOTH_DESC: "Văzut frecvent pe străzi",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Mască Cub",
  T_35_YS_F_A_PANTOMIME: "Two-toned Grief (Mască)",
  T_35_YS_F_A_RIDERS: "Fatal Rider (Mască)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Beauty Reuniter (Pantaloni)",
  T_35_YS_F_B_GOLDCHAIN: "Armor of Riches (Pantaloni)",
  T_35_YS_F_B_PANTOMIME: "Two-toned Grief (Pantaloni)",
  T_35_YS_F_B_RIDERS: "Fatal Rider (Pantaloni)",
  T_35_YS_F_H_BEAR_HW: "Șapcă Cub",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Beauty Reuniter (Cap)",
  T_35_YS_F_H_GOLDCHAIN: "Armor of Riches (Cap)",
  T_35_YS_F_H_PANTOMIME: "Two-toned Grief (Cap)",
  T_35_YS_F_H_RIDERS: "Fatal Rider (Cap)",
  T_35_YS_F_HA_GOLDCHAIN: "Armor of Riches (Vopsea de față)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Beauty Reuniter (Pantofi)",
  T_35_YS_F_S_GOLDCHAIN: "Armor of Riches (Pantofi)",
  T_35_YS_F_S_PANTOMIME: "Two-toned Grief (Pantofi)",
  T_35_YS_F_S_RIDERS: "Fatal Rider (Pantofi)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Beauty Reuniter (Haină)",
  T_35_YS_F_T_GOLDCHAIN: "Armor of Riches (Haină)",
  T_35_YS_F_T_PANTOMIME: "Two-toned Grief (Haină)",
  T_35_YS_F_T_RIDERS: "Fatal Rider (Haină)",
  T_35_YS_ITEM_SUPERFAK: "Super Med",
  T_35_YS_M_A_GOLDCHAIN: "Chainz of Lux (Mască)",
  T_35_YS_M_A_RIDERS: "Grim Rider (Mască)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz of Lux (Pantaloni)",
  T_35_YS_M_B_RIDERS: "Grim Rider (Pantaloni)",
  T_35_YS_M_H_BEAR_HW: "Șapcă Cub",
  T_35_YS_M_H_GOLDCHAIN: "Chainz of Lux (Cap)",
  T_35_YS_M_H_RIDERS: "Grim Rider (Cap)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz of Lux (Pantofi)",
  T_35_YS_M_S_RIDERS: "Grim Rider (Pantofi)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz of Lux (Haină)",
  T_35_YS_M_T_RIDERS: "Grim Rider (Haină)",
  T_35_YS_T_CHAMPION: "Champion Tee",
  T_35_YS_T_PAINTING: "Squeeze Tee",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Obțineți monede când începe meciul",
  T_36_JH_WS_CESAYCLOSE: "Dezactivați sau nu închiderea manuală",
  T_36_JH_WS_CHOOSEEDITSHOP: "Selectați un magazin de editat",
  T_36_JH_WS_CHOOSESHOP: "Selectează un magazin",
  T_36_JH_WS_COINCOUNT: "Cantitate monede",
  T_36_JH_WS_COINHUD: "Afișează cantitatea de monede sau nu",
  T_36_JH_WS_CRAFTSHOP: "Editează magazinul",
  T_36_JH_WS_CREATEGOLD: "Generator de monede",
  T_36_JH_WS_CSHOPENTITY: "Entitatea de legare a magazinului",
  T_36_JH_WS_CSHOPHUD: "Interfața magazinului",
  T_36_JH_WS_CURRENTLIMIT: "Limita rămasă de cumpărături",
  T_36_JH_WS_ECONOMIC: "Economie",
  T_36_JH_WS_INGAMEECONOMI: "Economia jocului",
  T_36_JH_WS_ITEMINDEXID: "Număr de marfă",
  T_36_JH_WS_KILLMONEY: "Obțineți monede pentru eliminare",
  T_36_JH_WS_KILLMONEYTIP: "Cantitatea de monede de câștigat pentru eliminarea zombilor în modul Rush și modul Endurance",
  T_36_JH_WS_LISTINDEX: "Lista tipurilor de marfă",
  T_36_JH_WS_NULL: "Nul",
  T_36_JH_WS_NUMBER: "Cantitate",
  T_36_JH_WS_OPTIONNAME: "Modul Droid Apocalypse Exclusiv",
  T_36_JH_WS_REALSHOPENTITY: "Entitate magazin",
  T_36_JH_WS_SEEORHIDE: "Automat de afișare",
  T_36_JH_WS_SHOPFRONT: "Stochează",
  T_36_JH_WS_SHOPITEMLIST: "Tip de marfă",
  T_36_JH_WS_SHOPOPENCON: "Status deschis",
  T_36_JH_WS_SSHOPNAME: "Nume magazin",
  T_36_JH_WS_TOTALLIMIT: "Limită de cumpărături",
  T_36_JH_WS_TRIGGERWIDE: "Interval de declanșare",
  T_36_JH_WS_VENDMACHINE: "Tonomat",
  T_36_JH_WS_WINMONEY: "Obțineți monede pentru victorie",
  T_36_JH_WS_WORTH: "Valoare",
  T_36_JL_FOREGRIP_MR_N: "Marksman Foregrip",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Shotgun Stock",
  T_36_JL_STOCK_SR_N: "Sniper Stock",
  T_36_KK_WS_MONTSTERDES: "Un camion cu 4 locuri cu durabilitate ridicată și poate călători pe terenuri dificile",
  T_36_M_WS_SETTEMPVAR: "Setați variabila temporară",
  T_36_M_WS_TEMPVAR: "Variabilă temporară",
  T_36_SY_AK47_MAMBAS_N: "AK47- Mamba Gnaw",
  T_36_SY_AN94_MAMBAS_N: "AN94- Mamba Gnaw",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher- Mamba Gnaw",
  T_36_SY_AUG_MAMBAS_N: "AUG- Mamba Gnaw",
  T_36_SY_AWM_MAMBAS_N: "AWM- Mamba Gnaw",
  T_36_SY_BLT_MAMBAS_N: "M82B- Mamba Gnaw",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster- Mamba Gnaw",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle- Mamba Gnaw",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS- Mamba Gnaw",
  T_36_SY_G18_MAMBAS_N: "G18- Mamba Gnaw",
  T_36_SY_G36_MAMBAS_N: "G36- Mamba Gnaw",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Grenadă- Navy Festivity",
  T_36_SY_GROZA_MAMBAS_N: "Groza- Mamba Gnaw",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon- Mamba Gnaw",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Treatment Sniper- Mamba Gnaw",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun- Mamba Gnaw",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k- Mamba Gnaw",
  T_36_SY_KORD_MAMBAS_N: "Kord- Mamba Gnaw",
  T_36_SY_M1014_MAMBAS_N: "M1014- Mamba Gnaw",
  T_36_SY_M14_MAMBAS_N: "M14- Mamba Gnaw",
  T_36_SY_M1873_MAMBAS_N: "M1873- Mamba Gnaw",
  T_36_SY_M1887_MAMBAS_N: "M1887- Mamba Gnaw",
  T_36_SY_M1917_MAMBAS_N: "M1917- Mamba Gnaw",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker- Mamba Gnaw",
  T_36_SY_M24_MAMBAS_N: "M24- Mamba Gnaw",
  T_36_SY_M249_MAMBAS_N: "M249- Mamba Gnaw",
  T_36_SY_M4A1_MAMBAS_N: "M4A1- Mamba Gnaw",
  T_36_SY_M500_MAMBAS_N: "M500- Mamba Gnaw",
  T_36_SY_M60_MAMBAS_N: "M60- Mamba Gnaw",
  T_36_SY_M79_MAMBAS_N: "M79- Mamba Gnaw",
  T_36_SY_MAC10_MAMBAS_N: "MAC10- Mamba Gnaw",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7- Mamba Gnaw",
  T_36_SY_MINI_MAMBAS_N: "AC80- Mamba Gnaw",
  T_36_SY_MP40_MAMBAS_N: "MP40- Mamba Gnaw",
  T_36_SY_MP5_MAMBAS_N: "MP5- Mamba Gnaw",
  T_36_SY_P90_MAMBAS_N: "P90- Mamba Gnaw",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL- Mamba Gnaw",
  T_36_SY_PP19_MAMBAS_N: "Bizon- Mamba Gnaw",
  T_36_SY_PP19_POLICEMAN_N: "Bizon- Wraith Patrol",
  T_36_SY_SCAR_MAMBAS_N: "SCAR- Mamba Gnaw",
  T_36_SY_SKS_MAMBAS_N: "SKS- Mamba Gnaw",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12- Mamba Gnaw",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA- Mamba Gnaw",
  T_36_SY_SVD_MAMBAS_N: "SVD- Mamba Gnaw",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson- Mamba Gnaw",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Mamba Dagger",
  T_36_SY_THROWINGKNIFE_MENA_N: "Boho Dagger",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Treatment Pistol- Mamba Gnaw",
  T_36_SY_UMP45_MAMBAS_N: "UMP- Mamba Gnaw",
  T_36_SY_USP45_MAMBAS_N: "USP- Mamba Gnaw",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi- Mamba Gnaw",
  T_36_SY_VECTOR_MAMBAS_N: "Vector- Mamba Gnaw",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Monster Truck- Blinding Gold",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Motocicletă- Spectral Ride",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Sports Car- Speed Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk- Netherworld Ride",
  T_36_SY_VSS_MAMBAS_N: "VSS- Mamba Gnaw",
  T_36_SY_XM8_MAMBAS_N: "XM8- Mamba Gnaw",
  T_36_WZY_AFTERACCUMULATOR: "Acumulator spate",
  T_36_WZY_AVAILAB: "Utilizabil",
  T_36_WZY_BACKANDFORTH: "Dus-întors",
  T_36_WZY_BASEMULTIPLIER: "Multiplicator de bază",
  T_36_WZY_BASIC: "Tip de bază",
  T_36_WZY_BEFORACCUMULATOR: "Acumulator frontal",
  T_36_WZY_CYLIC: "Încercuiește",
  T_36_WZY_GUNPRO_PARAM1: "Damage de bază",
  T_36_WZY_GUNPRO_PARAM10: "Începe răspândirea glonțului",
  T_36_WZY_GUNPRO_PARAM11: "Max. zonă răspândită",
  T_36_WZY_GUNPRO_PARAM12: "Sparge",
  T_36_WZY_GUNPRO_PARAM2: "Gloanțe în revistă",
  T_36_WZY_GUNPRO_PARAM3: "Numărul inițial al revistei",
  T_36_WZY_GUNPRO_PARAM4: "Interval de foc",
  T_36_WZY_GUNPRO_PARAM7: "Distanța pentru deteriorarea max.",
  T_36_WZY_GUNPRO_PARAM8: "Distanta pentru damage min.",
  T_36_WZY_GUNPRO_PARAM9: "Damage Minim",
  T_36_WZY_MULTIPLIR: "Multiplicator",
  T_36_WZY_PRICE: "Preț",
  T_36_WZY_SUMMULTIPLIER: "Acumulator multiplicator",
  T_36_WZY_WS_3DZOOM: "3D Zoom",
  T_36_WZY_WS_ABSRES: "Rezultat valoare absolută",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Adăugați toate elementele din [Lista sursă] în partea de jos a [Listei țintă]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "Lista țintă pentru a adăuga elemente",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "Lista surselor care conține elementele de adăugat",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Adăugați o anumită cantitate de monedă desemnată într-un portofel desemnat",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Portofel",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "Portofelul în care adăugați monedă",
  T_36_WZY_WS_ADDSUB: "Adăugați/scădeți valori",
  T_36_WZY_WS_AIENTITY: "Entitatea AI",
  T_36_WZY_WS_ALLSHOP_DESC: "O listă care constă în entități magazin",
  T_36_WZY_WS_ANGLE_DESC: "Măsurarea unghiului",
  T_36_WZY_WS_ANYTYPE: "Orice tip",
  T_36_WZY_WS_ARILEFT: "Valoare rămasă în operație",
  T_36_WZY_WS_ARIRES: "Rezultatul operațiunii",
  T_36_WZY_WS_ARIRIGHT: "Valoarea corectă în operațiune",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 operații aritmetice",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "Operațiile de bază cu numere întregi acceptă adunarea, scăderea, înmulțirea, împărțirea și restul. Operațiunile flotante acceptă adunarea, scăderea, înmulțirea și împărțirea.",
  T_36_WZY_WS_ARRAY_DESC: "Lista țintelor",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Verificați dacă o listă conține un element desemnat. Valoarea returnată este Booleană.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "Lista desemnată",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "Elementul de căutat în listă",
  T_36_WZY_WS_ARRCONELERES: "Rezultatul dacă un element desemnat există într-o listă. Valoarea este Booleană.",
  T_36_WZY_WS_ATTACK: "Patrolează și atacă",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Se declanșează atunci când jucătorul este doborât",
  T_36_WZY_WS_BIGFLOAT: "Zecimală mare",
  T_36_WZY_WS_BIGTOYBALL: "Zar",
  T_36_WZY_WS_BOOLLIST: "Lista Boolean",
  T_36_WZY_WS_CEIL_NAME_DESC: "Rotunjiți o valoare la cel mai mic număr întreg mai mare decât el însuși",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "Valoarea de rotunjit",
  T_36_WZY_WS_CEILRES: "Rezultatul rotunjirii în sus",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "AI selectat va urmări această entitate indiferent de distanță. [Entitate urmărită] poate fi orice entitate. Atunci când [entitatea urmărită] nu are o proprietate HP, atunci entitatea AI nu va provoca nicio daune.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "Entitatea care urmărește",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "Entitatea țintă care este urmărită. Poate fi orice entitate.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "Șablon pentru clonarea obiectelor. Selectați folosind cursorul. Proprietatea și scriptul clonei vor fi aceleași cu cele ale obiectului ales.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "Entitatea obiect de clonat",
  T_36_WZY_WS_CONDITION: "Condiție",
  T_36_WZY_WS_CONDITIONLIST: "Listă de condiții",
  T_36_WZY_WS_CONOFHUD: "Entitatea HUD în care există controlul",
  T_36_WZY_WS_CONTROL_DESC: "Singurul indice al unui control",
  T_36_WZY_WS_COS_NAMEDESC: "Aflați cosinusul unui unghi",
  T_36_WZY_WS_COSRES: "Cosinusul unghiului",
  T_36_WZY_WS_CREABLEOB: "Obiect creabil",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Creați o entitate obiect într-o locație desemnată. (Versiune de testare)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "Coordonatele obiectului de creat",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "Tipul obiectului de creat",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "Entitatea obiectului care urmează să fie creat",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Monedă",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Entitate marfă",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Creați o entitate de marfă",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Creați o entitate de portofel. [Bind player] este jucătorul care poate vedea acest portofel. [Proprietar] este jucătorul căruia îi aparține portofelul. Invalid dacă există deja un portofel.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Jucător legat",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "Jucătorul căruia îi este vizibil portofelul. Dacă nu sunt configurate setări, portofelul va fi vizibil pentru toți.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "Proprietarul portofelului",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Entitate portofel",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "Entitatea portofel creată",
  T_36_WZY_WS_CURRAMT: "Cantitatea de valută",
  T_36_WZY_WS_DATA_TYPE1: "Parametru adăugat",
  T_36_WZY_WS_DATA_TYPE2: "Calcul de bază și logic",
  T_36_WZY_WS_DATA_TYPE3: "Manipularea listelor",
  T_36_WZY_WS_DATA_TYPE4: "Calcul vectorial",
  T_36_WZY_WS_DESTITEM_NAME: "Distruge obiectul jucătorului",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Distruge un tip de obiect desemnat pentru un jucător desemnat",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Obiectele care pot fi distruse sunt armele, vestele și căștile",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "Indexul de slot al tipului de articol selectat. Indicele armelor este [1,3] iar Vesta și Casca este 1 în mod implicit.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Pierde echipamentul la eliminare",
  T_36_WZY_WS_DESTOBJ: "Obiecte ce pot fi distruse",
  T_36_WZY_WS_DIRPOINT: "Punct de direcție",
  T_36_WZY_WS_DIRPOINTDESC: "Punctul de direcție care urmează să fie creat",
  T_36_WZY_WS_ELEFINDRES: "Indexul primei poziții a unui element",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: "Obține indexul primei poziții a unui element dintr-o listă. Dacă elementul țintă nu există în listă, rezultatul va returna „-1”.",
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "Elementul de căutat în listă",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: "Obține indexul ultimei poziții a unui element dintr-o listă. Dacă elementul țintă nu există în listă, rezultatul va returna „-1”.",
  T_36_WZY_WS_ELELINDRES: "Indexul ultimei poziții a unui element",
  T_36_WZY_WS_ELEMENTSNUM: "# de elemente din listă",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Se declanșează atunci când [Triggering entity] se ciocnește de acest declanșator",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "Entitatea cu care se ciocnește acest declanșator",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Se declanșează atunci când o [entitate de declanșare] conduce vehiculul",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "Entitatea care conduce vehiculul",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Se declanșează când jucătorul introduce declanșatorul",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "Declanșatorul de intrare",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Se declanșează atunci când o [entitate de declanșare] iese din vehicul",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "Entitatea care iese din vehicul",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Se declanșează atunci când o [entitate de declanșare] intră în vehicul",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "Entitatea care intră în vehicul",
  T_36_WZY_WS_ENTITY_TYPE1: "Folosit des",
  T_36_WZY_WS_ENTITY_TYPE2: "Proprietăți",
  T_36_WZY_WS_ENTITY_TYPE3: "Obiecte și aarticole",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "Valoarea elementului care trebuie modificată",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Jucătorul țintă",
  T_36_WZY_WS_ENTITYLIST: "Listă de entități",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Se declanșează atunci când o [entitaâte de declanșare] sare de pe anvelopă",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "Entitatea care săre de pe anvelopă",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Se declanșează atunci când o [Entitate de Declanșare] intră în portal și este teleportată",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "Entitatea care este teleportată",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "Tipul de armură echipată, inclusiv vestă, cască și rucsac",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Se declanșează atunci când un jucător echipează cu succes o armă. [Trigger player] este jucătorul care echipează cu succes o armă. [Weapon entity] este entitatea armă pe care jucătorul a echipat-o.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "Entitatea cu armă echipată",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Tip de armă",
  T_36_WZY_WS_EULERANGLE: "Unghiurile Euler",
  T_36_WZY_WS_FACECAMERA: "Întotdeauna stai cu fața la cameră",
  T_36_WZY_WS_FLOATLIST: "Lista flotant",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Rotunjiți o valoare la cel mai mare întreg mai mic decât el însuși",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "Valoarea de rotunjit în jos",
  T_36_WZY_WS_FLOORRES: "Rezultatul rotunjirii în jos",
  T_36_WZY_WS_FORMUENT: "Entitate formulabilă de proprietate",
  T_36_WZY_WS_FORMUFACT: "Factorul de formulă tip de proprietate",
  T_36_WZY_WS_GAME_TYPE2: "Joc",
  T_36_WZY_WS_GAME_TYPE3: "Efecte speciale",
  T_36_WZY_WS_GENENT_NAMEDESC: "Se declanșează atunci când un generator generează unități. [Lista de entități de unități] este lista de unități generate de generator. [# de valuri] este numărul de valuri generate de generație.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Entitate de unitate",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "O listă care constă din entități unitate generate de un generator",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "Numărul de valuri pe care le generează un generator",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Obține toate magazinele din meci. Valoarea returnată este o listă care constă în entități magazin.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Utilizați RGB pentru a obține o culoare",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Obțineți suma unei anumite monede într-un anumit portofel",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "Portofelul din care se obține suma valutară",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "Tipul de monedă al sumei valutare de obținut",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Obține tipul de entitate al unei entități țintă",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "Entitatea al cărei tip trebuie obținut",
  T_36_WZY_WS_GETENTTYPERES: "Tipul de entitate al entității țintă",
  T_36_WZY_WS_GETFOR_NAME: "Obține tipul de entitate al unei entități țintă",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Obține vectorul unui punct de direcție desemnat",
  T_36_WZY_WS_GETFORRES: "Vectorul punctului de direcție",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Obțineți entitatea valutară dintr-un anumit tip de monedă în portofel",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "Portofelul în care se află entitatea monedă",
  T_36_WZY_WS_GETPOS_NAME: "Obține coordonatele",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Obțineți coordonatele unui punct de direcție desemnat",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "Punctul de direcție desemnat",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Tip de echipament",
  T_36_WZY_WS_GETWALLET_NAME: "Obține portofelul",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Obține portofelul proprietarului selectat",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Dacă există un portofel legat",
  T_36_WZY_WS_GETWALLETRES: "Entitatea portofel a proprietarului",
  T_36_WZY_WS_HUDCONTROL_DESC: "Entitatea de control a unui HUD",
  T_36_WZY_WS_HUDTYPE: "Tip de HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "Incident la nivelul meciului",
  T_36_WZY_WS_INCIDENT_TYPE2: "Incident de entitate",
  T_36_WZY_WS_INDEX_DESC: "O valoare de index a unei liste. Începe de la 0.",
  T_36_WZY_WS_INTLIST: "Lista Integer",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Verificați dacă un tip de entitate aparține unei anumite subcategorii. Rezultatul returnat este boolean.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "Categoria părinte pentru a verifica dacă entitatea îi aparține",
  T_36_WZY_WS_JENTSUBCLRES: "Rezultatul verificării categoriei părinte",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Verificați dacă o entitate aparține unui anumit tip de entitate. Rezultatul returnat este Boolean.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "Entitatea de verificat",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Înseamnă că este același cu tipul de entitate",
  T_36_WZY_WS_JENTTYPERES: "Rezultatul verificării entității",
  T_36_WZY_WS_JUSTPATROL: "Numai patrulare",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Se declanșează atunci când jucătorul iese din declanșare",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "Declanșatorul de ieșire",
  T_36_WZY_WS_LEVELOBLIST: "Tip de obiect",
  T_36_WZY_WS_LEVOBJSLIST: "O listă cu toate obiectele hărții din acest meci",
  T_36_WZY_WS_LEVOBTYPE: "Tip de obiect",
  T_36_WZY_WS_LISTT: "Șablon de listă",
  T_36_WZY_WS_LOGCONTEXT_DESC: "Conținutul care urmează să fie tipărit",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "Șirul din stânga care trebuie conectat",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "Șirul potrivit de conectat",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "Valoarea elementului care trebuie adăugată",
  T_36_WZY_WS_LOGOPER: "Când se efectuează operații logice (și & sau): dacă se utilizează operația și iar cele două valori booleene sunt ADEVARATE, rezultatul este adevărat, iar dacă se utilizează operația sau iar cele două valori booleene nu sunt ambele FALS, rezultatul este adevărat.",
  T_36_WZY_WS_LOOTPOINT: "Punct de pradă",
  T_36_WZY_WS_MAINWEAP: "Armă curentă",
  T_36_WZY_WS_MAX_DESC: "Interval superior al întregului generat (interval deschis)",
  T_36_WZY_WS_MIN_DESC: "Intervalul inferior al întregului generat (interval închis)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Entitate armă",
  T_36_WZY_WS_MONENT: "Entitate monedă",
  T_36_WZY_WS_MONTYPE: "Tip de monedă",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Faceți AI să se miște spre un punct țintă. Folosiți [Întoarcere sau nu] pentru a selecta dacă AI va reveni la poziția inițială. Folosiți [Atacare sau nu] pentru a selecta dacă AI-ul va scana după inamici pe drum.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "Entitatea AI care va călători",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "Destinația",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Utilizați pentru a seta dacă AI va reveni la locația inițială după sosirea la destinație. ADEVĂRAT înseamnă întoarcere; FALS înseamnă să nu te întorci.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Atac sau nu",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Folosiți pentru a stabili dacă AI va ataca inamicii din apropiere pe parcurs. TRUE înseamnă scanare pentru inamici; FALSE înseamnă că nu căutați inamici.",
  T_36_WZY_WS_MULVALUE: "Scalar",
  T_36_WZY_WS_MULVEC: "Vector de multiplicare scalară",
  T_36_WZY_WS_NEGRES: "Rezultat valoare negativă",
  T_36_WZY_WS_NEUTRAL: "Neutru",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Forțează generatorul desemnat să declanșeze următorul val. Generatoarele includ Zombie Spawns și item spawns.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Entitate generatoare",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "Entitatea generatoare desemnată, cum ar fi Zombie Spawns și item spawns",
  T_36_WZY_WS_OBJENT: "Entitate obiect",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Se declanșează atunci când se obține un articol. [Tipul articolului] este tipul de articol care se obține.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Se declanșează atunci când se obține o armă. [Entitatea armă] este arma obținută.",
  T_36_WZY_WS_ONEWAY: "Dus",
  T_36_WZY_WS_OPENSTATE: "Status",
  T_36_WZY_WS_OPERMETHOD_NAME: "Operațiune",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Operațiile aritmetice de bază. În prezent, operațiile cu numere întregi includ adunarea, scăderea, înmulțirea, împărțirea și restul, iar operațiunile cu virgulă includ adunarea, scăderea, înmulțirea și împărțirea.",
  T_36_WZY_WS_OWNERENT_DESC: "The entity whose wallet to obtain",
  T_36_WZY_WS_PERCENTAGE: "Ajustare procentuală",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Când jucătorul se ciocnește cu declanșatorul",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Se declanșează atunci când [Trigger player] se ciocnește cu declanșatorul",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "Jucătorul care se ciocnește cu declanșatorul",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "Entitatea obiect cu care se ciocnește jucătorul",
  T_36_WZY_WS_PLADRIVEH_NAME: "Când jucătorul conduce vehiculul",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Se declanșează atunci când [Jucătorul Trigger] conduce un vehicul",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "Jucătorul care conduce vehiculul",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "Entitatea vehicul pe care o conduce jucătorul",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Când jucătorul iese din vehicul",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Se declanșează atunci când [Trigger player] iese dintr-un vehicul",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "Jucătorul care iese din vehicul",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "Entitatea vehicul din care jucătorul iese",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Când jucătorul intră în vehicul",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Se declanșează atunci când [Trigger player] intră într-un vehicul",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "Entitatea vehicul în care intră jucătorul",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Când jucătorul sare pe anvelopă",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Se declanșează atunci când [Trigger player] sare de pe o anvelopă",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "Jucătorul care se leagănă de pe o anvelopă",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "Entitatea obiect pe care jucătorul sare",
  T_36_WZY_WS_PLATP_NAME: "După ce jucătorul este teleportat",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "Jucătorul care folosește un portal",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "Entitatea portal pe care jucătorul a folosit-o",
  T_36_WZY_WS_PLAYERLIST_DESC: "O listă cu toți jucătorii din acest meci",
  T_36_WZY_WS_POINTPICKER: "Pivot de cale",
  T_36_WZY_WS_PORTALENT: "Entitate portal",
  T_36_WZY_WS_PREFAB: "Template",
  T_36_WZY_WS_PRODLIST: "Lista de marfă",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Sortează ordinea",
  T_36_WZY_WS_PROPMOD: "Metoda de schimbare a proprietății",
  T_36_WZY_WS_RANKABLEE: "Entitate ce poate fi clasificată",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Consumați o anumită cantitate de monede desemnate într-un portofel desemnat",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "Portofelul care cheltuiește monedele",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "Tipul de monedă consumată",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "Cantitatea de monede folosite",
  T_36_WZY_WS_RNDFRES: "Flotare aleatoare generată",
  T_36_WZY_WS_RNDIRES: "Rezultatul generării aleatorii de numere întregi",
  T_36_WZY_WS_ROUND_NAME_DESC: "Rotunjiți o valoare la cel mai apropiat număr întreg",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "Valoarea de rotunjit",
  T_36_WZY_WS_ROUNDRES: "Rezultatul rotunjirii",
  T_36_WZY_WS_RUNAI_NAMEDESC: "Arborele de comportament pe care AI selectat îl va executa",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "Entitatea unitate care oprește/rulează un arbore de comportament implicit",
  T_36_WZY_WS_SCOREABLEE: "Entitate cu punctaj",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Se declanșează când scorul se modifică. [Tipul scorului] este tipul de scor care s-a modificat. [Scor] este noul scor.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Creați un punct de direcție",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Obțineți un punct de direcție nou creat. Folosiți [Locația] pentru a seta coordonatele punctului și [Directia] pentru a seta vectorul direcției.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "Coordonatele punctului de direcție",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Direcția",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "Vectorul punctului de direcție",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Entitățile AI vor călători în conformitate cu ordinea stabilită aici. Tipurile de călătorie disponibile sunt dus-întors, dus-întors și dus-întors. De asemenea, puteți selecta dacă AI va scana după inamici pe drum.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "O listă care constă din punctele către care ar trebui să călătorească AI",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "TIp de călătorie",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Acestea sunt tipurile de călătorie. Un singur sens este ca AI să nu mai călătorească odată ce ajunge la destinație. Circle-back este pentru ca AI să caute o cale de întoarcere odată ce ajunge la destinație. Dus-întors este pentru AI întoarcerea la locația inițială în ordinea inversă a listei de căi.",
  T_36_WZY_WS_SHOPECON: "Magazin și economie",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Utilizați pentru a afișa notificări care plutesc pe ecran. Configurați conținutul utilizând [Text], culoarea textului utilizând [Culoare] și durata de afișare folosind [Durata] (unitatea este de milisecunde).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "Conținutul notificării flotante",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "Culoarea notificării plutitoare",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "Durata de afișare a notificării plutitoare, în milisecunde",
  T_36_WZY_WS_SIN_NAMEDESC: "Aflați sinusul unui unghi",
  T_36_WZY_WS_SINRES: "Sinusul unghiului",
  T_36_WZY_WS_SKIPKNODOWN: "Indiferent dacă este eliminat la doborâre",
  T_36_WZY_WS_SQRTRES: "Rezultat rădăcină pătrată",
  T_36_WZY_WS_STRCONRES: "Rezultatul conexiunii șirului",
  T_36_WZY_WS_STRINGLIST: "Lista de șiruri",
  T_36_WZY_WS_STRLEN: "Lungimea șirului",
  T_36_WZY_WS_STRVAL: "Rezultat șir",
  T_36_WZY_WS_TAN_NAMEDESC: "Aflați tangenta unui unghi",
  T_36_WZY_WS_TANRES: "Tangenta unghiului",
  T_36_WZY_WS_TEAMLIST: "Lista de Echipe",
  T_36_WZY_WS_TEAMLIST_DESC: "O listă cu toate echipele din acest meci",
  T_36_WZY_WS_TIMETWEENTIPS: "Entitate de notificare numărătoare inversă",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Convertiți valoarea țintă într-un șir",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "Valoarea țintă de convertit într-un șir",
  T_36_WZY_WS_TOSTRINGRES: "Rezultatul conversiei șirurilor",
  T_36_WZY_WS_TOWERCAMP_DESC: "Numărul lateral și numărul echipei sunt aceleași. Turnurile și fortărețele neutre atacă toți jucătorii și IA din raza de acțiune.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Transferați o anumită cantitate de monede desemnate dintr-un portofel în altul",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "Portofelul din care să transferați moneda",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "Tipul de monedă din tranzacție",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "Cantitatea de monede din tranzacție",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "Portofelul în care să transferați moneda",
  T_36_WZY_WS_TWEENTIPS: "Entitate de notificare flotantă",
  T_36_WZY_WS_TYPEENUM: "Tip enumerare",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Se declanșează atunci când un jucător folosește un element. [Jucătorul Triggeri] este jucătorul care folosește un articol. [Tipul articolului] este elementul pe care l-a folosit jucătorul.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "Tipul de articol utilizat de jucător",
  T_36_WZY_WS_VECADDLEFT: "Valoarea din stânga a adunării vectoriale",
  T_36_WZY_WS_VECADDRES: "Rezultat adiție vectorială",
  T_36_WZY_WS_VECADDRIGHT: "Valoarea corectă a adunării vectoriale",
  T_36_WZY_WS_VECANGLEFT: "Valoarea stângă a unghiului vectorilor",
  T_36_WZY_WS_VECANGRES: "Unghiul dintre 2 vectori",
  T_36_WZY_WS_VECANGRIGHT: "Valoarea corectă a unghiului vectorilor",
  T_36_WZY_WS_VECCROLEFT: "Valoarea din stânga a produsului încrucișat",
  T_36_WZY_WS_VECCRORES: "Rezultatul produsului încrucișat",
  T_36_WZY_WS_VECCRORIGHT: "Valoarea corectă a produsului încrucișat",
  T_36_WZY_WS_VECDISLEFT: "Valoarea stângă a distanței vectorilor",
  T_36_WZY_WS_VECDISRES: "Distanța dintre 2 vectori",
  T_36_WZY_WS_VECDISRIGHT: "Valoarea corectă a distanței vectorilor",
  T_36_WZY_WS_VECDOCLEFT: "Valoarea din stânga a produsului punctual",
  T_36_WZY_WS_VECDOCRES: "Rezultatul produsului punctual",
  T_36_WZY_WS_VECDOCRIGHT: "Valoarea corectă a produsului punctual",
  T_36_WZY_WS_VECMULRES: "Rezultatul înmulțirii scalare",
  T_36_WZY_WS_VECNORRES: "Vector normalizat",
  T_36_WZY_WS_VECSIZERES: "Mărimea unui vector",
  T_36_WZY_WS_VECSUBLEFT: "Valoarea stângă a scăderii vectoriale",
  T_36_WZY_WS_VECSUBRES: "Rezultatul scăderii vectorului",
  T_36_WZY_WS_VECSUBRIGHT: "Valoarea corectă a scăderii vectoriale",
  T_36_WZY_WS_VECTORLIST: "Listă de vectori",
  T_36_WZY_WS_VECX: "x component",
  T_36_WZY_WS_VECY: "componentul y",
  T_36_WZY_WS_VECZ: "Componentul z",
  T_36_WZY_WS_VEHENT: "Entitate vehicol",
  T_36_WZY_WS_WALLCONT: "Conținutul portofelului",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Continuu",
  T_36_XYL_WS_AIBOT: "Unitate",
  T_36_XYL_WS_AIGENERATOR: "Unit Generator",
  T_36_XYL_WS_AIGENERATOR_DESC: "Un generator care poate genera continuu unități desemnate (de exemplu, zombi)",
  T_36_XYL_WS_AIWAVE: "# unități generate pe val",
  T_36_XYL_WS_ARROW: "Semn pentru direcție",
  T_36_XYL_WS_ARROW_DESC: "Un semn care indică o direcție",
  T_36_XYL_WS_BREAKBOX: "Cutia Breakable",
  T_36_XYL_WS_BREAKBOX_DESC: "O cutie de lemn care poate fi spartă atunci când este atacată",
  T_36_XYL_WS_FENCE: "Gard de Fier",
  T_36_XYL_WS_FENCE_DESC: "Un gard care permite gloanțelor să zboare",
  T_36_XYL_WS_STAIRI: "Landing C",
  T_36_XYL_WS_STAIRI_DESC: "O platformă care poate fi combinată cu scări",
  T_36_XYL_WS_ZOMBIEAI: "Zombie",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Un zombi care poate fi personalizat și poate fi un subiect obținut și duplicat în Unit Generator",
  T_36_YF_CORRODE_GRENADE_N: "Gloo Melter",
  T_36_YF_SETTING_TYPE3: "Prestabilit 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Pantaloni)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Pantaloni)",
  T_36_YS_F_A_GHOSTHUNTER: "Fiendish Foxtail (Mască)",
  T_36_YS_F_B_GHOSTHUNTER: "Fiendish Foxtail (Pantaloni)",
  T_36_YS_F_H_GHOSTHUNTER: "Fiendish Foxtail (Cap)",
  T_36_YS_F_S_GHOSTHUNTER: "Fiendish Foxtail (Pantofi)",
  T_36_YS_SETTING_GRENADE: "Lucruri de aruncat",
  T_36_YS_SETTING_MOVE: "Mișcare",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Haină)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Haină)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Colț",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Pet skin: Purple Zasil",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Pet skin: Lightning Falco",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Pet skin: Lava Fang",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Pet skin: Spectral Guide",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Pet skin: Arctic Fang",
  T_37_B_WS_HIDE: "Hide N Seek",
  T_37_HZ_WS_CATMODEDESC1: "Hide N Seek",
  T_37_JH_WS_CREATEGOLD_DESC: "A Vending Machine from which players can buy items. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_NAME1: "FF Knife (Droid Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droid Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droid Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droid Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droid Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droid Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droid Apocalypse)",
  T_37_JH_WS_NAME19: "SVD (Droid Apocalypse)â",
  T_37_JH_WS_NAME2: "GROZA (Droid Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droid Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droid Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droid Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droid Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droid Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droid Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droid Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "Gold that can be picked up around the map. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_X: "X Axis",
  T_37_JH_WS_Y: "Y Axis",
  T_37_JH_WS_Z: "Z Axis",
  T_37_JL_FOOTBALL_TIE: "Tie",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Waggor Snowman",
  T_37_LC_BP_ENTRANCE_GIFT: "Gift!",
  T_37_M_WS_MISSING: "Missing source",
  T_37_M_WS_NAMEERROR: "Contains sensitive characters. Please change.",
  T_37_PD_HuntingGround_BOSSTITLE: "The Butcher",
  T_37_QL_JUMPPAD_DES: "Creates a jump pad on the ground. It can be used to jump high in the air and enables air firing.",
  T_37_QL_JUMPPAD_NAME: "Trampoline",
  T_37_R_TAILOR_LIMIT: "Limited Time",
  T_37_RW_LOADOUT_BORNFIRETAG: "Get 2 Bonfires at the start of the match. Bonfire [FFBA00]regenerates 5 HP and 20 EP per second[-] (up to 10 seconds) for you and your teammates within the area. Bonfire effects do not stack.",
  T_37_RW_PROPCATAPULT_DESC: "Când este umflată, rampa de lansare poate fi folosită pentru a proiecta un jucător în aer. Dar asigurați-vă că rămâneți în Zona de siguranță!",
  T_37_RW_PROPCATAPULT_NAME: "Platforma de lansare",
  T_37_SP_WS_COLOR_02: "Culoare",
  T_37_SP_WS_COLOR_03: "Aparență",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "Entitatea este nulă la obținerea sau stabilirea proprietății sale",
  T_37_SP_WS_LOG_PHASE_END: "Etapa {0} s-a încheiat.",
  T_37_SP_WS_LOG_PHASE_START: "Etapa {0} a început",
  T_37_SP_WS_LOG_ROUND_END: "Runda {0} s-a încheiat.",
  T_37_SP_WS_LOG_ROUND_START: "Runda {0} a început",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Tip nepotrivit la atribuirea unei valori variabilei. Tip curent: {0}. Tip necesar: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Variabilă locală nedefinită sau în afara domeniului de aplicare {0}",
  T_37_SP_WS_MAPACCESS_08: "Editează",
  T_37_SP_WS_RACEMODE_01: "Countdown Mode",
  T_37_SP_WS_RACEMODE_02: "Timp de numărătoare inversă",
  T_37_SP_WS_RACEMODE_04: "Când este activată, va exista o numărătoare inversă când o întreagă echipă ajunge la punctul de sosire. Jocul se termină când se termină numărătoarea inversă.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher- Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "Ghiozdan Straw Hat",
  T_37_SY_GRENADE_FFWS2022_01_N: "Grenadă- Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Gaură Neagră",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Pet Skin: Glamstar Beanie",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Pet skin: Ash Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Pet skin: Galaxy Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Pet skin: Firemyth Arvon",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Pet Skin: Footie Flash",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Pet Skin: Winterlands Yeti",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep - Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Pickup Truck- Starsea Beast",
  T_37_WT_WS_PVE2DESC: "Eliminați numărul țintă de zombi în limita de timp/supraviețuire până la sfârșit",
  T_37_WT_WS_RULEDESC: "Eliminate the target number of zombies to win.",
  T_37_WT_WS_RULETITLE: "Goal",
  T_37_WT_WS_TXT1: "Eliminate zombies",
  T_37_WT_WS_TXT1DESC: "When on, players win by eliminating the specified number of zombies. When off, players win by surviving till the end.",
  T_37_WT_WS_TXT2: "Elimination amount",
  T_37_WZY_FRIDPLA: "Facțiune inamică",
  T_37_WZY_FRIDSIDE: "Facțiune aliată",
  T_37_WZY_FRIDTEAM: "Echipă aliată",
  T_37_WZY_HOSTPLA: "Jucător inamic",
  T_37_WZY_HOSTSIDE: "Echipă inamică",
  T_37_WZY_WS_ACCFRAMES: "Accumulated frames",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Adăugați articole la o marfă. Puteți adăuga un singur articol sau un grup de articole. Suma poate fi fie numărul articolelor individuale, fie o listă care constă din articole din această sumă.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "Entitatea de marfă la care să adăugați articole",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Elementele de adăugat. Puteți adăuga un singur articol sau un grup de articole.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "Cantitatea articolelor individuale de adăugat sau o listă care constă din articole din această sumă.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Add a tag for the selected entity",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "The entity to add the tag to",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "The text content to add",
  T_37_WZY_WS_AIMABLEENT: "Aim-able entity",
  T_37_WZY_WS_AIMASSISTTYPE: "Tip de asistență la țintire",
  T_37_WZY_WS_ALLOWDROP_NAME: "Activați/dezactivați eliminarea articolelor",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Dacă un jucător poate arunca obiecte",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "Entitatea jucător pentru a configura dacă să renunțe la elemente",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Dacă un jucător poate arunca obiecte. Aceasta este valoarea booleană.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Activați/dezactivați ridicarea articolelor",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Dacă un jucător poate ridica obiecte",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "Entitatea jucător pentru a configura dacă să ridice articole",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Dacă un jucător poate ridica obiecte. Aceasta este valoarea booleană.",
  T_37_WZY_WS_AMBIENTCOLOR: "Culoare deschisă pentru ambianță",
  T_37_WZY_WS_AMRORTOOL: "Repararea armurii",
  T_37_WZY_WS_ATTACK: "Atacă",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Cancel the player's disguise so that they will return to their normal appearance",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "The player entity whose disguise to cancel",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Boost the speed of a football",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "The football to boost speed for",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "The speed vector of the boost",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Triggers when the football is hit by the Football Shooter. [Player entity] is the player who owns the Football Shooter. [Speed boost] is the added speed of the football after being hit.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "The player who owns the Football Shooter",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "The speed vector of the football after it has been hit",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Triggers when the football collides with an entity and the ball's speed increases. [Colliding entity] is the entity that collides with the football. [Speed boost] is the added speed of the football after the collision.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "The entity that collides with the football",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "The speed vector that is added to the football upon collision",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Se declanșează atunci când entitatea este vizată de un jucător",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "Jucătorul care vizează entitatea",
  T_37_WZY_WS_BEHAVIORSTAT: "Starea comportamentului jucătorului",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "The weapon entity that hits this entity",
  T_37_WZY_WS_BLOODBARENT: "Health bar entity",
  T_37_WZY_WS_BOMBEND: "Înainte de explozie",
  T_37_WZY_WS_BOMBSTART: "Indicație bombă",
  T_37_WZY_WS_CHANENT: "Channel entity",
  T_37_WZY_WS_CHEER: "Încurajează",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Check whether a selected entity contains designated tags",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "The entity to check whether it contains tags",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "The tag to check",
  T_37_WZY_WS_CHELABELRES: "The result of the tag check. This is a Boolean value.",
  T_37_WZY_WS_CJERSEY_NAME: "Change jersey",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "The player whose jersey to change",
  T_37_WZY_WS_CJERSEY_PARAM2: "Jersey design",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "The design to change to",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "The color of part 1 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "The color of part 2 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "The color of part 3 on the jersey",
  T_37_WZY_WS_CJERSEYTYPE1: "Design 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Design 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Design 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Clear all the elements in the list",
  T_37_WZY_WS_CREABLEOB_DESC: "The object type that can be created using blocks",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Creați o marfă personalizabilă și returnați o entitate de marfă. Conținutul mărfurilor poate fi configurat prin setările proprietății.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Creați o listă de mărfuri personalizabilă și returnați o entitate de listă de mărfuri. Conținutul acestei liste poate fi modificat prin setările proprietății.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "Entitatea din lista de marfă care urmează să fie creată",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Create a faction entity",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "The faction entity to be created",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Create a customizable store and return a store entity. The content of the store can be changed through property settings.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "The store entity created",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Change the environment of the sky in the game. Options include day, dusk, and night.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "The type of sky to change to. Options include day, dusk, and night.",
  T_37_WZY_WS_DARKNESS: "Întunericul general",
  T_37_WZY_WS_DELENT_NAMEDESC: "Ștergeți o entitate desemnată. În prezent, acceptă entitate pictogramă, entitate text, entitate HUD, entitate cu efecte vizuale, entitate armă și alte entități obiect.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "Entitatea de șters",
  T_37_WZY_WS_DROP: "Greșeală",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Triggers when the player drops an item. [Item type] is the ID of the item type dropped.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "The type ID of the dropped item",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Triggers when the player drops a weapon. [Weapon entity] is the weapon being dropped.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "The weapon that is dropped",
  T_37_WZY_WS_DUMMYLEOBJ: "Regular level object",
  T_37_WZY_WS_DUST: "Dusk",
  T_37_WZY_WS_EMPTYCH: "Default empty channel",
  T_37_WZY_WS_EMPTYCH1: "Canal gol 1",
  T_37_WZY_WS_EMPTYCH2: "Canal gol 2",
  T_37_WZY_WS_EMPTYCH3: "Canal gol 3",
  T_37_WZY_WS_EMPTYCH4: "Canal gol 4",
  T_37_WZY_WS_EMPTYCH5: "Canal gol 5",
  T_37_WZY_WS_EMPTYCH6: "Canal gol 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Obtain a list that contains all entities that satisfy the 3 conditions. The content inserted for "Includes all", "Excludes", and "Includes" is a single component type or a list of component types. The result returned is a list of entities that satisfy the conditions.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "The entities filtered out must contain all the components from this array",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "The entities filtered out must not contain designated component(s) from this array",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "The entities filtered out must contain at least one component from this array",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "The property type of this entity to change",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "The property value to change to",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Let the player leave the current channel so that they will not be in any channel",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "The player to leave the channel",
  T_37_WZY_WS_FAKEENT: "Disguise entity",
  T_37_WZY_WS_FIND_STR_DESC: "Găsiți locația unui text desemnat într-un șir",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "Personajul de găsit",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Find a string from the starting location, which begins from 0.",
  T_37_WZY_WS_FINDSTRRES: "The first location that the string appears. Starts from 0.",
  T_37_WZY_WS_FOGCOLOR: "Culoare ceata",
  T_37_WZY_WS_FRICTIONCON: "Multiplicator obișnuit de frecare",
  T_37_WZY_WS_FRICTIONIMP: "Multiplicator de frecare a coliziunii",
  T_37_WZY_WS_FROMDEATH: "Revival",
  T_37_WZY_WS_FROMKNODOWN: "Help up",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Get the channel that the designated player is in",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "The player entity whose channel to get",
  T_37_WZY_WS_GETCHANRES: "The channel that the player is currently in",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "According channel ID 1 to 8, get the empty channel that was created by default at the start of the game",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID of the default empty channel",
  T_37_WZY_WS_GETEMPTYCH_RES: "The obtained channel entity",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Obtain the disguise entity of a player",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "The object whose disguise entity to obtain",
  T_37_WZY_WS_GETGAMEENT_NAME: "Get global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Get the game entity of this match",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Get attackable player",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Faction entity",
  T_37_WZY_WS_GOAL_NAMEDESC: "Triggers when a football enters the goal. [Goal] is the goal that this football enters. [Scorer] is the last player to have come in contact with the ball. [Assist] is the second-to-last player to have come in contact with the ball.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "The goal that this football enters",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "The last player to have come in contact with the ball",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "The second-to-last player to have come in contact with the ball",
  T_37_WZY_WS_HEARTBEAT: "Puls",
  T_37_WZY_WS_HEAVYWEAPON: "Armă grea",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Cel mai mic unghi de volley",
  T_37_WZY_WS_HOSTPLA: "A list of attackable players",
  T_37_WZY_WS_HOSTSIDE: "A list of attackable factions",
  T_37_WZY_WS_HOSTTEAM: "A list of attackable teams",
  T_37_WZY_WS_ICON_CLOCK: "Numărătoare inversă",
  T_37_WZY_WS_ICON_CLOTHES: "Haine",
  T_37_WZY_WS_ICON_QUIT: "Ieșire",
  T_37_WZY_WS_INSERT_ARR_DESC: "Insert a new element to a designated location in the list",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Extract a string of a designated length, starting from the index location. If extraction length exceeds string length, it will extract content until the end of the string.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Lungimea extracției",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "Șirul care a fost extras",
  T_37_WZY_WS_INTORINTL: "Integer or integer list",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Let a player join a designated faction",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "The faction for the player to join",
  T_37_WZY_WS_JUMP: "Sari",
  T_37_WZY_WS_LABEL: "Tag",
  T_37_WZY_WS_LENSFLARE: "Reflectarea lentilei",
  T_37_WZY_WS_LENTH: "Length",
  T_37_WZY_WS_LIGHTATTACK: "Lovitură reușită",
  T_37_WZY_WS_LIGHTCOLOR: "Culoarea sursei de lumină",
  T_37_WZY_WS_LIGHTINTENSITY: "Luminozitatea sursei de lumină",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Încărcați un nou peisaj",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "Numele peisajului de încărcat",
  T_37_WZY_WS_MOROBJECT: "Obiect deghizat",
  T_37_WZY_WS_MOVEAXISX: "Deplasați-vă de-a lungul axei x",
  T_37_WZY_WS_MOVEAXISY: "Deplasați-vă de-a lungul axei y",
  T_37_WZY_WS_MOVEAXISZ: "Deplasați-vă de-a lungul axei z",
  T_37_WZY_WS_MOVEDISTITLE: "Distance of movement",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Mesaje rapide activate/dezactivate",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Activați sau dezactivați mesajele rapide. Când este dezactivat, mesajul rapid HUD nu poate fi folosit și jucătorii nu vor putea trimite sau primi mesaje rapide.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "Jucătorul care să activeze/dezactiveze mesajele rapide pentru",
  T_37_WZY_WS_MUTEVOICE_NAME: "Activare/dezactivare chat vocal",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Activați sau dezactivați chatul vocal. Când este oprit, HUD-ul vocal nu poate fi utilizat și jucătorii nu vor putea trimite sau primi mesaje vocale.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "Playerul care să activeze/dezactiveze chatul vocal",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boolean. Adevărat înseamnă dezactivat; Fals înseamnă activat.",
  T_37_WZY_WS_NIGHTMODE: "Mod noapte",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Triggers when the player is aiming at an aim-able entity. [Target entity] is the entity being aimed. When there is no entity being aimed, the return value is null.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Aimed entity",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "The entity that the weapon has hit",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Se declanșează când peisajul se încarcă cu succes",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "Numele peisajului de încărcat. Acesta este un șir.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Se declanșează atunci când peisajul se schimbă cu succes",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "Numele noului peisaj. Acesta este un șir.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Restore the player's clothing to its default look",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "The player whose default clothing to restore",
  T_37_WZY_WS_PETSET: "Pet settings",
  T_37_WZY_WS_PETSKILL: "Pet skills",
  T_37_WZY_WS_PETSWITCH2: "Dacă abilitățile animalelor de companie pot fi folosite",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Whether to enable player movement. This is a Boolean value.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Tipul de comportament al jucătorului",
  T_37_WZY_WS_PRESS: "Dă click ușor",
  T_37_WZY_WS_PROGRESS: "Progresul Curent",
  T_37_WZY_WS_PROGRESSBAR: "Progres entitate HUD",
  T_37_WZY_WS_RANKDOWN: "Scădere in rang",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Remove a tag for the selected entity",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "The text content to remove",
  T_37_WZY_WS_REPLACE_STR_DESC: "Replace the content of a string with a designated content",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "Personajul care trebuie înlocuit",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "Noul personaj cu care trebuie înlocuit",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Reverse all the elements in this list",
  T_37_WZY_WS_REVIVEHERE: "The player who is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Triggers when a player is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEWAYDESC: "The method by which a player is revived or helped up from being eliminated or knocked down",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Configure the status of different behaviors for players. When disabled, the corresponding buttons on the HUD cannot be used, and manual and automatic movements are not allowed. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "The player to set behavior status for",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "The player's behavior, including moving, attacking, jumping, and sprinting",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Status includes disabled, hidden, and enabled. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "The coordinates of the football",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Whether the football should maintain its pre-configuration speed. This is a Boolean value.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Player attack setting",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Configure whether [Setting player] can attack [Target player]. The default setting is based on whether the target player belongs to a team and faction that can be attacked. This setting is of a higher priority than the team/faction setting.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "The player to configure enemies for",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "The player who is the enemy",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Attackable or not",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable. The default setting is based on whether the target player belongs to a team and faction that can be attacked.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable',
  T_37_WZY_WS_SHADOWSTRENGTH: "Umbre",
  T_37_WZY_WS_SHOOTANGLE: "Cel mai mic unghi de tragere",
  T_37_WZY_WS_SKYBOX: "Cer",
  T_37_WZY_WS_SKYBOXENT: "Sky entity",
  T_37_WZY_WS_SKYBOXTYPE: "Tipuri de cer de bază",
  T_37_WZY_WS_STEPPED: "Pășește pe trăgaci",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Switch the voice chat channel of the player",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "The player to switch channels for",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "The channel to switch to",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Schimbă la un peisaj desemnat",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "Numele peisajului la care să comutați",
  T_37_WZY_WS_TARGETSTR_DESC: "Target string",
  T_37_WZY_WS_TEAMASIDE: "Echipă și facțiune",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automatic",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Teleportabil sau nu",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manual",
  T_37_WZY_WS_TELEPORTN_NO: "Nu",
  T_37_WZY_WS_TELEPORTN_TITLE: "Metodă de teleportare",
  T_37_WZY_WS_TELEPORTN_YES: "Da",
  T_37_WZY_WS_TERRAINWET: "Umiditatea terenului",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Substitute the appearance of a [Player entity] with the appearance of a [Scenery object]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "The player entity whose appearance to change",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "The player whose disguise entity to obtain",
  T_37_WZY_WS_TRANSP: "Transparency",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Dezinstalați un decor desemnat",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "Numele peisajului de dezinstalat",
  T_37_WZY_WS_VFX1: "Simbolic",
  T_37_WZY_WS_VFX2: "Afumat",
  T_37_WZY_WS_VFX3: "Explozie blestemată",
  T_37_WZY_WS_VFX5: "Îngheţat",
  T_37_WZY_WS_VFX6: "În lumina reflectoarelor",
  T_37_WZY_WS_VFX7: "Turbulență ascendentă",
  T_37_WZY_WS_VFX8: "Explozie a atmosferei",
  T_37_WZY_WS_VISABLE: "Visibility",
  T_37_WZY_WS_WEAOPEN: "Show or not",
  T_37_WZY_WS_WEAPONENT: "Weapon entity",
  T_37_WZY_WS_WEATARGETED: "Whether can be targetted by aim assist",
  T_37_XYL_CUSTOMJERSEY: "Jersey Machine",
  T_37_XYL_CUSTOMJERSEY_DESC: "Use the Jersey Machine to create your ideal jersey",
  T_37_XYL_FOOTGUN: "Football Shooter",
  T_37_XYL_SOCCER: "Football",
  "T_37_XYL_SOCCER_ RADIUS": "Radius",
  T_37_XYL_SOCCER_DESC: "A football whose properties can be customized",
  T_37_XYL_SOCCER_HIGHT1: "Regular angle",
  T_37_XYL_SOCCER_HIGHT2: "Volley angle",
  T_37_XYL_SOCCER_RESET: "Reset time after a goal (s)",
  T_37_XYL_SOCCER_RESIST1: "Friction (Kick Mode)",
  T_37_XYL_SOCCER_RESIST2: "Friction (Gun Mode)",
  T_37_XYL_SOCCERGOAL: "Goal",
  T_37_XYL_SOCCERGOAL_DESC: "This is the goal. Shoot the football into the goal to score. (Only valid in Points Grab.)",
  T_37_XYL_SOCCERITEM: "Item Spawn",
  T_37_XYL_SOCCERITEM_DESC: "When placed, it will generate the selected item",
  T_37_XYL_SPAWN_PEOPLE: "# of players",
  T_37_XYL_WS_AIRCONDITIONER001: "Air Conditioner B",
  T_37_XYL_WS_AMMUCHEST: "War Chest A",
  T_37_XYL_WS_BAFFLE001: "Barrier A",
  T_37_XYL_WS_BARREL001: "Barrels",
  T_37_XYL_WS_BARREL001_DES: "Commonly seen circular wooden barrels",
  T_37_XYL_WS_BOARD001: "Ad Board B",
  T_37_XYL_WS_BOOK001: "Pile of Books A",
  T_37_XYL_WS_BOOK002: "Board Game A",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillea",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Decor - brightens up the place!",
  T_37_XYL_WS_BOX001: "Pile of Boxes A",
  T_37_XYL_WS_BOX002: "Cutie Mică",
  T_37_XYL_WS_BUSHCOVER: "Bush",
  T_37_XYL_WS_BUSHCOVER_DES: "A bush that can be used to hide in",
  T_37_XYL_WS_CABINET001: "Drawers A",
  T_37_XYL_WS_CHAIR001: "Chair A",
  T_37_XYL_WS_COCONUTTREE: "Coconut Tree",
  T_37_XYL_WS_COCONUTTREE_DES: "Decor - For a beachy vibe!",
  T_37_XYL_WS_COMPUTER001: "Computer A",
  T_37_XYL_WS_DAMAGERATIO: "Damage Ratio",
  T_37_XYL_WS_FIREEX: "Fire Extinguisher",
  T_37_XYL_WS_GUIDEPOSE: "Direction Post",
  T_37_XYL_WS_HUGEHOUSE001: "3-Story House B",
  T_37_XYL_WS_HUGEHOUSE002: "2-Story House B",
  T_37_XYL_WS_JACKSTRAW: "Scarecrow",
  T_37_XYL_WS_LADDER001: "Ladder A",
  T_37_XYL_WS_OILDRUM: "Jerry Can",
  T_37_XYL_WS_ORNAMENT001: "Vase A",
  T_37_XYL_WS_PACKBOX: "Supply Container",
  T_37_XYL_WS_PILLA001: "Concrete Pillar",
  T_37_XYL_WS_PRESENT: "Cutie Cadou",
  T_37_XYL_WS_PRESENT_DES: "Contains holiday gifts",
  T_37_XYL_WS_PUMPKIN: "Square Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT: "Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT_DES: "A commonly decoration for a spooky festival",
  T_37_XYL_WS_ROADBLOCK001: "Roadblock B",
  T_37_XYL_WS_SHELF001: "Bookshelf A",
  T_37_XYL_WS_SOFA001: "Sofa A",
  T_37_XYL_WS_SPAWNTEAM: "Toate echipele",
  T_37_XYL_WS_SUPPLYBOX: "Ammo Crate",
  T_37_XYL_WS_TABLE001: "Table A",
  T_37_XYL_WS_TABLE002: "Table B",
  T_37_XYL_WS_TARGET001: "Target",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Portal Finish Point",
  T_37_XYL_WS_TELEPORTNEW: "Portal A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "A portal that can teleport the player to the finishing point of the portal",
  T_37_XYL_WS_TIRES001: "Tire A",
  T_37_XYL_WS_TOOLRACK: "Tool Shelf",
  T_37_XYL_WS_WALL001: "Wall",
  T_37_XYL_WS_WOOD001: "Chopped Wood",
  T_37_XYL_WS_YELLOWDUCK001: "Ducky Float",
  T_37_XYL_WS_YELLOWDUCK001_DES: "An inflated swim ring in the shape of a duck",
  T_37_YM_BOMBSQUAD_DEFUSER: "Defuser",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF White Jersey (Pantaloni)",
  T_37_YS_F_B_VN_STREET: "Crimson Auspicion (Pantaloni)",
  T_37_YS_F_H_VN_STREET: "Crimson Auspicion (Cap)",
  T_37_YS_F_S_VN_STREET: "Crimson Auspicion (Pantofi)",
  T_37_YS_F_T_VN_STREET: "Crimson Auspicion (Haină)",
  T_37_YS_M_A_CRICKET_BLACK: "Bumblebee Cricketer (Mască)",
  T_37_YS_M_A_THKOL: "Blaze Banish (Mască)",
  T_37_YS_M_B_CRICKET_BLACK: "Bumblebee Cricketer (Pantaloni)",
  T_37_YS_M_B_SILVERERA: "Fearless Greyguard (Pantaloni)",
  T_37_YS_M_B_THKOL: "Blaze Banish (Pantaloni)",
  T_37_YS_M_H_SILVERERA: "Fearless Greyguard (Cap)",
  T_37_YS_M_H_THKOL: "Blaze Banish (Cap)",
  T_37_YS_M_S_CRICKET_BLACK: "Bumblebee Cricketer (Pantofi)",
  T_37_YS_M_S_SILVERERA: "Fearless Greyguard (Pantofi)",
  T_37_YS_M_S_THKOL: "Blaze Banish (Pantofi)",
  T_37_YS_M_T_CRICKET_BLACK: "Bumblebee Cricketer (Haină)",
  T_37_YS_M_T_SILVERERA: "Fearless Greyguard (Haină)",
  T_37_YS_M_T_THKOL: "Blaze Banish (Haină)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF White Jersey (Haină)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Minimum players",
  T_38_BQ_SKILL_NAME_DUMMY1: "Stunt Double",
  T_38_BQ_SKILL_NAME_DUMMY2: "Shape Splitter",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Heartseeker (Bottom)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Heartseeker (Head)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Heartseeker (Shoes)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Heartseeker (Top)",
  T_38_JH_WS_CM1: "Clear Rules",
  T_38_JH_WS_CM2: "Unclear Rules",
  T_38_JH_WS_CM3: "Frequent Quit Outs",
  T_38_JL_M79_AMMO_N: "M79 Ammo",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs' Microchip",
  T_38_M_WS_VECTOR2: "2D Vector",
  T_38_R_TACTICS_N: "Preset",
  T_38_RW_NIW_NIWNAME: "Gloo Maker",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Too many layers of blocks. Current: {0}. Max.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Number of items you've created ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Number of incidents received in the same frame ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Per-frame dynamic entity creation limit reached ({0}); {1} creation attempt(s) refused.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Length of the initialized list ({0}) has exceeded the limit ({1}). Auto-creates a max capacity list.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Number of loops ({0}) has exceeded the limit ({1}). Loop interrupted",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "The number of concurrent coroutines  ({0}) in the coroutine scope has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Failed to add element to the list. List {0} is empty",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Mismatched value types when executing the basic arithmetic operation. The left value type is {0} and the right value type is {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Repeated temporary variable definition. Variable name: {0}.",
  T_38_SP_WS_REVIEW_01: "Toxic",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Insulting",
  T_38_SP_WS_REVIEW_04: "Extremely Toxic",
  T_38_SP_WS_REVIEW_05: "Threatening",
  T_38_SP_WS_REVIEW_06: "Disrespectful",
  T_38_SP_WS_REVIEW_07: "Under Review",
  T_38_SP_WS_REVIEW_08: "{0} name {1} does not comply with the rules. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Store",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Function",
  T_38_SP_WS_REVIEW_13: "Object",
  T_38_SP_WS_REVIEW_14: "Go to definition.",
  T_38_SP_WS_REVIEW_15: "Go to Manage Objects.",
  T_38_SP_WS_REVIEW_16: "No redirection.",
  T_38_SP_WS_REVIEW_17: "Map Name",
  T_38_SP_WS_REVIEW_18: "Description",
  T_38_SP_WS_REVIEW_19: "Cover Image",
  T_38_SP_WS_REVIEW_20: "Text contains sensitive words.",
  T_38_SP_WS_REVIEW_21: "Save failed. Unable to be reviewed.",
  T_38_SP_WS_REVIEW_22: "Review under cooldown.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bat - Mayhem",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Pet Skin: Ghost Kactus",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Pet Skin: Neon Kactus",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Pet Skin: Palm Dream Kactus",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Pet Skin: Party Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Pet Skin: Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "Scythe - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Pickup Truck - Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "Multi-Level",
  T_38_WT_WS_SKILLSET15: "Thrill of Battle (A124)",
  T_38_WT_WS_SKILLSET16: "Senses Shockwave (Homer)",
  T_38_WT_WS_SKILLSET17: "Wall Brawl (Iris)",
  T_38_WT_WS_SKILLSET18: "Rebel Rush (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Active in scenery or not",
  T_38_WZY_WS_ACTIVEB: "Turn on logic refresh or not",
  T_38_WZY_WS_ACTIVEVALUE: "Activity status",
  T_38_WZY_WS_AIR: "Air",
  T_38_WZY_WS_ALLOWMOVE: "Moveable or not",
  T_38_WZY_WS_AMMOAMOUNT: "Ammo amount",
  T_38_WZY_WS_AMMONAME: "Ammo Entity",
  T_38_WZY_WS_ARMOR_DAMRED: "DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Explosion DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DURABILITY: "Current durability",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Max. durability",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Damageable or not",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destructible or not",
  T_38_WZY_WS_ARMOR_LEVEL: "Level",
  T_38_WZY_WS_ASSCONZOM: "Zombie elimination assist.",
  T_38_WZY_WS_BAGNAME: "Backpack Entity",
  T_38_WZY_WS_BAGSPACEEX: "Additional backpack space",
  T_38_WZY_WS_BRIDGING: "Bridge render component",
  T_38_WZY_WS_BUBBLE: "Bubble",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Clear all items in the [player entity's] backpack",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Clear the unwanted items lying around the map, such as loot, throwable residue, and loot boxes",
  T_38_WZY_WS_CLEARPRO: "Clear single property factor",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Clone a [scenery object] entity at the location of a [player entity] and return the [disguise entity]",
  T_38_WZY_WS_COMPONENT: "Component",
  T_38_WZY_WS_COSTAMMO: "Consume ammo",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Create a camera and return a [camera entity], whose properties can be modified through property settings",
  T_38_WZY_WS_CYCLES: "Times played",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a circular pole. The [center] is the center of the pole, the [radius] is the radius of the circular surface, the [height] is the height of the pole, the [Euler angles] are the angles of the 3D orientation of the pole.",
  T_38_WZY_WS_CYLINDERJUD_RES: "The result of the circular pole scope check. This is a Boolean value.",
  T_38_WZY_WS_DAMSUMZOM: "DMG to zombies",
  T_38_WZY_WS_DARKNESS: "Darkness",
  T_38_WZY_WS_DIFCOLOR: "Surface color",
  T_38_WZY_WS_DIFTEXTURE: "Surface texture",
  T_38_WZY_WS_DRUMMUSIC: "Component type: drums",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "The player that was disconnected",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "The player that is reconnecting",
  T_38_WZY_WS_EUIANCHOR: "HUD anchor type enumeration",
  T_38_WZY_WS_FEATHER: "Feather",
  T_38_WZY_WS_FLAMEAMMO: "Flamethrower Ammo",
  T_38_WZY_WS_FLOWER: "Flower",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Set the [entity] to always follow the [followed entity]. [Offset coordinates] is the distance between the two entities.",
  T_38_WZY_WS_FOLLOWENT: "Followed entity",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Get the camera entity that is currently being used by a [player entity]",
  T_38_WZY_WS_GETCURCAMDESC: "The camera that is currently being used by the player",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Get the amount of an item in the [designated item type] that a [player] owns",
  T_38_WZY_WS_GETITEMNUM_RES: "The amount of the designated item that the player owns",
  T_38_WZY_WS_GETVEC_NAME: "Get vector",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Get a vector using the x, y, and z components of a set of coordinates",
  T_38_WZY_WS_GETVECRES: "The vector got from the x, y, and z components",
  T_38_WZY_WS_GHOST: "Ghost",
  T_38_WZY_WS_GRENADEFROZENNAME: "Flash Freeze Entity",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Freeze zone radius",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Freeze duration",
  T_38_WZY_WS_GRENADENAME: "Grenade Entity",
  T_38_WZY_WS_GRENADEPARAM1: "Min. DMG",
  T_38_WZY_WS_GRENADEPARAM2: "Max. DMG",
  T_38_WZY_WS_GRENADEPARAM4: "Explosion range",
  T_38_WZY_WS_GRENADEPARAM5: "Throwing speed",
  T_38_WZY_WS_GRENADEPARAM6: "Explosion delay",
  T_38_WZY_WS_GRENADEPARAM7: "Self DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM8: "Ally DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM9: "Vehicle DMG multiplier",
  T_38_WZY_WS_GUNFIRE: "Gunfire",
  T_38_WZY_WS_GUNPRO_PARAM2: "Reload Speed",
  T_38_WZY_WS_GUNPRO_PARAM3: "Body shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM4: "Headshots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM5: "Limb shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM7: "Extra DMG",
  T_38_WZY_WS_HELMET_NAME: "Helmet Entity",
  T_38_WZY_WS_ICON1: "Crown",
  T_38_WZY_WS_ICON2: "Duel",
  T_38_WZY_WS_INITPOS: "Initial location",
  T_38_WZY_WS_ISRESET: "Reciprocating Motion",
  T_38_WZY_WS_KILLCONZOM: "No. of zombies eliminated",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Eliminate the chosen [entity], which must be a battle entity type. Ignores the invulnerable status.",
  T_38_WZY_WS_LABELPARAM: "Text content parameter list",
  T_38_WZY_WS_LEADMUSICA: "Component type: piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Component type: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Component type: piano (bass)",
  T_38_WZY_WS_LINE: "Line",
  T_38_WZY_WS_LIQUID: "Liquid",
  T_38_WZY_WS_LOCALKEY: "Localized key",
  T_38_WZY_WS_LOCALPOS: "Relative location",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Set an [entity] to aways face the [aimed entity]. [Offset coordinates] is the difference in coordinates of the aimed point and the entity's position.",
  T_38_WZY_WS_MAINWEAPONA: "Main Weapon 1",
  T_38_WZY_WS_MAINWEAPONB: "Main Weapon 2",
  T_38_WZY_WS_MOTIONTIME: "Movement duration",
  T_38_WZY_WS_MOTIONTYPE: "Movement method",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Modified EP",
  T_38_WZY_WS_MUSHROOMNAME: "Mushroom Entity",
  T_38_WZY_WS_OBFACTION: "Spectating faction",
  T_38_WZY_WS_OBGLOBAL: "Spectate all",
  T_38_WZY_WS_OBSERVER: "Spectator Options",
  T_38_WZY_WS_OBTEAM: "Spectating team",
  T_38_WZY_WS_OFFSETVEC: "Offset coordinates",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Triggers when a player is buying items from this Vending Machine. [Player entity] is the player that makes the purchase. [Merchandise entity] is the item bought.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Triggers when equipped by a [player entity]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Triggers when the player completes the jumping action",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Triggers when the player completes the prone position",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Triggers when the weapon reloads",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Triggers when the player completes the sprinting action",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Triggers when the player completes the crouching action",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Triggers when the weapon eliminates a unit. [Eliminated entity] is the unit that was eliminated.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Triggers when the weapon inflicts damage to a battle entity. [Hit target] is the battle entity that damage was inflicted on. [Damage] is the damage being inflicted.",
  T_38_WZY_WS_OWNER: "Owner",
  T_38_WZY_WS_PARAMLIST: "Parameter list",
  T_38_WZY_WS_PARTICALMAP: "Particle Mapping",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pause or resume the current emote for a [player entity]. [Pause or not] is a Boolean value. "Yes" means pause. "No" means resume.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Activated by player entering the trigger",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Activated by player leaving the trigger",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Force the [player entity] to play the designated [emote] once and return to original position when finished",
  T_38_WZY_WS_PLAYSPEED: "Playback speed percentage",
  T_38_WZY_WS_PREHUD_NAME: "Preset icon",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Let the [player entity] leave its current faction",
  T_38_WZY_WS_RESETENT: "Reset components every round",
  T_38_WZY_WS_RESUUID: "Resource UUID",
  T_38_WZY_WS_RIMCOLOR: "Border color",
  T_38_WZY_WS_RIMTEXTURE: "Border texture",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Check whether an [entity] is inside a cone. The [center] and [radius] are the center and radius of the cone. The [extracted radius] is the radius of the smaller sector within the cone. The height is the height of the 3D structure. The [angle] is the central angle of the cone. The [direction angle] is the direction vector of the central axis.",
  T_38_WZY_WS_SECTORJUD_RES: "The result of the fan-shaped scope check. This is a Boolean value.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Set the activity status of a [target entity]. [Activity status] is a Boolean value and affects the availability, visibility, and collidability of the entity.",
  T_38_WZY_WS_SETROUNDSCORE: "Set player's round score",
  T_38_WZY_WS_SHOOTANGMAX: "Max. shooting angle",
  T_38_WZY_WS_SHOWMAPINFO: "Display map info for same faction",
  T_38_WZY_WS_SHOWNAMEHUD: "Display name HUD for same faction",
  T_38_WZY_WS_SOUND1: "Acceleration",
  T_38_WZY_WS_SOUND10: "Phase Start",
  T_38_WZY_WS_SOUND11: "Zombies",
  T_38_WZY_WS_SOUND12: "Horror",
  T_38_WZY_WS_SOUND13: "Transformation",
  T_38_WZY_WS_SOUND14: "Pounding Heart",
  T_38_WZY_WS_SOUND15: "Medium Heartbeat",
  T_38_WZY_WS_SOUND16: "Slow Heartbeat",
  T_38_WZY_WS_SOUND17: "Rush Time",
  T_38_WZY_WS_SOUND18: "Click",
  T_38_WZY_WS_SOUND19: "Skill Recover",
  T_38_WZY_WS_SOUND2: "Disappear Notification",
  T_38_WZY_WS_SOUND20: "Join A Game",
  T_38_WZY_WS_SOUND3: "Visual Effects",
  T_38_WZY_WS_SOUND4: "Night Chirps",
  T_38_WZY_WS_SOUND5: "Hit (Blunt)",
  T_38_WZY_WS_SOUND6: "Reaction",
  T_38_WZY_WS_SOUND7: "Surprise Find",
  T_38_WZY_WS_SOUND8: "Apparition",
  T_38_WZY_WS_SOUNDENT: "Music entity",
  T_38_WZY_WS_SPAWNPOS: "Old Spawn Point",
  T_38_WZY_WS_SPHERENAME: "Basic sphere",
  T_38_WZY_WS_SPHERERADIUS: "Sphere radius",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Check whether an [entity] is inside a spherical scope. The [center] and [radius] is the center and radius of the spherical structure.",
  T_38_WZY_WS_SPHERICALJUD_RES: "The result of the spherical scope check. This is a Boolean value.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a cube. The [center] is the center of the cube, the [length], [width], and [height] are the length, width, and height of the cube, and the [Euler angles] are the angles of the 3D orientation of the cube.",
  T_38_WZY_WS_SQUAREJUD_RES: "The result of the cubic scope check. This is a Boolean value.",
  T_38_WZY_WS_STARTGENTIME: "Spawn start time",
  T_38_WZY_WS_STAYTIME: "Pause duration",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Switch a player's camera to the [camera entity]. [Switch mode] can be either no animation or progressive movement. [Switch time] is the time of switching during progressive mode.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Switch the camera mode. You can select between No Animation and Progressive Movement.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'The switch time during progressive movement mode. When selected "no animation", this setting is void.',
  T_38_WZY_WS_TEXTHUD: "HUD text component",
  T_38_WZY_WS_TEXTTYPE: "Font Size",
  T_38_WZY_WS_TEXTUREID: "Texture type",
  T_38_WZY_WS_TRANDIST: "Max. distance",
  T_38_WZY_WS_TWEENERENABLED: "Turn on UITweener script or not",
  T_38_WZY_WS_TYPELIST: "Type list",
  T_38_WZY_WS_TYPELISTORLIST: "Type or type list",
  T_38_WZY_WS_VEST_NAME: "Vest Entity",
  T_38_WZY_WS_VFX1: "Hider Elimination",
  T_38_WZY_WS_VFX10: "Cyclic Combustion",
  T_38_WZY_WS_VFX11: "Poison Gas",
  T_38_WZY_WS_VFX13: "Heart",
  T_38_WZY_WS_VFX15: "Door",
  T_38_WZY_WS_VFX2: "Rampage",
  T_38_WZY_WS_VFX3: "Clone Elimination",
  T_38_WZY_WS_VFX4: "Hit Feedback",
  T_38_WZY_WS_VFX5: "Clone",
  T_38_WZY_WS_VFX6: "Disguise",
  T_38_WZY_WS_VFX7: "Flashbang Sparks",
  T_38_WZY_WS_VFX8: "Motion Trail",
  T_38_WZY_WS_VFX9: "Fire Charge",
  T_38_WZY_WS_VFXENT: "VFX Instance",
  T_38_WZY_WS_VFXTYPEA_NAME: "Customizable mapping VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "Non-customizable mapping VFX",
  T_38_WZY_WS_VISIBILITY: "Visibility type",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Weapon Generator",
  T_38_WZY_WS_WHECYCLE: "Replay",
  T_38_XXJ_WS_BLOCKMODE: "Blocked Mode",
  T_38_XXJ_WS_CUSTOMCAMARA: "Custom Camera",
  T_38_XXJ_WS_FFCLASSIC: "Classic FF (Shooting)",
  T_38_XXJ_WS_FOV: "Field of View",
  T_38_XXJ_WS_FOVDESC: "The field of view is the observable range of the camera.",
  T_38_XXJ_WS_FPS: "First Person (Shooting)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Horizontal Angle",
  T_38_XXJ_WS_INVISICAM: "Semi-Transparent",
  T_38_XXJ_WS_OFFSET: "Offset",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Orthographic",
  T_38_XXJ_WS_PERSPECTIVE: "Perspective",
  T_38_XXJ_WS_PROJECTIONMODE: "Projection Mode",
  T_38_XXJ_WS_STABLE: "Fixed",
  T_38_XXJ_WS_STARTCAMERA: "Default Camera",
  T_38_XXJ_WS_STARTCAMERAMODE: "Default Camera Mode",
  T_38_XXJ_WS_THIRD: "Chase Camera",
  T_38_XXJ_WS_TOPVIEW: "High Angle",
  T_38_XXJ_WS_TPS: "Third Person",
  T_38_XXJ_WS_TRANSVERSE: "Horizontal Movement",
  T_38_XXJ_WS_VERTICALANGLE: "Vertical Angle",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Start time (s)",
  T_38_XYL_WS_ARMORDESTROY: "Armor DMG multiplier",
  T_38_XYL_WS_BONFIRE: "Bonfire",
  T_38_XYL_WS_CANDLE01: "Candle A",
  T_38_XYL_WS_CANNON01: "Mechanical Cannon",
  T_38_XYL_WS_CLIPAMMOSIZE: "Magazine Storage",
  T_38_XYL_WS_DAMAGEDTRUCK: "Damaged Truck",
  T_38_XYL_WS_DOLL01: "Eerie Doll",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Brick House A",
  T_38_XYL_WS_FENCE002: "Iron Fence B",
  T_38_XYL_WS_FIREWORK01: "Fireworks A",
  T_38_XYL_WS_GENERATOR: "Generator",
  T_38_XYL_WS_GRAVITY: "Gravitational Acceleration",
  T_38_XYL_WS_GRAVITYAREA: "Abnormal Grav Zone",
  T_38_XYL_WS_GRAVITYAREA_DESC: "A zone where players can change gravity",
  T_38_XYL_WS_HOLDWEAPON: "Weapon Hold",
  T_38_XYL_WS_INDOORFURNITURE: "Indoor Furniture",
  T_38_XYL_WS_LIGHTTUBE001: "Tube Light A",
  T_38_XYL_WS_LOVEBALLOON01: "Valentine Balloon A",
  T_38_XYL_WS_LOVELAMP01: "Heart Streetlight",
  T_38_XYL_WS_LOVESIGN01: "Love Neonlights",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Oil Barrel Damage Ratio",
  T_38_XYL_WS_OUTDOORPROPS: "Outdoor Items",
  T_38_XYL_WS_PIPEANDBOX: "Pipes and Containers",
  T_38_XYL_WS_PLANT: "Plants",
  T_38_XYL_WS_ROSE01: "Rose",
  T_38_XYL_WS_ROSEN: "Rose Bouquet",
  T_38_XYL_WS_SMALLBUILDING: "Small Buildings",
  T_38_XYL_WS_SOFA002: "Sofa B",
  T_38_XYL_WS_TOWNHOUSE01: "Old 2-Story House",
  T_38_XYL_WS_TV001: "Old TV",
  T_38_ZP_CC_EXCHANGESTATUS: "Status",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "Victory Glintmark",
  T_39_HJ_WS_Arrow002: "Arrow 2",
  T_39_HJ_WS_LIKERATE2: "{0} min",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min",
  T_39_HJ_WS_SOUND10: "Step",
  T_39_HJ_WS_SOUND11: "Mission Complete 1",
  T_39_HJ_WS_SOUND13: "Danger Alert 1",
  T_39_HJ_WS_SOUND14: "Danger Alert 2",
  T_39_HJ_WS_SOUND15: "Countdown 3",
  T_39_HJ_WS_SOUND16: "Tips Sound",
  T_39_HJ_WS_SOUND17: "Crow Caw",
  T_39_HJ_WS_SOUND18: "Sound of teleporting to a wrong area",
  T_39_HJ_WS_SOUND19: "Sound of teleporting to a correct area",
  T_39_HJ_WS_SOUND2: "Countdown 1",
  T_39_HJ_WS_SOUND20: "Teleport",
  T_39_HJ_WS_SOUND21: "Electric Shock",
  T_39_HJ_WS_SOUND23: "Get Item",
  T_39_HJ_WS_SOUND24: "Electronic & Cute BGM",
  T_39_HJ_WS_SOUND25: "Casual Game BGM",
  T_39_HJ_WS_SOUND4: "Mechanical Device Echo",
  T_39_HJ_WS_SOUND5: "Mosquito",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Gear Switched On",
  T_39_HJ_WS_SOUND9: "Charge 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Unlimited Gloo Walls",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Unlimited Throwables",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Special Firing Sound",
  T_39_HQ_UGC_CUSTOMRES: "Custom Resources",
  T_39_M_ACCOUNTID: "Account",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Execute after double click",
  T_39_MF_SKILLTAG_4: "Movement",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "After knocking down an enemy, marks their teammates within [FFB300]{0}m[-] from them and slows down their movement speed by [FFB300]{1}%[-]. Lasts for [FFB300]{2}s[-]. When knocked down by a nearby enemy, marks and slows down the attacker and their teammates.",
  T_39_QL_SKILL_WOLFRAHH_DES: "After knocking down an enemy, enter Highlight mode, which increases rate of fire by [FFB300]{0}%[-] and movement speed by [FFB300]{1}%[-] but then decays quickly. Lasts for [FFB300]{2}s[-]. During Highlight mode, consecutively knocking down enemies will reset countdown and further boost rate of fire by [FFB300]{3}%[-] and movement speed by [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Xtreme Mode: Get [FFB300]{0} temporary HP[-] for [FFB300]{1}s[-]. During this time, HP-healing effects are enhanced by [FFB300]{2}%[-]. Cooldown: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Failed",
  T_39_RW_SKILL_DESC_FORD: "Gain [FFB300]{1} HP/s[-] for [FFB300]{0}s[-] when taking damage. After releasing an active skill, this passive skill will reset immediately. Cooldown: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Item entity",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Nights",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Pet skin: Green Imp Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Pet Skin: Royal Tig",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Pet Skin: Scorpio Fang",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck - Green Giant",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Awakening: [FFB300]{0}s[-] before detonating, grenade produces [FFB300]{1}[-] extra grenades, which can cause [FFB300]{2}%[-] damage of their original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Split Blitz",
  T_39_WT_WS_EMPTYMAP_TAG: "Empty space",
  T_39_WT_WS_FEMAPMODE: "Mode Title",
  T_39_WT_WS_FEMAPTAG: "Map Tag",
  T_39_WT_WS_MAPPLAYER: "Number of Players",
  T_39_WT_WS_MEDENTERNUM: "Mid-game joining player limit",
  T_39_WT_WS_MIDENTER: "Mid-game joining",
  T_39_WT_WS_MIDENTERCOUNT: "Quota of joining mid-game",
  T_39_WT_WS_MIDENTERTIME1: "Time limit of mid-game joining",
  T_39_WT_WS_MIDENTERTIME2: "Duration of mid-game joining",
  T_39_WT_WS_MIDENTERTIMETIP: "When the map player number limit is not reached, enable players to join in within N sec after match starts. Players cannot join in after N sec.",
  T_39_WT_WS_MIDENTERTIP: "When enabled, players can join this map mid-game.",
  T_39_WT_WS_PLAYERCOUNT: "Initial player number",
  T_39_WT_WS_PLAYERCOUNTTIP: "The player number when the match starts. More players can join mid-game until it reaches the map's limit.",
  T_39_WT_WS_TAG1: "Free For All",
  T_39_WT_WS_TAG10: "Easy",
  T_39_WT_WS_TAG11: "Medium",
  T_39_WT_WS_TAG12: "Hard",
  T_39_WT_WS_TAG13: "Very Challenging",
  T_39_WT_WS_TAG14: "Escape",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Custom Resources",
  T_39_WT_WS_TAG18: "Puzzles",
  T_39_WT_WS_TAG19: "Racing",
  T_39_WT_WS_TAG2: "Gun Fight",
  T_39_WT_WS_TAG20: "Music",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Adventure",
  T_39_WT_WS_TAG23: "Zombie Hunt",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "Team Deathmatch",
  T_39_WT_WS_TAG27: "Turret Defense",
  T_39_WT_WS_TAG28: "Training",
  T_39_WT_WS_TAG3: "Gun King",
  T_39_WT_WS_TAG4: "Respawn",
  T_39_WT_WS_TAG5: "Sniper",
  T_39_WT_WS_TAG6: "Survival",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Horror",
  T_39_WT_WS_TAG9: "Casual",
  T_39_WT_WS_TAGMAXTIP: "Select up to {0} tags",
  T_39_WT_WS_TAGTYPE1: "Gameplay Type",
  T_39_WT_WS_TAGTYPE2: "Map Type",
  T_39_WT_WS_TAGTYPE3: "Mode Type",
  T_39_WT_WS_TAGTYPE4: "Team Size",
  T_39_WZY_WS_ACCSPEED: "Acceleration",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Add script [Script Name] for [Entity]",
  T_39_WZY_WS_ASC: "Ascending",
  T_39_WZY_WS_ASCIGZERO: "Ignore zero using Ascending",
  T_39_WZY_WS_BALLISTMOVENT: "Ballistic Motion Entity",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Triggers incident when the item is used by [Player Entity]",
  T_39_WZY_WS_BODYSCALE: "Body scale",
  T_39_WZY_WS_BRAKETORQUE: "Brake Horsepower",
  T_39_WZY_WS_CAMTRANTYPE: "Camera transition type",
  T_39_WZY_WS_CARVEHICLE: "4-Wheeler",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Check if a specified script [Script Name] exists in [Entity]. (The returned value should be Boolean)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Check if the entity has a result of the specified script (Boolean)",
  T_39_WZY_WS_COMBINEALL: "Dual-wielding (Different guns)",
  T_39_WZY_WS_COMBINESELF: "Dual-wielding (Same gun)",
  T_39_WZY_WS_CONENAME: "Basic Cone",
  T_39_WZY_WS_COORSYS: "Coordinate system",
  T_39_WZY_WS_CRASHMAXD: "Max Crash Damage",
  T_39_WZY_WS_CRASHMIND: "Minimum Crash Damage",
  T_39_WZY_WS_CRAWLSPEED: "Mvmt. spd. percentage (Prone)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Create Ballistic Motion for [Target Entity]. Can edit [Initial Speed], [Acceleration], and [Max Distance] accumulated in the direction of initial speed for the target entity, and return [Ballistic Motion Entity]",
  T_39_WZY_WS_CRETWEEN_NAME: "Create Interpolation Motion",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Create an Interpolation Motion for [Entity], with [Attributes] of the entity moving smoothly from [Start Value] to [Target Value] within [Time]. [Method] represents the way of motion, including [One-way], [PingPong], [Cycle]. [Curve] is the curve of motion. And [Interpolation Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_CURVE: "Curve",
  T_39_WZY_WS_CUSTRESULT: "Custom Match Result",
  T_39_WZY_WS_CYLINDERNAME: "Basic Cylinder",
  T_39_WZY_WS_DEFAULT: "No animation (Default)",
  T_39_WZY_WS_DESC: "Descending",
  T_39_WZY_WS_DIFFUSEALPHA: "Surface Transparency",
  T_39_WZY_WS_DISCONNECT: "Disconnect",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Energy recovery per sec",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consume Energy",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Max second jump height",
  T_39_WZY_WS_ENABLEJOIN: "Allow joining midway",
  T_39_WZY_WS_ENDPOS: "End point coordinates",
  T_39_WZY_WS_ENGINETORQUE: "Engine Horsepower",
  T_39_WZY_WS_EXPLODED: "Explosion Damage",
  T_39_WZY_WS_FEELDSPEED: "Mvmt. spd. percentage (Downed)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Center flash time",
  T_39_WZY_WS_FLASH_CRANGE: "Center range",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Edge flash time",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Flashbomb hit effect",
  T_39_WZY_WS_FLASH_RANGE: "Explosion range",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Descending speed",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Max. altitude",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Horizontal glide speed",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Vertical glide speed",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Minimum end height",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Minimum takeoff height",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Descent speed after super high",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Turning speed",
  T_39_WZY_WS_FOLMOVENT: "Position Following Motion Entity",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Get Skill List of [Player Entity]",
  T_39_WZY_WS_HB_BOOSTCD: "Sprint cooldown",
  T_39_WZY_WS_HB_BOOSTDURATION: "Sprint duration",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTSPEED: "Sprint speed",
  T_39_WZY_WS_HB_HOVERBCD: "Skyboard cooldown",
  T_39_WZY_WS_HB_JUMPCD: "Jump cooldown",
  T_39_WZY_WS_HB_JUMPH: "Skyboard jump height",
  T_39_WZY_WS_HEADSCALE: "Head scale",
  T_39_WZY_WS_HEADSHOTDESCALE: "Headshot damage reduction",
  T_39_WZY_WS_INTITALSPEED: "Initial Speed",
  T_39_WZY_WS_INVENTORYBASE: "Basic item types",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Energy cost per sec",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Basic horizontal speed",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Basic vertical speed",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Dash energy cost per sec",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Sprint horizontal speed",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Sprint distance",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Rush energy cost per sec",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Sprint vertical speed",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Upward energy cost per sec",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Attackable",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Self-triggerable",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Whether can be triggered by allies",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Triggerable by vehicle",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Duration",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Activation time",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Trigger radius",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Trigger time",
  T_39_WZY_WS_LEAVE: "Quit",
  T_39_WZY_WS_LIMBSCALE: "Limbs scale",
  T_39_WZY_WS_LISTLOCSTR: "Localized text list",
  T_39_WZY_WS_LOADRESULT_NAME: "Upload battle result",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Upload battle result of [Player], including [Rank], [Result], [Score Name], [Score Value]. The result type is an integer. 1 for victory, 2 for defeat, 3 for Booyah, and 4 for a draw.",
  T_39_WZY_WS_LOOKMOVENT: "Gaze-following Motion Entity",
  T_39_WZY_WS_MAXCOUNT: "Maximum Quantity",
  T_39_WZY_WS_MAXDISTANCE: "Max. Distance",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Turret Depression Angle",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Turret Angular Speed",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Turret Elevation Angle",
  T_39_WZY_WS_MINISENTRY_DAM: "Turret Damage",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Damage Reduction Rate",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Firing Angle",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Turret Hit Rate",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Turret Attack Interval",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Max Turret Number",
  T_39_WZY_WS_MINISENTRY_RANGE: "Turret Attack Range",
  T_39_WZY_WS_MOVEENT: "Motion Entity",
  T_39_WZY_WS_NOCOMBINE: "Not dual-wieldable",
  T_39_WZY_WS_ONCE: "Once",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Triggers incident when the item is discarded by [Player Entity]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Triggers incident when the item is equipped by [Player Entity]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Triggers incident when Hook Gun fires",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Triggers incident when Landmine is activated",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Triggers incident when Landmine is triggered by [Player Enitity]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Triggers when entity motion pauses",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Triggers when entity restarts moving from pause",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Triggers when entity starts moving",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Triggers incident when the item is picked up by [Player Entity]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Triggers incident when Throwable hits target",
  T_39_WZY_WS_OPENATTACK: "Whether to enable the attack",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Pause Motion Entity or Motion Entity List",
  T_39_WZY_WS_PAUSESOUND_NAME: "Pause sound effect",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Pause Sound Entity or Sound Entity List",
  T_39_WZY_WS_PIANOTYPE: "Music Component Type",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Motion Entity List",
  T_39_WZY_WS_PLAYINGSTATUE: "Status",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Restore the paused Motion Entity or Motion Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Play sound effect",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Restore the paused Sound Entity or Sound Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Progress Circle",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [List of Entities Hit] and [List of Coordinates Hit]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [Entity Hit] and [Coordinates Hit]",
  T_39_WZY_WS_REAHEALHP: "Armor recovery value",
  T_39_WZY_WS_REAHEALTIME: "In-effect time interval",
  T_39_WZY_WS_RELATCOORSYS: "Relative coordinate system",
  T_39_WZY_WS_REPAIRARM: "Repair Kit",
  T_39_WZY_WS_REVERSE: "Reverse",
  T_39_WZY_WS_RIMALPHA: "Edge Transparency",
  T_39_WZY_WS_SCORENAME: "Score Name",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Send a signal to Target Entity, the parameters uploaded are defined by predefined signal parameters. The selection of the entity type at the time of definition will generate the corresponding signal accepting event.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Create a position following motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Position Following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Create a Gaze-following Motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Gaze-following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Falling damage percentage",
  T_39_WZY_WS_SHOE_MAXENERGY: "Max. Energy",
  T_39_WZY_WS_SKILLLIST: "Skill List",
  T_39_WZY_WS_SKILLTYPE: "Character skill",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Smoke effect duration",
  T_39_WZY_WS_SMOOTH: "Camera switch",
  T_39_WZY_WS_SOUNDENTL: "Sound Effect Entity List",
  T_39_WZY_WS_SOUNDENTLORSENT: "Sound Effect Entity or List",
  T_39_WZY_WS_SPRINTSPEED: "Sprint speed percentage",
  T_39_WZY_WS_SQUATSPEED: "Mvmt. spd. percentage (Squat)",
  T_39_WZY_WS_STARTCOO: "Initial Coordinates",
  T_39_WZY_WS_STATE: "Play status",
  T_39_WZY_WS_TARGETVAL: "Target value",
  T_39_WZY_WS_THROWSPEED: "Hook flying speed",
  T_39_WZY_WS_TOWER_PARAM10: "Rotation angle",
  T_39_WZY_WS_TOWER_PARAM11: "Turret status",
  T_39_WZY_WS_TOWER_PARAM12: "Entity ID",
  T_39_WZY_WS_TOWER_PARAM9: "Attack Target",
  T_39_WZY_WS_TOWSPEED: "Player traveling speed",
  T_39_WZY_WS_TWEENCURVE_NAME: "Custom Curve",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Custom Curve can be used for Interpolation Motion",
  T_39_WZY_WS_TWEENENT: "Interpolation Motion Entity",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Motion Methods",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Methods of Interpolation Motion",
  T_39_WZY_WS_TWEENSTYLE: "Method",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Delete script [Script Name] for [Entity]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Randomize listed elements ",
  T_39_WZY_WS_VISIBLEONBACK: "Visible on back",
  T_39_WZY_WS_WEAPCOMBINET: "Dual-Wielding Weapon Type",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Extra damage on the downed",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Single shot bullet number",
  T_39_WZY_WS_WEAREPLAY: "Restart motion?",
  T_39_WZY_WS_WORLDCOORSYS: "World coordinate system",
  T_39_XXJ_WS_ADDFRIEND: "Add friend",
  T_39_XXJ_WS_ALLOWZ: "Enable player x-axis movement",
  T_39_XXJ_WS_BLOCKMODEDESC: "Camera's motion when there's an object between the camera and target",
  T_39_XXJ_WS_CAMERADISTANCE: "Distance from target",
  T_39_XXJ_WS_CAMERATYPEDESC: "Multiple types of preset and custom camera are provided",
  T_39_XXJ_WS_CAMERAUSER: "Camera user",
  T_39_XXJ_WS_CURENTCAMERA: "Camera used",
  T_39_XXJ_WS_DETAILS: "Match Details",
  T_39_XXJ_WS_FFECONOMY: "Economy",
  T_39_XXJ_WS_FOCUSTARGET: "Target observed",
  T_39_XXJ_WS_FOLLOWTARGET: "Target followed",
  T_39_XXJ_WS_GAMERESULT: "Match Result",
  T_39_XXJ_WS_GAMETITLE1: "Match 1",
  T_39_XXJ_WS_GAMETITLE2: "Match 2",
  T_39_XXJ_WS_GIFT: "Gift",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Camera's horizontal rotation angle",
  T_39_XXJ_WS_INVISICAM: "Translucent",
  T_39_XXJ_WS_INVISICAMDESC: "Object between the camera and target becomes translucent",
  T_39_XXJ_WS_LEFTSCORE: "Left Team Score",
  T_39_XXJ_WS_LIKE: "Like",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Total Score Name",
  T_39_XXJ_WS_MAINSCORENUM: "Total Score Number",
  T_39_XXJ_WS_MAPEVALUATE: "Map Rating",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Result of Multiple Teams",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Observation point offset",
  T_39_XXJ_WS_OFFSET2DESC: "Typically refers to the offset of camera focus point relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_OFFSETDESC: "Typically refers to the offset of camera position relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_ORTHOGONAL: "Orthogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "Camera portrays distant and nearer targets as the same size",
  T_39_XXJ_WS_PERSPECTIVE: "Perspective",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Camera uses perspective projection to observe the target",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Camera's image formation when rendering",
  T_39_XXJ_WS_RANK1: "Team Rank",
  T_39_XXJ_WS_RANK2: "Player Rank",
  T_39_XXJ_WS_REPORT: "Report",
  T_39_XXJ_WS_REVIEW: "Replay",
  T_39_XXJ_WS_RIGHTSCORE: "Right Team Score",
  T_39_XXJ_WS_SCORENUM1: "Score 1",
  T_39_XXJ_WS_SCORENUM2: "Score 2",
  T_39_XXJ_WS_SCORENUM3: "Score 3",
  T_39_XXJ_WS_SCORENUM4: "Score 4",
  T_39_XXJ_WS_SCORENUM5: "Score 5",
  T_39_XXJ_WS_SCORETITLELIST: "Score Name List",
  T_39_XXJ_WS_SHARE: "Share",
  T_39_XXJ_WS_SPECTATORSWITCH: "Spectator",
  T_39_XXJ_WS_STABLE: "Stable",
  T_39_XXJ_WS_STABLEDESC: "Camera remains stable if there's an object in between the camera and the followed entity",
  T_39_XXJ_WS_TEAMNAME1: "Left Team Name",
  T_39_XXJ_WS_TEAMNAME2: "Right Team Name",
  T_39_XXJ_WS_TEAMRANK: "Team Rank",
  T_39_XXJ_WS_TRANSITIONTIME: "Camera transition time",
  T_39_XXJ_WS_TRANSITIONTYPE: "Camera transition type",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Result of 2 Teams",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Camera's vertical rotation angle",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "Camera zooms in if there's an object in between the camera and the followed entity",
  T_39_XYL_WS_LIGHTINTENSITY: "Light intensity",
  T_39_XYL_WS_LIGHTRANGE: "Light range",
  T_39_XYL_WS_POINTLIGHT: "Pointlight",
  T_39_XYL_WS_WATERZONE: "Custom water zone",
  T_40_B_DISABLE_RECONNECT: "Disable Auto-reconnection",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "Clear Coloring Status",
  T_40_HJ_WS_EFFECT32: "Sneakers",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Spawnpoint",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Ammo",
  T_40_HJ_WS_EFFECT37: "Hit Effect",
  T_40_HJ_WS_EFFECT38: "Firing Effect",
  T_40_HJ_WS_EFFECT43: "Spider Web",
  T_40_HJ_WS_EFFECT44: "Releasing a Skill",
  T_40_HJ_WS_SOUND69: "Opening a Box",
  T_40_HJ_WS_SOUND70: "Level Up",
  T_40_HJ_WS_SOUND71: "Level Maxed",
  T_40_HJ_WS_SOUND72: "Tapping a Button",
  T_40_HJ_WS_SOUND73: "Countdown 1",
  T_40_HJ_WS_SOUND74: "Whistle",
  T_40_HJ_WS_SOUND75: "Game Over",
  T_40_HJ_WS_SOUND76: "Forward",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Checkpoint",
  T_40_HJ_WS_SOUND79: "Countdown 2",
  T_40_HJ_WS_SOUND80: "Game Starts",
  T_40_HJ_WS_SOUND81: "Obtained Many Coins",
  T_40_HJ_WS_SOUND82: "Obtained Coins",
  T_40_HJ_WS_SOUND83: "Obtained Some Coins",
  T_40_HJ_WS_SOUND84: "Joined the Game",
  T_40_HJ_WS_SOUND85: "Opening Guild Supply",
  T_40_HJ_WS_SOUND86: "Horn",
  T_40_HJ_WS_SOUND87: "Eliminated a Boss",
  T_40_HJ_WS_SOUND88: "Opening War Chest",
  T_40_HJ_WS_SOUND89: "Explosive Paint Skill",
  T_40_HJ_WS_SOUND90: "Bullet Hitting",
  T_40_HJ_WS_SOUND91: "Paint Shield Skill",
  T_40_HJ_WS_SOUND92: "Tapping a Disabled Button",
  T_40_HJ_WS_SOUND93: "Skill Charging Complete",
  T_40_HJ_WS_SOUND95: "Laser Skill",
  T_40_HJ_WS_SOUND96: "Get Item 2",
  T_40_HJ_WS_SOUND97: "Game Over 2",
  T_40_HJ_WS_SOUND98: "Elimination Notification",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Background Music",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "In-Match Sound Effect",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Widget Sound Effect",
  T_40_JH_WS_MAPTAG1: "Color Game",
  T_40_JH_WS_MAPTAG10: "Color Hide N Seek",
  T_40_JH_WS_MAPTAG11: "Anniversary",
  T_40_JH_WS_MAPTAG12: "Role Play",
  T_40_JH_WS_MAPTAG13: "Simulation",
  T_40_JH_WS_MAPTAG14: "Asymmetrical",
  T_40_JH_WS_MAPTAG15: "Resource Battle",
  T_40_JH_WS_MAPTAG16: "Cart Escort",
  T_40_JH_WS_MAPTAG17: "Official Map",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Speed Challenge",
  T_40_JH_WS_MAPTAG2: "Color Spray",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Color Fight",
  T_40_JH_WS_MAPTAG4: "Color Fight",
  T_40_JH_WS_MAPTAG5: "Color Playground",
  T_40_JH_WS_MAPTAG6: "Playground Color",
  T_40_JH_WS_MAPTAG7: "Color Party",
  T_40_JH_WS_MAPTAG8: "Color Parkour",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" Parkour',
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "Home-Wreck Havoc",
  T_40_JH_WS_TAG32: "Mystery Town",
  T_40_JH_WS_TAG33: "Dawn Crisis",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "Craftland Token",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "of",
  T_40_SP_WS_DYEING: "Color",
  T_40_SP_WS_DYEING_AREA: "Area Coloring",
  T_40_SP_WS_DYEING_COLOR: "Color number",
  T_40_SP_WS_DYEING_COUNT: "Coloring Count",
  T_40_SP_WS_DYEING_DIR: "Coloring Direction",
  T_40_SP_WS_DYEING_DIS: "Coloring Distance",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Fixed Coloring Area",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Plane Area Coloring",
  T_40_SP_WS_DYEING_POSITION: "Coordinate",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Random Coloring Rate Decay",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Random Coloring Rate",
  T_40_SP_WS_DYEING_RANGE: "Coloring Area",
  T_40_SP_WS_DYEING_STATE: "Coloring Status",
  T_40_SP_WS_FACTIONTIPS_11: "Purple",
  T_40_SP_WS_SHOE_CURENERGY: "Current Energy",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Awakened Alok",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Waggor's Wonder",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Pet Skin: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Pet Skin: Electric Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Pet Skin: Laser Eyes Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Pet Skin: Aloha Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Pet Skin: Tigerstripe Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activate Text Content",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Placeholder Text Content",
  T_40_W_DJMALE_AWAKENING_D: "Awakening: While the aura is active, music notes that last for [FFB300]{2}s[-] will be dropped [FFB300]{1}m[-] behind the skill user every [FFB300]{0}s[-]. Teammates who pick up the music note will receive the same effect as the aura.",
  T_40_W_DJMALE_AWAKENING_N: "Party Remix",
  T_40_W_NURSE_D: "Spread [FFB300]{0}%[-] of the user's single-target healing effects (skill, Med Kit, heal gun, etc.) to teammates within [FFB300]{1}m[-] of the user.",
  T_40_WH_MP_BOXING_NAME: "Boxing Match",
  T_40_WH_MP_C_PACK: "Unlawful Backpack",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Unlawful Money",
  T_40_WH_MP_PAYCHECK: "Wages",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "The speed of helping up teammates is increased by [FFB300]{0}%[-]. Cooldown: [FFB300]{3}s[-]. The helped up teammate recovers [FFB300]{2} HP[-] in [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Creates a [FFB300]{0}m-radius[-] healing zone. Inside, user and allies recover [FFB300]{1} HP/s[-]. Help up will be automatically triggered when needed. Zone lasts for [FFB300]{2}s[-]. The effects of helping up teammates can be enhanced by other skills. Cooldown: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Method of display",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Height",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radius",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Sphere",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Color",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressive",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Image Resources",
  T_40_WZY_WS_ICONENTITY_NAME: "Icon object",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Method of display",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Tiles",
  T_40_WZY_WS_NEWMAPTAG: "New Map Icon",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curse",
  T_40_WZY_WS_NEWVFX11: "Freeze Zone",
  T_40_WZY_WS_NEWVFX12: "Cold Air",
  T_40_WZY_WS_NEWVFX13: "Snowflake",
  T_40_WZY_WS_NEWVFX14: "Flame",
  T_40_WZY_WS_NEWVFX15: "Light Beam",
  T_40_WZY_WS_NEWVFX16: "Spread of Poison Gas",
  T_40_WZY_WS_NEWVFX17: "Poison Gas",
  T_40_WZY_WS_NEWVFX18: "Explosive Blaze",
  T_40_WZY_WS_NEWVFX19: "Light Effect",
  T_40_WZY_WS_NEWVFX2: "Bubble",
  T_40_WZY_WS_NEWVFX20: "Star",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Stone Splash",
  T_40_WZY_WS_NEWVFX5: "Line",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "Ring",
  T_40_WZY_WS_NEWVFX8: "Rising Particle",
  T_40_WZY_WS_NEWVFX9: "Smoke",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Font Size",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Font Style",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Font",
  T_40_WZY_WS_TEXTENTITY_NAME: "Text object",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Interaction button HUD component",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Whether it can be used in the scenery. This is read only and depends on "Parent available or not" and "Activity status".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Whether all parents are active. This is read only and not visible to players.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Parent available or not",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Whether it can be active on self. To use in the scenery, you must use "Active in scenery or not". This is read only and configured using an API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Whether the camera's cullingMask is visible to a certain layer",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Generate tokens at a certain place",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "The lootable item to give to the player",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Current orientation of the player",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direction",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "The AI is attacking the entity",
  T_40_XXJ_WS_AITARGET_DESCKEY: "The attacking AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "The align style",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Horizontal align",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Vertical align",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparency",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "The remaining ammo count",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Remaining ammo",
  T_40_XXJ_WS_ANCHORMAX: "Maximum Anchor",
  T_40_XXJ_WS_ANCHORMIN: "Minimum Anchor",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Current position of the player",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Position",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Armor HUD switch",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Configured asset ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Asset ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Target of attack",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Attack throwables",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "The entity that is being attacked by the AI",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Target attacked",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "The available coordinates of spawnpoints",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Available coordinates",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "The bottom image",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Background",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Backpack",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Background transparency",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Background color",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Background color",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Whether to fill the background",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Background fill",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Background name",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Background name",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Background size delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Background size delta",
  T_40_XXJ_WS_BLUE: "Blue",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Skeleton scale",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "The player's spawnpoint",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Spawn point",
  T_40_XXJ_WS_BOTH: "Either",
  T_40_XXJ_WS_BUTTONNAME: "Button component name",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Camera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "The direction that the client camera is facing",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "The location of the client camera",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detect the camera line of the client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Camera ray detection",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Stop dragging when coinciding with the viewport",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Exit drag after fit",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "The distance between the center of the semicircles of the pill shape. It cannot be smaller than twice the radius of the sphere.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Cell size",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Child cell height",
  T_40_XXJ_WS_CELLVALUE: "Read the content of a certain cell and return an object",
  T_40_XXJ_WS_CENTER_DESCKEY: "The world coordinates that corresponds to the minimap's center. 0 by default.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Minimap center",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "The offset of the button's position",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Position offset",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "The center of mass relative to the local coordinates",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Center of mass",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Whether to display the middle line",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Display middle line or not",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Middle line position [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Middle line position",
  T_40_XXJ_WS_CHASERANGE: "Chase Vicinity",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "The entity that is being chased by the AI",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Target chased",
  T_40_XXJ_WS_CHILD_DESCKEY: "Child entity",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Parent's children",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "The point that is hit by the camera line",
  T_40_XXJ_WS_CHOOSECARHUD: "Select card HUD entity",
  T_40_XXJ_WS_CLAMP_DESCKEY: "If the parameter is within the numerical range between the minimum and maximum values, the function will return the value of the parameter; if the parameter is greater than the range, the function will return the maximum value; if the argument is less than the range, the function will return the minimum value",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "The size of the click area",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Click size",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Clipping type",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Clipping type",
  T_40_XXJ_WS_CLONEENT_D: "Clone the selected entity and its attributes while keeping the original parent. If Level Object is selected, it will be based on Create Level Object.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "The list of outfits",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "Outfit ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_COL_DESC: "The column to read.",
  T_40_XXJ_WS_COLNAME_DESC: "The name of the column to be read.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Color",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Value",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Add color layers using the RGBA color channel. A channel value lies in between 0 and 255 and is stored in an Int32. White (255, 255, 255, 255) by default.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Color of the progress bar",
  T_40_XXJ_WS_COLOR3_DESCKEY: "The type of the RGBA color channel, which ranges from 0 to 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "The color of the text",
  T_40_XXJ_WS_COLOR5_DESCKEY: "The color of the HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "The color of the lighting",
  T_40_XXJ_WS_COLORA_DESCKEY: "The A color value",
  T_40_XXJ_WS_COLORB_DESCKEY: "The B color value",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Progress bar color",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Color barrel",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Color Barrel",
  T_40_XXJ_WS_COLORG_DESCKEY: "The G color value",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtain the RGBA channel",
  T_40_XXJ_WS_COLORGUN: "Rainbow Spray Rifle",
  T_40_XXJ_WS_COLORGUN_01: "Rainbow Spray Rifle (Red)",
  T_40_XXJ_WS_COLORGUN_02: "Rainbow Spray Rifle (Yellow)",
  T_40_XXJ_WS_COLORGUN_03: "Rainbow Spray Rifle (Blue)",
  T_40_XXJ_WS_COLORGUN_04: "Rainbow Spray Rifle (Green)",
  T_40_XXJ_WS_COLORGUN_05: "Rainbow Spray Rifle (Purple)",
  T_40_XXJ_WS_COLORR_DESCKEY: "The R color value",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Text color",
  T_40_XXJ_WS_COLVALUE: "Column Content",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "The HUD entity of a general HUD switch",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "HUD entity of general HUD switch",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "The number of constraints",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Constraint count",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Original content",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Default direction",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "The starting point of the scroll. Upper left corner by default.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Generate a static pixel for a certain object in the map. The pixel will not move with the object.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Create a minimap icon",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Define a localized string for a timestamp",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Create a custom UI component at the designated custom HUD and parent component",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Crawl",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Display when true, otherwise closed",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Crouch",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "This is the camera's cullingMask render layer. You can filter the render entity using the level of the visible layer.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "The top ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Top",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "The shoes ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Shoes",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "The head ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Head",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "The facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mask",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "The bottom ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bottom",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "The bundle ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Onesie",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "The drag amount in the xy direction",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY drag",
  T_40_XXJ_WS_DB: "Read Table Value",
  T_40_XXJ_WS_DB_DESC: "Read the corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBDELETE_DESC: "Delete a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "A custom name used to identify data",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifier",
  T_40_XXJ_WS_DBTABLENAME: "Database Table Name",
  T_40_XXJ_WS_DBTABLENAME_DESC: "The name of a table in a database.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "The value to write",
  T_40_XXJ_WS_DBWRITE: "Write Table Value",
  T_40_XXJ_WS_DBWRITE_DESC: "Write a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Defense throwables",
  T_40_XXJ_WS_DEFULT: "Default",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Delete a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Delete a corresponding value of a certain rank on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DEPTH: "HUD layer",
  T_40_XXJ_WS_DEPTH_D: "The basic layer of the HUD",
  T_40_XXJ_WS_DICTANDLIST: "List and Dictionary",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "The value of the targeted dictionary",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "The transparency of the surface",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "A point that is provided and can be used as a revival points, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordinates",
  T_40_XXJ_WS_DISABLEALL: "Deselect All",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Disabled color",
  T_40_XXJ_WS_DISTANT_DESCKEY: "The distance of the camera line detection",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Projecting distance",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Supports multiple dragging directions",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Drag effect",
  T_40_XXJ_WS_DRIVER_DESCKEY: "The driver of the vehicle",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Driver",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modify a value",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Effects color",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "The special effects entity represents the special effect to be displayed",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "The special effects object",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Emoji HUD switch",
  T_40_XXJ_WS_ENABLEALL: "Select all",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Whether to turn on logic update. When off, the blocks on this entity will stop updating every frame.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "When written into the weapon attributes, the weapon's basic statistics will be affected by the weapon skin",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Write weapon skin attribute",
  T_40_XXJ_WS_ENTITY_DESCKEY: "An entity is a vessel that holds all components, which must be added to entities in order to be activated",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Entity type",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "The basic component of an entity. All components will combine this component.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "The entity to transform into",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "The parameter name used in the code to represent the entity of the newly added custom UI control. Its corresponding local variable value is the entity of the newly added custom UI control.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "The name of the entity variable",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "The parameter name used in the code to represent the entity of the created icon. Its corresponding local variable value is the entity of the created icon.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP bar HUD switch",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Euler angles",
  T_40_XXJ_WS_FACINFECTION: "Faction (Droid Apocalyse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faction of the player. 1 = Human, 2 = Droid.",
  T_40_XXJ_WS_FEMALE: "Female",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Fill direction",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Sort direction",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fire",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "The value of the float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "The target entity to follow. Empty by default.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "The size of the text",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Font size",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "The font style",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Football Gloo Wall",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "The formatting style",
  T_40_XXJ_WS_FORWARD_DESCKEY: "The direction of the player",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "The direction to teleport",
  T_40_XXJ_WS_FREE_DESCKEY: "A camera that is controllable by the player and can be moved freely",
  T_40_XXJ_WS_FREE_NAMEKEY: "Free Camera",
  T_40_XXJ_WS_GENDER: "Gender",
  T_40_XXJ_WS_GENDER_DESCKEY: "Gender",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Gender enum",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtain the camera's cullingMask",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtain the player's outfit ID",
  T_40_XXJ_WS_GETPLAYERRANK: "Get Player Rank",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Get Player Total Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Get Player Round Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Get Player Specific Round Rank",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Search for data of the player's token",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtain the player's weapon skin",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtain a set of coordinates that has not been occupied by random spawnpoints",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtain the sky box of a scenery",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtain the region of a server",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtain the timestamp of a server",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtain a location near the teammate, avoiding areas where players cannot stand on",
  T_40_XXJ_WS_GETTEAMRANK: "Get Team Rank",
  T_40_XXJ_WS_GETTEAMRANK_D: "Get Team Total Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Get Team Round Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Get Team Specific Round Rank",
  T_40_XXJ_WS_GREEN: "Green",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Half of the dimensions of a 3-dimensional shape",
  T_40_XXJ_WS_HEAD_DESCKEY: "Head",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Head",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "The heartbeat effect entity",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Heartbeat effect entity",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "The height",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Hint button",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tips button",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "The entity to be displayed at the target location",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entity targeted",
  T_40_XXJ_WS_HITPOS_DESCKEY: "The spot that is hit",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "The horizontal display type",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Horizontal display type",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "The entity that is following another entity",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "The entity that is looking at another entity",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Health bar HUD switch",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Empty HUD panel component",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "The HUD entity it belongs to",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD grid component",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD panel component",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD scroll view component",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "Human model ID",
  T_40_XXJ_WS_ICON_DESCKEY: "The resource name of the icon",
  T_40_XXJ_WS_ICON_NAMEKEY: "Icon",
  T_40_XXJ_WS_ICON1_DESCKEY: "Select an icon",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "The icon entity represents the icon to be displayed",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "A resource path. Built-in resource is in:path. Custom resource is out:path. Empty by default.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Icon name",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Icon name",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "The resource path. Empty by default.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Whether it can scan for triggers",
  T_40_XXJ_WS_INDEX_DESCKEY: "The child's index under the parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Initial value [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "The value of the integer",
  T_40_XXJ_WS_IS3D: "3D sound effect",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Always facing the camera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Bold",
  T_40_XXJ_WS_ISBYORDER_D: "Detect whether players should trigger level objects in chronological order",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor button",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Whether the camera line has hit the entity",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Whether it is visible to a certain layer",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italic",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Whether marked by scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Scanned or not",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Whether marked by the pin button",
  T_40_XXJ_WS_ISTRIGGER: "Is trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Underlined",
  T_40_XXJ_WS_ITEMID_DESCKEY: "The entity's corresponding item ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Item ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "The item ID (only weapon ID available in the current version)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "The item ID of the weapon",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Item ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropolis area",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropolis area",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Jump",
  T_40_XXJ_WS_KEY_DESCKEY: "The value of the key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Key",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "The name of the key to traverse. You can use this to obtain the value of a key in a local variable.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Elimination announcement",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Text color",
  T_40_XXJ_WS_LANDMINEOBJ: "Entity after landmine creation",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "The mask of the collide layer. Layers not selected will not be included in the scan. When empty, all layers will be included in the scan.",
  T_40_XXJ_WS_LAYERSEDIT: "Edit Layers",
  T_40_XXJ_WS_LAYERSETTING: "Visible layer settings",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "The collision layer of the camera line detection",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Layer",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Layout type",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Layout type",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Scoreboard HUD component",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "The HUD entity of the scoreboard. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Leaderboard Name",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "The name of the leaderboard table in the database.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "The acceleration upon swinging",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Leave acceleration",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Left arm",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Left arm",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "The left color",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Left color",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the left",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Display left effect or not",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Left foot",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Left foot",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Left hand",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Left hand",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Left icon",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Left icon",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Left leg",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Left leg",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Left score text",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Left score text",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Left text",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Left text",
  T_40_XXJ_WS_LERP_DESCKEY: 't lies in between 0 and 1. When t=0, return "from". When t=1, return "to". When t=0.5, return the average of the values of "from" and "to".',
  T_40_XXJ_WS_LEVELOBJECT: "Level Object",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Line spacing",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compare the values in a list and return the largest one",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compare the values in a list and return the smallest one",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List or Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Local position",
  T_40_XXJ_WS_LOCALROTA: "Local Euler angles",
  T_40_XXJ_WS_LOCALROTATIONQ: "Local quaternion rotation",
  T_40_XXJ_WS_LOCALSACLE: "Local scale",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Localization switch",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "The container to traverse",
  T_40_XXJ_WS_MALE: "Male",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Remove the dictionary",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtain the length of the dictionary",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtain the value of the designated key in the dictionary element",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Remove the designated key-value pair in the dictionary",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configure the value of a designated key in the dictionary",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "The size of the minimap. Its width and height are equal.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Map size",
  T_40_XXJ_WS_MAPT: "Dict template",
  T_40_XXJ_WS_MAPT_D: "The data template for dict. You may designate the content type through T1 and T2.",
  T_40_XXJ_WS_MAPVALUE_D: "A data container for dict. The element is a pair that consists of a key and a value.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "The target dictionary",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "The mask type is the image name used when masking",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Mask name",
  T_40_XXJ_WS_MASS_DESCKEY: "Mass (in kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Mass (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compare 2 values and return the larger one",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Max. length",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "The maximum value",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "The biggest component ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Max. widget ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Healing items",
  T_40_XXJ_WS_MIN_DESCKEY: "Compare 2 values and return the smaller one",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Minimap component",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Minimap pixel",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Minimap icon",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimap",
  T_40_XXJ_WS_MINNUM_DESCKEY: "The minimum value",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "The factor of the momentum. The larger the value, the bigger the momentum while scrolling.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Momentum factor",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Movement joystick",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Match result",
  T_40_XXJ_WS_NEWENTITY_D: "The new item entity after creation (may be null)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Create a new dictionary",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "New Dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "The normal of the hit",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD position [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD position",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "The list to convert indices into numbers",
  T_40_XXJ_WS_OBJECT_DESCKEY: "The object that the spray gun hits",
  T_40_XXJ_WS_OBSOLETE: "Deleted, for safety reasons please replace this block.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "The screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Display position (the anchor is on the top right corner)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "The vertical offset",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Vertical offset",
  T_40_XXJ_WS_OK_DESCKEY: "Conversion successful",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Trigger this event when the entity enters the attack vicinity",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Trigger this event when the entity enters the chase vicinity",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Trigger this event when the entity leaves the attack vicinity",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Trigger this event when the entity leaves the chase vicinity",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Trigger a camera line detection through the client",
  T_40_XXJ_WS_ONCOLLISION_D: "Only entities with the Collider component attached support this event",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Trigger this event when the spray gun hits an entity",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "When the firing stops",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "When a player switches the scenery area",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Open status",
  T_40_XXJ_WS_ORANGE: "Orange",
  T_40_XXJ_WS_ORDER_DESC: "The rank on the leaderboard",
  T_40_XXJ_WS_ORDER1: "Starting Rank",
  T_40_XXJ_WS_ORDER2: "Finishing Rank",
  T_40_XXJ_WS_ORIGINAL: "Keep original logic",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Overflow method",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "When prioritized, the attributes of the player's weapon will replace the weapon's original attributes",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Prioritize player weapon skin",
  T_40_XXJ_WS_OWNER_DESCKEY: "The player that owns this entity",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "The global UID of the child scenery it belongs to",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID of child scenery",
  T_40_XXJ_WS_PARENT_DESCKEY: "Parent entity",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Parent",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "Parent component entity ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "The file ID of the parent component",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "All the passengers in the vehicle",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passenger",
  T_40_XXJ_WS_PHYSICALLAYER: "Physical Layer",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Physical Layer Matrix",
  T_40_XXJ_WS_PHYSICALTIP1: "Name Already Exists",
  T_40_XXJ_WS_PHYSICALTIP2: "Remove a layer name and make it invisible in the Physical Layer Matrix and Layer Enum, but the entity objects within that layer will not be affected.",
  T_40_XXJ_WS_PHYSICS: "Physics",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Loot list HUD switch",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "A playable entity",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "An entity always faces another entity",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "An entity follows another entity",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "The bullet trail animation is a simulated animation of a bullet trail",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "The player to receive the message",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "The avatar used by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "The outfit equipped by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Player outfit",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "The player's HUD type",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Player HUD type",
  T_40_XXJ_WS_PLAYERIDINFAC: "Faction Serial No.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "The player to record in the log",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume a certain player's token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "The list of skills of the player",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "The status of a player: alive, knocked down, or eliminated",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "For example, 1.25 means 25% faster than the original speed",
  T_40_XXJ_WS_POS_DESCKEY: "The coordinates to teleport to",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "The type of special effects sticker",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Color on press",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Executes a traversal of a container to obtain the key-value pair. Includes a child process, which is the loop.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Loop dict visit",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "The button for the skill progress",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Skill progress button",
  T_40_XXJ_WS_QUATERNION: "Quaternion rotation",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Quick msg HUD switch",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Msgs beside team list",
  T_40_XXJ_WS_RADIUS_DESCKEY: "The radius of the two semicircles of a pill shape",
  T_40_XXJ_WS_READCELL: "Read A Cell",
  T_40_XXJ_WS_READCSV: "Read Table Content",
  T_40_XXJ_WS_READCSV_DESC: "Read the content on the entire table. Return a two-dimensional array.",
  T_40_XXJ_WS_READCSVCELL: "Read by row # and column name",
  T_40_XXJ_WS_READCSVCOL_DESC: "Read a certain column's content on the table. Returns an array.",
  T_40_XXJ_WS_READCSVROW_DESC: "Read a certain row's content on the table. Returns an array.",
  T_40_XXJ_WS_READLEADERBOARD: "Read Leaderboard Value",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Read a corresponding value of a certain identifier on a leaderboard table in the database.",
  T_40_XXJ_WS_READLEADERBOARD2: "Read By Rank Range",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Read the value of the difference between a certain rank to a certain rank on the leaderboard in a database.",
  T_40_XXJ_WS_RED: "Red",
  T_40_XXJ_WS_RELOAD: "Reload",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Method of display",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restore the player's default outfit",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restore the player's default weapon skin",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Whether the dragging is constrained to the viewport. Selected by default.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Constrain drag or not",
  T_40_XXJ_WS_RESULT_DESCKEY: "The result of the read",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Result",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Whether to find the largest number in the list",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Whether to find the smallest number in the list",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Find the smallest number in a list",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Find the largest number in a list",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "The revival point of a player. If there are no checkpoints, use a spawnpoint. Otherwise use checkpoints.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Revival point",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Right arm",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Right arm",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "The right color",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Right color",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the right",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Display right effect or not",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Right foot",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Right foot",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Right hand",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Right hand",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Right icon",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Right icon",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Right leg",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Right leg",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Right score text",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Right score text",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Right text",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Right text",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "The component of the rigid body type",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Rigid body component",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "The enum of the rigid body type",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Rigid body type enum",
  T_40_XXJ_WS_ROW_DECS: "The row to read.",
  T_40_XXJ_WS_ROWVALUE: "Row Content",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configure the zoom scale of the object",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Scale",
  T_40_XXJ_WS_SCALE0_DESCKEY: "The zoom scale of the coordinate series in the world",
  T_40_XXJ_WS_SCALE1_DESCKEY: "The zoom scale. 1 by default.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "The scale value",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "The name of the area",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Scorebar",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Score bar",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Supports multiple scrolling directions",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Scroll direction",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "The factor of the scroll. The larger the value, the faster the scrolling.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Scroll factor",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configure the camera's cullingMask",
  T_40_XXJ_WS_SETGLOBAL: "Set Global",
  T_40_XXJ_WS_SETPARENT_D: "Only supports entities that have the Transform component",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configure the player's outfit ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modify multiple player outfits",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Set Player Direction",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configure a player's HUD switch",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configure the player's weapon skin",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Whether to display entities at the target location",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Display entity on target",
  T_40_XXJ_WS_SHOWPLAYER: "Display entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Single-player match details HUD entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "A HUD entity for single-player matches. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_SIZEDELTA: "Size delta of anchor box and component",
  T_40_XXJ_WS_SKELETON: "Skeleton",
  T_40_XXJ_WS_SKELETON_D: "The pivot used to access the skeleton mask",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Skeleton part",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Skill button HUD entity",
  T_40_XXJ_WS_SLOT_DESCKEY: "The weapon's slot",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "When selected, there will be a slow movement upon dragging. When unselected, the dragging corresponds to the speed of the mouse.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Smooth motion or not",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Softness",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Softness",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Sound entity",
  T_40_XXJ_WS_SPACE_DESCKEY: "Space",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Child cell spacing",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "The coordinates of the AI's spawnpoint",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Spawn point coordinates",
  T_40_XXJ_WS_SPEED_DESCKEY: "Speed",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Speed",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Sprint",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "The radius of the sphere",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "The color of the spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Spray color",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "The spray result",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Spray result",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "The spray gun (assault rifle)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Spray Rifle",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Initial Velocity",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Flip sticker",
  T_40_XXJ_WS_SPRITEID: "Sprite asset ID",
  T_40_XXJ_WS_SPRITEID_D: "The ID used to describe the sprite asset",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Sticker type",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "The target entity to generate into a static pixel",
  T_40_XXJ_WS_STARTPOSITION_D: "The coordinates of the shape's geometrical center",
  T_40_XXJ_WS_STAY_D: "Retain the current world position, rotation, and scaling of the child? This is generally set to true, and UI settings are ineffective for this option.",
  T_40_XXJ_WS_STRING_NAMEKEY: "String",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convert a string to a float",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convert a string to an integer",
  T_40_XXJ_WS_STYLE_DESCKEY: "The play method of the interpolation. Options include play once, loop, and play again.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Switch the player's area",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Switch value",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Switch weapons according to the player's slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Switch the item slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Item switch",
  T_40_XXJ_WS_TABLENAME_DESC: "Displayed as the table name but is actually the UID",
  T_40_XXJ_WS_TABLEVALUE: "Table content",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "The list of tags",
  T_40_XXJ_WS_TARGET_DESCKEY: "The target entity to generate map pixel. Empty by default.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entity to create map pixel",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Attack target",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "The target entity",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entity",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "The entity where the customized function is at",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "The entity that is attacked by the AI",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "The target entity to follow",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "The item entity (can be empty)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "The target entity to look at",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "The sound entity to pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "The sound entity to play after the pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "The sound entity to delete",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Teammates info",
  T_40_XXJ_WS_TELEPORTA_D: "Teleport the player to a designated spot with a set direction",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Tip text",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Notification text color",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "The text entity represents the text to be displayed",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "The text keys to display",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Text key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "The timestamp",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "The display style of a localized string",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Timestamp display style",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "The localized string for a timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc string timestamp",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Hint",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tip",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "The amount of lootable item",
  T_40_XXJ_WS_TOKENID_DESCKEY: "The ID of a lootable item",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "The tow speed of a player",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Translation type",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "The interpolation animation entity",
  T_40_XXJ_WS_TYPE_DESCKEY: 'This is the type of the description. Using "typeof" will return its type.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Rigid body type",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Different types of rigid bodies have different functions",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Only basic currencies supported in the current version",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Whether to enable minimap depth display",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Use depth map",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Whether it follows the gravitational law",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitational or not",
  T_40_XXJ_WS_UUID_DESCKEY: "The unique identifier of a player",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "The value",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Value",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Value [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "The first value",
  T_40_XXJ_WS_VALUE2_DESCKEY: "The second value",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Value [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "The starting value",
  T_40_XXJ_WS_VALUEB_DESCKEY: "The target value",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "The name of the value to traverse. You can use this to obtain the value in a local variable.",
  T_40_XXJ_WS_VALUET_DESCKEY: "The interpolation progress. Lies in between 0 and 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Variable type",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "The vertical display type",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Vertical display type",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "The level of an object's visibility",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Visible layer",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Outfits include bundle, head, mask, facepaint, top, bottom, and shoes",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Outfit type",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Outfit slot",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Weapons",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "The weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "Weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "The ID of the weapon skin",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "The player's weapon skin",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Component type enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "The width",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "Write Leaderboard Value",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Write a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XYL_WS_BUMPERFACTORY: "Bumper Car Factory",
  T_40_XYL_WS_BURNDAMAGE: "Combustion Damage",
  T_40_XYL_WS_BURNINTERVAL: "Combustion Damage Interval (s)",
  T_40_XYL_WS_BURNTIME: "Combustion Time After Explosion",
  T_40_XYL_WS_COLORFULSKY: "Colorful Sky",
  T_40_XYL_WS_CRANEMACHINE: "Claw Crane",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Maximum Crash Damage",
  T_40_XYL_WS_CRASHMAXSPEED: "Maximum Crash Damage Speed Limit",
  T_40_XYL_WS_CRASHMESS: "Mass Parameter During Crash",
  T_40_XYL_WS_CRASHMINDAMAGE: "Min. Crash Damage",
  T_40_XYL_WS_DISPLAYBOARD: "Billboard",
  T_40_XYL_WS_EXPLODEDAMAGE: "Explosion Damage",
  T_40_XYL_WS_EXPLODEDELAY: "Explosion Delay Time",
  T_40_XYL_WS_EXPLODERANGE: "Explosion Range",
  T_40_XYL_WS_FERRISWHEEL: "Ferris Wheel",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Gear Changing Time (s)",
  T_40_XYL_WS_ICAROUSEL001: "Merry-Go-Round Component A",
  T_40_XYL_WS_ICAROUSEL002: "Merry-Go-Round Component B",
  T_40_XYL_WS_ICAROUSEL003: "Merry-Go-Round",
  T_40_XYL_WS_ICEDANCEDOOL: "Blue Doll",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Uncontrolled Parking Horsepower Ratio",
  T_40_XYL_WS_LOLLIPOP: "Giant Lollipop",
  T_40_XYL_WS_NEWHOOKGUN: "Super Hook Gun",
  T_40_XYL_WS_OPENSWING: "Swing button",
  T_40_XYL_WS_OPENTRACTION: "Tow button",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "City",
  T_40_XYL_WS_SKYSCRAPER_A001: "Skyscraper A Component A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Skyscraper A Component B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Skyscraper A Component C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Skyscraper B Component A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Skyscraper B Component B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Skyscraper B Component C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Skyscraper C Component A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Skyscraper C Component B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Skyscraper C Component C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Skyscraper D Component A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Skyscraper D Component B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Skyscraper D Component C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Skyscraper E Component A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Skyscraper E Component B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Skyscraper E Component C",
  T_40_XYL_WS_STEERANGLE: "High-speed Turning Radius",
  T_40_XYL_WS_STEERSPEED: "Maximum Speed During High-speed Turning",
  T_40_XYL_WS_SWINGSPEED: "Swing speed",
  T_40_XYL_WS_TARGETOBJECT: "Motion Anchor",
  T_40_XYL_WS_TRACTIONSPEED: "Tow speed",
  T_40_XYL_WS_TRIGGERCAPSULE: "Custom Capsule Trigger",
  T_40_XYL_WS_TRIGGERSPHERE: "Custom Sphere Trigger",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Custom Object",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "An empty object component that can be used with the render component and collision component.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Custom Render Component",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "A custom rendering component, used for rendering with custom model resources.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Your enemy markings have bounty value. Anyone on ally team who eliminates a marked enemy will earn [FFB300]{0} in-match currency[-]. You will earn an extra [FFB300]100[-] for eliminating an enemy. Receive extra [FFB300]{1} FF Coins[-] from Coin Machines in BR matches.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Money Mark",
  T_41_CJ_A_ESPORTS_TH: "FFTC The Pro (Mask)",
  T_41_CJ_B_ESPORTS_TH: "FFTC The Pro (Bottom)",
  T_41_CJ_H_ESPORTS_TH: "FFTC The Pro (Head)",
  T_41_CJ_S_ESPORTS_TH: "FFTC The Pro (Shoes)",
  T_41_CJ_T_ESPORTS_TH: "FFTC The Pro (Top)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey",
  T_41_CJ_T_FOOTBALL_EU01: "Sunburst Jersey",
  T_41_CJ_T_FOOTBALL_EU02: "Bold Red Jersey",
  T_41_CJ_T_FOOTBALL_EU03: "Majestic Crown Jersey",
  T_41_CJ_T_FOOTBALL_EU04: "Regal Titan Jersey",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Item",
  T_41_R_CD_COIL: "Zone Shrink",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Whether to activate this device",
  T_41_SJ_WS_SPECIALITEM_NAME: "Device",
  T_41_SW_SKILL_DESC_DELIVERY: "When hit by an enemy from within [FFB300]{0}m[-], said attacker is marked for [FFB300]{1}s[-] (intel is shared with teammates). Max. [FFB300]{2} markings[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Get [FFB300]{0} extra Shield Points[-] at the start of the match. Recovers Shield Points after surviving combat.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "When using an active skill, gives [FFB300]{1} Shield Points[-] to self and teammates within [FFB300]{0}m[-]. The Shield Points decay after [FFB300]{2}s[-], after which players can obtain the effects again. Cooldown: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Deployed Gloo Walls restore [FFB300]{0}[-] durability per second when hit, during which teammates within [FFB300]{1}m[-] restore [FFB300]{2} HP/s[-]. Max. [FFB300]{3} HP[-] per teammate from each Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Pet Skin: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Pet Skin: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Type",
  T_41_WT_SKILL_DESC_FIREBOY: "Deploys a [FFB300]{1}m[-]-wide flaming screen that lasts [FFB300]{0}s[-] and moves forward at [FFB300]{2}m/s[-] for up to [FFB300]{3}s[-]. While in effect, use the skill again to stop the screen. [FFB300]Enemies (or Gloo Walls)[-] that get in touch with it will instantly take [FFB300]{4} (or {5}) DMG[-], and then take [FFB300]{6} (or {7}) DMG/s[-]. Lasts [FFB300]{8}s[-]. Cooldown: [FFB300]{9}s[-]. Up to [FFB300]{10}[-] skill uses can be stored, with a [FFB300]{11}s[-] cooldown between each use.",
  T_41_WT_SKILL_NAME_FIREBOY: "Flame Mirage",
  T_41_WZY_WS_CHARGEMAX: "Max. Gloo Maker charge",
  T_41_WZY_WS_CROSSBOWNAME: "Crossbow",
  T_41_WZY_WS_DECELERATIONRATIO: "Deceleration % in water",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radius of melt area",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duration of melt",
  T_41_WZY_WS_EXPPERCHIP: "EXP from Gloo Chip",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP from dealing DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP from each meter traveled",
  T_41_WZY_WS_EXPPERSECOND: "EXP per second",
  T_41_WZY_WS_GRENADEEXPTIME: "Explosion delay",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosives",
  T_41_WZY_WS_GRENADEMAX: "Maximum DMG",
  T_41_WZY_WS_GRENADEMIN: "Minimum DMG",
  T_41_WZY_WS_GRENADERANGE: "Explosion range",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "DMG coefficient on vehicles",
  T_41_WZY_WS_GRENADERATIOSELF: "DMG coefficient on self",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "DMG coefficient on teammates",
  T_41_WZY_WS_GRENADTHROWSPEED: "Explosive travel speed",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "Acceleration",
  T_41_XXJ_WS_ACCELERATION_D: "Create a designated acceleration effect",
  T_41_XXJ_WS_ACTION: "Action node",
  T_41_XXJ_WS_ACTION_D: "Action Pivot",
  T_41_XXJ_WS_ADDHP: "Healing Items",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Add max. HP",
  T_41_XXJ_WS_AICASTSKILL_D: "AI release skill",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Aim assist center offset",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Aim assist distance",
  T_41_XXJ_WS_AIMASSISTENTITY: "Aim assist entity",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entity that can be aim assisted",
  T_41_XXJ_WS_AISKILLTYPE: "Zombie skill type",
  T_41_XXJ_WS_AISKILLTYPE_D: "Zombie skill type",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "All items",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "All items",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modify magazine size",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Bullets in the magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "The anchor coordinates in relation to the parent",
  T_41_XXJ_WS_ANGLE_D: "The z axis rotation angle",
  T_41_XXJ_WS_ANGULARDRAG: "Angular drag",
  T_41_XXJ_WS_ANGULARVELOCITY: "Angular velocity",
  T_41_XXJ_WS_ANIMATIONCLIP: "Animation state",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Animation Controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Animation entity",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "The file and resource used to manage the animation controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Animation controller resource UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Loop type enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "Animation state",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operation, where all types of value assignment are supported, and digital types also support self-increment, self-subtraction, self-multiplication, and self-division",
  T_41_XXJ_WS_ATTACHMENT: "Attachment",
  T_41_XXJ_WS_ATTACHMENT_D: "Attachment",
  T_41_XXJ_WS_ATTACHTARGET: "Linked entity",
  T_41_XXJ_WS_BAG: "Backpack",
  T_41_XXJ_WS_BAG_D: "Backpack Component",
  T_41_XXJ_WS_BANNERID: "Banner ID",
  T_41_XXJ_WS_BANNERID_D: "Banner ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Behavior-mountable tree entity",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "A behavior tree entity that can be mounted",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Behavior tree custom node",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Behavior Tree Custom Pivot",
  T_41_XXJ_WS_BODY: "Body",
  T_41_XXJ_WS_BORDERLR: "Border (left & right)",
  T_41_XXJ_WS_BORDERLR_D: "The left and right border",
  T_41_XXJ_WS_BORDERTB: "Border (top & bottom)",
  T_41_XXJ_WS_BORDERTB_D: "The top and bottom border",
  T_41_XXJ_WS_BRPEAKRANK: "Highest BR rank",
  T_41_XXJ_WS_BRPEAKRANK_D: "Highest BR rank",
  T_41_XXJ_WS_BRRANK: "BR rank",
  T_41_XXJ_WS_BRRANK_D: "BR Rank",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Behavior tree node type",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Behavior Tree Pivot Type",
  T_41_XXJ_WS_BTREE: "Behavior tree",
  T_41_XXJ_WS_BTREENODESTATE: "Behavior tree node state",
  T_41_XXJ_WS_BTREENODESTATE_D: "Behavior Tree Pivot Operating Status",
  T_41_XXJ_WS_BUFFABLEENTITY: "Buff-enabled entity",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Enables adding buffs, removing buffs, and getting added buff lists",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Functional items",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Camouflage...",
  T_41_XXJ_WS_CAPICITY_D: "Initial Capacity",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible to center",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Not visible to center",
  T_41_XXJ_WS_COLOR: "Color",
  T_41_XXJ_WS_COLOR_D: "The color",
  T_41_XXJ_WS_CONDITION: "Condition node",
  T_41_XXJ_WS_CONDITION_D: "Conditions are a special Boolean type",
  T_41_XXJ_WS_CONDITION1_D: "Condition Pivot",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody constraint",
  T_41_XXJ_WS_CONSTRAIN_D: "Add constraints to the RigidBody. This is a compilation of RigidBody Constraint Type.",
  T_41_XXJ_WS_COUNT_D: "Amount",
  T_41_XXJ_WS_CROSSBOW_D: "Crossbow",
  T_41_XXJ_WS_CSPEAKRANK: "Highest CS rank",
  T_41_XXJ_WS_CSPEAKRANK_D: "Highest CS rank",
  T_41_XXJ_WS_CSRANK: "CS rank",
  T_41_XXJ_WS_CSRANK_D: "CS Rank",
  T_41_XXJ_WS_CSVNAME_D: "The csv file under SceneData that corresponds to the mode. Ends in .csv. Headers are written in lower case letters.",
  T_41_XXJ_WS_CURCAPACITY: "Used capacity",
  T_41_XXJ_WS_CURPROGRESS: "Current progress",
  T_41_XXJ_WS_CURRENTCLIP: "Current clip",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Current clip progress",
  T_41_XXJ_WS_CURRENTSTATE: "Current state",
  T_41_XXJ_WS_CUSTOMHUDID: "Custom HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "The ID used to describe a custom HUD asset",
  T_41_XXJ_WS_DASHATTACK: "Dash attack",
  T_41_XXJ_WS_DEBUG: "Start debugging",
  T_41_XXJ_WS_DEBUG_D: "Fix",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Deceleration %: The deceleration when an object is in the water (range temporarily set as 0-100)",
  T_41_XXJ_WS_DEPTH_D: "The depth",
  T_41_XXJ_WS_DRAG: "Drag coefficient",
  T_41_XXJ_WS_DRAG_D: "The larger the coefficient, the faster the movement speed deceleration",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Enable low-graphics mode",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "When low fps is on, the game will run on 15 fps; or else 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Return entity list created",
  T_41_XXJ_WS_ENTITYNAME: "Object name",
  T_41_XXJ_WS_ENTITYNAME_D: "The object name customized by the player",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Logical Entity or Prefab ID",
  T_41_XXJ_WS_EQUIPANDBAG: "Armor and Backpack",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Equipment slot enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Equipment Slot Enum",
  T_41_XXJ_WS_EXPLODE: "Self-explode",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Explosive Weapon",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Auto reload speed",
  T_41_XXJ_WS_FILEID: "Internal ID",
  T_41_XXJ_WS_FILEID_D: "The internal ID of the control in the prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Fill amount",
  T_41_XXJ_WS_FILLAMOUNT_D: "The fill value",
  T_41_XXJ_WS_FILLDIR: "Fill direction",
  T_41_XXJ_WS_FILLDIR_D: "The direction of the fill",
  T_41_XXJ_WS_FILLDIR_D1: "Fill direction enum",
  T_41_XXJ_WS_FILLTYPE: "Fill type",
  T_41_XXJ_WS_FILLTYPE_D: "The fill type",
  T_41_XXJ_WS_FILLTYPE_D1: "Fill type enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Find path",
  T_41_XXJ_WS_FINISH: "Complete",
  T_41_XXJ_WS_FIREINTERVAL: "Firing interval",
  T_41_XXJ_WS_FIREINTERVAL_D: "Attack Interval",
  T_41_XXJ_WS_FLIP: "Flip method",
  T_41_XXJ_WS_FLIP_D: "The flip method",
  T_41_XXJ_WS_FLYBOMBBEE: "Flying Zombie",
  T_41_XXJ_WS_FORCE: "Force",
  T_41_XXJ_WS_FORCE_D: "Create a force of a designated intensity",
  T_41_XXJ_WS_FORCETYPE: "Force type",
  T_41_XXJ_WS_FORCETYPE_D: "The different types of forces on the RigidBody. P.S. Only effective on dynamic RigidBody types.",
  T_41_XXJ_WS_FREEZEALL: "Freeze movement and rotation",
  T_41_XXJ_WS_FREEZEPOSITION: "Freeze linear movement",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Freeze x axis",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Freeze y axis",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Freeze z axis",
  T_41_XXJ_WS_FREEZEROTATION: "Freeze all rotation",
  T_41_XXJ_WS_FREEZEROTATIONX: "Freeze x rotation",
  T_41_XXJ_WS_FREEZEROTATIONY: "Freeze y rotation",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Freeze z rotation",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distance for max. damage",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distance for max. damage",
  T_41_XXJ_WS_GAMEID_D: "Mission ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Give a Metropolis item",
  T_41_XXJ_WS_GRADIENT: "Gradient",
  T_41_XXJ_WS_GRADIENT_D: "The gradient",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradient at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "The gradient at the bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparency at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Bottom Transparency",
  T_41_XXJ_WS_GRADIENTTOP: "Gradient at top",
  T_41_XXJ_WS_GRADIENTTOP_D: "The gradient at the top",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparency at top",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Top Transparency",
  T_41_XXJ_WS_GRAPHID: "Script ID",
  T_41_XXJ_WS_GRAPHID_D: "The ID used to describe a script asset",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Gloo Melter Component",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Explosion Delay",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Throwable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Max. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min. DMG",
  T_41_XXJ_WS_GRENADERANGE_D: "Explosion Range",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Self DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Ally DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Vehicle DMG multiplier",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Throwing Speed",
  T_41_XXJ_WS_GRENADEWEAPON: "Throwable category",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Basic Throwable Types",
  T_41_XXJ_WS_HANDCANNON_D: "Throwables",
  T_41_XXJ_WS_HEAD: "Head",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Heavy Weapon",
  T_41_XXJ_WS_HELMET_D: "The current helmet",
  T_41_XXJ_WS_HELMET1_D: "Helmet",
  T_41_XXJ_WS_HELMET2_D: "Helmet Entity",
  T_41_XXJ_WS_HITBODYPART_D: "The body part that is hit",
  T_41_XXJ_WS_HITBPDYPART: "Hit body part",
  T_41_XXJ_WS_HITENTITY_D: "Hit Entity",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "The HUD entity it belongs to",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D content container",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "The HUD 3D container entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDGRID: "Custom Layout(Panel) control",
  T_41_XXJ_WS_HUDLAYOUT: "Layout control",
  T_41_XXJ_WS_HUDLAYOUT_D: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Custom avatar control",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "The HUD profile info entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Texture control",
  T_41_XXJ_WS_HUDTEXTURE_D: "The HUD texture entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform control component",
  T_41_XXJ_WS_HUDTRANSFORM_D: "The UITransform control entity",
  T_41_XXJ_WS_IMPULSE: "Strike",
  T_41_XXJ_WS_IMPULSE_D: "Create a strike of a designated intensity",
  T_41_XXJ_WS_INITIALWORLDPOS: "Initial world coordinates",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponds to the ID column in the BuffData.csv. Before adding new content, please first check compatability with GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invert fill",
  T_41_XXJ_WS_INVERTFILL_D: "Invert the fill",
  T_41_XXJ_WS_ISLOOP: "Is loop",
  T_41_XXJ_WS_ISLOOP_D: "Whether or not to loop. Default is false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Static NavMesh generation",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Only used to check for static NavMesh generation when static loading objects",
  T_41_XXJ_WS_ISSUCCESS_D: "Destructed or not",
  T_41_XXJ_WS_ITEMENTITY_D: "Item Entity",
  T_41_XXJ_WS_ITEMID: "Item ID",
  T_41_XXJ_WS_ITEMID_D: "Item ID",
  T_41_XXJ_WS_ITEMID_D1: "The corresponding item ID of the attachment",
  T_41_XXJ_WS_ITEMLIST: "Item list",
  T_41_XXJ_WS_ITEMTYPE_D: "Item Type",
  T_41_XXJ_WS_JUMPATTACK: "Jump attack",
  T_41_XXJ_WS_LANDMINE: "Landmine",
  T_41_XXJ_WS_LENGTH: "Clip length",
  T_41_XXJ_WS_LENGTH_D: "The length of the progress bar. The default value is the length on the prefab UI.",
  T_41_XXJ_WS_LIMB: "Limbs",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Failed to add element since list length has exceeded capacity",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Buff list",
  T_41_XXJ_WS_LOOP: "Loop",
  T_41_XXJ_WS_LOOP_D: "Loop",
  T_41_XXJ_WS_MAXCAPACITY: "Capacity",
  T_41_XXJ_WS_MAXCAPACITY_D: "The backpack capacity",
  T_41_XXJ_WS_MAXPROGRESS: "Max. progress",
  T_41_XXJ_WS_MELEEWEAPON_D: "Melee Weapon",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distance for min. damage",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distance for min. damage",
  T_41_XXJ_WS_MINISENTRY: "Auto Turret",
  T_41_XXJ_WS_NAME: "Name",
  T_41_XXJ_WS_NAME_D: "The name of the skill button. Used for parameter sending during OnClick incidents, so uniqueness must be guaranteed.",
  T_41_XXJ_WS_NAME1_D: "Merchandise Name",
  T_41_XXJ_WS_NAME2_D: "Merchandise List Name",
  T_41_XXJ_WS_NAME3_D: "Vending Machine Name",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Player Name",
  T_41_XXJ_WS_NOCHANGE: "No changes",
  T_41_XXJ_WS_NONE: "No constraints",
  T_41_XXJ_WS_NONE1: "None",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "Offset",
  T_41_XXJ_WS_OFFSET1_D: "Written Offset Value",
  T_41_XXJ_WS_ONCE: "Once",
  T_41_XXJ_WS_ONCE_D: "Once",
  T_41_XXJ_WS_ONHIDE: "When interface is closed",
  T_41_XXJ_WS_ONHIDE_D: "When the interface is closed",
  T_41_XXJ_WS_ONNODEENTER_D: "When the pivot is entering",
  T_41_XXJ_WS_ONSHOW: "When interface is open",
  T_41_XXJ_WS_ONSHOW_D: "When the interface is open",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Triggers when the text box has changed",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "Pin ID",
  T_41_XXJ_WS_PINID_D: "Pin ID",
  T_41_XXJ_WS_PLAYERBAG: "Player backpack entity",
  T_41_XXJ_WS_PLAYERBAG_D: "The player's backpack entity",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Player backpack",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Player's backpack",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Modified coefficient of speed while scoped in",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impact of movement speed while firing",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impact of movement speed while firing",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "The ID used to describe a prefab asset",
  T_41_XXJ_WS_PREFABID1_D: "The HUD template entity that this ID represents",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Main Weapon 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Main Weapon 2",
  T_41_XXJ_WS_PROFILEINFO: "Player profile",
  T_41_XXJ_WS_PROFILEINFO_D: "Player bio",
  T_41_XXJ_WS_PROGRESSICON_D: "The progress icon",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Progress icon name",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Quit the Metropolis minigame",
  T_41_XXJ_WS_RANGE: "Firing range",
  T_41_XXJ_WS_RANGE_D: "Attack Range",
  T_41_XXJ_WS_RANGE_D1: "Explosion Range",
  T_41_XXJ_WS_RANGE_D2: "Turret Range",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Read the content on the entire table. Return a two-dimensional array.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Read the content of a certain cell",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Read a certain column's content. Returns an array.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Read a certain row's content. Returns an array.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Read accumulated database",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Read the value corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Continuously recover HP",
  T_41_XXJ_WS_RELOADSPEED: "Reload speed",
  T_41_XXJ_WS_RELOADSPEED_D: "Reload Speed (Basic Speed x Multiplier)",
  T_41_XXJ_WS_RESOURCEID: "Resource UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "Resource ID",
  T_41_XXJ_WS_RESUUID_D: "The designated resource UUID to render",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody constraint type",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Each constraint is defined by a bit marking and can be used as a combination",
  T_41_XXJ_WS_ROTATION: "Rotation",
  T_41_XXJ_WS_ROTATION_D: "The rotation angle in the world coordinates. x, y, z refers to the yaw, pitch, and roll, respectively.",
  T_41_XXJ_WS_ROTATION1_D: "The rotation",
  T_41_XXJ_WS_RUNNING: "Running",
  T_41_XXJ_WS_SCALE: "Scale",
  T_41_XXJ_WS_SCALE_D: "Scale",
  T_41_XXJ_WS_SCALE1_D: "Scales along a certain axis. Can be a combination of three axes.",
  T_41_XXJ_WS_SCATTERMAX: "Max. bullet scatter",
  T_41_XXJ_WS_SCATTERMAX_D: "The value at which bullet spread begins",
  T_41_XXJ_WS_SCATTERMOVE1: "Spread size when moving",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERSPEED: "Speed of spread increase",
  T_41_XXJ_WS_SCATTERSPEED_D: "Speed of spread increase (0.1 = The crosshair enlarges 10% for every one burst increase)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Less spread on prone and crouch",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Secondary Weapon",
  T_41_XXJ_WS_SHADERNAME: "Shader name",
  T_41_XXJ_WS_SHADERNAME_D: "The shader name",
  T_41_XXJ_WS_SHIELDBROKEN: "Shield-shatter attack",
  T_41_XXJ_WS_SHIELDUP: "Shield attack",
  T_41_XXJ_WS_SHOCKWAVE: "Shockwave",
  T_41_XXJ_WS_SHOWNAME: "Display nickname",
  T_41_XXJ_WS_SHOWNAME_D: "Display Nickname",
  T_41_XXJ_WS_SHOWPIN: "Display pin",
  T_41_XXJ_WS_SHOWPIN_D: "Display Pin",
  T_41_XXJ_WS_SHOWRANK: "Display rank",
  T_41_XXJ_WS_SHOWRANK_D: "Display Rank",
  T_41_XXJ_WS_SHOWTYPE: "Design",
  T_41_XXJ_WS_SHOWTYPE_D: "Type",
  T_41_XXJ_WS_SHRINKSPEED: "Shrink speed",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Enable aim assist on scope",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Aim assist crosshair sensitivity with distance (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient when prioritizing distance for aim assist (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Max. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Min. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Aim assist crosshair sensitivity (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Scope zoom in factor",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV zoom in factor",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Scope rotation sensitivity coefficient",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Modified coefficient x of min. scoped in DMG",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Scoped in firing UI zoom in time (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Scoped in firing UI zoom in factor",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Scoped in firing UI resume time (s)",
  T_41_XXJ_WS_SPEED: "Playback speed",
  T_41_XXJ_WS_SPEEQUIP: "Functional equipment",
  T_41_XXJ_WS_SPEITEM: "Devices",
  T_41_XXJ_WS_STATICGRAPHID: "Static script ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "The ID used to describe a static script asset",
  T_41_XXJ_WS_STATICWAINING: "Failed to modify static Rigidbody type",
  T_41_XXJ_WS_TARGETTREE: "Behavior tree entity",
  T_41_XXJ_WS_TARGETTREE_D: "The behavior tree entity",
  T_41_XXJ_WS_TEAMINDEX: "Team serial no.",
  T_41_XXJ_WS_TEAMINDEX_D: "The team index, which coincides with the team index in the room",
  T_41_XXJ_WS_TEAMINDEX_D1: "Team Faction Number",
  T_41_XXJ_WS_TEMPLATEPREFABID: "Template prefab ID",
  T_41_XXJ_WS_TEXT_D: "Content",
  T_41_XXJ_WS_TEXTURENAME: "Texture name",
  T_41_XXJ_WS_TEXTURENAME_D: "The texture name",
  T_41_XXJ_WS_THROWATTACK: "Grenade",
  T_41_XXJ_WS_TICKINTERVAL: "Refresh interval",
  T_41_XXJ_WS_TICKINTERVAL_D: "Refresh interval. The larger the number, the longer the refresh takes.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Enable special devices in the player's backpack",
  T_41_XXJ_WS_UVRECTWH: "UV width & height",
  T_41_XXJ_WS_UVRECTWH_D: "The UV width and height",
  T_41_XXJ_WS_UVRECTXY: "UV offset",
  T_41_XXJ_WS_UVRECTXY_D: "The UV offset",
  T_41_XXJ_WS_VELOCITY: "Velocity",
  T_41_XXJ_WS_VELOCITY_D: "Refrain from directly changing the RigidBody's speed. You may change it using related APIs.",
  T_41_XXJ_WS_VEST_D: "The current vest",
  T_41_XXJ_WS_VEST1_D: "Vest",
  T_41_XXJ_WS_WIDGETID: "Control ID",
  T_41_XXJ_WS_WIDGETID_D: "The ID used to describe a control in the interface assets. It must be paired with a custom HUD ID in order to ensure that it corresponds to a unique control ID.",
  T_41_XXJ_WS_WINDATTACK: "Tornado attack",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Write accumulated database offset",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Write the offset corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_ZONEDURATION_D: "Freeze duration",
  T_41_XXJ_WS_ZONEDURATION1_D: "Gloo Melter Duration",
  T_41_XXJ_WS_ZONERADIUS_D: "Freeze zone radius",
  T_41_XXJ_WS_ZONERADIUS1_D: "Gloo Melter Radius",
  T_41_XYL_WS_BOT12: "Earth Driller",
  T_41_XYL_WS_BOT9: "Mutated Tossing Zombie",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Frozen Container A",
  T_41_XYL_WS_ITEM264: "Frozen Supply Container",
  T_41_XYL_WS_ITEM265: "Frozen Metal Gate",
  T_41_XYL_WS_ITEM266: "Frozen Container B",
  T_41_XYL_WS_ITEM267: "Frozen Stone A",
  T_41_XYL_WS_ITEM268: "Frozen Stone B",
  T_41_XYL_WS_ITEM269: "Frozen Stone C",
  T_41_XYL_WS_ITEM270: "Frozen Stone D",
  T_41_XYL_WS_ITEM271: "Abandoned Subway Car",
  T_41_XYL_WS_MODELMATCHNAME: "Contest Canvas",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Play Cube",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (Bottom)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (Head)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (Shoes)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (Top)",
  T_42_CJ_HA_THUNDER_GOLD: "Lightning Facepaint",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bottom)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Head)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Shoes)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Top)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall - Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "Grenade - Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917 - Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "Ink",
  T_42_JH_WS_BANMATCHMAKING: "Matchmaking not allowed for this map",
  T_42_JH_WS_BANROOMCREATE: "Unable to create a room",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Party Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Wall of Flame (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Shape Splitter (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Lifeshield (Sonia)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "Infinity Racer",
  T_42_JH_WS_TAG11: "Race Rush",
  T_42_JH_WS_TAG12: "Car Racing",
  T_42_JH_WS_TAG13: "Exclude from Popular",
  T_42_JH_WS_TAG14: "Frontline",
  T_42_JH_WS_TAG15: "Zombie War",
  T_42_JH_WS_TAG16: "Legacy Legend",
  T_42_JH_WS_TAG2: "Social Island 1.0",
  T_42_JH_WS_TAG3: "Social Island 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "Preying Party",
  T_42_JH_WS_TAG7: "Preying Party",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Bounty Hunting",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Place a portal anywhere and teleport away!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Equip attachment",
  T_42_SJ_WS_AUTOPLAY: "Auto play",
  T_42_SJ_WS_CLIMB: "Climb over",
  T_42_SJ_WS_CLOCK_EVENTS: "Event compilation",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Countdown or not",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Loops",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pause event",
  T_42_SJ_WS_CLOCK_START_EVENT: "Start event",
  T_42_SJ_WS_CLOCK_START_TIME: "Countdown start time",
  T_42_SJ_WS_CLOCK_STATE: "Stopwatch status",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Stop event",
  T_42_SJ_WS_DAMRATIOHEAD: "Headshot DMG coefficient change",
  T_42_SJ_WS_DAMRATIOLIMB: "Limb DMG coefficient change",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Reduction coefficient from explosive DMG",
  T_42_SJ_WS_DRIVE: "Drive",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Display layers",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Extra backpack capacity",
  T_42_SJ_WS_EXTRAHPRATIO: "HP ratio",
  T_42_SJ_WS_GETOFF_DRIVE: "Exit vehicle",
  T_42_SJ_WS_GETON_DRIVE: "Enter vehicle",
  T_42_SJ_WS_KNIFEITEM: "Dagger",
  T_42_SJ_WS_KNIFEITEMPICK: "Dagger (ground loot)",
  T_42_SJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "You can enable or disable the pin button",
  T_42_SJ_WS_MAXDISTANCE: "Max. distance",
  T_42_SJ_WS_MAXDURARATIO: "Max. durability ratio",
  T_42_SJ_WS_MICBTNHUD: "The mic switch on the HUD",
  T_42_SJ_WS_MICBTNHUD_D: "You can enable or disable the mic button",
  T_42_SJ_WS_MINDISTANCE: "Min. distance",
  T_42_SJ_WS_OPE_VEHICLE: "Operate vehicle",
  T_42_SJ_WS_PLANE_DESC: "A basic mesh whose size can be freely adjusted",
  T_42_SJ_WS_PLANENAME: "Basic Plane",
  T_42_SJ_WS_PRIORITY: "Priority",
  T_42_SJ_WS_REPLACEPRIORITY: "Replace priority",
  T_42_SJ_WS_SETBTNHUD: "The settings button on the HUD",
  T_42_SJ_WS_SETBTNHUD_D: "You can enable or disable the settings button",
  T_42_SJ_WS_SIGNALBTNHUD: "The network connection button on the HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "You can enable or disable the network connection button",
  T_42_SJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "You can enable or disable the vehicle horn button",
  T_42_SJ_WS_START_TIME: "Start time (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Get an additional [FFB300]{0}[-] backpack capacity for ammo, excluding Grenade Launcher. ([FFB300]{1}[-] AR Ammo, [FFB300]{2}[-] SMG Ammo, [FFB300]{3}[-] Sniper Ammo, [FFB300]{4}[-] SG Ammo)",
  T_42_SW_SKILL_DESC_Bodyguard: "Reload speed increases by [FFB300]{0}%[-]. Every time the skill user hits an enemy, said target will get a [FFB300]{1}%[-] healing deduction that lasts for [FFB300]{3}s[-] (max. deduction: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Become immune from disruptive effects (e.g. slowdown, marking, skill-silencing) and have a [FFB300]{1}%[-] movement speed boost for [FFB300]{2}s[-]. Cooldown: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "After knocking down an enemy or using an active skill, [FFB300]{0}%[-] of the gun's magazine reloads automatically.",
  T_42_SW_SKILL_NAME_Playboy: "Silver Spoon",
  T_42_SY_BACKPACK_EMPIRE_N: "Backpack - Crowned Roar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Pet Skin: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motorbike - Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Amount of CS Cash obtained after losing a round",
  T_42_TYC_CST_LOSE_MONEY_2: "Amount of CS Cash obtained upon a 2-round losing streak",
  T_42_TYC_CST_LOSE_MONEY_3: "Amount of CS Cash obtained upon a 3-round losing streak",
  T_42_WH_ITEM_HEALUAV: "Heal UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "Deploys a UAV-Lite that flies forward and continuously heals teammates within the range below",
  T_42_WH_ITEM_SKILLCARD: "Skill: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Use to release the active skill of [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Ammo Type",
  T_42_XXJ_WS_AMMOTYPE_D: "Ammo Type",
  T_42_XXJ_WS_ASSETCONFIGID: "Skin ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: "Attack status",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Modifiable appearance component",
  T_42_XXJ_WS_AVATARABLE_D: "Change appearance according to the parts",
  T_42_XXJ_WS_AVATARRESUUID: "Appearance resource UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convert the axis-angle representation of a rotation into Quaternions",
  T_42_XXJ_WS_B_D: "The B color value",
  T_42_XXJ_WS_BASEVALUE_D: "Base of logarithm",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "The Bézier curve",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot Difficulty",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Combination Method of Bounciness",
  T_42_XXJ_WS_BOUNCINES: "Bounciness",
  T_42_XXJ_WS_BTREEID: "Behavior tree ID",
  T_42_XXJ_WS_BTREEID_D: "Behavior tree ID",
  T_42_XXJ_WS_CANPURCHAS: "Purchasable or Not",
  T_42_XXJ_WS_CANPURCHAS_D: "Purchasable or not",
  T_42_XXJ_WS_CLIMBSTATUS: "Climbing behavior",
  T_42_XXJ_WS_CLOCK: "Timer Object",
  T_42_XXJ_WS_CLOCK_D: "Timer Object",
  T_42_XXJ_WS_CLOCK_D1: "Timer",
  T_42_XXJ_WS_CONTAINER: "Container",
  T_42_XXJ_WS_CONTROLPOINTS: "Control points",
  T_42_XXJ_WS_CONTROLPOINTS_D: "The control points",
  T_42_XXJ_WS_COROUTINEID: "Coroutine handle",
  T_42_XXJ_WS_COROUTINEID_D: "The Coroutine ID refers to the handle of a specific coroutine. It allows for various operations to be performed on the handle.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESOUND: "Create Sound Effect",
  T_42_XXJ_WS_CREATESOUND_D: "Play the designated sound effect. If there are more properties to set, you can do so by configuring its entity properties.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Complete custom mission",
  T_42_XXJ_WS_DAMAGELIST_D: "DMG increment list",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Headshot DMG ratio",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Explosion DMG reduction multiplier",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Default Physics Material",
  T_42_XXJ_WS_DEFAULTFIST_D: "Default fist",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Logic frame interval",
  T_42_XXJ_WS_DELTATIME_D: "The interval between the 2 logic frame updates of the GS",
  T_42_XXJ_WS_DEPTH: "Layer",
  T_42_XXJ_WS_DEPTH_D: "Display layers on the icon",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "List of disabled ground loot",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "The list of items that are not ground loot",
  T_42_XXJ_WS_DRIVER: "Driver's seat",
  T_42_XXJ_WS_DRIVINGSTATUS: "Drive",
  T_42_XXJ_WS_DURATION_D1: "The countdown duration in seconds",
  T_42_XXJ_WS_DURATION_D2: "The duration in seconds",
  T_42_XXJ_WS_DURATION_D3: "The duration",
  T_42_XXJ_WS_DURATION_D4: "The duration of invulnerability in seconds",
  T_42_XXJ_WS_DURATIONTIMES: "Time Duration",
  T_42_XXJ_WS_DURATIONTIMES_D: "The duration in seconds",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Dynamic Friction",
  T_42_XXJ_WS_EASY: "Very Easy",
  T_42_XXJ_WS_ENDTIMES: "End Time",
  T_42_XXJ_WS_ENDTIMES_D: "The end time on the timer in seconds",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Global Energy Threshold",
  T_42_XXJ_WS_ENTITYVARNAME_D: "The self-relative entity",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equip attachment",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convert the given Euler angles into Quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponentiation",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Extra backpack capacity",
  T_42_XXJ_WS_FIST: "Fist",
  T_42_XXJ_WS_FONTTYPE: "Font enum",
  T_42_XXJ_WS_FONTTYPE_D: "Font enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "Force sync GS status",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "The force sync value",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "The location info. from the GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Location info from force sync",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "An entity that can formulate properties",
  T_42_XXJ_WS_FORWARD_D: "Direction vector",
  T_42_XXJ_WS_FRICTION_COMBINE: "Method of Friction Combination",
  T_42_XXJ_WS_FUNCPOINT: "Function Pointer",
  T_42_XXJ_WS_FUNCPOINT_D: "A pointer that points to an instance of a function. It is used to implement virtual functions or delegate mechanisms.",
  T_42_XXJ_WS_GETMAPID_D: "Get Map ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Exit vehicle",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Enter vehicle (driver)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Enter vehicle (passenger)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Search for today's player token data",
  T_42_XXJ_WS_GRAVITY: "Global Gravity",
  T_42_XXJ_WS_HANDHELDITEM: "Current handheld",
  T_42_XXJ_WS_HANDHELDITEM_D: "The current handheld",
  T_42_XXJ_WS_HARD: "Hard",
  T_42_XXJ_WS_HASCOMPONENT_D: "Whether there exists a component",
  T_42_XXJ_WS_HEIGHTLIST_D: "Height increment list",
  T_42_XXJ_WS_INDEXLIST_D: "Access the index list of the string",
  T_42_XXJ_WS_INSCENE: "In scene",
  T_42_XXJ_WS_INSCENE_D: "In scene",
  T_42_XXJ_WS_IS3D_D: "Whether it is a 3D music",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Countdown or stopwatch",
  T_42_XXJ_WS_ISLOOP: "Loop or not",
  T_42_XXJ_WS_ISLOOP_D: "The IsLoop command",
  T_42_XXJ_WS_ISREPLAY_D: "Whether or not to start from the beginning",
  T_42_XXJ_WS_ISSWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it can be combined with absolute motion.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Jump status",
  T_42_XXJ_WS_LEFTVALUE: "Left Value",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithm",
  T_42_XXJ_WS_LOOPABLE: "Loopable",
  T_42_XXJ_WS_LOOPABLE_D: "Loopable",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Get all keys from the dict",
  T_42_XXJ_WS_MAPVALUE_D: "Target Dict",
  T_42_XXJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "The maximum distance",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "The mic switch on the HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "The minimum distance",
  T_42_XXJ_WS_MISSIONID_D: "Mission ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progress (cannot be a negative number)",
  T_42_XXJ_WS_MODERATE: "Moderate",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Motor Bike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Movement status",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplication of two quaternions (representing rotation superposition)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Discarded",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Enable player perspective",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Enable player perspective",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Weapon Type",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Weapon Type",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioritize Player Config.",
  T_42_XXJ_WS_PARAMSARRAY: "Parameters Array",
  T_42_XXJ_WS_PARAMSARRAY_D: "Parameters Array is a list of parameters involved in output. It needs to match the number of %v in the format description.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "The list of actual parameters passed to the custom functions.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Part visibility mask 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Part visibility mask 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Part visibility mask 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Part visibility mask 4",
  T_42_XXJ_WS_PASSENGER1: "Passenger seat 1",
  T_42_XXJ_WS_PASSENGER2: "Passenger seat 2",
  T_42_XXJ_WS_PASSENGER3: "Passenger seat 3",
  T_42_XXJ_WS_PHYMAT: "Physical Material",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entity",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Self-relative motion in each frame",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Self-relative motion every frame",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Self-relative motion",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "The self-relative motion",
  T_42_XXJ_WS_PLAYER_D: "The player that needs to enter the vehicle",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entity of player behavior property sync",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "The entity of the player behavior property sync",
  T_42_XXJ_WS_PRIORITY_D: "Priority",
  T_42_XXJ_WS_PROPID_D: "The property ID",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion is a special four-dimensional vector used only to represent a rotation",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convert the given Quaternions to axis-angle representation",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convert the given Quaternions to Euler angles. If the Quaternions do not meet the standard, return (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "The number of times played. Default is 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reset",
  T_42_XXJ_WS_RIGHTVALUE: "Right Value",
  T_42_XXJ_WS_RIGHTVALUE_D: "Power",
  T_42_XXJ_WS_SEATTYPE: "Vehicle seat enum",
  T_42_XXJ_WS_SEPSTR_D: "String used for separation",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Set player fall DMG",
  T_42_XXJ_WS_SETTINGSBTNHUD: "The settings button on the HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Show Location",
  T_42_XXJ_WS_SHOWPOSITION_D: "Show Location",
  T_42_XXJ_WS_SIGNALICOHUD: "The network connection button on the HUD",
  T_42_XXJ_WS_SIMPLE: "Easy",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Spherical quaternion interpolation from A to B",
  T_42_XXJ_WS_SOUNDENTITY_D: "The sound effect entity represents a sound effect that is being played",
  T_42_XXJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Use a certain string as a delimiter to split the string into a slice",
  T_42_XXJ_WS_SPORTSCAR: "Sports Car",
  T_42_XXJ_WS_SPRINTSTATUS: "Sprint status",
  T_42_XXJ_WS_SRCVAL_D: "The source value",
  T_42_XXJ_WS_STARTTICKCOUNT: "The moment when the GS starts to tick",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "The moment when GS starts to tick",
  T_42_XXJ_WS_STARTTIME_D: "Time of start",
  T_42_XXJ_WS_STARTTIME_D1: "Time of start",
  T_42_XXJ_WS_STATE_D: "A player's status: active, knocked down, or eliminated",
  T_42_XXJ_WS_STATE_D1: "Check whether this sound effect is playing",
  T_42_XXJ_WS_STATIC_FRICTION: "Static Friction",
  T_42_XXJ_WS_STRELEMS_D: "Target string set",
  T_42_XXJ_WS_STRINGFINDAT_D: "Return the final combined string according to the index list",
  T_42_XXJ_WS_STRINGJOIN_D: "Join strings using a specified identifier",
  T_42_XXJ_WS_STRINGLOWER_D: "Convert all characters in the string to lowercase",
  T_42_XXJ_WS_STRINGSTRIP_D: "Remove whitespace characters from both sides of the string",
  T_42_XXJ_WS_STRINGUPPER_D: "Convert all characters in the string to uppercase",
  T_42_XXJ_WS_STYLE_D: "How it is played",
  T_42_XXJ_WS_SUV: "Pickup Truck",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it must be combined with absolute motion, otherwise the properties won't take effect correctly.",
  T_42_XXJ_WS_TARGETENTITY_D: "The target entity",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Team Round Score Banner",
  T_42_XXJ_WS_TEAMSEQ_D: "The team serial number that corresponds to the serial number property of the team entity",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Temporary shield points",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Temporary shield points",
  T_42_XXJ_WS_TEXT_D: "The original text to perform a profanity filter on",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Status Switch",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dagger (ground loot)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dagger",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Teams Match Details",
  T_42_XXJ_WS_UNIQUEID: "Unique ID",
  T_42_XXJ_WS_UNIQUEID_D: "Unique ID",
  T_42_XXJ_WS_VALUE_D: "The value",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Direction vector to Euler angles",
  T_42_XXJ_WS_VEHICLEID: "Vehicle ID",
  T_42_XXJ_WS_VEHICLESKINID: "Vehicle skin ID",
  T_42_XXJ_WS_VERYHARD: "Very Hard",
  T_42_XXJ_WS_VOLUME_D: "The sound volume. Default is 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Weapon's Main Type",
  T_42_XXJ_WS_WORKSHOPCODE: "Map code",
  T_42_XXJ_WS_WORKSHOPCODE_D: "The map code that corresponds to a data in the database",
  T_42_XXJ_WS_WORLDPOSITION: "World coordinates",
  T_42_XXJ_WS_WORLDPOSITION_D: "World coordinates",
  T_42_XYL_WS_ITEM275: "Fuel Tank",
  T_42_XYL_WS_ITEM276: "Sand Bag A",
  T_42_XYL_WS_ITEM277: "Sand Bag B",
  T_42_XYL_WS_ITEM278: "Sand Bag C",
  T_42_XYL_WS_ITEM279: "Sand Bag",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "Arms Factory",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "Stone Wall B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "Military Supply Box A",
  T_42_XYL_WS_ITEM287: "Copper Coin",
  T_42_XYL_WS_ITEM288: "Silver Coin",
  T_42_XYL_WS_ITEM289: "Gold Coin",
  T_42_XYL_WS_ITEM290: "Diamond",
  T_42_XYL_WS_ITEM291: "Diamond Shards",
  T_42_XYL_WS_ITEM292: "Ruby",
  T_42_XYL_WS_ITEM293: "Emerald",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Warning Sign",
  T_42_XYL_WS_ITEM297: "Ruin",
  T_42_XYL_WS_ITEM297TRUE: "Control Device",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "High-Tech Wall A",
  T_42_XYL_WS_ITEM301: "High-Tech Wall B",
  T_42_XYL_WS_ITEM302: "Frozen Stone F",
  T_42_XYL_WS_ITEM303: "Frozen Stone E",
  T_42_XYL_WS_ITEM304: "High-Tech Platform A",
  T_42_XYL_WS_ITEM305: "High-Tech Staircase A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "Logic",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuristic",
  T_42_XYL_WS_THEMEICE: "Icy",
  T_42_XYL_WS_THEMEMILITARY: "Military",
  T_42_XYL_WS_THEMEOBJECTS: "Themed Object",
  T_42_XYL_WS_TIMERCONTINUE: "Timer Resuming Incident",
  T_42_XYL_WS_TIMERCYCLE: "Loop Count",
  T_42_XYL_WS_TIMERDOWN: "Countdown",
  T_42_XYL_WS_TIMEREND: "Timer ending incident",
  T_42_XYL_WS_TIMEREVENT: "Customized Timer Incident",
  T_42_XYL_WS_TIMEREVENT1: "Control Timer",
  T_42_XYL_WS_TIMEREVENT2: "Set Timer Incidents",
  T_42_XYL_WS_TIMERORDER: "Timing Method",
  T_42_XYL_WS_TIMERPAUSE: "Timer Pausing Incident",
  T_42_XYL_WS_TIMERSTART1: "Timer Start Time",
  T_42_XYL_WS_TIMERSTART2: "Timer Starting Incident",
  T_42_XYL_WS_TIMERUP: "Count Up",
  T_42_XYL_WS_TRIGGERTIME_MS: "Trigger Time (in milliseconds)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "A skywing that can hold multiple players.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Individual Score",
  T_42_ZZ_GUILDWAR_SCORE: "Score",
  T_43_B_SKILL_DESC_MONKEYGOD: "Transforms into a bush for [FFB300]{1}s[-] . Cooldown: [FFB300]{0}s[-]. Attacking others or being attacked will return Wukong to his original state. CD resets when taking down an enemy.",
  T_43_B_SKILL_DESC_Nanoscientist: "After taking fatal damage, enter an invulnerable and immobile state for [FFB300]{0}s[-]. Then, gain a [FFB300]{1} HP shield[-] that lasts for [FFB300]{2}s[-]. The skill user will be eliminated when the shield disappears. Cooldown: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Replaces EP with [FFB300]{0} Crimson Energy[-]. Consumes [FFB300]{1} Crimson Energy[-] to activate its protection, during which you cannot take damage or attack enemies and will absorb [FFB300]{4} HP[-] (ignoring enemy Shield Points) from foes within [FFB300]{3}m[-]. Lasts for [FFB300]{2}s[-], during which your movement speed will decrease by [FFB300]{6}%[-]. Cooldown: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Velocity Racer (Mask)",
  T_43_CJ_F_B_RACER: "Velocity Racer (Bottom)",
  T_43_CJ_F_H_RACER: "Velocity Racer (Head)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (Facepaint)",
  T_43_CJ_F_S_RACER: "Velocity Racer (Shoes)",
  T_43_CJ_F_T_RACER: "Velocity Racer (Top)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Mask)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (Bottom)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bottom)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (Head)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Head)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (Facepaint)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (Shoes)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Shoes)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (Top)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Top)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "Other",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Beach",
  T_43_HJ_WS_TEXTURE_BRICK1: "Brick Wall A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Brick Wall B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Brick Wall C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Concrete Floor",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concrete",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Crystal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grass A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grass B",
  T_43_HJ_WS_TEXTURE_ICE: "Ice Block",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Floor",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Marble Floor",
  T_43_HJ_WS_TEXTURE_NONE: "Empty",
  T_43_HJ_WS_TEXTURE_STONE: "Stone",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Tablecloth A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Tablecloth B",
  T_43_HJ_WS_TEXTURE_WOOD: "Wood",
  T_43_HJ_WS_TEXTURE_WOODEN: "Wooden Floor A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Wooden Floor B",
  T_43_JH_WS_MAPTAG1: "Newbie-Friendly",
  T_43_JH_WS_MAPTAG10: "Boring new content",
  T_43_JH_WS_MAPTAG11: "Little sense of reward",
  T_43_JH_WS_MAPTAG12: "Reward imbalance",
  T_43_JH_WS_MAPTAG13: "Weak sense of progress",
  T_43_JH_WS_MAPTAG14: "Newbie-Unfriendly",
  T_43_JH_WS_MAPTAG15: "Confusing tutorial",
  T_43_JH_WS_MAPTAG16: "Lack of tutorials",
  T_43_JH_WS_MAPTAG17: "Players quit a lot",
  T_43_JH_WS_MAPTAG18: "Complicated controls",
  T_43_JH_WS_MAPTAG19: "Cluttered UI",
  T_43_JH_WS_MAPTAG2: "Preferred new content",
  T_43_JH_WS_MAPTAG20: "Poor map design",
  T_43_JH_WS_MAPTAG21: "Thrilling Shooter",
  T_43_JH_WS_MAPTAG22: "Fast-paced",
  T_43_JH_WS_MAPTAG23: "Open World",
  T_43_JH_WS_MAPTAG24: "Story-rich",
  T_43_JH_WS_MAPTAG25: "Progression",
  T_43_JH_WS_MAPTAG26: "Sports Simulation",
  T_43_JH_WS_MAPTAG27: "Co-op Mission",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Diverse Instances",
  T_43_JH_WS_MAPTAG3: "Active players",
  T_43_JH_WS_MAPTAG30: "Free Exploration",
  T_43_JH_WS_MAPTAG31: "Ranking Challenge",
  T_43_JH_WS_MAPTAG32: "Achievement",
  T_43_JH_WS_MAPTAG33: "Currency Redeem",
  T_43_JH_WS_MAPTAG4: "Well-Designed Map",
  T_43_JH_WS_MAPTAG40: "Numerous rewards",
  T_43_JH_WS_MAPTAG41: "Satisfying progression",
  T_43_JH_WS_MAPTAG42: "Popular Training Grounds",
  T_43_JH_WS_MAPTAG43: "Popular Solo Tower",
  T_43_JH_WS_MAPTAG44: "Popular War Zone",
  T_43_JH_WS_MAPTAG5: "Stuttering",
  T_43_JH_WS_MAPTAG6: "Hard co-op",
  T_43_JH_WS_MAPTAG7: "Buggy",
  T_43_JH_WS_MAPTAG8: "Few updates",
  T_43_JH_WS_MAPTAG9: "Boring in-match events",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Spider Trap (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Drop Items",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Start Drop Time",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Drop Items",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Is Auto-Play",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Is Center Position",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Animation Clip ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Is Loop",
  T_43_SJ_WS_ANITRIGGER_NAME: "Animation Trigger HUD",
  T_43_SJ_WS_RESET_ROUND: "Reset per Round",
  T_43_SJ_WS_START_DROPTIME: "Start Drop Time (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Animation Trigger",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Pet Skin: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motorbike - Incarnational Speed",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contains essential battle supplies such as ammo and medical items",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Supply Box",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Spawn a [FFB300]{1} HP[-] mannequin that autonomously travels for [FFB300]{0}s[-]. When the mannequin is within [FFB300]{3}m[-], use the skill again to switch positions with it. You can only switch once within [FFB300]{4}s[-], up to [FFB300]{2} time(s)[-] in total. The player who destroys the mannequin will be marked for [FFB300]{5}s[-]. Cooldown: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Active Skill",
  T_43_XXJ_WS_AIRDROP: "Airdrop and Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "The overall transparency of the HUD, with a range from 0 to 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Animation Controller ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "The ID used to describe an animation controller asset",
  T_43_XXJ_WS_AUDIOID: "Audio ID",
  T_43_XXJ_WS_AUDIOID_D: "The ID used to describe an audio asset",
  T_43_XXJ_WS_BACKGRCOLOR: "Background Color",
  T_43_XXJ_WS_BACKGRCOLOR_D: "The color of the health bar boarder and the blurred background",
  T_43_XXJ_WS_BURNING: "Burning",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "The ID used to describe a configuration table asset",
  T_43_XXJ_WS_CURRENTHP: "Current HP",
  T_43_XXJ_WS_CURRENTHP_D: "Current HP value",
  T_43_XXJ_WS_DAMAGEMAKER_D: "The game entity that deals damage",
  T_43_XXJ_WS_DAMAGEZONE: "Damage Zone",
  T_43_XXJ_WS_DEFAULT: "Default",
  T_43_XXJ_WS_DEFAULT_D: "Default",
  T_43_XXJ_WS_EFFECTID: "Effect ID",
  T_43_XXJ_WS_EFFECTID_D: "The ID used to describe a special effect asset",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "An entity that can fight (e.g. launch attacks, be attacked, or get eliminated)",
  T_43_XXJ_WS_FOLLOWTARGET: "Follow Target",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Must follow an entity with a Transform component",
  T_43_XXJ_WS_GAINHPCOLOR: "Gain HP Color",
  T_43_XXJ_WS_GAINHPCOLOR_D: "The increased portion of HP will show in this color for a short time",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Is No Fall Damage",
  T_43_XXJ_WS_ISOPENTWEEN: "Is Open Tween",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Enable this to show HP changes in different colors",
  T_43_XXJ_WS_KNOCKDOWN_D1: "The player is in the knockdown state",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Settings for the response to the knockdown state when eliminated",
  T_43_XXJ_WS_KNOCKDOWN_D3: "The revival source type. A player can be revived while  knocked down.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Knockdown State",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Knockdown State Type",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "The response to the knockdown state: maintain default logic, skip the knockdown state, or force into knockdown.",
  T_43_XXJ_WS_LEVEL: "Level",
  T_43_XXJ_WS_LEVEL_D: "Level",
  T_43_XXJ_WS_LEVEL_D1: "The current zombie level",
  T_43_XXJ_WS_LINESPACING: "Line Spacing",
  T_43_XXJ_WS_LINESPACING_D: "Does not display when the segmented HP between two dividers ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Lose HP Color",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "The reduced portion of HP will show in this color for a short time",
  T_43_XXJ_WS_MAINCOLOR: "Main Color",
  T_43_XXJ_WS_MAINCOLOR_D: "The color for HP, levels, and outlines",
  T_43_XXJ_WS_MINISENTRY: "Turret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "The enum for the types of targets a turret can attack",
  T_43_XXJ_WS_MISSILEEXPLODE: "Missile Explode",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Must Knockdown",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Forced knockdown",
  T_43_XXJ_WS_OFFSET: "Offset",
  T_43_XXJ_WS_OFFSET_D: "Offset relative to the target followed",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Oil Drum Explode",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Only triggered when the controller initiates movement",
  T_43_XXJ_WS_PLAYER_D: "The in-game player entity. Each player has one.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Player Head HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "The information displayed above the player's head",
  T_43_XXJ_WS_PLAYERNAME: "Player Name",
  T_43_XXJ_WS_PLAYERNAME_D: "Displays the name of the current health bar owner",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Player or Vehicle",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "The alias for the player/vehicle entity type",
  T_43_XXJ_WS_SCALE: "Scale",
  T_43_XXJ_WS_SCALE_D: "Determines the overall HUD scale size, with the font scaled to match.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Show Damage Number",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "True by default. Displays damage number.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Skip Knockdown",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Skip the knockdown state and get eliminated instantly",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Is Skip Stagger Animation",
  T_43_XXJ_WS_TEAM_D: "(Deprecated. Please use Team ID.)",
  T_43_XXJ_WS_TERRAIN: "Terrain",
  T_43_XXJ_WS_TERRAIN_D: "A terrain component of which attributes cannot be modified. Used to test functions only.",
  T_43_XXJ_WS_TOTALHP: "Total HP",
  T_43_XXJ_WS_TOTALHP_D: "Total HP value",
  T_43_XXJ_WS_TWEENENTITY: "Tween Entity",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Vehicle Explode",
  T_43_XXJ_WS_WIDTH: "Width",
  T_43_XXJ_WS_WIDTH_D: "The width of the displayed health bar",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Fist (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Japanese-Style",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Customize match event logs. Used for user experience analysis.",
  T_43_YU_WS_AIRDROPSTATE: "Airdrop State",
  T_43_YU_WS_AIRDROPSTATE_D: "Airdrop state (1: ready, 2: dropping, 3: landed)",
  T_43_YU_WS_ANIMATIONCLIPID: "Animation Clip ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Customize animation clip ID",
  T_43_YU_WS_ASKBUYTARGET: "Ask Buy Target",
  T_43_YU_WS_ASKBUYTARGET_D: "Specifies the target and sends purchase request",
  T_43_YU_WS_ASKEDLIST: "Asked List",
  T_43_YU_WS_ASKEDLIST_D: "The list of requested items",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Background Color 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "The upper background color",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Background Color 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "The bottom background color",
  T_43_YU_WS_BATCHCOMBINERENDER: "Batch Combine Render",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Bind Money Entity List",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "The list of bound currency entities",
  T_43_YU_WS_BINDWALLETENTITYID: "Bind Wallet Entity ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "The ID of the bound wallet entity",
  T_43_YU_WS_CENTEROFFSET: "Center Offset",
  T_43_YU_WS_CENTEROFFSET_D: "The offset value for the capsule collider",
  T_43_YU_WS_COLLECTIONID: "Collection ID",
  T_43_YU_WS_COLLECTIONID_D: "The Collection ID used for asset information collection",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Create an airdrop",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Create a damage number",
  T_43_YU_WS_CROSSPLATFORM_D: "When selected, send to the client if called on the server and vice versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS Round Result HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Results displayed at the end of each round",
  T_43_YU_WS_CURRENTEMOTECLIP: "Current Emote Clip",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID of the current emote clip",
  T_43_YU_WS_DAMAGE_D: "The out-of-zone damage",
  T_43_YU_WS_DICTIONARY: "Dictionary",
  T_43_YU_WS_DIRECTIONRULERHUD: "Direction Ruler HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "The compass on the top",
  T_43_YU_WS_DOTWEEN_D: "Whether to perform tween animations",
  T_43_YU_WS_DROPITEMS_D: "Items in the airdrop",
  T_43_YU_WS_DURATION: "Duration",
  T_43_YU_WS_ENERGY: "Energy",
  T_43_YU_WS_ENERGY_D: "EP modification value",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Prone",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Crouch",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Sprinting",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Stand",
  T_43_YU_WS_EVENTID: "Event ID",
  T_43_YU_WS_EVENTID_D: "Represents an event",
  T_43_YU_WS_FACTION: "Faction",
  T_43_YU_WS_FACTION_D: "The faction entity",
  T_43_YU_WS_FACTION_D1: "Ask the faction for help with purchase",
  T_43_YU_WS_FINALRADIUS_D: "The final radius of the safe zone",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Med Kit",
  T_43_YU_WS_FIRSTPERSONMODEL: "First Person Model",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "The first-person camera",
  T_43_YU_WS_FONTCOLOR_D: "The font color",
  T_43_YU_WS_FONTSIZE_D: "The font size",
  T_43_YU_WS_FORBIDEN: "Forbidden",
  T_43_YU_WS_FORBIDEN_D: "Disable the HUD for purchase request",
  T_43_YU_WS_FREEZINGTIME: "Freezing Time",
  T_43_YU_WS_FREEZINGTIME_D: "The duration for which the hit target stays frozen",
  T_43_YU_WS_GRAVITY: "Gravity",
  T_43_YU_WS_GRAVITY_D: "The gravitational acceleration. Only affects the player controller.",
  T_43_YU_WS_HANDCATAPULT: "Launch Pad",
  T_43_YU_WS_HANDCATAPULT_D: "Launch Pad",
  T_43_YU_WS_HEALTH: "Health",
  T_43_YU_WS_HEALTH_D: "The recovery value of armor durability",
  T_43_YU_WS_HEIGHT: "Height",
  T_43_YU_WS_HELPEDPLAYER_D: "The player who is helped",
  T_43_YU_WS_HELPPLAYER_D: "The player who helps with the purchase",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Horizontal Max. Angle",
  T_43_YU_WS_HORIZONTALMINANGLE: "Horizontal Min Angle",
  T_43_YU_WS_HUDTOGGLE: "HUD Toggle",
  T_43_YU_WS_HUDTOGGLE_D: "The HudToggle entity that players can edit in the HUD editor",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "The initial radius of the safe zone",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "A 64-bit signed integer",
  T_43_YU_WS_ISAPPLYSHADOW: "Is Apply Shadow",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Is Current Emote Loop",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Whether to set the current Emote animation to loop",
  T_43_YU_WS_ISSIDECOLLIDING: "Is Side Colliding",
  T_43_YU_WS_ISSLIDING: "Is Sliding",
  T_43_YU_WS_ISTOPCOLLIDING: "Is Top Colliding",
  T_43_YU_WS_ITEM331: "Futuristic Device A",
  T_43_YU_WS_ITEM332: "Glowing Rock A",
  T_43_YU_WS_ITEM333: "Futuristic Screen A",
  T_43_YU_WS_ITEM334: "Futuristic Container A",
  T_43_YU_WS_ITEM335: "Futuristic Container A",
  T_43_YU_WS_ITEM336: "Stone Sofa A",
  T_43_YU_WS_ITEM337: "Futuristic Switch A",
  T_43_YU_WS_ITEM338: "Futuristic Pipe A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Futuristic Table A",
  T_43_YU_WS_ITEM341: "Futuristic Table B",
  T_43_YU_WS_ITEM342: "Futuristic Table C",
  T_43_YU_WS_ITEM343: "Futuristic Computer A",
  T_43_YU_WS_ITEM344: "Stone A",
  T_43_YU_WS_ITEM345: "Stone B",
  T_43_YU_WS_ITEM346: "Stone C",
  T_43_YU_WS_ITEM347: "Stone D",
  T_43_YU_WS_ITEM348: "Stone E",
  T_43_YU_WS_ITEM349: "Stone F",
  T_43_YU_WS_ITEM350: "Stone G",
  T_43_YU_WS_ITEM351: "Japanese-Style Curtain A",
  T_43_YU_WS_ITEM352: "Japanese-Style Curtain B",
  T_43_YU_WS_ITEM353: "Japanese-Style Curtain C",
  T_43_YU_WS_ITEM354: "Japanese-Style Stairs A",
  T_43_YU_WS_ITEM355: "Japanese-Style Fence A",
  T_43_YU_WS_ITEM356: "Japanese-Style Fence B",
  T_43_YU_WS_ITEM357: "Japanese-Style Fence C",
  T_43_YU_WS_ITEM358: "Japanese-Style Platform A",
  T_43_YU_WS_ITEM359: "Japanese-Style Wall B",
  T_43_YU_WS_ITEM360: "Japanese-Style Gate B",
  T_43_YU_WS_ITEM361: "Futuristic Wall D",
  T_43_YU_WS_ITEM362: "Futuristic Wall B",
  T_43_YU_WS_ITEM363: "Futuristic Angled Baseboard",
  T_43_YU_WS_LEFTCOLOR: "Left Color",
  T_43_YU_WS_LEFTCOLOR_D: "The left side color",
  T_43_YU_WS_LEFTPLAYERARRAY: "Left Player Array",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "The left player array",
  T_43_YU_WS_LEFTSCORE: "Left Score",
  T_43_YU_WS_LEFTSCORE_D: "The left side score",
  T_43_YU_WS_LEFTSCOREAFTER: "Left Score After",
  T_43_YU_WS_LEFTSCOREAFTER_D: "The final score of the left side. Used in score transition animations.",
  T_43_YU_WS_LEVELOBJECTID: "Level Object ID",
  T_43_YU_WS_LEVELOBJECTID_D: "Describes the object type. Requires parsing through the SceneEditPrefab configuration table before loading.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordinates in the local coordinate system",
  T_43_YU_WS_LOCALPOSITION_D1: "The relative position",
  T_43_YU_WS_LOCALPOSITION_D2: "The position relative to the bottom right anchor",
  T_43_YU_WS_LOCALPOSITION_D3: "The position relative to the anchor",
  T_43_YU_WS_LOCALROTATION_D: "Rotation angles in the local coordinate system (X: yaw, Y: pitch, and Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "The quaternion in the local coordinate system",
  T_43_YU_WS_LOCALSCALE_D: "The scale size in the world coordinate system",
  T_43_YU_WS_MASS: "Mass",
  T_43_YU_WS_MATERIALS: "Materials",
  T_43_YU_WS_MATERIALS_D: "The list of materials used for rendering",
  T_43_YU_WS_MAXSPEED: "Max. Speed",
  T_43_YU_WS_MAXSPEED_D: "No more horsepower will be generated after the max speed is reached, but the vehicle speed may go over the limit (e.g. through acceleration when going down a hill).",
  T_43_YU_WS_MESHID: "Mesh ID",
  T_43_YU_WS_MESHID_D: "Describes the mesh type",
  T_43_YU_WS_MESHID1: "Mesh ID",
  T_43_YU_WS_MESHID1_D: "The mesh to be used for rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "Min. Move Distance",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movement with a distance shorter than this value will not be executed. It is recommended to set it to 0 unless there are special requirements.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animation",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Base Attributes",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Behavior Tree",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Camera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Chat Channel",
  T_43_YU_WS_MODULE_CHECKPOINT: "Checkpoint",
  T_43_YU_WS_MODULE_COLLECTION: "Collection",
  T_43_YU_WS_MODULE_COMBAT: "Combat",
  T_43_YU_WS_MODULE_COMPONENT: "Component",
  T_43_YU_WS_MODULE_CONVERT: "Convert",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Customize Room Parameters",
  T_43_YU_WS_MODULE_DATABASE: "Data Storage",
  T_43_YU_WS_MODULE_DYEING: "Dyeing",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dynamic NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Economy",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF Platform",
  T_43_YU_WS_MODULE_FOOTBALL: "Football",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Frame Rate Mode",
  T_43_YU_WS_MODULE_GAMERESULT: "Game Results",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Global Scripts",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Cheating",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Input System",
  T_43_YU_WS_MODULE_ITEMS: "Items",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Level Object",
  T_43_YU_WS_MODULE_LIST: "List",
  T_43_YU_WS_MODULE_MAP: "Map",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Mechanism Parameters",
  T_43_YU_WS_MODULE_MINIMAP: "Minimap",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Other",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Physics",
  T_43_YU_WS_MODULE_PLAYABLE: "Playable",
  T_43_YU_WS_MODULE_PLAYER: "Player",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Player Scripts",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Preset Character",
  T_43_YU_WS_MODULE_PROFILE: "Profile",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Property Formula",
  T_43_YU_WS_MODULE_SAFEZONE: "Safe Zone",
  T_43_YU_WS_MODULE_SCENE: "Scene",
  T_43_YU_WS_MODULE_SKILL: "Skill",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Static Scripts",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Report",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Library",
  T_43_YU_WS_MODULE_STRINGS: "Strings",
  T_43_YU_WS_MODULE_TEAM: "Team",
  T_43_YU_WS_MODULE_WORKFLOW: "Workflow",
  T_43_YU_WS_MONEYICON: "Money Icon",
  T_43_YU_WS_MONEYICON_D: "The currency icon",
  T_43_YU_WS_MONEYICONCOLOR: "Money Icon Color",
  T_43_YU_WS_MONEYICONCOLOR_D: "The currency icon color",
  T_43_YU_WS_MOVESAFEZONE_D: "Smoothly moves the safe zone from its start position to the end position. Players outside the zone will take a certain amount of damage.",
  T_43_YU_WS_NEWVECTOR2: "New Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Gets a new 2D vector",
  T_43_YU_WS_OFFSET_D: "The world position offset relative to the target entity",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "When the player purchase request is met",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "When a player requests for help with purchase in the store",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Trigger when the Toggle component state changes",
  T_43_YU_WS_OPENSTATE: "Open State",
  T_43_YU_WS_OPENSTATE_D: "Displays when set to true and hides if not",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "The list of parameters",
  T_43_YU_WS_PARENT_D: "The entity ID recorded during serialization",
  T_43_YU_WS_PHYSICALCCT: "Physical CCT",
  T_43_YU_WS_PHYSICALCCT_D: "The player controller with physical effects",
  T_43_YU_WS_PLAYER_D: "The purchasing player",
  T_43_YU_WS_PLAYERDATAID: "Player Data ID",
  T_43_YU_WS_PLAYERDATAID_D: "Customize character asset ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Player PhysX Pose Type",
  T_43_YU_WS_POSITION: "Position",
  T_43_YU_WS_POSITION_D: "Coordinates in the world coordinate system",
  T_43_YU_WS_POSITION_D1: "Coordinates in the world coordinate system. Only effective for 3D music.",
  T_43_YU_WS_PRESSEDSPRITE: "Pressed Sprite",
  T_43_YU_WS_PRESSEDSPRITE_D: "The pressed sprite",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Pressed Sprite Type",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "The pressed sprite type",
  T_43_YU_WS_PRETIME: "Pretime",
  T_43_YU_WS_RADIUS: "Radius",
  T_43_YU_WS_RANDOMRANGE_D: "Correct the set position based on a random range",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Request Purchase Type",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Purchase request in the store",
  T_43_YU_WS_REQUESTTYPE: "Request Type",
  T_43_YU_WS_REQUESTTYPE_D: "The type of the target requested by the current HUD player",
  T_43_YU_WS_RESPLAYERUUID: "Preset Player Type",
  T_43_YU_WS_RESPLAYERUUID_D: "The player asset ID",
  T_43_YU_WS_RESUUID: "Asset UUID",
  T_43_YU_WS_RESUUID_D: "Specifies the UUID of the Batch asset to be rendered",
  T_43_YU_WS_RIGHTCOLOR: "Right Color",
  T_43_YU_WS_RIGHTCOLOR_D: "The right side color",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Right Player Array",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "The right player array",
  T_43_YU_WS_RIGHTSCORE: "Right Score",
  T_43_YU_WS_RIGHTSCORE_D: "The right side score",
  T_43_YU_WS_RIGHTSCOREAFTER: "Right Score After",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "The final score of the right side. Used in score transition animations.",
  T_43_YU_WS_ROTATIONQ_D: "The quaternion in the world coordinate system",
  T_43_YU_WS_ROUNDINFOHUD: "Round Info HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Information displayed at the start of a round",
  T_43_YU_WS_SELECTEDCOLOR: "Selected Color",
  T_43_YU_WS_SELECTEDCOLOR_D: "The selected sprite color",
  T_43_YU_WS_SELECTEDSPRITE: "Selected Sprite",
  T_43_YU_WS_SELECTEDSPRITE_D: "The selected sprite",
  T_43_YU_WS_SELECTEDTYPE: "Selected Type",
  T_43_YU_WS_SELECTEDTYPE_D: "The selected sprite type",
  T_43_YU_WS_SHADOWCOLOR: "Shadow Color",
  T_43_YU_WS_SHADOWOFFSET: "Shadow Offset",
  T_43_YU_WS_SHOWTAG: "Show Tag",
  T_43_YU_WS_SHOWTAG_D: "Show team/faction markings",
  T_43_YU_WS_SHRINKDURATION_D: "The shrinking duration of the safe zone",
  T_43_YU_WS_SIMPLERENDER_D: "The bridging rendering component used for rendering with built-in models",
  T_43_YU_WS_SKINWIDTH: "Skin Width",
  T_43_YU_WS_SKINWIDTH_D: "The depth of penetration into the capsule to prevent the character from getting stuck or jittering",
  T_43_YU_WS_SLOPELIMIT: "Slope Limit",
  T_43_YU_WS_SLOPELIMIT_D: "Objects placed on the slope exceeding this angle will slide down",
  T_43_YU_WS_SPEED: "Speed",
  T_43_YU_WS_STARTDROPTIME_D: "The airdrop arrival time in milliseconds",
  T_43_YU_WS_STARTPOS_D: "The start position of the safe zone",
  T_43_YU_WS_STATICICONCOLORS: "Static Icon Colors",
  T_43_YU_WS_STATICICONCOLORS_D: "Icon colors shown on the ruler",
  T_43_YU_WS_STATICICONS: "Static Icons",
  T_43_YU_WS_STATICICONS_D: "The icons shown on rulers",
  T_43_YU_WS_STEPOFFSET: "Step Offset",
  T_43_YU_WS_STEPOFFSET_D: "Only obstacles exceeding this height will have a blocking effect",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "The subtitle",
  T_43_YU_WS_TARGET: "Target",
  T_43_YU_WS_TARGET_D: "The target entity for the displayed damage number",
  T_43_YU_WS_TARGETICONCOLORS: "Target Icon Colors",
  T_43_YU_WS_TARGETICONCOLORS_D: "Colors of the icon shown by the marked target",
  T_43_YU_WS_TARGETICONS: "Target Icons",
  T_43_YU_WS_TARGETICONS_D: "The icons shown by the marked targets",
  T_43_YU_WS_TARGETPOS_D: "The target end position of the safe zone",
  T_43_YU_WS_TEAM: "Team",
  T_43_YU_WS_TEAM_D: "The team entity in the game. Each team has one entity.",
  T_43_YU_WS_TEAM_D1: "Ask the team for help with purchase",
  T_43_YU_WS_TIMEOFSTAY_D: "The display duration in milliseconds",
  T_43_YU_WS_TITLE: "Title",
  T_43_YU_WS_TITLE_D: "The main title",
  T_43_YU_WS_TRANSFORM_D: "Rotation, scaling, and parent-child record",
  T_43_YU_WS_UNSELECTEDCOLOR: "Unselected Color",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "The unselected sprite color",
  T_43_YU_WS_UNSELECTEDSPRITE: "Unselected Sprite",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "The unselected sprite",
  T_43_YU_WS_UNSELECTEDTYPE: "Unselected Type",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Unselected sprite type",
  T_43_YU_WS_USEPHYSICALCCT: "Use Physical CCT",
  T_43_YU_WS_VALUE_D: "The displayed content",
  T_43_YU_WS_VECTOR2ADD: "Vector2 Add",
  T_43_YU_WS_VECTOR2GETX: "Vector2 Get X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 Get Y",
  T_43_YU_WS_VECTOR2SCALE: "Vector2 Scale",
  T_43_YU_WS_VECTOR2SETX: "Vector2 Set X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 Set Y",
  T_43_YU_WS_VECTOR2SUB: "Vector2 Sub",
  T_43_YU_WS_VELOCITY: "Velocity",
  T_43_YU_WS_VERTICALMAXANGLE: "Vertical Max Angle",
  T_43_YU_WS_VERTICALMINANGLE: "Vertical Min. Angle",
  T_43_YU_WS_VISIBILITY_D: "Indicates whether visibility can be set",
  T_43_YU_WS_VISIBLE_D: "The visibility setting. If set to invisible, the client stops rendering the target.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Futuristic Wall A",
  T_43_ZY_WS_ITEM320: "Futuristic Wall C",
  T_43_ZY_WS_ITEM321: "Futuristic Window",
  T_43_ZY_WS_ITEM322: "Futuristic Door",
  T_43_ZY_WS_ITEM323: "Futuristic Angled Roof",
  T_43_ZY_WS_ITEM324: "Futuristic Circular Roof",
  T_43_ZY_WS_ITEM325: "Futuristic Baseboard",
  T_43_ZY_WS_ITEM326: "Futuristic Circular Baseboard",
  T_43_ZY_WS_ITEM327: "Futuristic Stairs",
  T_43_ZY_WS_ITEM328: "Futuristic Decoration A",
  T_43_ZY_WS_ITEM329: "Futuristic Building A",
  T_43_ZY_WS_ITEM330: "Futuristic Building B",
  T_44_CJ_M_B_SPORT_TH: "Gym Uniform (Bottom)",
  T_44_CJ_M_H_SPORT_TH: "Gym Uniform (Head)",
  T_44_CJ_M_S_SPORT_TH: "Gym Uniform (Shoes)",
  T_44_CJ_M_T_SPORT_TH: "Gym Uniform (Top)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motorbike - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Force Start with Min. Players",
  T_44_JH_WS_HALFWAYKEY1: "Prioritize Start with Full Team",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_QL_GRENADE_DRAGON: "Dragon Freeze",
  T_44_QL_GRENADE_DRAGON_DES: "An upgraded Flash Freeze that will detonate three times consecutively upon impact",
  T_44_QL_JUMPSHOESX: "Dragon Sprinters",
  T_44_QL_JUMPSHOESX_DES: "A pair of special jumping shoes that allow for sprinting in the air during a double jump",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Safe Zone Close Time",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Time when the Safe Zone disappears. If the Safe Zone Close Time is less than Safe Zone Start Time, no Safe Zone will be generated.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Safe Zone Color",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Damage Interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Damage interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Damage Value",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "The damage dealt to a player out-of-zone in a single instance",
  T_44_SJ_WS_SAFEZONE_DESC: "A placeable out-of-zone object",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Out-of-Zone End Radius",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "End radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Safe Zone Player List",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Get the list of players in the Safe Zone",
  T_44_SJ_WS_SAFEZONE_NAME: "The out-of-zone area",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Shrink Duration (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Length of time the zone shrinking takes",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Out-of-Zone Initial Radius",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Initial radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Start Shrink Time",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Time when the zone shrinking starts",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Safe Zone Start Time",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Time when the safe zone appears each round in-match. Default is 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Activated Alpha",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Activated alpha",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Active Skill Button HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Add a component to an entity. Only supports custom components. (A component will not be added again if it already exists.)",
  T_44_XXJ_WS_ALLMEMBERS: "All Members",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Allow Pressed Outside",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Allow triggering outside the designated area",
  T_44_XXJ_WS_ARROWIMAGE: "Arrow Image",
  T_44_XXJ_WS_ARROWIMAGE_D: "Arrow image",
  T_44_XXJ_WS_ARROWOFFSET: "Arrow Offset",
  T_44_XXJ_WS_ARROWOFFSET_D: "Arrow offset",
  T_44_XXJ_WS_ARROWSIZE: "Arrow Size",
  T_44_XXJ_WS_ARROWSIZE_D: "Arrow size",
  T_44_XXJ_WS_AUTOPLAY_D: "Automatically play upon creation",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Background Image",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Base image",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Background Radius",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Base radius",
  T_44_XXJ_WS_BAGSKINID: "Backpack Skin ID",
  T_44_XXJ_WS_BAGSKINID_D: "The backpack skin ID",
  T_44_XXJ_WS_BONEPOSITION: "Bone Position",
  T_44_XXJ_WS_BONEPOSITION_D: "World coordinates of the bone node",
  T_44_XXJ_WS_CCTMOVE: "Move CCT",
  T_44_XXJ_WS_COLLIDER: "Collider",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collider Collection",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "The component used to describe the collision shape",
  T_44_XXJ_WS_COLOR: "Color",
  T_44_XXJ_WS_CONTENT: "Content",
  T_44_XXJ_WS_CONTENT_D: "Wallet content is a collection of currencies",
  T_44_XXJ_WS_CONTEXT_D: "Content to be printed",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Crosshairs HUD",
  T_44_XXJ_WS_CURVE_D: "Curve",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Color of the surface texture",
  T_44_XXJ_WS_ENABLE: "Enable",
  T_44_XXJ_WS_ENTITY_D: "Entity",
  T_44_XXJ_WS_GETBAGSKINID_D: "Get player backpack skin configuration",
  T_44_XXJ_WS_GETFACTION_D: "Get faction",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Get the loaded scenes that have not been uninstalled",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Get the local player",
  T_44_XXJ_WS_GROUPID: "Group ID",
  T_44_XXJ_WS_GROUPID_D: "For internal logic",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD Joystick Widget",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Joystick entity. Players can edit the HUD via the HUD Editor.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD Touchpad Widget",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "The HUD Touchpad widget that players can edit in the HUD editor",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Custom HUD or HUD Widget",
  T_44_XXJ_WS_ICON: "Icon",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Always Show Mark",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Always show marks on the compass",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Unactivated Alpha",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Unactivated alpha",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "When calling, the number of actual parameters does not match that of formal parameters. The expected number is {0}, while the actual is {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Is Dynamic Obstacle",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Is a dynamic obstacle for NavMesh",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Is Server-Driven",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "If false, then custom objects cannot be controlled by the APIs.",
  T_44_XXJ_WS_ISSUC_D: "Return execution result",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Joystick Drag Radius",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Joystick drag radius",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Joystick Image",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Joystick image",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Joystick Radius",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Joystick radius",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Character Skill ID List",
  T_44_XXJ_WS_LOOPTYPE_D: "Loop type",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Quit Midway Config",
  T_44_XXJ_WS_MOUNTABLE: "Hierarchical",
  T_44_XXJ_WS_MOUNTABLE_D: "Entity capable of mounting child nodes",
  T_44_XXJ_WS_MOVEMENT: "Movement",
  T_44_XXJ_WS_NAME_D: "Name",
  T_44_XXJ_WS_NATURALCONST: "Natural Constant",
  T_44_XXJ_WS_NATURALCONST_D: "Enum of natural constants to reduce redundant definitions",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Play icon animation",
  T_44_XXJ_WS_OFFSET_D: "Default base offset",
  T_44_XXJ_WS_ONFIRE_D: "Triggers the event each time the player shoots, attacks with fists, or attacks with melee weapons.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Trigger the event when the player stands up from prone/crouching",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Trigger the event when the player taps the fire button",
  T_44_XXJ_WS_OPTION: "Options",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Passive Skill HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "Physical Mover",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Players on this platform will automatically follow movement and rotation",
  T_44_XXJ_WS_PHYSICALOBJECT: "Physical Object",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Can apply force to it",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "The mathematical constant π (Pi) ",
  T_44_XXJ_WS_PLAYERS: "Player List",
  T_44_XXJ_WS_PLAYERS_D: "Player list",
  T_44_XXJ_WS_PLAYERSKILLID: "Character Skill ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "The character skill ID in AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "The previous pose before the player stands up",
  T_44_XXJ_WS_PRINT: "Print",
  T_44_XXJ_WS_PRINTERROR: "Print Error",
  T_44_XXJ_WS_PRINTERROR_D: "Print target data as an error to the console",
  T_44_XXJ_WS_PRINTWARNING: "Print Warning",
  T_44_XXJ_WS_PRINTWARNING_D: "Print target data as a warning to the console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioritize Player Skin Config",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioritize the out-of-match player skin configuration",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Read the content in cells of a  row by the column number and key",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Clear player backpack skin configuration",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Remove a component from an entity. Only supports custom components.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset player backpack skin configuration to its out-of-match configuration",
  T_44_XXJ_WS_SETBAGSKINID_D: "Set player backpack skin configuration",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entity supporting the Transform, SkeletonPart, Player, and MountPoint components",
  T_44_XXJ_WS_SHOWBACKGROUND: "Show Background",
  T_44_XXJ_WS_SKINID_D: "Backpack skin ID and skin configuration",
  T_44_XXJ_WS_SPEED_D: "Playback speed",
  T_44_XXJ_WS_TARGET: "Target",
  T_44_XXJ_WS_TARGET_D: "Target object",
  T_44_XXJ_WS_TITLE: "Title",
  T_44_XXJ_WS_TYPEID_D: "Component type ID. Only supports custom components.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Upload custom match results",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Type mismatch. Unable to read the table content.",
  T_44_XXJ_WS_X_D: "X-axis coordinate",
  T_44_XXJ_WS_Y_D: "Y-axis coordinate",
  T_44_XYL_WS_CTZSAFEZONE: "Custom Safe Zone",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Generates the start and end point of a Safe Zone based on the set positions and properties",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Hemispherical Shell",
  T_44_XYL_WS_QUARTERCYLINDER: "Quarter Cylinder",
  T_44_XYL_WS_SQUAREPYRAMID: "Square Pyramid",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Triangular Pyramid",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Add Game Event Log Map",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Add User Event Log",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "The custom match event log used for UX data analysis",
  T_44_YU_WS_ITEM366: "Military Wall A",
  T_44_YU_WS_ITEM367: "Military Wall B",
  T_44_YU_WS_ITEM368: "Military Wall C",
  T_44_YU_WS_ITEM369: "Military Wall D",
  T_44_YU_WS_ITEM370: "Military Window A",
  T_44_YU_WS_ITEM371: "Military Window B",
  T_44_YU_WS_ITEM372: "Military Window C",
  T_44_YU_WS_ITEM373: "Military Door A",
  T_44_YU_WS_ITEM374: "Military Door B",
  T_44_YU_WS_ITEM375: "Military Angled Roof A",
  T_44_YU_WS_ITEM376: "Military Angled Roof B",
  T_44_YU_WS_ITEM377: "Military Stairs A",
  T_44_YU_WS_ITEM378: "Military Stairs B",
  T_44_YU_WS_ITEM379: "Military Pillar A",
  T_44_YU_WS_ITEM380: "Military Handrail A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Customize",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Champion's Walk",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspect",
  T_45_HL_Moderation_fail_1: "Unfortunately, your submitted project did not pass the review.",
  T_45_HL_Moderation_fail_2: "involves",
  T_45_HL_Moderation_fail_3: "Reasons included:",
  T_45_HL_Moderation_fail_Location_1: "Game Content",
  T_45_HL_Moderation_fail_reason_1: "Toxic Content",
  T_45_HL_Moderation_fail_reason_10: "Community Guideline Violation",
  T_45_HL_Moderation_fail_reason_11: "Negative Impacts on In-Game Economies and Virtual Property Infringement",
  T_45_HL_Moderation_fail_reason_2: "Inappropriate Content",
  T_45_HL_Moderation_fail_reason_3: "Politically Sensitivity",
  T_45_HL_Moderation_fail_reason_4: "False Information",
  T_45_HL_Moderation_fail_reason_5: "Copyright Infringement",
  T_45_HL_Moderation_fail_reason_6: "Privacy Violation",
  T_45_HL_Moderation_fail_reason_7: "Security Concerns",
  T_45_HL_Moderation_fail_reason_8: "Hate Speech",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Other Issues",
  T_45_JH_WS_CLEMPTYOBJECT: "Object Group",
  T_45_JH_WS_PETSWITCH1: "Whether to show pets in the match",
  T_45_QL_CSFPP_DES: "Eliminate all opponents through the first-person perspective in this special CS mode!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "First-Person",
  T_45_SJ_WS_REVIEW_23: "Game Content",
  T_45_SJ_WS_REVIEW_24: "{0} involves {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} involves {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Tap to view details >>[-]",
  T_45_SJ_WS_REVIEW_27: "Not Approved",
  T_45_SJ_WS_REVIEW_28: "Review Feedback",
  T_45_SJ_WS_REVIEW_29: "The content involves {0} violation(s)",
  T_45_SJ_WS_REVIEW_31: "Not Approved",
  T_45_SJ_WS_REVIEW_32: "The review failed due to server exceptions",
  T_45_SJ_WS_REVIEW_TITLE: "Details of Violation",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Triggers vaulting (jumping over obstacles)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Vault Distance",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifies the distance of vaulting",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Vault Height",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controls the height of moving up and down when vaulting",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Vault Trigger",
  T_45_TYC_CL_TEMPLATE_WS: `An elimination mode where players take out all opposing teams in a chaotic battle to win.
You can set the gameplay rules and edit the gameplay parameters as you like.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = auto attack, 1 = defensive attack, 2 = do not attack",
  T_45_XXJ_WS_ADDFRIEND: "Add Friend",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Base Data",
  T_45_XXJ_WS_BOTH: "Both",
  T_45_XXJ_WS_BYHIERARCHY: "By Hierarchy",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "By Priority Low to High",
  T_45_XXJ_WS_CAMERA: "Camera",
  T_45_XXJ_WS_CAMERATYPE: "Camera Type",
  T_45_XXJ_WS_CENTERINVISIBLE: "Center Invisible",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "Collider ID",
  T_45_XXJ_WS_COLLIDERID_D: "The collider ID",
  T_45_XXJ_WS_COMPONENT: "Component",
  T_45_XXJ_WS_CURRENTCAMERA: "Current Camera",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Custom Push Force",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Throw",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Enable Move in Midair",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Enable Rotate with Gravity",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Event",
  T_45_XXJ_WS_FILLAMOUNT: "Fill Amount",
  T_45_XXJ_WS_FILLDIR: "Fill Direction",
  T_45_XXJ_WS_FIRETYPE: "Fire Type",
  T_45_XXJ_WS_FIRETYPE_D: "The firing type",
  T_45_XXJ_WS_FIXEDDELTATIME: "Fixed Delta Time",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "The fixed time interval for frame updates in milliseconds",
  T_45_XXJ_WS_FORWARD: "Forward",
  T_45_XXJ_WS_FORWARD_D: "The direction of the z-axis in the local coordinate system",
  T_45_XXJ_WS_FUNCTIONTYPE: "Function Type",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "The function type",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "The aiming direction of the local player",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Get the local timestamp",
  T_45_XXJ_WS_GRADIENT: "Gradient",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradient Bottom",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Bottom Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "Gradient Top",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Top Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "The world position of the target hit by bullets",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI Social Button Widget",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "Is Grounded",
  T_45_XXJ_WS_ISSILENCE: "Is Silence",
  T_45_XXJ_WS_ISSILENCE_D: "If it is silenced or not",
  T_45_XXJ_WS_ISSINGLESHOT: "Is Single Shot",
  T_45_XXJ_WS_ISSINGLESHOT_D: "If it is single-shot or not",
  T_45_XXJ_WS_JUMPHEIGHT: "Jump Height",
  T_45_XXJ_WS_JUMPHEIGHT_D: "The jump height",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Layout Sort Type",
  T_45_XXJ_WS_LIGHT_D: "Lights",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Max. Jump Count",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "None",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Execute the command each time before the entity deals damage",
  T_45_XXJ_WS_ONDISABLE_D: "Execute when the entity is disabled",
  T_45_XXJ_WS_ONEACHLOOP_D: "Execute each time Playable is looped. Only effective on the client side for entities such as Sound Effect and Special Effect.",
  T_45_XXJ_WS_ONENABLE_D: "Execute when the entity is enabled",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "When entering a frame at a fixed rate of 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Trigger the client event when the player adds or deletes a friend",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Trigger the event when the game is paused due to the called API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Trigger the event when the game resumes due to the called API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "When the player stops sprinting",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "When the player stops surfing",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "When the player is surfing",
  T_45_XXJ_WS_PHYSICALLAYER_D: "The custom physical layer within a range of 0 to 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Platform Type",
  T_45_XXJ_WS_PLATFORMTYPE_D: "The platform type",
  T_45_XXJ_WS_PLAYER: "Player",
  T_45_XXJ_WS_PLAYERCCT: "Player CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "A character controller with physical effects and used for Free Fire characters only",
  T_45_XXJ_WS_PRIORITY: "Priority",
  T_45_XXJ_WS_REMAINMULTINUM: "Remain Jump Count",
  T_45_XXJ_WS_REPORT: "Report",
  T_45_XXJ_WS_RIGHT: "Right",
  T_45_XXJ_WS_RIGHT_D: "The direction of the x-axis in the local coordinate system",
  T_45_XXJ_WS_SERVER: "Server",
  T_45_XXJ_WS_SINGLE: "Single",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Social Button Style Type",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "The social button style",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Social Button Type",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "The social button type",
  T_45_XXJ_WS_SORTTYPE_D: "Sort types: non-zero ascending, descending, and ascending",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Move Speed While ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "The movement speed while aiming down sight",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String or Localized String",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Up",
  T_45_XXJ_WS_UP_D: "The direction of the y-axis in the local coordinate system",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Use Custom Push Force",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Throw a signal flare towards the designated area to summon a random vehicle",
  T_45_ZD_VEHICLEDROP_R_NAME: "Mystery Vehicle",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Time Played",
  T_46_HJ_WS_SHAREBY: "By {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Game Mode",
  T_46_HJ_WS_SHARETEAM: "Team",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "Top of Class (Bottom)",
  T_46_HX_H_SCHOOL_VN: "Top of Class (Head)",
  T_46_HX_S_SCHOOL_VN: "Top of Class (Shoes)",
  T_46_HX_T_SCHOOL_VN: "Top of Class (Top)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Others",
  T_46_XXJ_WS_ACTUALPOSITION: "Actual Position",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Add the object to monitor with AOI synchronization beyond line of sight",
  T_46_XXJ_WS_APPEARANCE: "Appearance",
  T_46_XXJ_WS_APPEARANCERES: "Appearance Resource",
  T_46_XXJ_WS_BECOME: "Activate",
  T_46_XXJ_WS_BRAKETORQUE_D: "The horsepower given to the vehicle when Brake/Reverse is used",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Camera Rotate Angle Restriction Type",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Clear all monitored objects of the target",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "The maximum crash damage used for damage calculation",
  T_46_XXJ_WS_CRASHMAXSPEED: "Crash Max. Speed",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Used for crash damage calculation. Once exceeding this speed, no more damage will be added.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Crash Mass Factor",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "A parameter used in the damage formula for crash damage calculation",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "The minimum crash damage used for damage calculation",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Read and write limit of data storage has been exceeded",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Parameter exception",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Data storage timeout. Mainly applies to read and write now.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Edit Appearance",
  T_46_XXJ_WS_ENDVALUE_D: "The destination value",
  T_46_XXJ_WS_ENGINETORQUE_D: "The horsepower given to the vehicle when the gas pedal is used",
  T_46_XXJ_WS_ERRORCODE_D: "The error code enum",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Euler Angle to Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convert the Eular angle to a 3D vector",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Female Character",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Get Membership Expire Date",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "If the observer is monitoring an object or not",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "A type of flying vehicle",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "High-Speed Steer Restriction",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "The maximum steering angle while in a high-speed state",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "High-Speed Steer Angle at Speed",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "The speed threshold for the maximum high-speed steering angle",
  T_46_XXJ_WS_IDLE: "Idle Animation",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Idle Brake Input",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "When not driving a vehicle, decelerate it by (Idle Brake Input) x (Brake Torque).",
  T_46_XXJ_WS_INTTOFLOAT: "Int to Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convert an integer to a floating-point number",
  T_46_XXJ_WS_ISPREMIUM: "Is Membership",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "The leaderboard name in the database",
  T_46_XXJ_WS_MALEAVATAR: "Male Character",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI Persona",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "New UMA Appearance",
  T_46_XXJ_WS_NONE_D: "No error",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "The NPC object",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Tips: Humanoid NPCs usually have a collision model with a capsule that is 1.4m tall and 0.25m in radius. Pet NPCs usually have a collision model with a capsule that is 1m tall and 0.4m in radius.",
  T_46_XXJ_WS_OBSERVER_D: "The observer that is monitoring objects",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "On Enter Craftland Membership",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "On Quit Craftland Membership",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Open Craftland Membership",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Persona Center",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Player or Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "An alias for the Player and Transform entity",
  T_46_XXJ_WS_PREMIUM: "Membership",
  T_46_XXJ_WS_PREMIUMSTATUS: "Membership Status",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Observer",
  T_46_XXJ_WS_PROXYOBSERVER_D: "The proxy observer",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Remove the monitored object and cancel the AOI synchronization beyond line of sight",
  T_46_XXJ_WS_RENEWAL: "Renew",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotate Vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotate a vector based on quaternions",
  T_46_XXJ_WS_SKIN: "Gear",
  T_46_XXJ_WS_STARTVALUE_D: "The source value",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Switch the proxy observer of the User",
  T_46_XXJ_WS_TARGET_D: "The target that is monitored",
  T_46_XXJ_WS_USER_D: "The user",
  T_46_XXJ_WS_VALUE: "Value",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Safe Zone End Point",
  T_46_XYL_WS_RESOURCETYPE1: "Basic Structures",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometrics",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual & Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Scene Items",
  T_46_XYL_WS_RESOURCETYPE2_2: "Battle Supplies",
  T_46_XYL_WS_RESOURCETYPE3: "Nature",
  T_46_XYL_WS_RESOURCETYPE4: "Modular Component",
  T_46_XYL_WS_TYPEOTHERPROP: "Miscellaneous",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Containers & Boxes",
  T_47_CJ_FOREGRIP_SOFT_N: "Light Foregrip",
  T_47_CJ_MAGEZINE_FAST_N: "Fast Mag",
  T_47_CJ_STOCK_FAST_N: "Power Stock",
  T_47_GT_WS_USERMANUAL: "User Manual",
  T_47_HJ_WS_VFX_FOG: "Fog VFX",
  T_47_HJ_WS_VFX_LIGHTING: "Lighting VFX",
  T_47_HJ_WS_VFX_TRAILING: "Trailing VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Community Talent",
  T_47_HL_CL_MAP_LABEL1: "Selected Works by Community Talents",
  T_47_JH_WS_MODERATION_REASON12: "Gambling-related",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN collaboration",
  T_47_SD_RES_MATERIAL: "Material file",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "AI Map Generate",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a fiery explosion after a short delay to deal burn damage.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Fiery Kunai",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a Lightning strike after a short delay to paralyze the target.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Lightning Kunai",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a windstorm after a short delay to slow down the target moving towards its center.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Wind Kunai",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "A type of shuriken suitable for mid-to-long-range combat. One throw launches one piece quickly, dealing a great amount of damage.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Heavy Shuriken",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "A type of shuriken suitable for close-to-mid-range combat with two attack modes. One throw launches three pieces, dealing a small amount of damage.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Light Shuriken",
  T_47_XXJ_WS_ACTION: "Action",
  T_47_XXJ_WS_AOISETTING: "AOI Setting",
  T_47_XXJ_WS_BAGSKINTYPE: "Backpack Skin Type",
  T_47_XXJ_WS_CLEARMEMORY: "Clear Memory",
  T_47_XXJ_WS_CLNPC: "Advanced NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Outfit Skin Type",
  T_47_XXJ_WS_COMMON_ERROR: "Common Error",
  T_47_XXJ_WS_CONTENT: "Content",
  T_47_XXJ_WS_CREATERANDOMSEED: "Create Random Seed",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Elapsed Percentage",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Enable Fog Feature",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Enable Light Rotation Feature",
  T_47_XXJ_WS_ERRORCODE: "Error Code",
  T_47_XXJ_WS_EXPONENTIAL: "Exponential",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponential Squared",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Failed to create room: no valid Persona IDs",
  T_47_XXJ_WS_FOG: "Fog",
  T_47_XXJ_WS_FOGDENSITY: "Fog Density",
  T_47_XXJ_WS_FOGENDDISTANCE: "Fog End Distance",
  T_47_XXJ_WS_FOGMODE: "Fog Mode",
  T_47_XXJ_WS_FOGMODETYPE: "Fog Mode Type",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Fog Start Distance",
  T_47_XXJ_WS_HEIGHTSCALE: "Height Scale",
  T_47_XXJ_WS_ISVISIBLE: "Is Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Join New Team",
  T_47_XXJ_WS_JOINTEAM: "Join Team",
  T_47_XXJ_WS_LIGHTROTATE: "Light Rotation",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona Chat",
  T_47_XXJ_WS_NEWTEAM: "New Team",
  T_47_XXJ_WS_NEXT: "Next",
  T_47_XXJ_WS_NPC_TIP: "You can edit NPC's appearance and make NPC play animation",
  T_47_XXJ_WS_OBSERVERS: "Observers",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "On Player Send Message by UI Persona Chat",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "On Membership Status Changed",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "On Receive Action From Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "On Receive Content From Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "On Receive Finish From Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "On Receive Status From Persona",
  T_47_XXJ_WS_PARTICLESID: "Particles ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona Avatar",
  T_47_XXJ_WS_PERSONAID: "Persona ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona Nickname",
  T_47_XXJ_WS_PLAYERORNPC: "Player or NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Membership Closed",
  T_47_XXJ_WS_RANDOM: "Random",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Sender",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Set Persona Observer",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Set Player Can Quit Midway",
  T_47_XXJ_WS_SHOULDREPLY: "Should Reply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Show System Reply",
  T_47_XXJ_WS_SPOTANGLE: "Spot Angle",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Send System Message To Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream System Messages to Persona",
  T_47_XXJ_WS_TARGETTEAM: "Target Team",
  T_47_XXJ_WS_THISENTITY: "This Entity",
  T_47_XXJ_WS_USERAVATAR: "User Avatar",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Send User Message To Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream User Messages to Persona",
  T_47_XXJ_WS_USERNICKNAME: "User Nickname",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Vehicle Skin Type",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Weapon Skin Type",
  T_47_XYL_NB_UGC_EFFECT001: "Rasengan VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Chidori VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Cherry Blossom Clash VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Fireball Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Water Dragon Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Great Breach VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Tailed Beast Bomb VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Reanimation Curse Mark VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Asset Store",
  T_47_XYL_UGC_DONKEYCART: "Donkey Cart",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Spotlight Angle",
  T_48_H_EMOTE_WATERFEST25_N: "Swift Steps",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motorbike - Sea Foam",
  T_48_HJ_AC_STATENOTEXIST: "The state {0} does not exist in the animation controller",
  T_48_HL_CODESCRIPT: "Code Script",
  T_48_HL_GLOBAL_VAR: "Global Variable Name",
  T_48_HL_GRAPH: "Block",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Leaderboard",
  T_48_HL_LOCAL_VAR: "Local Variable Name",
  T_48_HL_LOCALIZATION: "Localization Name",
  T_48_HL_OPEN_ATTRIBUTES: "Open Attribute Name",
  T_48_HX_A_WATERFEST25: "Sea Foam (Mask)",
  T_48_HX_B_WATERFEST25: "Sea Foam (Bottom)",
  T_48_HX_F_B_BLACKDRESS: "Antimatter (Bottom)",
  T_48_HX_F_H_BLACKDRESS: "Antimatter (Head)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatter (Facepaint)",
  T_48_HX_F_S_BLACKDRESS: "Antimatter (Shoes)",
  T_48_HX_F_T_BLACKDRESS: "Antimatter (Top)",
  T_48_HX_H_WATERFEST25: "Sea Foam (Head)",
  T_48_HX_HA_WATERFEST25: "Sea Foam (Facepaint)",
  T_48_HX_M_A_BLACKDRESS: "Dark Matter (Mask)",
  T_48_HX_M_B_BLACKDRESS: "Dark Matter (Bottom)",
  T_48_HX_M_H_BLACKDRESS: "Dark Matter (Head)",
  T_48_HX_M_HA_BLACKDRESS: "Dark Matter (Facepaint)",
  T_48_HX_M_S_BLACKDRESS: "Dark Matter (Shoes)",
  T_48_HX_M_T_BLACKDRESS: "Dark Matter (Top)",
  T_48_HX_S_WATERFEST25: "Sea Foam (Shoes)",
  T_48_HX_T_WATERFEST25: "Sea Foam (Top)",
  T_48_JH_WS_STRINGDESC: "Enter a paragraph of text or other strings. Some widgets can display rich text. Add color to text with rich text using the following format: [#XXXXXX] text text [-]. “#XXXXXX” is the color you wish to display. Please note that the text color of the related widget must be set to white.",
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Find Entity by ID",
  T_48_META_API_10001_P0: "Entity ID",
  T_48_META_API_1098: "Batch Read Database Sheet Value",
  T_48_META_API_1098_D: "Batch read multiple data entries from a specified database sheet, where the entries of the unique player ID list correspond one-to-one with those of the key list.",
  T_48_META_API_1098_P1: "Account IDs",
  T_48_META_API_1098_P1_D: "The list of unique player IDs, which reads the data corresponding to the keys at the same index in the key list.",
  T_48_META_API_1098_P2: "Keys",
  T_48_META_API_1098_P2_D: "The list of keys, which reads the data corresponding to the unique player IDs at the same index in the ID list.",
  T_48_META_API_1098_P5: "Status Codes",
  T_48_META_API_1098_P5_D: "The list of status codes",
  T_48_META_API_1105: "Notify Start Plot",
  T_48_META_API_1105_D: "Start playing the specified plot for the triggering player",
  T_48_META_API_1105_P1_D: "The plot ID",
  T_48_META_API_1108: "Get Local Language",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Set Body Part Weight",
  T_48_META_API_3300_D: "Set the weight of the target body part when blending it with other lower-priority animations",
  T_48_META_API_3300_P0_D: "The addable animation controller component that the body part belongs to",
  T_48_META_API_3300_P1: "Body Part Name",
  T_48_META_API_3300_P1_D: "The body part name",
  T_48_META_API_3300_P2: "Weight",
  T_48_META_API_3300_P2_D: "Weight with a value range of [0, 1], representing the degree of blending with lower-priority animations.",
  T_48_META_API_3315: "Play Character Animation Clip Override",
  T_48_META_API_3315_D: "Play a character animation clip with the option to override the game's default animation",
  T_48_META_API_3315_P3: "Override Gameplay Control",
  T_48_META_API_3315_P3_D: "Whether to override the default animation of the game",
  T_48_META_API_3316: "Stop Animation",
  T_48_META_API_3316_D: "Stop playing the animation for the target in the specified status",
  T_48_META_API_90_P1: "Can Quit Midway",
  T_48_META_API_93: "Create Along Path Motion",
  T_48_META_API_93_D: "Create an interpolated movement along a path to make the object move along the specified path",
  T_48_META_API_93_P1: "Path",
  T_48_META_API_93_P1_D: "The path of motion",
  T_48_META_API_93_P3_D: "The magnitude of velocity",
  T_48_META_API_93_P4: "Tangent Facing",
  T_48_META_API_93_P4_D: "Whether the object is facing the direction of movement. This property remains unchanged even if the object's orientation is forcibly modified by other means.",
  T_48_META_API_96: "Instantiate Prefab",
  T_48_META_API_96_D: "Create a prefab instance with the option to process it asynchronously",
  T_48_META_API_96_P2: "Async Load",
  T_48_META_API_96_P2_D: "Whether loading is asynchronous",
  T_48_META_EVT_3140: "On Change Team",
  T_48_META_EVT_3140_D: "Triggers when the team of the current entity changes",
  T_48_META_EVT_3140_P0: "Former Team",
  T_48_META_EVT_3140_P0_D: "The team one belonged to before the change",
  T_48_META_EVT_3140_P1: "Current Team",
  T_48_META_EVT_3140_P1_D: "The team one belongs to after the change",
  T_48_META_EVT_3141: "On Plot Start",
  T_48_META_EVT_3141_D: "Triggers when the plot starts to play",
  T_48_META_EVT_3141_P1: "Plot ID",
  T_48_META_EVT_3141_P1_D: "The plot ID",
  T_48_META_EVT_3142: "On Plot End",
  T_48_META_EVT_3142_D: "Triggers when the plot ends",
  T_48_META_EVT_3142_P0_D: "The triggering player",
  T_48_META_EVT_3142_P1_D: "The plot ID",
  T_48_META_EVT_3143: "On Trigger Plot Option",
  T_48_META_EVT_3143_D: "Triggers when an option is selected in the plot",
  T_48_META_EVT_3143_P1_D: "The plot ID",
  T_48_META_EVT_3143_P2: "Option ID",
  T_48_META_EVT_3143_P2_D: "The ID of the option selected",
  T_48_META_TYP_409_I10: "Change Team Failed_Invalid Team",
  T_48_META_TYP_409_I11: "Change Team Failed_Eliminated",
  T_48_META_TYP_409_I12: "Change Team Failed_In Vehicle",
  T_48_META_TYP_409_I7: "Change Team Failed_Not Supported",
  T_48_META_TYP_409_I8: "Change Team Failed_Already In Team",
  T_48_META_TYP_409_I9: "Change Team Failed_Invalid Target",
  T_48_META_TYP_41_I19: "Disable Collider",
  T_48_META_TYP_417: "Particles",
  T_48_META_TYP_428: "Player Transform or NPC Outfit",
  T_48_META_TYP_431: "Along Path Motion",
  T_48_META_TYP_431_I1: "Path",
  T_48_META_TYP_432: "Custom Curve Path Waypoint",
  T_48_META_TYP_432_I0: "Roll",
  T_48_META_TYP_432_I1: "Tangent",
  T_48_META_TYP_433: "Custom Curve Path Type",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Smooth",
  T_48_META_TYP_433_I2: "Custom",
  T_48_META_TYP_434: "Custom Curve Path",
  T_48_META_TYP_434_I2: "Closed Loop",
  T_48_META_TYP_434_I3: "Waypoints",
  T_48_META_TYP_437_I5: "Score Type Names",
  T_48_META_TYP_437_I6: "Left Score Content",
  T_48_META_TYP_437_I7: "Right Score Content",
  T_48_META_TYP_438_I1: "Players",
  T_48_META_TYP_438_I2: "Ranks",
  T_48_META_TYP_438_I3: "Total Scores",
  T_48_META_TYP_438_I4: "Score Type Names",
  T_48_META_TYP_438_I5: "Colors",
  T_48_META_TYP_438_I6: "Scores",
  T_48_META_TYP_439: "Group",
  T_48_META_TYP_442_I1: "Left Score",
  T_48_META_TYP_442_I10: "Right Eliminated Icon",
  T_48_META_TYP_442_I2: "Right Score",
  T_48_META_TYP_442_I3: "Left Alive Number",
  T_48_META_TYP_442_I4: "Right Alive Number",
  T_48_META_TYP_442_I5: "Left Eliminated Number",
  T_48_META_TYP_442_I6: "Right Eliminated Number",
  T_48_META_TYP_442_I7: "Left Alive Icon",
  T_48_META_TYP_442_I8: "Right Alive Icon",
  T_48_META_TYP_442_I9: "Left Eliminated Icon",
  T_48_META_TYP_444: "Language Type",
  T_48_META_TYP_444_I0: "English",
  T_48_META_TYP_444_I1: "Simplified Chinese",
  T_48_META_TYP_444_I10: "French",
  T_48_META_TYP_444_I11: "German",
  T_48_META_TYP_444_I12: "Turkish",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japanese",
  T_48_META_TYP_444_I15: "Romanian",
  T_48_META_TYP_444_I16: "Arabic",
  T_48_META_TYP_444_I17: "Burmese",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Traditional Chinese",
  T_48_META_TYP_444_I3: "Thai",
  T_48_META_TYP_444_I4: "Vietnamese",
  T_48_META_TYP_444_I5: "Indonesian",
  T_48_META_TYP_444_I6: "Portuguese",
  T_48_META_TYP_444_I7: "Spanish",
  T_48_META_TYP_444_I8: "Russian",
  T_48_META_TYP_444_I9: "Korean",
  T_48_SD_ERROR_DIVISOR: "Divisor cannot be 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "The specified key does not exist in map: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "List index out of range: {0}",
  T_48_SD_SK_WARNING: "Did not found {1} in {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Since the attribute "IsServerDriven" of the Craftland character controller {0} is disabled, the related server API does not take effect.',
  T_48_XXJ_WS_PARENTERROR: "Failed to set parent",
  T_48_XXJ_WS_PERFORMANCE: "Performance",
  T_48_XXJ_WS_TANGENT: "Tangent",
  T_48_XXJ_WS_WAYPOINT: "Waypoint",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "List of objects",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Use Custom Minimap",
  T_48_XYL_UGC_HIDEMINIMAP: "Hide Minimap HUD",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Basic Custom Surface",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Cylinder Cutout",
  T_48_XYL_WS_BASICHEMISPHERE: "Basic Hemisphere",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quarter Torus",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quarter Square Torus",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Torus",
  T_48_XYL_WS_BASICTRIANGLE: "Triangle Surface",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Match players = Number of teams x Number of players per team. The more match players, the longer the matchmaking time",
  T_48_XYL_WS_MAPPLAYERSWARNING: "A high number of match players may lead to longer matchmaking time",
  T_49_HL_CL_CREATOR_LABEL2: "Craftland Community Talent",
  T_49_HL_CL_MAPS_LABEL2: "Map Winner",
  T_49_HL_CL_MAPS_LABEL3: "Gameplay Winner",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajectory",
  T_49_JH_WS_SKILLKASSIE: "Electro Therapy (Kassie)",
  T_49_JH_WS_SKILLKODA: "Aurora Vision (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Valiant Dash (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Generate with AI",
  T_49_META_API_10065: "Switch Custom Camera",
  T_49_META_API_10067: "Get Current Custom Camera",
  T_49_META_API_10069: "Create Custom Camera",
  T_49_META_API_10070: "Set Custom Camera Culling Mask",
  T_49_META_API_10070_D: "Set the culling mask of the target camera to control visibility across all layers",
  T_49_META_API_10071: "Get Custom Camera Culling Mask",
  T_49_META_API_10071_D: "Get the culling mask of the target camera",
  T_49_META_API_10072: "Set Custom Camera Culling Mask Layer",
  T_49_META_API_10072_D: "Set the visibility of the target camera for a specific layer",
  T_49_META_API_10073: "Capture Screenshot",
  T_49_META_API_10073_D: "Capture screenshot (for internal testing)",
  T_49_META_API_106: "Get Server Timestamp (ms)",
  T_49_META_API_106_D: "Get the server timestamp with millisecond precision",
  T_49_META_API_107: "Timestamp to Localized String (ms)",
  T_49_META_API_107_D: "Convert timestamps (in ms) into strings based on certain formats",
  T_49_META_API_107_P0: "Timestamp (ms)",
  T_49_META_API_107_P0_D: "A timestamp in millisecond",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Perform linear interpolation from the 3D vector A to vector B",
  T_49_META_API_1089_P2: "Request ID",
  T_49_META_API_109: "Update Context to Persona",
  T_49_META_API_109_D: "Update the model context of a specified persona in the current room and overwrite the original context after execution.The context will influence the persona's interpretation of the background, history, or certain parameters for the current dialogue.",
  T_49_META_API_109_P1: "Context",
  T_49_META_API_109_P1_D: "Details of the context",
  T_49_META_API_110: "Feedback on Persona Response",
  T_49_META_API_110_D: "Submit feedback on the response content of a persona, which will be used to optimize our model.",
  T_49_META_API_110_P1: "Is Liked",
  T_49_META_API_110_P1_D: "Whether the response is liked or not. True = like.",
  T_49_META_API_1109: "Set Local Player Position",
  T_49_META_API_1109_D: "When the player is using classic game characters, this API can set the player's position.",
  T_49_META_API_1109_P0_D: "The target position",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Perform spherical interpolation from the 3D vector A to vector B for smooth rotation",
  T_49_META_API_1110: "Set Local Player Forward",
  T_49_META_API_1110_D: "When the player is using classic game characters, this API can set the direction the player is facing.",
  T_49_META_API_1110_P0_D: "The forward vector",
  T_49_META_API_112: "Roll Back Persona Memory",
  T_49_META_API_112_D: "Roll back the memory of a persona to before the specific response ID. All memory of the dialogues including and after the response will be cleared.",
  T_49_META_API_113: "Play One-Shot Sound",
  T_49_META_API_113_D: "Play a one-shot sound effect with adjustable volume",
  T_49_META_API_113_P0_D: "The sound effect resource ID to be played",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "The playback volume for the sound effect, ranging from 0 to 1.",
  T_49_META_API_97: "Create Skeleton Part Look-at Controller",
  T_49_META_API_97_D: "After creating a skeleton part look-at controller entity, you can use this entity to control the specified skeleton part and make it always face a specific target.",
  T_49_META_API_97_P0_D: "The skeleton part look-at controller entity. If the entity is destroyed, the look-at functionality will cease.",
  T_49_META_API_97_P1_D: "The skeleton part that is being controlled",
  T_49_META_API_97_P2_D: "The target that is being looked at",
  T_49_META_API_98: "Projection",
  T_49_META_API_98_D: "Calculate the projection of vector A onto vector B",
  T_49_META_API_99: "Get Local Timestamp (ms)",
  T_49_META_API_99_D: "Get the local timestamp with millisecond precision",
  T_49_META_EVT_16_P1_D: "Starting from 0, each outgoing request will consume a sequential numeric ID, such as for creating a room and clearing memory.",
  T_49_META_EVT_16_P2: "Response ID",
  T_49_META_EVT_16_P2_D: "Each complete response will have a unique ID",
  T_49_META_TYP_122_I19: "Custom Material",
  T_49_META_TYP_122_I19_D: "Allow for replacing the skybox with a custom material",
  T_49_META_TYP_14_I78_D: "Get or set the camera entity that is currently rendering the scene on the player's client. Note: The camera entity essentially represents the configuration data for controlling the client-side camera.",
  T_49_META_TYP_335_I9: "Elapsed Time (ms)",
  T_49_META_TYP_335_I9_D: "The playback duration of the sound effect in milliseconds. This property can only be accessed on the client side.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "Performance ID",
  T_49_META_TYP_445: "Playable Controller ID",
  T_49_META_TYP_446: "Playable Controller Attachable",
  T_49_META_TYP_446_I0: "Playable Controller",
  T_49_META_TYP_447: "Skeleton Part Controller",
  T_49_META_TYP_448: "Skeleton Part Look-at Controller",
  T_49_META_TYP_448_I0: "Controlled Target",
  T_49_META_TYP_448_I1: "Look-at Target",
  T_49_META_TYP_449: "Custom Camera",
  T_49_META_TYP_449_I2: "Orthographic Size",
  T_49_META_TYP_449_I2_D: "Control the size of the area visible to the camera",
  T_49_META_TYP_450: "Timestamp Localized String (ms)",
  T_49_META_TYPE_449_D: "A custom camera is fully controlled by the developer and determines what the player sees during gameplay",
  T_49_META_TYPE_450_D: "Format a millisecond-level timestamp into a readable text format",
  T_49_SD_SEARCH_ICONDESC: "Smart Association",
  T_49_SD_SEARCHKEY_ACTION: "Action",
  T_49_SD_SEARCHKEY_ANICLIPID: "Animation clip ID",
  T_49_SD_SEARCHKEY_AS: "As",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "Attachment ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Sound effect type",
  T_49_SD_SEARCHKEY_BAGSKINID: "Backpack skin ID",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier curve",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Break",
  T_49_SD_SEARCHKEY_BTREEID: "Behavior Tree ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "On button clicked",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "On button double clicked",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "On Button pressed",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "On button release",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Outfit type",
  T_49_SD_SEARCHKEY_COLOR: "Color",
  T_49_SD_SEARCHKEY_COMMENT: "Comment note",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Component enum",
  T_49_SD_SEARCHKEY_CONCANT: "Connect",
  T_49_SD_SEARCHKEY_CONTINUE: "Continue",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Custom HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Custom hud widget",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "dynamic create level object type",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Visual effects type",
  T_49_SD_SEARCHKEY_ENTITY: "Select scene object",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "For index",
  T_49_SD_SEARCHKEY_FOREACH: "For each",
  T_49_SD_SEARCHKEY_FUNCTION: "Function",
  T_49_SD_SEARCHKEY_GETCSV: "Get CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Get registered asset by key",
  T_49_SD_SEARCHKEY_GETVALUE: "Get property value",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Get global variable",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Set Global Variable",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If else",
  T_49_SD_SEARCHKEY_IMGENUM: "Sprite Type",
  T_49_SD_SEARCHKEY_INT: "Integer",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD type",
  T_49_SD_SEARCHKEY_ITEMENUM: "Item Type",
  T_49_SD_SEARCHKEY_LISTAPPEND: "List append",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "List append range",
  T_49_SD_SEARCHKEY_LISTCLEAR: "List clear",
  T_49_SD_SEARCHKEY_LISTCLONE: "List clone",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "List contain",
  T_49_SD_SEARCHKEY_LISTCREATE: "List create",
  T_49_SD_SEARCHKEY_LISTDELETE: "Delete List",
  T_49_SD_SEARCHKEY_LISTGET: "Get list",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "List index of",
  T_49_SD_SEARCHKEY_LISTINSERT: "List insert",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "List last index of",
  T_49_SD_SEARCHKEY_LISTLENGTH: "List length",
  T_49_SD_SEARCHKEY_LISTREVERSE: "List reverse",
  T_49_SD_SEARCHKEY_LISTSET: "Set list",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "List shuffle",
  T_49_SD_SEARCHKEY_LOCALKEY: "Localized key",
  T_49_SD_SEARCHKEY_LOCALVAR: "Local variable",
  T_49_SD_SEARCHKEY_LOGICAL: "And or",
  T_49_SD_SEARCHKEY_LOGINFO: "Log info print",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict get all keys map get all keys",
  T_49_SD_SEARCHKEY_MAPCLEAR: "clear dict clear map",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict contain key map contain key",
  T_49_SD_SEARCHKEY_MAPCREATE: "create dict create map",
  T_49_SD_SEARCHKEY_MAPGET: "get dict value by key get map value by key",
  T_49_SD_SEARCHKEY_MAPLENGTH: "dict length map length",
  T_49_SD_SEARCHKEY_MAPREMOVE: "remove dict remove map",
  T_49_SD_SEARCHKEY_MAPSET: "set dict value set map value",
  T_49_SD_SEARCHKEY_MATH: "add subtract multiply divide",
  T_49_SD_SEARCHKEY_NEWLIST: "New list",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Number to string",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Particles properties",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "Player Data ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Character skill type",
  T_49_SD_SEARCHKEY_PREEFFECT: "Special sticker type",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "Raw ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Read accumulated data",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Resource uuid",
  T_49_SD_SEARCHKEY_RETURN: "Return",
  T_49_SD_SEARCHKEY_SCENEENUM: "Scene file",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Set property value",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Special item ID type",
  T_49_SD_SEARCHKEY_TEXT: "Text",
  T_49_SD_SEARCHKEY_TEXTUREID: "Texture type",
  T_49_SD_SEARCHKEY_THISENTITY: "This Entity",
  T_49_SD_SEARCHKEY_TIMELINE: "Timeline",
  T_49_SD_SEARCHKEY_TYPEENUM: "Any type",
  T_49_SD_SEARCHKEY_V2VCREATE: "Create Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Get Vector2 components",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 operation add subtract multiply dot product  distance angle",
  T_49_SD_SEARCHKEY_V2VSET: "Set Vector2 components",
  T_49_SD_SEARCHKEY_V3VCREATE: "Create Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Get Vector3 components",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 operation add subtract multiply dot product cross product distance angle",
  T_49_SD_SEARCHKEY_V3VSET: "Set Vector3 components",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "Vehicle skin ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Weapon Skin ID",
  T_49_SD_SEARCHKEY_WHILE: "While",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Write accumulated database offset",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Write accumulated database offset by map code",
  T_49_XXJ_WS_DURATIONS: "Duration (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Edit Performance",
  T_49_XXJ_WS_PERFORMANCE: "Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Delete Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Deleted performance cannot be restored, continue?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Editing {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "This name has already been used, please change it and try again",
  T_49_XXJ_WS_PERFORMANCENAME: "Performance Name",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Add Key Frame",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Add Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Add Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Delete Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Actor Track",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Event Track",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Key Frame already exists",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "The corresponding actor track already exists",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Content",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Duplicate track names detected. Please change them and try again.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Please start recording or choose a key frame first",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Recording...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Delete Key Frame",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Scene View",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Select an object to create a track or tap the add-track button directly",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Tap the add-track button to create a new track",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Track View",
  T_49_XYL_WS_DAILYPROPS: "Basic",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Trouble Academy",
  T_50_H_MACHETE_VA_N: "Parang - Trouble Academy",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Leaderboard Fields",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Overflow",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Wrap around",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Shrink font",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Create Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Get Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Set Tuple",
  T_50_HJ_TEXTOBGJ_H: "Height",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Overflow Options",
  T_50_HJ_TEXTOBGJ_W: "Width",
  T_50_HZY_REVIEW_TEXTOBJ: "Text object content",
  T_50_JH_WS_HIDEMAPERROR: "Cannot hide minimap without a custom cover image",
  T_50_JH_WS_HIDEMAPTIP: "When minimap is hidden, it will no longer be used as the cover image",
  T_50_JH_WS_HIDEMINIMAP: "Hide Minimap",
  T_50_META_API_10073_P0: "File Name",
  T_50_META_API_10073_P0_D: "The file name",
  T_50_META_API_10073_P1_D: "The result of the execution. Check the Status Code enum.",
  T_50_META_API_1102: "Read Database Sheet Column Value",
  T_50_META_API_1102_D: "Read the value of a specific column for a given key from a standard database table",
  T_50_META_API_1102_P3: "Column Index",
  T_50_META_API_1102_P3_D: "The column index of the database table (0 = the first column)",
  T_50_META_API_1106: "Create Performance",
  T_50_META_API_1106_D: "Create a performance entity",
  T_50_META_API_1106_P0_D: "The performance asset",
  T_50_META_API_1111: "Read Database Leaderboard Association Value",
  T_50_META_API_1111_D: "Read the combination of values from a leaderboard table and its associated table in the database",
  T_50_META_API_1111_P5: "Association Status Code",
  T_50_META_API_1111_P5_D: "Association Error Code",
  T_50_META_API_1112: "Read Database Leaderboard Association Values by Range",
  T_50_META_API_1112_D: "Read values from the leaderboard table within a specified rank range, read the corresponding values by retrieved keys from the associated table, and combine them.",
  T_50_META_API_1112_P6: "Association Status Code",
  T_50_META_API_1112_P6_D: "Association Error Code",
  T_50_META_API_1113: "Write Database Leaderboard Association Value",
  T_50_META_API_1113_D: "Write the value for a given key into the leaderboard table and its related table in the database",
  T_50_META_API_1113_P5: "Association Status Code",
  T_50_META_API_1113_P5_D: "Association Error Code",
  T_50_META_API_114_D: "Create custom UI",
  T_50_META_API_114_P0_D: "The code is used as the parameter name for creating a UI entity, and its corresponding local variable value represents the created UI entity.",
  T_50_META_API_114_P1_D: "The player entity it belongs to, only visible to the player.",
  T_50_META_API_114_P2: "UI Asset ID",
  T_50_META_API_114_P2_D: "The custom UI asset ID",
  T_50_META_API_115_D: "Create the specified custom UI",
  T_50_META_API_116: "Set Level Object Highlight",
  T_50_META_API_116_D: "Set the highlight status of the object. It may be affected by other in-game logics.",
  T_50_META_API_116_P0_D: "Target Object",
  T_50_META_API_116_P1_D: "Highlight status",
  T_50_META_API_117: "Bitwise Common",
  T_50_META_API_117_D: "Bitwise and/or/xor/left shift/right shift",
  T_50_META_API_117_P0_D: "Left value",
  T_50_META_API_117_P1_D: "Right value",
  T_50_META_API_117_P2_D: "Operation Type",
  T_50_META_API_118: "Bitwise Not",
  T_50_META_API_118_D: "Bitwise NOT, also known as bitwise complement.",
  T_50_META_API_118_P0_D: "Value",
  T_50_META_API_119: "Bitwise List to Int",
  T_50_META_API_119_D: "Perform bitwise OR operation on all list elements and transform the output to an integer value.",
  T_50_META_API_119_P0: "Bit Array",
  T_50_META_API_119_P0_D: "Bitwise array",
  T_50_META_API_120: "Bitwise Int to List",
  T_50_META_API_120_D: "Covert the decimal values represented by bits at position 1 of an integer in its binary form to a list",
  T_50_META_API_120_P0_D: "Integer",
  T_50_META_API_121: "Quaternion Angle",
  T_50_META_API_121_D: "Calculate the angle between two quaternions",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Quaternion Dot",
  T_50_META_API_122_D: "Calculate the dot product of two quaternions",
  T_50_META_API_123: "Quaternion Inverse",
  T_50_META_API_123_D: "Calculate the inverse of a quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion From To Rotation",
  T_50_META_API_124_D: 'Calculate rotation quaternion from "from" to "to"',
  T_50_META_API_124_P0_D: "The start point",
  T_50_META_API_124_P1_D: "The end point",
  T_50_META_API_125: "Quaternion Rotate Towards",
  T_50_META_API_125_D: 'Calculate the rotation quaternion from "from" to "to". Max Degrees Delta is the max. rotation angle.',
  T_50_META_API_125_P0: "From",
  T_50_META_API_125_P0_D: "Initial quaternion",
  T_50_META_API_125_P1: "To",
  T_50_META_API_125_P1_D: "The target quaternion",
  T_50_META_API_125_P2: "Max. Degree Delta",
  T_50_META_API_125_P2_D: "The max. rotation angle",
  T_50_META_API_126: "Get Gyroscope Orientation",
  T_50_META_API_126_D: "Device orientation in 3D space, representing rotation angles around the three axes.",
  T_50_META_API_127: "Get Gyroscope Gravity",
  T_50_META_API_127_D: "The gravity component detected by the sensor on your device",
  T_50_META_API_128: "Get Gyroscope Rotation Rate",
  T_50_META_API_128_D: "This refers to the rotation rate of a device. It is a term related to the gyroscope sensors that describes the device's rotational movement speed in a three-dimensional space.",
  T_50_META_API_129: "Get Gyroscope Rotation Unbiased",
  T_50_META_API_129_D: "Describes the device's rotation rate and provides a more precise result by compensating for the noise or bias of the device's sensors.",
  T_50_META_API_130: "Get Gyroscope User Acceleration",
  T_50_META_API_130_D: "The part of the device's acceleration with the gravity component removed, which is the acceleration caused by user actions or external forces.",
  T_50_META_API_131: "Get Touch Info",
  T_50_META_API_131_D: "Get the specified index screen touch information (including position,  displacement, and change time).",
  T_50_META_API_131_P0_D: "Distribute touch point IDs, starting from 0",
  T_50_META_API_131_P1_D: "Touch position",
  T_50_META_API_131_P2: "Delta Position",
  T_50_META_API_131_P2_D: "The shift in position compared to the last frame",
  T_50_META_API_131_P3: "Delta Time",
  T_50_META_API_131_P3_D: "Time elapsed since last frame",
  T_50_META_API_132: "Get Screen Touch Count",
  T_50_META_API_132_D: "Get the current number of touch points on the screen",
  T_50_META_API_133: "Vibrate Device",
  T_50_META_API_133_D: "Make the device vibrate once",
  T_50_META_API_134_D: "Notify the target player device to play the audio",
  T_50_META_API_134_P0_D: "The target player",
  T_50_META_API_134_P1_D: "The audio asset",
  T_50_META_API_134_P2_D: "The playback speed (valid range: 0.1~3.0; 1 = normal, <1 = slow down, >1 = speed up)",
  T_50_META_API_135_D: "Play the one-time audio file",
  T_50_META_API_135_P0_D: "Audio resources",
  T_50_META_API_135_P1_D: "Play Speed",
  T_50_META_API_136: "Format String",
  T_50_META_API_136_D: "Format the strings",
  T_50_META_API_136_P0_D: "Formatted strings that use Go formatting verb controls",
  T_50_META_API_136_P1: "Parameters Array",
  T_50_META_API_136_P1_D: "Parameter List",
  T_50_META_API_137: "Paste Component",
  T_50_META_API_137_D: "Copy or add component data",
  T_50_META_API_137_P0: "Source",
  T_50_META_API_137_P0_D: "The source entity",
  T_50_META_API_137_P1_D: "Target Entity",
  T_50_META_API_137_P2: "Component Type",
  T_50_META_API_137_P2_D: "Component Type",
  T_50_META_API_137_P3: "Is Success",
  T_50_META_API_137_P3_D: "Whether it is successful or not",
  T_50_META_API_138: "Revive At Next Frame",
  T_50_META_API_138_D: "Revive at the next frame",
  T_50_META_API_139: "Eliminate at Next Frame",
  T_50_META_API_139_D: "Eliminate the battle entity at the next frame",
  T_50_META_API_139_P0_D: "The battle entity",
  T_50_META_API_140: "Quit Game at Next Frame",
  T_50_META_API_140_D: "Exit the game at the next frame",
  T_50_META_API_141: "Get Microphone Volume",
  T_50_META_API_141_D: "Get the microphone volume. Return the status when the player's microphone is off or no access is granted.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "The microphone volume",
  T_50_META_API_141_P1_D: "Microphone is turned on or off",
  T_50_META_API_142: "Get Render Quality",
  T_50_META_API_142_D: "Get the current rendering quality (enum: Low/Medium/High/Ultra)",
  T_50_META_API_143: "Get Render Resolution",
  T_50_META_API_143_D: "Get the current render resolution",
  T_50_META_API_144: "Bind Custom Player",
  T_50_META_API_144_D: "Dynamically set the target that this player binds to that will override existing bindings. Returns false if failed.",
  T_50_META_API_144_P0: "Custom Player",
  T_50_META_API_144_P0_D: "After binding this Custom Player to the player, data such as position and direction will be automatically synced",
  T_50_META_API_144_P1_D: "Target Player",
  T_50_META_API_145: "Unbind Custom Player",
  T_50_META_API_145_D: "Cancel the binding. Returns false if failed.",
  T_50_META_API_145_P0: "Custom Player",
  T_50_META_API_145_P0_D: "Clear all bindings for this target. After unbinding, data such as position and direction will no longer be automcatically synced.",
  T_50_META_API_146_P0_D: "A custom player",
  T_50_META_API_147: "Set Custom Player State",
  T_50_META_API_147_D: "Automatically upload to the sever and sync with all clients. Returns false if failed.",
  T_50_META_API_147_P0: "Custom Player",
  T_50_META_API_147_P1: "State",
  T_50_META_API_147_P1_D: "Usually used to save the animation states. Get the synced state with Get Custom Player State.",
  T_50_META_API_148: "Get Custom Player State",
  T_50_META_API_148_D: "The state data is automatically synced to the server. Returns false if failed.",
  T_50_META_API_148_P0: "Custom Player",
  T_50_META_API_148_P1: "State",
  T_50_META_API_148_P1_D: "Set the state with Set Custom Player State",
  T_50_META_API_149: "Set Distance Volumes",
  T_50_META_API_149_D: "Set the distance ranges between players to dynamically set audio volume.",
  T_50_META_API_149_P0: "Distance List",
  T_50_META_API_149_P0_D: "A list of distance ranges, each corresponding to an element in the volume list.",
  T_50_META_API_149_P1: "Volume List",
  T_50_META_API_149_P1_D: "A list of volumes, each corresponding to an element in the distance list.",
  T_50_META_API_150: "Get Friends",
  T_50_META_API_150_D: "Get the list of the player's friend IDs",
  T_50_META_API_151: "Get Default UI Info",
  T_50_META_API_151_D: "Get the default UI location of the player",
  T_50_META_API_151_P0_D: "The default interface",
  T_50_META_API_151_P1_D: "Status",
  T_50_META_API_151_P2_D: "UI Position",
  T_50_META_API_151_P3: "Size",
  T_50_META_API_151_P3_D: "UI Size",
  T_50_META_API_152: "Broadcast Custom Event",
  T_50_META_API_152_D: "Broadcast a custom event for any entity to receive (listen to) this event",
  T_50_META_API_153: "Dispatch Event to Entity",
  T_50_META_API_153_D: "Send the custom event to the target entity",
  T_50_META_EVT_17: "On Screen Touch Begin",
  T_50_META_EVT_17_D: "Start the event when the screen is touched",
  T_50_META_EVT_17_P0: "Touch Index",
  T_50_META_EVT_17_P0_D: "Touch point index",
  T_50_META_EVT_17_P1_D: "Touch position",
  T_50_META_EVT_18: "On Screen Touch End",
  T_50_META_EVT_18_D: "End the event when the screen is touched",
  T_50_META_EVT_18_P0: "Touch Index",
  T_50_META_EVT_18_P0_D: "Touch point index",
  T_50_META_EVT_18_P1_D: "Touch positions on the screen",
  T_50_META_EVT_19: "On Receive Persona Create Room Result",
  T_50_META_EVT_19_D: "Receive the corresponding result when failed to create the persona chat room",
  T_50_META_EVT_19_P1: "Room ID",
  T_50_META_EVT_19_P1_D: "The room ID",
  T_50_META_EVT_20: "On User Quit or User Match End",
  T_50_META_EVT_20_D: "Trigger when the user quits the match or when the match ends",
  T_50_META_TYP_11_I44: "Distance Volumes",
  T_50_META_TYP_11_I44_D: "Dynamically adjust the audio volume based on the distance between players",
  T_50_META_TYP_22_I9_D: "The asset ID used to create the UI",
  T_50_META_TYP_244_I12_D: "The text box width",
  T_50_META_TYP_244_I13_D: "The text box height",
  T_50_META_TYP_244_I14_D: "The overflow type",
  T_50_META_TYP_335_I10_D: "The playback speed (valid value > 0, default = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "IO operation failed: an error occurred while creating the file.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "IO operation failed. Invalid file name.",
  T_50_META_TYP_448_I0_D: "The controlled skeleton part",
  T_50_META_TYP_448_I1_D: "The target that the skeleton part is looking at",
  T_50_META_TYP_451: "Overflow Type",
  T_50_META_TYP_451_D: "The method for handling text overflow",
  T_50_META_TYP_452: "Custom UI Asset ID",
  T_50_META_TYP_452_D: "The ID that describes the custom HUD asset",
  T_50_META_TYP_453: "Render Quality Type",
  T_50_META_TYP_453_D: "The rendering quality enum",
  T_50_META_TYPE_448_D: "This entity is used to control the skeleton part to look at a target",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D Object Generate Map",
  T_50_SD_WS_MAPTAG_AIRACING: "Racing AI Generate Map",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Animation state name enum",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Disable Footsteps Vibration",
  T_50_XXJ_WS_NOPERFORMANCE: "No performance file yet",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Beta version",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Dear creators, the performance editor is still in the testing phase. It may contain bugs or lack essential features. Please use it with caution.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Add Performance",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Add Key Clip",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Along Path Track",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animation",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Animation Track",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Audio Track",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Hold",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Loop Forever",
  T_50_XXJ_WS_TIMELINE_DURATION: "Duration: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Mismatch between animation and model",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Key clip overlap",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Bound entity missing",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "The track name cannot be empty",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC Track",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Property Track",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Remove Key Clip",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Track count limit exceeded",
  T_50_XYL_WS_AIGETERATESHOW: "Building Blocks",
  T_50_YU_F_B_VA_WITCH: "Mystic Trouble (Bottom)",
  T_50_YU_F_H_VA_WITCH: "Mystic Trouble (Head)",
  T_50_YU_F_HA_VA_WITCH: "Mystic Trouble (Facepaint)",
  T_50_YU_F_S_VA_WITCH: "Mystic Trouble (Shoes)",
  T_50_YU_F_T_VA_WITCH: "Mystic Trouble (Top)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Custom Event",
  T_51_GT_WS_BASIC: "Basic",
  T_51_GT_WS_GLOBALEVENT: "Global Event",
  T_51_GT_WS_PRIVATEEVENT: "Private Event",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Preparation time before game starts",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Read-only Property",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Jachetă neagră din piele (Feminină)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Mushroom hunter",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Activewear negru (Pantofi)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "Pantaloni Hotpants GW2018 (Feminini)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "Fustă GW2018 (Feminină)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Activewear negru (Hanorac)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Haină Songkran (Neagră)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Haină Plumber (Feminină)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "Flanelă GW2018 (Feminină)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "White Prosperity (Pantaloni)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Pantaloni de trening negri (Masculini)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Poacher",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Pantaloni Survivor",
  TXT_AVATAR_MALE_PANTS_MARIO: "Mamamia",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Pantofi Survivor",
  TXT_AVATAR_MALE_SHOE_RED: "Cizme roșii (Masculine)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "White Prosperity (Haină)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Tricou negru de baseball (Masculin)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Hanorac Rebel",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Cool Activewear (Hanorac)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Vestă Skull King",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Bluză Survivor",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Haină Plumber (Masculină)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Jachetă Racer (Feminină)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Night Clown (Cap)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Jachetă Racer (Masculină)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Jachetă Sleeveless (Verde)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Mr. Squido",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Zombified Samurai (Mască)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Full Arm Tattoo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Embrace",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Stylish & Retro",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Pantaloni Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Pantofi Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Pantofi Sports (Albaștri)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Pantaloni scurți Denim (Feminini)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Rochie Kitsune",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Pantaloni Combat (Masculini)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Pantaloni Angelic",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Pantaloni Bushido",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Hanorac gri cu fermoar",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Pantofi Hipster",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Pantofi Bushido",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Pantofi Astro",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Pantaloni scurți Denim (Masculini)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Vestă Combat (Masculină)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Haină Hipster",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Way of the Bushido",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "White Hurricane",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Baseballer (Colanți)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Jachetă Rider (Feminină)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Baseballer (Jachetă)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Cool Captain (Pantaloni)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "The Streets (Cap)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Cool Captain (Pantofi)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Jachetă Rider (Masculină)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Cool Captain (Jachetă)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Silver Boot",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Three Lions",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Tuxedo (Mască)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Tuxedo (Cap)",
  TXT_AVATAR_PARACHUTE_8: "Față Zâmbitoare",
  TXT_AVATAR_SHIRT_PLAID_2: "Programmers' Favorite (Roșu)",
  TXT_AVATAR_SHOES_1: "Teniși (Albi)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Schoolgirl (Begonie)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Schoolgirl (Roșie)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Schoolgirl (Galbenă)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Schoolgirl (Roz)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Schoolgirl (Iasomie)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Schoolgirl (Albastră)",
  TXT_AVATAR_TSHIRT_WEEK_007: "STARRY SUN",
  TXT_BANNER_NAME_MISHA: "Viteză",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Nume",
  TXT_COLLECTION_DESCRIPTION: "Descriere",
  TXT_COLLECTION_HEADPORTRAIT: "Avatar",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Echipament",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "Muniție AR",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Ghiozdan Nivel1",
  TXT_ITEM_BAG2: "Ghiozdan Nivel2",
  TXT_ITEM_BAG3: "Ghiozdan Nivel3",
  TXT_ITEM_BASEBALLPOLE: "Bâtă",
  TXT_ITEM_BOWAMMO: "Săgeată arbaletă",
  TXT_ITEM_CHANGUO: "Tigaie",
  TXT_ITEM_CROSSBOW: "Arbaletă",
  TXT_ITEM_DESC_FLASH: "Un dispozitiv exploziv care poate deruta inamicii temporar.",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Trusă medicală",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Pumn",
  TXT_ITEM_FLASH: "Grenadă de diversiune",
  TXT_ITEM_FOREGRIP1: "Mâner Nivel1",
  TXT_ITEM_FOREGRIP2: "Mâner Nivel2",
  TXT_ITEM_FOREGRIP3: "Mâner Nivel3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Grenadă",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "Tun de mână",
  TXT_ITEM_HEATSIGHT: "Lunetă termică",
  TXT_ITEM_HELMET1: "Cască Nivel1",
  TXT_ITEM_HELMET2: "Cască Nivel2",
  TXT_ITEM_HELMET3: "Cască Nivel3",
  TXT_ITEM_HGAMMO: "Muniție HG",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Parang",
  TXT_ITEM_MAGEZINE1: "Încărcător Nivel1",
  TXT_ITEM_MAGEZINE2: "Încărcător Nivel2",
  TXT_ITEM_MAGEZINE3: "Încărcător Nivel3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Compensator Nivel1",
  TXT_ITEM_MUZZLE2: "Compensator Nivel2",
  TXT_ITEM_MUZZLE3: "Compensator Nivel3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "Muniție SG",
  TXT_ITEM_SIGHT2: "Lunetă x2",
  TXT_ITEM_SIGHT4: "Lunetă x4",
  TXT_ITEM_SILENCER1: "Amortizor",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "Muniție SMG",
  TXT_ITEM_SNAMMO: "Muniție Sniper",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Vestă Nivel1",
  TXT_ITEM_VEST2: "Vestă Nivel2",
  TXT_ITEM_VEST3: "Vestă Nivel3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Rezultat",
  TXT_MESSAGEBOX_ERROR: "Eroare",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipied",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Butoi cu petrol",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Ucigaș nebun",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Mexican Grilled Corn",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Raza exploziei",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "The Executioner",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Mină",
  TXT_OB11_HQW_LANDMINE_DESC: "O mină care poate fi plasată pe pământ. Ai grijă să nu calci pe ea chiar tu!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Applause",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Chicken",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Hello!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provoke",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Viteza de mișcare crește cu {0}% atunci când ai în mâini o pușcă",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Agilitate",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Cheetah: Fang",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Futuristic",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Kit de reparație",
  TXT_OB5_HISTORY_HEADSHOOT: "Headshot-uri",
  TXT_OB5_HISTORY_LIVE: "Survival",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Mănânci ciuperci și folosești truse medicale mai repede cu {0}%.",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Gluttony",
  TXT_OB7_ZC_CLAN_NICKNAME: "Pseudonim",
  TXT_OB7_ZJS_HISTORY_TIME: "Timp",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Foc de tabără",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Bolt",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Daunele provocate de pumn cresc cu {0}%.",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Purple Meadows",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Atom Splitter",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Withered",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Skysplitter",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Snow Leopard",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Trafic de arme",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Green Star",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Gloo Wall",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Digital Camouflage",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Bloody Mary",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Desert Hunter",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Blueflame",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Purple Parade",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Lifestream",
  TXT_OB9_ZXR_M1873_NAME: "Deep Blue Sea",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Swordfish",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Harvester",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Purple Quartz",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Scorched Earth",
  TXT_OPTION_HIGH_BRIGHTNESS: "Luminos",
  TXT_PLAYER_RANK: "RANG",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Bermuda",
  TXT_SETTING_CHANGEWEAPON: "Quick Weapon Switch Button",
  TXT_SETTING_OB4_NOTREAL: "Întunecat",
  TXT_SKILL_DESC_COP: "Pierderea durabilității armurii scade cu {0}%",
  TXT_SKILL_DESC_RUNNER: "Viteza de sprint crește cu {0}%",
  TXT_SKILL_NAME_COP: "Specialist în armuri",
  TXT_SKILL_NAME_NURSE: "Atingere vindecătoare",
  TXT_SKILL_NAME_RACERGIRL: "Postcombustie",
  TXT_SKILL_NAME_RUNNER: "Elan",
  TXT_SKILL_NAME_SEAMAN: "Dorință de fier",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "Sprint",
  TXT_TUTORIAL_PICKUP_LABEL0: "Armă",
  T_34_M_WS_VFXTYPE: "Tip VFX",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Tip de țintă de atac",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Tip de UI pentru jucători",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Tip de abilitate a monștrilor",
  T_45_META_WS_DESCRIPTIVECOLOR: "Descriptive Color",
  T_45_META_WS_GAMETIME: "Game Time",
  T_45_META_WS_PROPERTY: "Property",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "Tip de stil de buton",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Tip de buton",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Accelerație",
  T_46_META_WS_A_ACCOUNTID: "ID cont",
  T_46_META_WS_A_ACTIONTYPE: "Tip acțiune",
  T_46_META_WS_A_ACTIVE: "Activ",
  T_46_META_WS_A_ANGLE: "Unghi",
  T_46_META_WS_A_ANY: "Orice",
  T_46_META_WS_A_APPEARANCEGROUP: "Grup de aspect",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Expresie de aserțiune",
  T_46_META_WS_A_ATTACHMENT: "Atașament",
  T_46_META_WS_A_ATTACHMENTS: "Lista de atașamente",
  T_46_META_WS_A_ATTACKABLE: "Poate fi atacat",
  T_46_META_WS_A_ATTACKER: "Atacator",
  T_46_META_WS_A_ATTACKTARGET: "Țintă de atac",
  T_46_META_WS_A_AUTOPLAY: "Redare automată",
  T_46_META_WS_A_AXIS: "Axa",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Bază",
  T_46_META_WS_A_BOUNDTARGET: "Țintă legată",
  T_46_META_WS_A_BTREE: "Arbore de comportament",
  T_46_META_WS_A_BUFF: "Buff",
  T_46_META_WS_A_CAMERA: "Cameră",
  T_46_META_WS_A_CAPICITY: "Capacitate",
  T_46_META_WS_A_CENTER: "Centru",
  T_46_META_WS_A_CHANGEROTATION: "Schimbă rotația",
  T_46_META_WS_A_CHANNEL: "Canal",
  T_46_META_WS_A_CHASEENEMY: "Urmărește inamicul",
  T_46_META_WS_A_CHILD: "Copil",
  T_46_META_WS_A_COLOR: "Culoare",
  T_46_META_WS_A_COLUMN: "Coloană",
  T_46_META_WS_A_COLUMNNAME: "Nume coloană",
  T_46_META_WS_A_COMEBACK: "Revenire",
  T_46_META_WS_A_COMPONENT: "Componentă",
  T_46_META_WS_A_CONTENT: "Conținut",
  T_46_META_WS_A_COORDINATESYSTEM: "Sistem de coordonate",
  T_46_META_WS_A_COUNT: "Număr",
  T_46_META_WS_A_COUNTS: "Număr",
  T_46_META_WS_A_CREATEDENTITY: "Entitate creată",
  T_46_META_WS_A_CROSSPLATFORM: "Cross-platform",
  T_46_META_WS_A_CULLINGMASK: "Masca de culling",
  T_46_META_WS_A_CURVE: "Curbă",
  T_46_META_WS_A_CUSTOMTAG: "Etichetă personalizată",
  T_46_META_WS_A_CUTRADIUS: "Rază de tăiere",
  T_46_META_WS_A_DAMAGE: "Dăunare",
  T_46_META_WS_A_DAMAGESEGMENTS: "Segmente de daune",
  T_46_META_WS_A_DEGREE: "Grad",
  T_46_META_WS_A_DELTA: "Delta",
  T_46_META_WS_A_DEPTH: "Adâncime",
  T_46_META_WS_A_DESTVAL: "Valoare destinație",
  T_46_META_WS_A_DIFFICULTY: "Dificultate",
  T_46_META_WS_A_DIRECTION: "Direcție",
  T_46_META_WS_A_DISABLE: "Dezactivat",
  T_46_META_WS_A_DISPLACEMENT: "Deplasare",
  T_46_META_WS_A_DISTANCE: "Distanță",
  T_46_META_WS_A_DIVINGMAXSPEED: "Viteza maximă de scufundare",
  T_46_META_WS_A_DOTWEEN: "Aplică tween",
  T_46_META_WS_A_DURATION: "Durată (s)",
  T_46_META_WS_A_EMOTE: "Emoticon",
  T_46_META_WS_A_ENABLE: "Activare",
  T_46_META_WS_A_ENDAREACENTER: "Centru zona de sfârșit",
  T_46_META_WS_A_ENDAREARANGE: "Interval zona de sfârșit",
  T_46_META_WS_A_ENDPOSITION: "Poziția de sfârșit",
  T_46_META_WS_A_ENDRANK: "Rang de sfârșit",
  T_46_META_WS_A_EQUIPMENTS: "Echipamente",
  T_46_META_WS_A_EVENTID: "ID Eveniment",
  T_46_META_WS_A_EXPONENT: "Exponent",
  T_46_META_WS_A_FACTION: "Facțiune",
  T_46_META_WS_A_FACTORTYPE: "Tip Factor",
  T_46_META_WS_A_FILTERTYPE: "Tip de filtru",
  T_46_META_WS_A_FINALRADIUS: "Rază finală",
  T_46_META_WS_A_FINDVALUE: "Găsește valoarea",
  T_46_META_WS_A_FIXEDRANGE: "Gama fixă",
  T_46_META_WS_A_FOLLOWTARGET: "Urmărește ținta",
  T_46_META_WS_A_FONTCOLOR: "Culoarea fontului",
  T_46_META_WS_A_FONTSIZE: "Dimensiunea fontului",
  T_46_META_WS_A_FOOTBALL: "Fotbal",
  T_46_META_WS_A_FORCE: "Forță",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Înălțimea minimă a parașutei",
  T_46_META_WS_A_FORCEMODE: "Mod forță",
  T_46_META_WS_A_FORWARD: "Înainte",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "ID joc",
  T_46_META_WS_A_HALFEXTENTS: "Jumătate din dimensiuni",
  T_46_META_WS_A_HEIGHT: "Înălțime",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Segmente de înălțime",
  T_46_META_WS_A_HITDISTANCE: "Distanța lovită",
  T_46_META_WS_A_HITDISTANCES: "Distanțe de lovire",
  T_46_META_WS_A_HITENTITIES: "Entități lovite",
  T_46_META_WS_A_HITENTITY: "Entitate lovită",
  T_46_META_WS_A_HITNORMAL: "Normală de lovire",
  T_46_META_WS_A_HITNORMALS: "Normale de lovire",
  T_46_META_WS_A_HITPOINTS: "Puncte de lovire",
  T_46_META_WS_A_HITPOSITION: "Poziția lovită",
  T_46_META_WS_A_INCLUDETRIGGER: "Include declanșator",
  T_46_META_WS_A_INDEX: "Index",
  T_46_META_WS_A_INDEXS: "Indexuri",
  T_46_META_WS_A_INITIALVELOCITY: "Viteză inițială",
  T_46_META_WS_A_INITRADIUS: "Rază inițială",
  T_46_META_WS_A_INWALLET: "Bani intrați",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Este coliziune de jos",
  T_46_META_WS_A_ISEXIST: "Existență",
  T_46_META_WS_A_ISLOOP: "Este buclă",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Este mapat pe ecran",
  T_46_META_WS_A_ISPAUSE: "Pauză",
  T_46_META_WS_A_ISSIDECOLLIDING: "Este coliziune laterală",
  T_46_META_WS_A_ISSUCCESS: "Succes",
  T_46_META_WS_A_ISTOPCOLLIDING: "Este coliziune de sus",
  T_46_META_WS_A_ITEM: "Obiect",
  T_46_META_WS_A_ITEMID: "ID obiect",
  T_46_META_WS_A_ITEMS: "Obiecte",
  T_46_META_WS_A_ITEMTYPE: "Tip obiect",
  T_46_META_WS_A_JERSEYTYPE: "Tip de tricou",
  T_46_META_WS_A_KEEPVELOCITY: "Menține viteza",
  T_46_META_WS_A_KEY: "Cheie",
  T_46_META_WS_A_KEYCOLUMN: "Coloană cheie",
  T_46_META_WS_A_KEYS: "Chei",
  T_46_META_WS_A_LAYER: "Strat",
  T_46_META_WS_A_LAYERMASK: "Mască strat",
  T_46_META_WS_A_LEFT: "Stânga",
  T_46_META_WS_A_LEFTVALUE: "Valoare stânga",
  T_46_META_WS_A_LENGTH: "Lungime",
  T_46_META_WS_A_LEVELOBJECT: "Obiect de nivel",
  T_46_META_WS_A_LOG: "Jurnal",
  T_46_META_WS_A_LOOKATTARGET: "Privește ținta",
  T_46_META_WS_A_LOOPTYPE: "Tip de buclă",
  T_46_META_WS_A_MAINCOLOR1: "Culoare principală1",
  T_46_META_WS_A_MAINCOLOR2: "Culoare principală2",
  T_46_META_WS_A_MAPCODE: "Cod hartă",
  T_46_META_WS_A_MAPPEDPOSITION: "Poziția mapată",
  T_46_META_WS_A_MAX: "Maxim",
  T_46_META_WS_A_MAXDISPLACEMENT: "Deplasare maximă",
  T_46_META_WS_A_MAXDISTANCE: "Distanța maximă",
  T_46_META_WS_A_MIN: "Minim",
  T_46_META_WS_A_MISSIONID: "ID Misiune",
  T_46_META_WS_A_MISSIONPROGRESS: "Progres misiune",
  T_46_META_WS_A_MODIFYTYPE: "Tip modificare",
  T_46_META_WS_A_MONEYTYPE: "Tip de bani",
  T_46_META_WS_A_MUST: "Trebuie",
  T_46_META_WS_A_NAME: "Nume",
  T_46_META_WS_A_NEWVALUE: "Valoare nouă",
  T_46_META_WS_A_NODE: "Nod",
  T_46_META_WS_A_NORMAL: "Normal",
  T_46_META_WS_A_NOT: "Nu",
  T_46_META_WS_A_OBSERVER: "Observator",
  T_46_META_WS_A_OFFSET: "Compensare",
  T_46_META_WS_A_OLDVALUE: "Valoare veche",
  T_46_META_WS_A_OPERATIOMETHOD: "Metodă de operare",
  T_46_META_WS_A_OPTIONS: "Opțiuni",
  T_46_META_WS_A_OTHERCOLOR: "Altă culoare",
  T_46_META_WS_A_OUTFIT: "Ținută",
  T_46_META_WS_A_OUTFITS: "Lista ținutelor",
  T_46_META_WS_A_OUTWALLET: "Bani ieșiți",
  T_46_META_WS_A_OWNER: "Proprietar",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Viteza maximă de parașutare",
  T_46_META_WS_A_PARAMS: "Parametri",
  T_46_META_WS_A_PARENT: "Părinte",
  T_46_META_WS_A_PARENTWIDGET: "Widget părinte",
  T_46_META_WS_A_PATH: "Cale",
  T_46_META_WS_A_PATHPOINTS: "Puncte de traseu",
  T_46_META_WS_A_PHASEINDEX: "Indice de fază",
  T_46_META_WS_A_PLATFORM: "Platformă",
  T_46_META_WS_A_PLAYER: "Jucător",
  T_46_META_WS_A_PLAYSPEED: "Viteză de redare",
  T_46_META_WS_A_POSITION: "Poziție",
  T_46_META_WS_A_POSITIONS: "Poziții",
  T_46_META_WS_A_POSTION: "Poziție",
  T_46_META_WS_A_PREFAB: "Prefab",
  T_46_META_WS_A_PROPERTY: "Proprietate",
  T_46_META_WS_A_PROPERTYID: "ID Proprietate",
  T_46_META_WS_A_PURSUITTARGET: "Țintă de urmărire",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Rază",
  T_46_META_WS_A_RANDOMDECAY: "Atenuare aleatorie",
  T_46_META_WS_A_RANDOMRANGE: "Interval aleatoriu",
  T_46_META_WS_A_RANDOMRATIO: "Raport aleatoriu",
  T_46_META_WS_A_RANGE: "Gama",
  T_46_META_WS_A_RANK: "Rang",
  T_46_META_WS_A_REALCOIN: "Monedă reală",
  T_46_META_WS_A_REALNUMBER: "Număr real",
  T_46_META_WS_A_RESET: "Resetează",
  T_46_META_WS_A_RESOURCE: "Resurse",
  T_46_META_WS_A_RESULT: "Rezultat",
  T_46_META_WS_A_RIGHT: "Dreapta",
  T_46_META_WS_A_RIGHTVALUE: "Valoare dreapta",
  T_46_META_WS_A_ROTATION: "Rotire",
  T_46_META_WS_A_ROW: "Rând",
  T_46_META_WS_A_SAMPLEPOINT: "Punct de eșantionare",
  T_46_META_WS_A_SCALE: "Scară",
  T_46_META_WS_A_SCENEID: "ID Scenă",
  T_46_META_WS_A_SCORE: "Scor",
  T_46_META_WS_A_SCORENAME: "Nume scor",
  T_46_META_WS_A_SCREENPOSITION: "Poziția pe ecran",
  T_46_META_WS_A_SCRIPT: "Script",
  T_46_META_WS_A_SEAT: "Loc",
  T_46_META_WS_A_SEP: "Sep",
  T_46_META_WS_A_SEPSTR: "Separator",
  T_46_META_WS_A_SHEETNAME: "Nume foaie",
  T_46_META_WS_A_SHOPITEM: "Articol de magazin",
  T_46_META_WS_A_SHOWBACKGROUND: "Afișează fundal",
  T_46_META_WS_A_SHOWMATCHRESULT: "Afișează rezultatul jocului",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Afișează mesajul la anulare",
  T_46_META_WS_A_SKILL: "Abilitate",
  T_46_META_WS_A_SKILLS: "Abilități",
  T_46_META_WS_A_SKILLTARGET: "Țintă a abilității",
  T_46_META_WS_A_SKIN: "Piele",
  T_46_META_WS_A_SLOT: "Slot",
  T_46_META_WS_A_SRCVAL: "Valoare sursă",
  T_46_META_WS_A_SRCVALUE: "Valoare sursă",
  T_46_META_WS_A_STARTAREACENTER: "Centru zona de început",
  T_46_META_WS_A_STARTAREARANGE: "Interval zona de început",
  T_46_META_WS_A_STARTINDEX: "Index de început",
  T_46_META_WS_A_STARTPOSITION: "Poziție de început",
  T_46_META_WS_A_STARTRANK: "Rang de început",
  T_46_META_WS_A_STATE: "Stare",
  T_46_META_WS_A_STATUS: "Stare",
  T_46_META_WS_A_STATUSCODE: "Cod de stare",
  T_46_META_WS_A_STYLE: "Stil",
  T_46_META_WS_A_SURFINGMAXSPEED: "Viteza maximă de surfing",
  T_46_META_WS_A_TARGET: "Țintă",
  T_46_META_WS_A_TARGETPOSITION: "Poziție țintă",
  T_46_META_WS_A_TEAMSEQ: "Secvență echipă",
  T_46_META_WS_A_THRESHOLD: "Prag",
  T_46_META_WS_A_TIMESTAMP: "Marcaj de timp",
  T_46_META_WS_A_TIPS: "Sfaturi",
  T_46_META_WS_A_TITLE: "Titlu",
  T_46_META_WS_A_TOKENCOUNT: "Număr de Token",
  T_46_META_WS_A_TOKENID: "ID Token",
  T_46_META_WS_A_TORQUE: "Cuplu",
  T_46_META_WS_A_TOUCHPOINT: "Punct de contact",
  T_46_META_WS_A_TRANSITIONTIME: "Timp de tranziție (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "Tip de tranziție",
  T_46_META_WS_A_TRIGGER: "Declanșator",
  T_46_META_WS_A_TYPE: "Tip",
  T_46_META_WS_A_UI: "Interfață",
  T_46_META_WS_A_UIID: "ID UI",
  T_46_META_WS_A_UPWARD: "În sus",
  T_46_META_WS_A_VALUE: "Valoare",
  T_46_META_WS_A_VALUEA: "Valoare A",
  T_46_META_WS_A_VALUEB: "Valoare B",
  T_46_META_WS_A_VALUES: "Valori",
  T_46_META_WS_A_VALUET: "Valoare T",
  T_46_META_WS_A_VALUETYPE: "Tip de valoare",
  T_46_META_WS_A_VEHICLE: "Vehicul",
  T_46_META_WS_A_VEHICLESKIN: "Pielea vehiculului",
  T_46_META_WS_A_VELOCITY: "Viteză",
  T_46_META_WS_A_VELOCITYXZ: "Viteză XZ",
  T_46_META_WS_A_VELOCITYY: "Viteză Y",
  T_46_META_WS_A_VISIBLE: "Vizibil",
  T_46_META_WS_A_WAITTIME: "Timp de așteptare (s)",
  T_46_META_WS_A_WALLET: "Portofel",
  T_46_META_WS_A_WEAPON: "Armă",
  T_46_META_WS_A_WEAPONSKIN: "Skin armă",
  T_46_META_WS_A_WIDGETID: "ID Widget",
  T_46_META_WS_A_WIDGETTYPE: "Tip widget",
  T_46_META_WS_A_WIDTH: "Lățime",
  T_46_META_WS_A_WORLDPOSITION: "Poziția în lume",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Menține poziția în lume",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Valoare absolută",
  T_46_META_WS_ACOS: "ACos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Adaugă urmărire specială AOI",
  T_46_META_WS_ADDATTACHMENTS: "Adaugă accesorii",
  T_46_META_WS_ADDBUFF: "Adaugă buff",
  T_46_META_WS_ADDCOMPONENT: "Adaugă componentă",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Adaugă viteză fotbal",
  T_46_META_WS_ADDFORCE: "Adaugă forță",
  T_46_META_WS_ADDFORCEATPOSITION: "Adaugă forță la poziție",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Adaugă factor proprietate formulă",
  T_46_META_WS_ADDGAMEEVENTLOG: "Adaugă jurnal de evenimente de joc",
  T_46_META_WS_ADDHP: "Adaugă HP",
  T_46_META_WS_ADDITEM: "Adaugă obiect",
  T_46_META_WS_ADDITEMINSCENE: "Creează obiect în scenă",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Adaugă articol la articol magazin",
  T_46_META_WS_ADDMONEY: "Adaugă bani",
  T_46_META_WS_ADDSCRIPT: "Adaugă script",
  T_46_META_WS_ADDTAG: "Adaugă etichetă",
  T_46_META_WS_ADDTOKEN: "Adaugă token",
  T_46_META_WS_ADDTORQUE: "Adaugă moment",
  T_46_META_WS_ADDUSEREVENTLOG: "Adaugă jurnal de evenimente al utilizatorului",
  T_46_META_WS_ANGEL: "Unghi",
  T_46_META_WS_APPEND: "Adaugă",
  T_46_META_WS_APPENDRANGE: "Adaugă interval",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Aplică configurația de ieșire intermediară",
  T_46_META_WS_ASIN: "ASin",
  T_46_META_WS_ASSERT: "Afirmă",
  T_46_META_WS_ASSISTPLAYER: "Jucător asistent",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Atacator",
  T_46_META_WS_ATTACKTARGET: "Țintă de atac",
  T_46_META_WS_AXISANGLETOQUATERNION: "Unghi de axă la Quaternion",
  T_46_META_WS_BOXCAST: "Detectare cu cutie",
  T_46_META_WS_BOXOVERLAP: "Verificare suprapunere cutie",
  T_46_META_WS_BUTTONNAME: "Nume buton",
  T_46_META_WS_C_ACTIONTYPE: "Tipul acțiunii",
  T_46_META_WS_C_AIMABLE: "Componenta care poate fi vizat",
  T_46_META_WS_C_AIMASSISTABLE: "Componente asistat pentru viziune",
  T_46_META_WS_C_AIMASSISTTYPE: "Tipul de Asistență la Țintire",
  T_46_META_WS_C_AIRDROP: "Aero-drop",
  T_46_META_WS_C_AMMO: "Muniții",
  T_46_META_WS_C_AMMOTYPE: "Tipul de Muniție",
  T_46_META_WS_C_AMPHIBIAN: "Amphibian",
  T_46_META_WS_C_ANIMATIONCLIP: "Clip animație",
  T_46_META_WS_C_ANIMATIONCLIPID: "ID-ul Clipului de Animație",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Controler animație",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Controler de animație atașabil",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "ID-ul Controlerului de Animație",
  T_46_META_WS_C_ANIMATIONSTATE: "Stare animație",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Declanșator animație",
  T_46_META_WS_C_APPEARENCE: "Aparență",
  T_46_META_WS_C_ASSETCONFIGID: "ID-ul configurării activului",
  T_46_META_WS_C_ASSETID: "ID-ul activului",
  T_46_META_WS_C_ATTACHMENT: "Atașament",
  T_46_META_WS_C_ATTACKABLETYPE: "Tip de atacabil",
  T_46_META_WS_C_AUDIOID: "ID-ul Audio",
  T_46_META_WS_C_BACKPACK: "Rucsac",
  T_46_META_WS_C_BACKPACKSKINID: "ID-ul skin-ului de rucsac",
  T_46_META_WS_C_BASEDATAALIAS: "Alias de Date de Bază",
  T_46_META_WS_C_BASICAPPEARANCE: "Aspect de bază",
  T_46_META_WS_C_BASICCYLINDER: "Cilindru sau con de bază",
  T_46_META_WS_C_BASICSCALABLE: "Scalabil de bază",
  T_46_META_WS_C_BASICSPHERE: "Sferă de bază",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Componenta de combinare prin lot",
  T_46_META_WS_C_BEVTREE: "Arbore comportamental",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Entitate atașabilă arborelui comportamental",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Nod personalizat de arbore comportamental",
  T_46_META_WS_C_BEVTREEID: "ID arbore comportamental",
  T_46_META_WS_C_BEVTREENODESTATUS: "Stare de execuție a nodului de arbore comportamental",
  T_46_META_WS_C_BEVTREENODETYPE: "Tip de nod de arbore comportamental",
  T_46_META_WS_C_BEZIERCURVE: "Curba Bezier",
  T_46_META_WS_C_BOOL: "Bool",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Tip de Dificultate Bot",
  T_46_META_WS_C_BOUNCINGTIRE: "Roată care sare",
  T_46_META_WS_C_BUFFABLE: "Buffabil",
  T_46_META_WS_C_BUFFGENERATOR: "Generator de buff",
  T_46_META_WS_C_BUFFTYPE: "Tipul Buff-ului",
  T_46_META_WS_C_BUILTINRENDER: "Redare încorporată",
  T_46_META_WS_C_BUILTINUI: "UI Încorporat",
  T_46_META_WS_C_BUILTINUITYPE: "Tipul UI Încorporat",
  T_46_META_WS_C_CAMERA: "Cameră",
  T_46_META_WS_C_CAMERABLOCKMODE: "Modul Blocare Cameră",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Modul Proiecție Cameră",
  T_46_META_WS_C_CAMERARAYCASTUI: "Interfața RayCast a Camerei",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Tip de tranziție a camerei",
  T_46_META_WS_C_CAMERATYPE: "Tipul camerei",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Tip Restricție Unghi de Vizualizare Cameră",
  T_46_META_WS_C_CAPSULETRIGGER: "Declanșator capsule",
  T_46_META_WS_C_CAR: "Mașină",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Controler de Personaj",
  T_46_META_WS_C_CHATCHANNEL: "Canal de chat",
  T_46_META_WS_C_CHATCHANNELTYPE: "Tip canal chat",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Declanșator de Punct de Control",
  T_46_META_WS_C_COINGENERATOR: "Generator de monede",
  T_46_META_WS_C_COLLECTIONID: "ID-ul colecției",
  T_46_META_WS_C_COLLIDER: "Container",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Formă colizor",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ID-ul Colectării Collider",
  T_46_META_WS_C_COLORDRUM: "Toba colorată",
  T_46_META_WS_C_COMBATABLE: "Combatabil",
  T_46_META_WS_C_COMPONENT: "Componentă",
  T_46_META_WS_C_CONDITION: "Condiție",
  T_46_META_WS_C_CONTAINER: "Contenitor",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Tipul sistemului de coordonate",
  T_46_META_WS_C_CROSSBOW: "Grenadă Arbaletă",
  T_46_META_WS_C_CSVID: "ID CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Declanșator Personalizat",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Obiect personalizat",
  T_46_META_WS_C_CUSTOMPATH: "Cale customizată",
  T_46_META_WS_C_CUSTOMUI: "UI Personalizat",
  T_46_META_WS_C_CUSTOMUIID: "معرف واجهة المستخدم المخصصة",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "UI Personalizat sau Widget",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "ID-ul Widget-ului UI Personalizat",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Tip de Parte a Corpului Deteriorat",
  T_46_META_WS_C_DAMAGETYPE: "Tipul de Daune",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Declanșator de Moarte sau Invincibilitate",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Obiect destructibil",
  T_46_META_WS_C_DICE: "Zaruri",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Pantofi cu dublu salt",
  T_46_META_WS_C_DRUMMUSIC: "Muzică de tambur",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Tipul de Armă Dual-Wield",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Obiect de nivel comun",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Tipul obiectului de nivel creat dinamic",
  T_46_META_WS_C_DYNAMICFENCE: "Gard Dinamic",
  T_46_META_WS_C_EFFECT: "Efect",
  T_46_META_WS_C_EFFECTCONTAINER: "Container pentru Efecte",
  T_46_META_WS_C_EFFECTID: "ID-ul Efectului",
  T_46_META_WS_C_EMOTETYPE: "Tip de Emoție",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Declanșator de Punct Final",
  T_46_META_WS_C_ENTITY: "Entitate",
  T_46_META_WS_C_ENTITYORPREFABID: "Entitate sau ID de Prefab",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Accesoriu de Echipament",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Tipul de Slot de Echipament",
  T_46_META_WS_C_EQUIPMENTTYPE: "Tipul de Echipament",
  T_46_META_WS_C_EVENTID: "ID Eveniment",
  T_46_META_WS_C_FACTION: "Facțiune",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Tip direcție umplere",
  T_46_META_WS_C_FILLTYPE: "Tip umplere",
  T_46_META_WS_C_FIRETYPE: "Tipul de Foc",
  T_46_META_WS_C_FLOAT: "Float",
  T_46_META_WS_C_FOLDWING: "Aripi pliante",
  T_46_META_WS_C_FOLLOW: "Urmărește",
  T_46_META_WS_C_FONTTYPE: "Tipul fontului",
  T_46_META_WS_C_FOOTBALL: "Fotbal",
  T_46_META_WS_C_FORCETYPE: "Tipul Forței",
  T_46_META_WS_C_FORMULABLE: "Formulabil",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Auto-referință pe cadru",
  T_46_META_WS_C_GAMERESULTTYPE: "Tipul rezultatului jocului",
  T_46_META_WS_C_GENDERTYPE: "Tipul de Gen",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Punct de apariție general",
  T_46_META_WS_C_GRENADEDEICEWALL: "Granada DeIce Wall",
  T_46_META_WS_C_GRENADEFLASHBANG: "Grenadă flashbang",
  T_46_META_WS_C_GRENADEFROZEN: "Grenadă înghețată",
  T_46_META_WS_C_GRENADELAUNCHER: "Lansator de Grenade",
  T_46_META_WS_C_GRENADESMOKE: "Grenadă fumigenă",
  T_46_META_WS_C_GRENADEWEAPON: "Baza Grenadă",
  T_46_META_WS_C_GRID: "Grilă",
  T_46_META_WS_C_HANDCANNON: "Granada de Mão",
  T_46_META_WS_C_HELMET: "Casca",
  T_46_META_WS_C_HIERARCHICAL: "Ierarhic",
  T_46_META_WS_C_HOOKGUN: "Pistol cu cârlig",
  T_46_META_WS_C_HORIZALINE: "Linie Orizontală",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "Transformare UI",
  T_46_META_WS_C_HUMANMODELID: "ID-ul modelului uman",
  T_46_META_WS_C_ICEWALL: "Zid de gheață",
  T_46_META_WS_C_ICEWALLCREATED: "Zid de gheață creat",
  T_46_META_WS_C_ICEWALLMAKER: "Creator de Perete de Gheață",
  T_46_META_WS_C_ICON: "Entitate icon",
  T_46_META_WS_C_ICONTYPE: "Tipul de Icon",
  T_46_META_WS_C_INHALER: "Inhalator",
  T_46_META_WS_C_INT: "Întreg",
  T_46_META_WS_C_INT64: "Întreg 64-bit",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Șablon Hartă Întregi",
  T_46_META_WS_C_INTORINTLIST: "Întreg sau Listă de Întregi",
  T_46_META_WS_C_INVENTORYTYPE: "Tipul de Inventar",
  T_46_META_WS_C_ITEMBASE: "Bază de Date",
  T_46_META_WS_C_ITEMCONTAINER: "Containere de Articole",
  T_46_META_WS_C_ITEMID: "ID-ul obiectului",
  T_46_META_WS_C_ITEMIDTYPE: "Tipul ID Articolului",
  "T_46_META_WS_C_JERSEY STYLE": "Stil de Tricou",
  T_46_META_WS_C_JERSEYMACHINE: "Mașină de Tricouri",
  T_46_META_WS_C_JETSHOES: "Pantofi cu jet",
  T_46_META_WS_C_KEYBOARD: "Tastatură",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Tipul de Knock-down",
  T_46_META_WS_C_LANDMINE: "Mină de teren",
  T_46_META_WS_C_LANDMINECREATED: "Mină creată",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Obiect Nivel de Platformă de Lansare",
  T_46_META_WS_C_LAUNCHPAD: "Rampă de Lansare",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Tip sortare layout",
  T_46_META_WS_C_LEAD1MUSIC: "Muzică Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "Muzică Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "Muzică Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "ID-ul obiectului de nivel",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Tipul Obiectului de Nivel",
  T_46_META_WS_C_LIST: "Listă",
  T_46_META_WS_C_LISTORMAP: "Listă sau Hartă",
  T_46_META_WS_C_LISTT: "Șablon de listă",
  T_46_META_WS_C_LISTT_BOOL: "Listă de Booleani",
  T_46_META_WS_C_LISTT_CONDITION: "Listă de Condiții",
  T_46_META_WS_C_LISTT_ENTITY: "Lista Entităților",
  T_46_META_WS_C_LISTT_FLOAT: "Listă cu virgula",
  T_46_META_WS_C_LISTT_INT: "Listă de Întregi",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Lista de Obiecte",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Lista Obiectelor de Nivel",
  T_46_META_WS_C_LISTT_LOCKEY: "Listă chei localizare",
  T_46_META_WS_C_LISTT_PLAYABLE: "Listă de obiecte jucabile",
  T_46_META_WS_C_LISTT_PLAYER: "Lista Jucătorilor",
  T_46_META_WS_C_LISTT_SKILLID: "Listă ID de abilitate",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Lista Efecte Sonore",
  T_46_META_WS_C_LISTT_STRING: "Listă de șiruri",
  T_46_META_WS_C_LISTT_TEAM: "Lista Echipei",
  T_46_META_WS_C_LISTT_TYPE: "Listă de Tipuri",
  T_46_META_WS_C_LISTT_VECTOR3: "Listă Vector3",
  T_46_META_WS_C_LOCKEY: "Cheie de Localizare",
  T_46_META_WS_C_LOOKAT: "Privește",
  T_46_META_WS_C_LOOPABLE: "Loopabil",
  T_46_META_WS_C_LOOPTYPE: "Tip loop",
  T_46_META_WS_C_LOOTAMMOTYPE: "Tipul muniției de loot",
  T_46_META_WS_C_LOOTARMOR: "Loot Armură",
  T_46_META_WS_C_LOOTARMORTYPE: "Tipul armurii de loot",
  T_46_META_WS_C_LOOTCONSUMABLE: "Loot Consumabil",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Tipul consumabilului de loot",
  T_46_META_WS_C_LOOTIAMMO: "Loot Muniție",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Cutie de loot fotbal",
  T_46_META_WS_C_LOOTSCOPE: "Loot Scară",
  T_46_META_WS_C_LOOTSCOPETYPE: "Tipul scării de loot",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Tip de loot fotbal",
  T_46_META_WS_C_LOOTTHROWABLE: "Loot Obiect aruncabil",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Tipul obiectului aruncabil de loot",
  T_46_META_WS_C_LOOTWEAPON: "Loot Arma",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Tipul armei de loot",
  T_46_META_WS_C_LOWGRAVITY: "Zonă cu gravitație scăzută",
  T_46_META_WS_C_MAP: "Hartă",
  T_46_META_WS_C_MAPT: "Șablon de hartă",
  T_46_META_WS_C_MATERIALID: "ID-ul Materialului",
  T_46_META_WS_C_MEDKIT: "Kit de Primă Ajutor",
  T_46_META_WS_C_MESHID: "ID-ul Mesh-ului",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Configurare Ieșire în Timpul Jocului",
  T_46_META_WS_C_MINIMAP: "Mini hartă",
  T_46_META_WS_C_MINIMAPICON: "Iconiță mini hartă",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Renderer de pixel pentru minimap",
  T_46_META_WS_C_MINISENTRY: "Mini Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Tipul razei de atac Mini Sentry",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini Sentry creat",
  T_46_META_WS_C_MONEY: "Bani",
  T_46_META_WS_C_MONEYTYPE: "Tipul de bani",
  T_46_META_WS_C_MONSTER: "Monstru",
  T_46_META_WS_C_MONSTERSPAWN: "Generare de Monștri",
  T_46_META_WS_C_MONSTERTYPE: "Tipul de Monstru",
  T_46_META_WS_C_MORPHABLEOBJECT: "Obiect morfabil",
  T_46_META_WS_C_MORPHOBJECT: "Obiect de morfare",
  T_46_META_WS_C_MOTOBIKE: "Motocicletă",
  T_46_META_WS_C_MOVEPLATFORM: "Platformă de mișcare",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Tip de platformă de mișcare",
  T_46_META_WS_C_MUSHROOM: "Ciupercă",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Constanta Naturală",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Număr",
  T_46_META_WS_C_OBJECT: "Obiect",
  T_46_META_WS_C_OILDRUM: "Tambur de ulei",
  T_46_META_WS_C_OUTFITID: "ID-ul ținutei",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Tipul slotului de îmbrăcăminte",
  T_46_META_WS_C_PATHPOINT: "Punctul de Drum",
  T_46_META_WS_C_PATROLSTYLETYPE: "Tipul de Stil de Patrulare",
  T_46_META_WS_C_PATROLTYPE: "Tipul de Patrulare",
  T_46_META_WS_C_PERSONA: "Persoană",
  T_46_META_WS_C_PHASE: "Fază",
  T_46_META_WS_C_PHYSICALMOVER: "Dispozitiv Fizic de Mișcare",
  T_46_META_WS_C_PHYSICALOBJECT: "Obiect Fizic",
  T_46_META_WS_C_PLATFORMTYPE: "Tip Platformă",
  T_46_META_WS_C_PLAYABLE: "Jucabil",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Playable sau Playables",
  T_46_META_WS_C_PLAYER: "Jucător",
  T_46_META_WS_C_PLAYERBACKPACK: "Rucsac pentru jucător",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Tip de stare a comportamentului jucătorului",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Tip comportament al jucător",
  T_46_META_WS_C_PLAYERCCT: "CCT-ul Jucătorului",
  T_46_META_WS_C_PLAYERDATAID: "Tipul Personajului Preset",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Jucător sau Transformare",
  T_46_META_WS_C_PLAYERORVEHICLE: "Jucător sau Vehicul",
  T_46_META_WS_C_PLAYEROUTFIT: "Îmbrăcăminte Jucătorului",
  T_46_META_WS_C_PLAYERPOSETYPE: "Tipul Pozei Jucătorului",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Tipul de Sursă de Revitalizare a Jucătorului",
  T_46_META_WS_C_PLAYERSTATETYPE: "Tipul Stării Jucătorului",
  T_46_META_WS_C_POINTLIGHT: "Lumină punctiformă",
  T_46_META_WS_C_PORTAL: "Portal",
  T_46_META_WS_C_PREFABID: "ID-ul Prefab-ului",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Generator de Efecte pentru Prezentare",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Tipul de Textură pentru Efecte",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Widget pentru Fotografia de Profil",
  T_46_META_WS_C_PROPERTY: "Proprietate",
  T_46_META_WS_C_PROPERTYFORMULA: "Formula de proprietăți",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Tipul factorului formulei de proprietăți",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Tipul de modificare a proprietății",
  T_46_META_WS_C_QUATERNION: "Quaternion",
  T_46_META_WS_C_RANKABLE: "Clasificabil",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Tip strat ray cast",
  T_46_META_WS_C_REPAIRKIT: "Kit de reparație",
  T_46_META_WS_C_RESETABLE: "Resetabil",
  T_46_META_WS_C_RIGIDBODY: "Rigidbody",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Tipul de Restricție Rigidbody",
  T_46_META_WS_C_RIGIDBODYTYPE: "Tipul Rigidbody",
  T_46_META_WS_C_ROUND: "Rundă",
  T_46_META_WS_C_SAFEZONE: "Zonă sigură",
  T_46_META_WS_C_SCOREABLE: "Evaluabil",
  T_46_META_WS_C_SCRIPTID: "ID-ul Scriptului",
  T_46_META_WS_C_SEATTYPE: "Tip de scaun",
  T_46_META_WS_C_SELFRELATIVE: "Auto-referință",
  T_46_META_WS_C_SHOP: "Magazin",
  T_46_META_WS_C_SHOPITEM: "Element de magazin",
  T_46_META_WS_C_SHOPSHELF: "Raft de magazin",
  T_46_META_WS_C_SKATEBOARD: "Skateboard",
  T_46_META_WS_C_SKELETON: "Schelet",
  T_46_META_WS_C_SKELETONPART: "Parte a scheletro",
  T_46_META_WS_C_SKILLID: "ID de abilitate",
  T_46_META_WS_C_SKYBLASTER: "Aparat de zbor",
  T_46_META_WS_C_SKYBOX: "Cutie de cer",
  T_46_META_WS_C_SKYBOXTYPE: "Tip de skybox",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Bulă de Neve de Insula Socială",
  T_46_META_WS_C_SORTTYPE: "Tipul de Sortare",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Tip de sunet de tobă",
  T_46_META_WS_C_SOUNDEFFECT: "Efect Sonor",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Efect Sonor sau Lista Efecte Sonore",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Tipul de Efect Sonor",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Tip de sunet Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Tip de sunet Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Tip de sunet Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Tip de sunet de pian",
  T_46_META_WS_C_SPAWN: "Spawn",
  T_46_META_WS_C_SPAWNABLE: "Spawnabil",
  T_46_META_WS_C_SPAWNBOX: "Cutie de Generare",
  T_46_META_WS_C_SPAWNPOSITION: "Punct de Generare",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Tipul ID Articolului Special",
  T_46_META_WS_C_SPHERETRIGGER: "Declanșator sferic",
  T_46_META_WS_C_SPORTSCAR: "Mașină sport",
  T_46_META_WS_C_SPRAYCOLOR: "Culoare spray",
  T_46_META_WS_C_SPRAYGUN: "Spray gun",
  T_46_META_WS_C_SPRAYRESULTUI: "UI rezultat spray",
  T_46_META_WS_C_SPRAYRIFLE: "Spray rifle",
  T_46_META_WS_C_SPRITEID: "ID-ul Sprite-ului",
  T_46_META_WS_C_STATICSCRIPTID: "ID-ul Scriptului Static",
  T_46_META_WS_C_STRING: "Șir",
  T_46_META_WS_C_STRINGORLOCSTRING: "Șir sau Șir Localizat",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Declanșator de Cutie de Provizii",
  T_46_META_WS_C_SWINGGUN: "Arma de balans",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Schimbarea slotului de echipament",
  T_46_META_WS_C_TEAM: "Echipa",
  T_46_META_WS_C_TERRAIN: "Teren",
  T_46_META_WS_C_TEXT: "Entitate text",
  T_46_META_WS_C_TEXTUREID: "ID-ul Texturii",
  T_46_META_WS_C_TEXTURETYPE: "Textura Obiectului",
  T_46_META_WS_C_TIMER: "Cronometru",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Tip Format Stil",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Șir de localizare a timestamp-ului",
  T_46_META_WS_C_TRAJECTORY: "Traiectorie",
  T_46_META_WS_C_TRANSFORM: "Transforma",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Turn",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Curba Tween",
  T_46_META_WS_C_TWEENSTYLE: "Tip stil Tween",
  T_46_META_WS_C_TYPE: "Tip",
  T_46_META_WS_C_TYPEENUM: "Tip Enum",
  T_46_META_WS_C_TYPEORTYPELIST: "Tip sau Listă de Tipuri",
  T_46_META_WS_C_UIADDSCORE: "Componentă UI de adăugare scor",
  T_46_META_WS_C_UIANITRIGGERHUD: "Componentă UI de declanșare a animației",
  T_46_META_WS_C_UIBUILTINSWITCH: "Comutator UI încorporat",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "Comutator UI încorporat",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "Componentă UI de selecție card",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "Componentă UI de indicator pentru punct de control",
  T_46_META_WS_C_UICOMPASS: "Busolă UI",
  T_46_META_WS_C_UICOUNTDOWN5: "Componentă UI de numărătoare inversă de 5 secunde",
  T_46_META_WS_C_UICOUNTDOWNHINT: "Componentă UI de memento de numărătoare inversă",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "Componentă UI de memento de numărătoare inversă",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Bară de sănătate deasupra capului personajului",
  T_46_META_WS_C_UIHEALTHBAR: "Componentă UI de bară de sănătate",
  T_46_META_WS_C_UIHEARTBEAT: "Componentă UI de bătăi de inimă",
  T_46_META_WS_C_UIICONNOTIFICATION: "Componentă UI de notificare cu pictogramă",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "Componentă UI de notificare de identitate",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "Buton UI de interacțiune",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "Buton UI pentru tabelă de scor",
  T_46_META_WS_C_UIMATCHSUBTITLE: "Componentă UI de subtitlu pentru meci",
  T_46_META_WS_C_UIMONSTERLEVEL: "Componentă UI de nivel al monstru",
  T_46_META_WS_C_UIMONSTERUI: "Componentă UI de efect pentru monstru",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "Componentă UI de tabelă de scor pentru mai multe echipe",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "Panou UI de rezultate pentru mai multe echipe",
  T_46_META_WS_C_UIOPENINGBANNER: "Componentă UI de banner la început",
  T_46_META_WS_C_UIPANEL: "Panou UI",
  T_46_META_WS_C_UIPANELEMPTY: "Panou UI gol",
  T_46_META_WS_C_UIPHASETIMER: "Componentă UI de cronometru pentru fază",
  T_46_META_WS_C_UIPROGRESSBAR: "Componentă UI de progres",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "Componentă UI de cerc de progres",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "Buton UI de progres pentru abilități",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "Tip de solicitare de achiziție",
  T_46_META_WS_C_UIROUNDINFOBANNER: "Componentă UI de informații despre rundă",
  T_46_META_WS_C_UIROUNDNUMBER: "Componentă UI de număr al rundei",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "Componentă UI de rezultate pentru rundă",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "Componentă UI de banner de început pentru două echipe",
  T_46_META_WS_C_UIROUNDTRANSITION: "Componentă UI de tranziție între runde",
  T_46_META_WS_C_UISCOREBAR: "Componentă UI de bară de scor",
  T_46_META_WS_C_UISCROLLPANEL: "Panou UI de derulare",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "Componentă UI de banner de scor pentru rundă de echipă",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "Componentă UI de banner simplu de început",
  T_46_META_WS_C_UISIMPLETIP: "Componentă UI de sfaturi",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "Componentă UI de banner simplu de versus",
  T_46_META_WS_C_UISKILLBUTTON: "Buton UI de abilitate",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "Widget de buton pentru funcții sociale",
  T_46_META_WS_C_UISOLOLEADERBOARD: "Componentă UI de tabelă de scor solo",
  T_46_META_WS_C_UISTORE: "Componentă UI de magazin",
  T_46_META_WS_C_UITEAMMATCHINFO: "Componentă UI de informații despre meciul echipelor",
  T_46_META_WS_C_UITEXTTIP: "Componentă UI de sfaturi",
  T_46_META_WS_C_UITIMERINFO: "Componentă UI de cronometru",
  T_46_META_WS_C_UITIPBUTTON: "Buton UI de sfaturi",
  T_46_META_WS_C_UITITLEBANNER: "Componentă UI de banner de titlu",
  T_46_META_WS_C_UITWEENTIP: "Componentă UI de sfat animat",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "Componentă UI de informații scurte pentru două echipe",
  T_46_META_WS_C_UITWOTEAMINFO: "Componentă UI pentru două echipe",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "Componentă UI de tabelă de scor pentru două echipe",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "Componentă UI de rezultat de rundă pentru două echipe",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "Componentă UI de scor pentru două echipe în rundă",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "Panou UI de scor pentru două echipe",
  T_46_META_WS_C_UIVERSUSBANNER: "Componentă UI de banner pentru două echipe",
  T_46_META_WS_C_UIWIDGET: "Widget UI",
  T_46_META_WS_C_UIWIDGETBUTTON: "Widget UI de buton",
  T_46_META_WS_C_UIWIDGETCONTAINER: "Container UI",
  T_46_META_WS_C_UIWIDGETEMPTY: "Widget UI gol",
  T_46_META_WS_C_UIWIDGETIMAGE: "Widget UI de imagine",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "Widget UI de câmp de text",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "Widget UI de joystick",
  T_46_META_WS_C_UIWIDGETLABEL: "Widget UI de etichetă",
  T_46_META_WS_C_UIWIDGETLAYOUT: "Widget UI de layout",
  T_46_META_WS_C_UIWIDGETPROFILE: "Widget UI de profil",
  T_46_META_WS_C_UIWIDGETTEXTURE: "Widget UI de textură",
  T_46_META_WS_C_UIWIDGETTOGGLE: "Widget UI de comutare",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "Widget UI de touchpad",
  T_46_META_WS_C_UIWINORLOSEBANNER: "Componentă UI de banner câștig-pierdere",
  T_46_META_WS_C_UNITSPAWN: "Generare Unități",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Obiect logic de escaladare a feronerie",
  T_46_META_WS_C_VECTOR2: "Vector2",
  T_46_META_WS_C_VECTOR3: "Vector3",
  T_46_META_WS_C_VEHICLE: "Vehicul",
  T_46_META_WS_C_VEHICLEIDTYPE: "Tip ID Vehicul",
  T_46_META_WS_C_VEHICLESKINID: "ID-ul Skin-ului Vehiculului",
  T_46_META_WS_C_VENDINGMACHINE: "Automat de vânzare",
  T_46_META_WS_C_VEST: "Vestă",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Entitate de textură VFX înlocuibilă",
  T_46_META_WS_C_VFXTEXTURE: "Textură VFX",
  T_46_META_WS_C_VISIBILITY: "Vizibilitate",
  T_46_META_WS_C_WALLET: "Portofel",
  T_46_META_WS_C_WALLETHUD: "UI Portofel",
  T_46_META_WS_C_WATERZONE: "Zonă de apă",
  T_46_META_WS_C_WAVECOUNTTYPE: "Tipul de Număr de Valuri",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Tipul de Interval de Valuri",
  T_46_META_WS_C_WEAPON: "Arma",
  T_46_META_WS_C_WEAPONGENERATOR: "Generator de Arme",
  T_46_META_WS_C_WEAPONSKINID: "ID-ul skin-ului de armă",
  T_46_META_WS_C_WEAPONTYPE: "Tipul de Armă",
  T_46_META_WS_C_WIDGETTYPE: "Tip widget",
  T_46_META_WS_C_ZIPLINE: "Linie de zip",
  T_46_META_WS_CAMERADIRECTION: "Direcția camerei",
  T_46_META_WS_CAMERAPOSITION: "Poziția camerei",
  T_46_META_WS_CAPSULECAST: "Detectare cu capsulă",
  T_46_META_WS_CAPSULEOVERLAP: "Verificare suprapunere capsulă",
  T_46_META_WS_CEIL: "Tavan",
  T_46_META_WS_CHATCHANNEL: "Canal de chat",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Verifică declanșatorul pe ordine",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "Golește",
  T_46_META_WS_CLEARALLCHILDREN: "Șterge toți copiii",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Șterge urmărirea specială AOI",
  T_46_META_WS_CLEARBACKPACK: "Curăță rucsac",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Șterge factor proprietate formulă",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Șterge obiectele reziduale de nivel",
  T_46_META_WS_CLIPNAME: "Nume clip",
  T_46_META_WS_CLONE: "Clonare",
  T_46_META_WS_COLLIDEDENTITY: "Entitate colizionată",
  T_46_META_WS_COLORGET: "Obține culoare",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Finalizează misiunea personalizată",
  T_46_META_WS_CONNECT: "Conectează",
  T_46_META_WS_CONSUMABLEID: "ID obiect",
  T_46_META_WS_CONTAIN: "Conține",
  T_46_META_WS_CONTAINKEY: "Conține cheia",
  T_46_META_WS_COPYTOMORPH: "Copiază în transformare",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Cheltuie bani",
  T_46_META_WS_COSTTOKEN: "Consumă token",
  T_46_META_WS_CREATEAIRDROP: "Creează airdrop",
  T_46_META_WS_CREATEBOT: "Creează bot",
  T_46_META_WS_CREATEBUILTINUI: "Creează UI încorporat",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Creează UI încorporat",
  T_46_META_WS_CREATECAMERA: "Creează camera",
  T_46_META_WS_CREATECURVE: "Creează curbă",
  T_46_META_WS_CREATECUSTOMUI: "Creează UI personalizat",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Creează UI personalizat",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Creează widget UI personalizat",
  T_46_META_WS_CREATEDAMAGENUM: "Creează numărul de daune",
  T_46_META_WS_CREATEEFFECT: "Creează efect",
  T_46_META_WS_CREATEEFFECTCLIENT: "Creează efect",
  T_46_META_WS_CREATEFACTION: "Creează facțiune",
  T_46_META_WS_CREATEFOLLOW: "Creează urmărire",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Creează mișcare auto-relaționată pe cadru",
  T_46_META_WS_CREATEFROMPREFAB: "Creează din prefab",
  T_46_META_WS_CREATELEVELOBJECT: "Creează obiect de nivel",
  T_46_META_WS_CREATELOOKAT: "Creează urmărire către",
  T_46_META_WS_CREATEMINIMAPICON: "Creează pictograma mini hartă",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Creează pixelul mini hartă",
  T_46_META_WS_CREATEMONSTER: "Creează monstru",
  T_46_META_WS_CREATEMORPH: "Creează transformare",
  T_46_META_WS_CREATESELFRELATIVE: "Creează auto-relaționat",
  T_46_META_WS_CREATESHOP: "Creează magazin",
  T_46_META_WS_CREATESHOPITEM: "Creează articol magazin",
  T_46_META_WS_CREATESHOPSHELF: "Creează raft magazin",
  T_46_META_WS_CREATESOUND: "Creează sunet",
  T_46_META_WS_CREATESOUNDCLIENT: "Creează sunet",
  T_46_META_WS_CREATETOKENINSCENE: "Creează token în scenă",
  T_46_META_WS_CREATETRAJECTORY: "Creează traiectorie",
  T_46_META_WS_CREATETWEEN: "Creează animație de interpolare",
  T_46_META_WS_CREATEWALLET: "Creează portofel",
  T_46_META_WS_CROSS: "Încrucișare",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "Converteste numele coloanei CSV în întreg",
  T_46_META_WS_CURRENTAMMOCOUNT: "Număr curent de gloanțe",
  T_46_META_WS_DAMAGE: "Daune",
  T_46_META_WS_DAMAGEDBODYPART: "Parte a corpului avariată",
  T_46_META_WS_DAMAGEDPLAYERS: "Jucători avariați",
  T_46_META_WS_DAMAGETYPE: "Tip daune",
  T_46_META_WS_DEALDAMAGE: "Cauzează daune",
  T_46_META_WS_DELETE: "Șterge",
  T_46_META_WS_DELETEAT: "Șterge la",
  T_46_META_WS_DELETECUSTOMUI: "Șterge UI personalizat",
  T_46_META_WS_DELETEFROMDATABASE: "Șterge din baza de date",
  T_46_META_WS_DELETEFROMDATASTORE: "Șterge din depozitul de date",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Șterge din baza de date a tabloului de lideri după cheie",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Șterge din baza de date a tabloului de lideri după rang",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Șterge din depozitul de date al tabelului de clasament după cheie",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Șterge din depozitul de date al tabelului de clasament după rang",
  T_46_META_WS_DELETETAG: "Șterge etichetă",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Distruge",
  T_46_META_WS_DESTROYBOT: "Distruge bot",
  T_46_META_WS_DESTROYBUILTINUI: "Distruge UI încorporat",
  T_46_META_WS_DESTROYEQUIPMENT: "Distruge echipament",
  T_46_META_WS_DESTROYITEM: "Distruge obiect",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Direcția în unghiul Euler",
  T_46_META_WS_DISABLESAFEZONE: "Dezactivează zona de siguranță",
  T_46_META_WS_DISPATCHEVENT: "Trimite eveniment",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Trimite eveniment cu platforma",
  T_46_META_WS_DISTANCE: "Distanță",
  T_46_META_WS_DOT: "Punct",
  T_46_META_WS_DROPITEM: "Aruncă obiectul",
  T_46_META_WS_DYEATAREA: "Colorare pe zonă",
  T_46_META_WS_DYEATPLANE: "Colorare pe plan",
  T_46_META_WS_DYEATPOSITION: "Colorare la poziție",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Zonă de gravitație scăzută",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Accelerație",
  T_46_META_WS_E_ACTIONNODE: "NodAcțiune",
  T_46_META_WS_E_ACTIVE: "Activ",
  T_46_META_WS_E_ACTIVESKILL: "Abilitate activă",
  T_46_META_WS_E_ADBOARD: "Panou publicitar",
  T_46_META_WS_E_ADD: "Adăuga",
  T_46_META_WS_E_ADDFRIEND: "Adaugă prieten",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Țintire",
  T_46_META_WS_E_AIR: "Aer",
  T_46_META_WS_E_AIRCONDITIONERA: "Aer conditionat",
  T_46_META_WS_E_AIRDROP: "Lansare de provizii, sinucidere cu zombie",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Viu",
  T_46_META_WS_E_AMMO: "Efecte de glonț",
  T_46_META_WS_E_AMPHIBIANCAR: "Vehicul Amfibie",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Copii Jucând",
  T_46_META_WS_E_AR: "Pușcă",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "Muniții AR",
  T_46_META_WS_E_ARMAGAZINE: "Magazie pentru AR",
  T_46_META_WS_E_ARMOR: "Armură",
  T_46_META_WS_E_ARMORBUFF: "Buff armură",
  T_46_META_WS_E_ARMORLV1: "Armură Lv1",
  T_46_META_WS_E_ARMORLV2: "Armură Lv2",
  T_46_META_WS_E_ARMORLV3: "Armură Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Distrugere armură",
  T_46_META_WS_E_ARMORSPECIALIST: "Abilitate 1",
  T_46_META_WS_E_ARROW: "Săgeată",
  T_46_META_WS_E_ASC: "Ordine Ascendentă",
  T_46_META_WS_E_ASCIGNOREZERO: "Ordine Ascendentă Exclude Zeros",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Explozie de gaz",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Accesoriu1 pentru compatibilitate",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Accesoriu4 pentru compatibilitate",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Accesoriu5 pentru compatibilitate",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Accesoriu6 pentru compatibilitate",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Accesoriu8 pentru compatibilitate",
  T_46_META_WS_E_ATTACK: "Atac",
  T_46_META_WS_E_ATTACKGRENADE: "Grenadă de atac",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Automat",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Întoarce",
  T_46_META_WS_E_BACKANDFORTH: "Dus-întors",
  T_46_META_WS_E_BAG: "Geantă",
  T_46_META_WS_E_BAG1: "Geantă1",
  T_46_META_WS_E_BAG2: "Geantă2",
  T_46_META_WS_E_BAG3: "Geantă3",
  T_46_META_WS_E_BAMBOOA: "Bambus A",
  T_46_META_WS_E_BANANATREE: "Copac de banane",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Coeficient de bază",
  T_46_META_WS_E_BASIC: "De Bază",
  T_46_META_WS_E_BASICCONE: "Con de bază",
  T_46_META_WS_E_BASICCYLINDER: "Cilindru de bază",
  T_46_META_WS_E_BASICSPHERE: "كرة أساسية",
  T_46_META_WS_E_BATTLEINSTYLE: "Luptă cu stil",
  T_46_META_WS_E_BELL: "Clopoțel",
  T_46_META_WS_E_BENCH: "Bancă",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "Ecran mare",
  T_46_META_WS_E_BIPOD: "Bipod",
  T_46_META_WS_E_BISGRAFFITIWALL: "Perete tematic BIS",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "Efecte vizuale explozie găuri negre",
  T_46_META_WS_E_BLACKHOLEBOOM: "Efecte vizuale bila de cristal",
  T_46_META_WS_E_BLAST: "Explozie",
  T_46_META_WS_E_BLOCK: "Pătrat",
  T_46_META_WS_E_BLOODBALL: "Efect de gaură neagră",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Albastru",
  T_46_META_WS_E_BLUEDOLL: "Păpușă de gheață",
  T_46_META_WS_E_BOARD: "Platformă Mobilă",
  T_46_META_WS_E_BODY: "Corp",
  T_46_META_WS_E_BOMBINDICATION: "Avertisment bombă",
  T_46_META_WS_E_BOMBPLIERS: "Cleste pentru bombe",
  T_46_META_WS_E_BONFIRE: "Foc de tabără arzând",
  T_46_META_WS_E_BOOM: "Boom",
  T_46_META_WS_E_BOOYAH: "Victorie",
  T_46_META_WS_E_BOTH: "Ambele",
  T_46_META_WS_E_BOUNCETIRE: "Anvelopă",
  T_46_META_WS_E_BOWAMMO: "Muniții Arc",
  T_46_META_WS_E_BREAKABLEBOX: "Cutie de lemn destructibilă",
  T_46_META_WS_E_BREAKABLECONTAINER: "Container Destructibil",
  T_46_META_WS_E_BREAKABLEFENCE: "Gard Destructibil",
  T_46_META_WS_E_BRICKA: "Cărămidă A",
  T_46_META_WS_E_BRICKB: "Cărămidă B",
  T_46_META_WS_E_BRICKC: "Cărămidă C",
  T_46_META_WS_E_BRICKHOUSEA: "Casă mică A",
  T_46_META_WS_E_BRIGHT: "Luminos",
  T_46_META_WS_E_BUBBLE: "Bulă",
  T_46_META_WS_E_BUFFGENERATOR: "Generator de Buff",
  T_46_META_WS_E_BULLETBUFF: "Buff glonț",
  T_46_META_WS_E_BULLETHITTING: "Impact Glonț",
  T_46_META_WS_E_BUMPERCAR: "Carusel cu Bumper",
  T_46_META_WS_E_BUMPERCARFACTORY: "Fabricant de mașini de bumper",
  T_46_META_WS_E_BURNING: "Daune de ardere la explozia vehiculului",
  T_46_META_WS_E_BUSHES: "Tufe",
  T_46_META_WS_E_BUSSTOP: "Stație de autobuz",
  T_46_META_WS_E_BUTTOM: "Îmbrăcăminte inferioară",
  T_46_META_WS_E_BUTTONWIDGET: "Widget buton",
  T_46_META_WS_E_BYHIERARCHY: "După ierarhie",
  T_46_META_WS_E_CABINET: "Dulap",
  T_46_META_WS_E_CACTUS: "Cactus",
  T_46_META_WS_E_CAMOUFLAGE: "Abilitate 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Declanșator de capsulă",
  T_46_META_WS_E_CARDIOTONIC: "Cardiotonic",
  T_46_META_WS_E_CASUALGAMEBGM: "BGM Joc de Distracție",
  T_46_META_WS_E_CEMENTA: "Ciment A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Canal A",
  T_46_META_WS_E_CHANNELB: "Canal B",
  T_46_META_WS_E_CHANNELC: "Canal C",
  T_46_META_WS_E_CHANNELD: "Canal D",
  T_46_META_WS_E_CHANNELE: "Canal E",
  T_46_META_WS_E_CHANNELF: "Canal F",
  T_46_META_WS_E_CHARACTERSKILL: "Abilitate de personaj",
  T_46_META_WS_E_CHARACTOR: "Caracter",
  T_46_META_WS_E_CHARGE: "Încărcare 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Punct de control",
  T_46_META_WS_E_CHEER: "Încurajare",
  T_46_META_WS_E_CHERRYBLOSSOM: "Arbre de Cerisier",
  T_46_META_WS_E_CIRCLE: "Cerc",
  T_46_META_WS_E_CIRCLEBACK: "Loop",
  T_46_META_WS_E_CIRCLEOFHEAT: "Fascicul de la picioare",
  T_46_META_WS_E_CITY: "Oraș",
  T_46_META_WS_E_CLAPS: "Aplauze",
  T_46_META_WS_E_CLEAR: "Șterge",
  T_46_META_WS_E_CLIENT: "Client",
  T_46_META_WS_E_CLONE: "Schimbător de aspect",
  T_46_META_WS_E_CLONEKILL: "Moartea clonelor",
  T_46_META_WS_E_CLOSE: "Închide",
  T_46_META_WS_E_CLOTHES: "Îmbrăcăminte",
  T_46_META_WS_E_COINGENERATOR: "Generator de aur",
  T_46_META_WS_E_COLDAIR: "Ceată",
  T_46_META_WS_E_COLORBLOCK: "Bloc colorat",
  T_46_META_WS_E_COLOROILBARREL: "Baril colorat",
  T_46_META_WS_E_COMBINEALL: "Combinare cu toate",
  T_46_META_WS_E_COMBINESELF: "Combinare cu sine",
  T_46_META_WS_E_COMBOKEYA1: "Note Muzicale - Sintetizator A",
  T_46_META_WS_E_COMBOKEYA2: "Note Muzicale - Sintetizator A",
  T_46_META_WS_E_COMBOKEYB1: "Note Muzicale - Sintetizator B",
  T_46_META_WS_E_COMBOKEYB2: "Note Muzicale - Sintetizator B",
  T_46_META_WS_E_COMBOKEYC1: "Note Muzicale - Sintetizator C",
  T_46_META_WS_E_COMBOKEYC2: "Note Muzicale - Sintetizator C",
  T_46_META_WS_E_CONCRETEPILLAR: "Pilon de beton",
  T_46_META_WS_E_CONDITIONNODE: "NodCondție",
  T_46_META_WS_E_CONTAINERA: "Container A",
  T_46_META_WS_E_CONTAINERB: "Container B",
  T_46_META_WS_E_CONTAINERC: "Container C",
  T_46_META_WS_E_CONTAINERWIDGET: "Widget container",
  T_46_META_WS_E_CONTINUOUS: "Continuă",
  T_46_META_WS_E_COUNTDOWN: "Contor",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Numărătoare Timp",
  T_46_META_WS_E_COUNTDOWNDIDI: "Semnal de numărătoare inversă",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Numărătoare Timp",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Numărătoare Timp 3",
  T_46_META_WS_E_CROSS: "Cruce",
  T_46_META_WS_E_CROSSBOW: "Arbalet",
  T_46_META_WS_E_CROSSHAIR: "Ținte",
  T_46_META_WS_E_CROSSHAIRS: "Țintă",
  T_46_META_WS_E_CROUCH: "Ghemuire",
  T_46_META_WS_E_CROUCHING: "Aplecat",
  T_46_META_WS_E_CROWCAW: "Căpcăun de Corb",
  T_46_META_WS_E_CROWN: "Coroană",
  T_46_META_WS_E_CUBE: "Mecanism de Bloc",
  T_46_META_WS_E_CURSE: "Talisman",
  T_46_META_WS_E_CURSEEXPLOSION: "Explozie de talisman",
  T_46_META_WS_E_CUSTOM: "Cameră personalizată",
  T_46_META_WS_E_CUSTOMTRIGGER: "Declanșator personalizat",
  T_46_META_WS_E_CUSTOMWATERZONE: "Corp de apă personalizat",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Ardere în buclă",
  T_46_META_WS_E_CYLIC: "Ciclic",
  T_46_META_WS_E_DAGGER: "Cuțit de aruncat",
  T_46_META_WS_E_DAMAGEDTRUCK: "Camion deteriorat",
  T_46_META_WS_E_DAMAGEZONE: "Zonă de daune",
  T_46_META_WS_E_DANGERALARM: "Pericol 2",
  T_46_META_WS_E_DANGERVIBRATING: "Pericol 1",
  T_46_META_WS_E_DARK: "Întunecat",
  T_46_META_WS_E_DARKNESS: "Întuneric",
  T_46_META_WS_E_DASHATTACK: "Atac de dash",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Limită de stocare a datelor depășită",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Eroare parametru de stocare a datelor",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Timeout pentru stocarea datelor",
  T_46_META_WS_E_DATETIME: "Dată și oră",
  T_46_META_WS_E_DAY: "Zi",
  T_46_META_WS_E_DEAD: "Mort",
  T_46_META_WS_E_DEATH: "Mort",
  T_46_META_WS_E_DEFAULT: "Implicit",
  T_46_META_WS_E_DEFAULTFIST: "Pumn",
  T_46_META_WS_E_DEFENCEGRENADE: "Grenadă de apărare",
  T_46_META_WS_E_DESC: "Ordine Descendentă",
  T_46_META_WS_E_DIALOGUE: "Dialog",
  T_46_META_WS_E_DIAMOND: "Diamant",
  T_46_META_WS_E_DIRECTIONSIGN: "Semn",
  T_46_META_WS_E_DIRVEVEHICLE: "Condu vehiculul",
  T_46_META_WS_E_DISABLE: "Dezactivează",
  T_46_META_WS_E_DISABLED: "Dezactivat",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Avertizare dispariție",
  T_46_META_WS_E_DISCONNECT: "Deconectare",
  T_46_META_WS_E_DISGUISE: "Clonă",
  T_46_META_WS_E_DOGHOUSE: "Casă pentru câini",
  T_46_META_WS_E_DOOR: "Ușă",
  T_46_META_WS_E_DOUBLE: "Dublu",
  T_46_META_WS_E_DOUBLEDOOR: "Ușă dublă",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Pantofi cu săritură dublă",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Magazie dublă",
  T_46_META_WS_E_DRAW: "Egalitate",
  T_46_META_WS_E_DRILLZOMBIE: "Zombie cu burghiu",
  T_46_META_WS_E_DRIVE: "Condu",
  T_46_META_WS_E_DRIVER: "Șofer",
  T_46_META_WS_E_DROPBEAT: "Abilitate 4",
  T_46_META_WS_E_DRUMKEY1: "Note Muzicale - Tobă",
  T_46_META_WS_E_DRUMKEY2: "Note Muzicale - Tobă",
  T_46_META_WS_E_DUEL: "Bătălie",
  T_46_META_WS_E_DUMMY: "Manekin",
  T_46_META_WS_E_DUMMYGRENADE: "Grenadă falsă",
  T_46_META_WS_E_DUMP: "Aruncare",
  T_46_META_WS_E_DUSK: "Amurg",
  T_46_META_WS_E_DUST: "Fum și praf",
  T_46_META_WS_E_DYNAMIC: "Dinamic",
  T_46_META_WS_E_E: "Constanta naturală",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Ușor",
  T_46_META_WS_E_ELECTRICSHOCK: "Șoc Electric",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Placă de surf electrică",
  T_46_META_WS_E_ELECTRICZONE: "Zonă electrică",
  T_46_META_WS_E_ELECTRONICBGM: "BGM Fantasy Electronic Drăguț",
  T_46_META_WS_E_ELIMINATEDBOSS: "Impeach Lider Guild",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Avertizare Ucidere",
  T_46_META_WS_E_EMOTE: "Emoție",
  T_46_META_WS_E_ENABLE: "Activează",
  T_46_META_WS_E_ENERGETIC: "Energic",
  T_46_META_WS_E_ENTERVEHICLE: "Intră în vehicul",
  T_46_META_WS_E_EP: "EP (Puncte de energie)",
  T_46_META_WS_E_EXCLAMATIONMARK: "Semn de exclamare",
  T_46_META_WS_E_EXIT: "Ieșire",
  T_46_META_WS_E_EXITVEHICLE: "Ieși din vehicul",
  T_46_META_WS_E_EXPLODE: "Auto-explozie",
  T_46_META_WS_E_EXPLOSION: "Efecte de explozie",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Flăcări de explozie",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Abilitate Orbs de Energie",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Zombie exploziv",
  T_46_META_WS_E_EYE: "Ochelari",
  T_46_META_WS_E_FACEPAINT: "Pictură facială",
  T_46_META_WS_E_FACTION: "Factie",
  T_46_META_WS_E_FALLING: "Cădere",
  T_46_META_WS_E_FALLINGSTAR: "Obține Consumabil",
  T_46_META_WS_E_FALSE: "Nu",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Mecanism de Propulsor",
  T_46_META_WS_E_FAR: "Departe",
  T_46_META_WS_E_FEATHER: "Pană",
  T_46_META_WS_E_FEMALE: "Feminin",
  T_46_META_WS_E_FENCE: "Gard",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "EntitateDeLuptă",
  T_46_META_WS_E_FILLED: "Umplut",
  T_46_META_WS_E_FINISH: "Finalizare",
  T_46_META_WS_E_FINISHINGPOINT: "Punct final",
  T_46_META_WS_E_FINISHLINEARCH: "Banner final",
  T_46_META_WS_E_FIRE: "Foc",
  T_46_META_WS_E_FIRECHARGE: "Glob de foc",
  T_46_META_WS_E_FIREWORK: "Focuri de artificii",
  T_46_META_WS_E_FIRINGEFFECT: "Efecte de tragere",
  T_46_META_WS_E_FIRSTPERSON: "Cameră first-person",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Cameră first-person (clasic)",
  T_46_META_WS_E_FIST: "Pumn",
  T_46_META_WS_E_FIT: "Se potriveste",
  T_46_META_WS_E_FLAG: "Steag",
  T_46_META_WS_E_FLAME: "Foc",
  T_46_META_WS_E_FLAMEGUN: "Aruncător de flăcări",
  T_46_META_WS_E_FLAMETHROWER: "Aruncător de flăcări",
  T_46_META_WS_E_FLASH: "Grenadă cu Flash",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Fum de grenadă flash",
  T_46_META_WS_E_FLASHFREEZE: "Congelare Rapidă",
  T_46_META_WS_E_FLEXWALL: "Perete Retractabil",
  T_46_META_WS_E_FLICKER: "Flicker",
  T_46_META_WS_E_FLOWER: "Floare",
  T_46_META_WS_E_FLYBOMBBEE: "Albina bombă zburătoare",
  T_46_META_WS_E_FLYPAN: "Mecanism de Tigăie",
  T_46_META_WS_E_FLYSHOE: "Pantofi zburători",
  T_46_META_WS_E_FOLDER: "Dosar",
  T_46_META_WS_E_FOLDWINGS: "Aripi pliabile",
  T_46_META_WS_E_FOODTRUCK: "Camion de mâncare",
  T_46_META_WS_E_FOODTRUCKB: "Camion de alimente B",
  T_46_META_WS_E_FOOTBALL: "Fotbal",
  T_46_META_WS_E_FOOTBALLGUN: "Pistol de fotbal",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Fotbalist",
  T_46_META_WS_E_FORCE: "Forță",
  T_46_META_WS_E_FOREGRIP_MR: "Mâner frontal MR",
  T_46_META_WS_E_FOREGRIP1: "Mâner frontal1",
  T_46_META_WS_E_FOREGRIP2: "Mâner frontal2",
  T_46_META_WS_E_FOREGRIP3: "Mâner frontal3",
  T_46_META_WS_E_FORWARD: "Înainte",
  T_46_META_WS_E_FOUNTAIN: "Fântână",
  T_46_META_WS_E_FREE: "Cameră liberă",
  T_46_META_WS_E_FREEZEALL: "Totale",
  T_46_META_WS_E_FREEZEPOSITION: "Poziție",
  T_46_META_WS_E_FREEZEPOSITIONX: "Poziție X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Poziție Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Poziție Z",
  T_46_META_WS_E_FREEZEROTATION: "Rotire",
  T_46_META_WS_E_FREEZEROTATIONX: "Rotire X",
  T_46_META_WS_E_FREEZEROTATIONY: "Rotire Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Rotire Z",
  T_46_META_WS_E_FREEZEZONE: "Zonă înghețată",
  "T_46_META_WS_E_FROST GALAXY": "Galaxie de îngheț",
  T_46_META_WS_E_FROZEN: "Înghețare",
  T_46_META_WS_E_FROZENGRENADE: "Grenadă de înghețare",
  T_46_META_WS_E_FUNCTIONALITEMS: "Obiecte funcționale",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Joc",
  T_46_META_WS_E_GAMEOVER: "Joc Terminare 2",
  T_46_META_WS_E_GAMESTART: "Început Joc",
  T_46_META_WS_E_GARAGE: "Garaj",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Mecanism Activat",
  T_46_META_WS_E_GENTLETAP: "Atingere ușoară",
  T_46_META_WS_E_GETITEM: "Obține Consumabil 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Fantom",
  T_46_META_WS_E_GIANTDICE: "Zaruri",
  T_46_META_WS_E_GIANTLOLLIPOP: "Lollipop uriaș",
  T_46_META_WS_E_GIFT: "Cadou",
  T_46_META_WS_E_GLOOWALL: "Perete de Gel",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "Grădină de flori tematică BIS",
  T_46_META_WS_E_GRAFFITIWALL: "Perete graffiti",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Arma cu cârlig",
  T_46_META_WS_E_GREATCONDUCTOR: "Mare Conducător",
  T_46_META_WS_E_GREEN: "Verde",
  T_46_META_WS_E_GRENADE: "Grenadă",
  T_46_META_WS_E_GRID: "Grilă",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Turn de Supraveghere",
  T_46_META_WS_E_GUILD: "Gildă",
  T_46_META_WS_E_GUN: "Armă",
  T_46_META_WS_E_GUNFIRE: "Tragere",
  T_46_META_WS_E_HALO: "Aureolă",
  T_46_META_WS_E_HAMMER: "Mecanism de Ciocan Gigantic",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Raft de Uscare",
  T_46_META_WS_E_HARD: "Dificil",
  T_46_META_WS_E_HATTRICK: "Abilitate 8",
  T_46_META_WS_E_HAYSTACK: "Găleată cu Fân",
  T_46_META_WS_E_HEAD: "Accesoriu pentru cap",
  T_46_META_WS_E_HEADSHOOT: "Țintire la cap",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "Pistol de vindecare",
  T_46_META_WS_E_HEART: "Inimă",
  T_46_META_WS_E_HEARTBEAT: "Bătăi ale inimii",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "Armă grea",
  T_46_META_WS_E_HELL: "Foarte greu",
  T_46_META_WS_E_HELMET: "Cască",
  T_46_META_WS_E_HELMET1: "Cască1",
  T_46_META_WS_E_HELMET2: "Cască2",
  T_46_META_WS_E_HELMET3: "Cască3",
  T_46_META_WS_E_HEXAGON: "Hexagon",
  T_46_META_WS_E_HGAMMO: "Muniții HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Aruncător de flăcări pentru joc de-a v-ați ascunselea",
  T_46_META_WS_E_HIDERKILL: "Ascuns ucis",
  T_46_META_WS_E_HIHATS: "Hi-Hat",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Lovitură Plictisitoare",
  T_46_META_WS_E_HITEFFECT: "Efecte de lovire a glonțului",
  T_46_META_WS_E_HITFEEDBACK: "Feedback la tragere",
  T_46_META_WS_E_HOOK: "Cârlig",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "Muniție pentru arma cu cârlig",
  T_46_META_WS_E_HORIZALINE: "Orizontal",
  T_46_META_WS_E_HORIZONTAL: "Orizontal",
  T_46_META_WS_E_HORN: "Difuzor",
  T_46_META_WS_E_HORROR: "Groază",
  T_46_META_WS_E_HOURGLASS: "Clepsidră",
  T_46_META_WS_E_HOUSE: "Casă",
  T_46_META_WS_E_HOUSEA: "Casă cu un etaj",
  T_46_META_WS_E_HOUSEB: "Casă cu Două Etaje",
  T_46_META_WS_E_HOUSEC: "Casă cu trei etaje",
  T_46_META_WS_E_HP: "HP (Puncte de viață)",
  T_46_META_WS_E_HPBUFF: "Buff HP",
  T_46_META_WS_E_HUT: "Cabin",
  T_46_META_WS_E_ICEA: "Gheață A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "Constructor de ziduri de gheață",
  T_46_META_WS_E_ICONOBJECT: "Icon",
  T_46_META_WS_E_IMAGEWIDGET: "Widget imagine",
  T_46_META_WS_E_IMPULSE: "Impuls",
  T_46_META_WS_E_INHALER: "Inhalator",
  T_46_META_WS_E_INJUREDFEMALE: "Strigăt de femeie la lovitură",
  T_46_META_WS_E_INJUREDMALE: "Strigăt de bărbat la lovitură",
  T_46_META_WS_E_INK: "Efect de cerneală",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Widget etichetă de intrare",
  T_46_META_WS_E_INSECTCHIRPING: "Ciripitul Insectelor",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 secunde",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 secunde",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 secunde",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 secunde",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 secunde",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 secunde",
  T_46_META_WS_E_INVISIBLE: "Invizibil",
  T_46_META_WS_E_IPIPE: "Țeavă I",
  T_46_META_WS_E_IRONFENCE: "Gard",
  T_46_META_WS_E_IRONFENCEB: "Gard B",
  T_46_META_WS_E_IRONPLATFORM: "Platformă din Fier",
  T_46_META_WS_E_ITEMENTITY: "Generator de consumabile",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Baril de ulei",
  T_46_META_WS_E_JERSEYMACHINE: "Mașină de tricouri",
  T_46_META_WS_E_JOINEDGAMEDULL: "Intră în Luptă",
  T_46_META_WS_E_JOINGAME: "Alătură-te Jocului",
  T_46_META_WS_E_JOYSTICKWIDGET: "Widget joystick",
  T_46_META_WS_E_JUMP: "Sari",
  T_46_META_WS_E_JUMPATTACK: "Atac cu salt",
  T_46_META_WS_E_JUSTPATROL: "Patrulare simplă",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Cheie",
  T_46_META_WS_E_KICK: "Kick",
  T_46_META_WS_E_KILLINGTIPS: "Sfaturi de eliminare",
  T_46_META_WS_E_KILLZONE: "Zonă de moarte",
  T_46_META_WS_E_KINEMATIC: "Cinematic",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "Doborât",
  T_46_META_WS_E_KNOCKEDDOWN: "Împins la pământ",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Widget eticheta",
  T_46_META_WS_E_LANDINGA: "Etajera A",
  T_46_META_WS_E_LANDINGB: "Etajera B",
  T_46_META_WS_E_LANDINGC: "Etajera C",
  T_46_META_WS_E_LANDMINE: "Mină terestră",
  T_46_META_WS_E_LANUNCHERAMMO: "Muniție pentru lansator",
  T_46_META_WS_E_LASER: "Efect de laser",
  T_46_META_WS_E_LASERSKILL: "Abilitate Laser",
  T_46_META_WS_E_LATTICESCREEN: "Ecran",
  T_46_META_WS_E_LAWNA: "Gazon A",
  T_46_META_WS_E_LAWNB: "Gazon B",
  T_46_META_WS_E_LAYOUTWIDGET: "Widget de layout",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Lemn Mort",
  T_46_META_WS_E_LEVELMAXED: "Nivel Maxim",
  T_46_META_WS_E_LEVELUP: "Urcă Rang",
  T_46_META_WS_E_LEVELUPDISCARDED: "Creștere în rang",
  T_46_META_WS_E_LIGHTBEAM: "Fascicul de lumină",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Fascicul de lumină",
  T_46_META_WS_E_LIGHTEFFECT: "Efect de lumină",
  T_46_META_WS_E_LIGHTNING: "Fulger",
  T_46_META_WS_E_LIMB: "Membri",
  T_46_META_WS_E_LINE: "Linie",
  T_46_META_WS_E_LIQUID: "Lichid",
  T_46_META_WS_E_LOCAL: "Local",
  T_46_META_WS_E_LOCALPOSITION: "Poziție locală",
  T_46_META_WS_E_LOCK: "Lacăt",
  T_46_META_WS_E_LONGBOX: "Cutie din Lemn Lung",
  T_46_META_WS_E_LOOP: "Ciclu",
  T_46_META_WS_E_LOOTITEMBOX: "Armă de Pradă",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Muniție de Pradă",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Armură de Pradă",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Consumabil de Pradă",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Obiect Aruncabil de Loot",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Mira de Pradă",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "Grenadă de gheață",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Pradă fotbal aleatorie",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Scut de fotbal",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Răscolire Arme Aleatorie",
  T_46_META_WS_E_LOSE: "Înfrângere",
  T_46_META_WS_E_LOUDSPEAKER: "Difuzor",
  T_46_META_WS_E_LOWFALLING: "Cădere mică",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "Grenadă M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "Grenadă specializată M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Magazie1",
  T_46_META_WS_E_MAGEZINE2: "Magazie2",
  T_46_META_WS_E_MAGEZINE3: "Magazie3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Lupă",
  T_46_META_WS_E_MALE: "Masculin",
  T_46_META_WS_E_MARK: "Marcaj",
  T_46_META_WS_E_MARKER: "Marcaj",
  T_46_META_WS_E_MASK: "Accesoriu facial",
  T_46_META_WS_E_MAXVALUE: "Valoare Maxima",
  T_46_META_WS_E_MECHANICAL: "Clipe Rapid 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Ecou Dispozitiv Mecanism",
  T_46_META_WS_E_MEDICALPROPS: "Obiecte medicale",
  T_46_META_WS_E_MEDICALTENT: "Cort Medical",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Bătăi Medii ale Inimii",
  T_46_META_WS_E_MEDKIT: "Kit de Primă Ajutor",
  T_46_META_WS_E_MELEE: "Arme de Cântec",
  T_46_META_WS_E_MELEEWEAPONS: "Armă de corp",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Microfon",
  T_46_META_WS_E_MIDDLE: "Mediu",
  T_46_META_WS_E_MINIHANDLE: "Mâner mic",
  T_46_META_WS_E_MINIMAP: "Mini hartă",
  T_46_META_WS_E_MINISENTRY: "Mini sentinela",
  T_46_META_WS_E_MINVALUE: "Valoare Minima",
  T_46_META_WS_E_MISSILEEXPLODE: "Arma de tip rachetă",
  T_46_META_WS_E_MISSIONCOMPLETE: "Succes Misiune 1",
  T_46_META_WS_E_MISTAKE: "Eroare",
  T_46_META_WS_E_MODERATE: "Moderat",
  T_46_META_WS_E_MONEY: "Bani",
  T_46_META_WS_E_MONSTER: "Monster",
  T_46_META_WS_E_MONSTERSPAWN: "Punct de spawn al monstrului",
  T_46_META_WS_E_MONSTERTRUCK: "Camion monstruos",
  T_46_META_WS_E_MOON: "Lună",
  T_46_META_WS_E_MOSQUITO: "Țânțar",
  T_46_META_WS_E_MOTIONTRAIL: "Lovitură din spate",
  T_46_META_WS_E_MOTOBIKE: "Motocicletă",
  T_46_META_WS_E_MOTORBIKE: "Motocicletă",
  T_46_META_WS_E_MOVE: "Mișcare",
  T_46_META_WS_E_MOVEMENT: "Mutați",
  T_46_META_WS_E_MOVINGJOYSTICK: "Joystick de mișcare",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Domnul V",
  T_46_META_WS_E_MULTIPLIER: "Multiplicator",
  T_46_META_WS_E_MULTIPLY: "În-mulți",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Înmulțiți și Accumulați",
  T_46_META_WS_E_MUSHROOM1: "Ciupercă1",
  T_46_META_WS_E_MUSHROOM2: "Ciupercă2",
  T_46_META_WS_E_MUSHROOM3: "Ciupercă3",
  T_46_META_WS_E_MUSHROOM4: "Ciupercă4",
  T_46_META_WS_E_MUSHSHADE: "Grupă de Ciuperci Gigante",
  T_46_META_WS_E_MUSIC: "Muzică",
  T_46_META_WS_E_MUZZLE1: "Compensator1",
  T_46_META_WS_E_MUZZLE2: "Compensator2",
  T_46_META_WS_E_MUZZLE3: "Compensator3",
  T_46_META_WS_E_NEAR: "Aproape",
  T_46_META_WS_E_NIGHT: "Noapte",
  T_46_META_WS_E_NOATTACK: "Fără atac",
  T_46_META_WS_E_NODUALWIELDING: "Fără dual wielding",
  T_46_META_WS_E_NOERROR: "Fără eroare",
  T_46_META_WS_E_NONE: "Nici",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Nu sari peste căderea la pământ",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Abilitate 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Obține Aur Mediu",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Obține Aur Mare",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Obține Aur Mic",
  T_46_META_WS_E_OILDRUMEXPLODE: "Explozie de butoi cu petrol",
  T_46_META_WS_E_ONCE: "O dată",
  T_46_META_WS_E_ONEWAY: "Numai dus",
  T_46_META_WS_E_OPENFOLDER: "Dosar deschis",
  T_46_META_WS_E_OPENHIHATS: "Hi-Hat deschis",
  T_46_META_WS_E_OPENINGBOX: "Deschide Cutie",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Provizion Guild",
  T_46_META_WS_E_OPENINGWARCHEST: "Salvează Depozit",
  T_46_META_WS_E_ORANGE: "Portocalie",
  T_46_META_WS_E_ORTHOGONAL: "Ortogonal",
  T_46_META_WS_E_OUTPOST: "Casa de Gardă",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Perete Pictat",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Abilitate Piscină de Sânge",
  T_46_META_WS_E_PALM: "Hârtie",
  T_46_META_WS_E_PANEL: "Panou",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Pasager A",
  T_46_META_WS_E_PASSENGERB: "Pasager B",
  T_46_META_WS_E_PASSENGERC: "Pasager C",
  T_46_META_WS_E_PASSIVE: "Pasiv",
  T_46_META_WS_E_PASSIVESKILL: "Abilitate pasivă",
  T_46_META_WS_E_PATROLWHILEATTACK: "Patrulare și atac",
  T_46_META_WS_E_PERSONALUAV: "UAV personal",
  T_46_META_WS_E_PERSPECTIVE: "Perspectivă",
  T_46_META_WS_E_PETTABBG: "Pisică",
  T_46_META_WS_E_PHASESTART: "Începere Fază",
  T_46_META_WS_E_PHONEBOOTH: "Cabina telefonică",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Note Muzicale - Pian",
  T_46_META_WS_E_PIANOKEY2: "Note Muzicale - Pian",
  T_46_META_WS_E_PICKUPS: "Ridicare obiecte",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Coloana de Beton",
  T_46_META_WS_E_PIN: "Etichetă",
  T_46_META_WS_E_PINGPONG: "Tenis de masă",
  T_46_META_WS_E_PIPECORNER: "Țeavă Înghițită",
  T_46_META_WS_E_PIPEINTERSECTION: "Țeavă Încrucișată",
  T_46_META_WS_E_PISTOL: "Pistol",
  T_46_META_WS_E_PISTOLAMMO: "Muniție pentru pistol",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Bloc de parc de distracții cu damier",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Jucător",
  T_46_META_WS_E_PLUS: "Plus",
  T_46_META_WS_E_PODIUM: "Podium",
  T_46_META_WS_E_POISONGAS: "Gaz toxic",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Gaz toxic",
  T_46_META_WS_E_PORTAL: "Portal",
  T_46_META_WS_E_POSTACCUMULATOR: "Post-Acumulator",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Bătăi Rapide ale Inimii",
  T_46_META_WS_E_PREACCUMULATOR: "Pre-Acumulator",
  T_46_META_WS_E_PRIMARYWEAPONA: "Arma principală A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Arma principală B",
  T_46_META_WS_E_PRIOREXPLOSION: "Înainte de explozia bombe",
  T_46_META_WS_E_PROFILEWIDGET: "Widget profil",
  T_46_META_WS_E_PRONE: "Întins",
  T_46_META_WS_E_PUMPKIN: "Dovleac",
  T_46_META_WS_E_PURPLE: "Violet",
  T_46_META_WS_E_QUADRILATERAL: "Patrulater",
  T_46_META_WS_E_QUESTIONMARK: "Semn de întrebare",
  T_46_META_WS_E_QUICKCHAT: "Chat rapid",
  T_46_META_WS_E_QUICKCHATSHOW: "Afișare chat rapid",
  T_46_META_WS_E_RADIAL180: "Radial 180°",
  T_46_META_WS_E_RADIAL360: "Radial 360°",
  T_46_META_WS_E_RADIAL90: "Radial 90°",
  T_46_META_WS_E_RAMPAGE: "Rampă",
  T_46_META_WS_E_RANDOM: "Aleatoriu",
  T_46_META_WS_E_RANDOMBUFF: "Buff aleatoriu",
  T_46_META_WS_E_RANKDOWN: "Scădere în rang",
  T_46_META_WS_E_REACTION: "Răspunde",
  T_46_META_WS_E_RECOVER: "Recuperare",
  T_46_META_WS_E_RECYCLE: "Reciclare",
  T_46_META_WS_E_RED: "Roșu",
  T_46_META_WS_E_REFINERYTANK: "Jug de apă",
  T_46_META_WS_E_REFLECTIVECUBE: "Bloc de culoare solidă reflectorizant 1",
  T_46_META_WS_E_REFRESH: "Refresh",
  T_46_META_WS_E_RELEASINGSKILL: "Efect de lansare a abilității",
  T_46_META_WS_E_RELOAD: "Reîncarcă",
  T_46_META_WS_E_REMINDER: "Reminder",
  T_46_META_WS_E_REPAIR: "Reparare",
  T_46_META_WS_E_REPAIREQUIP: "Reparare echipament",
  T_46_META_WS_E_REPAIRKIT: "Kit de Reparare",
  T_46_META_WS_E_REPLACER: "Înlocuitor",
  T_46_META_WS_E_REPORT: "Raportează",
  T_46_META_WS_E_REST: "Odihnă",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Ride",
  T_46_META_WS_E_RIDICULE: "Ironie",
  T_46_META_WS_E_RIDICULEFUNNY: "Ironie amuzantă",
  T_46_META_WS_E_RIFLE: "Pușcă",
  T_46_META_WS_E_RIFLEAMMO: "Muniție pentru pușcă",
  T_46_META_WS_E_RIGHT: "Corect",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Trapez dreptunghiular",
  T_46_META_WS_E_RING: "Mecanism de Inel",
  T_46_META_WS_E_RINGPREDISCARDED: "Inel",
  T_46_META_WS_E_RIPTIDERHYTHM: "Abilitate 9",
  T_46_META_WS_E_RISINGPARTICLE: "Particule ascendente",
  T_46_META_WS_E_ROADBLOCK: "Baricadă",
  T_46_META_WS_E_ROTATE: "Rotatie",
  T_46_META_WS_E_RUNNING: "În curs de desfășurare",
  T_46_META_WS_E_RUSHTIME: "Furia",
  T_46_META_WS_E_SAMURAI: "Samurai",
  T_46_META_WS_E_SANDA: "Nisip A",
  T_46_META_WS_E_SANDSTRUCTURE: "Sculptură din nisip",
  T_46_META_WS_E_SCALE: "Scară",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Statuie",
  T_46_META_WS_E_SCISSORS: "Foarfeci",
  T_46_META_WS_E_SCOPE2X: "2x Obiectiv",
  T_46_META_WS_E_SCOPE4X: "4x Obiectiv",
  T_46_META_WS_E_SCROLLPANEL: "Panou de derulare",
  T_46_META_WS_E_SECONDARYWEAPON: "Arma secundară",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Abilitate 10",
  T_46_META_WS_E_SERVER: "Server",
  T_46_META_WS_E_SET: "Combinezon",
  T_46_META_WS_E_SETTING: "Setări",
  T_46_META_WS_E_SETTINGS: "Setări",
  T_46_META_WS_E_SG: "Pușcă cu Pompa",
  T_46_META_WS_E_SGAMMO: "Muniții SN",
  T_46_META_WS_E_SHARPMECHANICAL: "Clipe Rapid 1",
  T_46_META_WS_E_SHIELD: "Apărare",
  T_46_META_WS_E_SHIELDBROKEN: "Scut rupt",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "Ridicați scutul",
  T_46_META_WS_E_SHOCKWAVE: "Undă de șoc",
  T_46_META_WS_E_SHOES: "Încălțăminte",
  T_46_META_WS_E_SHOOTINGTARGET: "Țintă în Mișcare",
  T_46_META_WS_E_SHORTDATE: "Dată scurtă",
  T_46_META_WS_E_SHORTDATETIME: "Dată și oră scurtă",
  T_46_META_WS_E_SHORTTIME: "Timp scurt",
  T_46_META_WS_E_SHOTGUN: "Mitralieră",
  T_46_META_WS_E_SHOTGUNAMMO: "Muniție pentru pușcă de vânătoare",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Compensator pentru shotgun",
  T_46_META_WS_E_SHOW: "Afișează",
  T_46_META_WS_E_SHRUB: "Cutie din Lemn Lung Acoperită cu Arbuști",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "Cameră cu derulare laterală",
  T_46_META_WS_E_SIGNAL: "Semnal",
  T_46_META_WS_E_SIGNOUT: "Ieșire",
  T_46_META_WS_E_SILENCER: "Amortizor",
  T_46_META_WS_E_SIMPLE: "Simplu",
  T_46_META_WS_E_SIMPLEWIDGET: "Widget simplu",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Simplu",
  T_46_META_WS_E_SITEHUT: "Casă din Containere",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Încărcare Abilități Completa",
  T_46_META_WS_E_SKILLRECOVER: "Recuperare Abilități",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Sari peste căderea la pământ",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Feliat",
  T_46_META_WS_E_SLOPE: "Panta",
  T_46_META_WS_E_SLOWHEARTBEAT: "Bătăi Lente ale Inimii",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "Muniții SMG",
  T_46_META_WS_E_SMGMUZZLE: "Compensator pentru SMG",
  T_46_META_WS_E_SMILEY: "Față zâmbitoare",
  T_46_META_WS_E_SMOKE: "Fum",
  T_46_META_WS_E_SMOKEGRENADE: "Grenadă cu Fum",
  T_46_META_WS_E_SMOKEY: "Fum",
  T_46_META_WS_E_SMOOTH: "Neted",
  T_46_META_WS_E_SNAMMO: "Muniții SN",
  T_46_META_WS_E_SNARES: "Tar drums",
  T_46_META_WS_E_SNEAKERS: "Efecte de încălțăminte de alergare",
  T_46_META_WS_E_SNIPER: "Pușcă de lunetist",
  T_46_META_WS_E_SNIPERAMMO: "Muniție pentru pușcă de lunetă",
  T_46_META_WS_E_SNOWA: "Zăpadă A",
  T_46_META_WS_E_SNOWFLAKE: "Fulgi de zăpadă",
  T_46_META_WS_E_SOCCER: "Fotbal",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Widget social",
  T_46_META_WS_E_SOLARPANEL: "Panou Solar",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "După prioritate mare la mică",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "După prioritate mică la mare",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Efect de punct de apariție",
  T_46_META_WS_E_SPEAKER: "Difuzor",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Sunet Arma Specială",
  T_46_META_WS_E_SPECIALGUN: "Armă specială",
  T_46_META_WS_E_SPHERE: "Sferă",
  T_46_META_WS_E_SPHERETRIGGER: "Declanșator de coliziune sferică",
  T_46_META_WS_E_SPIDERWEB: "Efecte de abilitate",
  T_46_META_WS_E_SPORTSCAR: "Mașină sport",
  T_46_META_WS_E_SPOTLIGHT: "Lumină",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Răspândirea gazului toxic",
  T_46_META_WS_E_SPRINT: "Sprint",
  T_46_META_WS_E_SQUARE: "Pătrat",
  T_46_META_WS_E_SQUAREBOX: "Cutie din Lemn Pătrat",
  T_46_META_WS_E_SR: "Pușcă de Precizie",
  T_46_META_WS_E_STABLE: "Colibă cu paie",
  T_46_META_WS_E_STAIRS: "Scară",
  T_46_META_WS_E_STANDING: "În picioare",
  T_46_META_WS_E_STAR: "Stea",
  T_46_META_WS_E_STATIC: "Static",
  T_46_META_WS_E_STATUSTRIGGER: "Declanșator de moarte sau invincibilitate",
  T_46_META_WS_E_STEP: "Sunet Pași",
  T_46_META_WS_E_STEPTRIGGER: "Activare mecanism",
  T_46_META_WS_E_STOCK_S: "Pat S",
  T_46_META_WS_E_STOCK_SR: "Pat SR",
  T_46_META_WS_E_STOCK1: "Pat1",
  T_46_META_WS_E_STOCK2: "Pat2",
  T_46_META_WS_E_STOCK3: "Pat3",
  T_46_META_WS_E_STONE: "Rocă",
  T_46_META_WS_E_STONEBRIDGE: "Pod de piatră",
  T_46_META_WS_E_STONELANTERN: "Lanternă Regală",
  T_46_META_WS_E_STONESPLASH: "Deșeuri zburătoare",
  T_46_META_WS_E_STORE: "Magazin",
  T_46_META_WS_E_STREETLAMP: "Lumină Stradală",
  T_46_META_WS_E_STYLEA: "Stil A",
  T_46_META_WS_E_STYLEB: "Stil B",
  T_46_META_WS_E_STYLEC: "Stil C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "Muniție pentru SMG",
  T_46_META_WS_E_SUCCESSFULHIT: "Lovitură",
  T_46_META_WS_E_SUN: "Soare",
  T_46_META_WS_E_SUNSHADE: "Set de patio cu umbrelă",
  T_46_META_WS_E_SUPERCAR: "Mașină sport",
  T_46_META_WS_E_SUPERMARKET: "Supermarket",
  T_46_META_WS_E_SURPRISEFIND: "Descoperă Surpriza",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Schimbare rapidă a armei",
  T_46_META_WS_E_SWIMRING: "Cerc de înot",
  T_46_META_WS_E_SWORD: "Sabie",
  T_46_META_WS_E_SYMBOLIC: "Marcaj pe sol",
  T_46_META_WS_E_TANKZOMBIE: "Zombie tanc",
  T_46_META_WS_E_TAP: "Apasă",
  T_46_META_WS_E_TAPPINGBUTTON: "Apasă Buton",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Apasă Buton Dezactivare",
  T_46_META_WS_E_TEAM: "Echipa",
  T_46_META_WS_E_TEAMMATESINFO: "Informații despre coechipieri",
  T_46_META_WS_E_TELEPORT: "Teleportare",
  T_46_META_WS_E_TELEPORTCORRECT: "Beacon-ing Destinație Corectă",
  T_46_META_WS_E_TELEPORTWRONG: "Beacon-ing Destinație Greșită",
  T_46_META_WS_E_TEXT: "Text",
  T_46_META_WS_E_TEXTOBJECT: "Text",
  T_46_META_WS_E_TEXTUREWIDGET: "Widget textură",
  T_46_META_WS_E_THERMALSCOPE: "Termic Vedere",
  T_46_META_WS_E_THIRDPERSON: "Cameră third-person",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Cameră third-person (clasic)",
  T_46_META_WS_E_THIRDPERSONLOCK: "Cameră third-person blocată",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "Cuțit de aruncat2 pentru compatibilitate",
  T_46_META_WS_E_THRILLBATTLE: "Abilitate 5",
  T_46_META_WS_E_THROWATTACK: "Aruncă grenada",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Zombie roșu aruncător",
  T_46_META_WS_E_THROWZOMBIE: "Zombie aruncător",
  T_46_META_WS_E_THUMBSUP: "Like",
  T_46_META_WS_E_THUNDER: "Șoc electric",
  T_46_META_WS_E_TILEA: "Placă A",
  T_46_META_WS_E_TILEB: "Placă B",
  T_46_META_WS_E_TILEC: "Placă C",
  T_46_META_WS_E_TILED: "Plăcuit",
  T_46_META_WS_E_TIPSSOUND: "Arată Sfaturi",
  T_46_META_WS_E_TOGGLEWIDGET: "Widget comutator",
  T_46_META_WS_E_TOILETBOWL: "Toaletă",
  T_46_META_WS_E_TONEA: "Ton A",
  T_46_META_WS_E_TOP: "Îmbrăcăminte superioară",
  T_46_META_WS_E_TOPDOWN: "Cameră de sus în jos",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Widget touchpad",
  T_46_META_WS_E_TOWER: "Fortăreață",
  T_46_META_WS_E_TPIPE: "Țeavă T",
  T_46_META_WS_E_TRACINGSTEPS: "Abilitate 3",
  T_46_META_WS_E_TRAILER: "Remorcă",
  T_46_META_WS_E_TRANSFORMATION: "Schimbător de Aspect",
  T_46_META_WS_E_TRANSPARENT: "Transparent",
  T_46_META_WS_E_TRAPEZOID: "Trapez",
  T_46_META_WS_E_TRASHCAN: "Coș de gunoi",
  T_46_META_WS_E_TRIANGLE: "Triunghi",
  T_46_META_WS_E_TRIGGERS: "Declanșator",
  T_46_META_WS_E_TRIPLE: "Triplu",
  T_46_META_WS_E_TROPHY: "Trofeu",
  T_46_META_WS_E_TRUE: "Da",
  T_46_META_WS_E_TUKTUK: "Tuk Tuk",
  T_46_META_WS_E_TUTUCAR: "Tuk-Tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Zombie tiran",
  T_46_META_WS_E_UAVLITE: "UAV ușor",
  T_46_META_WS_E_UIFINISH: "Sfârșit",
  T_46_META_WS_E_UITAP: "Atingere UI",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Generator de unități",
  T_46_META_WS_E_UPWARDTURBULENCE: "Curent de urcare",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Escaladează",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Vehicul",
  T_46_META_WS_E_VEHICLEEXPLODE: "Explozie vehicul",
  T_46_META_WS_E_VELOCITY: "Viteză",
  T_46_META_WS_E_VENDINGMACHINE: "Automat de vânzări",
  T_46_META_WS_E_VERTICAL: "Vertical",
  T_46_META_WS_E_VEST: "Vestă",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Vestă4",
  T_46_META_WS_E_VISUALEFFECTS: "Efecte Vizuale",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Perete A",
  T_46_META_WS_E_WALLBRAWL: "Abilitate 2",
  T_46_META_WS_E_WARNING: "Avertisment",
  T_46_META_WS_E_WATERRING: "Stropire cu apă",
  T_46_META_WS_E_WAVE1: "Val1",
  T_46_META_WS_E_WAVE2: "Val2",
  T_46_META_WS_E_WAVE3: "Val3",
  T_46_META_WS_E_WEAPONGENERATOR: "Armă",
  T_46_META_WS_E_WEAPONSLOT: "Slot pentru arme",
  T_46_META_WS_E_WHISTLE: "Înfrângere Inamic",
  T_46_META_WS_E_WIDERANGE: "Interval larg",
  T_46_META_WS_E_WIN: "Victorie",
  T_46_META_WS_E_WINDATTACK: "Atac de vânt",
  T_46_META_WS_E_WOODA: "Lemn A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Zombie tăietor de lemne",
  T_46_META_WS_E_WOODENPLANK: "Pod de Lemn",
  T_46_META_WS_E_WORLDPOSITION: "Coordonate globale",
  T_46_META_WS_E_WRECKEDBUS: "Autobuz Distrus",
  T_46_META_WS_E_WRECKEDCAR: "Mașină Distrusă",
  T_46_META_WS_E_WRONG: "Greșit",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zombie",
  T_46_META_WS_E_ZOMBIES: "Zombi",
  T_46_META_WS_E_ZOOM: "Zoom",
  T_46_META_WS_ELIMINATE: "Eliminare",
  T_46_META_WS_ELIMINATEDENTITY: "Entitate eliminată",
  T_46_META_WS_ELIMINATEDPLAYER: "Jucător eliminat",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Activare arbore comportamental implicit",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Activează zona de siguranță în mișcare",
  T_46_META_WS_ENABLESAFEZONE: "Activează zona de siguranță",
  T_46_META_WS_ENDCURRENTPHASE: "Încheie faza curentă",
  T_46_META_WS_ENDMORPH: "Sfârșește transformare",
  T_46_META_WS_ENDPOSITION: "Poziție finală",
  T_46_META_WS_ENTERVEHICLE: "Intră în vehicul",
  T_46_META_WS_ENTITY: "Entitate",
  T_46_META_WS_EQUIPMENTID: "ID echipament",
  T_46_META_WS_EULERANGLETOQUATERNION: "Unghiuri Euler la Quaternion",
  T_46_META_WS_EXITVEHICLE: "Ieși din vehicul",
  T_46_META_WS_EXPONENTIATION: "Exponențiere",
  T_46_META_WS_FILTERENTITY: "Filtrează entitate",
  T_46_META_WS_FILTERLEVELOBJECTS: "Filtrează obiectele de nivel",
  T_46_META_WS_FIND: "Găsește",
  T_46_META_WS_FINDAT: "Găsește la",
  T_46_META_WS_FINDPATH: "Găsește traseul",
  T_46_META_WS_FLOOR: "Tavan",
  T_46_META_WS_FOOTBALLGOAL: "Gol de fotbal",
  T_46_META_WS_FORMAT: "Formatează",
  T_46_META_WS_GETALLKEYS: "Obține toate cheile",
  T_46_META_WS_GETALLPLAYERS: "Obține toți jucătorii",
  T_46_META_WS_GETALLSHOPS: "Obține toate magazinele",
  T_46_META_WS_GETALLTEAMS: "Obține toate echipele",
  T_46_META_WS_GETATTACKABLEENTITY: "Obține entitate atacabilă",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Obține facțiunile atacabile",
  T_46_META_WS_GETBACKPACKSKIN: "Obține aspectul rucsacului",
  T_46_META_WS_GETBLACKBOARDVALUE: "Obține valoarea tabloului negru",
  T_46_META_WS_GETBUFFS: "Obține buff-uri",
  T_46_META_WS_GETCHATCHANNEL: "Obține canal chat",
  T_46_META_WS_GETCHILDBYINDEX: "Obține copil după index",
  T_46_META_WS_GETCHILDBYNAME: "Obține copil după nume",
  T_46_META_WS_GETCHILDREN: "Obține toți copiii",
  T_46_META_WS_GETCOLORCHANNEL: "Obține canalul de culoare",
  T_46_META_WS_GETCONSUMABLES: "Obține consumabile",
  T_46_META_WS_GETCULLINGMASK: "Obține masca de culling",
  T_46_META_WS_GETCURRENTCAMERA: "Obține camera curentă",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Obține canal chat curent",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Obține progresul misiunii personalizate",
  T_46_META_WS_GETDYEDCOUNT: "Obține numărul de colorări",
  T_46_META_WS_GETDYEDSTATUS: "Obține statutul de colorare",
  T_46_META_WS_GETEQUIPMENTS: "Obține echipamente",
  T_46_META_WS_GETFACTION: "Obține facțiune",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Obține pragul global de somn",
  T_46_META_WS_GETITEMCOUNT: "Obține numărul de obiecte",
  T_46_META_WS_GETLOADEDSCENES: "Obține scenele încărcate",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Obține direcția de țintire locală",
  T_46_META_WS_GETLOCALPLAYER: "Obține jucătorul local",
  T_46_META_WS_GETLOCALTIMESTAMP: "Obține timestamp-ul local",
  T_46_META_WS_GETMAPID: "Obține ID hartă",
  T_46_META_WS_GETMINIMAP: "Obține mini harta",
  T_46_META_WS_GETMONEY: "Obține bani",
  T_46_META_WS_GETMONEYCOUNT: "Obține număr bani",
  T_46_META_WS_GETMORPH: "Obține transformare",
  T_46_META_WS_GETNODEVARIABLE: "Obține variabila nodului",
  T_46_META_WS_GETOUTFIT: "Obține ținută",
  T_46_META_WS_GETOWNER: "Obține proprietarul",
  T_46_META_WS_GETPARENT: "Obține părinte",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Obține poziția aproape de colegul de echipă",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Obține poziția de spawn aleatorie",
  T_46_META_WS_GETRESULTFROMCURVE: "Obține rezultat din curvă",
  T_46_META_WS_GETSCENESKYBOX: "Obține skybox-ul scenei",
  T_46_META_WS_GETSERVERREGION: "Obține regiunea serverului",
  T_46_META_WS_GETSERVERTIMESTAMP: "Obține timestamp server",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Obține partea de schelet după nume",
  T_46_META_WS_GETSKILLS: "Obține abilități",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Obține pragul de somn",
  T_46_META_WS_GETTOKENCOUNT: "Obține numărul de token-uri",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Obține numărul de token-uri de astăzi",
  T_46_META_WS_GETTYPE: "Obține tip",
  T_46_META_WS_GETVEHICLESKIN: "Obține aspectul vehiculului",
  T_46_META_WS_GETWALLET: "Obține portofel",
  T_46_META_WS_GETWEAPONSKIN: "Obține skin pentru armă",
  T_46_META_WS_GETWIDGETBYPATH: "Obține widget după cale",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Obține widget din UI personalizat",
  T_46_META_WS_GIVEJAILBREAKITEM: "Oferă item de evadare din închisoare",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Oferă recompensă pentru evadare din închisoare",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Există urmărire specială AOI",
  T_46_META_WS_HASCOMPONENT: "Are componentă",
  T_46_META_WS_HASSCRIPT: "Are script",
  T_46_META_WS_HASTAG: "Are etichetă",
  T_46_META_WS_HELPEDPLAYER: "Jucător ajutat",
  T_46_META_WS_HELPPLAYER: "Jucător asistent",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Ascunde grup aspect",
  T_46_META_WS_HITENTITY: "Entitate lovită",
  T_46_META_WS_HITFLY: "Lovește și ridică",
  T_46_META_WS_HITNORMAL: "Normală de impact",
  T_46_META_WS_HITOBJECT: "Obiect lovit",
  T_46_META_WS_HITPOSITION: "Poziție de lovire",
  T_46_META_WS_INDEXOF: "Indexul",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Infecție zombie evoluează",
  T_46_META_WS_INSERT: "Inserează",
  T_46_META_WS_ISATTACKABLE: "Este atacabil",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Este canalul de chat gol?",
  T_46_META_WS_ISEQUAL: "Este egal",
  T_46_META_WS_ISFRIEND: "Este prieten",
  T_46_META_WS_ISHIT: "A fost lovit",
  T_46_META_WS_ISINSIDEBOX: "Este în cub",
  T_46_META_WS_ISINSIDECYLINDER: "Este în cilindru",
  T_46_META_WS_ISINSIDESECTOR: "Este în sector",
  T_46_META_WS_ISINSIDESPHERE: "Este în sferă",
  T_46_META_WS_ISSLEEPING: "Este în somn",
  T_46_META_WS_ISSUBTYPEOF: "Este subtip de",
  T_46_META_WS_ITEM: "Entitate",
  T_46_META_WS_ITEMID: "ID obiect",
  T_46_META_WS_JOIN: "Alătură",
  T_46_META_WS_JOINCHATCHANNEL: "Alătură-te canalului de chat",
  T_46_META_WS_JOINFACTION: "Alătură-te facțiunii",
  T_46_META_WS_LASTINDEXOF: "Ultimul index",
  T_46_META_WS_LENGTH: "Lungime",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "Încarcă scenă",
  T_46_META_WS_LOGARITHM: "Logaritm",
  T_46_META_WS_LOGERROR: "Înregistrează eroare",
  T_46_META_WS_LOGINFO: "Înregistrează informații",
  T_46_META_WS_LOGWARNING: "Înregistrează avertisment",
  T_46_META_WS_LOOKROTATION: "Creează rotația către direcția țintă",
  T_46_META_WS_MAGNITUDE: "Magnitudine",
  T_46_META_WS_MAKER: "Creator",
  T_46_META_WS_MAX: "Max",
  T_46_META_WS_MECHANISM: "Mecanism",
  T_46_META_WS_MIN: "Min",
  T_46_META_WS_MONSTERUSESKILL: "Folosește abilitatea",
  T_46_META_WS_MORPHOBJECT: "Obiect de morfing",
  T_46_META_WS_MORPHTO: "Transformă în",
  T_46_META_WS_MORPHTOBYITEMID: "Transformă în după ID articol",
  T_46_META_WS_MOVECCT: "Mută CCT",
  T_46_META_WS_MOVEPOSITION: "Mută poziție",
  T_46_META_WS_MOVEROTATION: "Mută rotație",
  T_46_META_WS_MULTIPLYQUATERNION: "Înmulțire Quaternion",
  T_46_META_WS_MULTIRAYCAST: "Detectare cu multiple raycast-uri",
  T_46_META_WS_NEGATE: "Negativ",
  T_46_META_WS_NEW: "Nou",
  T_46_META_WS_NODENAME: "Nume nod",
  T_46_META_WS_NORMALIZE: "Normalizează",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Notifică redarea efectului",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Notifică redarea animației pictogramei",
  T_46_META_WS_NOTIFYPLAYSOUND: "Notifică redarea sunetului",
  T_46_META_WS_NOTIFYSHOWTIPS: "Notifică afișarea sugestiilor",
  T_46_META_WS_NUMTOSTRING: "Număr la șir",
  T_46_META_WS_ONACCESSEQUIPMENT: "Accesează echipament",
  T_46_META_WS_ONACCESSITEM: "Accesează obiect",
  T_46_META_WS_ONACCESSWEAPON: "Accesează armă",
  T_46_META_WS_ONACE: "ACE realizat",
  T_46_META_WS_ONAIMED: "Țintire completată",
  T_46_META_WS_ONAIMING: "Țintire",
  T_46_META_WS_ONASSIST: "Asistență",
  T_46_META_WS_ONATTACK: "Atac",
  T_46_META_WS_ONATTACKSTOP: "Oprire atac",
  T_46_META_WS_ONAWAKE: "Trezește-te",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Doborât",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Respins de cauciuc",
  T_46_META_WS_ONBOUNCEENTITY: "Respinge entitate",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Buton UI integrat apăsat",
  T_46_META_WS_ONBULLETHIT: "Lovit de glonț",
  T_46_META_WS_ONCAMERARAYCAST: "Raycast cameră",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Controller caracter lovit",
  T_46_META_WS_ONCHASE: "Urmărire",
  T_46_META_WS_ONCHASESTOP: "Oprire urmărire",
  T_46_META_WS_ONCLIPEND: "Sfârșit clip",
  T_46_META_WS_ONCOLLISIONENTER: "Început coliziune",
  T_46_META_WS_ONCOLLISIONEXIT: "Sfârșit coliziune",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Numărătoare inversă finalizată",
  T_46_META_WS_ONCREEP: "Târâre",
  T_46_META_WS_ONCROUCH: "Ghemuire",
  T_46_META_WS_ONDEALDAMAGE: "Provoacă daune",
  T_46_META_WS_ONDESTROY: "Distruge",
  T_46_META_WS_ONDISABLE: "Dezactivează",
  T_46_META_WS_ONDISCONNECT: "Deconectat",
  T_46_META_WS_ONDOUBLETAPPED: "Apăsare dublă",
  T_46_META_WS_ONDRAG: "Tragere",
  T_46_META_WS_ONDRAGEND: "Sfârșit tragere",
  T_46_META_WS_ONDRAGSTART: "Început tragere",
  T_46_META_WS_ONDRIVED: "Condus",
  T_46_META_WS_ONDRIVEVEHICLE: "Conduce vehicul",
  T_46_META_WS_ONDROPCONSUMABLE: "Lasă consumabil",
  T_46_META_WS_ONDROPPED: "Aruncat",
  T_46_META_WS_ONDROPWEAPON: "Lasă armă",
  T_46_META_WS_ONEACHLOOP: "Fiecare buclă",
  T_46_META_WS_ONELIMINATE: "Elimină",
  T_46_META_WS_ONELIMINATED: "Eliminat",
  T_46_META_WS_ONENABLE: "Activează",
  T_46_META_WS_ONEND: "Sfârșit",
  T_46_META_WS_ONENTERED: "Intrat",
  T_46_META_WS_ONENTERVEHICLE: "Intră în vehicul",
  T_46_META_WS_ONENTITYENTER: "Intrare entitate",
  T_46_META_WS_ONENTITYEXIT: "Ieșire entitate",
  T_46_META_WS_ONEQUIPARMOR: "Echipează armură",
  T_46_META_WS_ONEQUIPED: "Echipat",
  T_46_META_WS_ONEQUIPWEAPON: "Echipează armă",
  T_46_META_WS_ONEXPLODE: "Explozie",
  T_46_META_WS_ONFALL: "Când cade",
  T_46_META_WS_ONFALLSTOP: "La sfârșitul căderii",
  T_46_META_WS_ONFIRE: "Foc",
  T_46_META_WS_ONFIXEDUPDATE: "Actualizare fixă",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Coliziune cu mingea de fotbal",
  T_46_META_WS_ONFRIENDSUPDATE: "Actualizare stare prietenie ",
  T_46_META_WS_ONGAMEEND: "Sfârșit joc",
  T_46_META_WS_ONGAMEPAUSE: "Pauză joc",
  T_46_META_WS_ONGAMERESUME: "Reia joc",
  T_46_META_WS_ONGAMESTART: "Început joc",
  T_46_META_WS_ONGOAL: "Gol",
  T_46_META_WS_ONHITBYBULLET: "Lovit de glonț",
  T_46_META_WS_ONHITFLY: "Lovește în zbor",
  T_46_META_WS_ONHITFLYENTITY: "Lovește entitate în zbor",
  T_46_META_WS_ONHOOKGUNFIRE: "Foc cârlig",
  T_46_META_WS_ONIDLE: "Inactiv",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Început zonă de evadare",
  T_46_META_WS_ONJAILBREAKAREAEND: "Sfârșit zonă de evadare",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Intrare jucător în zonă de evadare",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Ieșire jucător din zonă de evadare",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Alăturare canal de chat reușită",
  T_46_META_WS_ONJOYSTICKMOVE: "Mișcare joystick",
  T_46_META_WS_ONJOYSTICKPRESSED: "Apăsat",
  T_46_META_WS_ONJOYSTICKRELEASED: "Eliberat",
  T_46_META_WS_ONJUMP: "Salt",
  T_46_META_WS_ONJUMPSTOP: "La sfârșitul săriturii",
  T_46_META_WS_ONLANDMINEACTIVE: "Mina activată",
  T_46_META_WS_ONLANDMINETRIGGER: "Declanșator mină",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Părăsește canal de chat",
  T_46_META_WS_ONLEAVEVEHICLE: "Părăsește vehicul",
  T_46_META_WS_ONLEFT: "Ieșit",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Obiect nivel transformat",
  T_46_META_WS_ONMOVE: "Mișcare",
  T_46_META_WS_ONNODEENTER: "Intrare nod",
  T_46_META_WS_ONNODEEXIT: "Ieșire nod",
  T_46_META_WS_ONPAUSE: "Pauză",
  T_46_META_WS_ONPHASEEND: "Sfârșit fază",
  T_46_META_WS_ONPHASESTART: "Început fază",
  T_46_META_WS_ONPICKEDUP: "Ridicat",
  T_46_META_WS_ONPLAYERASSIST: "Jucător asistă",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Jucător eliminat",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Jucător doborât",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Jucător provoacă daune",
  T_46_META_WS_ONPLAYERELIMINATE: "Jucător elimină",
  T_46_META_WS_ONPLAYERENTER: "Intrare jucător",
  T_46_META_WS_ONPLAYERJOIN: "Jucător intrare",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Eșec la alăturare canal de chat",
  T_46_META_WS_ONPLAYERLEAVE: "Ieșire jucător",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Jucător solicită cumpărare",
  T_46_META_WS_ONPLAYERQUIT: "Jucător ieșire",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Schimbare rang jucător",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Solicitare cumpărare îndeplinită",
  T_46_META_WS_ONPLAYERREVIVED: "Jucător reînviat",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Jucător reînviat la punctul de generare",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Schimbare scor jucător",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Jucător schimbă scenă",
  T_46_META_WS_ONPREDEALDAMAGE: "Înainte de a provoca daune",
  T_46_META_WS_ONPREPURCHASE: "Înainte de cumpărare",
  T_46_META_WS_ONPRESSED: "Apăsat",
  T_46_META_WS_ONPRETAKEDAMAGE: "Înainte de a primi daune",
  T_46_META_WS_ONPURCHASE: "Cumpărare",
  T_46_META_WS_ONRANKCHANGED: "Schimbare rang entitate",
  T_46_META_WS_ONRECONNECT: "Reconectat",
  T_46_META_WS_ONRELEASED: "Eliberat",
  T_46_META_WS_ONRELOAD: "Reîncarcă",
  T_46_META_WS_ONRESUME: "Reia",
  T_46_META_WS_ONREVIVED: "Reînviat",
  T_46_META_WS_ONROUNDEND: "Sfârșit rundă",
  T_46_META_WS_ONROUNDSTART: "Început rundă",
  T_46_META_WS_ONSCENELOAD: "Încărcare scenă",
  T_46_META_WS_ONSCENESWITCH: "Schimbare scenă",
  T_46_META_WS_ONSCORECHANGE: "Schimbare scor entitate",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Împușcat de shooter de fotbal",
  T_46_META_WS_ONSLEEP: "Somn",
  T_46_META_WS_ONSPAWN: "Generat",
  T_46_META_WS_ONSPRAY: "Spray",
  T_46_META_WS_ONSPRAYED: "Pulverizat",
  T_46_META_WS_ONSPRINT: "Sprint",
  T_46_META_WS_ONSPRINTSTOP: "Oprire sprint",
  T_46_META_WS_ONSTANDUP: "Ridicare",
  T_46_META_WS_ONSTART: "Început",
  T_46_META_WS_ONSTARTFIRE: "Atac",
  T_46_META_WS_ONSTATEEND: "Sfârșit stare",
  T_46_META_WS_ONSURFING: "Surfing",
  T_46_META_WS_ONSURFINGSTOP: "Oprire surfing",
  T_46_META_WS_ONSWITCHHANDHELD: "Schimbă dispozitiv portabil",
  T_46_META_WS_ONTAKEDAMAGE: "Primește daune",
  T_46_META_WS_ONTAPPED: "Apăsat",
  T_46_META_WS_ONTEAMACE: "Echipă complet eliminată",
  T_46_META_WS_ONTEAMADD: "Adăugare echipă",
  T_46_META_WS_ONTEAMREMOVE: "Eliminare echipă",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Schimbare rang echipă în rundă",
  T_46_META_WS_ONTEAMSCORECHANGE: "Schimbare scor echipă",
  T_46_META_WS_ONTELEPORTENTITY: "Teleportează entitate",
  T_46_META_WS_ONTEXTCHANGE: "Schimbare text",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Explozie obiect aruncat",
  T_46_META_WS_ONTOGGLE: "Comutare",
  T_46_META_WS_ONTOUCHDOWN: "Atingere jos",
  T_46_META_WS_ONTOUCHUP: "Atingere sus",
  T_46_META_WS_ONUIHIDE: "Ascundere UI",
  T_46_META_WS_ONUISHOW: "Afișare UI",
  T_46_META_WS_ONUPDATE: "Actualizare",
  T_46_META_WS_ONUSEAVATARSKILL: "Folosește abilitate avatar",
  T_46_META_WS_ONUSECONSUMABLE: "Folosește consumabil",
  T_46_META_WS_ONUSED: "Folosire",
  T_46_META_WS_ONUSEPORTAL: "Folosește portal",
  T_46_META_WS_ONWAKEUP: "Trezire",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Armă echipată",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Provocare daune cu armă",
  T_46_META_WS_ONWEAPONELIMINATE: "Eliminare cu armă",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Oprire foc armă",
  T_46_META_WS_OWNER: "Proprietar",
  T_46_META_WS_P_ACCELERATE: "Accelerare",
  T_46_META_WS_P_ACCELERATION: "Accelerare",
  T_46_META_WS_P_ACCOUNTID: "ID Cont",
  T_46_META_WS_P_ACCURACY: "Precizie",
  T_46_META_WS_P_ACTIONTYPE: "Tipul de acțiune",
  T_46_META_WS_P_ACTIVATEDALPHA: "Alfa activat",
  T_46_META_WS_P_ACTIVE: "Activ",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Activ în ierarhie",
  T_46_META_WS_P_ACTIVESELF: "Activ",
  T_46_META_WS_P_ACTIVETEXT: "Text activ",
  T_46_META_WS_P_ACTUALPOSITION: "Poziție actuală",
  T_46_META_WS_P_AFTERACCUMULATOR: "Acumulatoare după",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Decalaj Centru Asistență",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Distanță asistență țintire",
  T_46_META_WS_P_AIMASSISTTYPE: "Asistență la țintire",
  T_46_META_WS_P_AIRDROPSTATE: "Stare cădere aeriană",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Aliniere orizontală",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Aliniere verticală",
  T_46_META_WS_P_ALLITEMS: "Toate obiectele",
  T_46_META_WS_P_ALLMEMBERS: "Toți membrii",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Permite blocare prin asistență",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Permite apăsare în afara zonei",
  T_46_META_WS_P_ALLPLAYERS: "Toți jucătorii",
  T_46_META_WS_P_ALLTEAMMATES: "Toți colegii de echipă",
  T_46_META_WS_P_ALPHA: "Alfa",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Afișează întotdeauna marcajul",
  T_46_META_WS_P_AMBIENTCOLOR: "Culoare ambientală",
  T_46_META_WS_P_AMMOCLIPSIZE: "Mărime încărcător",
  T_46_META_WS_P_AMMOMAGSIZE: "Dimensiunea magazinului de muniție",
  T_46_META_WS_P_AMMOPERSHOT: "Muniție per Tir",
  T_46_META_WS_P_AMMOTYPE: "Tip muniție",
  T_46_META_WS_P_ANCHORMAX: "Ancoră maximă",
  T_46_META_WS_P_ANCHORMIN: "Ancoră minimă",
  T_46_META_WS_P_ANCHOROBJECT: "Obiect ancoră",
  T_46_META_WS_P_ANCHORPOSITION: "Poziție ancoră",
  T_46_META_WS_P_ANCHORTYPE: "Activare UITweener",
  T_46_META_WS_P_ANGLE: "Unghi",
  T_46_META_WS_P_ANGLEDOWN: "Unghi jos",
  T_46_META_WS_P_ANGLEUP: "Unghi sus",
  T_46_META_WS_P_ANGULARDRAG: "Frânare Angulară",
  T_46_META_WS_P_ANGULARSPEED: "Viteză unghiulară",
  T_46_META_WS_P_ANGULARVELOCITY: "Viteză Angulară (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Nume animație",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Controler de animație",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "ID Resursă Controler Animație",
  T_46_META_WS_P_ARMORPENETRATION: "Penetrare armură",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Factor de penetrare a armurii",
  T_46_META_WS_P_ARMORTYPE: "Tip armură",
  T_46_META_WS_P_ARROWOFFSET: "Ofset săgeată",
  T_46_META_WS_P_ARROWSIZE: "Dimensiune săgeată",
  T_46_META_WS_P_ARROWSPRITE: "Sprite săgeată",
  T_46_META_WS_P_ASKBUYTARGET: "Cerere de cumpărare a țintei",
  T_46_META_WS_P_ATTACHTARGET: "Țintă Atașată",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Facțiuni atacabile",
  T_46_META_WS_P_ATTACKDAMAGE: "Daune de atac",
  T_46_META_WS_P_ATTACKINTERVAL: "Interval atac",
  T_46_META_WS_P_ATTACKRANGE: "Rază atac",
  T_46_META_WS_P_ATTACKTARGET: "Ținta atacului",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Obiectivele atacabile",
  T_46_META_WS_P_AUTOPLAY: "Starea de redare automată",
  T_46_META_WS_P_AVAILABLEPOINT: "Punct disponibil",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "ID Avatar",
  T_46_META_WS_P_BACKGROUND: "Fundal",
  T_46_META_WS_P_BACKGROUNDALPHA: "Alfa fundal",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Culoare fundal",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Culoare fundal 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Culoare fundal 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Umplere fundal",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Nume iconiță fundal",
  T_46_META_WS_P_BACKGROUNDNAME: "Nume fundal",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Ofset fundal",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Raza fundalului",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Dimensiune delta fundal",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Sprite fundal",
  T_46_META_WS_P_BACKPACK: "Rucsac",
  T_46_META_WS_P_BACKPACKSKINID: "ID-ul pielii rucsacului",
  T_46_META_WS_P_BACKWARDSPEED: "Viteză înapoi",
  T_46_META_WS_P_BANNERID: "ID Banner",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Viteză orizontală de bază",
  T_46_META_WS_P_BASEMULTIPLIER: "Înmulțitor de bază",
  T_46_META_WS_P_BASETIME: "Timp de Bază",
  T_46_META_WS_P_BASEVERTICALSPEED: "Viteză verticală de bază",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Acumulatoare înainte",
  T_46_META_WS_P_BEVTREEID: "ID-ul arborelui de comportament",
  T_46_META_WS_P_BINDPROPERTYID: "ID proprietate legată",
  T_46_META_WS_P_BODY: "Torace",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Factor de daune corporale",
  T_46_META_WS_P_BONEPOSITION: "Poziția oaselor",
  T_46_META_WS_P_BONESCALE: "Scalare oase",
  T_46_META_WS_P_BOOSTCD: "CD-ul boost",
  T_46_META_WS_P_BOOSTDURATION: "Durată de boost",
  T_46_META_WS_P_BOOSTSPEED: "Viteză de boost",
  T_46_META_WS_P_BORDERLR: "Margine stânga dreapta",
  T_46_META_WS_P_BORDERTB: "Margine sus jos",
  T_46_META_WS_P_BOTTOMALPHA: "Alfa de jos",
  T_46_META_WS_P_BOUNDWALLET: "Tip ancoră HUD",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Puterea frânei",
  T_46_META_WS_P_BRAKETORQUE: "Cuplu de frână",
  T_46_META_WS_P_BRRANK: "Rang BR",
  T_46_META_WS_P_BUFFTYPE: "Tip de buff",
  T_46_META_WS_P_BURNDAMAGE: "Daune ardere",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Interval daune ardere",
  T_46_META_WS_P_BURNTIME: "Timp de ardere",
  T_46_META_WS_P_BUTTOM: "Partea de jos",
  T_46_META_WS_P_BUTTONCOLORS: "Culori butoane",
  T_46_META_WS_P_BUTTONNAMES: "Nume butoane",
  T_46_META_WS_P_BUTTONSTYLE: "Stil buton",
  T_46_META_WS_P_CAMERABLOCKMODE: "Mod de Blocat al Camerei",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Mod de Proiecție al Camerei",
  T_46_META_WS_P_CAMERATYPE: "Cameră",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Anulează tragerea dacă se potrivește",
  T_46_META_WS_P_CANCOSTDURABILITY: "Poate afecta durabilitatea",
  T_46_META_WS_P_CANDAMAGED: "Poate Fi Deteriorat",
  T_46_META_WS_P_CANDESTROY: "Poate fi distrus",
  T_46_META_WS_P_CANDESTROYED: "Poate Fi Distrus",
  T_46_META_WS_P_CANSELFTRIGGER: "Poate fi declanșat de sine",
  T_46_META_WS_P_CANTEAMTRIGGER: "Poate fi declanșat de echipă",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Poate fi declanșat de sine",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Poate fi declanșat de echipă",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Poate fi declanșat de vehicul",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Poate fi declanșat de vehicul",
  T_46_META_WS_P_CELLSIZE: "Dimensiunea celulei",
  T_46_META_WS_P_CELLSPACE: "Spațiu între celule",
  T_46_META_WS_P_CENTER: "Centru",
  T_46_META_WS_P_CENTERINVISIBLE: "Centru invizibil",
  T_46_META_WS_P_CENTEROFFSET: "Offset Centru",
  T_46_META_WS_P_CENTEROFMASS: "Centrul de Masă",
  T_46_META_WS_P_CENTERRANGE: "Raza Centrală",
  T_46_META_WS_P_CENTRALFLASHTIME: "Timpul Flash de Margine",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Linie centrală activă",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Poziție linie centrală",
  T_46_META_WS_P_CHANNELID: "ID canal chat",
  T_46_META_WS_P_CHARGEMAX: "Încărcare maximă",
  T_46_META_WS_P_CHASETARGET: "Ținta urmăririi",
  T_46_META_WS_P_CHATCHANNEL: "Canal de chat",
  T_46_META_WS_P_CHECKPOINTID: "ID checkpoint",
  T_46_META_WS_P_CHILDINDEX: "Index copil",
  T_46_META_WS_P_CHIPEXP: "Experiență cip",
  T_46_META_WS_P_CLICKSIZE: "Mărime click",
  T_46_META_WS_P_CLIPLENGTH: "Lungimea clipului",
  T_46_META_WS_P_CLIPPINGTYPE: "Tip decupare",
  T_46_META_WS_P_COLLIDERID: "ID colizor",
  T_46_META_WS_P_CONSTRAIN: "Constrângere",
  T_46_META_WS_P_CONSTRAINT: "Constrângere",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Număr constrângeri",
  T_46_META_WS_P_CONSUMABLETYPE: "Tip consumabil",
  T_46_META_WS_P_CONTENT: "Conținut",
  T_46_META_WS_P_CONTENTORIGIN: "Originea conținutului",
  T_46_META_WS_P_CONTROLPOINTS: "Puncte de control",
  T_46_META_WS_P_COORDINATESYSTEM: "Sistem de coordonate",
  T_46_META_WS_P_COUNT: "Număr",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Timp sfârșit numărătoare inversă (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Cheie contor",
  T_46_META_WS_P_COUNTDOWNTIME: "Timp contor",
  T_46_META_WS_P_COUNTPERWAVE: "Număr pe val",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Daune maxime de coliziune",
  T_46_META_WS_P_CRASHMAXSPEED: "Viteză maximă de coliziune",
  T_46_META_WS_P_CRASHMESSFACTOR: "Factor de masă de coliziune",
  T_46_META_WS_P_CRASHMINDAMAGE: "Daune minime de coliziune",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Scala de viteză a mișcării în târâre",
  T_46_META_WS_P_CREATEDENTITY: "Entitate creată",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Scala de viteză a mișcării în poziție ghemuită",
  T_46_META_WS_P_CSRANK: "Rang CS",
  "T_46_META_WS_P_CURRENT AMMO": "Muniția curentă",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Resursa de animație curentă",
  T_46_META_WS_P_CURRENTCLIP: "Clip curent",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Progres clip curent",
  T_46_META_WS_P_CURRENTDURABILITY: "Durabilitate Curentă",
  T_46_META_WS_P_CURRENTENERGY: "Energie curentă",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Element de mână curent",
  T_46_META_WS_P_CURRENTHP: "HP curent",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Index de fază curentă",
  T_46_META_WS_P_CURRENTPROGRESS: "Progres Curent",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Index de rundă curentă",
  T_46_META_WS_P_CURRENTSTATE: "Stare curentă",
  T_46_META_WS_P_CURRENTVALUE: "Valoare curentă",
  T_46_META_WS_P_CURRENTWAVE: "Valul curent",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Resursa personalizată a caracterului",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Rezultatul jocului personalizat",
  T_46_META_WS_P_CUSTOMGRAVITY: "Gravitație personalizată",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Forță de Împingere Personalizată",
  T_46_META_WS_P_CUSTOMXY: "XY personalizat",
  T_46_META_WS_P_DAMAGE: "Daune",
  "T_46_META_WS_P_DAMAGE RANGE": "Rază",
  T_46_META_WS_P_DAMAGEFACTOR: "Factor daune",
  T_46_META_WS_P_DAMAGEINTERVAL: "Interval de daune (ms)",
  T_46_META_WS_P_DAMAGERADIUS: "Rază de daune",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Raport daune cap",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Raport daune membre",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Factorul de Reducere a Deteriorării",
  T_46_META_WS_P_DAMAGETAKENPCT: "Procentajul de daune primite",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Procentaj de daune primite",
  T_46_META_WS_P_DAMAGEVALUE: "Valoare daune",
  T_46_META_WS_P_DARKNESS: "Întuneric",
  T_46_META_WS_P_DECELERATIONPERCENT: "Procentaj de decelerare",
  T_46_META_WS_P_DEFAULTTEXT: "Text implicit",
  T_46_META_WS_P_DEFENSE: "Rată apărare",
  T_46_META_WS_P_DEFENSERATE: "Rată de apărare",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Timp Delta",
  T_46_META_WS_P_DELTAVALUE: "Valoare delta",
  T_46_META_WS_P_DEPTH: "Adâncime",
  T_46_META_WS_P_DESC: "Descriere",
  T_46_META_WS_P_DESCRIPTION: "Descriere",
  T_46_META_WS_P_DESCRIPTIONKEY: "Cheie descriere",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Parametri descriere",
  T_46_META_WS_P_DESTVAL: "Valoare destinație",
  T_46_META_WS_P_DETECTRANGE: "Rază de detectare",
  T_46_META_WS_P_DIFFUSEALPHA: "Alfa Difuză",
  T_46_META_WS_P_DIFFUSECOLOR: "Culoare Difuză",
  T_46_META_WS_P_DIFFUSETEXTURE: "Textură Difuză",
  T_46_META_WS_P_DISABLECOLOR: "Culoare dezactivată",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Dezactivați daunele la cădere",
  T_46_META_WS_P_DISABLEITEMDROP: "Dezactivați renunțarea obiectelor",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Dezactivați ridicarea obiectelor",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Dezactivare închidere manuală",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Dezactivați chatul rapid",
  T_46_META_WS_P_DISABLERECIPROCATING: "Dezactivează reciprocitatea",
  T_46_META_WS_P_DISABLEVOICECHAT: "Dezactivați chatul vocal",
  T_46_META_WS_P_DISTANCE: "Distanță",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Tipul de armă dublă",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Scala de viteză a mișcării în târâre",
  T_46_META_WS_P_DOWNSPEED: "Viteză jos",
  T_46_META_WS_P_DRAG: "Frânare",
  T_46_META_WS_P_DRIVER: "Șofer",
  T_46_META_WS_P_DROPITEMS: "Articole căzute",
  T_46_META_WS_P_DURABILITY: "Durabilitate",
  T_46_META_WS_P_DURABILITYRECOVERY: "Recuperarea durabilității",
  T_46_META_WS_P_DURATION: "Durată",
  T_46_META_WS_P_EDGEFLASHTIME: "Comutatorul Efectului Flashbang",
  T_46_META_WS_P_EFFECTACTIVE: "Efect activ",
  T_46_META_WS_P_EFFECTCOLOR: "Culoare efect",
  T_46_META_WS_P_EFFECTDURATION: "Timp de Declanșare",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Interval de timp efectiv",
  T_46_META_WS_P_EFFECTRESID: "Cale resurse efect",
  T_46_META_WS_P_ENABLE: "Activare",
  T_46_META_WS_P_ENABLEATTACK: "Permite atac",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Activarea revitalizării bot",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Activare hartă de adâncime",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Permite căderea la moarte",
  T_46_META_WS_P_ENABLELOCALIZATION: "Activare Localizare",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Mișcare în Aer",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Activare reînviere jucător",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Activare Vizualizare Jucător",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Activează Rotirea cu Gravitația",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Activare atribute de piele",
  T_46_META_WS_P_ENABLESWINGING: "Activează balansarea",
  T_46_META_WS_P_ENABLETRACTION: "Activează tracțiunea",
  T_46_META_WS_P_ENDPOSITION: "Poziție de final",
  T_46_META_WS_P_ENDRADIUS: "Raza de sfârșit",
  T_46_META_WS_P_ENDTIME: "Timp sfârșit (ms)",
  T_46_META_WS_P_ENDTIMES: "Timp final S",
  T_46_META_WS_P_ENDVALUE: "Valoare finală",
  T_46_META_WS_P_ENERGY: "Energie",
  T_46_META_WS_P_ENERGYCOST: "Cost energie",
  T_46_META_WS_P_ENERGYRECOVERY: "Recuperare energie",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Puterea motorului",
  T_46_META_WS_P_ENGINETORQUE: "Cuplu motor",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "EP maxim",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "Cantitate recuperare EP",
  T_46_META_WS_P_EVENTS: "Evenimente",
  T_46_META_WS_P_EXPLODEDAMAGE: "Daune explozie",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Factorul de Reducere a Deteriorării Explozive",
  T_46_META_WS_P_EXPLODEDELAY: "Întârziere explozie",
  T_46_META_WS_P_EXPLODERANGE: "Rază de explozie",
  T_46_META_WS_P_EXPLOSIONDELAY: "Timpul Flash Central",
  T_46_META_WS_P_EXPLOSIONRANGE: "Raza de Explozie",
  T_46_META_WS_P_EXPLOSIONTIME: "Întârziere de Explozie",
  T_46_META_WS_P_EXPPERDAMAGE: "Exp pe daune",
  T_46_META_WS_P_EXPPERMOVEMILE: "Exp pe milă parcursă",
  T_46_META_WS_P_EXPPERSECOND: "Exp pe secundă",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Capacitate suplimentară rucsac",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Spațiu Extra pentru Rucsac",
  T_46_META_WS_P_EXTRAHPRATIO: "Proporție suplimentară HP",
  T_46_META_WS_P_FACEPAINT: "Machiaj",
  T_46_META_WS_P_FACTION: "Faction",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Rata de daune la cădere",
  T_46_META_WS_P_FALLSPEED: "Viteză de cădere",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Viteză reîncărcare automată",
  T_46_META_WS_P_FILEID: "ID fișier",
  T_46_META_WS_P_FILL: "Umplere",
  T_46_META_WS_P_FILLAMOUNT: "Valoarea umplerii",
  T_46_META_WS_P_FILLDIRECTION: "Direcția umplerii",
  T_46_META_WS_P_FILLTYPE: "Tip umplere",
  T_46_META_WS_P_FIREANGLELIMIT: "Limită unghi de tragere",
  T_46_META_WS_P_FIRETYPE: "Tip de foc",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Parametri Primul Scor",
  T_46_META_WS_P_FIRSTSCORETITLE: "Titlu Primul Scor",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Valoare Primul Scor",
  T_46_META_WS_P_FIXEDDELTATIME: "Delta fix",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Durata Efectului",
  T_46_META_WS_P_FLIP: "Răsturnare",
  T_46_META_WS_P_FLIPTYPE: "Tip flip",
  T_46_META_WS_P_FLYMAXHEIGHT: "Înălțimea maximă de zbor",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Viteză orizontală de zbor",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Viteză verticală de zbor",
  T_46_META_WS_P_FOGCOLOR: "Culoare ceață",
  T_46_META_WS_P_FOLLOWTARGET: "Urmărește țintă",
  T_46_META_WS_P_FONT: "Font",
  T_46_META_WS_P_FONTSIZE: "Dimensiune font",
  T_46_META_WS_P_FONTSTYLE: "Stil font",
  T_46_META_WS_P_FONTTYPE: "Tip font",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Forțează sincronizarea cu clientul",
  T_46_META_WS_P_FORWARD: "Înainte",
  T_46_META_WS_P_FORWARDSPEED: "Viteză înainte",
  T_46_META_WS_P_FOV: "Câmpul de Vizibilitate",
  T_46_META_WS_P_FREEZEDURATION: "Durata înghețării (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Facțiuni prietenoase",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Jucători prietenoși",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Distanța completă a daunelor",
  T_46_META_WS_P_FUNCTIONTYPE: "Tip funcție",
  T_46_META_WS_P_GAINHPCOLOR: "Culoare câștig HP",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Numărul total de cadre",
  T_46_META_WS_P_GAMETIMECOUNT: "Timp de joc",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Întârziere schimbare treaptă",
  T_46_META_WS_P_GENDER: "Gen",
  T_46_META_WS_P_GETONBOOSTCD: "CD-ul pentru urcare pe boost",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Comutator CD pentru urcare pe boost",
  T_46_META_WS_P_GETONSKATEBOARDCD: "CD-ul pentru urcare pe skateboard",
  T_46_META_WS_P_GRADIENT: "Gradient",
  T_46_META_WS_P_GRADIENTBOTTOM: "Gradient de jos",
  T_46_META_WS_P_GRADIENTTOP: "Gradient de sus",
  T_46_META_WS_P_GRAVITY: "Gravitație",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Daune maxime grenadă",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Daune minime grenadă",
  T_46_META_WS_P_GRENADERANGE: "Raza grenadă",
  T_46_META_WS_P_GROUPID: "ID grup",
  T_46_META_WS_P_HEAD: "Cap de sus",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Factor de daune la cap",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Reducerea daunelor de cap",
  T_46_META_WS_P_HEIGHT: "Înălțime",
  T_46_META_WS_P_HELMET: "Casca",
  T_46_META_WS_P_HIGHESTBRRANK: "Cel Mai Înalt Rang BR",
  T_46_META_WS_P_HIGHESTCSRANK: "Cel Mai Înalt Rang CS",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Unghiul minim de elevație",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Limită de direcție la viteză mare",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Limită de direcție la viteză mare prag",
  T_46_META_WS_P_HITPOINTEFFECT: "Efect punct de lovitură",
  T_46_META_WS_P_HORIZONTALBAR: "Bară orizontală",
  T_46_META_WS_P_HORIZONTALOFFSET: "Ofset orizontal",
  T_46_META_WS_P_HOSTILETEAMS: "Echipe inamice",
  T_46_META_WS_P_HOSTTEAM: "Echipa gazdă",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "HP maxim",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "Cantitate recuperare HP",
  T_46_META_WS_P_HPRECOVERYSPEED: "Viteză de recuperare a HP (ms)",
  T_46_META_WS_P_ICON: "Iconiță",
  T_46_META_WS_P_ICONCOLOR: "Culoare iconiță",
  T_46_META_WS_P_ICONNAME: "Nume iconiță",
  T_46_META_WS_P_ICONRESOURCE: "Resursă iconiță",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Interval daune (s)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Frână de repaus",
  T_46_META_WS_P_INACTIVATEDALPHA: "Alfa dezactivat",
  T_46_META_WS_P_INDEX: "Index",
  T_46_META_WS_P_INITIALMAGCOUNT: "Numărul inițial al magazinelor",
  T_46_META_WS_P_INITIALSPEED: "Viteză inițială",
  T_46_META_WS_P_INITIALVALUE: "Valoare inițială",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Poziție inițială lume",
  T_46_META_WS_P_INSCENE: "În Scenă",
  T_46_META_WS_P_INSTANCEID: "ID-ul instanței",
  T_46_META_WS_P_INTENSITY: "Intensitate",
  T_46_META_WS_P_INVERTFILL: "Inversare umplere",
  T_46_META_WS_P_INVINCIBLE: "Invincibil",
  "T_46_META_WS_P_IS SHOW": "Este vizibil",
  T_46_META_WS_P_IS3D: "Este 3D",
  T_46_META_WS_P_ISACE: "Este ACE?",
  T_46_META_WS_P_ISACED: "Este eliminat",
  T_46_META_WS_P_ISAI: "Este AI?",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Întotdeauna pe ecran",
  T_46_META_WS_P_ISAPPLYSHADOW: "Aplicare umbră",
  T_46_META_WS_P_ISATTACKABLE: "Atacabil",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Urmărire automată a inamicului",
  T_46_META_WS_P_ISAUTOPLAY: "Redare automată",
  T_46_META_WS_P_ISAUTOTELEPORT: "Este teleportare automată",
  T_46_META_WS_P_ISBILLBOARD: "Întotdeauna în videoclip",
  T_46_META_WS_P_ISBOLD: "Îngroșat",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Coliziune Inferioară",
  T_46_META_WS_P_ISCENTERPOS: "Este poziție centru",
  T_46_META_WS_P_ISCONSUMEAMMO: "Consumarea muniției",
  T_46_META_WS_P_ISCONTINUOUS: "Este continuu",
  T_46_META_WS_P_ISCOUNTDOWN: "Este numărătoare inversă",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Este Animatia Curentă În Loop?",
  T_46_META_WS_P_ISDEADDROP: "Suport la moarte",
  T_46_META_WS_P_ISDEATHTRIGGER: "Este declanșator de moarte",
  T_46_META_WS_P_ISDEBUG: "Activare debug BTree",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Este punct de apariție implicit",
  T_46_META_WS_P_ISDROPONELIMINATED: "Pierdere echipament la eliminare",
  T_46_META_WS_P_ISEND: "Este final",
  T_46_META_WS_P_ISFEBUTTON: "Este buton FE",
  T_46_META_WS_P_ISGREY: "Este gri",
  T_46_META_WS_P_ISGROUNDED: "Aderat la Sol",
  T_46_META_WS_P_ISIGNOREDEPTH: "Ignoră adâncimea",
  T_46_META_WS_P_ISINVINCIBLE: "Este invincibil",
  T_46_META_WS_P_ISITALIC: "Italic",
  T_46_META_WS_P_ISLASTROUND: "Ultima rundă",
  T_46_META_WS_P_ISLOCALPOS: "Este poziție locală",
  T_46_META_WS_P_ISLOOP: "Este ciclic",
  T_46_META_WS_P_ISMATCHPOINT: "Punct de meci",
  T_46_META_WS_P_ISMOVEABLE: "Se poate mișca",
  T_46_META_WS_P_ISOCCUPIED: "Este ocupat",
  T_46_META_WS_P_ISOPENTWEEN: "Este OpenTween",
  T_46_META_WS_P_ISPLAYING: "Este în redare",
  T_46_META_WS_P_ISPURCHASABLE: "Articole magazin",
  T_46_META_WS_P_ISREVERSE: "Este invers",
  T_46_META_WS_P_ISSERVERDRIVEN: "Condus de Server",
  T_46_META_WS_P_ISSHOW: "Afișează",
  T_46_META_WS_P_ISSHOWHUDNAME: "Afișează numele HUD",
  T_46_META_WS_P_ISSHOWMAPINFO: "Afișează informații harta",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Afișează mesaj rapid",
  T_46_META_WS_P_ISSHOWSCAN: "Afișează scanare",
  T_46_META_WS_P_ISSHOWTAG: "Afișează eticheta",
  T_46_META_WS_P_ISSIDECOLLIDING: "Coliziune Laterală",
  T_46_META_WS_P_ISSILENCE: "Este Silențios",
  T_46_META_WS_P_ISSINGLESHOT: "Este Unic",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Sari animatia caderii",
  T_46_META_WS_P_ISSLIDING: "Alunecă",
  T_46_META_WS_P_ISTOPCOLLIDING: "Coliziune Superioră",
  T_46_META_WS_P_ISUNDERLINE: "Subliniat",
  T_46_META_WS_P_ISVISIBLE: "Este vizibil",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Culori fundal carduri",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Sprite fundal carduri",
  T_46_META_WS_P_ITEMCOUNTS: "Este achiziționabil",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Descrieri carduri",
  T_46_META_WS_P_ITEMICONS: "Sprite iconițe carduri",
  T_46_META_WS_P_ITEMID: "ID-ul obiectului",
  T_46_META_WS_P_ITEMIDS: "ID-uri obiecte",
  T_46_META_WS_P_ITEMNAMES: "Nume carduri",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Lista de interdicție pentru obiecte",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Raza de tragere capac joystick",
  T_46_META_WS_P_JOYSTICKIMAGE: "Imagine capac joystick",
  T_46_META_WS_P_JOYSTICKRADIUS: "Raza capacului joystick",
  T_46_META_WS_P_JUMPCD: "CD-ul salt",
  T_46_META_WS_P_JUMPHEIGHT: "Înălțime Săritură",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Scara înălțimii săriturii",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Bonus de daune la cădere",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Stare de Knockdown",
  T_46_META_WS_P_LABEL: "Etichetă",
  T_46_META_WS_P_LABELCOLOR: "Culoare etichetă",
  T_46_META_WS_P_LABELKEY: "Cheie etichetă",
  T_46_META_WS_P_LABELPARAMS: "Parametri etichetă",
  T_46_META_WS_P_LASTCHECKPOINTID: "ID-ul punctului de control",
  T_46_META_WS_P_LASTSURVIVALTIME: "Ultimul timp de supraviețuire",
  T_46_META_WS_P_LAYERTYPE: "Tip strat",
  T_46_META_WS_P_LAYOUTTYPE: "Tip aranjament",
  T_46_META_WS_P_LEFTARM: "Brațul stâng",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Culoare fundal stânga",
  T_46_META_WS_P_LEFTCOLOR: "Culoare Stânga",
  T_46_META_WS_P_LEFTDESCRIPTION: "Descriere Echipa Stânga",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Efect stânga activ",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Unghi de tragere stânga",
  T_46_META_WS_P_LEFTFOOT: "Piciorul stâng jos",
  T_46_META_WS_P_LEFTHAND: "Mâna stângă",
  T_46_META_WS_P_LEFTICON: "Iconiță stângă",
  T_46_META_WS_P_LEFTICONNAME: "Nume iconiță stânga",
  T_46_META_WS_P_LEFTLEG: "Piciorul stâng",
  T_46_META_WS_P_LEFTPLAYERS: "Jucători stânga",
  T_46_META_WS_P_LEFTSCORE: "Scor stâng",
  T_46_META_WS_P_LEFTSCOREAFTER: "Scor final stâng",
  T_46_META_WS_P_LEFTSCORETEXT: "Scor stâng",
  T_46_META_WS_P_LEFTTEAM: "Echipa dreaptă",
  T_46_META_WS_P_LEFTTEAMINDEX: "Index echipă stânga",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Număr jucători vii stânga",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Număr Steag Membri Echipa Stânga",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Stare Membri Echipa Stânga",
  T_46_META_WS_P_LEFTTEAMNAME: "Nume Echipa Stânga",
  T_46_META_WS_P_LEFTTEAMSCORE: "Scor Echipa Stânga",
  T_46_META_WS_P_LEFTTEXT: "Text stâng",
  T_46_META_WS_P_LENGTH: "Lungime",
  T_46_META_WS_P_LENSFLARE: "Flare de obiectiv",
  T_46_META_WS_P_LEVEL: "Nivel",
  T_46_META_WS_P_LIFETIME: "Timp de viață (s)",
  T_46_META_WS_P_LIGHTCOLOR: "Culoare lumină",
  T_46_META_WS_P_LIGHTINTENSITY: "Intensitate lumină",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Factor de daune la membre",
  T_46_META_WS_P_LINESPACING: "Spațiere între linii",
  T_46_META_WS_P_LOCALPOSITION: "Poziție locală",
  T_46_META_WS_P_LOCALROTATION: "Rotire local",
  T_46_META_WS_P_LOCALROTATIONQ: "Quaternion local",
  T_46_META_WS_P_LOCALSCALE: "Scală locală",
  T_46_META_WS_P_LOCKEY: "Cheie de localizare",
  T_46_META_WS_P_LOOPCOUNT: "Număr bucle",
  T_46_META_WS_P_LOOTSOCCER: "Loot Fotbal",
  T_46_META_WS_P_LOSEHPCOLOR: "Culoare pierdere HP",
  T_46_META_WS_P_LOSEMVPS: "MVP-uri pierzătoare",
  T_46_META_WS_P_LOSETEXT: "Text înfrângere",
  "T_46_META_WS_P_MAIN CAMERA": "Camera principal",
  T_46_META_WS_P_MAINCOLOR: "Culoare principală",
  T_46_META_WS_P_MAINSCORELIST: "Punctaje principale",
  T_46_META_WS_P_MAINSCORETITLE: "Titlu punctaj principal",
  T_46_META_WS_P_MAINWEAPON: "Arma principal",
  T_46_META_WS_P_MAPSIZE: "Dimensiune hartă",
  T_46_META_WS_P_MASK: "Mască",
  T_46_META_WS_P_MASKNAME: "Nume mască",
  T_46_META_WS_P_MASS: "Masă (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Titlu meci stânga",
  T_46_META_WS_P_MATCHTITLERIGHT: "Titlu meci dreapta",
  T_46_META_WS_P_MAXCAPACITY: "Capacitate maximă",
  T_46_META_WS_P_MAXCOUNT: "Nr. maxim",
  T_46_META_WS_P_MAXDAMAGE: "Daune Maxime",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Unghi maxim de coborâre",
  T_46_META_WS_P_MAXDISPLACEMENT: "Dezpl. maxim",
  T_46_META_WS_P_MAXDISTANCE: "Distanță maximă",
  T_46_META_WS_P_MAXDURABILITY: "Durabilitate Maximă",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Raport durabilitate maximă",
  T_46_META_WS_P_MAXENERGY: "Energie maximă",
  T_46_META_WS_P_MAXEP: "EP maxim",
  T_46_META_WS_P_MAXHP: "HP maxim",
  T_46_META_WS_P_MAXJUMPCOUNT: "Număr Maxim de Sărituri",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Înălțimea maximă a săriturii",
  T_46_META_WS_P_MAXLENGTH: "Lungime maximă",
  T_46_META_WS_P_MAXPROGRESS: "Progres Maxim",
  T_46_META_WS_P_MAXSCATTERRATIO: "Rata maximă de dispersie",
  T_46_META_WS_P_MAXSPEED: "Viteză Maximă",
  T_46_META_WS_P_MAXTURRETCOUNT: "Număr maxim turele",
  T_46_META_WS_P_MAXVALUE: "Valoare maximă",
  T_46_META_WS_P_MAXWIDGETID: "MaxWidgetID",
  T_46_META_WS_P_MINDAMAGE: "Daune minimă",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Distanța minimă a daunelor",
  T_46_META_WS_P_MINDISTANCE: "Distanță minimă",
  T_46_META_WS_P_MINELEVATIONANGLE: "Unghi minim de ridicare",
  T_46_META_WS_P_MINENDHEIGHT: "Înălțimea minimă de sfârșit",
  T_46_META_WS_P_MINFLYHEIGHT: "Înălțimea minimă de zbor",
  T_46_META_WS_P_MINMOVEDISTANCE: "Distanță Minimă de Mișcare",
  T_46_META_WS_P_MINVALUE: "Valoare minimă",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Daune maxime ale rachetei",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Daune minime ale rachetei",
  T_46_META_WS_P_MISSILERANGE: "Raza rachetei",
  T_46_META_WS_P_MODEL: "Model",
  T_46_META_WS_P_MODELVISIBILITY: "Vizibilitate model",
  T_46_META_WS_P_MODELVISIBLE: "Vizibilitatea modelului",
  T_46_META_WS_P_MONEY: "Bani",
  T_46_META_WS_P_MONEYLIST: "Lista de bani",
  T_46_META_WS_P_MONEYS: "Portofel legat",
  T_46_META_WS_P_MONEYTYPE: "Tip monedă",
  T_46_META_WS_P_MONSTERTYPE: "Tip monstru",
  T_46_META_WS_P_MOTIONTYPE: "Tip de mișcare",
  T_46_META_WS_P_MOTIONVALUEX: "Valoare mișcare X",
  T_46_META_WS_P_MOTIONVALUEY: "Valoare mișcare Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Valoare mișcare Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Durata mișcării",
  T_46_META_WS_P_MULTIPLIER: "Înmulțitor",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Tip element muzical",
  T_46_META_WS_P_MUZZLEVELOCITY: "Viteză gura țevii",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Nume",
  T_46_META_WS_P_NEXTROUNDINDEX: "Index runda următoare",
  T_46_META_WS_P_NICKNAME: "Pseudonim",
  T_46_META_WS_P_NORMALCOLOR: "Culoare normală",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Poziție normalizată",
  T_46_META_WS_P_NUMBERINFACTION: "Număr în facțiune",
  T_46_META_WS_P_OBJECTID: "ID obiect",
  T_46_META_WS_P_OFFSET: "Offset",
  T_46_META_WS_P_OPTIONS: "Opțiuni",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Alt factor de daune",
  T_46_META_WS_P_OUTFIT: "Îmbrăcăminte",
  T_46_META_WS_P_OVERFLOW: "Depășire text",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Viteză de cădere după depășirea înălțimii",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Prioritate Configurare Jucător",
  T_46_META_WS_P_OWNER: "Proprietar",
  T_46_META_WS_P_PARAMS: "Parametri",
  T_46_META_WS_P_PARENT: "Părinte",
  T_46_META_WS_P_PARENTID: "ID părinte",
  T_46_META_WS_P_PARENTUI: "UI părinte",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "ID widget entitate părinte",
  T_46_META_WS_P_PARENTWIDGETFILEID: "ID fișier widget părinte",
  T_46_META_WS_P_PARTMASKA: "Mască Părți 1",
  T_46_META_WS_P_PASSENGERS: "Pasageri",
  T_46_META_WS_P_PATHID: "ID-ul căii",
  T_46_META_WS_P_PAUSEEVENT: "Eveniment pauză",
  T_46_META_WS_P_PERSONAID: "ID persoană",
  T_46_META_WS_P_PHASEDURATION: "Durată (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Timp Încheiere (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Nivel Fizic",
  T_46_META_WS_P_PINID: "ID Insignă",
  T_46_META_WS_P_PITCH: "Înclinare",
  T_46_META_WS_P_PIVOT: "Pivot",
  T_46_META_WS_P_PLAYER: "Jucător",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Factor de viteză la țintire jucător",
  T_46_META_WS_P_PLAYERLIST: "Lista de jucători",
  T_46_META_WS_P_PLAYERNAME: "Nume jucător",
  T_46_META_WS_P_PLAYERRANK: "Clasament jucător",
  T_46_META_WS_P_PLAYERRANKS: "Rânc jucători",
  T_46_META_WS_P_PLAYERS: "Jucători",
  T_46_META_WS_P_PLAYERSCORETYPES: "Tipuri scor jucători",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Factor de viteză al jucătorului",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Factorul de viteză al jucătorului în timp ce trage",
  T_46_META_WS_P_PLAYERSTATUS: "Stare jucător",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Viteză de tracțiune a jucătorului",
  T_46_META_WS_P_PLAYINGSTATUS: "Starea de redare",
  T_46_META_WS_P_PLAYSPEED: "Viteză redare",
  T_46_META_WS_P_POINTPOSITION: "Poziția punctului",
  T_46_META_WS_P_POINTS: "Puncte",
  T_46_META_WS_P_POSITION: "Poziție",
  T_46_META_WS_P_PREFABID: "ID Prefab",
  T_46_META_WS_P_PRESSEDCOLOR: "Culoare apăsată",
  T_46_META_WS_P_PRESSEDSPRITE: "Sprite apăsat",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Tip sprite apăsat",
  T_46_META_WS_P_PRICE: "Preț",
  T_46_META_WS_P_PRIORITY: "Prioritate",
  T_46_META_WS_P_PROFILEINFO: "Informații profil",
  T_46_META_WS_P_PROGRESS: "Progres [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Iconiță Progres",
  T_46_META_WS_P_PROGRESSICONNAME: "Nume Iconiță Progres",
  T_46_META_WS_P_PROPID: "ID proprietate",
  T_46_META_WS_P_PURCHASELIMIT: "Limită de achiziție",
  T_46_META_WS_P_RADIUS: "Rază",
  T_46_META_WS_P_RANGE: "Rază",
  T_46_META_WS_P_RANK: "Rang",
  T_46_META_WS_P_RATIOSELFFACTOR: "Factor de daune proprii",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Factor de daune coechipieri",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Factor de daune vehicule",
  T_46_META_WS_P_REFRESHTIME: "Timp de reîmprospătare (s)",
  T_46_META_WS_P_RELOADSPEED: "Viteză reîncărcare",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Factor de viteză de reîncărcare",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Număr Rămas de Sărituri",
  T_46_META_WS_P_REMAINQUANTITY: "Cantitate rămasă",
  T_46_META_WS_P_RENDERTYPE: "Tip redare",
  T_46_META_WS_P_REPEATTIMES: "Număr de repetări",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Prioritate înlocuire",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ID jucător declanșator",
  T_46_META_WS_P_REQUESTTYPE: "Lista articolelor solicitate",
  T_46_META_WS_P_RESETPERROUND: "Răspunsul fiecărei runde",
  T_46_META_WS_P_RESETPOSITION: "Poziția Resetării",
  T_46_META_WS_P_RESETTIME: "Timp de Resetare",
  T_46_META_WS_P_RESOURCE: "Resursă",
  T_46_META_WS_P_RESOURCEID: "ID resursă",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Restricționează în panou",
  T_46_META_WS_P_RESULT: "Rezultate",
  T_46_META_WS_P_RESULTTYPE: "Tip rezultat",
  T_46_META_WS_P_REVIVALPOINT: "Punct de revitalizare",
  T_46_META_WS_P_REVIVECD: "Timp de reînvigorare",
  T_46_META_WS_P_RIGHT: "Dreapta",
  T_46_META_WS_P_RIGHTARM: "Brațul drept",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Culoare fundal dreapta",
  T_46_META_WS_P_RIGHTCOLOR: "Culoare Dreapta",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Descriere Echipa Dreapta",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Efect dreapta activ",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Unghi de tragere dreapta",
  T_46_META_WS_P_RIGHTFOOT: "Piciorul drept jos",
  T_46_META_WS_P_RIGHTHAND: "Mâna dreaptă",
  T_46_META_WS_P_RIGHTICON: "Iconiță dreaptă",
  T_46_META_WS_P_RIGHTICONNAME: "Nume iconiță dreapta",
  T_46_META_WS_P_RIGHTLEG: "Piciorul drept",
  T_46_META_WS_P_RIGHTPLAYERS: "Jucători dreapta",
  T_46_META_WS_P_RIGHTSCORE: "Scor dreapta",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Scor final dreapta",
  T_46_META_WS_P_RIGHTSCORETEXT: "Scor dreaptă",
  T_46_META_WS_P_RIGHTTEAM: "Titluri",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Index echipă dreapta",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Număr jucători vii dreapta",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Numărul de steaguri al echipei de dreapta",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Stare Membri Echipa Dreapta",
  T_46_META_WS_P_RIGHTTEAMNAME: "Nume Echipa Dreapta",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Scor Echipa Dreapta",
  T_46_META_WS_P_RIGHTTEXT: "Text dreaptă",
  T_46_META_WS_P_RIMALPHA: "Alfa Margine",
  T_46_META_WS_P_RIMCOLOR: "Culoare Margine",
  T_46_META_WS_P_RIMTEXTURE: "Textură Margine",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Coeficientul de frecare la rulare",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Coeficientul de frecare la rulare în viteză",
  T_46_META_WS_P_ROTATION: "Rotire",
  T_46_META_WS_P_ROTATIONANGLE: "Unghi de rotație",
  T_46_META_WS_P_ROTATIONQ: "Cuarțian de rotație",
  T_46_META_WS_P_ROUNDINCOME: "Venituri rundă",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Numere detalii venit pe rundă",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Titluri detalii venit pe rundă",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Titlu venituri rundă",
  T_46_META_WS_P_ROUNDNUM: "Număr Rundă",
  T_46_META_WS_P_ROUNDNUMKEY: "Cheie Număr Rundă",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Parametri Localizare Număr Rundă",
  T_46_META_WS_P_RUNSPEED: "Viteză de alergare",
  T_46_META_WS_P_RUNSPEEDSCALE: "Scara vitezei de alergare",
  T_46_META_WS_P_RUSHDISTANCE: "Distanță Rush",
  T_46_META_WS_P_RUSHENERGYCOST: "Cost energie pentru rush",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Viteză verticală Rush",
  T_46_META_WS_P_SCALE: "Scalare",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Viteză de creștere a dispersiei",
  T_46_META_WS_P_SCATTERMAX: "Dispersie maximă",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Multiplicator de dispersie în mișcare",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Viteză de recuperare a dispersiei",
  T_46_META_WS_P_SCATTERSPEED: "Viteză de dispersie",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Viteză de dispersie în poziție ghemuit/culcat",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Prag de dispersie",
  T_46_META_WS_P_SCOPETYPE: "Tip telescop",
  T_46_META_WS_P_SCORE: "Scor",
  T_46_META_WS_P_SCORES1: "Lista de puncte 1",
  T_46_META_WS_P_SCORES2: "Lista de puncte 2",
  T_46_META_WS_P_SCORES3: "Lista de puncte 3",
  T_46_META_WS_P_SCORES4: "Lista de puncte 4",
  T_46_META_WS_P_SCORES5: "Lista de puncte 5",
  T_46_META_WS_P_SCORETEXTKEY: "Cheie text scor",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Parametri text scor",
  T_46_META_WS_P_SCROLLCONTINUITY: "Continuitate derulare",
  T_46_META_WS_P_SCROLLDIRECTION: "Direcție derulare",
  T_46_META_WS_P_SCROLLEFFECT: "Efect derulare",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Viteza roții de derulare",
  T_46_META_WS_P_SECONDSCORETITLE: "Titlu Al Doilea Scor",
  T_46_META_WS_P_SECONDSCOREVALUE: "Valoare Al Doilea Scor",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Parametri Valoare Al Doilea Scor",
  T_46_META_WS_P_SELECTEDCOLOR: "Culoare selectată",
  T_46_META_WS_P_SELECTEDINDEX: "Index selectat",
  T_46_META_WS_P_SELECTEDSPRITE: "Sprite selectat",
  T_46_META_WS_P_SELECTEDTYPE: "Tip selectat",
  T_46_META_WS_P_SELF: "Sin",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Factorul de Daune Personale",
  T_46_META_WS_P_SET: "Setul",
  T_46_META_WS_P_SHADERNAME: "Nume shader",
  T_46_META_WS_P_SHADOWCOLOR: "Culoare umbră",
  T_46_META_WS_P_SHADOWOFFSET: "Ofset umbră",
  T_46_META_WS_P_SHADOWSTRENGTH: "Forță umbra",
  T_46_META_WS_P_SHELFS: "Închiderea manuală dezactivată",
  T_46_META_WS_P_SHOES: "Pantofi",
  T_46_META_WS_P_SHOOTANGLEMAX: "Unghiul maxim de tragere",
  T_46_META_WS_P_SHOOTANGLEMIN: "Unghiul minim de tragere",
  T_46_META_WS_P_SHOP: "Magazin",
  T_46_META_WS_P_SHOPITEMS: "Rafturi",
  T_46_META_WS_P_SHOWADDFRIEND: "Afișează adăugare prieten",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Afișare grenadă atac",
  T_46_META_WS_P_SHOWBACKGROUND: "Afișează fundalul",
  T_46_META_WS_P_SHOWCROUCH: "Afișare ghemuit",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Afișați numărul de daune",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Afișare grenadă apărare",
  T_46_META_WS_P_SHOWECCONOMY: "Afișează economia externă",
  T_46_META_WS_P_SHOWECONOMY: "Afișează economia externă",
  T_46_META_WS_P_SHOWFIRE: "Afișare foc",
  T_46_META_WS_P_SHOWFRAME: "Afișare cadru",
  T_46_META_WS_P_SHOWGIFT: "Afișează cadouri",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Afișează efect punct de lovitură",
  T_46_META_WS_P_SHOWJUMP: "Afișare salt",
  T_46_META_WS_P_SHOWLIKE: "Afișează like-uri",
  T_46_META_WS_P_SHOWLOBBY: "Afișează lobby",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Afișează evaluarea hărții",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Afișează detalii meci",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Afișare joystick mișcare",
  T_46_META_WS_P_SHOWNAME: "Afișare poreclă",
  T_46_META_WS_P_SHOWPIN: "Afișare pin",
  T_46_META_WS_P_SHOWPRONE: "Afișare culcat",
  T_46_META_WS_P_SHOWRANK: "Afișare rang",
  T_46_META_WS_P_SHOWREPLAY: "Afișează repornirea",
  T_46_META_WS_P_SHOWREPORT: "Afișează raportul",
  T_46_META_WS_P_SHOWSHARE: "Afișează partajare",
  T_46_META_WS_P_SHOWSPRINT: "Afișare sprint",
  T_46_META_WS_P_SHOWTAG: "Afișare etichetă",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Afișare informații colegi",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Afișare Stare Membri Echipei",
  T_46_META_WS_P_SHOWTEAMSCORE: "Afișare Scor Echipa",
  T_46_META_WS_P_SHOWTIMETYPE: "Afișare Tip Timp",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Afișare Scor Două Echipe",
  T_46_META_WS_P_SHRINKDURATION: "Durată micșorare (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Timp sfârșit micșorare (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Rată de convergență",
  T_46_META_WS_P_SHRINKSTARTTIME: "Timp început micșorare (ms)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Permite asistența la țintire ADS",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Coeficient de atenuare al distanței asistenței la țintire (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Coeficient de impact al priorității distanței asistenței la țintire (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Distanța maximă prioritară pentru asistența la țintire",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Distanța minimă prioritară pentru asistența la țintire",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Permite prioritizarea distanței asistenței la țintire",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Raport de atracție al asistenței la țintire pe ecran (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Raport de amplificare vizuală",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "Mărire câmp vizual (FOV)",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "Sensibilitate la rotație ADS",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "Coeficient corecție daune minime la distanță ADS",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "Timp de mărire ADS (s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "Mărire ADS",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "Timp de recuperare ADS (s)",
  T_46_META_WS_P_SIZE: "Dimensiune",
  T_46_META_WS_P_SIZEDELTA: "Delta dimensiune",
  T_46_META_WS_P_SKELETON: "Schelet",
  T_46_META_WS_P_SKIN: "Piele",
  T_46_META_WS_P_SKINID: "ID-ul skin-ului",
  T_46_META_WS_P_SKINWIDTH: "Grosime Piele",
  T_46_META_WS_P_SKYBOXENV: "Cutie cerului",
  T_46_META_WS_P_SKYBOXRESOURCE: "Resurs de cer",
  T_46_META_WS_P_SLOPELIMIT: "Limită Panta",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Derulare lină la început",
  T_46_META_WS_P_SOFTNESS: "Moliciune",
  T_46_META_WS_P_SORTTYPE: "Tip sortare",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Numărul de spawn per val",
  T_46_META_WS_P_SPAWNPOINT: "Punct de reapariție",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Număr de puncte de apariție",
  T_46_META_WS_P_SPAWNPOSITION: "Poziția de spawn",
  T_46_META_WS_P_SPEED: "Viteză",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Rata de viteză a mișcării ADS",
  T_46_META_WS_P_SPRAYCOLOR: "Culoare pulverizare",
  T_46_META_WS_P_SPRINTENERGYCOST: "Cost energie pentru sprint",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Viteză orizontală Sprint",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Scala de viteză a mișcării în sprint",
  T_46_META_WS_P_SPRITENAME: "Formă sprite",
  T_46_META_WS_P_SPRITERESOURCE: "Resursa sprite",
  T_46_META_WS_P_SRCVAL: "Valoare sursă",
  T_46_META_WS_P_STARTDROPTIME: "Timp început cădere (ms)",
  T_46_META_WS_P_STARTEVENT: "Eveniment început",
  T_46_META_WS_P_STARTPOSITION: "Poziție de start",
  T_46_META_WS_P_STARTRADIUS: "Raza de început",
  T_46_META_WS_P_STARTSPAWNTIME: "Timpul de început al apariției (s)",
  T_46_META_WS_P_STARTTIME: "Timp început",
  T_46_META_WS_P_STARTVALUE: "Valoare inițială",
  T_46_META_WS_P_STATICICONCOLORS: "Culori iconițe statice",
  T_46_META_WS_P_STATICICONS: "Iconițe statice",
  T_46_META_WS_P_STATUS: "Starea mini-turretului",
  T_46_META_WS_P_STEPOFFSET: "Offset Pas",
  T_46_META_WS_P_STOPDURATION: "Durata opririi",
  T_46_META_WS_P_STOPEVENT: "Eveniment oprit",
  T_46_META_WS_P_STORE: "Magazin",
  T_46_META_WS_P_STROPID: "ID strop",
  T_46_META_WS_P_STYLE: "Stil",
  T_46_META_WS_P_SUBTITLE: "Subtitlu",
  T_46_META_WS_P_SUMMULTIPLIER: "Acumulatoare de sumă",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Accelerația la ieșirea din balans",
  T_46_META_WS_P_SWINGINGSPEED: "Viteză de balansare",
  T_46_META_WS_P_TAGS: "Etichete",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ID-ul punctului de control țintă",
  T_46_META_WS_P_TARGETICONCOLORS: "Culori iconițe țintă",
  T_46_META_WS_P_TARGETICONS: "Iconițe țintă",
  T_46_META_WS_P_TARGETID: "ID țintă",
  T_46_META_WS_P_TARGETITEMID: "ID obiect țintă",
  T_46_META_WS_P_TARGETROTATION: "Rotirea țintei",
  T_46_META_WS_P_TARGETSCALE: "Scalarea țintei",
  T_46_META_WS_P_TEAMCOLOR: "Culoarea echipei",
  T_46_META_WS_P_TEAMCOLORS: "Culori echipe",
  T_46_META_WS_P_TEAMINDEXS: "Indexuri echipe",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Factorul de Daune pentru Coechipieri",
  T_46_META_WS_P_TEAMMEMBERNUM: "Numărul membrilor echipei",
  T_46_META_WS_P_TEAMNUM: "Numărul echipei",
  T_46_META_WS_P_TEAMRANK: "Clasament echipă",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Afișare clasament echipă",
  T_46_META_WS_P_TEAMRANKS: "Rânc echipe",
  T_46_META_WS_P_TEAMSCORES: "Scoruri echipe",
  T_46_META_WS_P_TEAMSEQ: "Secvența echipei",
  T_46_META_WS_P_TEMPLATEENTITY: "Entitate șablon",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Puncte de scut temporar",
  T_46_META_WS_P_TERRAINWETNESS: "Umiditate teren",
  T_46_META_WS_P_TEXT: "Text",
  T_46_META_WS_P_TEXTCOLOR: "Culoare text",
  T_46_META_WS_P_TEXTKEY: "Cheie Text",
  T_46_META_WS_P_TEXTKEYPARAMS: "Parametri Cheie Text",
  T_46_META_WS_P_TEXTURERESOURCE: "Resursa texturii",
  T_46_META_WS_P_THEMECOLOR: "Culoare Temă",
  T_46_META_WS_P_THROWABLETYPE: "Tip aruncabil",
  T_46_META_WS_P_THROWINGSPEED: "Viteza de Aruncare",
  T_46_META_WS_P_THROWSPEED: "Viteză de aruncare",
  T_46_META_WS_P_TICKINTERVAL: "Interval de tic",
  T_46_META_WS_P_TIMEREQUIRED: "Timp necesar (ms)",
  T_46_META_WS_P_TIPSTYPE: "Tipul de sfaturi",
  T_46_META_WS_P_TITLE: "Titlu",
  T_46_META_WS_P_TITLELIST: "Titluri",
  T_46_META_WS_P_TITLES: "Scoruri1",
  T_46_META_WS_P_TOP: "Partea de sus",
  T_46_META_WS_P_TOPALPHA: "Alfa de sus",
  T_46_META_WS_P_TOTALHP: "HP total",
  T_46_META_WS_P_TOTALLEVEL: "Nivel total",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Numărul total de runde",
  T_46_META_WS_P_TOWSPEED: "Viteză de tractare",
  T_46_META_WS_P_TRANSITIONSTAGE: "Etapa tranziție",
  T_46_META_WS_P_TRANSITIONTYPE: "Tip tranziție",
  T_46_META_WS_P_TRIGGERPLAYERID: "Monede",
  T_46_META_WS_P_TRIGGERRADIUS: "Domeniul Declanșatorului",
  T_46_META_WS_P_TRIGGERRANGE: "Rază de declanșare",
  T_46_META_WS_P_TRIGGERTIME: "Timp de declanșare",
  T_46_META_WS_P_TURNSPEED: "Viteză de rotație",
  T_46_META_WS_P_TWEENERENABLED: "Echipa stângă",
  T_46_META_WS_P_TWEENSTYLE: "Stil de tranziție",
  T_46_META_WS_P_TYPE: "Tip",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Culoare neselectată",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Sprite neselectat",
  T_46_META_WS_P_UNSELECTEDTYPE: "Tip neselectat",
  T_46_META_WS_P_UP: "Sus",
  T_46_META_WS_P_UPDATETYPE: "Tip Actualizare",
  T_46_META_WS_P_UPENERGYCOST: "Cost energie în sus",
  T_46_META_WS_P_UPSPEED: "Viteză sus",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Folosește Forță de Împingere Personalizată",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Folosește resursă personalizată",
  T_46_META_WS_P_USEDCAPACITY: "Capacitate utilizată",
  T_46_META_WS_P_USEGRAVITY: "Folosește Gravitație",
  T_46_META_WS_P_USEPHYSICALCCT: "Folosește CCT Fizic",
  T_46_META_WS_P_USERUID: "UID-ul utilizatorului",
  T_46_META_WS_P_UVOFFSET: "Ofset UV",
  T_46_META_WS_P_UVSIZE: "Dimensiune UV",
  T_46_META_WS_P_VALUE: "Valoare",
  T_46_META_WS_P_VAULTDISTANCE: "Distanță salt",
  T_46_META_WS_P_VAULTHEIGHT: "Înălțime salt",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Factorul de Daune al Vehiculului",
  T_46_META_WS_P_VEHICLESKINID: "ID aspect vehicul",
  T_46_META_WS_P_VEHICLESKINIDS: "ID-uri Skin pentru Vehicul",
  T_46_META_WS_P_VELOCITY: "Viteză (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Viteză XZ",
  T_46_META_WS_P_VELOCITYY: "Viteză Y",
  T_46_META_WS_P_VERTICALBAR: "Bară verticală",
  T_46_META_WS_P_VERTICALOFFSET: "Ofset vertical",
  T_46_META_WS_P_VEST: "Vesta",
  T_46_META_WS_P_VFXTEXTURETYPE: "Tip textură VFX",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Restricție Unghi de Vizualizare",
  T_46_META_WS_P_VISIBILITYLAYER: "Strat de vizibilitate",
  T_46_META_WS_P_VISIBLE: "Vizibil",
  T_46_META_WS_P_VISIBLEONBACK: "Vizibil pe spate",
  T_46_META_WS_P_VISIBLEPLAYERS: "Jucători vizibili",
  T_46_META_WS_P_VOLUME: "Volum",
  T_46_META_WS_P_WALLETID: "ID portofel",
  T_46_META_WS_P_WANDERRANGE: "Raza de rătăcire",
  T_46_META_WS_P_WAVECOUNT: "Număr de valuri",
  T_46_META_WS_P_WAVEINTERVAL: "Intervalul de val",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Rata de daune a armelor",
  T_46_META_WS_P_WEAPONSKINIDS: "ID-uri Skin de Arma",
  T_46_META_WS_P_WEAPONSUBTYPE: "Subtip de armă",
  T_46_META_WS_P_WEAPONTYPE: "Tip armă",
  T_46_META_WS_P_WIDTH: "Lățime",
  T_46_META_WS_P_WINMVPS: "MVP-uri câștigătoare",
  T_46_META_WS_P_WINTEXT: "Text victorie",
  T_46_META_WS_P_WORDWRAP: "Împachetare cuvinte",
  T_46_META_WS_P_WORLDPOSITION: "Poziție Mondială",
  T_46_META_WS_P_YAW: "Răsucire",
  T_46_META_WS_PATROLALONG: "Patrulează pe",
  T_46_META_WS_PATROLTO: "Patrulează către",
  T_46_META_WS_PAUSE: "Pauză",
  T_46_META_WS_PAUSEEMOTE: "Pauză emote",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Pauză actualizare fixă",
  T_46_META_WS_PHASE: "Fază",
  T_46_META_WS_PLAY: "Joacă",
  T_46_META_WS_PLAYANIMATION: "Redă animație",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Redă clip animație caracter",
  T_46_META_WS_PLAYEMOTE: "Joacă emote",
  T_46_META_WS_PLAYER: "Jucător",
  T_46_META_WS_PORTAL: "Portal",
  T_46_META_WS_POSE: "Poză",
  T_46_META_WS_POSITION: "Poziție",
  T_46_META_WS_PREPOSE: "Poză inițială ",
  T_46_META_WS_PROFANITYFILTER: "Filtru pentru cuvinte obscene",
  T_46_META_WS_PURSUITTARGET: "Țintă de urmărire",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Quaternion la unghi de axă",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Quaternion la unghiuri Euler",
  T_46_META_WS_QUITCHATCHANNEL: "Ieși din canalul de chat",
  T_46_META_WS_QUITFACTION: "Ieși din facțiune",
  T_46_META_WS_QUITGAME: "Ieși din joc",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Ieși din mini-jocul de evadare din închisoare",
  T_46_META_WS_RANDOMFLOAT: "Float aleator",
  T_46_META_WS_RANDOMINT: "Întreg aleator",
  T_46_META_WS_RANK: "Clasament",
  T_46_META_WS_READCSV: "Citește CSV",
  T_46_META_WS_READCSVCELL: "Citește celulă CSV",
  T_46_META_WS_READCSVCELLBYNAME: "Citește celulă CSV după număr de rând și nume coloană",
  T_46_META_WS_READCSVCELLFROMSERVER: "Citește celulă CSV de pe server",
  T_46_META_WS_READCSVCOLUMN: "Citește coloană CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Citește coloană CSV de pe server",
  T_46_META_WS_READCSVFROMSERVER: "Citește CSV de pe server",
  T_46_META_WS_READCSVROW: "Citește rând CSV",
  T_46_META_WS_READCSVROWBYKEY: "Obține rând CSV după cheie",
  T_46_META_WS_READCSVROWFROMSERVER: "Citește rând CSV de pe server",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Citește din depozitul de date acumulate",
  T_46_META_WS_READFROMDATASTORE: "Citește din depozitul de date",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Citește din depozitul de date al tabelului de clasament",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Citește din depozitul de date al tabelului de clasament după rang",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Îndepărtează urmărirea specială AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Îndepărtează aspectul rucsacului",
  T_46_META_WS_REMOVEBUFF: "Elimină buff",
  T_46_META_WS_REMOVECOMPONENT: "Îndepărtează componentă",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Elimină factor proprietate formulă",
  T_46_META_WS_REMOVEOUTFIT: "Îndepărtează ținuta",
  T_46_META_WS_REMOVESCRIPT: "Elimină script",
  T_46_META_WS_REMOVEVEHICLESKIN: "Îndepărtează aspectul vehiculului",
  T_46_META_WS_REMOVEWEAPONSKIN: "Îndepărtează skin-ul pentru armă",
  T_46_META_WS_REPLACE: "Înlocuiește",
  T_46_META_WS_REQUESTMATCHMAKING: "Solicită potrivire",
  T_46_META_WS_RESET: "Resetează",
  T_46_META_WS_RESETBACKPACKSKIN: "Resetează aspectul rucsacului",
  T_46_META_WS_RESETDYEING: "Resetează colorarea",
  T_46_META_WS_RESETJERSEY: "Resetează tricou",
  T_46_META_WS_RESETOUTFIT: "Resetează ținuta",
  T_46_META_WS_RESETVEHICLESKIN: "Resetează aspectul vehiculului",
  T_46_META_WS_RESETWEAPONSKIN: "Resetează skin-ul pentru armă",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Continuare actualizare fixă",
  T_46_META_WS_REVERSE: "Inversează",
  T_46_META_WS_REVIVALSOURCE: "Sursă de revigorare",
  T_46_META_WS_REVIVE: "Revivează",
  T_46_META_WS_ROUND: "Rotunjire",
  T_46_META_WS_ROUNDINDEX: "Indice runde",
  T_46_META_WS_SAMPLEONCURVE: "Eșantionare pe curvă",
  T_46_META_WS_SCENENAME: "Nume scenă",
  T_46_META_WS_SCORE: "Scor",
  T_46_META_WS_SCORER: "Marcator",
  T_46_META_WS_SCORETYPE: "Tip scor",
  T_46_META_WS_SCREENMULTIRAYCAST: "Detectare rază de atingere a ecranului (multiplu)",
  T_46_META_WS_SCREENSINGLERAYCAST: "Detectare rază de atingere a ecranului (simplă)",
  T_46_META_WS_SCREENTOUCHRAY: "Rază de atingere a ecranului",
  T_46_META_WS_SCREENTOWORLDPOINT: "Din ecran în lume",
  T_46_META_WS_SENDEVENT: "Trimite eveniment",
  T_46_META_WS_SETACTIVE: "Setează activ",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Setează starea de mișcare a tuturor jucătorilor",
  T_46_META_WS_SETATTACKABLEENTITY: "Setează entitate atacabilă",
  T_46_META_WS_SETATTACKABLEFACTION: "Setează facțiunea atacabilă",
  T_46_META_WS_SETATTACKABLETEAM: "Setează echipa atacabilă",
  T_46_META_WS_SETBACKPACKSKIN: "Setează aspectul rucsacului",
  T_46_META_WS_SETBEHAVIORSTATUS: "Setează status comportamental",
  T_46_META_WS_SETBLACKBOARDVALUE: "Setează valoarea tabloului negru",
  T_46_META_WS_SETBUNDLE: "Setează bundle",
  T_46_META_WS_SETCAMERAFOCUS: "Setează focalizarea camerei",
  T_46_META_WS_SETCAMERAFOLLOW: "Setează urmărirea camerei",
  T_46_META_WS_SETCHARACTER: "Setează caracter",
  T_46_META_WS_SETCULLINGMASK: "Setează masca de culling",
  T_46_META_WS_SETCULLINGMASKLAYER: "Setează stratul de masca de culling",
  T_46_META_WS_SETDEFAULTUISTATUS: "Setează statusul UI implicit",
  T_46_META_WS_SETDROPSTATUS: "Setează status aruncare",
  T_46_META_WS_SETFALLINGDAMAGE: "Setează daunele de cădere",
  T_46_META_WS_SETFOOTBALLPOSITION: "Setează poziția fotbalului",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Setează proprietate formulă absolut",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Setează proprietate formulă relativ",
  T_46_META_WS_SETFORWARD: "Setează direcția",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Setează pragul global de somn",
  T_46_META_WS_SETINVINCIBILITY: "Setează invincibilitatea",
  T_46_META_WS_SETJERSEY: "Setează tricou",
  T_46_META_WS_SETOUTFIT: "Setează ținută",
  T_46_META_WS_SETPARENT: "Setează părinte",
  T_46_META_WS_SETPARENTCLIENT: "Setează părinte pentru obiect",
  T_46_META_WS_SETPICKUPSTATUS: "Setează status ridicare",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Setează status mesaj rapid jucător",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Setează status voce jucător",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Setează proprietate lin",
  T_46_META_WS_SETSKILLS: "Setează abilități",
  T_46_META_WS_SETSKYBOX: "Setează Skybox",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Setează pragul de somn",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Setează starea obiectului special",
  T_46_META_WS_SETVEHICLESKIN: "Setează aspectul vehiculului",
  T_46_META_WS_SETWEAPONSKIN: "Setează skin pentru armă",
  T_46_META_WS_SETWIDGETPARENT: "Setează părinte widget",
  T_46_META_WS_SHOPITEM: "Obiect magazin",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Afișează grup aspect",
  T_46_META_WS_SHUFFLE: "Amestecă",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Detectare cu un singur raycast",
  T_46_META_WS_SKILL: "Abilitate",
  T_46_META_WS_SLEEP: "Dormi",
  T_46_META_WS_SLERPQUATERNION: "Interpolare Quaternion",
  T_46_META_WS_SPAWNABLES: "Obiecte generabile",
  T_46_META_WS_SPAWNEDITEM: "Obiect generat",
  T_46_META_WS_SPAWNNEXTWAVE: "Generare următoarea undă",
  T_46_META_WS_SPHERECAST: "Detectare cu sferă",
  T_46_META_WS_SPHEREOVERLAP: "Verificare suprapunere sferă",
  T_46_META_WS_SPLIT: "Împarte",
  T_46_META_WS_SQRT: "Rădăcină pătrată",
  T_46_META_WS_STARTPARACHUTE: "Începe parașutismul",
  T_46_META_WS_STARTPOSITION: "Poziție de început",
  T_46_META_WS_STATENAME: "Nume stare",
  T_46_META_WS_STATUS: "Stare",
  T_46_META_WS_STRINGTOFLOAT: "String la Float",
  T_46_META_WS_STRINGTOINT: "String la Int",
  T_46_META_WS_STRIP: "Stripare",
  T_46_META_WS_SUB: "Sub",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Schimbă observatorul proxy AOI",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Schimbă grup aspect",
  T_46_META_WS_SWITCHAREA: "Schimbă zonă",
  T_46_META_WS_SWITCHCAMERA: "Schimbă camera",
  T_46_META_WS_SWITCHPHASE: "Schimbă faza",
  T_46_META_WS_SWITCHSCENE: "Schimbă scenă",
  T_46_META_WS_SWITCHWEAPON: "Schimbare armă",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Țintă",
  T_46_META_WS_TEAM: "Echipă",
  T_46_META_WS_TELEPORT: "Teleportează",
  T_46_META_WS_TELEPORTCCT: "Teleportează CCT",
  T_46_META_WS_TEXT: "Text",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Timestamp la șir de localizare",
  T_46_META_WS_TIRE: "Anvelopă",
  T_46_META_WS_TOLOWER: "La minuscule",
  T_46_META_WS_TOSTRING: "La șir",
  T_46_META_WS_TOUPPER: "La majuscule",
  T_46_META_WS_TRANSFERMONEY: "Transferă bani",
  T_46_META_WS_TRIGGER: "Declanșator",
  T_46_META_WS_TYPEIS: "Tip este",
  T_46_META_WS_UNLOADSCENE: "Descărcare scenă",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Actualizează misiunea de evadare din închisoare",
  T_46_META_WS_UPLOADGAMERESULT: "Încarcă rezultatul jocului",
  T_46_META_WS_VALUE: "Daune",
  T_46_META_WS_VECTOR2ANGLE: "Vector2Unghi",
  T_46_META_WS_VECTOR2DISTANCE: "Vector2Distanță",
  T_46_META_WS_VECTOR2DOT: "Vector2Punct",
  T_46_META_WS_VECTOR2MAGNITUDE: "Vector2Magnitudine",
  T_46_META_WS_VECTOR2NORMALIZE: "Vector2Normalizează",
  T_46_META_WS_VECTOR2REFLECT: "Vector2Reflect",
  T_46_META_WS_VECTOR2TOVECTOR3: "Vector2 la Vector3",
  T_46_META_WS_VECTOR3REFLECT: "Vector3Reflect",
  T_46_META_WS_VECTOR3TOVECTOR2: "Vector3 la Vector2",
  T_46_META_WS_VEHICLE: "Vehicul",
  T_46_META_WS_VELOCITY: "Viteză",
  T_46_META_WS_WAITFORMILESECOND: "Așteaptă milisecunde",
  T_46_META_WS_WAITFORNEXTFRAME: "Așteaptă următorul cadru",
  T_46_META_WS_WAKEUP: "Trezește-te",
  T_46_META_WS_WAVES: "Valuri",
  T_46_META_WS_WEAPON: "Armă",
  T_46_META_WS_WORLDTOSCREENPOINT: "Din lume în ecran",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Scrie în depozitul de date acumulate",
  T_46_META_WS_WRITETODATASTORE: "Scrie în depozitul de date",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Scrie în depozitul de date al tabelului de clasament",
  T_48_META_API_1_D: "Obține toți jucătorii din jocul curent și returnează o listă de jucători.",
  T_48_META_API_1_R_D: "Lista jucătorilor",
  T_48_META_API_10_D: "Obținerea obiectelor scenei",
  T_48_META_API_10_P0_D: "Ce tipuri de obiecte ale scenei trebuie filtrate",
  T_48_META_API_10_R_D: "Lista obiectelor scenei",
  T_48_META_API_100_D: "Încărcarea scenariilor fără descărcarea automată a scenariilor deja încărcate",
  T_48_META_API_100_P0_D: "ID-ul scenei care urmează să fie încărcată",
  T_48_META_API_10000_D: "Returnează entitatea la care este legat scriptul curent",
  T_48_META_API_10000_R_D: "Entitatea la care este legat scriptul curent",
  T_48_META_API_10001_D: "Utilizați ID-ul entității pentru a găsi entitatea corespunzătoare, acest API este destinat exclusiv editorilor, utilizarea de către utilizator a acestui API nu garantează compatibilitatea sa, cum ar fi eliminarea sau ajustarea",
  T_48_META_API_10001_P0_D: "ID-ul entității țintă",
  T_48_META_API_10001_R_D: "lucru care are o existență materială (spre deosebire de o existență conceptuală, virtuală sau online)",
  T_48_META_API_10002_D: "Obțineți entitatea globală pentru joc",
  T_48_META_API_10002_R_D: "entitate globală",
  T_48_META_API_10003_D: "Teleportează jucătorii la anumite coordonate (depreciat, utilizați Teleport)",
  T_48_META_API_10003_P0_D: "Jucători teleportați",
  T_48_META_API_10003_P1_D: "Coordonate ale punctului transportat",
  T_48_META_API_10004_D: "Obține poziția în apropierea coechipierilor, va ocoli poziția jucătorilor care nu pot sta în picioare (depreciat, utilizați GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "jucător țintă",
  T_48_META_API_10004_R_D: "Coordonate în apropierea coechipierilor",
  T_48_META_API_10005_D: "Jucători care aparțin entității achizitoare",
  T_48_META_API_10005_P0_D: "Entitate țintă, entitatea se va sincroniza numai cu jucătorul căruia îi aparține",
  T_48_META_API_10005_R_D: "Jucătorii care aparțin entității țintă",
  T_48_META_API_10006_D: "Faceți jucătorul invincibil",
  T_48_META_API_10006_P0_D: "jucător țintă",
  T_48_META_API_10006_P1_D: "Durata efectului de invulnerabilitate, în secunde",
  T_48_META_API_10007_D: "Clonează entitatea selectată și toate proprietățile acesteia în poziția inițială",
  T_48_META_API_10007_P0_D: "Entități create",
  T_48_META_API_10007_P1_D: "entitatea care urmează să fie clonată",
  T_48_META_API_10008_D: "Acordă daune jucătorului, dacă nu este selectată nicio sursă de daune, ținta primește daune de la sistem",
  T_48_META_API_10008_P0_D: "Entități de jocuri de noroc prejudiciate",
  T_48_META_API_10008_P1_D: "Entități de joc care provoacă daune",
  T_48_META_API_10008_P2_D: "Tipul de daună",
  T_48_META_API_10008_P3_D: "cantitatea de daune",
  T_48_META_API_10009_D: "Resuscitarea unui jucător desemnat",
  T_48_META_API_10009_P0_D: "Jucători resuscitați",
  T_48_META_API_1001_D: "Dacă condiția este îndeplinită, se execută nodul de la IF. Dacă condiția nu este îndeplinită, se execută nodul sub ELSE dacă există un ELSE, altfel se încheie instrucțiunea IF.",
  T_48_META_API_1001_P0_D: "Lista de condiții trebuie să fie compatibilă cu numărul de liste de subproceduri (liste de ramificații logice).",
  T_48_META_API_10010_D: "Creează un element sau o listă de elemente la o locație specificată.",
  T_48_META_API_10010_P0_D: "Locația de creare a articolului",
  T_48_META_API_10010_P1_D: "Articole sau liste de articole create",
  T_48_META_API_10010_P2_D: "Numărul de articole care urmează să fie create. Atunci când creați o listă de articole, trebuie să completați o listă cu numărul de articole corespunzător ordinii listei de articole.",
  T_48_META_API_10011_D: "Entități AI care patrulează către puncte țintă",
  T_48_META_API_10011_P0_D: "Entități AI direcționate",
  T_48_META_API_10011_P1_D: "Punct țintă în mișcare",
  T_48_META_API_10011_P2_D: "Dacă să se întoarcă la punctul de plecare",
  T_48_META_API_10011_P3_D: "Dacă țintele ostile sunt detectate și atacate în timpul patrulării",
  T_48_META_API_10012_D: "Patrularea entităților AI în ordinea listei de coordonate",
  T_48_META_API_10012_P0_D: "Entități AI direcționate",
  T_48_META_API_10012_P1_D: "Lista punctelor de coordonate mobile",
  T_48_META_API_10012_P2_D: "Tipul de patrulă, cu posibilitatea de a efectua o singură tură, o tură dus-întors sau o tură ciclică",
  T_48_META_API_10012_P3_D: "Dacă țintele ostile sunt detectate și atacate în timpul patrulării",
  T_48_META_API_10013_D: "Generatorul actualizează imediat următorul val de entități unitare",
  T_48_META_API_10013_P0_D: "entitate generatoare",
  T_48_META_API_10014_D: "Adăugați un factor pentru calcularea atributelor calculabile, care vor fi calculate printr-o formulă compusă din factori pentru a produce rezultatul final.",
  T_48_META_API_10014_P0_D: "entitate țintă",
  T_48_META_API_10014_P1_D: "Tipuri de atribute calculabile",
  T_48_META_API_10014_P2_D: "Tipul factorului de calcul",
  T_48_META_API_10014_P3_D: "Calcularea valorilor factorilor",
  T_48_META_API_10015_D: "Ștergeți factorul de calcul pentru atributele calculabile",
  T_48_META_API_10015_P0_D: "entitate țintă",
  T_48_META_API_10015_P1_D: "Tipuri de atribute calculabile",
  T_48_META_API_10016_D: "Eliminarea tuturor factorilor de calcul pentru toate atributele calculabile ale entității țintă",
  T_48_META_API_10016_P0_D: "entitate țintă",
  T_48_META_API_10017_D: "Modificarea atributelor",
  T_48_META_API_10017_P0_D: "entitate țintă",
  T_48_META_API_10017_P1_D: "Tip atribut",
  T_48_META_API_10017_P2_D: "Metoda de modificare",
  T_48_META_API_10017_P3_D: "să fie de serviciu",
  T_48_META_API_10018_D: "Stabilirea valorii unei proprietăți calculabile",
  T_48_META_API_10018_P0_D: "entitate țintă",
  T_48_META_API_10018_P1_D: "Tip atribut",
  T_48_META_API_10018_P2_D: "să fie de serviciu",
  T_48_META_API_10019_D: "Eliminarea modificărilor individuale ale proprietăților calculabile",
  T_48_META_API_10019_P0_D: "entitate țintă",
  T_48_META_API_10019_P1_D: "Tip atribut",
  T_48_META_API_1002_D: "Parametrul i pornește de la valoarea minimă și, de fiecare dată când este rulat nodul de mai jos, i crește valoarea pasului până când i este mai mare sau egal cu valoarea maximă.",
  T_48_META_API_1002_P0_D: "Numele indicelui ciclic, care poate fi utilizat pentru a obține valoarea indicelui ciclic pe o variabilă locală.",
  T_48_META_API_1002_P1_D: "Valoarea inițială ciclică",
  T_48_META_API_1002_P2_D: "valoarea de sfârșit de ciclu",
  T_48_META_API_1002_P3_D: "Dimensiunea pasului buclei, atunci când valoarea inițială este mai mică decât valoarea finală, dimensiunea pasului trebuie să fie mai mare decât 0; atunci când valoarea inițială este mai mare decât valoarea finală, dimensiunea pasului trebuie să fie mai m",
  T_48_META_API_10020_D: "Obține toate entitățile din joc care îndeplinesc criteriile de filtrare",
  T_48_META_API_10020_P0_D: "Rezultatul filtrului trebuie să conțină tipul introdus în acest parametru",
  T_48_META_API_10020_P1_D: "Rezultatul filtrului nu trebuie să conțină tipul introdus în acest parametru",
  T_48_META_API_10020_P2_D: "Rezultatele filtrului conțin cel puțin unul dintre tipurile introduse în acest parametru",
  T_48_META_API_10020_R_D: "Filtrați lista entităților rezultate",
  T_48_META_API_10021_D: "Adăugând o viteză mingii de fotbal, viteza se va modifica prin accelerație în aceeași direcție",
  T_48_META_API_10021_P0_D: "Gol Fotbal",
  T_48_META_API_10021_P1_D: "Adăugat viteza spațiului 3D",
  T_48_META_API_10022_D: "Distrugerea entităților desemnate",
  T_48_META_API_10022_P0_D: "Entități țintă care urmează să fie distruse",
  T_48_META_API_10023_D: "Adăugarea de etichete entităților",
  T_48_META_API_10023_P0_D: "entitate țintă",
  T_48_META_API_10023_P1_D: "Etichete personalizate",
  T_48_META_API_10024_D: "Eliminarea etichetelor pentru entități",
  T_48_META_API_10024_P0_D: "entitate țintă",
  T_48_META_API_10024_P1_D: "Etichete personalizate",
  T_48_META_API_10025_D: "Determină dacă entitatea țintă conține eticheta specificată",
  T_48_META_API_10025_P0_D: "entitate țintă",
  T_48_META_API_10025_P1_D: "Etichete personalizate",
  T_48_META_API_10025_R_D: "Dacă se include sau nu eticheta specificată",
  T_48_META_API_10026_D: "Setarea poziției mingii de fotbal",
  T_48_META_API_10026_P0_D: "entitate fotbalistică",
  T_48_META_API_10026_P1_D: "plasare",
  T_48_META_API_10026_P2_D: "Menținerea vitezei",
  T_48_META_API_10027_D: "Obține entitatea camerei utilizată în prezent de jucătorul țintă",
  T_48_META_API_10027_P0_D: "jucător țintă",
  T_48_META_API_10027_R_D: "Entitatea camerei utilizată în prezent",
  T_48_META_API_10028_D: "Comutarea camerei jucătorului țintă la camera țintă, funcția",
  T_48_META_API_10028_P0_D: "jucător țintă",
  T_48_META_API_10028_P1_D: "cameră țintă",
  T_48_META_API_10028_P2_D: "Metoda de comutare, puteți alege să păstrați logica originală sau progresivă",
  T_48_META_API_10028_P3_D: "Timpul de comutare este timpul de comutare a camerelor în modul progresiv",
  T_48_META_API_10029_D: "Creați o cameră",
  T_48_META_API_10029_P0_D: "Tipul de cameră creat",
  T_48_META_API_10029_P1_D: "Entitate cameră creată",
  T_48_META_API_1003_D: "Implementați o traversare a unui container de date pentru a ajunge la fiecare subelement, conținând subproceduri, corpul buclei este subprocedura",
  T_48_META_API_1003_P0_D: "Iterați peste numele elementului copil, care poate fi utilizat pentru a ajunge la valoarea elementului copil pe variabila locală",
  T_48_META_API_1003_P1_D: "Numele indicelui ciclic, care poate fi utilizat pentru a obține valoarea indicelui ciclic pe o variabilă locală.",
  T_48_META_API_1003_P2_D: "Containerul de date care urmează să fie traversat, în prezent sunt acceptate următoarele tipuri: tip array",
  T_48_META_API_10030_D: "Ucideți entitățile combatabile",
  T_48_META_API_10030_P0_D: "Entitatea țintă, care trebuie să fie pregătită de luptă",
  T_48_META_API_10031_D: "Stabilește starea activă a entității țintă și a nodurilor copiilor acesteia; disponibilitatea, vizibilitatea, coliziunile etc. sunt dezactivate pentru obiectele inactive",
  T_48_META_API_10031_P0_D: "entitate țintă",
  T_48_META_API_10031_P1_D: "Activ sau inactiv",
  T_48_META_API_10032_D: "Setați poziția entității cameră pentru a urmări întotdeauna entitatea țintă",
  T_48_META_API_10032_P0_D: "entitate cameră țintă",
  T_48_META_API_10032_P1_D: "Entitate țintă de urmat",
  T_48_META_API_10032_P2_D: "Decalaj față de coordonatele entității țintă",
  T_48_META_API_10032_P3_D: "Sistem de coordonate pentru decalaje",
  T_48_META_API_10033_D: "Setați entitatea camerei să fie întotdeauna orientată spre entitatea țintă",
  T_48_META_API_10033_P0_D: "entitate cameră țintă",
  T_48_META_API_10033_P1_D: "entitate țintă",
  T_48_META_API_10033_P2_D: "Deplasarea punctului de privire față de coordonatele țintă",
  T_48_META_API_10033_P3_D: "Sistem de coordonate pentru decalaje",
  T_48_META_API_10034_D: "Creați Tween",
  T_48_META_API_10034_P0_D: "entitate țintă",
  T_48_META_API_10034_P1_D: "ID proprietate",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Stil",
  T_48_META_API_10034_P5_D: "Curbă",
  T_48_META_API_10034_P6_D: "Durată",
  T_48_META_API_10034_P7_D: "între entități",
  T_48_META_API_10035_D: "Setarea nodului părinte necesită ca atât părintele, cât și copilul să aibă componenta Transform",
  T_48_META_API_10035_P0_D: "nod părinte",
  T_48_META_API_10035_P1_D: "nod copil",
  T_48_META_API_10035_P2_D: "Dacă se păstrează poziția curentă în lume, rotația și scalarea nodurilor copil, acest element nu este valabil atunci când se setează UI.",
  T_48_META_API_10036_D: "NewCurve (depreciat, vă rugăm să utilizați CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "Puncte de control",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Încearcă să redea entitatea țintă, care trebuie să aibă o componentă redabilă",
  T_48_META_API_10037_P0_D: "Entitate jucabilă țintă",
  T_48_META_API_10037_P1_D: `Dacă să redați 
true: redați 
false: continuați redarea`,
  T_48_META_API_10038_D: "Pauză entități redabile",
  T_48_META_API_10038_P0_D: "Entitate jucabilă țintă",
  T_48_META_API_10039_D: "Creează o mișcare balistică care dă entității țintă viteza inițială și accelerația cu direcția",
  T_48_META_API_10039_P0_D: "entitate țintă",
  T_48_META_API_10039_P1_D: "viteza inițială",
  T_48_META_API_10039_P2_D: "accelerarea mișcării",
  T_48_META_API_10039_P3_D: "Distanța maximă de deplasare",
  T_48_META_API_10039_P4_D: "Entități de mișcare balistică create",
  T_48_META_API_10039_P5_D: "Dacă redarea începe automat după creare",
  T_48_META_API_1004_D: "Întrerupe procesul buclei curente și iese din buclă",
  T_48_META_API_10040_D: "Creează o mișcare de urmărire a poziției în care entitatea țintă urmărește obiectul specificat.",
  T_48_META_API_10040_P0_D: "entitate țintă",
  T_48_META_API_10040_P1_D: "Entități obiect care urmăresc mișcarea",
  T_48_META_API_10040_P2_D: "Distanța urmează decalajul coordonatelor țintei",
  T_48_META_API_10040_P3_D: "Sistemul de coordonate utilizat",
  T_48_META_API_10040_P4_D: "Entitate Follow Motion creată",
  T_48_META_API_10040_P5_D: "Dacă redarea începe automat după creare",
  T_48_META_API_10041_D: "Creează o mișcare de urmărire a privirii în care entitatea țintă rămâne orientată spre obiectul specificat.",
  T_48_META_API_10041_P0_D: "entitate țintă",
  T_48_META_API_10041_P1_D: "entitate considerată",
  T_48_META_API_10041_P2_D: "Deplasarea punctului de privire față de entitatea obiect",
  T_48_META_API_10041_P3_D: "Sistemul de coordonate utilizat",
  T_48_META_API_10041_P4_D: "Entități de mișcare create care urmăresc privirea",
  T_48_META_API_10041_P5_D: "Dacă redarea începe automat după creare",
  T_48_META_API_10042_D: "abandonate",
  T_48_META_API_10042_P0_D: "entitate jucător",
  T_48_META_API_10042_P1_D: "rezultatele unui concurs",
  T_48_META_API_10042_P2_D: "abandonate",
  T_48_META_API_10042_P3_D: "abandonate",
  T_48_META_API_10042_P4_D: "abandonate",
  T_48_META_API_10043_D: "Smoothing stabilește proprietățile entității țintă, proprietățile se schimbă imediat, dar clientul redă o performanță de tranziție lină",
  T_48_META_API_10043_P0_D: "entitate țintă",
  T_48_META_API_10043_P1_D: "Un atribut al entității țintă",
  T_48_META_API_10043_P2_D: "Valoarea țintă, care trebuie să corespundă tipului solicitat atunci când a fost definită proprietatea",
  T_48_META_API_10044_D: "Efectuează detectarea unei raze și returnează prima entitate lovită în direcția razei, entitatea lovită trebuie să aibă o componentă de coliziune",
  T_48_META_API_10044_P0_D: "Coordonatele poziției de pornire",
  T_48_META_API_10044_P1_D: "Direcția de detectare a radiațiilor",
  T_48_META_API_10044_P2_D: "Distanța de detectare a radiațiilor, sunt acceptate numai valorile pozitive",
  T_48_META_API_10044_P3_D: "Masca stratului de detectare a razelor, numai straturile completate vor participa la scanare, dacă se lasă gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_10044_P4_D: "Este posibilă scanarea pentru declanșatori",
  T_48_META_API_10044_P5_D: "entitate lovită",
  T_48_META_API_10044_P6_D: "coordonatele punctului de impact",
  T_48_META_API_10044_P7_D: "Distanța punctului de impact de la punctul de plecare",
  T_48_META_API_10044_P8_D: "a lovit suprafața normală",
  T_48_META_API_10045_D: "Efectuează detectarea unei singure raze, returnând toate entitățile lovite în direcția razei, de la aproape la departe",
  T_48_META_API_10045_P0_D: "Coordonatele poziției de pornire",
  T_48_META_API_10045_P1_D: "Direcția de detectare a radiațiilor",
  T_48_META_API_10045_P2_D: "Distanța de detectare a radiațiilor, sunt acceptate numai valorile pozitive",
  T_48_META_API_10045_P3_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_10045_P4_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_10045_P5_D: "Lista entităților afectate",
  T_48_META_API_10045_P6_D: "Lista punctelor de lovire",
  T_48_META_API_10045_P7_D: "Lista distanțelor punctelor de impact de la punctele de plecare",
  T_48_META_API_10045_P8_D: "a lovit suprafața normală",
  T_48_META_API_10046_D: "Crearea de corpuri solide pentru șabloane utilizând corpuri prefabricate",
  T_48_META_API_10046_P0_D: "Entități create",
  T_48_META_API_10046_P1_D: "Corp prefabricat ID",
  T_48_META_API_10047_D: "decolora",
  T_48_META_API_10047_P0_D: "Setarea normalelor obiectelor",
  T_48_META_API_10047_P1_D: "Setarea punctului de colorare",
  T_48_META_API_10047_P2_D: "culoare",
  T_48_META_API_10048_D: "Starea culorii",
  T_48_META_API_10048_P0_D: "Setarea punctului de colorare",
  T_48_META_API_10048_P1_D: "Stabilirea direcției",
  T_48_META_API_10048_P2_D: "Setarea distanței",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "Statistici de colorat",
  T_48_META_API_10049_P0_D: "culoare",
  T_48_META_API_10049_R_D: "Număr de culori",
  T_48_META_API_1005_D: "Săriți peste restul corpului buclei și treceți direct la bucla următoare.",
  T_48_META_API_10050_D: "Colorarea gamei plate",
  T_48_META_API_10050_P0_D: "Setarea normalelor obiectelor",
  T_48_META_API_10050_P1_D: "Setarea punctului de colorare",
  T_48_META_API_10050_P2_D: "Setarea intervalului de colorare",
  T_48_META_API_10050_P3_D: "culoare",
  T_48_META_API_10050_P4_D: "Număr de culori",
  T_48_META_API_10051_D: "pată regională",
  T_48_META_API_10051_P0_D: "Setarea normalelor obiectelor",
  T_48_META_API_10051_P1_D: "Setarea punctului de colorare",
  T_48_META_API_10051_P2_D: "Setarea intervalului de colorare",
  T_48_META_API_10051_P3_D: "culoare",
  T_48_META_API_10051_P4_D: "Zona de colorare fixă",
  T_48_META_API_10051_P5_D: "coeficient aleatoriu (mate.)",
  T_48_META_API_10051_P6_D: "coeficient de atenuare aleatorie",
  T_48_META_API_10051_P7_D: "Număr de culori",
  T_48_META_API_10052_D: "Obține toți copiii entității părinte țintă",
  T_48_META_API_10052_P0_D: "entitate-mamă",
  T_48_META_API_10052_R_D: "lista nodurilor copil",
  T_48_META_API_10053_D: "Obține nodul copil specificat al entității părinte țintă pe baza indicelui",
  T_48_META_API_10053_P0_D: "entitate-mamă",
  T_48_META_API_10053_P1_D: "Indice subnod",
  T_48_META_API_10053_R_D: "entitate copil",
  T_48_META_API_10054_D: "Obține părintele entității copil țintă",
  T_48_META_API_10054_P0_D: "entitate copil",
  T_48_META_API_10054_R_D: "entitate-mamă",
  T_48_META_API_10055_D: "Șterge toate nodurile copil de sub entitatea nodului părinte specificată; nodurile trebuie să aibă componenta Transform",
  T_48_META_API_10055_P0_D: "entitate-mamă",
  T_48_META_API_10056_D: "Teleportează ținta în locația specificată",
  T_48_META_API_10056_P0_D: "unitate de transport (de exemplu, militară)",
  T_48_META_API_10056_P1_D: "coordonatele punctului de transmisie",
  T_48_META_API_10056_P2_D: "orientarea unității post-transfer",
  T_48_META_API_10057_D: "Obțineți locația unui coechipier aleatoriu din apropiere și reveniți la propriile coordonate din apropiere atunci când nu aveți un coechipier, ceea ce va evita locația jucătorilor care nu se pot ridica în picioare",
  T_48_META_API_10057_P0_D: "jucător țintă",
  T_48_META_API_10057_R_D: "Coordonate în apropierea coechipierilor jucătorului țintă",
  T_48_META_API_10058_D: "Stare de colorare clară",
  T_48_META_API_10059_D: "Redă efectul sonor specificat și, dacă sunt mai multe atribute de setat, setează atributele entității în continuare prin intermediul entității",
  T_48_META_API_10059_P0_D: "În cod este numele parametrului formal utilizat pentru a reprezenta entitatea care creează efectul sonor, iar valoarea variabilei locale corespunzătoare este entitatea care creează efectul sonor",
  T_48_META_API_10059_P1_D: "Entitatea jucătorului căreia îi aparține, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_10059_P2_D: "Tipuri de sunet, tipurile de efecte sonore din care jucătorul poate alege",
  T_48_META_API_1006_D: "Încheiați procesul de execuție curent, reveniți direct la locația de apel, puteți transporta datele împreună cu revenirea",
  T_48_META_API_1006_P0_D: "Data la care doriți să vă întoarceți la locul de apel",
  T_48_META_API_10060_D: "Scoate jucătorul țintă din joc",
  T_48_META_API_10060_P0_D: "jucător țintă",
  T_48_META_API_10060_P1_D: "Dacă se afișează informații privind decontarea",
  T_48_META_API_10061_D: "Jucătorul țintă solicită să fie asociat cu o anumită hartă",
  T_48_META_API_10061_P0_D: "jucător țintă",
  T_48_META_API_10061_P1_D: "codul câmpului de luptă",
  T_48_META_API_10061_P2_D: "Dacă o fereastră pop-up solicită sau nu reintrarea în jocul original atunci când se anulează un meci.",
  T_48_META_API_10062_D: "Întreruperea entității sonore în redare",
  T_48_META_API_10062_P0_D: "Entități sonore care trebuie suspendate",
  T_48_META_API_10063_D: "Redarea continuă a efectelor sonore, opțional de la început",
  T_48_META_API_10063_P0_D: "Entități sonore care trebuie să continue redarea după ce au fost puse în pauză",
  T_48_META_API_10063_P1_D: "Dacă să începeți de la zero",
  T_48_META_API_10064_D: "Creați o picătură, picătura are trei faze: 1. gata, 2. cădere, 3. aterizare, numai în starea 1 se pot modifica proprietățile picăturii",
  T_48_META_API_10064_P0_D: "Entități Drop Box create",
  T_48_META_API_1007_D: "Implementați o buclă care continuă să se execute în funcție de faptul dacă condiția este adevărată sau nu, până când condiția este falsă și bucla se încheie.",
  T_48_META_API_1007_P0_D: "Când condiția este adevărată, bucla continuă, iar când condiția este falsă, bucla se încheie.",
  T_48_META_API_1008_D: "Așteptați până la începutul următorului cadru logic Pe server, activați modul de rată scăzută a cadrelor, va aștepta mai mult Pe client, timpul de așteptare este afectat de performanța dispozitivului și de complexitatea logicii cadrului curent Funcțiile c",
  T_48_META_API_1009_D: "Așteaptă o anumită perioadă de timp. Funcțiile care utilizează acest API trebuie să fie declarate asincrone.",
  T_48_META_API_1009_P0_D: "Timp de așteptare în milisecunde",
  T_48_META_API_101_D: "Dezinstalarea unei scene specificate",
  T_48_META_API_101_P0_D: "ID-ul scenei care urmează să fie dezinstalată",
  T_48_META_API_1010: "Event Callback",
  T_48_META_API_1010_D: "Acțiuni declanșate atunci când are loc un eveniment",
  T_48_META_API_1010_P0: "Event Parameter Names",
  T_48_META_API_1010_P0_D: "Numele parametrului formal al parametrului evenimentului, prin care se poate obține valoarea parametrului real pe variabila locală",
  T_48_META_API_1011: "Code Block",
  T_48_META_API_1011_D: "Un bloc de cod pentru a găzdui o combinație de API-uri",
  T_48_META_API_1011_P0: "Parameter Names",
  T_48_META_API_1011_P0_D: "Nume formale ale parametrilor atunci când blocul de cod este o funcție personalizată",
  T_48_META_API_1012: "Find and Invoke Custom API with Serial",
  T_48_META_API_1012_D: "apelează funcții personalizate în mod serial, iar dacă există o așteptare în funcția personalizată, locația apelului așteaptă și ea",
  T_48_META_API_1012_P0_D: "Entitatea în care se află funcția personalizată",
  T_48_META_API_1012_P1: "Graph ID",
  T_48_META_API_1012_P1_D: "Script ID al scriptului în care se află funcția personalizată",
  T_48_META_API_1012_P2: "Function ID",
  T_48_META_API_1012_P2_D: "ID-ul funcției apelului țintă",
  T_48_META_API_1012_P3_D: "Lista parametrilor reali transferați funcției personalizate",
  T_48_META_API_1013: "Find and Invoke Custom API with Parallel",
  T_48_META_API_1013_D: "apelează funcții personalizate în mod paralel, revenind imediat la poziția de apel pentru a continua linia, indiferent dacă există sau nu o așteptare în funcția personalizată",
  T_48_META_API_1013_P0_D: "Entitatea în care se află funcția personalizată",
  T_48_META_API_1013_P1: "Graph ID",
  T_48_META_API_1013_P1_D: "Script ID al scriptului în care se află funcția personalizată",
  T_48_META_API_1013_P2: "Function ID",
  T_48_META_API_1013_P2_D: "ID-ul funcției apelului țintă",
  T_48_META_API_1013_P3_D: "Lista parametrilor reali transferați funcției personalizate",
  T_48_META_API_1014: "Find and Invoke Self Custom API with Serial",
  T_48_META_API_1014_D: "Apelează o funcție personalizată în scriptul curent în mod serial, iar dacă există o așteptare în funcția personalizată, locația de apelare așteaptă de asemenea",
  T_48_META_API_1014_P0: "Function ID",
  T_48_META_API_1014_P0_D: "ID-ul funcției apelului țintă",
  T_48_META_API_1014_P1_D: "Lista parametrilor reali transferați funcției personalizate",
  T_48_META_API_1015: "Find and Invoke Self Custom API with Parallel",
  T_48_META_API_1015_D: "apelează funcții personalizate în mod paralel, revenind imediat la poziția de apel pentru a continua linia, indiferent dacă există sau nu o așteptare în funcția personalizată",
  T_48_META_API_1015_P0: "Set Local Variable by Index",
  T_48_META_API_1015_P0_D: "ID-ul funcției apelului țintă",
  T_48_META_API_1015_P1_D: "Lista parametrilor reali transferați funcției personalizate",
  T_48_META_API_1016_D: "Obțineți tipul de țintă atunci când apelați acest API",
  T_48_META_API_1016_P0_D: "țintă interogată",
  T_48_META_API_1016_R_D: "Tip variabil",
  T_48_META_API_1017_D: "Determină dacă variabila țintă este de tipul specificat",
  T_48_META_API_1017_P0_D: "țintă interogată",
  T_48_META_API_1017_P1_D: "Tip de comparație",
  T_48_META_API_1017_R_D: "coerență",
  T_48_META_API_1018_D: "Determină dacă variabila țintă este o subclasă a unui anumit tip, valoarea returnată este o valoare booleană",
  T_48_META_API_1018_P0_D: "Variabila țintă care este interogată",
  T_48_META_API_1018_P1_D: "Tip de comparație",
  T_48_META_API_1018_R_D: "Dacă este sau nu o subclasă",
  T_48_META_API_1019_D: "Determină entitatea țintă să declanșeze evenimentul personalizat specificat",
  T_48_META_API_1019_P0_D: "ID-uri de eveniment personalizate trimise",
  T_48_META_API_1019_P1_D: "entitate țintă",
  T_48_META_API_1019_P2_D: "lista parametrilor",
  T_48_META_API_102_D: "Comutarea la o anumită scenă descarcă celelalte scene încărcate.",
  T_48_META_API_102_P0_D: "ID scenă pentru a trece la",
  T_48_META_API_1020_D: "Implementarea traversării unui container pentru a ajunge la fiecare pereche cheie-valoare conține subproceduri, corpul buclei este subprocedura",
  T_48_META_API_1020_P0_D: "Iterând peste numele unei chei, îl puteți utiliza pentru a obține valoarea cheii pe o variabilă locală",
  T_48_META_API_1020_P1_D: "Iterați peste numele valorii, care poate fi utilizat pentru a ajunge la valoarea de pe variabila locală",
  T_48_META_API_1020_P2_D: "Containere care urmează să fie traversate",
  T_48_META_API_1021_D: "Ștergeți Bot",
  T_48_META_API_1021_P0_D: "Ștergeți entitatea Bot Player",
  T_48_META_API_1022_D: "Forțați jucătorul țintă să părăsească purtătorul",
  T_48_META_API_1022_P0_D: "jucător țintă",
  T_48_META_API_1023_D: "Crearea saltătorilor de leziuni",
  T_48_META_API_1023_P0_D: "conținut skip-word",
  T_48_META_API_1023_P1_D: "dimensiunea fontului",
  T_48_META_API_1023_P2_D: "culoarea fontului",
  T_48_META_API_1023_P3_D: "Timp de repaus în milisecunde",
  T_48_META_API_1023_P4_D: "entitate prejudiciată",
  T_48_META_API_1023_P5_D: "Decalajul cuvântului de salt al daunelor în raport cu coordonatele mondiale ale entității țintă",
  T_48_META_API_1023_P6_D: "Mărimea intervalului de corecții poziționale aleatorii la locațiile de salt ale avariilor din nou",
  T_48_META_API_1023_P7_D: "Dacă se execută animația de completare",
  T_48_META_API_1024_D: "abandonate",
  T_48_META_API_1024_P0_D: "abandonate",
  T_48_META_API_1024_P1_D: "entitate țintă",
  T_48_META_API_1024_P2_D: "Atunci când este selectat, acesta este trimis către client dacă este apelat de pe server și către server dacă este apelat de pe client.",
  T_48_META_API_1024_P3_D: "lista parametrilor",
  T_48_META_API_1025_D: "Căutarea progresului unei sarcini personalizate",
  T_48_META_API_1025_P0_D: "jucător țintă",
  T_48_META_API_1025_P1_D: "ID activitate personalizată",
  T_48_META_API_1025_R_D: "Progresul misiunii",
  T_48_META_API_1026_D: "Obțineți pielea rucsacului jucătorului țintă",
  T_48_META_API_1026_P0_D: "jucător țintă",
  T_48_META_API_1026_R_D: "Rucsac piele ID",
  T_48_META_API_1027_D: "Setarea pielii rucsacului jucătorului țintă",
  T_48_META_API_1027_P0_D: "jucător țintă",
  T_48_META_API_1027_P1_D: "Rucsac piele ID",
  T_48_META_API_1028_D: "Restaurați pielea rucsacului jucătorului țintă la configurația implicită din afara biroului",
  T_48_META_API_1028_P0_D: "jucător țintă",
  T_48_META_API_1029_D: "Goliți pielea rucsacului jucătorului țintă",
  T_48_META_API_1029_P0_D: "jucător țintă",
  T_48_META_API_103_D: "Înlocuiți stilul de mediu skybox al jocului cu o alegere de zi, amurg, noapte, etc.",
  T_48_META_API_103_P0_D: "Tip Skybox",
  T_48_META_API_1030_D: "Obținerea părții de schelet după nume",
  T_48_META_API_1030_P0_D: "entitate țintă",
  T_48_META_API_1030_P1_D: "Nume punct de suspensie scheletic",
  T_48_META_API_1030_R_D: "Punctul de Rig",
  T_48_META_API_1031_D: "Setează nodul părinte al unei entități obiect care acceptă entități pe care sunt montate componente Transform, SkeletonPart, Player, MountPoint.",
  T_48_META_API_1031_P0_D: "nod părinte",
  T_48_META_API_1031_P1_D: "nod copil",
  T_48_META_API_1031_P2_D: "Dacă se păstrează poziția curentă în lume, rotația și scalarea nodurilor copil, setarea UI a acestui element este invalidă",
  T_48_META_API_1032_D: "Redă un efect de pictogramă animată în care pictograma se deplasează de la poziția inițială la poziția finală la viteza de redare.",
  T_48_META_API_1032_P0_D: "Icoană ID resursă",
  T_48_META_API_1032_P1_D: "culoare",
  T_48_META_API_1032_P2_D: "Pictograma Zoom",
  T_48_META_API_1032_P3_D: "Poziția de pornire centru",
  T_48_META_API_1032_P4_D: "Domeniul de aplicare regional inițial",
  T_48_META_API_1032_P5_D: "Poziția finală centru",
  T_48_META_API_1032_P6_D: "Intervalul poziției finale",
  T_48_META_API_1032_P7_D: "Viteza de redare, care este distanța pe secundă parcursă de pictogramă",
  T_48_META_API_1033_D: "Efectuați o operație de tangență inversă pentru a obține unghiul",
  T_48_META_API_1033_P0_D: "Coordonatele axei Y",
  T_48_META_API_1033_P1_D: "Coordonatele axei X",
  T_48_META_API_1033_R_D: "Unghi, interval (-180, 180]",
  T_48_META_API_1034_D: "Adăugarea de componente la entități, sunt acceptate numai componentele personalizate create de utilizator",
  T_48_META_API_1034_P0_D: "entitate țintă",
  T_48_META_API_1034_P1_D: "ID tip componentă, sunt acceptate numai componentele personalizate create de utilizator",
  T_48_META_API_1034_P2_D: "Indiferent dacă este adăugată cu succes sau nu, componentele existente sau componentele nepersonalizate nu vor fi adăugate.",
  T_48_META_API_1035_D: "Eliminați componentele din entități, sunt acceptate numai componentele personalizate",
  T_48_META_API_1035_P0_D: "entitate țintă",
  T_48_META_API_1035_P1_D: "ID tip componentă, sunt acceptate numai componentele personalizate create de utilizator",
  T_48_META_API_1035_P2_D: "Indiferent dacă eliminarea a reușit sau nu, componentele inexistente sau componentele necustomizate nu vor fi eliminate.",
  T_48_META_API_1036_D: "Personalizați ecranul de ieșire al jucătorului",
  T_48_META_API_1036_P0_D: "legendă",
  T_48_META_API_1036_P1_D: "element",
  T_48_META_API_1036_P2_D: "opțiuni",
  T_48_META_API_1036_P3_D: "Dacă să se afișeze fundalul",
  T_48_META_API_1037_D: "Obțineți toate scenele încărcate în prezent",
  T_48_META_API_1037_R_D: "Lista scenelor",
  T_48_META_API_1038_D: "Obține direcția locală de ochire a jucătorului",
  T_48_META_API_1038_R_D: "țintiți în direcția corectă",
  T_48_META_API_1039_D: "Obțineți timestamp-ul local",
  T_48_META_API_1039_R_D: "marca temporală",
  T_48_META_API_104_D: "Comută playerul la o locație specificată într-o scenă specificată, scenele neîncărcate vor fi încărcate automat și nu vor descărca automat scenele deja încărcate",
  T_48_META_API_104_P0_D: "jucător",
  T_48_META_API_104_P1_D: "ID-ul scenei care urmează să fie încărcată",
  T_48_META_API_104_P2_D: "Poziția jucătorului în noul scenariu",
  T_48_META_API_104_P3_D: "Orientarea jucătorului în noul scenariu",
  T_48_META_API_1040_D: "Întrerupe actualizarea cadrelor fixe pentru platforma curentă, iar evenimentul de actualizare a cadrelor fixe pentru platforma respectivă nu va fi declanșat după întrerupere.",
  T_48_META_API_1041_D: "Reluarea actualizării cadrului fix pentru platforma curentă, iar evenimentul de actualizare a cadrului fix pentru platforma respectivă începe să se declanșeze din nou după reluare",
  T_48_META_API_1042_D: "Determinați relația de prietenie a jucătorului țintă cu jucătorul client curent, clientul curent însuși nu este un prieten al clientului curent",
  T_48_META_API_1042_P0_D: "jucător țintă",
  T_48_META_API_1042_R_D: "Dacă sunteți sau nu prieten cu clientul actual",
  T_48_META_API_1043_D: "Declanșarea evenimentelor personalizate",
  T_48_META_API_1043_P0_D: "ID eveniment personalizat",
  T_48_META_API_1043_P1_D: "entitate țintă",
  T_48_META_API_1043_P2_D: "Funcționează pe platforme server-side sau client-side",
  T_48_META_API_1043_P3_D: "lista parametrilor",
  T_48_META_API_1044_D: "Open Skydive",
  T_48_META_API_1044_P0_D: "jucător țintă",
  T_48_META_API_1044_P1_D: "Sub această altitudine, parașuta va fi forțată să se deschidă.",
  T_48_META_API_1044_P2_D: "Viteza în timpul planării, componenta X reprezintă viteza orizontală, componenta Y reprezintă viteza verticală; jucătorul aterizează în jos atunci când componenta Y este negativă",
  T_48_META_API_1044_P3_D: "Viteza în picaj, componenta X reprezintă viteza orizontală, componenta Y reprezintă viteza verticală; jucătorul coboară în jos atunci când componenta Y este negativă",
  T_48_META_API_1044_P4_D: "Viteza la deschiderea parașutei, componenta X reprezintă viteza orizontală, componenta Y reprezintă viteza verticală; când componenta Y este negativă, jucătorul aterizează în jos",
  T_48_META_API_1045_D: "Citește valoarea corespunzătoare identificatorului specificat în tabelul de date.",
  T_48_META_API_1045_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_1045_P1_D: "ID unic al jucătorului",
  T_48_META_API_1045_P2_D: "identificator specificat",
  T_48_META_API_1045_P3_D: "Rezultatele citirilor",
  T_48_META_API_1045_P4_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1045_P5_D: "cod de eroare",
  T_48_META_API_1046_D: "Recuperează valoarea corespunzătoare identificatorului specificat în tabelul de date al graficului.",
  T_48_META_API_1046_P0_D: "Numele tabelului Leaderboard din baza de date",
  T_48_META_API_1046_P1_D: "identificator specificat",
  T_48_META_API_1046_P2_D: "Rezultatele citirilor",
  T_48_META_API_1046_P3_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1046_P4_D: "cod de eroare",
  T_48_META_API_1047_D: "Recuperează valoarea intervalului de rang specificat în tabelul de date Leaderboards",
  T_48_META_API_1047_P0_D: "Numele tabelului Leaderboard din baza de date",
  T_48_META_API_1047_P1_D: "Rangul inițial trebuie să fie mai mic sau egal cu rangul final, iar rangul începe de la 1.",
  T_48_META_API_1047_P2_D: "poziția de sosire",
  T_48_META_API_1047_P3_D: "Rezultatele citirilor",
  T_48_META_API_1047_P4_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1047_P5_D: "cod de eroare",
  T_48_META_API_1048_D: "Citește valoarea corespunzătoare identificatorului specificat în tabelul de date cumulative.",
  T_48_META_API_1048_P0_D: "Numele tabelului de date cumulative din baza de date",
  T_48_META_API_1048_P1_D: "identificator specificat",
  T_48_META_API_1048_P2_D: "Rezultatele citirilor",
  T_48_META_API_1048_P3_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1048_P4_D: "cod de eroare",
  T_48_META_API_1049_D: "Scrieți valoarea corespunzătoare identificatorului specificat în tabelul de date.",
  T_48_META_API_1049_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_1049_P1_D: "ID unic al jucătorului",
  T_48_META_API_1049_P2_D: "identificator specificat",
  T_48_META_API_1049_P3_D: "Valoarea înscrisă",
  T_48_META_API_1049_P4_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1049_P5_D: "cod de eroare",
  T_48_META_API_105_D: "Obțineți skybox-ul scenei",
  T_48_META_API_105_P0_D: "ID scenă",
  T_48_META_API_105_R_D: "skybox",
  T_48_META_API_1050_D: "Obține numărul de elemente din listă",
  T_48_META_API_1050_P0_D: "listă de ținte",
  T_48_META_API_1050_R_D: "Număr de elemente",
  T_48_META_API_1051_D: "Obține valoarea elementului la indexul specificat în listă",
  T_48_META_API_1051_P0_D: "listă de ținte",
  T_48_META_API_1051_P1_D: "Valori ale indicelui, începând de la 0",
  T_48_META_API_1051_R_D: "valoare elementară",
  T_48_META_API_1052_D: "Setează valoarea elementului corespunzător indicelui specificat în listă",
  T_48_META_API_1052_P0_D: "listă de ținte",
  T_48_META_API_1052_P1_D: "Valori ale indicelui, începând de la 0",
  T_48_META_API_1052_P2_D: "valoare elementară",
  T_48_META_API_1053_D: "Adăugați elemente la sfârșitul listei",
  T_48_META_API_1053_P0_D: "listă de ținte",
  T_48_META_API_1053_P1_D: "Elemente de adăugat",
  T_48_META_API_1054_D: "Îndepărtează din listă elementul aflat la indexul specificat",
  T_48_META_API_1054_P0_D: "listă de ținte",
  T_48_META_API_1054_P1_D: "Valori ale indicelui, începând de la 0",
  T_48_META_API_1055_D: "Goliți lista de toate elementele",
  T_48_META_API_1055_P0_D: "listă de ținte",
  T_48_META_API_1056_D: "Inversează ordinea elementelor din lista specificată.",
  T_48_META_API_1056_P0_D: "listă de ținte",
  T_48_META_API_1057_D: "Copierea unei liste",
  T_48_META_API_1057_P0_D: "listă de ținte",
  T_48_META_API_1057_R_D: "Lista nouă copiată",
  T_48_META_API_1058_D: "Inserează un nou element în lista la poziția indicelui specificată, iar elementele de la acea poziție indicelui și de după aceea sunt mutate înapoi cu un loc în ordine.",
  T_48_META_API_1058_P0_D: "listă de ținte",
  T_48_META_API_1058_P1_D: "Poziția indicelui care urmează să fie inserată, indicele se numără de la 0",
  T_48_META_API_1058_P2_D: "Valoarea noului element care urmează să fie introdus",
  T_48_META_API_1059_D: "Re-randomizați elementele din listă",
  T_48_META_API_1059_P0_D: "listă de ținte",
  T_48_META_API_1060_D: "Compară ambele părți ale argumentului și returnează true sau false.",
  T_48_META_API_1060_P0_D: "Valoarea stângă utilizată pentru comparație",
  T_48_META_API_1060_P1_D: "Metode de comparare, sunt acceptate următoarele: >,>=,==,! =,<=,<,And(qualified bool type),Or(qualified bool type)",
  T_48_META_API_1060_P2_D: "Valoarea stângă utilizată pentru comparație",
  T_48_META_API_1060_R_D: "Rezultate comparative",
  T_48_META_API_1061_D: "Cele patru operații de bază, inclusiv adunarea, scăderea, înmulțirea, împărțirea și restul. Operația restului acceptă numai numere întregi, iar restul operațiilor acceptă numere întregi sau zecimale.",
  T_48_META_API_1061_P0_D: "valoarea stângă a unei operațiuni",
  T_48_META_API_1061_P1_D: "Tipuri de cele patru operații, inclusiv adunarea, scăderea, înmulțirea, împărțirea și restul, care nu acceptă zecimalele",
  T_48_META_API_1061_P2_D: "valoarea corectă a unei operații",
  T_48_META_API_1061_R_D: "rezultatul calculului",
  T_48_META_API_1062_D: "Generarea unui număr întreg aleatoriu între numărul întreg cu valoare minimă (inclus) și numărul întreg cu valoare maximă (neinclus)",
  T_48_META_API_1062_P0_D: "Interval aleatoriu din stânga intervalului cu posibilitatea de randomizare la valoarea completată",
  T_48_META_API_1062_P1_D: "Interval aleatoriu interval drept, nu va fi aleatoriu la valoarea completată",
  T_48_META_API_1062_R_D: "Rezultat aleatoriu, număr întreg",
  T_48_META_API_1063_D: "Generarea unei zecimale aleatorii între valoarea minimă a zecimalei (inclusă) și valoarea maximă a zecimalei (neinclusă)",
  T_48_META_API_1063_P0_D: "Interval aleatoriu din stânga intervalului, cu o mică șansă de randomizare la valoarea completată",
  T_48_META_API_1063_P1_D: "Interval aleatoriu interval drept, nu va fi aleatoriu la valoarea completată",
  T_48_META_API_1063_R_D: "Rezultate randomizate, zecimale, cu 7 zecimale",
  T_48_META_API_1064_D: "Determinați dacă un obiect este gol",
  T_48_META_API_1064_P0_D: "obiect gol pentru a fi judecat",
  T_48_META_API_1064_R_D: "Este gol",
  T_48_META_API_1065_D: "Invers logic, valoare de intrare: true sau false, valoare de retur: false sau true",
  T_48_META_API_1065_P0_D: "Valori care trebuie să fie solicitate pentru non",
  T_48_META_API_1065_R_D: "Rezultatul nonce",
  T_48_META_API_1066_D: "Acceptă valori absolute și acceptă numere întregi și zecimale.",
  T_48_META_API_1066_P0_D: "Valori pentru care sunt necesare valori absolute",
  T_48_META_API_1066_R_D: "Rezultatul luării valorilor absolute",
  T_48_META_API_1067_D: "calculul rădăcinii pătrate",
  T_48_META_API_1067_P0_D: "Trebuie să cereți valoarea rădăcinii pătrate",
  T_48_META_API_1067_R_D: "Rezultatul găsirii rădăcinii pătrate",
  T_48_META_API_1068_D: "Calcularea valorilor negative",
  T_48_META_API_1068_P0_D: "Valorile negative care urmează să fie solicitate",
  T_48_META_API_1068_R_D: "Rezultate negative",
  T_48_META_API_1069_D: "Unirea a două corzi împreună",
  T_48_META_API_1069_P0_D: "valoarea stângă a unui șir de caractere",
  T_48_META_API_1069_P1_D: "valoarea din dreapta a unui șir de caractere",
  T_48_META_API_1069_R_D: "rezultatul concatenării șirurilor de caractere",
  T_48_META_API_1070_D: "Obțineți lungimea șirului",
  T_48_META_API_1070_P0_D: "string",
  T_48_META_API_1070_R_D: "lungimea șirului",
  T_48_META_API_1071_D: "Rotunjește valoarea specificată la cel mai apropiat număr întreg.",
  T_48_META_API_1071_P0_D: "Valoarea care trebuie rotunjită în jos",
  T_48_META_API_1071_R_D: "rotunjirea în jos",
  T_48_META_API_1072_D: "Rotunjește valoarea specificată la cel mai apropiat număr întreg.",
  T_48_META_API_1072_P0_D: "Valori care urmează să fie rotunjite în sus",
  T_48_META_API_1072_R_D: "Rezultatele rotunjirii în sus",
  T_48_META_API_1073_D: "Rotunjește valoarea specificată la cel mai apropiat număr întreg.",
  T_48_META_API_1073_P0_D: "Numărul de valori care urmează să fie rotunjite",
  T_48_META_API_1073_R_D: "rezultat rotunjit",
  T_48_META_API_1074_D: "Produce un șir nou după înlocuirea tuturor șirurilor specificate în șirul țintă",
  T_48_META_API_1074_P0_D: "șir țintă",
  T_48_META_API_1074_P1_D: "Șirul vechi care urmează să fie înlocuit",
  T_48_META_API_1074_P2_D: "Șir nou de înlocuit cu",
  T_48_META_API_1074_R_D: "Înlocuirea șirului completat",
  T_48_META_API_1075_D: "Găsește prima apariție a unui șir specificat în șirul țintă.",
  T_48_META_API_1075_P0_D: "șir țintă",
  T_48_META_API_1075_P1_D: "Șirul specificat pentru căutare",
  T_48_META_API_1075_P2_D: "Găsește șirul de caractere din poziția de pornire, poziția șirului de caractere este socotită de la 0",
  T_48_META_API_1075_R_D: "Specifică poziția primei apariții a șirului în șirul țintă, poziția șirului fiind socotită de la 0.",
  T_48_META_API_1076_D: "Scoate un șir nou după interceptarea unui șir cu o lungime specificată dintr-o poziție specificată.",
  T_48_META_API_1076_P0_D: "șir țintă",
  T_48_META_API_1076_P1_D: "Poziția de la care se începe interceptarea, poziția șirului se numără de la 0",
  T_48_META_API_1076_P2_D: "Lungimea interceptării, implicit este până la sfârșitul șirului.",
  T_48_META_API_1076_R_D: "String interceptat",
  T_48_META_API_1077_D: "Comparați două liste cu elemente identice, dimensiunea listei nu afectează rezultatul.",
  T_48_META_API_1077_P0_D: "Valoarea din stânga a listei utilizate pentru comparație",
  T_48_META_API_1077_P1_D: "Valoarea din dreapta a listei utilizate pentru comparație",
  T_48_META_API_1077_R_D: "Comparați rezultatele, consecvența conținutului returnează True, inconsecvența conținutului returnează False.",
  T_48_META_API_1078_D: "Luați șirul specificat ca separator, tăiați șirul țintă într-un număr de felii și emiteți noul șir, cei N separatori consecutivi vor fi tăiați în N-1 spații de jumătate de lățime ca elemente ale listei de șiruri de ieșire",
  T_48_META_API_1078_P0_D: "șir țintă",
  T_48_META_API_1078_P1_D: "șir delimitator",
  T_48_META_API_1078_R_D: "Scoate o listă de șiruri de caractere, care se termină întotdeauna cu un element de spațiu de jumătate de lățime",
  T_48_META_API_1079_D: "Extrage caractere din lista de poziții ale șirului și le combină într-un nou șir de ieșire",
  T_48_META_API_1079_P0_D: "șir țintă",
  T_48_META_API_1079_P1_D: "Listă de poziții ale șirurilor de caractere, pozițiile șirurilor de caractere fiind numărate de la 0",
  T_48_META_API_1079_R_D: "Șir de ieșire",
  T_48_META_API_1080_D: "Convertește toate caracterele șirului țintă în majuscule",
  T_48_META_API_1080_P0_D: "șir țintă",
  T_48_META_API_1080_R_D: "Șir de ieșire",
  T_48_META_API_1081_D: "Convertește toate caracterele șirului țintă în minuscule",
  T_48_META_API_1081_P0_D: "șir țintă",
  T_48_META_API_1081_R_D: "Șir de ieșire",
  T_48_META_API_1082_D: "Elimină toate spațiile înainte de primul caracter fără spațiu și după ultimul caracter fără spațiu din șirul țintă.",
  T_48_META_API_1082_P0_D: "șir țintă",
  T_48_META_API_1082_R_D: "Șir de ieșire",
  T_48_META_API_1083_D: "Scoate un nou șir de caractere după legarea cu un identificator specificat.",
  T_48_META_API_1083_P0_D: "Lista de șiruri de caractere țintă",
  T_48_META_API_1083_P1_D: "Identificator specificat utilizat pentru concatenarea șirurilor de caractere",
  T_48_META_API_1083_R_D: "Șir de ieșire",
  T_48_META_API_1084_D: "Scrie valoarea corespunzătoare identificatorului specificat în tabelul de date al clasamentului",
  T_48_META_API_1084_P0_D: "Numele tabelului Leaderboard din baza de date",
  T_48_META_API_1084_P1_D: "identificator specificat",
  T_48_META_API_1084_P2_D: "Valoarea înscrisă",
  T_48_META_API_1084_P3_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1084_P4_D: "cod de eroare",
  T_48_META_API_1085_D: "Scrieți valoarea de offset corespunzătoare identificatorului specificat în tabelul de date cumulative",
  T_48_META_API_1085_P0_D: "Numele tabelului de date cumulative din baza de date",
  T_48_META_API_1085_P1_D: "identificator specificat",
  T_48_META_API_1085_P2_D: "Tipuri de operații fundamentale",
  T_48_META_API_1085_P3_D: "Valoarea offset scrisă",
  T_48_META_API_1085_P4_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1085_P5_D: "cod de eroare",
  T_48_META_API_1086_D: "Șterge valoarea corespunzătoare identificatorului specificat în tabelul de date.",
  T_48_META_API_1086_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_1086_P1_D: "ID unic al jucătorului",
  T_48_META_API_1086_P2_D: "identificator specificat",
  T_48_META_API_1086_P3_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1086_P4_D: "cod de eroare",
  T_48_META_API_1087_D: "Șterge valoarea corespunzătoare identificatorului specificat în tabelul de date al graficului.",
  T_48_META_API_1087_P0_D: "Numele tabelului Leaderboard din baza de date",
  T_48_META_API_1087_P1_D: "identificator specificat",
  T_48_META_API_1087_P2_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1087_P3_D: "cod de eroare",
  T_48_META_API_1088_D: "Șterge valoarea corespunzătoare rangului specificat în tabelul Leaderboard.",
  T_48_META_API_1088_P0_D: "Numele tabelului Leaderboard din baza de date",
  T_48_META_API_1088_P1_D: "a primit o poziție prestigioasă",
  T_48_META_API_1088_P2_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_1088_P3_D: "cod de eroare",
  T_48_META_API_1089_D: "Trimite un mesaj de utilizator lui Persona",
  T_48_META_API_1089_P0_D: "PersonaID țintă",
  T_48_META_API_1089_P1_D: "Mesaj",
  T_48_META_API_1090_D: "Trimiteți un mesaj de sistem către Persona",
  T_48_META_API_1090_P0_D: "PersonaID țintă",
  T_48_META_API_1090_P1_D: "Mesaj",
  T_48_META_API_1091_D: "Ștergeți memoria Persona",
  T_48_META_API_1091_P0_D: "cod de eroare",
  T_48_META_API_1092_D: "Centrul pentru membri Evoke",
  T_48_META_API_1092_P0_D: "cod de eroare",
  T_48_META_API_1093_D: "Obțineți data expirării membrului",
  T_48_META_API_1093_P0_D: "jucător țintă",
  T_48_META_API_1093_P1_D: "marca temporală",
  T_48_META_API_1093_P2_D: "cod de eroare",
  T_48_META_API_1094_D: "Determinați dacă un jucător este membru",
  T_48_META_API_1094_P0_D: "cod de eroare",
  T_48_META_API_1094_P1_D: "Fie că sunteți membru",
  T_48_META_API_1095_D: "Obțineți data expirării membrului",
  T_48_META_API_1095_P0_D: "marca temporală",
  T_48_META_API_1095_P1_D: "cod de eroare",
  T_48_META_API_1096_D: "Determinați dacă un jucător este membru",
  T_48_META_API_1096_P0_D: "jucător țintă",
  T_48_META_API_1096_P1_D: "cod de eroare",
  T_48_META_API_1096_P2_D: "Fie că sunteți membru",
  T_48_META_API_1097_D: "Centrul pentru membri Evoke",
  T_48_META_API_1097_P0_D: "jucător țintă",
  T_48_META_API_1097_P1_D: "cod de eroare",
  T_48_META_API_1099_D: "Configurarea observatorilor Persona, după care conversațiile cu Persona sunt trimise și observatorului",
  T_48_META_API_1099_P0_D: "PersonaID țintă",
  T_48_META_API_1099_P1_D: "listă de supraveghere",
  T_48_META_API_11_D: "Încheiați faza curentă și treceți la următoarea",
  T_48_META_API_1100_D: "Trimiterea mesajelor utilizatorului către Persona utilizând Streaming",
  T_48_META_API_1100_P0_D: "PersonaID țintă",
  T_48_META_API_1100_P1_D: "Mesaj",
  T_48_META_API_1101_D: "Trimiterea mesajelor de sistem către Persona utilizând streaming",
  T_48_META_API_1101_P0_D: "PersonaID țintă",
  T_48_META_API_1101_P1_D: "Mesaj",
  T_48_META_API_1101_P2_D: "Dacă să răspundeți sau nu",
  T_48_META_API_1103_D: "Crearea de semințe aleatorii",
  T_48_META_API_1103_P0_D: "torrent",
  T_48_META_API_1103_R_D: "Generator de numere aleatorii",
  T_48_META_API_1104_D: "Obține următorul număr aleatoriu al generatorului de numere aleatorii specificat, valoarea maximă 32767",
  T_48_META_API_1104_P0_D: "Generator de numere aleatorii",
  T_48_META_API_1104_P1_D: "Interval Minim",
  T_48_META_API_1104_P2_D: "Intervalul maxim",
  T_48_META_API_1104_R_D: "număr aleatoriu",
  T_48_META_API_1108_D: "Get the client language used by the player ",
  T_48_META_API_12_D: "Imprimarea jurnalelor la consolă",
  T_48_META_API_12_P0_D: "Ce să tipăriți",
  T_48_META_API_13_D: "Scoate un șir de caractere cu parametri",
  T_48_META_API_13_P0_D: "Utilizați marcajul %v pentru un parametru, numărul de %v și numărul de parametri trebuie să fie identice.",
  T_48_META_API_13_P1_D: "Lista parametrilor care participă la ieșire trebuie să fie în concordanță cu numărul de %v din descrierea formatului",
  T_48_META_API_13_R_D: "Șir de ieșire",
  T_48_META_API_14_D: "Curățați rămășițele obiectelor de pe hartă, inclusiv cutiile morții, obiectele create, obiectele plasate, rămășițele proiectilelor etc.",
  T_48_META_API_15_D: "Jurnale personalizate de îngropare a concursurilor pentru analiza datelor privind experiența utilizatorului",
  T_48_META_API_15_P0_D: "Lista numelor de câmpuri care urmează să fie raportate",
  T_48_META_API_15_P1_D: "Lista valorilor câmpului care urmează să fie raportate",
  T_48_META_API_1500_D: "Obține componenta x a vectorului 3D",
  T_48_META_API_1500_P0_D: "Vector 3D",
  T_48_META_API_1500_R_D: "Vectorul 3D x-componentă",
  T_48_META_API_1501_D: "Obține componenta y a vectorului 3D",
  T_48_META_API_1501_P0_D: "Vector 3D",
  T_48_META_API_1501_R_D: "Componenta Y a vectorului 3D",
  T_48_META_API_1502_D: "Obține componenta z a vectorului 3D",
  T_48_META_API_1502_P0_D: "Vector 3D",
  T_48_META_API_1502_R_D: "Componenta z a vectorului tridimensional",
  T_48_META_API_1503_D: "Setează componenta x a vectorului 3D",
  T_48_META_API_1503_P0_D: "Vector 3D",
  T_48_META_API_1503_P1_D: "Componenta X",
  T_48_META_API_1504_D: "Setează componenta Y a vectorului 3D",
  T_48_META_API_1504_P0_D: "Vector 3D",
  T_48_META_API_1504_P1_D: "Componenta Y",
  T_48_META_API_1505_D: "Setează componenta z a vectorului 3D",
  T_48_META_API_1505_P0_D: "Vector 3D",
  T_48_META_API_1505_P1_D: "Componenta Z",
  T_48_META_API_1506_D: "Adăugați împreună doi vectori 3D",
  T_48_META_API_1506_P0_D: "Stânga",
  T_48_META_API_1506_P1_D: "Dreapta",
  T_48_META_API_1506_R_D: "Rezultatul sumei vectorilor 3D",
  T_48_META_API_1507_D: "Scăderea a doi vectori 3D",
  T_48_META_API_1507_P0_D: "Stânga",
  T_48_META_API_1507_P1_D: "Dreapta",
  T_48_META_API_1507_R_D: "Rezultatul sustragerii valorii din dreapta din valoarea din stânga a vectorului 3D",
  T_48_META_API_1508_D: "Scalarea vectorilor 3D",
  T_48_META_API_1508_P0_D: "Vectori 3D care urmează să fie scalați",
  T_48_META_API_1508_P1_D: "Deflație vectorială 3D",
  T_48_META_API_1508_R_D: "Rezultatele scalării vectorului 3D",
  T_48_META_API_1509_D: "Înmulțirea punctuală a doi vectori 3D, rezultatul înmulțirii punctuale este un scalar",
  T_48_META_API_1509_P0_D: "Stânga",
  T_48_META_API_1509_P1_D: "Dreapta",
  T_48_META_API_1509_R_D: "Rezultatul produsului punctelor",
  T_48_META_API_1510_D: "Înmulțirea încrucișată a doi vectori 3D, rezultatul înmulțirii încrucișate este un vector perpendicular pe planul în care sunt localizați cei doi vectori",
  T_48_META_API_1510_P0_D: "Stânga",
  T_48_META_API_1510_P1_D: "Dreapta",
  T_48_META_API_1510_R_D: "Rezultatul produsului încrucișat, orientat perpendicular pe planul în care se află cei doi vectori implicați în operație",
  T_48_META_API_1511_D: "Normalizarea vectorilor 3D",
  T_48_META_API_1511_P0_D: "Vector 3D",
  T_48_META_API_1511_R_D: "Returnează un nou vector normalizat. Lungimea modulului este 1",
  T_48_META_API_1512_D: "Modelarea vectorilor 3D",
  T_48_META_API_1512_P0_D: "Vector 3D",
  T_48_META_API_1512_R_D: "Rezultatul modelării, lungimea modulului vectorului",
  T_48_META_API_1513_D: "Calculați distanța euclidiană dintre doi vectori 3D",
  T_48_META_API_1513_P0_D: "Stânga",
  T_48_META_API_1513_P1_D: "Dreapta",
  T_48_META_API_1513_R_D: "După scăderea a doi vectori, modulul vectorului rezultat",
  T_48_META_API_1514_D: "Calculați unghiul dintre doi vectori 3D",
  T_48_META_API_1514_P0_D: "Stânga",
  T_48_META_API_1514_P1_D: "Dreapta",
  T_48_META_API_1514_R_D: "Unghi vectorial, intervalul unghiului 0-180",
  T_48_META_API_1515_D: "Creați un vector 3D",
  T_48_META_API_1515_P0_D: "Componenta X a unui vector 3D",
  T_48_META_API_1515_P1_D: "Componenta Y a unui vector 3D",
  T_48_META_API_1515_P2_D: "Componenta Z a unui vector 3D",
  T_48_META_API_1515_R_D: "Vectori 3D creați",
  T_48_META_API_1516_D: "Obține punctul de orientare al unei construcții noi (depreciat, vă rugăm să nu îl utilizați)",
  T_48_META_API_1516_P0_D: "plasare",
  T_48_META_API_1516_P1_D: "să se întoarcă spre",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Ia poziția punctului de direcție (depreciat, vă rugăm să nu utilizați)",
  T_48_META_API_1517_P0_D: "punct de orientare",
  T_48_META_API_1517_R_D: "Poziția",
  T_48_META_API_1518_D: "Luarea direcției punctului de orientare (învechit, vă rugăm să nu utilizați)",
  T_48_META_API_1518_P0_D: "punct de orientare",
  T_48_META_API_1518_R_D: "Înainte",
  T_48_META_API_1519_D: "Creați o listă",
  T_48_META_API_1519_P0_D: "Lungimea inițială a listei, care trebuie să fie mai mică sau egală cu capacitatea inițială",
  T_48_META_API_1519_P1_D: "Capacitatea inițială a listei trebuie să fie mai mare sau egală cu lungimea inițială. Capacitatea poate fi extinsă în mod dinamic, dar aceasta va consuma ceva performanță, astfel încât este recomandat să se stabilească o valoare adecvată în momentul const",
  T_48_META_API_1519_R_D: "Crearea unei liste",
  T_48_META_API_1520_D: "Verifică dacă lista conține elementul specificat",
  T_48_META_API_1520_P0_D: "listă de ținte",
  T_48_META_API_1520_P1_D: "Elementul specificat care urmează să fie verificat",
  T_48_META_API_1520_R_D: "Dacă conține sau nu elementul specificat",
  T_48_META_API_1521_D: "Adăugarea mai multor elemente la sfârșitul listei țintă",
  T_48_META_API_1521_P0_D: "listă de ținte",
  T_48_META_API_1521_P1_D: "Listă suplimentară",
  T_48_META_API_1522_D: "Îndepărtează elementul specificat din listă",
  T_48_META_API_1522_P0_D: "listă de ținte",
  T_48_META_API_1522_P1_D: "Valoarea elementului care urmează să fie eliminat",
  T_48_META_API_1523_D: "Obține indexul primei poziții a elementului din listă, dacă nu există niciun element țintă în listă, atunci se returnează -1.",
  T_48_META_API_1523_P0_D: "listă de ținte",
  T_48_META_API_1523_P1_D: "valoare elementară",
  T_48_META_API_1523_R_D: "indexul locației",
  T_48_META_API_1524_D: "Obține indexul ultimei poziții a elementului din listă, dacă nu există niciun element țintă în listă, returnează -1.",
  T_48_META_API_1524_P0_D: "listă de ținte",
  T_48_META_API_1524_P1_D: "valoare elementară",
  T_48_META_API_1524_R_D: "indexul locației",
  T_48_META_API_1525_D: "Găsiți sinusul unghiului",
  T_48_META_API_1525_P0_D: "Unghi, 360 pentru 360 de grade",
  T_48_META_API_1525_R_D: "sinus",
  T_48_META_API_1526_D: "Găsirea cosinusului unui unghi",
  T_48_META_API_1526_P0_D: "Unghi, 360 pentru 360 de grade",
  T_48_META_API_1526_R_D: "cosinus",
  T_48_META_API_1527_D: "Găsirea tangentei unui unghi",
  T_48_META_API_1527_P0_D: "Unghi, 360 pentru 360 de grade",
  T_48_META_API_1527_R_D: "tangentă",
  T_48_META_API_1528_D: "Construiți o valoare de culoare cu transparență fixată la 255 decimal, mai întâi convertiți canalul într-un număr binar, fiecare 8 biți reprezentând un canal, îmbinat în funcție de R, G, B și transparență, apoi convertiți acest număr binar la tipul Int32 ",
  T_48_META_API_1528_P0_D: "Valoarea canalului roșu al culorii, în intervalul [0,255], dacă depășește intervalul, va fi fixată la valoarea legală.",
  T_48_META_API_1528_P1_D: "Valoarea canalului verde al culorii, în intervalul [0,255], dacă depășește intervalul, va fi fixată la valoarea legală.",
  T_48_META_API_1528_P2_D: "Valoarea canalului albastru al culorii, în intervalul [0,255], dacă depășește intervalul, va fi fixată la valoarea legală.",
  T_48_META_API_1528_R_D: "Valori de culoare construite",
  T_48_META_API_1529_D: "Efectuați o operație de sinus invers pentru a obține unghiul",
  T_48_META_API_1529_P0_D: "Valoarea pentru care se efectuează operația sinus invers, în intervalul [-1,1].",
  T_48_META_API_1529_R_D: "perspective",
  T_48_META_API_1530_D: "Efectuați operația cosinusului invers pentru a obține unghiul",
  T_48_META_API_1530_P0_D: "Valoarea operației cosinus invers, în intervalul [-1,1].",
  T_48_META_API_1530_R_D: "perspective",
  T_48_META_API_1531_D: "Efectuați o operație de tangență inversă pentru a obține unghiul",
  T_48_META_API_1531_P0_D: "Valoarea pentru care se efectuează operația arctangentă",
  T_48_META_API_1531_R_D: "perspective",
  T_48_META_API_1532_D: "Determină dacă entitatea țintă se află în sfera specificată, dacă entitatea nu are atribute poziționale, returnează fals",
  T_48_META_API_1532_P0_D: "entitate țintă",
  T_48_META_API_1532_P1_D: "Specificați centrul sferei",
  T_48_META_API_1532_P2_D: "Specificați raza sferei",
  T_48_META_API_1532_R_D: "Constatări",
  T_48_META_API_1533_D: "Determină dacă entitatea țintă se află în intervalul de cilindri specificat, dacă entitatea nu are un atribut de locație, va returna fals",
  T_48_META_API_1533_P0_D: "entitate țintă",
  T_48_META_API_1533_P1_D: "Specificați centrul cilindrului",
  T_48_META_API_1533_P2_D: "Specificați raza secțiunii transversale a cilindrului",
  T_48_META_API_1533_P3_D: "Specificați înălțimea cilindrului",
  T_48_META_API_1533_P4_D: "Specificați unghiul Euler al unui cilindru care se rotește în trei dimensiuni în jurul punctului său central",
  T_48_META_API_1533_R_D: "Constatări",
  T_48_META_API_1534_D: "Determinați dacă entitatea țintă se află în intervalul de cuburi specificat",
  T_48_META_API_1534_P0_D: "entitate țintă",
  T_48_META_API_1534_P1_D: "Specificați centrul cubului",
  T_48_META_API_1534_P2_D: "Specificați lungimea cubului",
  T_48_META_API_1534_P3_D: "Specificați lățimea cubului",
  T_48_META_API_1534_P4_D: "Specificați înălțimea cubului",
  T_48_META_API_1534_P5_D: "Specificați unghiurile Euler pentru rotația tridimensională a cubului în jurul punctului său central",
  T_48_META_API_1534_R_D: "Constatări",
  T_48_META_API_1535_D: "Determinați dacă entitatea țintă se află în coloanele sectorului specificat",
  T_48_META_API_1535_P0_D: "entitate țintă",
  T_48_META_API_1535_P1_D: "Specificarea centrului cercului secțiunii de mijloc a unei coloane în formă de sector",
  T_48_META_API_1535_P2_D: "Specificați raza secțiunii centrale a unei coloane în formă de sector",
  T_48_META_API_1535_P3_D: "Raza secțiunii transversale a coloanei în formă de evantai care nu va fi detectată, cu punctul central ca un cerc, nu va fi detectată în această regiune a coloanei în formă de evantai mic, fiind detectată doar diferența dintre coloana în formă de evantai ",
  T_48_META_API_1535_P4_D: "Specificați înălțimea coloanei în formă de evantai",
  T_48_META_API_1535_P5_D: "Detectarea secțiunii transversale cilindrice în formă de evantai a unghiului centroidului, mai mare de 360 atunci când detectarea cilindrică, mai mică de 0 atunci când dimensiunea zonei de detectare este 0",
  T_48_META_API_1535_P6_D: "Specificați unghiul Euler de rotație al coloanei în formă de evantai în jurul punctului central în trei locuri",
  T_48_META_API_1535_R_D: "Constatări",
  T_48_META_API_1536_D: "Compară valoarea a două numere și returnează valoarea cea mai mare",
  T_48_META_API_1536_P0_D: "Stânga",
  T_48_META_API_1536_P1_D: "Dreapta",
  T_48_META_API_1536_R_D: "cifră mai mare",
  T_48_META_API_1537_D: "Returnează valoarea maximă din listă",
  T_48_META_API_1537_P0_D: "Lista țintă, acceptă numai elemente de listă de tip numeric",
  T_48_META_API_1537_P1_D: "Comparați rezultatele, dacă în listă există numere care nu sunt numere, etc., comparația eșuează și returnează fals.",
  T_48_META_API_1537_P2_D: "Returnează cea mai mare valoare din listă dacă comparația reușește, sau 0 dacă comparația eșuează.",
  T_48_META_API_1538_D: "Compară valoarea a două numere și returnează valoarea cea mai mică",
  T_48_META_API_1538_P0_D: "Stânga",
  T_48_META_API_1538_P1_D: "Dreapta",
  T_48_META_API_1538_R_D: "Cifre mai mici",
  T_48_META_API_1539_D: "Returnează cea mai mică valoare din listă.",
  T_48_META_API_1539_P0_D: "Lista țintă, acceptă numai elemente de listă de tip numeric",
  T_48_META_API_1539_P1_D: "Comparați rezultatele, dacă în listă există numere care nu sunt numere, etc., comparația eșuează și returnează fals.",
  T_48_META_API_1539_P2_D: "Returnează cea mai mică valoare din listă dacă comparația reușește, sau 0 dacă comparația eșuează.",
  T_48_META_API_1540_D: "Interpolare liniară, returnarea valorii corespunzătoare progresului de interpolare între valoarea inițială și valoarea țintă, coeficienți de interpolare [0,1]",
  T_48_META_API_1540_P0_D: "Valoarea de pornire a interpolării liniare, care este returnată atunci când progresul interpolării este 0.",
  T_48_META_API_1540_P1_D: "Valoarea țintă a interpolării liniare, care este returnată atunci când progresul interpolării este 1",
  T_48_META_API_1540_P2_D: "Progresul interpolării, intervalul de valori [0,1], valoarea 0 pentru a reveni la valoarea inițială, valoarea 1 pentru a reveni la valoarea țintă, valoarea 0,5 pentru a reveni la media dintre valoarea inițială și valoarea țintă",
  T_48_META_API_1540_R_D: "Valoarea returnată a interpolării liniare",
  T_48_META_API_1541_D: "Limitați intervalul valorii țintă, obțineți valoarea din mijlocul celor trei intrări; rolul său este de a limita valoarea țintă la intervalul specificat, valoarea țintă este mai mică decât valoarea minimă pentru a reveni la cea mai mică valoare, mai mare ",
  T_48_META_API_1541_P0_D: "valoarea țintă",
  T_48_META_API_1541_P1_D: "Valoarea minimă a intervalului limită",
  T_48_META_API_1541_P2_D: "Valoarea maximă a intervalului limită",
  T_48_META_API_1541_R_D: "Valoarea returnată după restricție",
  T_48_META_API_1542_D: "Obține valorile canalelor culorii țintă",
  T_48_META_API_1542_P0_D: "culoarea țintă",
  T_48_META_API_1542_P1_D: "Valoarea R a culorii, în intervalul [0 , 255].",
  T_48_META_API_1542_P2_D: "Valoarea G a culorii, în intervalul [0 , 255].",
  T_48_META_API_1542_P3_D: "Valoarea B a culorii, în intervalul [0 , 255].",
  T_48_META_API_1542_P4_D: "Valoarea A a culorii, în intervalul [0 , 255].",
  T_48_META_API_1543_D: "operația de alimentare",
  T_48_META_API_1543_P0_D: "baza",
  T_48_META_API_1543_P1_D: "exponenți",
  T_48_META_API_1543_R_D: "rezultatul calculului",
  T_48_META_API_1544_D: "operație logaritmică",
  T_48_META_API_1544_P0_D: "baza",
  T_48_META_API_1544_P1_D: "logaritm",
  T_48_META_API_1544_R_D: "rezultatul calculului",
  T_48_META_API_1545_D: "Vectorul de direcție al unghiului Euler",
  T_48_META_API_1545_P0_D: "vectorul de direcție",
  T_48_META_API_1545_R_D: "Unghiul lui Euler",
  T_48_META_API_1546_D: "Vectorul direcției de virare a unghiului Euler",
  T_48_META_API_1546_P0_D: "Unghiul lui Euler",
  T_48_META_API_1546_R_D: "vectorul de direcție",
  T_48_META_API_1547_D: "număr întreg în număr cu virgulă mobilă",
  T_48_META_API_1547_P0_D: "număr întreg",
  T_48_META_API_1547_R_D: "punct flotant",
  T_48_META_API_1548_D: "Rotirea vectorului țintă în funcție de cuaternion",
  T_48_META_API_1548_P0_D: "vector țintă",
  T_48_META_API_1548_P1_D: "cuaternion rotativ",
  T_48_META_API_1548_R_D: "vector rotit",
  T_48_META_API_1549_D: "Conversia numărului țintă în șir de caractere",
  T_48_META_API_1549_P0_D: "Numărul de destinație al șirului care urmează să fie convertit",
  T_48_META_API_1549_P1_D: "Formatul șirului numeric de ieșire",
  T_48_META_API_1549_R_D: "string",
  T_48_META_API_1598_D: "Obțineți timestamp-ul serverului",
  T_48_META_API_1598_R_D: "Returnează numărul de secunde de la 0:0:0 pe 1 ianuarie 1970",
  T_48_META_API_1599_D: "Obțineți zona serverului",
  T_48_META_API_1599_R_D: "Înapoi la Abrevieri regionale (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Jurnale personalizate de îngropare a utilizatorilor pentru analiza datelor privind experiența utilizatorilor",
  T_48_META_API_16_P0_D: "Pentru a ține evidența jucătorilor raportați",
  T_48_META_API_16_P1_D: "Lista numelor de câmpuri care urmează să fie raportate",
  T_48_META_API_16_P2_D: "Lista valorilor câmpului care urmează să fie raportate",
  T_48_META_API_1601_D: "Crearea unui dicționar",
  T_48_META_API_1601_R_D: "Dicționar creat",
  T_48_META_API_1602_D: "Obține valoarea corespunzătoare cheii specificate în dicționar",
  T_48_META_API_1602_P0_D: "Dicționar țintă",
  T_48_META_API_1602_P1_D: "Cheie",
  T_48_META_API_1602_R_D: "Valoare",
  T_48_META_API_1603_D: "Setează valoarea corespunzătoare cheii specificate în dicționar",
  T_48_META_API_1603_P0_D: "Dicționar țintă",
  T_48_META_API_1603_P1_D: "Cheie",
  T_48_META_API_1603_P2_D: "Valoare",
  T_48_META_API_1604_D: "Îndepărtează perechea cheie-valoare specificată din dicționar",
  T_48_META_API_1604_P0_D: "Dicționar țintă",
  T_48_META_API_1604_P1_D: "Cheie",
  T_48_META_API_1605_D: "Șterge toate perechile cheie-valoare din dicționar",
  T_48_META_API_1605_P0_D: "Dicționar țintă",
  T_48_META_API_1606_D: "Obține numărul de perechi cheie-valoare din dicționar",
  T_48_META_API_1606_P0_D: "Dicționar țintă",
  T_48_META_API_1606_R_D: "Lungimea dicționarului",
  T_48_META_API_1607_D: "Determinați dacă o cheie există într-un dicționar",
  T_48_META_API_1607_P0_D: "Dicționar țintă",
  T_48_META_API_1607_P1_D: "Cheie",
  T_48_META_API_1607_R_D: "Există?",
  T_48_META_API_1608_D: "Obține toate cheile din dicționar și le returnează sub formă de listă.",
  T_48_META_API_1608_P0_D: "Dicționar țintă",
  T_48_META_API_1608_R_D: "Lista tuturor valorilor cheie",
  T_48_META_API_17_D: "Detectarea se realizează cu ajutorul unei zone în formă de cutie care se deplasează liniar, returnând de la aproape la departe toate entitățile întâlnite pe traseul zonei în formă de cutie, care inițial nu sunt detectate, adică nu sunt detectate dacă se a",
  T_48_META_API_17_P0_D: "Jumătate din lungimea celor trei laturi ale regiunii încadrate, sunt acceptate numai valori pozitive",
  T_48_META_API_17_P1_D: "Punctul central al zonei încadrate",
  T_48_META_API_17_P2_D: "Rotația zonei casetei",
  T_48_META_API_17_P3_D: "Direcția de deplasare în zona încadrată",
  T_48_META_API_17_P4_D: "Distanța parcursă în zona încadrată, sunt acceptate numai valori pozitive",
  T_48_META_API_17_P5_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_17_P6_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_17_P7_D: "Lista entităților afectate",
  T_48_META_API_1700_D: "Conversia unui șir de caractere într-un număr întreg",
  T_48_META_API_1700_P0_D: "șir țintă",
  T_48_META_API_1700_P1_D: "număr întreg rezultat",
  T_48_META_API_1700_P2_D: "Dacă conversia este reușită sau nu",
  T_48_META_API_1701_D: "Conversia unui șir de caractere într-un număr în virgulă mobilă",
  T_48_META_API_1701_P0_D: "șir țintă",
  T_48_META_API_1701_P1_D: "float rezultat",
  T_48_META_API_1701_P2_D: "Dacă conversia este reușită sau nu",
  T_48_META_API_18_D: "Detectarea se realizează utilizând o regiune sferică care se deplasează liniar, returnând de la aproape la departe toate entitățile întâlnite pe traseul regiunii sferice care se află inițial în interiorul regiunii sferice și nu sunt detectate.",
  T_48_META_API_18_P0_D: "Raza regiunii sferice, sunt acceptate numai valori pozitive",
  T_48_META_API_18_P1_D: "punctul central al zonei sferice",
  T_48_META_API_18_P2_D: "Direcția de deplasare în zona sferică",
  T_48_META_API_18_P3_D: "Distanța de deplasare a suprafeței sferice, sunt acceptate numai valori pozitive",
  T_48_META_API_18_P4_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_18_P5_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_18_P6_D: "Lista entităților afectate",
  T_48_META_API_19_D: "Detectarea se realizează utilizând o regiune de capsulă cu mișcare liniară, care returnează toate entitățile întâlnite de-a lungul traseului regiunii de capsulă, inițial în interiorul regiunii de capsulă, care nu sunt detectate, de la aproape la departe.",
  T_48_META_API_19_P0_D: "Raza emisferei la fiecare capăt al regiunii corpului capsulei, se acceptă numai valori pozitive",
  T_48_META_API_19_P1_D: "Distanța dintre centrele sferice ale emisferelor de la fiecare capăt al regiunii corpului capsulei, care trebuie să fie mai mare de două ori raza emisferelor de la fiecare capăt",
  T_48_META_API_19_P2_D: "Punctul central al regiunii corpului capsulei",
  T_48_META_API_19_P3_D: "Rotirea regiunii corpului capsulei",
  T_48_META_API_19_P4_D: "Direcția de deplasare în regiunea corpului capsulei",
  T_48_META_API_19_P5_D: "Distanța parcursă în zona capsulei, sunt acceptate doar valorile pozitive",
  T_48_META_API_19_P6_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_19_P7_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_19_P8_D: "Lista entităților afectate",
  T_48_META_API_2_D: "Obține toate echipele din jocul curent și returnează lista de echipe.",
  T_48_META_API_2_R_D: "Lista echipelor",
  T_48_META_API_20_D: "Utilizează o regiune de cutie staționară pentru detectare, returnând toate entitățile din regiunea de cutie",
  T_48_META_API_20_P0_D: "Jumătate din lungimea celor trei laturi ale regiunii încadrate, sunt acceptate numai valori pozitive",
  T_48_META_API_20_P1_D: "Punctul central al zonei încadrate",
  T_48_META_API_20_P2_D: "Rotația zonei casetei",
  T_48_META_API_20_P3_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_20_P4_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_20_P5_D: "Lista entităților afectate",
  T_48_META_API_2000_D: "Setarea valorii unui atribut al entității țintă necesită ca atributul să fi fost deja definit.",
  T_48_META_API_2000_P0_D: "entitate țintă",
  T_48_META_API_2000_P1_D: "Un atribut al entității țintă",
  T_48_META_API_2000_P2_D: "Valoarea țintă, care trebuie să corespundă tipului solicitat atunci când a fost definită proprietatea",
  T_48_META_API_2000_P3_D: "Toate tipurile suportă atribuirea, iar tipurile numerice suportă autoadăugarea, autominusul, automultiplicarea, autodivizarea și autoremanența.",
  T_48_META_API_2001_D: "Obținerea valorii unui atribut al unei entități",
  T_48_META_API_2001_P0_D: "entitate țintă",
  T_48_META_API_2001_P1_D: "ID-ul unui atribut al acestei entități",
  T_48_META_API_2001_R_D: "valoarea unui atribut",
  T_48_META_API_2002: "Set Graph Property",
  T_48_META_API_2002_D: "Setarea variabilelor de script",
  T_48_META_API_2002_P0_D: "entitate țintă",
  T_48_META_API_2002_P1: "Graph ID",
  T_48_META_API_2002_P1_D: "ID-ul scriptului țintă",
  T_48_META_API_2002_P2: "Property ID",
  T_48_META_API_2002_P2_D: "ID-ul proprietății membre definite în script",
  T_48_META_API_2002_P3: "Property Value",
  T_48_META_API_2002_P3_D: "Valoarea țintă, care trebuie să corespundă tipului solicitat atunci când a fost definită proprietatea",
  T_48_META_API_2002_P4_D: "Toate tipurile suportă atribuirea, iar tipurile numerice suportă autoadăugarea, autominusul, automultiplicarea, autodivizarea și autoremanența.",
  T_48_META_API_2003: "Get Graph Property",
  T_48_META_API_2003_D: "Obținerea variabilelor de script",
  T_48_META_API_2003_P0_D: "entitate țintă",
  T_48_META_API_2003_P1: "Graph ID",
  T_48_META_API_2003_P1_D: "ID-ul scriptului țintă",
  T_48_META_API_2003_P2: "Property ID",
  T_48_META_API_2003_P2_D: "ID atribut țintă",
  T_48_META_API_2003_R_D: "valoarea unui atribut",
  T_48_META_API_2004_D: "Definiți și inițializați o variabilă locală, care are domeniul de aplicare de la poziția de declarare până la sfârșitul blocului de instrucțiuni în care este localizată.",
  T_48_META_API_2004_P0_D: "numele variabilei",
  T_48_META_API_2004_P1_D: "valoarea inițială a variabilei",
  T_48_META_API_2004_P2_D: "Tipul declarației variabilei, atribuirea trebuie să corespundă tipului declarat",
  T_48_META_API_2005_D: "Setează valoarea unei variabile locale, care are un domeniu de aplicare de la poziția de declarare până la sfârșitul blocului de instrucțiuni în care este localizată.",
  T_48_META_API_2005_P0_D: "numele variabilei",
  T_48_META_API_2005_P1: "Variable Value",
  T_48_META_API_2005_P1_D: "valoare variabilă",
  T_48_META_API_2005_P2_D: "Toate tipurile suportă atribuirea, iar tipurile numerice suportă autoadăugarea, autominusul, automultiplicarea, autodivizarea și autoremanența.",
  T_48_META_API_2006: "Get Local Variable",
  T_48_META_API_2006_D: "Obțineți valoarea unei variabile locale, care este delimitată de la poziția declarației până la sfârșitul blocului de instrucțiuni.",
  T_48_META_API_2006_P0: "Variable Name",
  T_48_META_API_2006_P0_D: "numele variabilei",
  T_48_META_API_2006_R_D: "valoare variabilă",
  T_48_META_API_2009: "Find and Invoke Global Custom API with Serial",
  T_48_META_API_2009_D: "apelează funcții personalizate globale în mod serial, iar dacă există o așteptare în funcția personalizată, locația apelului așteaptă și ea",
  T_48_META_API_2009_P0: "Graph ID",
  T_48_META_API_2009_P0_D: "Script ID al scriptului în care se află funcția personalizată",
  T_48_META_API_2009_P1: "Function ID",
  T_48_META_API_2009_P1_D: "ID-ul funcției personalizate numite",
  T_48_META_API_2009_P2_D: "Lista de argumente transmise funcției personalizate",
  T_48_META_API_2010: "Find and Invoke Global Custom API with Parallel",
  T_48_META_API_2010_D: "apelează funcții personalizate globale în mod paralel, revenind imediat la locul apelului pentru a continua linia, indiferent dacă există sau nu o așteptare în funcția personalizată",
  T_48_META_API_2010_P0: "Graph ID",
  T_48_META_API_2010_P0_D: "Script ID al scriptului în care se află funcția personalizată",
  T_48_META_API_2010_P1: "Function ID",
  T_48_META_API_2010_P1_D: "ID-ul funcției personalizate numite",
  T_48_META_API_2010_P2_D: "Lista de argumente transmise funcției personalizate",
  T_48_META_API_2013: "Set Self Graph Property",
  T_48_META_API_2013_D: "Setarea variabilelor pentru scriptul curent",
  T_48_META_API_2013_P0: "Property ID",
  T_48_META_API_2013_P0_D: "ID atribut țintă",
  T_48_META_API_2013_P1: "Property Value",
  T_48_META_API_2013_P1_D: "valoarea țintă",
  T_48_META_API_2013_P2_D: "Toate tipurile suportă atribuirea, iar tipurile numerice suportă autoadăugarea, autominusul, automultiplicarea, autodivizarea și autoremanența.",
  T_48_META_API_2014: "Get Self Graph Property",
  T_48_META_API_2014_D: "Obținerea variabilelor pentru scriptul curent",
  T_48_META_API_2014_P0: "Property ID",
  T_48_META_API_2014_P0_D: "ID atribut țintă",
  T_48_META_API_2014_R_D: "valoarea unui atribut",
  T_48_META_API_21_D: "Utilizează o regiune sferică staționară pentru detectare, returnează toate entitățile din regiunea sferică",
  T_48_META_API_21_P0_D: "Raza regiunii sferice, sunt acceptate numai valori pozitive",
  T_48_META_API_21_P1_D: "punctul central al zonei sferice",
  T_48_META_API_21_P2_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_21_P3_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_21_P4_D: "Lista entităților afectate",
  T_48_META_API_22_D: "Detectarea folosind o regiune staționară a corpului capsulei, returnarea tuturor entităților din regiunea corpului capsulei",
  T_48_META_API_22_P0_D: "Raza emisferei la fiecare capăt al regiunii corpului capsulei, se acceptă numai valori pozitive",
  T_48_META_API_22_P1_D: "Distanța dintre centrele sferice ale emisferelor de la fiecare capăt al regiunii corpului capsulei, care trebuie să fie mai mare de două ori raza emisferelor de la fiecare capăt",
  T_48_META_API_22_P2_D: "Punctul central al regiunii corpului capsulei",
  T_48_META_API_22_P3_D: "Rotirea regiunii corpului capsulei",
  T_48_META_API_22_P4_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_22_P5_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_22_P6_D: "Lista entităților afectate",
  T_48_META_API_23_D: "Setează statutul de obiect special pentru jucător, obiectele speciale pot avea doar unul",
  T_48_META_API_23_P0_D: "jucător",
  T_48_META_API_23_P1_D: "ID articol",
  T_48_META_API_23_P2_D: "Dacă să activați elementul",
  T_48_META_API_23_P3_D: "substanță specială",
  T_48_META_API_24_D: "Aplicați o forță asupra țintei, care trebuie să fie un obiect fizic.",
  T_48_META_API_24_P0_D: "obiect fizic țintă",
  T_48_META_API_24_P1_D: "vectorul forță",
  T_48_META_API_24_P2_D: "Tip de forță",
  T_48_META_API_25_D: "Aplicați o forță o dată într-un punct, ținta trebuie să fie un corp rigid",
  T_48_META_API_25_P0_D: "corp rigid țintă",
  T_48_META_API_25_P1_D: "vectorul forță",
  T_48_META_API_25_P2_D: "Poziția de aplicare a forței",
  T_48_META_API_25_P3_D: "Tip de forță",
  T_48_META_API_26_D: "Aplicați un cuplu asupra țintei, care trebuie să fie rigidă.",
  T_48_META_API_26_P0_D: "corp rigid țintă",
  T_48_META_API_26_P1_D: "torsiune",
  T_48_META_API_26_P2_D: "Tipul de forță aplicată",
  T_48_META_API_27_D: "Mută corpul rigid țintă în poziția specificată",
  T_48_META_API_27_P0_D: "corp rigid țintă",
  T_48_META_API_27_P1_D: "locație desemnată",
  T_48_META_API_28_D: "Rotiți corpul rigid țintă",
  T_48_META_API_28_P0_D: "corp rigid țintă",
  T_48_META_API_28_P1_D: "cuaternion rotativ",
  T_48_META_API_29_D: "Creează o mișcare interpolată în care proprietățile specificate ale entității țintă sunt netezite în conformitate cu setările.",
  T_48_META_API_29_P0_D: "entitate țintă",
  T_48_META_API_29_P1_D: "ID-uri de atribute care necesită modificări ale mișcării",
  T_48_META_API_29_P2_D: "Valoarea inițială a atributului",
  T_48_META_API_29_P3_D: "Valoarea finală a atributului",
  T_48_META_API_29_P4_D: `Se pot selecta variantele Single, Loop și Reciprocal. 
Ciclic înseamnă că, după finalizarea fiecărei mișcări, entitatea se va deplasa din nou de la valoarea de pornire. Reciproc înseamnă că, după finalizarea mișcării de la valoarea de pornire la valoare`,
  T_48_META_API_29_P5_D: "Punctul de control al curbei Bessel",
  T_48_META_API_29_P6_D: "Durata unei modificări în milisecunde",
  T_48_META_API_29_P7_D: "Entități de mișcare interpolate create",
  T_48_META_API_29_P8_D: "Dacă redarea începe automat după creare",
  T_48_META_API_3_D: "Comutarea jocului la faza țintă, rândul este, de asemenea, o fază specială. La trecerea la o fază într-o rundă, numărul de runde este 0.",
  T_48_META_API_3_P0_D: "Indicele rundei sau al fazei țintă",
  T_48_META_API_30_D: "Forțează jucătorul țintă să intre în vehiculul specificat",
  T_48_META_API_30_P0_D: "jucător țintă",
  T_48_META_API_30_P1_D: "entitatea transportatoare",
  T_48_META_API_30_P2_D: "Numărul locului",
  T_48_META_API_30_P3_D: "Indiferent dacă reușește sau nu să introducă jucătorul în purtător",
  T_48_META_API_3001_D: "Faceți jucătorul țintă să renunțe la un obiect",
  T_48_META_API_3001_P0_D: "jucător țintă",
  T_48_META_API_3001_P1_D: "entitate fizică",
  T_48_META_API_3002_D: "Obține coordonatele disponibile în punctul de naștere aleatoriu disponibil în prezent care nu este complet ocupat (depreciat, vă rugăm să utilizați GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "Jucători cărora trebuie să li se atribuie o zonă a punctului de naștere",
  T_48_META_API_3002_R_D: "Coordonate aleatorii ale punctelor atribuite aleatoriu",
  T_48_META_API_3003_D: "Obține scorul total al jucătorului pentru tipul de punct specificat",
  T_48_META_API_3003_P0_D: "jucător",
  T_48_META_API_3003_P1_D: "Tip de puncte",
  T_48_META_API_3003_R_D: "valoarea punctului",
  T_48_META_API_3004_D: "Setarea scorului rundei pentru tipul de punct specificat al unui jucător",
  T_48_META_API_3004_P0_D: "entitate jucător",
  T_48_META_API_3004_P1_D: "Tip de puncte",
  T_48_META_API_3004_P2_D: "valoarea punctului",
  T_48_META_API_3005_D: "Obține scorul total al echipei pentru tipul de punct specificat",
  T_48_META_API_3005_P0_D: "entitate de echipă",
  T_48_META_API_3005_P1_D: "Tip de puncte",
  T_48_META_API_3005_R_D: "valoarea punctului",
  T_48_META_API_3006_D: "Stabilirea scorului rundei pentru tipul de punct specificat de o echipă",
  T_48_META_API_3006_P0_D: "entitate de echipă",
  T_48_META_API_3006_P1_D: "Tip de puncte",
  T_48_META_API_3006_P2_D: "valoarea punctului",
  T_48_META_API_3007_D: "Obține scorul jucătorului pentru runda și tipul de punct specificate",
  T_48_META_API_3007_P0_D: "entitate jucător",
  T_48_META_API_3007_P1_D: "Index rotund",
  T_48_META_API_3007_P2_D: "Tip de puncte",
  T_48_META_API_3007_R_D: "valoarea punctului",
  T_48_META_API_3008_D: "Obțineți scorul echipei pentru runda specificată, tipul de punct",
  T_48_META_API_3008_P0_D: "entitate de echipă",
  T_48_META_API_3008_P1_D: "Index rotund",
  T_48_META_API_3008_P2_D: "Tip de puncte",
  T_48_META_API_3008_R_D: "valoarea punctului",
  T_48_META_API_3009_D: "Obțineți clasamentul general al jucătorului în joc",
  T_48_META_API_3009_P0_D: "entitate jucător",
  T_48_META_API_3009_R_D: "poziția într-un clasament al numelor",
  T_48_META_API_3011_D: "Obțineți clasamentul general al jocului echipei",
  T_48_META_API_3011_P0_D: "abandonate",
  T_48_META_API_3011_R_D: "poziția într-un clasament al numelor",
  T_48_META_API_3013_D: "Obțineți clasamentul jucătorului pentru o anumită rundă",
  T_48_META_API_3013_P0_D: "entitate jucător",
  T_48_META_API_3013_P1_D: "Index rotund",
  T_48_META_API_3013_R_D: "poziția într-un clasament al numelor",
  T_48_META_API_3014_D: "Obțineți clasamentul echipelor pentru o anumită rundă",
  T_48_META_API_3014_P0_D: "abandonate",
  T_48_META_API_3014_P1_D: "Index rotund",
  T_48_META_API_3014_R_D: "poziția într-un clasament al numelor",
  T_48_META_API_3015_D: "Obțineți portofelul entității țintă",
  T_48_META_API_3015_P0_D: "entitate țintă",
  T_48_META_API_3015_P1_D: "Prezența unui portofel",
  T_48_META_API_3015_P2_D: "Entități de portofel achiziționate",
  T_48_META_API_3016_D: "Creează un portofel pentru jucătorul țintă, nu este valabil dacă jucătorul are deja un portofel.",
  T_48_META_API_3016_P0_D: "jucător țintă",
  T_48_META_API_3016_P1_D: "Entitate legată de portofel, proprietarul portofelului",
  T_48_META_API_3016_P2_D: "entitate portofel",
  T_48_META_API_3017_D: "Adăugați valută la un anumit portofel",
  T_48_META_API_3017_P0_D: "Portofel țintă",
  T_48_META_API_3017_P1_D: "Tipul de monedă adăugată",
  T_48_META_API_3017_P2_D: "Creșterea numărului de monede",
  T_48_META_API_3018_D: "Reducerea monedei pentru un anumit portofel",
  T_48_META_API_3018_P0_D: "Portofel țintă",
  T_48_META_API_3018_P1_D: "Tip redus de monedă",
  T_48_META_API_3018_P2_D: "Număr redus de monede",
  T_48_META_API_3019_D: "Transferul de valută de la un portofel la un alt portofel",
  T_48_META_API_3019_P0_D: "Portofele pentru transferul de valute",
  T_48_META_API_3019_P1_D: "Tipuri de bani transferați",
  T_48_META_API_3019_P2_D: "Numărul de valute transferate",
  T_48_META_API_3019_P3_D: "Portofelul în care este transferată moneda",
  T_48_META_API_3020_D: "Obțineți numărul de monede de un anumit tip într-un anumit portofel",
  T_48_META_API_3020_P0_D: "Portofel țintă",
  T_48_META_API_3020_P1_D: "Tipul de monedă al întrebării",
  T_48_META_API_3020_R_D: "Valoarea monedei",
  T_48_META_API_3021_D: "Obține entitățile din tipul specificat de monedă în portofelul specificat",
  T_48_META_API_3021_P0_D: "Portofel țintă",
  T_48_META_API_3021_P1_D: "Tipul de monedă al întrebării",
  T_48_META_API_3021_R_D: "Entități monetare",
  T_48_META_API_3022_D: "Obține toate magazinele din joc, le returnează sub formă de listă",
  T_48_META_API_3022_R_D: "Lista entităților magazinului",
  T_48_META_API_3023_D: "Înlocuiește forma jucătorului țintă cu forma unui obiect de scenă specificat.",
  T_48_META_API_3023_P0_D: "jucător țintă",
  T_48_META_API_3023_P1_D: "Obiecte de scenă țintă pentru înlocuire",
  T_48_META_API_3023_P2_D: "Înlocuirea componentei de camuflaj a transformării jucătorului creată după",
  T_48_META_API_3024_D: "Anulează starea de camuflaj a jucătorului",
  T_48_META_API_3024_P0_D: "jucător țintă",
  T_48_META_API_3025_D: "Creați un alter ego sub forma unei entități de scenă la jucătorul țintă",
  T_48_META_API_3025_P0_D: "jucător țintă",
  T_48_META_API_3025_P1_D: "Entități de scenă pentru imagini divizate",
  T_48_META_API_3025_P2_D: "Entități de bilocație create",
  T_48_META_API_3026_D: "Obținerea entității camuflate a jucătorului",
  T_48_META_API_3026_P0_D: "jucător",
  T_48_META_API_3026_R_D: "Entitate deghizare jucător",
  T_48_META_API_3027_D: "Obțineți entitatea canalului de chat după index",
  T_48_META_API_3027_P0_D: "Indicele canalului de chat, interval [1,8]",
  T_48_META_API_3027_R_D: "Entități ale canalului de chat",
  T_48_META_API_3028_D: "Obține entitatea canalului de chat în care se află în prezent jucătorul specificat",
  T_48_META_API_3028_P0_D: "jucător țintă",
  T_48_META_API_3028_R_D: "Entități ale canalului de chat",
  T_48_META_API_3029_D: "Permite jucătorilor să se alăture canalului de chat desemnat și să treacă la canalul țintă atunci când jucătorii sunt deja în alte canale de chat.",
  T_48_META_API_3029_P0_D: "jucător țintă",
  T_48_META_API_3029_P1_D: "Entități ale canalului de chat",
  T_48_META_API_3030_D: "Face ca jucătorul să iasă de pe canalul în care se află în prezent și se află într-o stare în care nu se mai află în niciun canal de chat după aceea",
  T_48_META_API_3030_P0_D: "jucător țintă",
  T_48_META_API_3031_D: "abandonate",
  T_48_META_API_3031_P0_D: "Entitatea canalului de chat, goală atunci când nu există niciun jucător în canal",
  T_48_META_API_3032_D: "Setarea stării comportamentale a jucătorului",
  T_48_META_API_3032_P0_D: "jucător țintă",
  T_48_META_API_3032_P1_D: "Tipuri de comportament al jucătorilor",
  T_48_META_API_3032_P2_D: "Activat: butonul HUD este disponibil, utilizabil în mod normal Dezactivat: butonul HUD este dezactivat, nu poate accesa starea comportamentală activ sau pasiv Mascat: butonul HUD este ascuns, nu poate accesa starea comportamentală activ, dar poate accesa ",
  T_48_META_API_3033_D: "Jucătorul se transformă într-un obiect într-o scenă dată",
  T_48_META_API_3033_P0_D: "jucător țintă",
  T_48_META_API_3033_P1_D: "pentru a fi transformat în",
  T_48_META_API_3033_P2_D: "Entități create după transformare",
  T_48_META_API_3034_D: "Jucătorul creează un alter ego al propriului aspect",
  T_48_META_API_3034_P0_D: "jucător țintă",
  T_48_META_API_3034_P1_D: "Entități alter ego create",
  T_48_META_API_3035_D: "Creați un magazin personalizat cu rafturi ca nivel următor al magazinului",
  T_48_META_API_3035_P0_D: "Entități de magazin create",
  T_48_META_API_3036_D: "Creați un raft personalizat în care nivelul superior al raftului este magazinul, iar nivelul inferior este produsele",
  T_48_META_API_3036_P0_D: "Entități de raft create",
  T_48_META_API_3037_D: "Creați un produs personalizat, produsul poate adăuga articole",
  T_48_META_API_3037_P0_D: "Entități de mărfuri create",
  T_48_META_API_3038_D: "Adăugarea de articole la un produs vă permite să adăugați mai multe articole la un produs prin utilizarea elementului de mai multe ori.",
  T_48_META_API_3038_P0_D: "Entități de mărfuri",
  T_48_META_API_3038_P1_D: "Elemente care urmează să fie adăugate",
  T_48_META_API_3038_P2_D: "Număr de articole",
  T_48_META_API_3039_D: "Oferirea de recompense Jailbreak",
  T_48_META_API_3039_P0_D: "entitate jucător",
  T_48_META_API_3039_P1_D: "cantități",
  T_48_META_API_3039_P2_D: "bani reali",
  T_48_META_API_3040_D: "Sarcini actualizate pentru jailbreak",
  T_48_META_API_3040_P0_D: "entitate jucător",
  T_48_META_API_3040_P1_D: "ID sarcină",
  T_48_META_API_3040_P2_D: "să fie de serviciu",
  T_48_META_API_3041_D: "Obține coordonatele unui punct de naștere aleatoriu, numai din punctele de naștere disponibile care nu sunt complet ocupate.",
  T_48_META_API_3041_P0_D: "jucător țintă",
  T_48_META_API_3041_R_D: "Randomizează coordonatele punctului de naștere; dacă nu există niciun punct de naștere care să corespundă criteriilor, se va returna o locație apropiată de (0, 0, 0).",
  T_48_META_API_3042_D: "Ieși Jailbreak joc",
  T_48_META_API_3042_P0_D: "entitate jucător",
  T_48_META_API_3042_P1_D: "ID sarcină",
  T_48_META_API_3043_D: "Bazat pe props jailbreak",
  T_48_META_API_3043_P0_D: "entitate jucător",
  T_48_META_API_3043_P1_D: "Tip de recuzită",
  T_48_META_API_3043_P2_D: "ID recuzită",
  T_48_META_API_31_D: "Creează o mișcare relativă la sine, în care entitatea țintă se modifică de fiecare dată în funcție de valorile actuale ale atributelor sale",
  T_48_META_API_31_P0_D: "entitate țintă",
  T_48_META_API_31_P1_D: "Proprietăți care necesită modificări ale mișcării",
  T_48_META_API_31_P2_D: "Cantitatea de schimbare per mișcare",
  T_48_META_API_31_P3_D: "Punctul de control al curbei Bessel",
  T_48_META_API_31_P4_D: `Simplu: mișcarea se oprește atunci când atributul se modifică cu o valoare Delta 
 Ciclic: mișcarea se repetă, de fiecare dată când atributul se modifică cu o valoare Delta`,
  T_48_META_API_31_P5_D: "Durata unei modificări în milisecunde",
  T_48_META_API_31_P6_D: "Entități create care se mișcă relativ la ele însele",
  T_48_META_API_31_P7_D: "Dacă redarea începe automat după creare",
  T_48_META_API_3100_D: "Ținta redă animația în starea specificată",
  T_48_META_API_3100_P0_D: "Componente de entitate care redau animații cu controlori de animație montabili",
  T_48_META_API_3100_P1_D: "Starea specificată a controlerului de animație",
  T_48_META_API_3100_P2_D: "Scalarea vitezei de redare a animației",
  T_48_META_API_3100_P3_D: "Tip buclă, puteți păstra logica originală a animației, să o redați o singură dată sau să o buclă.",
  T_48_META_API_3101_D: "Joacă animația personajului, suportă resurse de animație personalizate",
  T_48_META_API_3101_P0_D: "jucător țintă",
  T_48_META_API_3101_P1_D: "ID personalizat al resursei de animație",
  T_48_META_API_3101_P2_D: "Dacă să se facă o buclă sau nu",
  T_48_META_API_3102_D: "Setarea resurselor personajului pentru un anumit jucător",
  T_48_META_API_3102_P0_D: "jucător țintă",
  T_48_META_API_3102_P1_D: "Rol personalizat ID resursă",
  T_48_META_API_3109_D: "Pornirea va ușura mișcarea până la sfârșitul zonei de siguranță",
  T_48_META_API_3109_P0_D: "Poziția inițială a zonei de securitate",
  T_48_META_API_3109_P1_D: "Amplasarea capătului zonei de securitate",
  T_48_META_API_3109_P2_D: "Raza inițială a zonei de siguranță",
  T_48_META_API_3109_P3_D: "Raza finală a zonei de siguranță",
  T_48_META_API_3109_P4_D: "Timpul în secunde pentru ca zona de siguranță să ajungă la starea sa finală",
  T_48_META_API_3109_P5_D: "Cantitatea de daune pe secundă suferită în afara zonei de siguranță",
  T_48_META_API_3110_D: "Comutarea grupurilor de apariție a caracterelor",
  T_48_META_API_3110_P0_D: "obiective",
  T_48_META_API_3110_P1_D: "Grupul de înfățișare",
  T_48_META_API_3111_D: "Afișare Rol Apariție Grup",
  T_48_META_API_3111_P0_D: "obiective",
  T_48_META_API_3111_P1_D: "Grupul de înfățișare",
  T_48_META_API_3112_D: "Grup de apariție a caracterelor ascunse",
  T_48_META_API_3112_P0_D: "obiective",
  T_48_META_API_3112_P1_D: "Grupul de înfățișare",
  T_48_META_API_3121_D: "Trimiterea rezultatelor certificării către Craftland Studio PC pentru utilizare statistică",
  T_48_META_API_3121_P0_D: "expresia aserțiunii",
  T_48_META_API_3121_P1_D: "a atrage atenția asupra a ceva",
  T_48_META_API_32_D: "Obțineți datele despre jetonul de astăzi al jucătorului",
  T_48_META_API_32_P0_D: "jucător țintă",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Număr de jetoane",
  T_48_META_API_32_P3_D: "Dacă tuple-ul a fost invocat cu succes sau nu",
  T_48_META_API_3200_D: "Adaugă elemente la player și returnează o listă a elementelor emise",
  T_48_META_API_3200_P0_D: "jucător",
  T_48_META_API_3200_P1_D: "ID articol",
  T_48_META_API_3200_P2_D: "Număr de articole",
  T_48_META_API_3200_P3_D: "O listă de elemente adăugate pentru jucător, chiar dacă este adăugat un singur element, acesta este returnat ca o listă.",
  T_48_META_API_3201_D: "Restituie sângele jucătorului desemnat fără a depăși limita de sânge",
  T_48_META_API_3201_P0_D: "jucător țintă",
  T_48_META_API_3201_P1_D: "O valoare care adaugă sânge jucătorului, sunt acceptate numai numere pozitive",
  T_48_META_API_3202_D: "Setarea listei de abilități a jucătorului țintă",
  T_48_META_API_3202_P0_D: "jucător țintă",
  T_48_META_API_3202_P1_D: "Lista de competențe",
  T_48_META_API_3203_D: "Obțineți o listă a abilităților jucătorului țintă",
  T_48_META_API_3203_P0_D: "jucător țintă",
  T_48_META_API_3203_R_D: "Lista de competențe",
  T_48_META_API_3205_D: "Ștergeți un anumit număr de elemente din jucător",
  T_48_META_API_3205_P0_D: "jucător țintă",
  T_48_META_API_3205_P1_D: "Tipul de element care urmează să fie șters",
  T_48_META_API_3205_P2_D: "Numărul de elemente care urmează să fie șterse, dacă depășește numărul deținut de jucător, atunci vor fi șterse numai elementele deținute",
  T_48_META_API_3206_D: "Obține numărul specificat de obiecte deținute de un jucător",
  T_48_META_API_3206_P0_D: "jucător țintă",
  T_48_META_API_3206_P1_D: "Tip de articol",
  T_48_META_API_3206_R_D: "Numărul de exploatații ale jucătorilor",
  T_48_META_API_3207_D: "Detectă dacă jucătorul poate declanșa punctul de control curent",
  T_48_META_API_3207_P0_D: "jucător țintă",
  T_48_META_API_3207_P1_D: "Declanșator",
  T_48_META_API_3207_R_D: "Adevărat: poate fi declanșat, Fals: nu poate fi declanșat",
  T_48_META_API_3208_D: "Modul infecție Zombie Evolution",
  T_48_META_API_3208_P0_D: "jucător țintă",
  T_48_META_API_3209_D: "Entitatea AI oprește/aplică arborele comportamentului implicit",
  T_48_META_API_3209_P0_D: "Pentru a permite atingerea obiectivului arborelui comportamental",
  T_48_META_API_3209_P1_D: "Dacă să se implementeze arborele comportamentului implicit",
  T_48_META_API_3210_D: "Entitate AI care urmărește o țintă desemnată",
  T_48_META_API_3210_P0_D: "Entități AI care efectuează urmărirea",
  T_48_META_API_3210_P1_D: "țintă",
  T_48_META_API_3211_D: "Distruge obiectele jucătorului (depreciat, utilizați DeleteEquipment)",
  T_48_META_API_3211_P0_D: "Jucătorul al cărui obiect a fost distrus",
  T_48_META_API_3211_P1_D: "Tipul de element distrus",
  T_48_META_API_3211_P2_D: "Slot pentru armă, numai pentru armă.",
  T_48_META_API_3212_D: "Schimbarea tricourilor",
  T_48_META_API_3212_P0_D: "jucător țintă",
  T_48_META_API_3212_P1_D: "Stil de îmbrăcăminte",
  T_48_META_API_3212_P2_D: "Culori principale I",
  T_48_META_API_3212_P3_D: "Culoare principală II",
  T_48_META_API_3212_P4_D: "configurați",
  T_48_META_API_3213_D: "Restaurați tricoul jucătorului la starea sa inițială",
  T_48_META_API_3213_P0_D: "jucător țintă",
  T_48_META_API_3214_D: "Switch Player Voice Chat",
  T_48_META_API_3214_P0_D: "jucător țintă",
  T_48_META_API_3214_P1_D: "Dacă să închideți chat-ul vocal, Adevărat:Închis Fals:Deschis",
  T_48_META_API_3215_D: "Schimbare jucător Chat rapid",
  T_48_META_API_3215_P0_D: "jucător țintă",
  T_48_META_API_3215_P1_D: "Dacă să închideți chat-ul rapid, Adevărat:Închis Fals:Deschis",
  T_48_META_API_3216_D: "Setează dacă jucătorul țintă poate ridica obiecte",
  T_48_META_API_3216_P0_D: "jucător țintă",
  T_48_META_API_3216_P1_D: "Dacă este interzisă sau nu ridicarea obiectelor, true: ridicarea este interzisă false: ridicarea este permisă",
  T_48_META_API_3217_D: "Setează dacă jucătorul țintă poate renunța la obiecte",
  T_48_META_API_3217_P0_D: "jucător țintă",
  T_48_META_API_3217_P1_D: "Dacă este interzisă sau nu aruncarea obiectelor, true: ridicarea este interzisă false: ridicarea este posibilă",
  T_48_META_API_3218_D: "Distruge o armă în locașul desemnat de jucător",
  T_48_META_API_3218_P0_D: "jucător țintă",
  T_48_META_API_3218_P1_D: "Sloturi pentru arme care urmează să fie distruse",
  T_48_META_API_3218_P2_D: "Numărul care urmează să fie distrus",
  T_48_META_API_3218_P3_D: "Distrugere reușită sau nu, distrugerea eșuează dacă nicio armă nu este echipată în locașul armei",
  T_48_META_API_3219_D: "Goliți rucsacul jucătorului țintă de toate obiectele, inclusiv obiectele echipate.",
  T_48_META_API_3219_P0_D: "jucător țintă",
  T_48_META_API_3220_D: "Setarea orientării jucătorului",
  T_48_META_API_3220_P0_D: "jucător țintă",
  T_48_META_API_3220_P1_D: "Orientarea jucătorului",
  T_48_META_API_3221_D: "<Player>(depreciat, a nu se utiliza, a se vedea atributul :Skeleton pentru informații)",
  T_48_META_API_3221_P0_D: "entitate jucător",
  T_48_META_API_3221_P1_D: "zona de zoom",
  T_48_META_API_3221_P2_D: "Valoarea zoom-ului",
  T_48_META_API_3222_D: "Acordați unui jucător un efect de repulsie, jucătorul țintă va cădea cu o accelerație fixă și efectul de repulsie va fi oprit forțat la coliziunea în aer",
  T_48_META_API_3222_P0_D: "jucător țintă",
  T_48_META_API_3222_P1_D: "Direcția Knockout",
  T_48_META_API_3222_P2_D: "timp de fugă de la locul accidentului",
  T_48_META_API_3222_P3_D: "Viteza inițială a axei Y la impact",
  T_48_META_API_3222_P4_D: "Viteza inițială în planul XZ la impact",
  T_48_META_API_3222_P5_D: "Dacă să se schimbe orientarea jucătorului",
  T_48_META_API_3223_D: "Obțineți ID-ul costumului jucătorului sau NPC-ului țintă",
  T_48_META_API_3223_P0_D: "Jucător țintă sau NPC",
  T_48_META_API_3223_P1_D: "Tip de îmbrăcăminte",
  T_48_META_API_3223_R_D: "ID îmbrăcăminte",
  T_48_META_API_3224_D: "Setarea ID-ului costumului jucătorului sau NPC-ului țintă",
  T_48_META_API_3224_P0_D: "Jucător țintă sau NPC",
  T_48_META_API_3224_P1_D: "ID îmbrăcăminte",
  T_48_META_API_3225_D: "Restabilește îmbrăcămintea implicită a jucătorului țintă, nu poate fi aplicată NPC-urilor.",
  T_48_META_API_3225_P0_D: "jucător țintă",
  T_48_META_API_3226_D: "Atacuri ale entităților AI Țintă desemnată",
  T_48_META_API_3226_P0_D: "Entitatea AI care efectuează atacul",
  T_48_META_API_3226_P1_D: "țintă",
  T_48_META_API_3227_D: "Schimbă arma jucătorului cu arma din slotul specificat",
  T_48_META_API_3227_P0_D: "jucător țintă",
  T_48_META_API_3227_P1_D: "Slotul de armă care urmează să fie schimbat",
  T_48_META_API_3227_P2_D: "Indiferent dacă schimbarea este reușită sau nu, schimbarea va eșua dacă nu există nicio armă echipată în locașul pentru arme.",
  T_48_META_API_3228_D: "Obțineți skin-uri de arme pentru jucători sau NPC-uri țintă",
  T_48_META_API_3228_P0_D: "Jucător țintă sau NPC",
  T_48_META_API_3228_P1_D: "ID piele armă",
  T_48_META_API_3228_R_D: "ID piele armă",
  T_48_META_API_3229_D: "Setarea skin-ului armei jucătorului sau NPC-ului țintă",
  T_48_META_API_3229_P0_D: "Jucător țintă sau NPC",
  T_48_META_API_3229_P1_D: "ID piele armă",
  T_48_META_API_3230_D: "Restaurează skin-ul implicit al armei jucătorului țintă, care nu poate fi aplicat NPC-urilor.",
  T_48_META_API_3230_P0_D: "jucător țintă",
  T_48_META_API_3230_P1_D: "ID armă",
  T_48_META_API_3231_D: "Configurarea costumului jucătorului",
  T_48_META_API_3231_P0_D: "jucător țintă",
  T_48_META_API_3231_P1_D: "Lista de îmbrăcăminte",
  T_48_META_API_3232_D: "Îndepărtează toate costumele de tipul specificat de la jucătorul sau NPC-ul țintă",
  T_48_META_API_3232_P0_D: "Jucător țintă sau NPC",
  T_48_META_API_3232_P1_D: "Tip de îmbrăcăminte",
  T_48_META_API_3233_D: "Îndepărtați pielea armei desemnate a unui jucător sau a unui NPC",
  T_48_META_API_3233_P0_D: "Jucător țintă sau NPC",
  T_48_META_API_3233_P1_D: "ID armă",
  T_48_META_API_3234_D: "Adaugă buffs la țintă",
  T_48_META_API_3234_P0_D: "Entitatea țintă, trebuie să fie o entitate la care se pot adăuga buffs",
  T_48_META_API_3234_P1_D: "Buff id",
  T_48_META_API_3235_D: "Îndepărtează buffs de la țintă",
  T_48_META_API_3235_P0_D: "Entitatea țintă, trebuie să fie o entitate la care se pot adăuga buffs",
  T_48_META_API_3235_P1_D: "Buff id",
  T_48_META_API_3236_D: "Obține buff-ul curent al țintei",
  T_48_META_API_3236_P0_D: "Entitatea țintă, trebuie să fie o entitate la care se pot adăuga buffs",
  T_48_META_API_3236_R_D: "Lista Buff",
  T_48_META_API_3237_D: "Obține obiectele din bara de recuzită din rucsacul jucătorului țintă.",
  T_48_META_API_3237_P0_D: "jucător țintă",
  T_48_META_API_3237_P1_D: "Lista de recuzită",
  T_48_META_API_3238_D: "Adaugă accesorii în locașul specificat al armei, accesoriile care nu se potrivesc cu locașul vor eșua; accesoriile potrivite, dar duplicate, vor înlocui accesoriile originale, accesoriile originale vor fi trimise în rucsacul jucătorului, iar când rucsacul",
  T_48_META_API_3238_P0_D: "jucător țintă",
  T_48_META_API_3238_P1_D: "echipament bar slot",
  T_48_META_API_3238_P2_D: "înlocuire (piese)",
  T_48_META_API_3238_P3_D: `Dacă accesoriul a fost sau nu adăugat cu succes
 Adevărat: accesoriul a fost echipat cu arma în slotul corespunzător
 Fals: accesoriul nu a reușit să fie adăugat și nu va apărea în rucsacul jucătorului`,
  T_48_META_API_3238_P4_D: "Accesorii adăugate, nule la eșec",
  T_48_META_API_3239_D: "Obținerea echipamentului în coloana de echipament din rucsac",
  T_48_META_API_3239_P0_D: "jucător țintă",
  T_48_META_API_3239_P1_D: "echipament bar slot",
  T_48_META_API_3239_P2_D: "Echipament în slotul specificat, gol dacă nu este echipat",
  T_48_META_API_3239_P3_D: "Toate accesoriile pentru acest echipament",
  T_48_META_API_3240_D: "Un vector 2D are componenta x",
  T_48_META_API_3240_P0_D: "vector bidimensional",
  T_48_META_API_3240_R_D: "Componenta x a vectorului 2D",
  T_48_META_API_3241_D: "Vectorii bidimensionali iau componenta y",
  T_48_META_API_3241_P0_D: "vector bidimensional",
  T_48_META_API_3241_R_D: "Componenta Y a unui vector 2D",
  T_48_META_API_3242_D: "vector 2D care stabilește componenta x",
  T_48_META_API_3242_P0_D: "vector bidimensional",
  T_48_META_API_3242_P1_D: "Componenta x a vectorului 2D",
  T_48_META_API_3243_D: "vector 2D care stabilește componenta y",
  T_48_META_API_3243_P0_D: "vector bidimensional",
  T_48_META_API_3243_P1_D: "Componenta Y a unui vector 2D",
  T_48_META_API_3244_D: "Adăugați doi vectori 2D",
  T_48_META_API_3244_P0_D: "Stânga",
  T_48_META_API_3244_P1_D: "Dreapta",
  T_48_META_API_3244_R_D: "Rezultatul sumei vectorilor 2D",
  T_48_META_API_3245_D: "Scăderea a doi vectori 2D",
  T_48_META_API_3245_P0_D: "Stânga",
  T_48_META_API_3245_P1_D: "Dreapta",
  T_48_META_API_3245_R_D: "Rezultatul subtragerii vectorilor 2D",
  T_48_META_API_3246_D: "Înmulțiți vectorii bidimensionali cu",
  T_48_META_API_3246_P0_D: "vector bidimensional",
  T_48_META_API_3246_P1_D: "Valori de scalare a vectorului 2D",
  T_48_META_API_3246_R_D: "Rezultatul înmulțirii vectorilor 2D",
  T_48_META_API_3247_D: "Înmulțirea punctuală a doi vectori 2D, rezultatul înmulțirii punctuale este un scalar care caracterizează unghiul dintre cei doi vectori",
  T_48_META_API_3247_P0_D: "Stânga",
  T_48_META_API_3247_P1_D: "Dreapta",
  T_48_META_API_3247_R_D: "Rezultatul produsului punctelor",
  T_48_META_API_3248_D: "Calculați distanța euclidiană dintre doi vectori 2D",
  T_48_META_API_3248_P0_D: "Stânga",
  T_48_META_API_3248_P1_D: "Dreapta",
  T_48_META_API_3248_R_D: "După scăderea a doi vectori, modulul vectorului rezultat",
  T_48_META_API_3249_D: "Calculați unghiul dintre doi vectori 2D",
  T_48_META_API_3249_P0_D: "Stânga",
  T_48_META_API_3249_P1_D: "Dreapta",
  T_48_META_API_3249_R_D: "Unghi vectorial, intervalul unghiului 0-180",
  T_48_META_API_3250_D: "Normalizarea vectorului 2D",
  T_48_META_API_3250_P0_D: "vector bidimensional",
  T_48_META_API_3250_R_D: "Rezultat normalizat pentru vectori cu lungimea de 1m în aceeași direcție ca vectorul",
  T_48_META_API_3251_D: "Modelarea unui vector 2D",
  T_48_META_API_3251_P0_D: "vector bidimensional",
  T_48_META_API_3251_R_D: "Rezultatul modelării, ca lungime vectorială",
  T_48_META_API_3252_D: "Calculați vectorul unui vector 2D după reflexia cu o linie verticală normală",
  T_48_META_API_3252_P0_D: "vectorul 2D incident",
  T_48_META_API_3252_P1_D: "Vectorul normal 2D",
  T_48_META_API_3252_R_D: "Vector 2D reflectorizant",
  T_48_META_API_3253_D: "Calcularea vectorilor 3D după reflexia cu un plan vertical normal",
  T_48_META_API_3253_P0_D: "vector 3D incident",
  T_48_META_API_3253_P1_D: "Vectorul normal 3D",
  T_48_META_API_3253_R_D: "vector 3D reflectorizant",
  T_48_META_API_3254_D: "Conversia unui vector 3D într-un vector 2D, eliminarea componentei Z a vectorului 3D",
  T_48_META_API_3254_P0_D: "Vector 3D țintă",
  T_48_META_API_3254_R_D: "Vector 2D convertit",
  T_48_META_API_3255_D: "vector 2D în vector 3D, componenta Z a vectorului 3D este setată la 0",
  T_48_META_API_3255_P0_D: "Vector 2D țintă",
  T_48_META_API_3255_R_D: "Vector 3D convertit",
  T_48_META_API_3256_D: "Crearea unui vector 2D",
  T_48_META_API_3256_P0_D: "Componenta x a unui vector 2D",
  T_48_META_API_3256_P1_D: "Componenta Y a unui vector 2D",
  T_48_META_API_3256_R_D: "Vectorul 2D creat",
  T_48_META_API_3257_D: "Jurnale personalizate de îngropare a concursurilor pentru analiza datelor privind experiența utilizatorului",
  T_48_META_API_3257_P0_D: "log",
  T_48_META_API_3258_D: "Jurnale personalizate de îngropare a concursurilor pentru analiza datelor privind experiența utilizatorului",
  T_48_META_API_3258_P0_D: "Pentru a ține evidența jucătorilor raportați",
  T_48_META_API_3258_P1_D: "log",
  T_48_META_API_33_D: "filtre pentru cuvinte murdare",
  T_48_META_API_33_P0_D: "Textul original care necesită filtrarea cuvintelor murdare",
  T_48_META_API_33_R_D: "Text filtrat",
  T_48_META_API_3301_D: "Crearea unei entități de tabără",
  T_48_META_API_3301_P0_D: "Entități de formare",
  T_48_META_API_3302_D: "Entitatea țintă se alătură taberei desemnate",
  T_48_META_API_3302_P0_D: "entitate țintă",
  T_48_META_API_3302_P1_D: "Entități de formare",
  T_48_META_API_3303_D: "Obținerea de tabere pentru tabere atacabile",
  T_48_META_API_3303_P0_D: "tabără de atac",
  T_48_META_API_3303_R_D: "Lista entităților taberei",
  T_48_META_API_3304_D: "Tabere atacabile pentru înființarea de tabere",
  T_48_META_API_3304_P0_D: "tabără de atac",
  T_48_META_API_3304_P1_D: "tabără țintă",
  T_48_META_API_3304_P2_D: "Atacabilitate",
  T_48_META_API_3305_D: "Configurarea jucătorilor atacabili",
  T_48_META_API_3305_P0_D: "jucător",
  T_48_META_API_3305_P1_D: "Jucători atacabili",
  T_48_META_API_3305_P2_D: "Atacabilitate",
  T_48_META_API_3306_D: "Setarea echipei atacabile a echipei",
  T_48_META_API_3306_P0_D: "echipa de grevă",
  T_48_META_API_3306_P1_D: "grup țintă",
  T_48_META_API_3306_P2_D: "Atacabilitate",
  T_48_META_API_3307_D: "abandonate",
  T_48_META_API_3307_P0_D: "abandonate",
  T_48_META_API_3307_R_D: "Lista entităților jucătorului",
  T_48_META_API_3308_D: "Retragerea entității desemnate din tabăra actuală",
  T_48_META_API_3308_P0_D: "entitate țintă",
  T_48_META_API_3309_D: "Tabăra de achiziție a obiectivului",
  T_48_META_API_3309_P0_D: "entitate țintă",
  T_48_META_API_3309_R_D: "Entități de formare",
  T_48_META_API_3310_D: "Determinați dacă ținta poate fi atacată",
  T_48_META_API_3310_P0_D: "agresori",
  T_48_META_API_3310_P1_D: "entitate țintă",
  T_48_META_API_3310_R_D: "Atacabilitate",
  T_48_META_API_3311_D: "Stabilirea țintelor atacabile ale unei entități",
  T_48_META_API_3311_P0_D: "agresori",
  T_48_META_API_3311_P1_D: "entitate țintă",
  T_48_META_API_3311_P2_D: "Atacabilitate",
  T_48_META_API_3312_D: "Achiziționarea de ținte atacabile ale unei entități",
  T_48_META_API_3312_P0_D: "agresori",
  T_48_META_API_3312_R_D: "Lista entităților care pot fi atacate",
  T_48_META_API_34_D: "Determinați dacă există o componentă pentru entitatea țintă",
  T_48_META_API_34_P0_D: "entitate țintă",
  T_48_META_API_34_P1_D: "Tipul componentei",
  T_48_META_API_34_R_D: "Există?",
  T_48_META_API_35_D: "Adaugă Bot",
  T_48_META_API_35_P0_D: "Nivel de dificultate Bot",
  T_48_META_API_35_P1_D: "Echipa lui Bot",
  T_48_META_API_35_P2_D: "Bot creat Entitate jucător",
  T_48_META_API_3500_D: "Obțineți datele despre jetonul jucătorului",
  T_48_META_API_3500_P0_D: "jucător țintă",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Număr de jetoane",
  T_48_META_API_3500_P3_D: "succes sau eșec",
  T_48_META_API_3501_D: "Adăugarea de date simbolice la player",
  T_48_META_API_3501_P0_D: "jucător țintă",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Număr de jetoane",
  T_48_META_API_3501_P3_D: "Dacă tuple-ul a fost invocat cu succes sau nu",
  T_48_META_API_3502_D: "Consumați jetonul jucătorului țintă",
  T_48_META_API_3502_P0_D: "jucător țintă",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Număr de jetoane",
  T_48_META_API_3502_P3_D: "Dacă tuple-ul a fost invocat cu succes sau nu",
  T_48_META_API_3503_D: "Adăugați un simbol la locația specificată",
  T_48_META_API_3503_P0_D: "plasare",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Număr de jetoane",
  T_48_META_API_3503_P3_D: "Dacă tuple-ul a fost invocat cu succes sau nu",
  T_48_META_API_3504_D: "AI-ul țintă eliberează abilitatea specificată",
  T_48_META_API_3504_P0_D: "AI țintă",
  T_48_META_API_3504_P1_D: "tehnică",
  T_48_META_API_3504_P2_D: "țintă de calificare",
  T_48_META_API_3504_P3_D: "Dacă abilitatea a fost eliberată cu succes sau nu",
  T_48_META_API_3505_D: "Creează căi de ghidare de la început la sfârșit care ocolesc blocurile și pot fi utilizate pentru ghidarea AI",
  T_48_META_API_3505_P0_D: "coordonatele punctului de plecare",
  T_48_META_API_3505_P1_D: "coordonatele destinației",
  T_48_META_API_3505_P2_D: "Dacă traseul de căutare a fost stabilit cu succes sau nu",
  T_48_META_API_3505_P3_D: "Adunarea punctelor de urmărire a traseului",
  T_48_META_API_3506_D: "Setarea variabilei de tablă a arborelui comportamental",
  T_48_META_API_3506_P0_D: "Copacul comportamentelor vizate",
  T_48_META_API_3506_P1_D: "numele variabilei",
  T_48_META_API_3506_P2_D: "valoare variabilă",
  T_48_META_API_3507_D: "Obținerea variabilelor arborelui comportamental la tablă",
  T_48_META_API_3507_P0_D: "Copacul comportamentelor vizate",
  T_48_META_API_3507_P1_D: "numele variabilei",
  T_48_META_API_3507_P2_D: "valoare variabilă",
  T_48_META_API_3508_D: "Obținerea parametrilor nodului comportamental al arborelui",
  T_48_META_API_3508_P0_D: "Noduri ale arborelui comportamentului țintă",
  T_48_META_API_3508_P1_D: "numele parametrului",
  T_48_META_API_3508_P2_D: "valoarea parametrului",
  T_48_META_API_3509_D: "Obțineți skin-ul purtătorului jucătorului țintă",
  T_48_META_API_3509_P0_D: "jucător țintă",
  T_48_META_API_3509_P1_D: "ID transportator",
  T_48_META_API_3509_R_D: "Carrier Piele",
  T_48_META_API_3510_D: "Setarea pielii purtătoare a jucătorului țintă",
  T_48_META_API_3510_P0_D: "jucător țintă",
  T_48_META_API_3510_P1_D: "Carrier Skin ID",
  T_48_META_API_3511_D: "Curățați pielea vehiculului specificat al jucătorului țintă",
  T_48_META_API_3511_P0_D: "jucător țintă",
  T_48_META_API_3511_P1_D: "ID transportator",
  T_48_META_API_3512_D: "Restaurați pielea de purtător implicită a jucătorului țintă",
  T_48_META_API_3512_P0_D: "jucător țintă",
  T_48_META_API_3512_P1_D: "ID transportator",
  T_48_META_API_36_D: "Țintă inactivă, poate fi utilizată numai pentru corpuri rigide de tip dinamic.",
  T_48_META_API_36_P0_D: "corp rigid țintă",
  T_48_META_API_37_D: "Țintă de trezire, poate fi utilizată numai pe corpuri rigide de tip dinamic.",
  T_48_META_API_37_P0_D: "corp rigid țintă",
  T_48_META_API_38_D: "Verificați dacă corpul rigid țintă este inactiv",
  T_48_META_API_38_P0_D: "corp rigid țintă",
  T_48_META_API_38_R_D: "Dacă hibernează sau nu",
  T_48_META_API_39_D: "Setarea pragului de hibernare",
  T_48_META_API_39_P0_D: "corp rigid țintă",
  T_48_META_API_39_P1_D: "Pragul de inactivitate, mișcarea și rotația corpului rigid este mai mică decât această valoare pentru o perioadă de timp pentru a intra în starea de inactivitate, starea de inactivitate a corpului rigid nu va mai efectua calcule fizice",
  T_48_META_API_4_D: "Setează dacă toți jucătorii se pot mișca",
  T_48_META_API_4_P0_D: `Adevărat: poate fi mutat 
 Fals: nu poate fi mutat`,
  T_48_META_API_40_D: "Obțineți pragul de hibernare",
  T_48_META_API_40_P0_D: "corp rigid țintă",
  T_48_META_API_40_R_D: "Pragul de inactivitate, mișcarea și rotația corpului rigid este mai mică decât această valoare pentru o perioadă de timp pentru a intra în starea de inactivitate, starea de inactivitate a corpului rigid nu va mai efectua calcule fizice",
  T_48_META_API_4000_D: "Citește conținutul întregului tabel și returnează un array bidimensional în ordinea rândurilor",
  T_48_META_API_4000_P0_D: "numele mesei",
  T_48_META_API_4000_R_D: "Conținutul tabelului",
  T_48_META_API_4001_D: "Citește un rând dintr-un tabel și returnează un array",
  T_48_META_API_4001_P0_D: "numele mesei",
  T_48_META_API_4001_P1_D: "Numărul de linii de citit, începând cu 1",
  T_48_META_API_4001_R_D: "Tabelul specifică conținutul unui rând",
  T_48_META_API_4002_D: "Citește conținutul unei coloane dintr-un tabel și returnează un array",
  T_48_META_API_4002_P0_D: "numele mesei",
  T_48_META_API_4002_P1_D: "Numărul de coloane de citit, începând de la 1",
  T_48_META_API_4002_R_D: "Tabelul specifică conținutul unei coloane",
  T_48_META_API_4003_D: "Citirea conținutului unei celule dintr-un tabel",
  T_48_META_API_4003_P0_D: "numele mesei",
  T_48_META_API_4003_P1_D: "Numărul de linii de citit, începând cu 1",
  T_48_META_API_4003_P2_D: "Numărul de coloane de citit, începând de la 1",
  T_48_META_API_4003_R_D: "Conținutul celulei specificate din tabel",
  T_48_META_API_4004_D: "Citirea conținutului unei celule dintr-un tabel după numele rândului și al coloanei",
  T_48_META_API_4004_P0_D: "numele mesei",
  T_48_META_API_4004_P1_D: "Numărul de linii de citit, începând cu 1",
  T_48_META_API_4004_P2_D: "Numele coloanei de citit",
  T_48_META_API_4004_R_D: "Conținutul celulei specificate din tabel",
  T_48_META_API_4005_D: "Citește conținutul întregului tabel și returnează un array bidimensional",
  T_48_META_API_4005_P0_D: "numele mesei",
  T_48_META_API_4005_R_D: "Conținutul tabelului, o matrice bidimensională",
  T_48_META_API_4006_D: "Citește un rând dintr-un tabel și returnează un array.",
  T_48_META_API_4006_P0_D: "numele mesei",
  T_48_META_API_4006_P1_D: "Numărul de linii de citit, începând cu 1",
  T_48_META_API_4006_R_D: "Tabelul specifică conținutul unui rând, un array",
  T_48_META_API_4007_D: "Citește conținutul unei coloane din întregul tabel, returnează array",
  T_48_META_API_4007_P0_D: "numele mesei",
  T_48_META_API_4007_P1_D: "Numărul de coloane de citit, începând de la 1",
  T_48_META_API_4007_R_D: "Tabelul specifică conținutul unei coloane, matrice",
  T_48_META_API_4008_D: "Citirea conținutului unei celule dintr-un tabel",
  T_48_META_API_4008_P0_D: "numele mesei",
  T_48_META_API_4008_P1_D: "Numărul de linii de citit, începând cu 1",
  T_48_META_API_4008_P2_D: "Numărul de coloane de citit, începând de la 1",
  T_48_META_API_4008_R_D: "Conținutul celulei specificate din tabel",
  T_48_META_API_4009_D: "Găsește rândul specificat după numărul de coloane și valoarea celulei.",
  T_48_META_API_4009_P0_D: "numele mesei",
  T_48_META_API_4009_P1_D: "Numărul de coloane de citit",
  T_48_META_API_4009_P2_D: "Valoarea celulei de găsit",
  T_48_META_API_4009_R_D: "Conținutul rândurilor găsite, matrice",
  T_48_META_API_4010_D: "Obțineți numărul coloanei după numele coloanei",
  T_48_META_API_4010_P0_D: "numele mesei",
  T_48_META_API_4010_P1_D: "Numele coloanei pentru căutarea numărului de serie",
  T_48_META_API_4010_R_D: "Coloane, numărând de la 1",
  T_48_META_API_41_D: "Setează pragul global de repaus, valabil numai pentru corpurile rigide nou generate de tip Dynamic.",
  T_48_META_API_41_P0_D: "Pragul de inactivitate, mișcarea și rotația corpului rigid este mai mică decât această valoare pentru o perioadă de timp pentru a intra în starea de inactivitate, starea de inactivitate a corpului rigid nu va mai efectua calcule fizice",
  T_48_META_API_42_D: "Obțineți pragul global de hibernare",
  T_48_META_API_42_R_D: "Pragul latent, implicit 0,005, mișcarea și rotația corpului rigid este mai mică decât această valoare pentru o perioadă de timp pentru a intra în starea latentă, corpul rigid latent nu va mai efectua calcule fizice",
  T_48_META_API_43_D: "Convertește cuaternionul dat într-un unghi Euler, ordinea de rotație a unghiului Euler este YXZ, dacă cuaternionul primit nu este legal, returnează (0,0,0)",
  T_48_META_API_43_P0_D: "Cuaternionul de intrare",
  T_48_META_API_43_R_D: "Unghiuri Euler returnate",
  T_48_META_API_44_D: "Conversia unui anumit unghi Euler într-un cuaternion",
  T_48_META_API_44_P0_D: "Unghiuri Euler de intrare",
  T_48_META_API_44_R_D: "Cuaternion returnat",
  T_48_META_API_45_D: "Conversia rotațiilor reprezentărilor unghiurilor axiale în cuaternioni",
  T_48_META_API_45_P0_D: "axa de rotație",
  T_48_META_API_45_P1_D: "Unghiul de rotație în sensul acelor de ceasornic în jurul axei de rotație",
  T_48_META_API_45_R_D: "Cuaternion returnat",
  T_48_META_API_46_D: "Conversia quaternionilor în reprezentări axiale ale unghiurilor",
  T_48_META_API_46_P0_D: "Cuaternionul de intrare",
  T_48_META_API_46_P1_D: "axa de rotație",
  T_48_META_API_46_P2_D: "Unghiul de rotație în sensul acelor de ceasornic în jurul axei de rotație",
  T_48_META_API_47_D: "Setarea progresului de finalizare a sarcinii personalizate",
  T_48_META_API_47_P0_D: "jucător țintă",
  T_48_META_API_47_P1_D: "ID sarcină",
  T_48_META_API_47_P2_D: "Progresul către finalizare, nu sunt permise numere negative",
  T_48_META_API_48_D: "Creează o curbă Bezier care poate fi utilizată pentru interpolarea mișcării",
  T_48_META_API_48_P0_D: "punctul de control al curbei",
  T_48_META_API_48_R_D: "Curba Bessel",
  T_48_META_API_49_D: "Obțineți ID-ul hărții scenei",
  T_48_META_API_49_P0_D: "ID scenă",
  T_48_META_API_49_R_D: "ID hartă",
  T_48_META_API_5_D: "Șterge obiectele plasate în scenă (depreciat, utilizați DeleteEntity)",
  T_48_META_API_5_P0_D: "Entități de obiect care urmează să fie șterse",
  T_48_META_API_50_D: "Creează mișcare în raport cu sine în fiecare cadru, entitatea țintă modificându-și propriile atribute o dată pe cadru, de fiecare dată în raport cu valorile actuale ale atributelor sale",
  T_48_META_API_50_P0_D: "entitate țintă",
  T_48_META_API_50_P1_D: "Proprietăți care necesită modificări ale mișcării",
  T_48_META_API_50_P2_D: "Cantitatea de schimbare per mișcare",
  T_48_META_API_50_P3_D: `Configurare atunci când este utilizat în combinație cu alte moduri de mișcare
 Adevărat: poate fi utilizat în combinație cu mișcare relativă
 Fals: poate fi utilizat în combinație cu mișcare absolută`,
  T_48_META_API_50_P4_D: "Entități de mișcare pe cadru create în raport cu ele însele",
  T_48_META_API_50_P5_D: "Dacă redarea începe automat după creare",
  T_48_META_API_5000_D: "Citește valoarea corespunzătoare unei chei dintr-un tabel din baza de date.",
  T_48_META_API_5000_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5000_P1_D: "Etichetarea jucătorilor, gestionarea simultaneității",
  T_48_META_API_5000_P2_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5000_P3_D: "Returnează rezultatul citirii",
  T_48_META_API_5000_P4_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5001_D: "Scrieți valoarea corespunzătoare unei chei într-un tabel din baza de date.",
  T_48_META_API_5001_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5001_P1_D: "Etichetarea jucătorilor, gestionarea simultaneității",
  T_48_META_API_5001_P2_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5001_P3_D: "Valoarea înscrisă",
  T_48_META_API_5001_P4_D: "Codul câmpului de luptă corespunzător bazei de date, care poate fi completat în câmpuri libere, reprezintă codul câmpului de luptă al hărții curente.",
  T_48_META_API_5002_D: "Ștergeți valoarea corespunzătoare unei chei dintr-un tabel din baza de date.",
  T_48_META_API_5002_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5002_P1_D: "Etichetarea jucătorilor, gestionarea simultaneității",
  T_48_META_API_5002_P2_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5002_P3_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5003_D: "Preluarea valorii unei chei dintr-un tabel al bazei de date.",
  T_48_META_API_5003_P0_D: "Numele tabelului Leaderboard din baza de date",
  T_48_META_API_5003_P1_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5003_P2_D: "Returnează rezultatul citirii",
  T_48_META_API_5003_P3_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5004_D: "Scrieți valoarea corespunzătoare unei chei într-un tabel grafic din baza de date.",
  T_48_META_API_5004_P0_D: "Numele tabelului Leaderboard din baza de date",
  T_48_META_API_5004_P1_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5004_P2_D: "Valoarea înscrisă",
  T_48_META_API_5004_P3_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5005_D: "Ștergeți valoarea corespunzătoare unei chei dintr-un tabel grafic din baza de date.",
  T_48_META_API_5005_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5005_P1_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5005_P2_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5006_D: "Ștergeți valoarea corespunzătoare unui rang dintr-un tabel de clasificare din baza de date.",
  T_48_META_API_5006_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5006_P1_D: "Clasarea în clasament",
  T_48_META_API_5006_P2_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5007_D: "Citiți valorile de la un anumit rang la un anumit rang într-un tabel grafic din baza de date.",
  T_48_META_API_5007_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5007_P1_D: "poziția de pornire",
  T_48_META_API_5007_P2_D: "poziția de sosire",
  T_48_META_API_5007_P3_D: "Returnează rezultatul citirii",
  T_48_META_API_5007_P4_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5008_D: "Citește valoarea corespunzătoare unei chei dintr-un tabel al bazei de date cumulative.",
  T_48_META_API_5008_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5008_P1_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5008_P2_D: "Returnează rezultatul citirii",
  T_48_META_API_5008_P3_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_5009_D: "Scrieți valoarea offset corespunzătoare unei chei într-un tabel al bazei de date cumulative",
  T_48_META_API_5009_P0_D: "Numele tabelelor din baza de date",
  T_48_META_API_5009_P1_D: "Nume personalizat utilizat pentru a identifica datele",
  T_48_META_API_5009_P2_D: "Tipurile celor patru operații acceptă în prezent următoarele tipuri: tipul Int acceptă adunarea, scăderea, înmulțirea, împărțirea și restul; tipul Float acceptă adunarea, scăderea, înmulțirea și împărțirea",
  T_48_META_API_5009_P3_D: "Valoarea offset scrisă",
  T_48_META_API_5009_P4_D: "Codul câmpului de luptă corespunzător bazei de date",
  T_48_META_API_51_D: "Resetarea entității redabile, readuce entitatea redabilă la forma sa inițială fără a modifica starea de redare",
  T_48_META_API_51_P0_D: "Entitate jucabilă țintă",
  T_48_META_API_52_D: "Înmulțirea a doi quaternioni, A*B, înseamnă rotirea lui A și apoi a lui B. O ordine diferită a rotației va duce la un rezultat diferit.",
  T_48_META_API_52_P0_D: "cuaternion cu valoare stângă",
  T_48_META_API_52_P1_D: "cuaternion cu valoare dreaptă",
  T_48_META_API_52_R_D: "Cuaternionul rezultat",
  T_48_META_API_53_D: "Creează un quaternion rotativ orientat într-o direcție specificată",
  T_48_META_API_53_P0_D: "indică direcția",
  T_48_META_API_53_P1_D: "în sus",
  T_48_META_API_53_R_D: "Valoarea rotației necesare pentru alinierea în direcția specificată.",
  T_48_META_API_54_D: "Interpolare sferică cuaternionică de la A la B",
  T_48_META_API_54_P0_D: "Valoare A",
  T_48_META_API_54_P1_D: "Valoare B",
  T_48_META_API_54_P2_D: "Progresul interpolării, intervalul de valori [0,1], valoarea 0 pentru a reveni la începutul valorii, valoarea 1 pentru a reveni la valoarea țintă",
  T_48_META_API_54_R_D: "Cuaternionul rezultat",
  T_48_META_API_57_D: "Tipărește datele țintă ca un avertisment pe consolă",
  T_48_META_API_57_P0_D: "Ce să tipăriți",
  T_48_META_API_58_D: "Tipărește datele țintă pe consolă ca mesaj de eroare.",
  T_48_META_API_58_P0_D: "Ce să tipăriți",
  T_48_META_API_59_D: "Obținerea valorii pe curbă",
  T_48_META_API_59_P0_D: "într-un mod ocolit",
  T_48_META_API_59_P1_D: "Punct de eșantionare, interval de valori [0,1]",
  T_48_META_API_59_R_D: "în cele din urmă",
  T_48_META_API_6_D: "Creează obiecte de scenă la coordonatele specificate",
  T_48_META_API_6_P0_D: "Entități de obiecte de scenă create",
  T_48_META_API_6_P1_D: "Localizarea generării obiectului",
  T_48_META_API_6_P2_D: "ID-ul tipului de obiect creat, care trebuie să fie înregistrat în prealabil în registrul de active pentru a putea fi utilizat în scripturile de cod.",
  T_48_META_API_60_D: "Interpolare bazată pe curbe",
  T_48_META_API_60_P0_D: "tip de valoare",
  T_48_META_API_60_P1_D: "valoarea de pornire",
  T_48_META_API_60_P2_D: "valoarea țintă",
  T_48_META_API_60_P3_D: "într-un mod ocolit",
  T_48_META_API_60_P4_D: "Punct de eșantionare, interval de valori [0,1]",
  T_48_META_API_60_R_D: "în cele din urmă",
  T_48_META_API_6000_D: "Adăugarea de scripturi la entitățile țintă",
  T_48_META_API_6000_P0_D: "entitate țintă",
  T_48_META_API_6000_P1_D: "Script ID",
  T_48_META_API_6001_D: "Descărcarea scripturilor pentru entitățile țintă",
  T_48_META_API_6001_P0_D: "entitate țintă",
  T_48_META_API_6001_P1_D: "Script ID",
  T_48_META_API_6002_D: "Verifică dacă scriptul specificat există pentru entitatea țintă",
  T_48_META_API_6002_P0_D: "entitate țintă",
  T_48_META_API_6002_P1_D: "Script ID",
  T_48_META_API_6002_R_D: "Existența scriptului specificat",
  T_48_META_API_61_D: "Setarea nodului părinte al unui control UI",
  T_48_META_API_61_P0_D: "Nod părinte, poate specifica controlul interfeței de utilizator sau interfața de utilizator personalizată",
  T_48_META_API_61_P1_D: "nod copil",
  T_48_META_API_62_D: "abandonate",
  T_48_META_API_62_P0_D: "abandonate",
  T_48_META_API_62_P1_D: "abandonate",
  T_48_META_API_62_P2_D: "abandonate",
  T_48_META_API_62_P3_D: "abandonate",
  T_48_META_API_62_P4_D: "abandonate",
  T_48_META_API_63_D: "Crearea unei raze de la camera curentă la punctul de atingere al ecranului",
  T_48_META_API_63_P0_D: "contact ecran",
  T_48_META_API_63_P1_D: "prag",
  T_48_META_API_63_P2_D: "direcția razei",
  T_48_META_API_64_D: "Încărcați informații de facturare personalizate",
  T_48_META_API_64_P0_D: "entitate jucător",
  T_48_META_API_64_P1_D: "rezultatele unui concurs",
  T_48_META_API_64_P2_D: "titlu integral (informatică)",
  T_48_META_API_64_P3_D: "valoarea punctului",
  T_48_META_API_65_D: "Redă efectul de sunet specificat și îi definește proprietățile entității dacă aveți mai multe proprietăți de definit.",
  T_48_META_API_65_P0_D: "Entități sonore create",
  T_48_META_API_65_P1_D: "Jucător țintă, numai jucătorul țintă poate auzi efectele sonore",
  T_48_META_API_65_P2_D: "Tip de efect sonor",
  T_48_META_API_65_P3_D: "Tip buclă",
  T_48_META_API_65_P4_D: "Dacă să joci sau nu imediat",
  T_48_META_API_66_D: "Creează efectul vizual specificat și îi stabilește atributele entității, dacă sunt mai multe atribute de stabilit.",
  T_48_META_API_66_P0_D: "Entități de efecte speciale create",
  T_48_META_API_66_P1_D: "Jucători vizați, vizibili numai pentru jucătorii vizați",
  T_48_META_API_66_P2_D: "Tip de efect special",
  T_48_META_API_66_P3_D: "Tip buclă",
  T_48_META_API_66_P4_D: "Dacă să joci sau nu imediat",
  T_48_META_API_67_D: "Creează efectul sonor specificat și îi definește proprietățile entității, dacă există mai multe proprietăți de definit.",
  T_48_META_API_67_P0_D: "Entități sonore create",
  T_48_META_API_67_P1_D: "Tip de efect sonor",
  T_48_META_API_67_P2_D: "Tip buclă",
  T_48_META_API_67_P3_D: "Dacă să joci sau nu imediat",
  T_48_META_API_68_D: "Coordonate mondiale convertite în coordonate ecran",
  T_48_META_API_68_P0_D: "coordonată mondială",
  T_48_META_API_68_P1_D: "Dacă este sau nu mapat în cadrul ecranului",
  T_48_META_API_68_P2_D: "poziția de cartografiere",
  T_48_META_API_69_D: "Coordonate ecran în coordonate lume",
  T_48_META_API_69_P0_D: "coordonată ecran",
  T_48_META_API_69_P1_D: "Distanța de la ecran",
  T_48_META_API_69_P2_D: "coordonată mondială",
  T_48_META_API_7_D: "Conversia valorii țintă în șir de caractere",
  T_48_META_API_7_P0_D: "Valoarea țintă a șirului care urmează să fie convertit",
  T_48_META_API_7_R_D: "string",
  T_48_META_API_70_D: "Detectarea razelor prin atingerea ecranului returnează prima entitate lovită",
  T_48_META_API_70_P0_D: "Ecran de pornire Contacte",
  T_48_META_API_70_P1_D: "Distanța de detecție",
  T_48_META_API_70_P2_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_70_P3_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_70_P4_D: "entitate lovită",
  T_48_META_API_70_P5_D: "coordonatele punctului de impact",
  T_48_META_API_70_P6_D: "Distanța punctului de impact de la punctul de plecare",
  T_48_META_API_70_P7_D: "a lovit suprafața normală",
  T_48_META_API_71_D: "Detectarea razelor prin atingerea ecranului, returnează toate entitățile lovite",
  T_48_META_API_71_P0_D: "Ecran de pornire Contacte",
  T_48_META_API_71_P1_D: "Distanța de detecție",
  T_48_META_API_71_P2_D: "Mască de strat, numai straturile completate vor participa la scanare, dacă este lăsat gol înseamnă că toate straturile participă la scanare",
  T_48_META_API_71_P3_D: "Dacă declanșatorul poate fi detectat",
  T_48_META_API_71_P4_D: "Lista entităților afectate",
  T_48_META_API_71_P5_D: "Lista de coordonate ale punctului de lovire",
  T_48_META_API_71_P6_D: "Lista distanțelor dintre punctul lovit și punctul de plecare",
  T_48_META_API_71_P7_D: "Lista normalelor suprafeței lovite",
  T_48_META_API_72_D: "Creează efectul vizual specificat și îi stabilește atributele entității, dacă sunt mai multe atribute de stabilit.",
  T_48_META_API_72_P0_D: "Entități de efecte speciale create",
  T_48_META_API_72_P1_D: "Tip de efect special",
  T_48_META_API_72_P2_D: "Tip buclă",
  T_48_META_API_72_P3_D: "Dacă să joci sau nu imediat",
  T_48_META_API_73_D: "Creați o interfață integrată care nu este sincronizată cu alți clienți",
  T_48_META_API_73_P0_D: "Entități UI încorporate create",
  T_48_META_API_73_P1_D: "Tipuri de UI încorporate",
  T_48_META_API_74_D: "Creați o interfață personalizată care nu este sincronizată cu alți clienți",
  T_48_META_API_74_P0_D: "Entități UI personalizate create",
  T_48_META_API_74_P1_D: "Index UI personalizat",
  T_48_META_API_75_D: "Obțineți jucătorul corespunzător clientului curent",
  T_48_META_API_75_R_D: "entitate jucător",
  T_48_META_API_76_D: "Crearea monștrilor AI",
  T_48_META_API_76_P0_D: "AI țintă",
  T_48_META_API_76_P1_D: "Crearea locației",
  T_48_META_API_76_P2_D: "Tip AI",
  T_48_META_API_76_P3_D: "echipă afiliată",
  T_48_META_API_76_P4_D: "dacă se revendică sau nu în mod automat inamicul",
  T_48_META_API_76_P5_D: "modul de atac",
  T_48_META_API_76_P6_D: "Ruta de călătorie",
  T_48_META_API_77_D: "Setează prima componentă a vectorului",
  T_48_META_API_77_P0_D: "vectori",
  T_48_META_API_77_P1_D: "Valoarea primei componente",
  T_48_META_API_77_R_D: "Vector după modificarea primei componente",
  T_48_META_API_78_D: "Setează a doua componentă a vectorului",
  T_48_META_API_78_P0_D: "vectori",
  T_48_META_API_78_P1_D: "Valoarea celei de-a doua componente",
  T_48_META_API_78_R_D: "Vectorul după modificarea celei de-a doua componente",
  T_48_META_API_79_D: "Setează a treia componentă a vectorului",
  T_48_META_API_79_P0_D: "vectori",
  T_48_META_API_79_P1_D: "Valoarea celei de-a treia componente",
  T_48_META_API_79_R_D: "Vectorul după modificarea celei de-a treia componente",
  T_48_META_API_8_D: "Deschideți zona de siguranță care se micșorează până la punctul coordonatelor centrale.",
  T_48_META_API_8_P0_D: "Punctul central al zonei de securitate",
  T_48_META_API_8_P1_D: "Raza zonei de siguranță",
  T_48_META_API_8_P2_D: "Timp de așteptare în secunde, la sfârșitul căruia zona de siguranță va începe să se micșoreze către punctul central",
  T_48_META_API_8_P3_D: "Timpul necesar pentru ca zona de siguranță să se micșoreze până la punctul central, în secunde",
  T_48_META_API_8_P4_D: "Cantitatea de daune pe secundă suferită în afara zonei de siguranță",
  T_48_META_API_80_D: "Setează prima componentă a vectorului 2D",
  T_48_META_API_80_P0_D: "vector bidimensional",
  T_48_META_API_80_P1_D: "Valoarea primei componente",
  T_48_META_API_80_R_D: "Vectorul 2D după modificarea primei componente",
  T_48_META_API_81_D: "Setează a doua componentă a vectorului 2D",
  T_48_META_API_81_P0_D: "vector bidimensional",
  T_48_META_API_81_P1_D: "Valoarea celei de-a doua componente",
  T_48_META_API_81_R_D: "Vectorul 2D după modificarea celei de-a doua componente",
  T_48_META_API_82_D: "Mută controlerul personajului în locația specificată, dacă acționează asupra jucătorului, jucătorul trebuie să pornească controlerul jucătorului care utilizează efectul fizic pentru ca acesta să aibă efect",
  T_48_META_API_82_P0_D: "Rolul țintă Controlor",
  T_48_META_API_82_P1_D: "locație desemnată",
  T_48_META_API_83_D: "Obține nodul copil specificat al entității părinte țintă după nume",
  T_48_META_API_83_P0_D: "entitate-mamă",
  T_48_META_API_83_P1_D: "Numele subnodului",
  T_48_META_API_83_R_D: "entitate copil",
  T_48_META_API_84_D: "Adăugați o atenție specială AOI și sincronizați întotdeauna indiferent de distanță",
  T_48_META_API_84_P0_D: "Obiective pentru o atenție specială",
  T_48_META_API_84_P1_D: "observator",
  T_48_META_API_85_D: "Eliminarea atenției speciale AOI și anularea sincronizării AOI în afara vederii",
  T_48_META_API_85_P0_D: "Obiective pentru o atenție specială",
  T_48_META_API_85_P1_D: "observator",
  T_48_META_API_86_D: "Elimină toate preocupările speciale AOI pentru ținta specificată.",
  T_48_META_API_86_P0_D: "Obiective pentru o atenție specială",
  T_48_META_API_87_D: "Determinați dacă există o preocupare specială pentru un AOI",
  T_48_META_API_87_P0_D: "Obiective pentru o atenție specială",
  T_48_META_API_87_P1_D: "abandonate",
  T_48_META_API_87_R_D: "Există?",
  T_48_META_API_88_D: "Schimbarea observatorului proxy al jucătorului",
  T_48_META_API_88_P0_D: "jucător",
  T_48_META_API_88_P1_D: "observator proxy",
  T_48_META_API_89_D: "Dislocă controlerul personajului o dată, iar dacă acționează asupra jucătorului, jucătorul trebuie să activeze controlerul jucătorului care utilizează efectul fizic pentru ca acesta să aibă efect",
  T_48_META_API_89_P0_D: "Obiectul țintă sau, în cazul unui jucător, jucătorul trebuie să aibă un controler de jucător care utilizează efecte fizice activat pentru ca efectul să aibă efect",
  T_48_META_API_89_P1_D: "vector de deplasare",
  T_48_META_API_9_D: "Dezactivați mecanismul zonei de siguranță, atunci când zona de siguranță este redusă la minimum, jucătorii din afara zonei de siguranță vor continua să primească daune, după ce mecanismul zonei de siguranță este oprit, jucătorii revin în siguranță",
  T_48_META_API_90_D: "Setați dacă jucătorul poate renunța liber",
  T_48_META_API_90_P0_D: "jucător țintă",
  T_48_META_API_90_P1_D: "Libertatea de a se retrage",
  T_48_META_API_9000_D: "Creați o interfață integrată care poate fi văzută doar de anumiți jucători",
  T_48_META_API_9000_P0_D: "Entități UI încorporate create",
  T_48_META_API_9000_P1_D: "Entitatea jucătorului căreia îi aparține interfața de utilizator, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_9000_P2_D: "Tipuri de UI încorporate",
  T_48_META_API_9001_D: "Eliminați interfața de joc încorporată",
  T_48_META_API_9001_P0_D: "Entități încorporate în interfața utilizator care urmează să fie eliminate",
  T_48_META_API_9002_D: "Creează o pictogramă cu tipul de pictogramă specificat și, atunci când există mai multe proprietăți de setat, setează în continuare proprietățile entității sale prin intermediul entității (depreciat, utilizați CreateLevelObject)",
  T_48_META_API_9002_P0_D: "În cod este numele parametrului formal utilizat pentru a reprezenta entitatea care creează pictograma, iar valoarea variabilei locale corespunzătoare este entitatea care creează pictograma",
  T_48_META_API_9002_P1_D: "Entitatea jucătorului căreia îi aparține, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_9002_P2_D: "Calea resurselor, calea resurselor corespunzătoare pictogramei selectate de jucător",
  T_48_META_API_9003_D: "Elimină pictograma specificată (depreciat, utilizați DeleteEntity)",
  T_48_META_API_9003_P0_D: "Entitatea pictogramă care urmează să fie eliminată",
  T_48_META_API_9004_D: "Creează un text cu conținutul textului specificat și, atunci când există mai multe atribute de setat, setează în continuare atributele entității sale prin intermediul entității (depreciat, vă rugăm să utilizați CreateLevelObject)",
  T_48_META_API_9004_P0_D: "În cod este numele parametrului formal utilizat pentru a reprezenta entitatea care creează textul, iar valoarea variabilei locale corespunzătoare este entitatea care creează textul",
  T_48_META_API_9004_P1_D: "Entitatea jucătorului căreia îi aparține, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_9004_P2_D: "Conținutul textului care urmează să fie prezentat",
  T_48_META_API_9005_D: "Elimină textul specificat (depreciat, utilizați DeleteEntity)",
  T_48_META_API_9005_P0_D: "Entități text care urmează să fie eliminate",
  T_48_META_API_9006_D: "Creează o pictogramă cu tipul de efect specificat și, atunci când există mai multe proprietăți care trebuie setate, setează proprietățile entității în continuare prin entitate (depreciat, vă rugăm să utilizați CreateEffect)",
  T_48_META_API_9006_P0_D: "În cod este numele parametrului formal utilizat pentru a reprezenta entitatea care creează efectul, iar valoarea variabilei locale corespunzătoare este entitatea care creează efectul.",
  T_48_META_API_9006_P1_D: "Entitatea jucătorului căreia îi aparține, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_9006_P2_D: "Tipuri de efecte speciale, tipurile de efecte din care jucătorii pot alege",
  T_48_META_API_9007_D: "Elimină efectul specificat (depreciat, utilizați DeleteEntity)",
  T_48_META_API_9007_P0_D: "Entitatea efectelor care urmează să fie eliminată",
  T_48_META_API_9008_D: "Creați o interfață personalizată care poate fi văzută doar de anumiți jucători",
  T_48_META_API_9008_P0_D: "Entități UI personalizate create",
  T_48_META_API_9008_P1_D: "Entitatea jucătorului căreia îi aparține interfața de utilizator, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_9008_P2_D: "Index UI personalizat",
  T_48_META_API_9009_D: "Eliminați interfața de joc personalizată",
  T_48_META_API_9009_P0_D: "Entități UI personalizate care urmează să fie eliminate",
  T_48_META_API_9010_D: "Obținerea controalelor interfeței de utilizator dintr-o interfață de utilizator personalizată",
  T_48_META_API_9010_P0_D: "Entitatea jucătorului căreia îi aparține interfața de utilizator",
  T_48_META_API_9010_P1_D: "Entități UI personalizate",
  T_48_META_API_9010_P2_D: "Control Index unic",
  T_48_META_API_9010_R_D: "Entitate de control UI",
  T_48_META_API_9011_D: "Redă sunetul specificat și, dacă există mai multe proprietăți care trebuie setate, setează în continuare proprietățile entității sale prin intermediul entității (depreciat, vă rugăm să utilizați CreateSound)",
  T_48_META_API_9011_P0_D: "În cod este numele parametrului formal utilizat pentru a reprezenta entitatea care creează efectul sonor, iar valoarea variabilei locale corespunzătoare este entitatea care creează efectul sonor",
  T_48_META_API_9011_P1_D: "Entitatea jucătorului căreia îi aparține, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_9011_P2_D: "Tipuri de sunet, tipurile de efecte sonore din care jucătorul poate alege",
  T_48_META_API_9012_D: "Elimină efectul sonor specificat (depreciat, utilizați DeleteEntity)",
  T_48_META_API_9012_P0_D: "Entități sonore care urmează să fie eliminate",
  T_48_META_API_9013_D: "Obținerea unui control de interfață dintr-o interfață personalizată utilizând o cale",
  T_48_META_API_9013_P0_D: "Entitatea jucătorului căreia îi aparține interfața de utilizator",
  T_48_META_API_9013_P1_D: "Interfață personalizată",
  T_48_META_API_9013_P2_D: "Calea de control",
  T_48_META_API_9013_R_D: "Entitate de control UI",
  T_48_META_API_9014_D: "Entitate sonoră în întreruperea redării (depreciat, utilizați PauseSound)",
  T_48_META_API_9014_P0_D: "Entități sonore care trebuie suspendate",
  T_48_META_API_9015_D: "Reluarea sunetului, opțional de la început (depreciat, vă rugăm să utilizați ResumeSound)",
  T_48_META_API_9015_P0_D: "Entități sonore care trebuie să continue redarea după ce au fost puse în pauză",
  T_48_META_API_9015_P1_D: "Dacă să începeți de la zero",
  T_48_META_API_9016_D: "Crearea de comenzi de interfață personalizate",
  T_48_META_API_9016_P0_D: "Entități de control personalizate create",
  T_48_META_API_9016_P1_D: "Tipul de control creat",
  T_48_META_API_9016_P2_D: "Entități UI afiliate",
  T_48_META_API_9016_P3_D: "Control părinte, dacă nu este completat, entitatea UI va fi nodul părinte.",
  T_48_META_API_9017_D: "Setarea măștii stratului camerei țintă",
  T_48_META_API_9017_P0_D: "entitate cameră țintă",
  T_48_META_API_9017_P1_D: "Layer mask (Mască de straturi), numai straturile umplute vor fi afișate în camera țintă; dacă îl lăsați gol, toate straturile sunt afișate.",
  T_48_META_API_9018_D: "Obțineți masca stratului camerei țintă",
  T_48_META_API_9018_P0_D: "entitate cameră țintă",
  T_48_META_API_9018_R_D: "Mască de strat, numai straturile din cadrul măștii de strat sunt afișate în camera țintă",
  T_48_META_API_9019_D: "Stabilește dacă nivelul specificat este vizibil pentru camera țintă",
  T_48_META_API_9019_P0_D: "entitate cameră țintă",
  T_48_META_API_9019_P1_D: "Ierarhia vizibilității",
  T_48_META_API_9019_P2_D: "vizibilitate",
  T_48_META_API_9020_D: "Setarea stării implicite a interfeței jucătorului țintă",
  T_48_META_API_9020_P0_D: "jucător țintă",
  T_48_META_API_9020_P1_D: "Tipuri de interfață pentru jucător, care sunt elemente de interfață utilizate pentru manipularea jucătorului și a conținutului aferent jucătorului",
  T_48_META_API_9020_P2_D: "Valoarea comutatorului, determină vizibilitatea interfeței jucătorului",
  T_48_META_API_9021_D: "Crearea unui șir de localizare a timestampului",
  T_48_META_API_9021_P0_D: "marca temporală",
  T_48_META_API_9021_P1_D: "Stiluri de formatare",
  T_48_META_API_9021_R_D: "Timestamp Localizare String",
  T_48_META_API_9022_D: "Crearea unei pictograme de mini-artă",
  T_48_META_API_9022_P0_D: "Crearea entităților pictogramă mindmap",
  T_48_META_API_9022_P1_D: "Jucătorul de care aparțineți creează o pictogramă de mini-artă care este vizibilă numai pentru acel jucător.",
  T_48_META_API_9022_P2_D: "Mindmap Icon Calea resurselor",
  T_48_META_API_9023_D: "Creează o pictogramă cu tipul de efect specificat și îi definește în continuare proprietățile entității prin intermediul entității, dacă există mai multe proprietăți de definit.",
  T_48_META_API_9023_P0_D: "În cod este numele parametrului formal utilizat pentru a reprezenta entitatea care creează efectul, iar valoarea variabilei locale corespunzătoare este entitatea care creează efectul.",
  T_48_META_API_9023_P1_D: "Entitatea jucătorului căreia îi aparține, vizibilă numai pentru jucătorul respectiv",
  T_48_META_API_9023_P2_D: "Tipuri de efecte speciale, tipurile de efecte din care jucătorii pot alege",
  T_48_META_API_9024_D: "Elimină efectul specificat (depreciat, utilizați DeleteEntity)",
  T_48_META_API_9024_P0_D: "Entitatea efectelor care urmează să fie eliminată",
  T_48_META_API_9025_D: "Generează pixeli statici pe hartă pentru obiectul țintă, care nu se mișcă odată cu obiectul țintă.",
  T_48_META_API_9025_P0_D: "Entități statice pixel create",
  T_48_META_API_9025_P1_D: "Jucătorul căruia îi aparține, creând pixeli statici care sunt vizibili numai pentru acel jucător",
  T_48_META_API_9025_P2_D: "obiect țintă entitate",
  T_48_META_API_9026_D: "Obțineți entitatea mini-map a jucătorului țintă",
  T_48_META_API_9026_P0_D: "jucător țintă",
  T_48_META_API_9026_R_D: "Mini hartă a jucătorului actual",
  T_48_META_API_9027_D: "Setați daunele de cădere ale jucătorului, puteți seta daune diferite în funcție de segmentele de înălțime",
  T_48_META_API_9027_P0_D: "jucător țintă",
  T_48_META_API_9027_P1_D: "Listă segmentată pe înălțime",
  T_48_META_API_9027_P2_D: "Lista segmentelor de daune",
  T_48_META_API_91_D: "Adăugarea unei ținte la o anumită echipă va face ca ținta să părăsească echipa din care făcea parte anterior.",
  T_48_META_API_91_P0_D: "Obiective care trebuie adăugate la echipă",
  T_48_META_API_91_P1_D: "Alăturați-vă echipei",
  T_48_META_API_91_P2_D: "succes sau eșec",
  T_48_META_API_92_D: "Adăugarea unei ținte la o echipă nou creată va face ca ținta să părăsească echipa în care se afla anterior.",
  T_48_META_API_92_P0_D: "Obiective care trebuie adăugate la echipă",
  T_48_META_API_92_P1_D: "Numele noii echipe",
  T_48_META_API_92_P2_D: "succes sau eșec",
  T_48_META_API_94_D: "Set the value of a local variable by index; before setting, the variable must be defined in the current call process ",
  T_48_META_API_94_P0: "Index",
  T_48_META_API_94_P0_D: "Get a variable by index ",
  T_48_META_API_94_P1: "Variable Value",
  T_48_META_API_94_P1_D: "Target variable value ",
  T_48_META_API_94_P2: "Arithmetic Type",
  T_48_META_API_94_P2_D: "Operation method; all types support assignment, and numeric types also support increment, decrement, multiplication, division, and modulus operations ",
  T_48_META_API_94_P3: "Variable Name",
  T_48_META_API_94_P3_D: "Target variable name. Used only for error output ",
  T_48_META_API_95: "Get Local Variable by Index",
  T_48_META_API_95_D: "Get the value of a local variable; before getting, the variable must be defined in the current call process ",
  T_48_META_API_95_P0: "Index",
  T_48_META_API_95_P0_D: "Variable index ",
  T_48_META_API_95_P1: "Variable Name",
  T_48_META_API_95_P1_D: "Target variable name. Used only for error output ",
  T_48_META_API_9500_D: "Efecte de redare din partea clientului care notifică playerul țintă",
  T_48_META_API_9500_P0_D: "jucător țintă",
  T_48_META_API_9500_P1_D: "Calea resurselor pentru efecte speciale",
  T_48_META_API_9500_P2_D: "culoare",
  T_48_META_API_9500_P3_D: "Dimensiunea zoomului, implicit 1",
  T_48_META_API_9500_P4_D: "Obiect legat la care sunt adăugate efecte ca noduri copil",
  T_48_META_API_9500_P5_D: "Decalaj în coordonatele lumii față de obiectul legat",
  T_48_META_API_9501_D: "Notifică clientul jucătorului țintă pentru a reda un efect sonor",
  T_48_META_API_9501_P0_D: "jucător țintă",
  T_48_META_API_9501_P1_D: "Tip de efect sonor",
  T_48_META_API_9502_D: "Notifică clientul jucătorului țintă să afișeze caractere flotante",
  T_48_META_API_9502_P0_D: "jucător țintă",
  T_48_META_API_9502_P1_D: 'Conținutul cuvântului "float',
  T_48_META_API_9502_P2_D: "Culoare caracter flotant, Culoare tip",
  T_48_META_API_9502_P3_D: "Durata cuvântului flotant în milisecunde",
  T_48_META_API_9503_D: "Fă unitatea țintă să joace o expresie a acțiunii Emote o dată",
  T_48_META_API_9503_P0_D: "Obiectivele jocului Emote",
  T_48_META_API_9503_P1_D: "Tip emoție",
  T_48_META_API_9504_D: "Întrerupeți/reîncepeți expresia mișcării Emote a unității",
  T_48_META_API_9504_P0_D: "Suspendarea/reluarea obiectivelor Emote",
  T_48_META_API_9504_P1_D: "Adevărat: Pauză redare, Fals: Reluare redare",
  T_48_META_EVT_1_D: "Declanșat la începutul jocului, serverul va fi gata cu ceva timp înainte de client",
  T_48_META_EVT_10_D: "Se declanșează înainte ca entitatea curentă să primească daune",
  T_48_META_EVT_10_P0_D: "Entitatea atacatorului, eventual nulă",
  T_48_META_EVT_10_P1_D: "Tipul de daună",
  T_48_META_EVT_10_P2_D: "Valoarea daunelor produse",
  T_48_META_EVT_10_P3_D: "parte rănită",
  T_48_META_EVT_1000_D: "Declanșat atunci când punctele jucătorului se modifică",
  T_48_META_EVT_1000_P0_D: "Jucători cu schimbări în puncte",
  T_48_META_EVT_1000_P1_D: "Tipuri de puncte de schimbare",
  T_48_META_EVT_1000_P2_D: "Valoarea integrală după modificarea integrală",
  T_48_META_EVT_1001_D: "Declanșat atunci când se modifică punctele echipei",
  T_48_META_EVT_1001_P0_D: "Echipele cu schimbări în puncte",
  T_48_META_EVT_1001_P1_D: "Tipuri de puncte de schimbare",
  T_48_META_EVT_1001_P2_D: "Valoarea integrală după modificarea integrală",
  T_48_META_EVT_1002_D: "Declanșat atunci când se modifică clasamentul jucătorilor",
  T_48_META_EVT_1002_P0_D: "Jucători cu schimbări în clasament",
  T_48_META_EVT_1002_P1_D: "Clasament după modificarea clasamentului",
  T_48_META_EVT_1003_D: "abandonate",
  T_48_META_EVT_1003_P0_D: "abandonate",
  T_48_META_EVT_1003_P1_D: "Clasament după modificarea clasamentului",
  T_48_META_EVT_11_D: "Declanșat atunci când jucătorul iese",
  T_48_META_EVT_11_P0_D: "Jucători retrași",
  T_48_META_EVT_12_D: "Se declanșează atunci când controlerul jucătorului atinge o entitate și se declanșează numai atunci când controlerul este supus unei mișcări active",
  T_48_META_EVT_12_P0_D: "Entități întâlnite",
  T_48_META_EVT_13_D: "Se declanșează înainte ca entitatea curentă să producă daune",
  T_48_META_EVT_13_P0_D: "Entități care au suferit prejudicii",
  T_48_META_EVT_13_P1_D: "Tipul de daună",
  T_48_META_EVT_13_P2_D: "Valoarea daunelor produse",
  T_48_META_EVT_13_P3_D: "parte rănită",
  T_48_META_EVT_14_D: "Declanșat de fiecare dată când o entitate care poate fi redată face un ciclu, acest eveniment funcționează pe partea de client numai dacă entitatea care poate fi redată este o entitate de sunet, efect etc.",
  T_48_META_EVT_2_D: "Declanșat atunci când cadrul logic este actualizat; în funcție de platformă și de setări, frecvența acestui eveniment poate varia.",
  T_48_META_EVT_2002_D: "Declanșat la moartea jucătorului",
  T_48_META_EVT_2002_P0_D: "Jucători morți",
  T_48_META_EVT_2003_D: "Declanșat la asistențele jucătorilor",
  T_48_META_EVT_2003_P0_D: "Jucători cu pase decisive",
  T_48_META_EVT_2003_P1_D: "Jucători uciși",
  T_48_META_EVT_2004_D: "Se declanșează atunci când jucătorul produce daune",
  T_48_META_EVT_2004_P0_D: "Jucătorul care a provocat daunele",
  T_48_META_EVT_2004_P1_D: "jucător deteriorat",
  T_48_META_EVT_2004_P2_D: "Tipul de daună",
  T_48_META_EVT_2004_P3_D: "cantitatea de daune",
  T_48_META_EVT_2004_P4_D: "parte rănită",
  T_48_META_EVT_2005_D: "Declanșat atunci când un jucător provoacă o ucidere",
  T_48_META_EVT_2005_P0_D: "jucător care a provocat o lovitură",
  T_48_META_EVT_2005_P1_D: "Jucători uciși",
  T_48_META_EVT_2005_P2_D: "Tipul de daună",
  T_48_META_EVT_2006_D: "Declanșat atunci când un jucător intră în joc",
  T_48_META_EVT_2006_P0_D: "Jucătorii se alătură jocului",
  T_48_META_EVT_2007_D: "Declanșat atunci când jucătorul este reînviat",
  T_48_META_EVT_2007_P0_D: "Jucători resuscitați",
  T_48_META_EVT_2007_P1_D: "Surse de înviere",
  T_48_META_EVT_2008_D: "Declanșat atunci când un jucător este doborât",
  T_48_META_EVT_2008_P0_D: "Jucător Knocked Out",
  T_48_META_EVT_2008_P1_D: "agresor",
  T_48_META_EVT_2009_D: "Declanșat atunci când jucătorul se deconectează",
  T_48_META_EVT_2009_P0_D: "Jucători deconectați",
  T_48_META_EVT_2010_D: "Declanșat atunci când jucătorul se reconectează",
  T_48_META_EVT_2010_P0_D: "Jucători reconectați",
  T_48_META_EVT_2100_D: "Declanșat atunci când echipa este eliminată",
  T_48_META_EVT_2100_P0_D: "Echipe eliminate",
  T_48_META_EVT_2101_D: "Declanșat la adăugarea unei echipe",
  T_48_META_EVT_2101_P0_D: "Echipe adăugate",
  T_48_META_EVT_2102_D: "Declanșat atunci când echipa este distrusă de grup",
  T_48_META_EVT_2102_P0_D: "Echipa care a fost distrusă de regiment",
  T_48_META_EVT_3_D: "Declanșat la sfârșitul jocului și înainte ca jocul să se încheie pe server",
  T_48_META_EVT_30_D: "Declanșat atunci când scena se încarcă cu succes",
  T_48_META_EVT_30_P0_D: "numele scenei",
  T_48_META_EVT_3000_D: "Declanșat după crearea entității curente",
  T_48_META_EVT_3001_D: "Declanșat înainte ca entitatea curentă să fie distrusă",
  T_48_META_EVT_3002_D: "Declanșat atunci când jucătorul intră în declanșator",
  T_48_META_EVT_3002_P0_D: "Jucătorii care intră pe trăgaci",
  T_48_META_EVT_3003_D: "Declanșat atunci când jucătorul părăsește declanșatorul",
  T_48_META_EVT_3003_P0_D: "Jucătorii care părăsesc declanșatorul",
  T_48_META_EVT_3004_D: "Declanșat după ce se dă clic pe controlul butonului UI",
  T_48_META_EVT_3004_P0_D: "Faceți clic pe jucători",
  T_48_META_EVT_3005_D: "Declanșat la apăsarea unui buton în interfața încorporată",
  T_48_META_EVT_3005_P0_D: "Numele butonului de control pe care trebuie să faceți clic",
  T_48_META_EVT_3006_D: "Declanșat atunci când jucătorul folosește schiurile de apă",
  T_48_META_EVT_3007_D: "Declanșat după ce entitatea curentă este disponibilă",
  T_48_META_EVT_3008_D: "Declanșat după ce entitatea curentă nu este disponibilă",
  T_48_META_EVT_3009_D: "Declanșat atunci când o entitate intră într-un declanșator, ambele părți primesc evenimentul atunci când acesta este declanșat, una dintre ele trebuie să fie un corp rigid, iar cealaltă trebuie să fie un declanșator",
  T_48_META_EVT_3009_P0_D: "Entitatea adversă la momentul evenimentului declanșator",
  T_48_META_EVT_3010_D: "Declanșat atunci când o entitate părăsește declanșatorul, ambele părți primesc evenimentul atunci când acesta este declanșat, una dintre ele trebuie să fie un corp rigid, iar cealaltă trebuie să fie un declanșator",
  T_48_META_EVT_3010_P0_D: "Entitatea adversă la momentul evenimentului declanșator",
  T_48_META_EVT_3011_D: "Declanșat atunci când entitatea curentă este distrusă",
  T_48_META_EVT_3011_P0_D: "Entitatea atacatorului, eventual nulă",
  T_48_META_EVT_3011_P1_D: "Tipul de daună",
  T_48_META_EVT_3011_P2_D: "parte rănită",
  T_48_META_EVT_3012_D: "Declanșat după ce entitatea curentă este atacată",
  T_48_META_EVT_3012_P0_D: "Entitatea atacatorului, eventual nulă",
  T_48_META_EVT_3012_P1_D: "Tipul de daună",
  T_48_META_EVT_3012_P2_D: "Valoarea daunelor produse",
  T_48_META_EVT_3012_P3_D: "parte rănită",
  T_48_META_EVT_3013_D: "Declanșat după ce entitatea curentă suferă daune",
  T_48_META_EVT_3013_P0_D: "Entități care au suferit prejudicii",
  T_48_META_EVT_3013_P1_D: "Tipul de daună",
  T_48_META_EVT_3013_P2_D: "Valoarea daunelor produse",
  T_48_META_EVT_3013_P3_D: "parte rănită",
  T_48_META_EVT_3014_D: "Declanșat după ce entitatea curentă distruge o altă entitate",
  T_48_META_EVT_3014_P0_D: "Entități eliminate",
  T_48_META_EVT_3014_P1_D: "parte rănită",
  T_48_META_EVT_3015_D: "Declanșat atunci când acest jucător este înviat",
  T_48_META_EVT_3015_P0_D: "Tipul de jucător Sursa de înviere",
  T_48_META_EVT_3016_D: "Declanșat atunci când generatorul generează o entitate",
  T_48_META_EVT_3016_P0_D: "Lista entităților generate",
  T_48_META_EVT_3016_P1_D: "numărul de unde",
  T_48_META_EVT_3017_D: "Apelat atunci când jucătorul intră în poziția de îngenunchere knockout",
  T_48_META_EVT_3018_D: "Declanșat atunci când toți membrii echipei sunt morți",
  T_48_META_EVT_3019_D: "Se declanșează atunci când este echipat cu o cască, o armură sau un rucsac",
  T_48_META_EVT_3019_P0_D: "ID echipament",
  T_48_META_EVT_3020_D: "Se declanșează în timp ce țineți o armă principală, secundară sau corp la corp, inclusiv atunci când treceți la pumn",
  T_48_META_EVT_3020_P0_D: "Entitate armă echipată în momentul declanșării",
  T_48_META_EVT_3021_D: "Declanșat după utilizarea recuzitei, recuzitele a căror utilizare necesită timp vor declanșa acest eveniment după finalizarea utilizării",
  T_48_META_EVT_3021_P0_D: "ID recuzită",
  T_48_META_EVT_3021_P1_D: "Entitate de recuzită, posibil nulă",
  T_48_META_EVT_3021_P2_D: "Nouă entitate prop creată folosind props, poate fi goală",
  T_48_META_EVT_3022_D: "Declanșat la achiziționarea unui element",
  T_48_META_EVT_3022_P0_D: "Tip de articol",
  T_48_META_EVT_3022_P1_D: "Obiect entitate, posibil nul",
  T_48_META_EVT_3023_D: "Declanșat atunci când punctele entității se modifică",
  T_48_META_EVT_3023_P0_D: "Tipuri de puncte de schimbare",
  T_48_META_EVT_3023_P1_D: "Valoarea integrală după modificarea integrală",
  T_48_META_EVT_3024_D: "Declanșat atunci când se modifică rangul entității",
  T_48_META_EVT_3024_P0_D: "Clasament după modificarea clasamentului",
  T_48_META_EVT_3025_D: "Declanșat la o asistență",
  T_48_META_EVT_3025_P0_D: "lovit",
  T_48_META_EVT_3026_D: "Declanșat atunci când o entitate intră într-un vehicul, inclusiv ca șofer și pasager",
  T_48_META_EVT_3026_P0_D: "Entități care intră în operatorul de transport",
  T_48_META_EVT_3026_P1_D: "Transportatori înscriși",
  T_48_META_EVT_3027_D: "Declanșat atunci când entitatea părăsește transportatorul",
  T_48_META_EVT_3027_P0_D: "Entități care părăsesc operatorul de transport",
  T_48_META_EVT_3027_P1_D: "Transportatori care pleacă",
  T_48_META_EVT_3028_D: "Declanșat atunci când conduceți fizic un transportator, când vă aflați într-o mașină ca șofer",
  T_48_META_EVT_3028_P0_D: "Entitatea care conduce transportatorul",
  T_48_META_EVT_3028_P1_D: "Vehicule conduse",
  T_48_META_EVT_3029_D: "Declanșat atunci când transportatorul este introdus fizic",
  T_48_META_EVT_3029_P0_D: "entitatea declanșatoare",
  T_48_META_EVT_3030_D: "Declanșat la plecarea transportatorului",
  T_48_META_EVT_3030_P0_D: "entitatea declanșatoare",
  T_48_META_EVT_3031_D: "Declanșat atunci când vehiculul este condus de o entitate",
  T_48_META_EVT_3031_P0_D: "entitatea declanșatoare",
  T_48_META_EVT_3032_D: "Declanșat după ce are loc o teleportare atunci când o entitate utilizează un portal (depreciat, utilizați OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Entități care utilizează portalul",
  T_48_META_EVT_3032_P1_D: "Portal utilizat",
  T_48_META_EVT_3033_D: "Declanșat atunci când entitatea ricoșează",
  T_48_META_EVT_3033_P0_D: "entitatea declanșatoare",
  T_48_META_EVT_3033_P1_D: "Obiecte săltărețe folosite",
  T_48_META_EVT_3034_D: "Declanșat după ce portalul permite entității să se teleporteze",
  T_48_META_EVT_3034_P0_D: "entitate de transmitere",
  T_48_META_EVT_3035_D: "Declanșat după ce anvelopa sare de entitate",
  T_48_META_EVT_3035_P0_D: "entitate pop-up",
  T_48_META_EVT_3036_D: "Declanșat atunci când o mașină trimite o entitate care zboară",
  T_48_META_EVT_3036_P0_D: "entitate care este doborâtă",
  T_48_META_EVT_3036_P1_D: "obiect generat de mașină",
  T_48_META_EVT_3037_D: "Se declanșează atunci când entitatea intră în declanșator",
  T_48_META_EVT_3037_P0_D: "Declanșator pentru intrare",
  T_48_META_EVT_3038_D: "Se declanșează atunci când entitatea părăsește declanșatorul",
  T_48_META_EVT_3038_P0_D: "Declanșator pentru plecare",
  T_48_META_EVT_3039_D: "Declanșat la achiziționarea unei entități de armă",
  T_48_META_EVT_3039_P0_D: "entitate de arme",
  T_48_META_EVT_3040_D: "Declanșat atunci când o entitate este doborâtă de o mașină",
  T_48_META_EVT_3040_P0_D: "entitate care este doborâtă",
  T_48_META_EVT_3040_P1_D: "obiect generat de mașină",
  T_48_META_EVT_3041_D: "Declanșat atunci când se țintește o entitate care poate fi țintită",
  T_48_META_EVT_3041_P0_D: "Entități vizate",
  T_48_META_EVT_3042_D: "Declanșat atunci când este vizat de un jucător",
  T_48_META_EVT_3042_P0_D: "Țintirea jucătorilor",
  T_48_META_EVT_3043_D: "Declanșat atunci când glonțul lovește ținta",
  T_48_META_EVT_3043_P0_D: "lovit",
  T_48_META_EVT_3043_P1_D: "Coordonatele mondiale ale locațiilor impactului glonțului",
  T_48_META_EVT_3044_D: "Se declanșează atunci când este lovit de o armă",
  T_48_META_EVT_3044_P0_D: "armament",
  T_48_META_EVT_3044_P1_D: "Coordonatele mondiale ale zonei afectate",
  T_48_META_EVT_3045_D: "Declanșat atunci când jucătorul alege să se transforme într-un obiect pentru acel nivel",
  T_48_META_EVT_3045_P0_D: "Jucătorul se transformă într-o entitate, nu în obiectul scenei în sine",
  T_48_META_EVT_3046_D: "Declanșat atunci când un jucător este înviat la acel punct de înviere",
  T_48_META_EVT_3046_P0_D: "Jucătorii înviați la acest punct de înviere",
  T_48_META_EVT_3047_D: "Declanșat atunci când un jucător aruncă o armă",
  T_48_META_EVT_3047_P0_D: "Entități de arme aruncate",
  T_48_META_EVT_3048_D: "Declanșat atunci când un jucător aruncă un obiect, altul decât o armă",
  T_48_META_EVT_3048_P0_D: "Tip de articol",
  T_48_META_EVT_3048_P1_D: "Obiect entitate, posibil nul",
  T_48_META_EVT_3049_D: "Declanșat atunci când este lovit de o armă de fotbal",
  T_48_META_EVT_3049_P0_D: "jucător",
  T_48_META_EVT_3049_P1_D: "Viteza după ce a fost lovit",
  T_48_META_EVT_3050_D: "Declanșat la coliziunea dintre mingea de fotbal și solid",
  T_48_META_EVT_3050_P0_D: "obiect de coliziune",
  T_48_META_EVT_3050_P1_D: "Viteza după coliziune",
  T_48_META_EVT_3051_D: "Declanșat atunci când un jucător se alătură cu succes unui canal vocal",
  T_48_META_EVT_3051_P0_D: "entitatea canalului vocal",
  T_48_META_EVT_3052_D: "Declanșat atunci când un jucător nu reușește să se alăture unui canal vocal",
  T_48_META_EVT_3052_P0_D: "entitatea canalului vocal",
  T_48_META_EVT_3053_D: "Declanșat atunci când un jucător părăsește un canal vocal",
  T_48_META_EVT_3053_P0_D: "entitatea canalului vocal",
  T_48_META_EVT_3054_D: "Declanșat atunci când mingea intră în poartă",
  T_48_META_EVT_3054_P0_D: "goalmouth",
  T_48_META_EVT_3054_P1_D: "Marcator, ultimul jucător care atinge mingea înainte de a intra în poartă",
  T_48_META_EVT_3054_P2_D: "Asistenți, penultimul jucător care atinge mingea înainte de marcarea golului",
  T_48_META_EVT_3055_D: "Declanșat atunci când jucătorul apasă butonul de foc",
  T_48_META_EVT_3056_D: "Declanșat atunci când jucătorul sare",
  T_48_META_EVT_3057_D: "Declanșat atunci când jucătorul se ghemuiește",
  T_48_META_EVT_3058_D: "Declanșat atunci când jucătorul cade",
  T_48_META_EVT_3059_D: "Declanșat atunci când jucătorul sprintează",
  T_48_META_EVT_3060_D: "Declanșat atunci când un articol este achiziționat cu succes în magazin",
  T_48_META_EVT_3060_P0_D: "Jucători care cumpără bunuri",
  T_48_META_EVT_3060_P1_D: "marfă",
  T_48_META_EVT_3061_D: "Declanșat atunci când arma este echipată de jucător",
  T_48_META_EVT_3061_P0_D: "Jucători echipați cu arme",
  T_48_META_EVT_3062_D: "Se declanșează atunci când o unitate este ucisă cu această armă",
  T_48_META_EVT_3062_P0_D: "Entități ucise",
  T_48_META_EVT_3063_D: "Se declanșează atunci când utilizați această armă pentru a provoca daune unei unități",
  T_48_META_EVT_3063_P0_D: "entitate prejudiciată",
  T_48_META_EVT_3063_P1_D: "cantitatea de daune",
  T_48_META_EVT_3064_D: "Declanșat atunci când arma schimbă gloanțele",
  T_48_META_EVT_3065_D: "Declanșat atunci când o entitate intră în operatorul de transport, fie ca șofer, fie ca pasager",
  T_48_META_EVT_3065_P0_D: "Transportatori înscriși",
  T_48_META_EVT_3066_D: "Declanșat atunci când entitatea părăsește transportatorul",
  T_48_META_EVT_3066_P0_D: "Transportatori care pleacă",
  T_48_META_EVT_3067_D: "Declanșat în timpul acționării fizice a suportului",
  T_48_META_EVT_3067_P0_D: "Vehicule conduse",
  T_48_META_EVT_3068_D: "Declanșat după o teleportare are loc atunci când o entitate utilizează un portal",
  T_48_META_EVT_3068_P0_D: "Portal utilizat",
  T_48_META_EVT_3069_D: "Declanșat atunci când o entitate este lovită de o anvelopă",
  T_48_META_EVT_3069_P0_D: "Anvelope utilizate",
  T_48_META_EVT_3070_D: "Declanșat atunci când o entitate este doborâtă de o mașină",
  T_48_META_EVT_3070_P0_D: "obiect generat de mașină",
  T_48_META_EVT_3071_D: "Declanșat după ce jucătorul apasă pe un buton de control UI",
  T_48_META_EVT_3071_P0_D: "jucător de declanșare",
  T_48_META_EVT_3072_D: "Declanșat atunci când controlul butonului UI este ridicat",
  T_48_META_EVT_3072_P0_D: "jucător de declanșare",
  T_48_META_EVT_3073_D: "Declanșat după ce jucătorul face dublu clic pe un buton de control UI",
  T_48_META_EVT_3073_P0_D: "jucător de declanșare",
  T_48_META_EVT_3074_D: "Pornirea zonei Jailbreak",
  T_48_META_EVT_3075_D: "Zona de evadare din închisoare închisă",
  T_48_META_EVT_3076_D: "Declanșat atunci când jucătorul nu mai folosește schiurile de apă",
  T_48_META_EVT_3077_D: "Declanșat atunci când conținutul textului din caseta de control UI este modificat de către jucător",
  T_48_META_EVT_3077_P0_D: "jucător de declanșare",
  T_48_META_EVT_3077_P1_D: "Modificat conținutul textului",
  T_48_META_EVT_3078_D: "Declanșat atunci când entitatea jucabilă începe să joace",
  T_48_META_EVT_3078_P0_D: "entitate jucabilă",
  T_48_META_EVT_3079_D: "Declanșat atunci când o entitate care poate fi redată termină redarea, acest eveniment funcționează numai pe partea de client dacă entitatea care poate fi redată este o entitate de sunet, efect etc.",
  T_48_META_EVT_3079_P0_D: "entitate jucabilă",
  T_48_META_EVT_3080_D: "Declanșat atunci când entitatea jucabilă continuă să joace",
  T_48_META_EVT_3080_P0_D: "entitate jucabilă",
  T_48_META_EVT_3081_D: "Declanșat atunci când o entitate redabilă întrerupe redarea",
  T_48_META_EVT_3081_P0_D: "entitate jucabilă",
  T_48_META_EVT_3082_D: "Jucătorii Jailbreak se alătură",
  T_48_META_EVT_3082_P0_D: "jucător de declanșare",
  T_48_META_EVT_3083_D: "Jucătorii Jailbreak renunță",
  T_48_META_EVT_3083_P0_D: "jucător de declanșare",
  T_48_META_EVT_3084_D: "Declanșat la sfârșitul numărătorii inverse",
  T_48_META_EVT_3084_P0_D: "entitate afiliată",
  T_48_META_EVT_3085_D: "Declanșat atunci când un articol este ridicat",
  T_48_META_EVT_3085_P0_D: "Jucători care ridică obiecte",
  T_48_META_EVT_3086_D: "Declanșat atunci când un articol este aruncat",
  T_48_META_EVT_3086_P0_D: "Jucătorul care a scăpat obiectul",
  T_48_META_EVT_3087_D: "Declanșat atunci când acest element este echipat",
  T_48_META_EVT_3088_D: "Declanșat atunci când obiectul este pornit după ce mina este creată",
  T_48_META_EVT_3089_D: "Declanșat atunci când obiectul este declanșat după ce mina este creată",
  T_48_META_EVT_3089_P0_D: "Direcționarea obiectelor după declanșarea creării minei",
  T_48_META_EVT_3090_D: "Declanșat înainte de achiziționarea unui articol într-un magazin",
  T_48_META_EVT_3090_P0_D: "Jucători care cumpără bunuri",
  T_48_META_EVT_3090_P1_D: "marfă",
  T_48_META_EVT_3091_D: "Declanșat atunci când acest dispozitiv este utilizat",
  T_48_META_EVT_3092_D: "Declanșat atunci când se trage cu arma cu cârlig",
  T_48_META_EVT_3093_D: "Declanșat atunci când proiectilul explodează după ce a fost aruncat.",
  T_48_META_EVT_3093_P0_D: "punctul de explozie",
  T_48_META_EVT_3094_D: "Declanșat atunci când este lovit de o armă de paintball",
  T_48_META_EVT_3094_P0_D: "Pistol de vopsit entități",
  T_48_META_EVT_3094_P1_D: "punct de lovire",
  T_48_META_EVT_3094_P2_D: "loviți linia țintă",
  T_48_META_EVT_3095_D: "Declanșat la lovirea cu pistolul de vopsit",
  T_48_META_EVT_3095_P0_D: "obiect lovit",
  T_48_META_EVT_3095_P1_D: "punct de lovire",
  T_48_META_EVT_3095_P2_D: "loviți linia țintă",
  T_48_META_EVT_3096_D: "Declanșat atunci când explodează un transportator sau o găleată de colorant",
  T_48_META_EVT_3096_P0_D: "Jucătorul care a provocat explozia",
  T_48_META_EVT_3096_P1_D: "Lista jucătorilor afectați de explozie",
  T_48_META_EVT_3097_D: "Declanșat atunci când arma nu mai trage",
  T_48_META_EVT_3097_P0_D: "Capacitatea actuală a magaziilor la momentul încetării focului",
  T_48_META_EVT_3098_D: "Declanșat atunci când ținta urmărită intră în raza de urmărire",
  T_48_META_EVT_3099_D: "Declanșat atunci când ținta urmărită iese din raza de urmărire",
  T_48_META_EVT_31_D: "Declanșat la schimbarea cu succes a scenei",
  T_48_META_EVT_31_P0_D: "numele scenei",
  T_48_META_EVT_3100_D: "Se declanșează atunci când ținta atacului intră în raza de atac",
  T_48_META_EVT_3101_D: "Se declanșează atunci când ținta atacului este în afara razei de acțiune",
  T_48_META_EVT_3102_D: "Declanșat atunci când detectarea razei camerei este declanșată de un eveniment de clic al clientului",
  T_48_META_EVT_3102_P0_D: "jucător de declanșare",
  T_48_META_EVT_3102_P1_D: "Dacă raza camerei atinge obiectul",
  T_48_META_EVT_3102_P2_D: "Poziția de lovire a razei camerei",
  T_48_META_EVT_3102_P3_D: "Orientarea camerei clientului",
  T_48_META_EVT_3102_P4_D: "Poziția camerei clientului",
  T_48_META_EVT_3102_P5_D: "atinge ținta",
  T_48_META_EVT_3103_D: "Declanșat atunci când este deschis ecranul magazinului",
  T_48_META_EVT_3103_P0_D: "jucător de declanșare",
  T_48_META_EVT_3104_D: "Declanșat atunci când ecranul magazinului este închis",
  T_48_META_EVT_3104_P0_D: "jucător de declanșare",
  T_48_META_EVT_3105_D: "Declanșat atunci când logica arborelui de comportament intră în nod",
  T_48_META_EVT_3105_P0_D: "Numele nodului",
  T_48_META_EVT_3105_P1_D: "entitate afiliată",
  T_48_META_EVT_3106_D: "Declanșat atunci când logica arborelui comportamental iese din nod",
  T_48_META_EVT_3106_P0_D: "Numele nodului",
  T_48_META_EVT_3106_P1_D: "entitate afiliată",
  T_48_META_EVT_3107_D: "Declanșat atunci când un corp rigid este trezit",
  T_48_META_EVT_3108_D: "Declanșat atunci când corpul rigid intră în repaus",
  T_48_META_EVT_3109_D: "Declanșat atunci când jucătorul se mișcă",
  T_48_META_EVT_3109_P0_D: "deschideri",
  T_48_META_EVT_3110_D: "Declanșat atunci când playerul este în standby",
  T_48_META_EVT_3110_P0_D: "deschideri",
  T_48_META_EVT_3111_D: "Declanșat atunci când jucătorul folosește o abilitate",
  T_48_META_EVT_3111_P0_D: "Competențe utilizate",
  T_48_META_EVT_3112_D: "Declanșat atunci când jucătorul termină sprintul",
  T_48_META_EVT_3113_D: "Declanșat atunci când elementul corespunzător slotului din enumerarea SwitchEquipSlot este achiziționat.",
  T_48_META_EVT_3113_P0_D: "Entități de elemente achiziționate",
  T_48_META_EVT_3114_D: "Declanșări la schimbarea obiectelor de mână, inclusiv la trecerea la pumni",
  T_48_META_EVT_3114_P0_D: "Articolul entități deținute după comutare",
  T_48_META_EVT_3115_D: "Declanșat atunci când un jucător din magazin cere cuiva să cumpere un articol",
  T_48_META_EVT_3115_P0_D: "Jucătorii care solicită marfă",
  T_48_META_EVT_3115_P1_D: "marfă",
  T_48_META_EVT_3116_D: "Declanșat atunci când un jucător dintr-un magazin solicită un obiect de la altcineva și solicitarea este acceptată.",
  T_48_META_EVT_3116_P0_D: "Ajutor pentru jucătorii achiziționați",
  T_48_META_EVT_3116_P1_D: "Jucătorii care solicită ajutor cu achizițiile lor",
  T_48_META_EVT_3116_P2_D: "marfă",
  T_48_META_EVT_3117_D: "Declanșat la actualizări fixe ale cadrelor la o frecvență fixă de 30 de ori pe secundă",
  T_48_META_EVT_3118_D: "Declanșat după un apel la API-ul de pauză a jocului",
  T_48_META_EVT_3119_D: "Declanșat după un apel la API-ul Restore Game",
  T_48_META_EVT_3120_D: "Declanșat atunci când un jucător adaugă sau șterge un prieten",
  T_48_META_EVT_3121_D: "Declanșat la primirea mesajului Persona",
  T_48_META_EVT_3121_P0_D: "Conținutul informațiilor",
  T_48_META_EVT_3121_P1_D: "Persoana expeditorului",
  T_48_META_EVT_3122_D: "Declanșat la sfârșitul săriturii unui jucător",
  T_48_META_EVT_3123_D: "Declanșat atunci când jucătorul cade",
  T_48_META_EVT_3124_D: "Declanșat la sfârșitul căderii unui jucător",
  T_48_META_EVT_3125_D: "Declanșat la primirea comportamentului Persona",
  T_48_META_EVT_3125_P0_D: "comportament",
  T_48_META_EVT_3125_P1_D: "Persoana expeditorului",
  T_48_META_EVT_3126_D: "Declanșat atunci când se modifică informațiile despre membru",
  T_48_META_EVT_3126_P0_D: "Statutul modificat al membrului",
  T_48_META_EVT_3127_D: "Declanșat la intrarea în Centrul pentru membri",
  T_48_META_EVT_3128_D: "Declanșat la părăsirea Centrului pentru membri",
  T_48_META_EVT_3129_D: "Declanșat atunci când un jucător intră în starea de knockdown",
  T_48_META_EVT_3129_P0_D: "Entitatea atacatorului, eventual nulă",
  T_48_META_EVT_3130_D: "Declanșat atunci când este primit statutul Persona",
  T_48_META_EVT_3130_P0_D: "Persoana expeditorului",
  T_48_META_EVT_3130_P1_D: "cod de eroare",
  T_48_META_EVT_3131_D: "Declanșat la trimiterea unui mesaj către Persona prin intermediul interfeței",
  T_48_META_EVT_3131_P0_D: "Conținutul informațiilor",
  T_48_META_EVT_3131_P1_D: "Persoana expeditorului",
  T_48_META_EVT_3132_D: "Declanșat la sfârșitul primirii Persona",
  T_48_META_EVT_3132_P0_D: "Persoana expeditorului",
  T_48_META_EVT_3132_P1_D: "cod de eroare",
  T_48_META_EVT_32_D: "Declanșat atunci când jucătorul schimbă scena",
  T_48_META_EVT_32_P0_D: "numele scenei",
  T_48_META_EVT_3200_D: "Declanșat atunci când se termină redarea clipului de animație",
  T_48_META_EVT_3200_P0_D: "Numele segmentului animat",
  T_48_META_EVT_3201_D: "Declanșat atunci când se termină redarea stării de animație",
  T_48_META_EVT_3201_P0_D: "Numele stării de animație",
  T_48_META_EVT_3204_D: "Declanșat atunci când se modifică starea controlului Toggle.",
  T_48_META_EVT_3204_P0_D: "jucător de declanșare",
  T_48_META_EVT_3204_P1_D: "starea de fapt",
  T_48_META_EVT_3260_D: "Declanșat atunci când jucătorul apasă pe touchpad",
  T_48_META_EVT_3260_P0_D: "jucător de declanșare",
  T_48_META_EVT_3260_P1_D: "Poziția presei",
  T_48_META_EVT_3261_D: "Declanșat atunci când touchpad-ul este ridicat",
  T_48_META_EVT_3261_P0_D: "jucător de declanșare",
  T_48_META_EVT_3261_P1_D: "Poziția de ridicare",
  T_48_META_EVT_3262_D: "Declanșat atunci când touchpad-ul începe să alunece",
  T_48_META_EVT_3262_P0_D: "jucător de declanșare",
  T_48_META_EVT_3262_P1_D: "Start Poziție glisieră",
  T_48_META_EVT_3263_D: "Declanșat la o glisare pe touchpad, acest eveniment este declanșat o dată pe cadru în timpul glisării",
  T_48_META_EVT_3263_P0_D: "jucător de declanșare",
  T_48_META_EVT_3263_P1_D: "Start Poziție glisieră",
  T_48_META_EVT_3263_P2_D: "deplasare",
  T_48_META_EVT_3264_D: "Declanșat la sfârșitul unei glisări pe touchpad",
  T_48_META_EVT_3264_P0_D: "jucător de declanșare",
  T_48_META_EVT_3264_P1_D: "Poziția glisierei de capăt",
  T_48_META_EVT_3265_D: "Declanșat atunci când JoyStick este apăsat",
  T_48_META_EVT_3265_P0_D: "jucător de declanșare",
  T_48_META_EVT_3266_D: "Declanșat atunci când JoyStick-ul este ridicat",
  T_48_META_EVT_3266_P0_D: "jucător de declanșare",
  T_48_META_EVT_3267_D: "Declanșat atunci când se utilizează joystick-ul JoyStick",
  T_48_META_EVT_3267_P0_D: "jucător de declanșare",
  T_48_META_EVT_3267_P1_D: "Deplasare de ieșire",
  T_48_META_EVT_3268_D: "Declanșat atunci când jucătorul se ridică din altă poziție",
  T_48_META_EVT_3268_P0_D: "Poziția jucătorului înainte de a se ridica în picioare",
  T_48_META_EVT_3269_D: "Declanșat atunci când arma este trasă",
  T_48_META_EVT_4_D: "Declanșat la începutul fiecărei ture",
  T_48_META_EVT_4_P0_D: "Indice rotund, numărând de la 0",
  T_48_META_EVT_5_D: "Declanșat la sfârșitul fiecărei ture",
  T_48_META_EVT_5_P0_D: "Indice rotund, numărând de la 0",
  T_48_META_EVT_6_D: "Declanșat atunci când o entitate s-a ciocnit, acceptat numai de entitățile care au montată o componentă Rigid Body.",
  T_48_META_EVT_6_P0_D: "Entități întâlnite",
  T_48_META_EVT_7_D: "Declanșat la începutul fiecărei faze",
  T_48_META_EVT_7_P0_D: "entitate pas",
  T_48_META_EVT_8_D: "Declanșat la sfârșitul fiecărei faze",
  T_48_META_EVT_8_P0_D: "entitate pas",
  T_48_META_EVT_9_D: "Declanșat la sfârșitul coliziunii unei entități, acceptat numai de entitățile care au montată pe ele o componentă Rigid Body.",
  T_48_META_EVT_9_P0_D: "Entități întâlnite",
  T_49_META_TYP_10_I1_D: "Tag List",
  T_49_META_TYP_10_I2_D: "Is it available for itself",
  T_49_META_TYP_10_I3_D: "Available in all parents",
  T_49_META_TYP_10_I4_D: "Whether it is available in the Scene or not",
  T_49_META_TYP_10_I5_D: "Whether logic update is turned on, when it is turned off, the script on this entity stops updating every frame",
  T_49_META_TYP_10_I6_D: "Entity name",
  T_49_META_TYP_10_I7_D: "Region filtering options, 0 for automatic calculation of controlled or uncontrolled, 1 for uncontrolled always synchronized, 2 for controlled",
  T_49_META_TYP_100_I0_D: "Setting the trigger range",
  T_49_META_TYP_100_I1_D: "Model Visibility",
  T_49_META_TYP_101_I0_D: "Player",
  T_49_META_TYP_101_I1_D: "TargetItemID",
  T_49_META_TYP_101_I2_D: "TargetRotation",
  T_49_META_TYP_101_I3_D: "TargetScale",
  T_49_META_TYP_1010_I1_D: "Timing duration in seconds",
  T_49_META_TYP_1010_I2_D: "The start time of the timings, in seconds of the game moment",
  T_49_META_TYP_1010_I3_D: "The update type of the timer, see `EUITimeUpdateType`, can be static, timed, or countdown.",
  T_49_META_TYP_1010_I4_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinates.",
  T_49_META_TYP_1011_I10_D: "Progress Icon Name",
  T_49_META_TYP_1011_I2_D: "Theme Color",
  T_49_META_TYP_1011_I3_D: "Whether to enable localized display",
  T_49_META_TYP_1011_I4_D: "Title",
  T_49_META_TYP_1011_I5_D: "Description",
  T_49_META_TYP_1011_I6_D: "Icon resource name",
  T_49_META_TYP_1011_I7_D: "Max Progress",
  T_49_META_TYP_1011_I8_D: "Current Progress",
  T_49_META_TYP_1011_I9_D: "Progress Icon",
  T_49_META_TYP_1012_I1_D: "Enable or disable localization",
  T_49_META_TYP_1012_I2_D: "Number of rounds text",
  T_49_META_TYP_1012_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1012_I5_D: "LeftColor",
  T_49_META_TYP_1012_I6_D: "RightColor",
  T_49_META_TYP_1013_I2_D: "Round Count Text",
  T_49_META_TYP_1013_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1014_I2_D: "First Score Title Text",
  T_49_META_TYP_1014_I3_D: "First Score",
  T_49_META_TYP_1014_I4_D: "First Score Params",
  T_49_META_TYP_1014_I5_D: "Title of the second score",
  T_49_META_TYP_1014_I6_D: "Second score value",
  T_49_META_TYP_1014_I7_D: "Second Score Value Params",
  T_49_META_TYP_1016_I1_D: "Show the corresponding status according to the value, Victory (1), Defeat (2), Tie (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Show if the score of 2 teams is true, otherwise hidden",
  T_49_META_TYP_1016_I3_D: "Left Team Score",
  T_49_META_TYP_1016_I4_D: "Right Team Score",
  T_49_META_TYP_1016_I5_D: "Phase end timestamps",
  T_49_META_TYP_1017_I1_D: "Left Team Name",
  T_49_META_TYP_1017_I2_D: "Left Description",
  T_49_META_TYP_1017_I3_D: "Right Team Name",
  T_49_META_TYP_1017_I4_D: "Right Description",
  T_49_META_TYP_1018_I1_D: "Round Num",
  T_49_META_TYP_1018_I4_D: "Left team score",
  T_49_META_TYP_1018_I6_D: "Score of the right team",
  T_49_META_TYP_1019_I1_D: "1 2 3 for win/loss/tie",
  T_49_META_TYP_102_I0_D: "Resurrection source type, player resurrects from death",
  T_49_META_TYP_102_I1_D: "Resurrection source type, player resurrects from downed state",
  T_49_META_TYP_1020_I2_D: "Text key to be displayed",
  T_49_META_TYP_1020_I3_D: "Array of parameters corresponding to the text key",
  T_49_META_TYP_1021_I1_D: "Base time in seconds",
  T_49_META_TYP_1021_I2_D: "Duration in seconds",
  T_49_META_TYP_1021_I3_D: "Display position, when there is a target to follow, it is the offset of the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0).",
  T_49_META_TYP_1022_I2_D: "the key of the text to be displayed",
  T_49_META_TYP_1022_I3_D: "Array of parameters corresponding to the text key.",
  T_49_META_TYP_1023_I1_D: "show team score if it is true, otherwise it will be closed.",
  T_49_META_TYP_1023_I4_D: "If the status of the team is true, then display, otherwise it will be closed.",
  T_49_META_TYP_1023_I5_D: "Left player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I6_D: "Right player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I7_D: "Left Teammate Flag Count",
  T_49_META_TYP_1023_I8_D: "Right Teammate Flag Count",
  T_49_META_TYP_1024_I2_D: "Offset",
  T_49_META_TYP_1024_I3_D: "Rank",
  T_49_META_TYP_1024_I4_D: "Team Color",
  T_49_META_TYP_1024_I5_D: "Icon Name",
  T_49_META_TYP_1024_I6_D: "Displayed if border is true, otherwise it is off.",
  T_49_META_TYP_1024_I7_D: "Score Text Key",
  T_49_META_TYP_1024_I8_D: "Score Text Key Params",
  T_49_META_TYP_1028_I1_D: "Left Teammate Alive Num",
  T_49_META_TYP_1028_I2_D: "Right Teammate Alive Num",
  T_49_META_TYP_1028_I3_D: "Left Background Color",
  T_49_META_TYP_1028_I4_D: "Right Background Color",
  T_49_META_TYP_1028_I5_D: "Left Icon Name",
  T_49_META_TYP_1028_I6_D: "Right Icon Name",
  T_49_META_TYP_1029_I1_D: "Icon Name",
  T_49_META_TYP_1029_I2_D: "Background Icon Name",
  T_49_META_TYP_103_I0_D: "Primary Weapon A",
  T_49_META_TYP_103_I1_D: "Primary WeaponB",
  T_49_META_TYP_103_I10_D: "Freeze Bomb",
  T_49_META_TYP_103_I11_D: "Ice Wall",
  T_49_META_TYP_103_I12_D: "Landmine",
  T_49_META_TYP_103_I13_D: "Auto Turret",
  T_49_META_TYP_103_I14_D: "DummyGrenade",
  T_49_META_TYP_103_I16_D: "Skateboard, Camo ....",
  T_49_META_TYP_103_I2_D: "Secondary Weapon",
  T_49_META_TYP_103_I3_D: "Blast Weapon",
  T_49_META_TYP_103_I5_D: "HeavyWeapon",
  T_49_META_TYP_1030_I3_D: "Left Teammate Alive Num",
  T_49_META_TYP_1030_I4_D: "Right Teammate Alive Num",
  T_49_META_TYP_1030_I5_D: "Left team icon name",
  T_49_META_TYP_1030_I6_D: "Right team icon name",
  T_49_META_TYP_1031_I2_D: "Description of the message",
  T_49_META_TYP_1031_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_1031_I4_D: "Description Params",
  T_49_META_TYP_1032_I1_D: "Tips Type",
  T_49_META_TYP_1032_I3_D: "Params",
  T_49_META_TYP_1033_I1_D: "Toggles phases, 0 for current round and 1 for next round",
  T_49_META_TYP_1033_I10_D: "Defeat prompt text, not filled in as default",
  T_49_META_TYP_1033_I11_D: "Round Income Title",
  T_49_META_TYP_1033_I12_D: "Round Income",
  T_49_META_TYP_1033_I13_D: "Round Income Detail Titles",
  T_49_META_TYP_1033_I14_D: "Round revenue value detail list, corresponding to the above detail title list one by one",
  T_49_META_TYP_1033_I15_D: "MVP Player Nickname",
  T_49_META_TYP_1033_I16_D: "Next Round Index",
  T_49_META_TYP_1033_I17_D: "Is Match Point",
  T_49_META_TYP_1033_I18_D: "Is Last Round",
  T_49_META_TYP_1033_I6_D: "Left team icon name",
  T_49_META_TYP_1033_I7_D: "Right team icon name",
  T_49_META_TYP_1033_I8_D: "Depending on the value, the corresponding status will be displayed, Victory (1), Defeat (2).",
  T_49_META_TYP_1033_I9_D: "Victory prompt text, default if not filled in",
  T_49_META_TYP_1036_I1_D: "Indicates how many levels there are in total",
  T_49_META_TYP_1036_I2_D: "Indicates the current bot level",
  T_49_META_TYP_1037_I1_D: "Indicates how many points are displayed",
  T_49_META_TYP_1039_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_104_I0_D: "Style A",
  T_49_META_TYP_104_I1_D: "Style B",
  T_49_META_TYP_104_I2_D: "Style C",
  T_49_META_TYP_1040_I10_D: "ItemDescriptions",
  T_49_META_TYP_1040_I11_D: "Index of the selected item, start from 0, less than 0 means deselected.",
  T_49_META_TYP_1040_I12_D: "ButtonNames",
  T_49_META_TYP_1040_I13_D: "ButtonColors",
  T_49_META_TYP_1040_I2_D: "Count Down Key",
  T_49_META_TYP_1040_I3_D: "Countdown Time",
  T_49_META_TYP_1040_I4_D: "Description Key",
  T_49_META_TYP_1040_I5_D: "Array of description parameters",
  T_49_META_TYP_1040_I6_D: "ItemBackgrounds",
  T_49_META_TYP_1040_I7_D: "ItemBackgroundColors",
  T_49_META_TYP_1040_I8_D: "ItemIcons",
  T_49_META_TYP_1040_I9_D: "ItemNames",
  T_49_META_TYP_1041_I2_D: "Position",
  T_49_META_TYP_1041_I3_D: "Icon",
  T_49_META_TYP_1041_I4_D: "Label",
  T_49_META_TYP_1041_I5_D: "Background Color",
  T_49_META_TYP_1042_I1_D: "Local Position",
  T_49_META_TYP_1043_I4_D: "Color",
  T_49_META_TYP_1043_I5_D: "Label Key",
  T_49_META_TYP_1043_I6_D: "Label Params",
  T_49_META_TYP_1045_I2_D: "Button icon",
  T_49_META_TYP_1045_I3_D: "Icon Color",
  T_49_META_TYP_1045_I4_D: "Size, same width and height",
  T_49_META_TYP_1045_I5_D: "Position of the button relative to the anchor point in the lower right corner.",
  T_49_META_TYP_1045_I6_D: "Number of charge, less than 0 means hidden",
  T_49_META_TYP_1045_I7_D: "CD start time, in milliseconds",
  T_49_META_TYP_1045_I8_D: "CD duration, in milliseconds",
  T_49_META_TYP_1045_I9_D: "True, the button will be grayed out, False, it will be restored.",
  T_49_META_TYP_106_I1_D: "Enable",
  T_49_META_TYP_106_I2_D: "Disable",
  T_49_META_TYP_109_I0_D: "Chat Channel ID",
  T_49_META_TYP_109_I1_D: "Player List",
  T_49_META_TYP_11_I0_D: "Whether the current game is in illegal state, when it is in illegal state, it means the game has lost the value of confrontation, so it is recommended to end the game directly.",
  T_49_META_TYP_11_I1_D: "The length of the current game, in milliseconds.",
  T_49_META_TYP_11_I10_D: "Whether or not to reset equipment every round",
  T_49_META_TYP_11_I11_D: "Whether or not to enable out-of-zone mechanic",
  T_49_META_TYP_11_I12_D: "Safe Zone Size",
  T_49_META_TYP_11_I13_D: "Shrinking Start Time",
  T_49_META_TYP_11_I14_D: "Shrinking Duration",
  T_49_META_TYP_11_I15_D: "Out-of-Zone Damage",
  T_49_META_TYP_11_I18_D: "Revival Type",
  T_49_META_TYP_11_I2_D: "Current round index, through this value you can get the current round entity.",
  T_49_META_TYP_11_I27_D: "Total Round Count",
  T_49_META_TYP_11_I3_D: "Current phase index, by this value you can get the current phase entity.",
  T_49_META_TYP_11_I32_D: "Number of coins gained at the start of the round",
  T_49_META_TYP_11_I33_D: "Number of coins at kill",
  T_49_META_TYP_11_I34_D: "Number of coins when you win",
  T_49_META_TYP_11_I35_D: "Whether to show wallet UI",
  T_49_META_TYP_11_I36_D: "Skybox Entity",
  T_49_META_TYP_11_I37_D: "Cumulative running frames since game start",
  T_49_META_TYP_11_I38_D: "Enable Move",
  T_49_META_TYP_11_I39_D: "Whether to customize the settlement",
  T_49_META_TYP_11_I4_D: "Preset template ID for UGC mode.",
  T_49_META_TYP_11_I40_D: "Whether to allow joining in the middle of the game",
  T_49_META_TYP_11_I41_D: "Enable low frame rate mode, the game will run at 15FPS, otherwise 30FPS",
  T_49_META_TYP_11_I42_D: "Logical frame update interval between two game server updates",
  T_49_META_TYP_11_I43_D: "Fixed frame update interval in milliseconds",
  T_49_META_TYP_11_I5_D: "Disable player resurrection if off",
  T_49_META_TYP_11_I6_D: "Disable Bot resurrection if off",
  T_49_META_TYP_11_I7_D: "Resurrection time in seconds",
  T_49_META_TYP_11_I8_D: "Total number of teams in the game",
  T_49_META_TYP_11_I9_D: "Number of members in each team",
  T_49_META_TYP_110_I0_D: "ChannelA",
  T_49_META_TYP_110_I1_D: "ChannelB",
  T_49_META_TYP_110_I2_D: "ChannelC",
  T_49_META_TYP_110_I3_D: "ChannelD",
  T_49_META_TYP_110_I4_D: "ChannelE",
  T_49_META_TYP_110_I5_D: "ChannelF",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Attack",
  T_49_META_TYP_111_I3_D: "Jump",
  T_49_META_TYP_111_I4_D: "Window Jump",
  T_49_META_TYP_111_I5_D: "Drive",
  T_49_META_TYP_111_I6_D: "Enter Vehicle",
  T_49_META_TYP_111_I7_D: "Exit Vehicle",
  T_49_META_TYP_111_I8_D: "Dirve Vehicle",
  T_49_META_TYP_112_I0_D: "Enable",
  T_49_META_TYP_112_I1_D: "Disable",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Claps",
  T_49_META_TYP_117_I1_D: "Hihats",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "OpenHihats",
  T_49_META_TYP_117_I4_D: "Rides",
  T_49_META_TYP_117_I5_D: "Snares",
  T_49_META_TYP_118_I0_D: "Whether all members of the camp are in death",
  T_49_META_TYP_118_I1_D: "List of all team members",
  T_49_META_TYP_118_I2_D: "Allied Factions",
  T_49_META_TYP_118_I3_D: "Attackable Factions",
  T_49_META_TYP_118_I4_D: "Whether to show UI name",
  T_49_META_TYP_118_I5_D: "Whether to show map information",
  T_49_META_TYP_118_I6_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I7_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I8_D: "All Members",
  T_49_META_TYP_118_I9_D: "Is Show Quick Message",
  T_49_META_TYP_119_I0_D: "Yes",
  T_49_META_TYP_119_I1_D: "No",
  T_49_META_TYP_120_I1_D: "Target entity to follow, default is empty",
  T_49_META_TYP_120_I2_D: "UI color",
  T_49_META_TYP_120_I3_D: "UI length",
  T_49_META_TYP_120_I4_D: "Current progress value,0 to 1.0",
  T_49_META_TYP_120_I5_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0)",
  T_49_META_TYP_121_I0_D: "3s",
  T_49_META_TYP_121_I1_D: "5s",
  T_49_META_TYP_121_I2_D: "10s",
  T_49_META_TYP_121_I3_D: "15s",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999s",
  T_49_META_TYP_122_I0_D: "Skybox Resource",
  T_49_META_TYP_122_I1_D: "Light Color",
  T_49_META_TYP_122_I10_D: "The GUID of the sub-scene it belongs to",
  T_49_META_TYP_122_I11_D: "Fog function switch",
  T_49_META_TYP_122_I12_D: "Fog Effect Mode",
  T_49_META_TYP_122_I13_D: "Exponential fog density",
  T_49_META_TYP_122_I14_D: "Start distance of linear fog",
  T_49_META_TYP_122_I15_D: "End distance of linear fog",
  T_49_META_TYP_122_I16_D: "Turn on the fog effect feature",
  T_49_META_TYP_122_I17_D: "Rotation angle of main light source",
  T_49_META_TYP_122_I18_D: "Enable the main light source rotation angle feature",
  T_49_META_TYP_122_I2_D: "Light Intensity",
  T_49_META_TYP_122_I3_D: "Darkness",
  T_49_META_TYP_122_I4_D: "Shadow Strength",
  T_49_META_TYP_122_I5_D: "Terrain Wetness",
  T_49_META_TYP_122_I6_D: "Lens Flare",
  T_49_META_TYP_122_I7_D: "Fog Color",
  T_49_META_TYP_122_I8_D: "Ambient Color",
  T_49_META_TYP_123_I0_D: "Day",
  T_49_META_TYP_123_I1_D: "Night",
  T_49_META_TYP_123_I2_D: "Dusk",
  T_49_META_TYP_123_I3_D: "City View",
  T_49_META_TYP_123_I4_D: "Colorful Sky",
  T_49_META_TYP_123_I5_D: "Frost Moon",
  T_49_META_TYP_124_I0_D: "Close Range",
  T_49_META_TYP_124_I1_D: "Medium Range",
  T_49_META_TYP_124_I2_D: "Long range",
  T_49_META_TYP_125_I0_D: "Diffuse Color",
  T_49_META_TYP_125_I2_D: "Diffuse Texture",
  T_49_META_TYP_125_I4_D: "Diffuse Alpha",
  T_49_META_TYP_126_I1_D: "Name",
  T_49_META_TYP_126_I2_D: "Current progress value",
  T_49_META_TYP_126_I3_D: "Maximum progress value",
  T_49_META_TYP_126_I4_D: "Screen coordinate, default is Vector3(0).",
  T_49_META_TYP_126_I5_D: "length of the progress bar, default is the length of the UI on the prefab.",
  T_49_META_TYP_127_I0_D: "Panning along an axis can be combined with three axes.",
  T_49_META_TYP_127_I1_D: "Rotate along an axis, three combinations possible",
  T_49_META_TYP_127_I2_D: "Zoom along an axis, three combinations possible",
  T_49_META_TYP_128_I0_D: "Bushes",
  T_49_META_TYP_128_I1_D: "Pumpkin",
  T_49_META_TYP_128_I2_D: "Scarecrow",
  T_49_META_TYP_128_I3_D: "Cabinet",
  T_49_META_TYP_129_I0_D: "Random Loot",
  T_49_META_TYP_129_I1_D: "AR Ammo",
  T_49_META_TYP_129_I2_D: "SMG Ammo",
  T_49_META_TYP_129_I3_D: "SN Ammo",
  T_49_META_TYP_129_I4_D: "HG Ammo",
  T_49_META_TYP_129_I5_D: "SG Bullets",
  T_49_META_TYP_129_I6_D: "Bow Ammo",
  T_49_META_TYP_13_I1_D: "Anchor coordinates relative to the parent node.",
  T_49_META_TYP_13_I10_D: "Widget and anchor frame size difference",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Depth",
  T_49_META_TYP_13_I14_D: "Order of all children in the same parent node",
  T_49_META_TYP_13_I15_D: "ParentID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "Priority",
  T_49_META_TYP_13_I18_D: "Actual Position",
  T_49_META_TYP_13_I2_D: "Width",
  T_49_META_TYP_13_I4_D: "Z-axis rotation angle",
  T_49_META_TYP_13_I6_D: "Internal ID of the widget in the prefab",
  T_49_META_TYP_13_I7_D: "UI entity where it is located",
  T_49_META_TYP_13_I8_D: "Anchor Min",
  T_49_META_TYP_13_I9_D: "Anchor Max",
  T_49_META_TYP_130_I0_D: "Random Consumable Loot",
  T_49_META_TYP_130_I1_D: "MedKit",
  T_49_META_TYP_130_I2_D: "Repair Kit",
  T_49_META_TYP_130_I3_D: "Horizaline",
  T_49_META_TYP_130_I4_D: "Inhaler",
  T_49_META_TYP_131_I0_D: "Random Armor Loot",
  T_49_META_TYP_131_I1_D: "Level 1 Armor",
  T_49_META_TYP_131_I2_D: "Class II Armor",
  T_49_META_TYP_131_I3_D: "Tier 3 Armor",
  T_49_META_TYP_132_I0_D: "Random Throwing Object Loot",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Flash Freeze",
  T_49_META_TYP_133_I0_D: "Random Multiplier Loot",
  T_49_META_TYP_133_I1_D: "2x Scope",
  T_49_META_TYP_133_I2_D: "4x Scope",
  T_49_META_TYP_133_I3_D: "Thermal Scope",
  T_49_META_TYP_134_I0_D: "Random Weapon Loot",
  T_49_META_TYP_134_I5_D: "Shotgun",
  T_49_META_TYP_134_I8_D: "Football Gun",
  T_49_META_TYP_135_I0_D: "Loot bullet points",
  T_49_META_TYP_136_I0_D: "Loot Consumable Points",
  T_49_META_TYP_137_I0_D: "Loot Consumable Points",
  T_49_META_TYP_138_I0_D: "Loot Multiplier Points",
  T_49_META_TYP_139_I0_D: "Loot Armor Points",
  T_49_META_TYP_14_I0_D: "Player's current blood level",
  T_49_META_TYP_14_I1_D: "Player's current blood maximum",
  T_49_META_TYP_14_I11_D: "The player's camp",
  T_49_META_TYP_14_I12_D: "The player's damage multiplier, e.g. 2x configured as 2.0",
  T_49_META_TYP_14_I13_D: "Use the exact same rig as the male or female character, 0 means no model replacement",
  T_49_META_TYP_14_I14_D: "Does not conflict with existing velocity scaling",
  T_49_META_TYP_14_I15_D: "Does not conflict with existing jump height scaling",
  T_49_META_TYP_14_I16_D: "Identity,0 Normal Player,1 Hunter,2 Matrix Zombie,3 Normal Zombie,4 Evolved Zombie Type 1, 5 Evolved Zombie Type 2,6 Evolved Zombie Type 3",
  T_49_META_TYP_14_I17_D: "Zombie level, 1~3",
  T_49_META_TYP_14_I19_D: "Player's nickname",
  T_49_META_TYP_14_I2_D: "Determine the current player is AI player, AI is usually NPC or PVE monster",
  T_49_META_TYP_14_I20_D: "Percentage of damage dealt when taking damage, can be reduced or increased",
  T_49_META_TYP_14_I21_D: "Player's current EP",
  T_49_META_TYP_14_I22_D: "Player's maximum EP",
  T_49_META_TYP_14_I23_D: "Primary weapon currently in hand.",
  T_49_META_TYP_14_I24_D: "Is Drop on Eliminated",
  T_49_META_TYP_14_I26_D: "Aim Assist Type",
  T_49_META_TYP_14_I27_D: "Allow Lock by Aim Assist",
  T_49_META_TYP_14_I28_D: "Switch voice chat on/off: true to turn off voice, false to turn on voice",
  T_49_META_TYP_14_I29_D: "Switch quick chat: trueClose voice, falseOpen voice",
  T_49_META_TYP_14_I3_D: "Player Status",
  T_49_META_TYP_14_I30_D: "Channel",
  T_49_META_TYP_14_I35_D: "Switch pickup: trueCan't pickup, falseCan pickup",
  T_49_META_TYP_14_I36_D: "Toggle Discard Item: trueCan't discard, falseCan discard",
  T_49_META_TYP_14_I37_D: "Attackable Targets",
  T_49_META_TYP_14_I38_D: "Friendly Players",
  T_49_META_TYP_14_I39_D: "Faction",
  T_49_META_TYP_14_I4_D: "The player's survival time, if the player dies, the time will be recalculated.",
  T_49_META_TYP_14_I40_D: "Number in Faction",
  T_49_META_TYP_14_I41_D: "Camera the player is using",
  T_49_META_TYP_14_I42_D: "Custom Gravity",
  T_49_META_TYP_14_I43_D: "Helmet",
  T_49_META_TYP_14_I44_D: "Vest",
  T_49_META_TYP_14_I5_D: "Player's invincibility",
  T_49_META_TYP_14_I52_D: "User UID",
  T_49_META_TYP_14_I53_D: "Headshot Damage Reduction",
  T_49_META_TYP_14_I54_D: "AVATAR the player is bound to",
  T_49_META_TYP_14_I55_D: "Gender",
  T_49_META_TYP_14_I56_D: "Weapon Skin IDs",
  T_49_META_TYP_14_I57_D: "Player's spwan point",
  T_49_META_TYP_14_I58_D: "Player's resurrection point, if no checkpoints are recorded then the spwan point is used, otherwise checkpoints are used",
  T_49_META_TYP_14_I59_D: "Player's current position",
  T_49_META_TYP_14_I6_D: "The entity of the team the player belongs to",
  T_49_META_TYP_14_I60_D: "The player's current orientation",
  T_49_META_TYP_14_I61_D: "The node used to access the skinned rigs",
  T_49_META_TYP_14_I62_D: "Backpack",
  T_49_META_TYP_14_I63_D: "Temporary Shield Points",
  T_49_META_TYP_14_I64_D: "Vehicle Skin ID",
  T_49_META_TYP_14_I65_D: "Is Skip Stagger Animation",
  T_49_META_TYP_14_I66_D: "Is No Fall Damage",
  T_49_META_TYP_14_I67_D: "Current Handheld Item",
  T_49_META_TYP_14_I68_D: "Item Pickup Banlist",
  T_49_META_TYP_14_I69_D: "Player's resource ID",
  T_49_META_TYP_14_I7_D: "Current checkpoint ID",
  T_49_META_TYP_14_I70_D: "The target to which the Request Purchase message was sent",
  T_49_META_TYP_14_I71_D: "The resource ID of the currently playing Emote",
  T_49_META_TYP_14_I72_D: "Whether the currently playing Emote is looping or not",
  T_49_META_TYP_14_I73_D: "Handling of knockdown status",
  T_49_META_TYP_14_I74_D: "Whether to enable damage skipping, the default is True, which means it's enabled.",
  T_49_META_TYP_14_I76_D: "Whether to quit in the middle of the game",
  T_49_META_TYP_14_I77_D: "Clothing information to be kept when the player transforms into another character",
  T_49_META_TYP_14_I8_D: "ID of the checkpoint the target is traveling to",
  T_49_META_TYP_140_I0_D: "Wave 1",
  T_49_META_TYP_140_I1_D: "Wave 2",
  T_49_META_TYP_140_I2_D: "Wave 3",
  T_49_META_TYP_140_I3_D: "Continuous",
  T_49_META_TYP_141_I0_D: "Loot Soccer Random",
  T_49_META_TYP_141_I1_D: "Loot Soccer Shield",
  T_49_META_TYP_141_I2_D: "Freezing Grenade",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (Shooting)",
  T_49_META_TYP_147_I1_D: "Third Person",
  T_49_META_TYP_147_I2_D: "First Person (Shooting)",
  T_49_META_TYP_147_I3_D: "Top-down perspective",
  T_49_META_TYP_147_I4_D: "Horizontal Scroll",
  T_49_META_TYP_147_I5_D: "Custom",
  T_49_META_TYP_147_I6_D: "Backchase",
  T_49_META_TYP_147_I7_D: "Player-controlled, free-moving camera",
  T_49_META_TYP_147_I8_D: "New version of the first person view camera",
  T_49_META_TYP_148_I0_D: "Provide many preset camera types and customized camera types.",
  T_49_META_TYP_148_I1_D: "Field of view is the camera's viewing angle",
  T_49_META_TYP_148_I10_D: "Camera Switch Animation Type",
  T_49_META_TYP_148_I11_D: "Transition time to this camera in milliseconds, only if the switch type is smooth.",
  T_49_META_TYP_148_I12_D: "Motion mode of the camera when there is an occlusion between the camera and the target.",
  T_49_META_TYP_148_I13_D: "How the camera renders the screen",
  T_49_META_TYP_148_I14_D: "Follow object offset reference coordinate system",
  T_49_META_TYP_148_I15_D: "Observing object offset reference coordinate system",
  T_49_META_TYP_148_I16_D: "The camera's rendering layer mask, which allows filtering the camera's rendered objects by visibility level",
  T_49_META_TYP_148_I17_D: "Viewing Angle Restriction",
  T_49_META_TYP_148_I2_D: "Generally refers to the offset of the camera's position from the player's home position, with different meanings for different camera types.",
  T_49_META_TYP_148_I3_D: "FOV is the offset of the camera's focus point from the player's home position, which varies by camera type.",
  T_49_META_TYP_148_I4_D: "Angle of rotation of the camera in the vertical direction",
  T_49_META_TYP_148_I5_D: "The angle of rotation of the camera in the horizontal direction.",
  T_49_META_TYP_148_I7_D: "The target that the camera is following",
  T_49_META_TYP_148_I8_D: "The target that the camera is looking at",
  T_49_META_TYP_148_I9_D: "The player who is using the camera",
  T_49_META_TYP_15_I0_D: "Whether all players in the team are currently dead",
  T_49_META_TYP_15_I1_D: "List of all players in the team",
  T_49_META_TYP_15_I3_D: "Hostile team list",
  T_49_META_TYP_15_I4_D: "List of friendly teams",
  T_49_META_TYP_15_I5_D: "Team number",
  T_49_META_TYP_150_I0_D: "Durability",
  T_49_META_TYP_150_I1_D: "The radius of the hemispheres at the ends of the capsule body.",
  T_49_META_TYP_150_I2_D: "Damage Factor",
  T_49_META_TYP_152_I1_D: "Custom Gravity",
  T_49_META_TYP_152_I2_D: "If or not need to show the trigger, True is show.",
  T_49_META_TYP_154_I0_D: "Cannot be dual-wielded",
  T_49_META_TYP_154_I1_D: "Can only be dual-wielded in combination with the same gun",
  T_49_META_TYP_154_I2_D: "Can be combo dual-wielded with another weapon as well as yourself",
  T_49_META_TYP_155_I0_D: "Level",
  T_49_META_TYP_155_I1_D: "Max. Durability",
  T_49_META_TYP_155_I2_D: "Current Durability",
  T_49_META_TYP_155_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_155_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_155_I5_D: "Can Cost Durability",
  T_49_META_TYP_155_I6_D: "Can Destroy",
  T_49_META_TYP_156_I1_D: "Max. Durability",
  T_49_META_TYP_156_I2_D: "Current Durability",
  T_49_META_TYP_156_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_156_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_156_I5_D: "Can Cost Durability",
  T_49_META_TYP_156_I6_D: "Can Destroy",
  T_49_META_TYP_157_I0_D: "No Animation",
  T_49_META_TYP_157_I1_D: "Smooth",
  T_49_META_TYP_158_I2_D: "UI anchor type enumeration, default value is 9 (Center)",
  T_49_META_TYP_158_I6_D: "Label Key",
  T_49_META_TYP_158_I7_D: "Label Params",
  T_49_META_TYP_158_I8_D: "Tweener Enabled",
  T_49_META_TYP_16_I1_D: "Item ID of the entity",
  T_49_META_TYP_16_I2_D: "Only for static loading of objects, to determine if the NavMesh is statically generated.",
  T_49_META_TYP_16_I3_D: "Whether it is dynamic blocking of NavMesh or not",
  T_49_META_TYP_16_I4_D: "Asynchronous loading",
  T_49_META_TYP_160_I0_D: "Brick A",
  T_49_META_TYP_160_I1_D: "Tile A",
  T_49_META_TYP_160_I10_D: "Sand A",
  T_49_META_TYP_160_I11_D: "Snow A",
  T_49_META_TYP_160_I12_D: "Wood A",
  T_49_META_TYP_160_I13_D: "Stone A",
  T_49_META_TYP_160_I14_D: "Lawn B",
  T_49_META_TYP_160_I15_D: "Brick B",
  T_49_META_TYP_160_I16_D: "Brick C",
  T_49_META_TYP_160_I17_D: "Clear",
  T_49_META_TYP_160_I2_D: "Tile B",
  T_49_META_TYP_160_I3_D: "Tile C",
  T_49_META_TYP_160_I4_D: "Bamboo A",
  T_49_META_TYP_160_I5_D: "Cement A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Lawn A",
  T_49_META_TYP_160_I8_D: "Ice A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Whether to enable collision",
  T_49_META_TYP_165_I1_D: "Whether or not to act as a trigger",
  T_49_META_TYP_165_I2_D: "Physical layers, configure layers in the physics module, up to 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "VFX Texture Type",
  T_49_META_TYP_170_I0_D: "Visible or not, client stops rendering the target when it is not visible.",
  T_49_META_TYP_170_I1_D: "Visibility level, value in the range [0,15], affects the visibility in the camera.",
  T_49_META_TYP_171_I0_D: "Energy",
  T_49_META_TYP_172_I0_D: "Number of bullets",
  T_49_META_TYP_173_I0_D: "Extra Backpack Capacity",
  T_49_META_TYP_173_I1_D: "Priority of Skin configuration outside of the player's station.",
  T_49_META_TYP_173_I2_D: "Skin ID of the backpack, Skin configuration of the backpack itself",
  T_49_META_TYP_174_I2_D: "Max. Damage",
  T_49_META_TYP_174_I4_D: "Throw Speed",
  T_49_META_TYP_174_I5_D: "Explosion delay, in seconds",
  T_49_META_TYP_174_I6_D: "Self-Damage Factor",
  T_49_META_TYP_174_I7_D: "Friendly Fire DMG Coeff.",
  T_49_META_TYP_174_I8_D: "Ratio Vehicle Factor",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Freeze Zone Radius",
  T_49_META_TYP_175_I1_D: "Frozen area duration in seconds",
  T_49_META_TYP_176_I0_D: "Weapon's primary type",
  T_49_META_TYP_176_I1_D: "Weapon Subtype",
  T_49_META_TYP_177_I0_D: "When there is an obstacle between the camera and the object to be followed, the camera will not change.",
  T_49_META_TYP_177_I1_D: "When there is an obstacle between the camera and the object to follow, the camera will be pushed closer to the object to follow.",
  T_49_META_TYP_177_I2_D: "When there is an occlusion between the camera and the object, the occlusion will become translucent.",
  T_49_META_TYP_178_I0_D: "When the camera looks at the object, the near object is big and the far object is small",
  T_49_META_TYP_178_I1_D: "Near and far objects are the same size when the camera is looking at them.",
  T_49_META_TYP_184_I0_D: "The UUID of the resource to be rendered.",
  T_49_META_TYP_185_I0_D: "Model mesh to use for rendering",
  T_49_META_TYP_185_I1_D: "The list of materials to use for rendering",
  T_49_META_TYP_187_I0_D: "Item ID",
  T_49_META_TYP_190_I0_D: "Open status",
  T_49_META_TYP_190_I1_D: "Match result",
  T_49_META_TYP_190_I10_D: "Scores1",
  T_49_META_TYP_190_I11_D: "Scores2",
  T_49_META_TYP_190_I12_D: "Scores3",
  T_49_META_TYP_190_I13_D: "Win MVPs",
  T_49_META_TYP_190_I14_D: "Lose MVPs",
  T_49_META_TYP_190_I15_D: "Show Match Details",
  T_49_META_TYP_190_I16_D: "Show Map Ratings",
  T_49_META_TYP_190_I17_D: "Show Gift",
  T_49_META_TYP_190_I18_D: "Show Report",
  T_49_META_TYP_190_I19_D: "Show Replay",
  T_49_META_TYP_190_I20_D: "Show Share",
  T_49_META_TYP_190_I21_D: "Show Lobby",
  T_49_META_TYP_190_I22_D: "Show Like",
  T_49_META_TYP_190_I23_D: "Show Add Friend",
  T_49_META_TYP_190_I24_D: "Show Ecconomy",
  T_49_META_TYP_190_I4_D: "Left Team",
  T_49_META_TYP_190_I5_D: "Right Team",
  T_49_META_TYP_190_I6_D: "Player Rank",
  T_49_META_TYP_190_I9_D: "Titles",
  T_49_META_TYP_191_I0_D: "Center Range",
  T_49_META_TYP_191_I4_D: "Center flash duration in milliseconds",
  T_49_META_TYP_191_I5_D: "Edge flash duration in milliseconds",
  T_49_META_TYP_191_I6_D: "Flashbang Hit Effect Switch",
  T_49_META_TYP_192_I3_D: "Duration of effect, in seconds",
  T_49_META_TYP_193_I1_D: "Match Title Left",
  T_49_META_TYP_193_I10_D: "Scores1",
  T_49_META_TYP_193_I11_D: "Scores2",
  T_49_META_TYP_193_I12_D: "Scores3",
  T_49_META_TYP_193_I13_D: "Scores4",
  T_49_META_TYP_193_I14_D: "Scores5",
  T_49_META_TYP_193_I15_D: "Win MVPs",
  T_49_META_TYP_193_I16_D: "Lose MVPs",
  T_49_META_TYP_193_I17_D: "Show Match Details",
  T_49_META_TYP_193_I18_D: "Show Map Ratings",
  T_49_META_TYP_193_I19_D: "Show Gift",
  T_49_META_TYP_193_I2_D: "Match Title Right",
  T_49_META_TYP_193_I20_D: "Show Report",
  T_49_META_TYP_193_I21_D: "Show Replay",
  T_49_META_TYP_193_I22_D: "Show Share",
  T_49_META_TYP_193_I23_D: "Show Lobby",
  T_49_META_TYP_193_I24_D: "Show Like",
  T_49_META_TYP_193_I25_D: "Show Add Friend",
  T_49_META_TYP_193_I26_D: "Show Ecconomy",
  T_49_META_TYP_193_I3_D: "Match result",
  T_49_META_TYP_193_I4_D: "Team Rank",
  T_49_META_TYP_193_I5_D: "Player Rank",
  T_49_META_TYP_193_I6_D: "Name of the team",
  T_49_META_TYP_193_I7_D: "Main Score Title",
  T_49_META_TYP_193_I8_D: "Main Scores",
  T_49_META_TYP_193_I9_D: "Titles",
  T_49_META_TYP_194_I0_D: "Time for the mine to take effect, in seconds",
  T_49_META_TYP_194_I1_D: "Trigger radius",
  T_49_META_TYP_194_I2_D: "Length of time it takes to trigger a mine within the mine's range, in seconds",
  T_49_META_TYP_194_I3_D: "Can Self Trigger",
  T_49_META_TYP_194_I4_D: "Can Teammates Trigger",
  T_49_META_TYP_194_I5_D: "Can Triggered by Vehicle",
  T_49_META_TYP_194_I6_D: "Duration of the mine's existence, which automatically explodes when it ends, from the time it is dropped, in units of seconds",
  T_49_META_TYP_194_I7_D: "Is Attackable",
  T_49_META_TYP_194_I8_D: "Life value",
  T_49_META_TYP_195_I0_D: "Once",
  T_49_META_TYP_195_I2_D: "Reciprocation",
  T_49_META_TYP_197_I0_D: "Whether the wave is playing or not",
  T_49_META_TYP_197_I1_D: "Flag bit",
  T_49_META_TYP_197_I2_D: "If checked, it will be played automatically upon creation.",
  T_49_META_TYP_198_I0_D: "The prop id of the accessory.",
  T_49_META_TYP_199_I0_D: "Max EP",
  T_49_META_TYP_199_I1_D: "Energy Cost",
  T_49_META_TYP_199_I10_D: "Fall Damage Ratio",
  T_49_META_TYP_199_I11_D: "Current Energy",
  T_49_META_TYP_199_I2_D: "UpEnergy Cost",
  T_49_META_TYP_199_I3_D: "Sprint Energy Cost",
  T_49_META_TYP_199_I4_D: "Rush Energy Cost",
  T_49_META_TYP_199_I5_D: "Base Horizontal Speed",
  T_49_META_TYP_199_I6_D: "Sprint Horizontal Speed",
  T_49_META_TYP_199_I7_D: "Base Vertical Speed",
  T_49_META_TYP_199_I8_D: "Sprint Vertical Speed",
  T_49_META_TYP_199_I9_D: "Sprint Distance",
  T_49_META_TYP_200_I0_D: "Area ID",
  T_49_META_TYP_200_I1_D: "Game ID",
  T_49_META_TYP_201_I0_D: "Percentage of slowdown: Percentage of slowdown of movement speed in open water for water objects",
  T_49_META_TYP_203_I0_D: "target entity",
  T_49_META_TYP_203_I1_D: "Prop ID",
  T_49_META_TYP_203_I10_D: "The moment when the game server starts ticking",
  T_49_META_TYP_203_I11_D: "Start Value",
  T_49_META_TYP_203_I12_D: "End Value",
  T_49_META_TYP_203_I13_D: "Percentage passed",
  T_49_META_TYP_203_I4_D: "Tween Style",
  T_49_META_TYP_203_I6_D: "Duration (s)",
  T_49_META_TYP_203_I7_D: "Is Reverse",
  T_49_META_TYP_203_I8_D: "Control Points",
  T_49_META_TYP_203_I9_D: "Forced synchronization of the game server state",
  T_49_META_TYP_204_I0_D: "Max. Double Jump Height",
  T_49_META_TYP_204_I1_D: "Fall Damage Percentage",
  T_49_META_TYP_204_I2_D: "Energy Recovery",
  T_49_META_TYP_204_I3_D: "Energy consumption",
  T_49_META_TYP_204_I4_D: "Max. Energy",
  T_49_META_TYP_205_I0_D: "Min. Fly Height",
  T_49_META_TYP_205_I1_D: "Min. End Height",
  T_49_META_TYP_205_I2_D: "Horizontal Glide Speed",
  T_49_META_TYP_205_I3_D: "Vertical Glide Speed",
  T_49_META_TYP_205_I4_D: "Fall Speed",
  T_49_META_TYP_205_I5_D: "Turning Speed",
  T_49_META_TYP_205_I6_D: "Fly Max. Height",
  T_49_META_TYP_205_I7_D: "Overheight Fall Speed",
  T_49_META_TYP_205_I8_D: "Speed change acceleration",
  T_49_META_TYP_206_I0_D: "Velocity",
  T_49_META_TYP_206_I1_D: "Acceleration",
  T_49_META_TYP_206_I10_D: "Maximum steering angle at high speed",
  T_49_META_TYP_206_I11_D: "Tween base rate of high speed steering angle",
  T_49_META_TYP_206_I2_D: "Sprint Speed",
  T_49_META_TYP_206_I3_D: "Duration of sprint, in seconds",
  T_49_META_TYP_206_I4_D: "Sprint cooldown, in seconds",
  T_49_META_TYP_206_I6_D: "Jump CD, in seconds",
  T_49_META_TYP_206_I7_D: "Sprint CD after boarding, in seconds",
  T_49_META_TYP_206_I8_D: "Get On Boost CD Switch",
  T_49_META_TYP_206_I9_D: "Get on board CD, in seconds",
  T_49_META_TYP_207_I1_D: "Start Index",
  T_49_META_TYP_207_I2_D: "End Position",
  T_49_META_TYP_207_I3_D: "Slide ID",
  T_49_META_TYP_207_I4_D: "Group ID",
  T_49_META_TYP_207_I5_D: "End or not",
  T_49_META_TYP_21_I0_D: "The base level of the UI",
  T_49_META_TYP_210_I1_D: "Initial Velocity",
  T_49_META_TYP_210_I2_D: "Acceleration",
  T_49_META_TYP_210_I3_D: "Max. Displacement",
  T_49_META_TYP_210_I4_D: "InitialWorldPosition",
  T_49_META_TYP_210_I5_D: "Forced synchronization of position information by game server",
  T_49_META_TYP_211_I0_D: "Local Position",
  T_49_META_TYP_211_I1_D: "World Position",
  T_49_META_TYP_212_I0_D: "Self",
  T_49_META_TYP_212_I2_D: "Offset coordinate",
  T_49_META_TYP_213_I0_D: "Self",
  T_49_META_TYP_213_I2_D: "Offset coordinate",
  T_49_META_TYP_215_I0_D: "Victory",
  T_49_META_TYP_215_I1_D: "Defeat",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Draw",
  T_49_META_TYP_218_I0_D: "Intensity",
  T_49_META_TYP_218_I1_D: "Range",
  T_49_META_TYP_218_I2_D: "Light color",
  T_49_META_TYP_22_I0_D: "Displayed if on is true, off otherwise",
  T_49_META_TYP_22_I1_D: "Prefab ID",
  T_49_META_TYP_22_I2_D: "The ID of the current largest widget",
  T_49_META_TYP_22_I3_D: "Base level of UI",
  T_49_META_TYP_22_I4_D: "Enable Player View",
  T_49_META_TYP_22_I5_D: "World Position",
  T_49_META_TYP_22_I6_D: "Whether or not it is in the Scene",
  T_49_META_TYP_22_I7_D: "Rotation in the world coordinate system",
  T_49_META_TYP_22_I8_D: "Zoom in the world coordinate system",
  T_49_META_TYP_221_I0_D: "The larger the value, the slower the speed of gear change.",
  T_49_META_TYP_222_I0_D: "Gear switching delay, the larger this value is, the slower the gear changes.",
  T_49_META_TYP_225_I0_D: "Turret Damage",
  T_49_META_TYP_225_I1_D: "Damage Interval (s)",
  T_49_META_TYP_225_I10_D: "Fire only at an angle",
  T_49_META_TYP_225_I11_D: "Damage Reduction Rate",
  T_49_META_TYP_225_I12_D: "Armor Penetration",
  T_49_META_TYP_225_I2_D: "Accuracy",
  T_49_META_TYP_225_I3_D: "Range",
  T_49_META_TYP_225_I4_D: "Angular Speed",
  T_49_META_TYP_225_I5_D: "Angle Up",
  T_49_META_TYP_225_I6_D: "Angle Down",
  T_49_META_TYP_225_I7_D: "Max. HP",
  T_49_META_TYP_225_I8_D: "Life Time (s)",
  T_49_META_TYP_225_I9_D: "Max. Turret Count",
  T_49_META_TYP_226_I0_D: "Turret current life value",
  T_49_META_TYP_226_I1_D: "Enable Attack",
  T_49_META_TYP_227_I0_D: "Simple Widget",
  T_49_META_TYP_227_I1_D: "Image Widget",
  T_49_META_TYP_227_I10_D: "Texture Widget",
  T_49_META_TYP_227_I11_D: "Profile Widget",
  T_49_META_TYP_227_I12_D: "Toggle Widget",
  T_49_META_TYP_227_I13_D: "Touch Pad Widget",
  T_49_META_TYP_227_I14_D: "Joystick Widget",
  T_49_META_TYP_227_I15_D: "Social Button Widget",
  T_49_META_TYP_227_I2_D: "Label Widget",
  T_49_META_TYP_227_I3_D: "Button Widget",
  T_49_META_TYP_227_I4_D: "Input Label Widget",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Scroll Panel",
  T_49_META_TYP_227_I7_D: "Grid",
  T_49_META_TYP_227_I8_D: "Layout Widget",
  T_49_META_TYP_227_I9_D: "Container Widget",
  T_49_META_TYP_231_I0_D: "Durability Recovery",
  T_49_META_TYP_231_I1_D: "Effective time interval, in seconds",
  T_49_META_TYP_233_I2_D: "Time to expiration, in seconds",
  T_49_META_TYP_233_I4_D: "Icon resource name",
  T_49_META_TYP_234_I0_D: "Trigger time, in seconds",
  T_49_META_TYP_234_I1_D: "Can Self Trigger",
  T_49_META_TYP_234_I10_D: "Current life value",
  T_49_META_TYP_234_I2_D: "Can Teammates Trigger",
  T_49_META_TYP_234_I3_D: "Can Triggered by Vehicle",
  T_49_META_TYP_234_I4_D: "Duration in seconds",
  T_49_META_TYP_234_I5_D: "Is Attackable",
  T_49_META_TYP_234_I6_D: "Life value",
  T_49_META_TYP_235_I0_D: "Maximum life value",
  T_49_META_TYP_235_I2_D: "Max. Count",
  T_49_META_TYP_237_I0_D: "Throw Speed",
  T_49_META_TYP_237_I1_D: "Player Traction Speed",
  T_49_META_TYP_238_I0_D: "Spray Color",
  T_49_META_TYP_239_I0_D: "Initial speed",
  T_49_META_TYP_239_I1_D: "Acceleration speed (e.g. gravity)",
  T_49_META_TYP_24_I0_D: "Melee",
  T_49_META_TYP_24_I1_D: "Gun",
  T_49_META_TYP_24_I10_D: "Airdrop hit damage, monster suicide damage",
  T_49_META_TYP_24_I11_D: "Burning Damage on Vehicle Explosion",
  T_49_META_TYP_24_I12_D: "Oil Drum Explosion",
  T_49_META_TYP_24_I13_D: "Missile-Type Weapon",
  T_49_META_TYP_24_I14_D: "Monster",
  T_49_META_TYP_24_I15_D: "Damage Zone",
  T_49_META_TYP_24_I17_D: "Character Skill",
  T_49_META_TYP_24_I2_D: "Throw Attack",
  T_49_META_TYP_24_I3_D: "Safe Zone",
  T_49_META_TYP_24_I4_D: "Vehicle",
  T_49_META_TYP_24_I5_D: "Falling",
  T_49_META_TYP_24_I6_D: "KillZone",
  T_49_META_TYP_24_I7_D: "Exit",
  T_49_META_TYP_24_I8_D: "Disconnect",
  T_49_META_TYP_24_I9_D: "Vehicle Explosion",
  T_49_META_TYP_241_I0_D: "Traction speed",
  T_49_META_TYP_241_I1_D: "Swing speed",
  T_49_META_TYP_241_I2_D: "Turn on traction button",
  T_49_META_TYP_241_I3_D: "Turn on swing button",
  T_49_META_TYP_241_I4_D: "Motion anchor point",
  T_49_META_TYP_241_I5_D: "Swing Exit Acceleration",
  T_49_META_TYP_242_I2_D: "Left Effect Active",
  T_49_META_TYP_242_I3_D: "Right Effect Active",
  T_49_META_TYP_242_I4_D: "Central Line Active",
  T_49_META_TYP_242_I5_D: "Value",
  T_49_META_TYP_242_I7_D: "UI position, only the XY component is active",
  T_49_META_TYP_242_I8_D: "Position of the median [0,1]",
  T_49_META_TYP_243_I0_D: "Top Wear",
  T_49_META_TYP_243_I1_D: "Bottom Wear",
  T_49_META_TYP_243_I2_D: "Shoes",
  T_49_META_TYP_243_I3_D: "Facepaint",
  T_49_META_TYP_243_I4_D: "Headwear",
  T_49_META_TYP_243_I5_D: "Bodysuit",
  T_49_META_TYP_243_I6_D: "Facepaint",
  T_49_META_TYP_244_I0_D: "Text content to be displayed",
  T_49_META_TYP_244_I10_D: "List of players who can see this entity",
  T_49_META_TYP_244_I11_D: "Display level",
  T_49_META_TYP_244_I2_D: "Follow Target",
  T_49_META_TYP_244_I3_D: "When depth is ignored it can be displayed through the wall, otherwise it won't work",
  T_49_META_TYP_244_I4_D: "Always Facing Camera",
  T_49_META_TYP_244_I5_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_244_I6_D: "Font Style",
  T_49_META_TYP_244_I7_D: "Font type",
  T_49_META_TYP_244_I8_D: "Font size",
  T_49_META_TYP_245_I0_D: "Effect Resource Path",
  T_49_META_TYP_245_I11_D: "Display Layers",
  T_49_META_TYP_245_I3_D: "When ignore depth, it can be displayed through the wall, otherwise it won't work.",
  T_49_META_TYP_245_I4_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_245_I5_D: "Always Facing Camera",
  T_49_META_TYP_245_I6_D: "Render Type",
  T_49_META_TYP_245_I7_D: "Width",
  T_49_META_TYP_246_I0_D: "Orange",
  T_49_META_TYP_246_I1_D: "Purple",
  T_49_META_TYP_246_I2_D: "Red",
  T_49_META_TYP_246_I3_D: "Green",
  T_49_META_TYP_246_I4_D: "Blue",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Quick Chat",
  T_49_META_TYP_247_I16_D: "Pickups",
  T_49_META_TYP_247_I17_D: "Quick Chat Show",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "Attack",
  T_49_META_TYP_247_I20_D: "Armor",
  T_49_META_TYP_247_I21_D: "Reload",
  T_49_META_TYP_247_I22_D: "Quick Change Button",
  T_49_META_TYP_247_I23_D: "Carrier Speaker Button",
  T_49_META_TYP_247_I24_D: "Enable/disable voice (microphone) button",
  T_49_META_TYP_247_I25_D: "Enable/disable marker button",
  T_49_META_TYP_247_I27_D: "Enable/disable network signal button",
  T_49_META_TYP_247_I28_D: "Active Skill",
  T_49_META_TYP_247_I29_D: "Crosshair",
  T_49_META_TYP_247_I3_D: "Jump",
  T_49_META_TYP_247_I30_D: "Passive Skill",
  T_49_META_TYP_247_I4_D: "Killing Tips",
  T_49_META_TYP_247_I5_D: "Weapon Slot",
  T_49_META_TYP_247_I6_D: "Mini Map",
  T_49_META_TYP_247_I7_D: "Backpack UI",
  T_49_META_TYP_247_I8_D: "Medical Items",
  T_49_META_TYP_247_I9_D: "Displayed when True, otherwise turned off",
  T_49_META_TYP_249_I3_D: "Demolition weapons",
  T_49_META_TYP_249_I5_D: "HeavyWeapon",
  T_49_META_TYP_249_I8_D: "Freeze Bomb",
  T_49_META_TYP_249_I9_D: "DummyGrenade",
  T_49_META_TYP_25_I0_D: "Index of the current phase, corresponding to the index in the flow editor",
  T_49_META_TYP_25_I1_D: "Start time of the current phase, in ms.",
  T_49_META_TYP_25_I2_D: "The end time of the current phase in ms.",
  T_49_META_TYP_25_I3_D: "Duration of the current phase in ms.",
  T_49_META_TYP_250_I1_D: "Special effect color, RGBA four channels, single channel value range 0~255, stored in an Int32.",
  T_49_META_TYP_250_I3_D: "VFX Texture Type",
  T_49_META_TYP_250_I4_D: "Diffuse Alpha",
  T_49_META_TYP_2500_I1_D: "Is Default Spawn Point",
  T_49_META_TYP_2500_I3_D: "Whether or not a player has already been born in the birth point area.",
  T_49_META_TYP_2500_I4_D: "The coordinates of the currently assignable birth point location",
  T_49_META_TYP_2502_I0_D: "Whether it is a death trigger, when it is not a death trigger it is an invincibility trigger. (This is a legacy issue from OB32, please split the function in the future!)",
  T_49_META_TYP_2502_I1_D: "Whether to show trigger border, true for show",
  T_49_META_TYP_2503_I0_D: "Checkpoint ID",
  T_49_META_TYP_2503_I2_D: "Location of checkpoints",
  T_49_META_TYP_2507_I0_D: "Which camp the tower belongs to, if it is the same as the player, it won't attack the player.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "Object ID",
  T_49_META_TYP_2507_I2_D: "Max. HP",
  T_49_META_TYP_2507_I3_D: "Attack damage, the damage that can be done to the player by a single attack.",
  T_49_META_TYP_2507_I4_D: "The interval between attacks, in seconds.",
  T_49_META_TYP_2507_I5_D: "Attacks can be made in a radius from the center of the tower.",
  T_49_META_TYP_2507_I6_D: "Damage reduction rate, a decimal number less than 1, the final damage is the damage multiplied by (1 - damage reduction rate)",
  T_49_META_TYP_2507_I7_D: "Attack Target",
  T_49_META_TYP_2507_I8_D: "Angle",
  T_49_META_TYP_2507_I9_D: "Mini Sentry Status",
  T_49_META_TYP_2508_I0_D: "How many zombies will be spawned in each wave",
  T_49_META_TYP_2508_I1_D: "How many waves of zombies will be spawned in total",
  T_49_META_TYP_2508_I2_D: "Whether to spawn continuously, but there will be an upper limit for the same screen.",
  T_49_META_TYP_2508_I3_D: "How many waves will be spawned in the current wave?",
  T_49_META_TYP_2508_I5_D: "What kind of zombies are spawned in the current wave",
  T_49_META_TYP_2508_I6_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_2508_I7_D: "Start Spawn Time (s)",
  T_49_META_TYP_2508_I8_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I0_D: "The number of unit bodies that will be generated in each wave",
  T_49_META_TYP_2509_I1_D: "How many waves of unit generators will be generated in total",
  T_49_META_TYP_2509_I2_D: "How many waves are currently generated",
  T_49_META_TYP_2509_I4_D: "Which entity will be used as a template for each wave of generation",
  T_49_META_TYP_2509_I5_D: "When the units will start generating",
  T_49_META_TYP_2509_I6_D: "Whether or not to spawn consecutively, but there will be an upper limit of the same screen",
  T_49_META_TYP_2509_I7_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I8_D: "The prefabID of the template",
  T_49_META_TYP_2510_I0_D: "Spawn Point Count",
  T_49_META_TYP_252_I1_D: "Left Icon",
  T_49_META_TYP_252_I2_D: "Left Text",
  T_49_META_TYP_252_I3_D: "Left Score",
  T_49_META_TYP_252_I5_D: "Right Icon",
  T_49_META_TYP_252_I6_D: "Right Text",
  T_49_META_TYP_252_I7_D: "Right Score",
  T_49_META_TYP_252_I8_D: "Progress [0,1]",
  T_49_META_TYP_253_I0_D: "Select Icon",
  T_49_META_TYP_253_I1_D: "Text",
  T_49_META_TYP_253_I2_D: "Show Effect",
  T_49_META_TYP_253_I3_D: "UI position",
  T_49_META_TYP_254_I1_D: "For example, 1.25 means 1.25 times the normal speed.",
  T_49_META_TYP_254_I2_D: "Color",
  T_49_META_TYP_256_I0_D: "Completely stationary. Minimum Performance",
  T_49_META_TYP_256_I1_D: "Normal force application. Least performance",
  T_49_META_TYP_256_I2_D: "Motion can be controlled by scripting and can be considered as mass infinite",
  T_49_META_TYP_257_I0_D: "Functions of different types of rigid bodies",
  T_49_META_TYP_257_I1_D: "Use Gravity",
  T_49_META_TYP_257_I2_D: "Mass (kg), the minimum effective mass is 0.001kg, if it is 0, then it is infinite mass and will not move under force.",
  T_49_META_TYP_257_I3_D: "Position of the center of gravity, local coordinate system",
  T_49_META_TYP_257_I4_D: "Linear velocity of rigid body motion",
  T_49_META_TYP_257_I5_D: "Angular velocity of rigid body motion",
  T_49_META_TYP_257_I6_D: "Coefficient of natural decay of linear velocity, the larger the coefficient, the faster the decay of velocity.",
  T_49_META_TYP_257_I7_D: "Angular velocity natural decay coefficient, the larger the coefficient, the faster the velocity decays.",
  T_49_META_TYP_257_I8_D: "The constraints imposed on the rigid body, a collection of RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Background",
  T_49_META_TYP_259_I1_D: "Text",
  T_49_META_TYP_259_I2_D: "UI position",
  T_49_META_TYP_259_I4_D: "Text Color",
  T_49_META_TYP_260_I0_D: "Select Icon",
  T_49_META_TYP_260_I1_D: "Progress bar color",
  T_49_META_TYP_260_I2_D: "Value",
  T_49_META_TYP_260_I3_D: "Speed in m/s",
  T_49_META_TYP_260_I4_D: "Whether to display special effects",
  T_49_META_TYP_260_I5_D: "UI position [0,1].",
  T_49_META_TYP_260_I6_D: "Initial progress of the skill, value [0, 1], the progress will be synchronized to the current progress immediately after the UI is created.",
  T_49_META_TYP_260_I7_D: "Effect Color",
  T_49_META_TYP_260_I8_D: "Set the object scaling value",
  T_49_META_TYP_265_I1_D: "Background fill or not",
  T_49_META_TYP_265_I2_D: "Background Name",
  T_49_META_TYP_265_I3_D: "Background Color",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Crop type",
  T_49_META_TYP_265_I7_D: "Mask type is the name of the image selected for masking",
  T_49_META_TYP_265_I8_D: "Edge softening unit",
  T_49_META_TYP_267_I0_D: "Scroll start point, default is top left corner.",
  T_49_META_TYP_267_I1_D: "Support multiple scrolling directions",
  T_49_META_TYP_267_I10_D: "Horizontal Bar",
  T_49_META_TYP_267_I11_D: "Show position",
  T_49_META_TYP_267_I2_D: "XY direction drag component",
  T_49_META_TYP_267_I3_D: "Support multiple dragging effects",
  T_49_META_TYP_267_I4_D: "Scroll factor, the larger the value, the faster the scrolling.",
  T_49_META_TYP_267_I5_D: "Inertia factor, the larger the value, the larger the inertia when scrolling.",
  T_49_META_TYP_267_I6_D: "If or not the drag is limited to the viewport, default is checked.",
  T_49_META_TYP_267_I7_D: "When checked, the drag will start to move slowly, if unchecked, the drag will start to move at the speed of the mouse.",
  T_49_META_TYP_267_I8_D: "Exit dragging when it fits in the viewport.",
  T_49_META_TYP_267_I9_D: "Vertical Bar",
  T_49_META_TYP_268_I0_D: "Default",
  T_49_META_TYP_268_I1_D: "Close",
  T_49_META_TYP_268_I2_D: "Show",
  T_49_META_TYP_269_I0_D: "Owner",
  T_49_META_TYP_269_I1_D: "Set ID",
  T_49_META_TYP_269_I2_D: "Headwear ID",
  T_49_META_TYP_269_I3_D: "Face ID",
  T_49_META_TYP_269_I4_D: "Makeup ID",
  T_49_META_TYP_269_I5_D: "Upper Body ID",
  T_49_META_TYP_269_I6_D: "Bottom ID",
  T_49_META_TYP_269_I7_D: "Shoe ID",
  T_49_META_TYP_272_I0_D: "Female",
  T_49_META_TYP_272_I1_D: "Male",
  T_49_META_TYP_273_I0_D: "World coordinates of the center of the mini-map",
  T_49_META_TYP_273_I1_D: "Size of the mini-map, same width and height",
  T_49_META_TYP_273_I2_D: "Enable or disable the depth map display mode of the mini-map",
  T_49_META_TYP_274_I1_D: "Zoom size",
  T_49_META_TYP_274_I4_D: "Icon display level",
  T_49_META_TYP_275_I0_D: "Skeleton Scale",
  T_49_META_TYP_275_I1_D: "World coordinates of rig nodes",
  T_49_META_TYP_276_I0_D: "Head",
  T_49_META_TYP_276_I1_D: "Left Arm",
  T_49_META_TYP_276_I2_D: "Left Hand",
  T_49_META_TYP_276_I3_D: "Right Arm",
  T_49_META_TYP_276_I4_D: "Right Hand",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Left Leg",
  T_49_META_TYP_276_I7_D: "Left Foot",
  T_49_META_TYP_276_I8_D: "Right Leg",
  T_49_META_TYP_276_I9_D: "Right Foot",
  T_49_META_TYP_277_I1_D: "Distance for camera ray detection",
  T_49_META_TYP_277_I2_D: "Collision layer mask for camera ray detection",
  T_49_META_TYP_277_I3_D: "Button position offset",
  T_49_META_TYP_277_I4_D: "Icon resource ID",
  T_49_META_TYP_277_I5_D: "Click area size",
  T_49_META_TYP_277_I6_D: "Whether objects are displayed at the target point",
  T_49_META_TYP_277_I7_D: "Objects displayed at the target point",
  T_49_META_TYP_278_I0_D: "Target entity for generating map pixels",
  T_49_META_TYP_28_I0_D: "Whether or not the team can reset every round.",
  T_49_META_TYP_280_I0_D: "Sphere radius",
  T_49_META_TYP_281_I0_D: "The radius of the hemispheres at both ends of the capsule.",
  T_49_META_TYP_29_I0_D: "Sphere",
  T_49_META_TYP_29_I1_D: "Light Beam",
  T_49_META_TYP_29_I10_D: "A pillar of light under the feet, now used for feedback when entering the finish line",
  T_49_META_TYP_29_I11_D: "Freeze",
  T_49_META_TYP_29_I12_D: "Light",
  T_49_META_TYP_29_I13_D: "Updraft",
  T_49_META_TYP_29_I14_D: "Gas Explosion",
  T_49_META_TYP_29_I15_D: "Hider Eliminated",
  T_49_META_TYP_29_I16_D: "Rampage",
  T_49_META_TYP_29_I17_D: "Clone Death",
  T_49_META_TYP_29_I18_D: "Shooting Feedback",
  T_49_META_TYP_29_I19_D: "Clone Death",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Clone",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Flashbang Smoke",
  T_49_META_TYP_29_I23_D: "Fireball",
  T_49_META_TYP_29_I24_D: "Burning in a Loop",
  T_49_META_TYP_29_I25_D: "Poison Gas",
  T_49_META_TYP_29_I26_D: "Heart",
  T_49_META_TYP_29_I29_D: "Door",
  T_49_META_TYP_29_I30_D: "Fireworks",
  T_49_META_TYP_29_I31_D: "Running Shoes VFX",
  T_49_META_TYP_29_I32_D: "Explosion VFX",
  T_49_META_TYP_29_I33_D: "Spawn Point VFX",
  T_49_META_TYP_29_I34_D: "Laser VFX",
  T_49_META_TYP_29_I35_D: "Skill Cast VFX",
  T_49_META_TYP_29_I36_D: "Bullet VFX",
  T_49_META_TYP_29_I37_D: "Bullet Hit VFX",
  T_49_META_TYP_29_I38_D: "Shooting VFX",
  T_49_META_TYP_29_I39_D: "Skill VFX",
  T_49_META_TYP_29_I40_D: "Halo",
  T_49_META_TYP_29_I41_D: "Bubbles",
  T_49_META_TYP_29_I42_D: "Smoke and Dust",
  T_49_META_TYP_29_I43_D: "Flying Debris",
  T_49_META_TYP_29_I44_D: "Lines",
  T_49_META_TYP_29_I45_D: "Flicker",
  T_49_META_TYP_29_I47_D: "Rising Particles",
  T_49_META_TYP_29_I48_D: "Smoke",
  T_49_META_TYP_29_I49_D: "Talisman",
  T_49_META_TYP_29_I50_D: "Frozen Area",
  T_49_META_TYP_29_I51_D: "Fog",
  T_49_META_TYP_29_I52_D: "Snowflake",
  T_49_META_TYP_29_I53_D: "Fire",
  T_49_META_TYP_29_I54_D: "Light Beam",
  T_49_META_TYP_29_I55_D: "Diffusing Poison Gas",
  T_49_META_TYP_29_I56_D: "Poison Gas",
  T_49_META_TYP_29_I57_D: "Explosion Flames",
  T_49_META_TYP_29_I58_D: "Light Effect",
  T_49_META_TYP_29_I59_D: "Star",
  T_49_META_TYP_29_I6_D: "Foot Halo",
  T_49_META_TYP_29_I60_D: "Blazing Bonfire",
  T_49_META_TYP_29_I61_D: "Water Splash",
  T_49_META_TYP_29_I62_D: "Electric Shock",
  T_49_META_TYP_29_I63_D: "Ink VFX",
  T_49_META_TYP_29_I64_D: "Blackhole VFX",
  T_49_META_TYP_29_I65_D: "Blackhole Explosion VFX",
  T_49_META_TYP_29_I66_D: "Crystal Ball VFX",
  T_49_META_TYP_29_I67_D: "Laser bullet effect",
  T_49_META_TYP_29_I68_D: "Drag effects",
  T_49_META_TYP_29_I69_D: "Clouds",
  T_49_META_TYP_29_I7_D: "Ground Marker",
  T_49_META_TYP_29_I8_D: "Smoke",
  T_49_META_TYP_29_I9_D: "Talisman Explosion",
  T_49_META_TYP_290_I0_D: "Refresh interval, the larger the number, the slower the refresh, in milliseconds.",
  T_49_META_TYP_290_I1_D: "Whether to enable debugging",
  T_49_META_TYP_291_I0_D: "Condition Node",
  T_49_META_TYP_291_I1_D: "Action Node",
  T_49_META_TYP_293_I0_D: "Behavior Tree ID",
  T_49_META_TYP_293_I1_D: "Attach Target",
  T_49_META_TYP_294_I1_D: "Layout Type",
  T_49_META_TYP_294_I10_D: "Sort Order",
  T_49_META_TYP_294_I2_D: "Content Origin",
  T_49_META_TYP_294_I3_D: "Alignment direction",
  T_49_META_TYP_294_I4_D: "Width and height of the sub-item grid",
  T_49_META_TYP_294_I5_D: "Cell Space",
  T_49_META_TYP_294_I6_D: "Constraint",
  T_49_META_TYP_294_I7_D: "Constraint Count",
  T_49_META_TYP_294_I8_D: "Vertical offset",
  T_49_META_TYP_294_I9_D: "Horizontal offset",
  T_49_META_TYP_295_I2_D: "Play Speed",
  T_49_META_TYP_296_I1_D: "Clip Length",
  T_49_META_TYP_297_I0_D: "Bound objects",
  T_49_META_TYP_297_I4_D: "Resource ID",
  T_49_META_TYP_298_I0_D: "Default",
  T_49_META_TYP_298_I2_D: "Once",
  T_49_META_TYP_30_I0_D: "Square",
  T_49_META_TYP_30_I1_D: "Quadrilateral",
  T_49_META_TYP_30_I10_D: "Arrow",
  T_49_META_TYP_30_I11_D: "Callout",
  T_49_META_TYP_30_I12_D: "Rock",
  T_49_META_TYP_30_I13_D: "Scissors",
  T_49_META_TYP_30_I14_D: "Paper",
  T_49_META_TYP_30_I15_D: "Like",
  T_49_META_TYP_30_I16_D: "Right",
  T_49_META_TYP_30_I17_D: "Wrong",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Lightning",
  T_49_META_TYP_30_I2_D: "Right-Angled Trapezoid",
  T_49_META_TYP_30_I20_D: "Hearts",
  T_49_META_TYP_30_I21_D: "Star",
  T_49_META_TYP_30_I22_D: "Moon",
  T_49_META_TYP_30_I23_D: "Sun",
  T_49_META_TYP_30_I24_D: "Glasses",
  T_49_META_TYP_30_I25_D: "Key",
  T_49_META_TYP_30_I26_D: "Trophy",
  T_49_META_TYP_30_I27_D: "Flag",
  T_49_META_TYP_30_I28_D: "Hourglass",
  T_49_META_TYP_30_I29_D: "Folder",
  T_49_META_TYP_30_I3_D: "Trapezoid",
  T_49_META_TYP_30_I30_D: "Open Folder",
  T_49_META_TYP_30_I31_D: "House",
  T_49_META_TYP_30_I32_D: "Rest",
  T_49_META_TYP_30_I33_D: "Refresh",
  T_49_META_TYP_30_I34_D: "Loop",
  T_49_META_TYP_30_I35_D: "Magnifier",
  T_49_META_TYP_30_I36_D: "Trash Can",
  T_49_META_TYP_30_I37_D: "Return",
  T_49_META_TYP_30_I38_D: "Diamond",
  T_49_META_TYP_30_I39_D: "Swim Ring",
  T_49_META_TYP_30_I4_D: "Hexagon",
  T_49_META_TYP_30_I40_D: "Money",
  T_49_META_TYP_30_I41_D: "Lock",
  T_49_META_TYP_30_I42_D: "Settings",
  T_49_META_TYP_30_I43_D: "Exit",
  T_49_META_TYP_30_I44_D: "Dialogue",
  T_49_META_TYP_30_I45_D: "Crosshairs",
  T_49_META_TYP_30_I46_D: "Guns",
  T_49_META_TYP_30_I47_D: "Sword",
  T_49_META_TYP_30_I48_D: "Explosion",
  T_49_META_TYP_30_I49_D: "Aim",
  T_49_META_TYP_30_I5_D: "Circles",
  T_49_META_TYP_30_I50_D: "Cross",
  T_49_META_TYP_30_I51_D: "Defense",
  T_49_META_TYP_30_I52_D: "Zombie",
  T_49_META_TYP_30_I53_D: "Recycle",
  T_49_META_TYP_30_I54_D: "Gift",
  T_49_META_TYP_30_I55_D: "Clothes",
  T_49_META_TYP_30_I56_D: "Game",
  T_49_META_TYP_30_I57_D: "Player",
  T_49_META_TYP_30_I58_D: "Store",
  T_49_META_TYP_30_I59_D: "Exit",
  T_49_META_TYP_30_I6_D: "Triangle",
  T_49_META_TYP_30_I60_D: "Warning",
  T_49_META_TYP_30_I61_D: "Text",
  T_49_META_TYP_30_I62_D: "Timer Objects",
  T_49_META_TYP_30_I63_D: "Bell",
  T_49_META_TYP_30_I64_D: "Pet",
  T_49_META_TYP_30_I65_D: "Bomb",
  T_49_META_TYP_30_I66_D: "Repair",
  T_49_META_TYP_30_I67_D: "Smiling Face",
  T_49_META_TYP_30_I68_D: "Speaker",
  T_49_META_TYP_30_I7_D: "Exclamation Mark",
  T_49_META_TYP_30_I70_D: "Crown",
  T_49_META_TYP_30_I71_D: "Battle",
  T_49_META_TYP_30_I72_D: "Guild",
  T_49_META_TYP_30_I73_D: "Heartbeat",
  T_49_META_TYP_30_I74_D: "Music",
  T_49_META_TYP_30_I75_D: "Vehicle",
  T_49_META_TYP_30_I76_D: "Melee",
  T_49_META_TYP_30_I77_D: "Pistol",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Sniper Rifle",
  T_49_META_TYP_30_I8_D: "Question Mark",
  T_49_META_TYP_30_I80_D: "Shotgun",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Healing Gun",
  T_49_META_TYP_30_I83_D: "Shatter Armor",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Skill 1",
  T_49_META_TYP_30_I86_D: "Skill 2",
  T_49_META_TYP_30_I87_D: "Skill 3",
  T_49_META_TYP_30_I88_D: "Skill 4",
  T_49_META_TYP_30_I89_D: "Skill 5",
  T_49_META_TYP_30_I9_D: "Mark",
  T_49_META_TYP_30_I90_D: "Skill 6",
  T_49_META_TYP_30_I91_D: "Skill 7",
  T_49_META_TYP_30_I92_D: "Skill 8",
  T_49_META_TYP_30_I93_D: "Skill 9",
  T_49_META_TYP_30_I94_D: "Skill 10",
  T_49_META_TYP_300_I0_D: "Resource ID",
  T_49_META_TYP_300_I2_D: "Rotation",
  T_49_META_TYP_300_I3_D: "Created Entity",
  T_49_META_TYP_301_I1_D: "Self-Destruct",
  T_49_META_TYP_301_I2_D: "Dash Attack",
  T_49_META_TYP_301_I3_D: "Shock Wave",
  T_49_META_TYP_301_I4_D: "Tornado Attack",
  T_49_META_TYP_301_I5_D: "Jump Attack",
  T_49_META_TYP_301_I6_D: "Shield Up",
  T_49_META_TYP_301_I7_D: "Shield Broken",
  T_49_META_TYP_302_I5_D: "Backpack",
  T_49_META_TYP_302_I7_D: "Skateboard, Camo ....",
  T_49_META_TYP_303_I0_D: "Add Max. Player HP",
  T_49_META_TYP_303_I1_D: "Restore Player HP Continuously",
  T_49_META_TYP_305_I0_D: "Finish",
  T_49_META_TYP_305_I1_D: "Running",
  T_49_META_TYP_307_I0_D: "Exp Per Damage",
  T_49_META_TYP_307_I1_D: "Exp Per Move Mile",
  T_49_META_TYP_307_I2_D: "EXP per Second",
  T_49_META_TYP_307_I3_D: "Chip Exp",
  T_49_META_TYP_307_I4_D: "Charge Max",
  T_49_META_TYP_308_I0_D: "Gel Maker",
  T_49_META_TYP_31_I0_D: "Grenade Explosion",
  T_49_META_TYP_31_I1_D: "Gun Sound",
  T_49_META_TYP_31_I10_D: "Hit Damage Sound",
  T_49_META_TYP_31_I11_D: "Upgrade Sound",
  T_49_META_TYP_31_I12_D: "Weakness hit sound effect",
  T_49_META_TYP_31_I13_D: "Player stepping sound effect",
  T_49_META_TYP_31_I14_D: "Equipment Repair Sound Effect",
  T_49_META_TYP_31_I15_D: "Equipment repair sound effect",
  T_49_META_TYP_31_I16_D: "Missing or lost sound effect",
  T_49_META_TYP_31_I17_D: "Reminder Sound",
  T_49_META_TYP_31_I18_D: "Soccer Ball Landing Sound Effect",
  T_49_META_TYP_31_I19_D: "Cheers Sound Effect",
  T_49_META_TYP_31_I2_D: "Countdown Beep",
  T_49_META_TYP_31_I20_D: "Bomb Alert Sound Effect",
  T_49_META_TYP_31_I21_D: "Bomb Before Explosion Sound Effect",
  T_49_META_TYP_31_I22_D: "Hunter Appearance Sound Effect",
  T_49_META_TYP_31_I23_D: "Final BGM Sound Effect",
  T_49_META_TYP_31_I24_D: "Resupply Box Refresh Sound Effect",
  T_49_META_TYP_31_I25_D: "Accelerator sound effect",
  T_49_META_TYP_31_I26_D: "Disappearing Sound",
  T_49_META_TYP_31_I27_D: "Visual Effects",
  T_49_META_TYP_31_I28_D: "Night Bugs",
  T_49_META_TYP_31_I29_D: "Dull percussion sound effect",
  T_49_META_TYP_31_I3_D: "UI Tap",
  T_49_META_TYP_31_I30_D: "Response Sound Effect",
  T_49_META_TYP_31_I31_D: "Discovery Surprise sound effect",
  T_49_META_TYP_31_I32_D: "Ghosts playing sound effect",
  T_49_META_TYP_31_I33_D: "Phase Start Sound Effect",
  T_49_META_TYP_31_I34_D: "Zombie sound effect",
  T_49_META_TYP_31_I35_D: "Scary sound effect",
  T_49_META_TYP_31_I36_D: "Transformation sound effect",
  T_49_META_TYP_31_I37_D: "Fast Heartbeat Sound Effect",
  T_49_META_TYP_31_I38_D: "Medium Heartbeat",
  T_49_META_TYP_31_I39_D: "Slow heartbeat sound effect",
  T_49_META_TYP_31_I4_D: "Female Screaming on Hit",
  T_49_META_TYP_31_I40_D: "Stampede sound effect",
  T_49_META_TYP_31_I41_D: "Clicking Sound",
  T_49_META_TYP_31_I42_D: "Skill Recovery Sound",
  T_49_META_TYP_31_I43_D: "Join Game Sound Effects",
  T_49_META_TYP_31_I44_D: "Mechanism Echo Sound",
  T_49_META_TYP_31_I45_D: "Mosquito sound effect",
  T_49_META_TYP_31_I46_D: "Clank 1 sound effect",
  T_49_META_TYP_31_I47_D: "Clank 2 sound effect",
  T_49_META_TYP_31_I48_D: "Mechanism opening sound effect",
  T_49_META_TYP_31_I49_D: "Energy Charge 1 sound effect",
  T_49_META_TYP_31_I5_D: "Male Screaming on Hit",
  T_49_META_TYP_31_I50_D: "Footsteps sound effect",
  T_49_META_TYP_31_I51_D: "Mission Success 1 sound effect",
  T_49_META_TYP_31_I52_D: "Danger Tone 1 sound effect",
  T_49_META_TYP_31_I53_D: "Danger tone 2 sound effect",
  T_49_META_TYP_31_I54_D: "Countdown 3 sound effect",
  T_49_META_TYP_31_I55_D: "Show Tips sound effect",
  T_49_META_TYP_31_I56_D: "Crow cawing ambient sound effect",
  T_49_META_TYP_31_I57_D: "Sound effect of teleporting to the wrong area with a teleport point",
  T_49_META_TYP_31_I58_D: "Sound effect of teleporting to the right area with a teleport point",
  T_49_META_TYP_31_I59_D: "Teleport sound effect",
  T_49_META_TYP_31_I6_D: "Gold Pickup Sound",
  T_49_META_TYP_31_I60_D: "Electric shock sound effect",
  T_49_META_TYP_31_I61_D: "Consumable sound effect",
  T_49_META_TYP_31_I62_D: "Electronic Fantasy Cute Background Music Sound Effects",
  T_49_META_TYP_31_I63_D: "Casual Game Background Music Sound Effects",
  T_49_META_TYP_31_I64_D: "Open Box",
  T_49_META_TYP_31_I65_D: "Level Up",
  T_49_META_TYP_31_I66_D: "Max. Level",
  T_49_META_TYP_31_I67_D: "Tap Button",
  T_49_META_TYP_31_I68_D: "Countdown",
  T_49_META_TYP_31_I69_D: "Defeat Enemy",
  T_49_META_TYP_31_I7_D: "Race past the finish line trigger sound effect",
  T_49_META_TYP_31_I70_D: "End",
  T_49_META_TYP_31_I71_D: "Forward",
  T_49_META_TYP_31_I72_D: "Victory",
  T_49_META_TYP_31_I73_D: "Training Base Checkpoints",
  T_49_META_TYP_31_I74_D: "Countdown",
  T_49_META_TYP_31_I75_D: "Game Start",
  T_49_META_TYP_31_I76_D: "Get Big Gold",
  T_49_META_TYP_31_I77_D: "Get Medium Gold",
  T_49_META_TYP_31_I78_D: "Get Small Gold",
  T_49_META_TYP_31_I79_D: "Join the Fray",
  T_49_META_TYP_31_I8_D: "Trigger Trigger Sound",
  T_49_META_TYP_31_I80_D: "Guild Supply",
  T_49_META_TYP_31_I81_D: "Speaker",
  T_49_META_TYP_31_I82_D: "Impeach Guild Leader",
  T_49_META_TYP_31_I83_D: "Save Warehouse",
  T_49_META_TYP_31_I84_D: "Special Gun Sound",
  T_49_META_TYP_31_I85_D: "Bullet Hit",
  T_49_META_TYP_31_I86_D: "Move",
  T_49_META_TYP_31_I87_D: "Tap Disable Button",
  T_49_META_TYP_31_I88_D: "Skill Charge Complete",
  T_49_META_TYP_31_I89_D: "Laser Skill",
  T_49_META_TYP_31_I9_D: "Degradation Sound",
  T_49_META_TYP_31_I90_D: "Get Consumable 2",
  T_49_META_TYP_31_I91_D: "Countdown 3",
  T_49_META_TYP_31_I92_D: "Game Over 2",
  T_49_META_TYP_31_I93_D: "Elimination Prompt",
  T_49_META_TYP_31_I94_D: "Explosion",
  T_49_META_TYP_31_I95_D: "Energy Orb Skill",
  T_49_META_TYP_31_I96_D: "Crimson Pool Skill",
  T_49_META_TYP_311_I1_D: "Max. Damage",
  T_49_META_TYP_311_I3_D: "The speed of the projectile after it is released, in m/s.",
  T_49_META_TYP_311_I4_D: "The time interval between when the projectile is released and when it takes effect, in seconds.",
  T_49_META_TYP_313_I0_D: "Zone Radius",
  T_49_META_TYP_313_I1_D: "Duration of countermeasure area, in seconds",
  T_49_META_TYP_314_I0_D: "Animation controller resource ID.",
  T_49_META_TYP_314_I1_D: "Animation Controller",
  T_49_META_TYP_315_I0_D: "The owner of the backpack.",
  T_49_META_TYP_315_I1_D: "The space of the backpack.",
  T_49_META_TYP_315_I2_D: "Used Capacity",
  T_49_META_TYP_315_I3_D: "All Supplies",
  T_49_META_TYP_316_I0_D: "Texture Resource",
  T_49_META_TYP_316_I1_D: "Shader Name",
  T_49_META_TYP_316_I11_D: "Flip method",
  T_49_META_TYP_316_I2_D: "UV Offset",
  T_49_META_TYP_316_I3_D: "UV Size",
  T_49_META_TYP_316_I4_D: "Fill Type",
  T_49_META_TYP_316_I5_D: "Border Left Right",
  T_49_META_TYP_316_I6_D: "Border Top Bottom",
  T_49_META_TYP_317_I0_D: "None",
  T_49_META_TYP_317_I1_D: "Freeze Position X",
  T_49_META_TYP_317_I2_D: "Freeze Position Y",
  T_49_META_TYP_317_I3_D: "Freeze Position Z",
  T_49_META_TYP_317_I4_D: "Restricted rotation around X-axis",
  T_49_META_TYP_317_I5_D: "Restriction of rotation around the Y-axis",
  T_49_META_TYP_317_I6_D: "Limit rotation around the Z-axis",
  T_49_META_TYP_317_I7_D: "Freeze Position",
  T_49_META_TYP_317_I8_D: "Freeze Rotation",
  T_49_META_TYP_317_I9_D: "Freeze All",
  T_49_META_TYP_318_I0_D: "Range",
  T_49_META_TYP_318_I1_D: "Full Damage Distance",
  T_49_META_TYP_318_I10_D: "Player Aiming Speed Factor",
  T_49_META_TYP_318_I11_D: "Scope Zoom-In Factor",
  T_49_META_TYP_318_I12_D: "FOV Magnification",
  T_49_META_TYP_318_I13_D: "ADS Magnification",
  T_49_META_TYP_318_I14_D: "ADS Magnification Time (s)",
  T_49_META_TYP_318_I15_D: "ADS Recovery Time (s)",
  T_49_META_TYP_318_I16_D: "Scope Min Damage Distance correction factor.",
  T_49_META_TYP_318_I17_D: "Allow ADS Aim Assist",
  T_49_META_TYP_318_I18_D: "Aim Assist Crosshairs Screen Range Attraction Ratio (0-1)",
  T_49_META_TYP_318_I19_D: "Aim Assist Distance Attenuation Coefficient (0-1)",
  T_49_META_TYP_318_I2_D: "Min. Damage Distance",
  T_49_META_TYP_318_I20_D: "Allow Aim Assist Distance First",
  T_49_META_TYP_318_I21_D: "Aim Assist Distance Priority Min. Distance",
  T_49_META_TYP_318_I22_D: "Aim Assist Distance Priority Max. Distance",
  T_49_META_TYP_318_I23_D: "Aim Assist Distance Priority Impact Coefficient (>=1)",
  T_49_META_TYP_318_I24_D: "ADS Rotation Sensitivity",
  T_49_META_TYP_318_I25_D: "Shrink Speed",
  T_49_META_TYP_318_I3_D: "Ammo Clip Size",
  T_49_META_TYP_318_I4_D: "Attack Interval",
  T_49_META_TYP_318_I5_D: "Reload Speed",
  T_49_META_TYP_318_I6_D: "Auto Reload Speed",
  T_49_META_TYP_318_I7_D: "Scatter Speed",
  T_49_META_TYP_318_I8_D: "Scattering rate when crouching and lying down, per 0.1 means 10% range increase per bullet aiming",
  T_49_META_TYP_318_I9_D: "Max. Spread",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Sliced",
  T_49_META_TYP_319_I2_D: "Tiled",
  T_49_META_TYP_319_I3_D: "Filled",
  T_49_META_TYP_319_I4_D: "Fit",
  T_49_META_TYP_32_I0_D: "Player in normal active state",
  T_49_META_TYP_32_I1_D: "Player is knocked down",
  T_49_META_TYP_32_I2_D: "Player is dead",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "The maximum distance at which the targeting assist will be triggered.",
  T_49_META_TYP_321_I1_D: "The offset of the collimator when triggering targeting, if the offset point is not in the solid, the targeting will be disabled.",
  T_49_META_TYP_322_I0_D: "No",
  T_49_META_TYP_322_I1_D: "Head",
  T_49_META_TYP_322_I2_D: "Body",
  T_49_META_TYP_322_I3_D: "Limb",
  T_49_META_TYP_323_I0_D: "Scale",
  T_49_META_TYP_323_I1_D: "Account ID",
  T_49_META_TYP_323_I2_D: "Player Profile Information",
  T_49_META_TYP_323_I3_D: "Style",
  T_49_META_TYP_323_I4_D: "Show Rank",
  T_49_META_TYP_323_I5_D: "Show Pin",
  T_49_META_TYP_323_I6_D: "Show Nickname",
  T_49_META_TYP_324_I0_D: "Generate a specified amount of force",
  T_49_META_TYP_324_I1_D: "Generate an acceleration of a specified magnitude",
  T_49_META_TYP_324_I2_D: "Generate an impulse of a specified magnitude",
  T_49_META_TYP_324_I3_D: "Generate a specified amount of velocity",
  T_49_META_TYP_326_I0_D: "Account ID",
  T_49_META_TYP_326_I1_D: "Avatar ID",
  T_49_META_TYP_326_I2_D: "Banner ID",
  T_49_META_TYP_326_I3_D: "Pin ID",
  T_49_META_TYP_326_I4_D: "Player's nickname",
  T_49_META_TYP_326_I5_D: "BR Rank",
  T_49_META_TYP_326_I6_D: "Highest BR rank",
  T_49_META_TYP_326_I7_D: "CS Rank",
  T_49_META_TYP_326_I8_D: "Highest CS rank",
  T_49_META_TYP_327_I0_D: "Resource ID",
  T_49_META_TYP_327_I1_D: "Part Mask 1",
  T_49_META_TYP_327_I2_D: "Part Mask 2",
  T_49_META_TYP_327_I3_D: "Part Mask 3",
  T_49_META_TYP_327_I4_D: "Part Mask 4",
  T_49_META_TYP_329_I0_D: "Driver",
  T_49_META_TYP_329_I1_D: "Passenger A",
  T_49_META_TYP_329_I2_D: "Passenger B",
  T_49_META_TYP_329_I3_D: "Passenger C",
  T_49_META_TYP_33_I0_D: "Ascending order ignores zero values, zero values come last",
  T_49_META_TYP_33_I1_D: "Descending order, large to small",
  T_49_META_TYP_33_I2_D: "Ascending, smallest to largest",
  T_49_META_TYP_330_I4_D: "Duration of invincibility effect (in s)",
  T_49_META_TYP_330_I5_D: "Control Points",
  T_49_META_TYP_330_I8_D: "Delta Value",
  T_49_META_TYP_332_I0_D: "Is Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Resource path, default is empty",
  T_49_META_TYP_335_I1_D: "Play count, default is 1",
  T_49_META_TYP_335_I2_D: "Volume, default is 50",
  T_49_META_TYP_335_I3_D: "Max. Distance",
  T_49_META_TYP_335_I4_D: "Min. Distance",
  T_49_META_TYP_335_I5_D: "Whether the music is 3D or not",
  T_49_META_TYP_335_I6_D: "Priority",
  T_49_META_TYP_335_I7_D: "Wait time before start, in seconds",
  T_49_META_TYP_335_I8_D: "Is Playing",
  T_49_META_TYP_338_I0_D: "Movement status",
  T_49_META_TYP_338_I1_D: "Sprint",
  T_49_META_TYP_338_I2_D: "Attack",
  T_49_META_TYP_338_I3_D: "Jump",
  T_49_META_TYP_338_I4_D: "Overrun",
  T_49_META_TYP_338_I5_D: "Enter vehicle (driver)",
  T_49_META_TYP_338_I6_D: "Enter Carrier (Passenger)",
  T_49_META_TYP_338_I7_D: "Exit Vehicle",
  T_49_META_TYP_338_I8_D: "Drive",
  T_49_META_TYP_339_I0_D: "Damage Ratio Limb",
  T_49_META_TYP_339_I1_D: "Headshot DMG Coefficient",
  T_49_META_TYP_339_I2_D: "Max. Durability Multiplier",
  T_49_META_TYP_339_I3_D: "Extra HP Ratio",
  T_49_META_TYP_339_I4_D: "Additional Blast Damage Reduction Factor (%)",
  T_49_META_TYP_339_I5_D: "Extra Backpack Capacity",
  T_49_META_TYP_339_I6_D: "Replacement Priority",
  T_49_META_TYP_34_I0_D: "Default Fist",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Shotgun",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Hand Cannon",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Shield Gun",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Shield Gun",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-Ⅲ - Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Flame Grenade Gun",
  T_49_META_TYP_34_I133_D: "Flashbang",
  T_49_META_TYP_34_I134_D: "Smoke Grenade",
  T_49_META_TYP_34_I135_D: "Freezing Grenade",
  T_49_META_TYP_34_I136_D: "Bulletproof Vest Lv1",
  T_49_META_TYP_34_I137_D: "Body armor Lv2",
  T_49_META_TYP_34_I138_D: "Body armor Lv3",
  T_49_META_TYP_34_I139_D: "Helmet Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Helmet Lv2",
  T_49_META_TYP_34_I141_D: "Helmet Lv3",
  T_49_META_TYP_34_I142_D: "Explosion-proof Armor",
  T_49_META_TYP_34_I143_D: "Backpack Lv1",
  T_49_META_TYP_34_I144_D: "Backpack Lv2",
  T_49_META_TYP_34_I145_D: "Backpack Lv3",
  T_49_META_TYP_34_I146_D: "Muzzle Lv1",
  T_49_META_TYP_34_I147_D: "Muzzle Lv2",
  T_49_META_TYP_34_I148_D: "Muzzle Lv3",
  T_49_META_TYP_34_I149_D: "Silencer",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Assault Muzzle",
  T_49_META_TYP_34_I151_D: "Wide Muzzle",
  T_49_META_TYP_34_I152_D: "Magazine Lv1",
  T_49_META_TYP_34_I153_D: "Magazine Lv2",
  T_49_META_TYP_34_I154_D: "Magazine Lv3",
  T_49_META_TYP_34_I155_D: "Double Bundle Magazine",
  T_49_META_TYP_34_I156_D: "Chain Magazine",
  T_49_META_TYP_34_I157_D: "Grip Lv1",
  T_49_META_TYP_34_I158_D: "Grip Lv2",
  T_49_META_TYP_34_I159_D: "Grip Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Folding Bracket",
  T_49_META_TYP_34_I161_D: "Shooter's Rifle Grip",
  T_49_META_TYP_34_I162_D: "Shotgun Stocks",
  T_49_META_TYP_34_I163_D: "Sniper Stocks",
  T_49_META_TYP_34_I164_D: "Thermal Imaging Scope",
  T_49_META_TYP_34_I165_D: "Stock Lv1",
  T_49_META_TYP_34_I166_D: "Stock Lv2",
  T_49_META_TYP_34_I167_D: "Stock Lv3",
  T_49_META_TYP_34_I168_D: "Shield Expander",
  T_49_META_TYP_34_I169_D: "Full Body Armor",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Excess Jacket",
  T_49_META_TYP_34_I171_D: "Explosion-proof Jacket",
  T_49_META_TYP_34_I172_D: "Backpack Expander",
  T_49_META_TYP_34_I173_D: "Healing Breather",
  T_49_META_TYP_34_I174_D: "Horizaline",
  T_49_META_TYP_34_I175_D: "MedKit",
  T_49_META_TYP_34_I176_D: "Armor Repair Kit",
  T_49_META_TYP_34_I177_D: "An AI sentry tower made of high-tech materials that actively searches and attacks enemies within a certain range",
  T_49_META_TYP_34_I178_D: "Level 1 Mushroom",
  T_49_META_TYP_34_I179_D: "Level 2 Mushroom",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Level 3 Mushroom",
  T_49_META_TYP_34_I181_D: "Level 4 Mushroom",
  T_49_META_TYP_34_I182_D: "Personal UAV",
  T_49_META_TYP_34_I184_D: "Sensor Mines",
  T_49_META_TYP_34_I185_D: "Jet Flying Shoes",
  T_49_META_TYP_34_I186_D: "Bouncing Power Shoes",
  T_49_META_TYP_34_I187_D: "Glider",
  T_49_META_TYP_34_I188_D: "Bait Grenade",
  T_49_META_TYP_34_I189_D: "Maglev Skateboard",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "Bomb Disposal Pliers",
  T_49_META_TYP_34_I191_D: "Gun Upgrader",
  T_49_META_TYP_34_I192_D: "Rifle Ammo",
  T_49_META_TYP_34_I193_D: "Pistol Ammo",
  T_49_META_TYP_34_I194_D: "Sniper Rifle Ammo",
  T_49_META_TYP_34_I195_D: "Shotgun Ammo",
  T_49_META_TYP_34_I196_D: "SMG Ammo",
  T_49_META_TYP_34_I197_D: "Arrows",
  T_49_META_TYP_34_I198_D: "M79 Grenade",
  T_49_META_TYP_34_I199_D: "Flamethrower Bullets",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "Hook",
  T_49_META_TYP_34_I202_D: "Football Gun",
  T_49_META_TYP_34_I203_D: "Boxing",
  T_49_META_TYP_34_I204_D: "Flamethrower",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Loot Soccer Shield",
  T_49_META_TYP_34_I30_D: "Superheated Energy Gun",
  T_49_META_TYP_34_I31_D: "Superheated Gun-I",
  T_49_META_TYP_34_I32_D: "Superheat Gun-II",
  T_49_META_TYP_34_I33_D: "Superheat Gun-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Heal Pistol-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "Heal Pistol",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "Groza",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "Groza",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Pan",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Baseball Bat",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Samurai Sword",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Power Hook Gun",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "1887 with 3 bullets",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "Big Head Hammer",
  T_49_META_TYP_34_I88_D: "Flying Dagger (pickable)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Easy",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderate",
  T_49_META_TYP_340_I4_D: "Hard",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Start Event",
  T_49_META_TYP_342_I1_D: "Stop Event",
  T_49_META_TYP_342_I2_D: "Pause Event",
  T_49_META_TYP_342_I3_D: "How long to wait after being created to start the timer, in milliseconds",
  T_49_META_TYP_342_I4_D: "Loop Count",
  T_49_META_TYP_342_I5_D: "Events",
  T_49_META_TYP_342_I6_D: "Countdown or positive timing",
  T_49_META_TYP_342_I7_D: "Player Status",
  T_49_META_TYP_342_I8_D: "Timing end time in seconds",
  T_49_META_TYP_345_I10_D: "Hand Cannon",
  T_49_META_TYP_345_I12_D: "Ice Wall Gun",
  T_49_META_TYP_345_I13_D: "Flamethrower",
  T_49_META_TYP_345_I4_D: "Shotgun",
  T_49_META_TYP_345_I6_D: "Special Gun",
  T_49_META_TYP_345_I8_D: "Accumulator",
  T_49_META_TYP_346_I0_D: "Rifle Ammo",
  T_49_META_TYP_346_I1_D: "Pistol Ammo",
  T_49_META_TYP_346_I2_D: "Sniper Rifle Ammo",
  T_49_META_TYP_346_I3_D: "Shotgun Ammo",
  T_49_META_TYP_346_I4_D: "SMG Ammo",
  T_49_META_TYP_346_I5_D: "Arrows",
  T_49_META_TYP_346_I6_D: "M79 Grenade",
  T_49_META_TYP_346_I7_D: "Hook",
  T_49_META_TYP_346_I8_D: "M79 Specialized Grenade",
  T_49_META_TYP_347_I3_D: "Can be combined with Relative Motion if true, must be combined with Absolute Motion if false, otherwise the property will not take effect correctly.",
  T_49_META_TYP_347_I6_D: "Delta Value",
  T_49_META_TYP_350_I0_D: "Sports Car",
  T_49_META_TYP_350_I1_D: "Motorbike",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Monster Truck",
  T_49_META_TYP_350_I5_D: "Mutant Truck",
  T_49_META_TYP_352_I1_D: "Unselected Sprite",
  T_49_META_TYP_352_I2_D: "Unchecked image type",
  T_49_META_TYP_352_I3_D: "Unselected Color",
  T_49_META_TYP_352_I4_D: "Selected Sprite",
  T_49_META_TYP_352_I5_D: "Selected Image Type",
  T_49_META_TYP_352_I6_D: "Selected Color",
  T_49_META_TYP_353_I0_D: "HP Recovery Amount",
  T_49_META_TYP_353_I1_D: "HP Recovery Speed (ms)",
  T_49_META_TYP_353_I2_D: "Time Required (ms)",
  T_49_META_TYP_354_I0_D: "EP Recovery Amount",
  T_49_META_TYP_355_I0_D: "HP Recovery Amount",
  T_49_META_TYP_355_I1_D: "EP Recovery Amount",
  T_49_META_TYP_355_I2_D: "Time Required (ms)",
  T_49_META_TYP_356_I0_D: "Drop Items",
  T_49_META_TYP_356_I1_D: "Drop box drop time ms",
  T_49_META_TYP_356_I2_D: "Airdrop State",
  T_49_META_TYP_357_I0_D: "Surface",
  T_49_META_TYP_357_I1_D: "Boundary",
  T_49_META_TYP_359_I0_D: "Whether to use a player controller with physics effects",
  T_49_META_TYP_359_I1_D: "Placed on a slope above this angle, it will slide downward",
  T_49_META_TYP_359_I10_D: "This gravity acceleration is only applied to this player's controller.",
  T_49_META_TYP_359_I11_D: "Mass in kg",
  T_49_META_TYP_359_I12_D: "If the slope exceeds the maximum uphill angle, the capsule will slide downward.",
  T_49_META_TYP_359_I16_D: "When enabled, movement is controlled by server-side blocks or scripts.",
  T_49_META_TYP_359_I17_D: "When enabled, the force applied when the character pushes on a rigid body can be customized.",
  T_49_META_TYP_359_I18_D: "The amount of force applied when the character pushes the rigid body",
  T_49_META_TYP_359_I19_D: "True when the lower part of the body touches the collision body, usually used to determine if the player is on the ground.",
  T_49_META_TYP_359_I2_D: "Only obstacles above this height will have a blocking effect, in the range [0,Height]",
  T_49_META_TYP_359_I20_D: "Customizable physics level, value [0,15].",
  T_49_META_TYP_359_I21_D: "Enable Rotate With Gravity",
  T_49_META_TYP_359_I3_D: "Allows embedding to change the depth of the capsule body. It can prevent the character from getting stuck or shaking, and is not recommended to be changed without special needs. Value range (0,Radius]",
  T_49_META_TYP_359_I4_D: "Minimum movement distance, any movement less than this value will not be executed. If there is no special need, it is recommended to keep it at 0.",
  T_49_META_TYP_359_I5_D: "The offset of the center of the collision box from the local coordinate origin.",
  T_49_META_TYP_359_I6_D: "Radius of the capsule, minimum value 0.01.",
  T_49_META_TYP_359_I7_D: "Total height of the capsule, including the upper and lower hemispheres, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Current linear velocity, in m/s",
  T_49_META_TYP_360_I0_D: "Left Firing Arc Angle",
  T_49_META_TYP_360_I1_D: "Right Firing Arc Angle",
  T_49_META_TYP_360_I2_D: "Min. Elevation Angle",
  T_49_META_TYP_360_I3_D: "Max. Depression Angle",
  T_49_META_TYP_360_I4_D: "Muzzle Velocity",
  T_49_META_TYP_362_I0_D: "Freeze time caused by hitting the player, in seconds",
  T_49_META_TYP_363_I0_D: "Disable Hud Request Purchase",
  T_49_META_TYP_363_I1_D: "Request help from team to buy",
  T_49_META_TYP_363_I2_D: "Purchase by requesting help from a camp",
  T_49_META_TYP_364_I0_D: "Is Center Position",
  T_49_META_TYP_364_I1_D: "Whether to loop playback",
  T_49_META_TYP_364_I2_D: "Animation name",
  T_49_META_TYP_364_I3_D: "Whether or not to autoplay",
  T_49_META_TYP_364_I4_D: "Use Custom Resource",
  T_49_META_TYP_366_I0_D: "Specifies the UUID of the Batch resource to render.",
  T_49_META_TYP_367_I1_D: "Show Tag",
  T_49_META_TYP_367_I2_D: "Icon style for marker targets",
  T_49_META_TYP_367_I3_D: "Overlay color of icons displayed on marked targets",
  T_49_META_TYP_367_I4_D: "Icon style displayed on a scale",
  T_49_META_TYP_367_I5_D: "Overlay color of the icon displayed on a scale",
  T_49_META_TYP_367_I6_D: "Always Show Mark",
  T_49_META_TYP_370_I0_D: "Main title",
  T_49_META_TYP_370_I1_D: "Subtitle",
  T_49_META_TYP_370_I2_D: "Upper background color",
  T_49_META_TYP_370_I3_D: "Bottom background color",
  T_49_META_TYP_371_I2_D: "Left Score",
  T_49_META_TYP_371_I3_D: "Right Score",
  T_49_META_TYP_371_I4_D: "The last score on the left, used to play the score switching Animation",
  T_49_META_TYP_371_I5_D: "The last score on the right, used to play the score toggle Animation",
  T_49_META_TYP_372_I0_D: "Standing",
  T_49_META_TYP_372_I1_D: "Show Crouch",
  T_49_META_TYP_372_I10_D: "High fall",
  T_49_META_TYP_372_I11_D: "Low fall, e.g. jumping",
  T_49_META_TYP_372_I12_D: "Flying shoes",
  T_49_META_TYP_372_I13_D: "Two jump jumps",
  T_49_META_TYP_372_I14_D: "Sitting on a chair",
  T_49_META_TYP_372_I15_D: "Ejected by catapult",
  T_49_META_TYP_372_I16_D: "Catapult preparation phase",
  T_49_META_TYP_372_I17_D: "Gliding on the consumable",
  T_49_META_TYP_372_I18_D: "Gliding prop drop",
  T_49_META_TYP_372_I19_D: "Bounced by tires",
  T_49_META_TYP_372_I2_D: "Running",
  T_49_META_TYP_372_I20_D: "Bounced by human tires",
  T_49_META_TYP_372_I21_D: "An Animation in the Party Zone",
  T_49_META_TYP_372_I22_D: "Ride a Flying Machine",
  T_49_META_TYP_372_I23_D: "Entering a Cannon",
  T_49_META_TYP_372_I24_D: "This is the state when coming out of a Cannon, Carrier, etc. if the ride object is flying",
  T_49_META_TYP_372_I25_D: "After jumping from a springboard",
  T_49_META_TYP_372_I26_D: "After getting off the zipline",
  T_49_META_TYP_372_I27_D: "Not used",
  T_49_META_TYP_372_I3_D: "Down and Crawl",
  T_49_META_TYP_372_I4_D: "Swimming",
  T_49_META_TYP_372_I5_D: "Falling vertically",
  T_49_META_TYP_372_I6_D: "Over the wall",
  T_49_META_TYP_372_I7_D: "Unused",
  T_49_META_TYP_372_I8_D: "Knocked down but not dead",
  T_49_META_TYP_372_I9_D: "Water Skateboarding",
  T_49_META_TYP_374_I0_D: "Life, level and stroke colors",
  T_49_META_TYP_374_I1_D: "When the life value decreases, the lost portion is briefly shown in this color.",
  T_49_META_TYP_374_I10_D: "Offset relative to the target to be followed",
  T_49_META_TYP_374_I11_D: "The amount of life between each line, if less than or equal to 0, it will not be shown.",
  T_49_META_TYP_374_I12_D: "Total HP",
  T_49_META_TYP_374_I13_D: "Current HP",
  T_49_META_TYP_374_I14_D: "When enabled, blood changes will be colored differently.",
  T_49_META_TYP_374_I15_D: "When enabled, the offset property is transferred to the world coordinate system using the local coordinate system.",
  T_49_META_TYP_374_I2_D: "When the life value increases, the increased part is briefly displayed in this color.",
  T_49_META_TYP_374_I3_D: "The color of the life value border and the bottom of the vignette.",
  T_49_META_TYP_374_I4_D: "Range 0~1, the transparency of the overall UI.",
  T_49_META_TYP_374_I5_D: "Determines the overall UI scaling, and the font will be scaled as well.",
  T_49_META_TYP_374_I6_D: "Indicates the name of the current blood bar owner",
  T_49_META_TYP_374_I8_D: "The length of the bloodstain portion on the screen",
  T_49_META_TYP_374_I9_D: "Must follow an entity with a Transform component.",
  T_49_META_TYP_375_I1_D: "Battle Entity",
  T_49_META_TYP_376_I1_D: "Battle Entity",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Default",
  T_49_META_TYP_382_I1_D: "Skip the knockdown state and just die",
  T_49_META_TYP_382_I2_D: "No Skip Knockdown",
  T_49_META_TYP_387_I1_D: "Allow Pressed Outside",
  T_49_META_TYP_389_I0_D: "Default offset of the base",
  T_49_META_TYP_389_I1_D: "Background Sprite",
  T_49_META_TYP_389_I10_D: "Inactivated Alpha",
  T_49_META_TYP_389_I2_D: "Background Radius",
  T_49_META_TYP_389_I3_D: "Joystick Cap Image",
  T_49_META_TYP_389_I4_D: "Joystick Cap Radius",
  T_49_META_TYP_389_I5_D: "Joystick Cap Drag Radius",
  T_49_META_TYP_389_I6_D: "Arrow Sprite",
  T_49_META_TYP_389_I7_D: "Arrow Size",
  T_49_META_TYP_389_I8_D: "Arrow Offset",
  T_49_META_TYP_389_I9_D: "Activated Alpha",
  T_49_META_TYP_39_I1_D: "Sprite Shape",
  T_49_META_TYP_39_I10_D: "Gradient Top",
  T_49_META_TYP_39_I11_D: "Gradient Bottom",
  T_49_META_TYP_39_I12_D: "Top Alpha",
  T_49_META_TYP_39_I13_D: "Bottom Alpha",
  T_49_META_TYP_39_I3_D: "Flip",
  T_49_META_TYP_39_I4_D: "Filled",
  T_49_META_TYP_39_I5_D: "Center Invisible",
  T_49_META_TYP_39_I6_D: "Fill Direction",
  T_49_META_TYP_39_I7_D: "Fill Value",
  T_49_META_TYP_39_I8_D: "Invert Fill",
  T_49_META_TYP_39_I9_D: "Gradient",
  T_49_META_TYP_392_I0_D: "Default is 0, unit is ms.",
  T_49_META_TYP_392_I1_D: "The time it takes to shrink the circle, in ms",
  T_49_META_TYP_392_I10_D: "The end time of the reduced circle, in ms",
  T_49_META_TYP_392_I12_D: "Radius of out-of-zone end circle.",
  T_49_META_TYP_392_I13_D: "Shrinking Start Time",
  T_49_META_TYP_392_I14_D: "Damage Interval (ms)",
  T_49_META_TYP_392_I3_D: "The amount of damage done to players in the out-of-zone in a single turn.",
  T_49_META_TYP_392_I4_D: "List of players in the safe zone",
  T_49_META_TYP_392_I5_D: "Safe zone disappearance time, no safe zone will be generated when the safe zone disappearance time is less than the effective time.",
  T_49_META_TYP_392_I6_D: "Group ID",
  T_49_META_TYP_392_I7_D: "Radius of the out-of-zone starting circle",
  T_49_META_TYP_392_I8_D: "End state",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "Value is about 3.1416",
  T_49_META_TYP_394_I1_D: "Value about 2.7183",
  T_49_META_TYP_396_I0_D: "Title",
  T_49_META_TYP_396_I1_D: "Content",
  T_49_META_TYP_396_I2_D: "Options",
  T_49_META_TYP_396_I3_D: "ShowBackground",
  T_49_META_TYP_399_I0_D: "Jump Height",
  T_49_META_TYP_399_I1_D: "The number of consecutive jumps that can be performed before landing",
  T_49_META_TYP_399_I2_D: "How many jumps can be performed before landing",
  T_49_META_TYP_399_I3_D: "Enable Move In Midair",
  T_49_META_TYP_40_I1_D: "Label",
  T_49_META_TYP_40_I10_D: "Line Spacing",
  T_49_META_TYP_40_I11_D: "Overflow method",
  T_49_META_TYP_40_I12_D: "Font Style",
  T_49_META_TYP_40_I13_D: "Is Apply Shadow",
  T_49_META_TYP_40_I14_D: "Shadow Color",
  T_49_META_TYP_40_I15_D: "Shadow Offset",
  T_49_META_TYP_40_I3_D: "Localized Key, can be used in multiple languages",
  T_49_META_TYP_40_I5_D: "Alignment method",
  T_49_META_TYP_40_I6_D: "Alignment Vertical",
  T_49_META_TYP_40_I7_D: "Is Bold",
  T_49_META_TYP_40_I8_D: "Is Italic",
  T_49_META_TYP_40_I9_D: "Is Underline",
  T_49_META_TYP_400_I0_D: "Active",
  T_49_META_TYP_400_I1_D: "Passive",
  T_49_META_TYP_400_I2_D: "No Attack",
  T_49_META_TYP_401_I0_D: "Cannot fire.",
  T_49_META_TYP_401_I1_D: "Can fire continuously",
  T_49_META_TYP_401_I2_D: "Fires once per attack command",
  T_49_META_TYP_401_I3_D: "Three times per attack command.",
  T_49_META_TYP_401_I4_D: "Fires twice per attack command",
  T_49_META_TYP_401_I5_D: "Parry",
  T_49_META_TYP_402_I0_D: "Targets to friend",
  T_49_META_TYP_402_I1_D: "Function Type",
  T_49_META_TYP_402_I2_D: "Style",
  T_49_META_TYP_403_I0_D: "Add Friend",
  T_49_META_TYP_403_I1_D: "Report",
  T_49_META_TYP_404_I0_D: "Light",
  T_49_META_TYP_404_I1_D: "Dark",
  T_49_META_TYP_405_I0_D: "By Hierarchy",
  T_49_META_TYP_405_I1_D: "By Priority High To Low",
  T_49_META_TYP_405_I2_D: "By Priority Low To High",
  T_49_META_TYP_406_I0_D: "Control the distance of player's Animation.",
  T_49_META_TYP_406_I1_D: "Controls the height of the player's body during the move.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Client",
  T_49_META_TYP_407_I2_D: "Server",
  T_49_META_TYP_407_I3_D: "Both",
  T_49_META_TYP_409_I0_D: "No errors",
  T_49_META_TYP_409_I1_D: "Data storage timeout, mainly for read operations",
  T_49_META_TYP_409_I10_D: "Failed team change - invalid target team",
  T_49_META_TYP_409_I11_D: "Failed team change - Dead player not allowed to change teams",
  T_49_META_TYP_409_I12_D: "Failed team change - not allowed to change team in vehicle",
  T_49_META_TYP_409_I2_D: "Data storage read/write frequency exceeds the limit",
  T_49_META_TYP_409_I3_D: "Parameter exceptions",
  T_49_META_TYP_409_I4_D: "Room creation failed: no valid PersonaIDs available",
  T_49_META_TYP_409_I5_D: "Undefined error status",
  T_49_META_TYP_409_I6_D: "Commercialization service shut down, users can no longer use the developer's service",
  T_49_META_TYP_409_I7_D: "Failed to change team - mode not supported",
  T_49_META_TYP_409_I8_D: "Failed to change team-Currently already in target team",
  T_49_META_TYP_409_I9_D: "Queue change failed-invalid target",
  T_49_META_TYP_41_I0_D: "Sprite Shape",
  T_49_META_TYP_41_I19_D: "Disable collision box",
  T_49_META_TYP_41_I3_D: "Disable Color",
  T_49_META_TYP_41_I4_D: "Pressed Color",
  T_49_META_TYP_41_I5_D: "Fill Type",
  T_49_META_TYP_41_I6_D: "Is FE Button",
  T_49_META_TYP_41_I7_D: "Pressed Sprite",
  T_49_META_TYP_41_I8_D: "Pressed Sprite Type",
  T_49_META_TYP_41_I9_D: "Flip Type",
  T_49_META_TYP_411_I0_D: "Forward Speed",
  T_49_META_TYP_411_I1_D: "Backward Speed",
  T_49_META_TYP_411_I2_D: "Up Speed",
  T_49_META_TYP_411_I3_D: "Down Speed",
  T_49_META_TYP_411_I4_D: "Grenade Min Damage",
  T_49_META_TYP_411_I5_D: "Grenade Max Damage",
  T_49_META_TYP_411_I6_D: "Grenade Range",
  T_49_META_TYP_412_I0_D: "Horsepower gained by the vehicle when using the gas button",
  T_49_META_TYP_412_I1_D: "Horsepower gained by the vehicle when using the reverse/brake button",
  T_49_META_TYP_412_I2_D: "Maximum steering angle at high speed",
  T_49_META_TYP_412_I3_D: "Speed threshold applied to the maximum steering angle at high speeds",
  T_49_META_TYP_412_I4_D: "After reaching the maximum speed, the carrier does not provide any more horsepower, but the carrier may exceed that maximum speed (e.g. through a downhill)",
  T_49_META_TYP_412_I5_D: "When the carrier is not being maneuvered, decelerate the carrier by multiplying IdleBrakeInput by BrakeTorque",
  T_49_META_TYP_412_I6_D: "Damage calculation for crashes, applying the parameters of the damage formula",
  T_49_META_TYP_412_I7_D: "Damage calculation for crashing, damage will not be increased even if the speed is exceeded.",
  T_49_META_TYP_412_I8_D: "Damage calculation for ramming, minimum damage",
  T_49_META_TYP_412_I9_D: "Damage calculation for ramming, maximum damage",
  T_49_META_TYP_413_I0_D: "Player (NPC) transformed costume",
  T_49_META_TYP_414_I1_D: "Wide Range",
  T_49_META_TYP_415_I0_D: "Persona ID",
  T_49_META_TYP_415_I1_D: "Nickname",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "The Persona to which it is bound.",
  T_49_META_TYP_416_I2_D: "Offset",
  T_49_META_TYP_416_I3_D: "Height",
  T_49_META_TYP_416_I4_D: "Whether to reply to system messages",
  T_49_META_TYP_416_I5_D: "Persona nickname",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Nickname of the user",
  T_49_META_TYP_416_I8_D: "User Avatar",
  T_49_META_TYP_417_I0_D: "Resource ID",
  T_49_META_TYP_418_I0_D: "Membership expiration",
  T_49_META_TYP_418_I1_D: "Become a member",
  T_49_META_TYP_418_I2_D: "Renew membership",
  T_49_META_TYP_42_I0_D: "Default Text",
  T_49_META_TYP_42_I1_D: "Active Text",
  T_49_META_TYP_42_I10_D: "Max Length",
  T_49_META_TYP_42_I14_D: "Pressed Color",
  T_49_META_TYP_42_I16_D: "Localized Key, available in multiple languages",
  T_49_META_TYP_42_I3_D: "Alignment method",
  T_49_META_TYP_42_I4_D: "Alignment Vertical",
  T_49_META_TYP_42_I5_D: "Is Bold",
  T_49_META_TYP_42_I6_D: "Is Italic",
  T_49_META_TYP_42_I7_D: "Is Underline",
  T_49_META_TYP_42_I8_D: "Line Spacing",
  T_49_META_TYP_42_I9_D: "Word Wrap",
  T_49_META_TYP_424_I0_D: "Linear Fog",
  T_49_META_TYP_424_I1_D: "Exponential Fog",
  T_49_META_TYP_424_I2_D: "Exponential Square Fog",
  T_49_META_TYP_426_I0_D: "Intensity",
  T_49_META_TYP_426_I1_D: "Range",
  T_49_META_TYP_426_I2_D: "The angle of the cone in degrees.",
  T_49_META_TYP_426_I3_D: "Light color",
  T_49_META_TYP_428_I0_D: "Weapon Skin IDs",
  T_49_META_TYP_428_I2_D: "Suit ID",
  T_49_META_TYP_428_I3_D: "Headwear ID",
  T_49_META_TYP_428_I4_D: "Face ID",
  T_49_META_TYP_428_I5_D: "Makeup ID",
  T_49_META_TYP_428_I6_D: "Upper Body ID",
  T_49_META_TYP_428_I7_D: "Bottom ID",
  T_49_META_TYP_428_I8_D: "Shoe ID",
  T_49_META_TYP_431_I1_D: "The trajectory of the target entity",
  T_49_META_TYP_431_I3_D: "Movement speed, unit m/s",
  T_49_META_TYP_431_I4_D: `Whether the movement is toward the tangent line of the path or not 
Default is False, the movement of the object will not change the direction 
 If True, the movement of the object will face the path forward direction`,
  T_49_META_TYP_431_I5_D: "Played Percentage",
  T_49_META_TYP_432_I0_D: "Rollover angle, affects the radial rotation of the path from both sides of this point",
  T_49_META_TYP_432_I1_D: "The relative position of the tangent control point to the waypoint, which determines the path tangent.",
  T_49_META_TYP_433_I0_D: "Tween straight lines between path points",
  T_49_META_TYP_433_I1_D: "Tween curves between path points for smooth motion.",
  T_49_META_TYP_433_I2_D: "Supports manual adjustment of tangents to curve points",
  T_49_META_TYP_434_I0_D: "Path type",
  T_49_META_TYP_434_I1_D: "Total length of the path",
  T_49_META_TYP_434_I2_D: "Whether the path begins and ends at the same time",
  T_49_META_TYP_434_I3_D: "Collection of waypoints",
  T_49_META_TYP_437_I3_D: "Left Players",
  T_49_META_TYP_437_I4_D: "Right Players",
  T_49_META_TYP_437_I5_D: "Array of points type names",
  T_49_META_TYP_437_I6_D: "Left points array (List 1D: player; List 2D: points data filled according to customized points type)",
  T_49_META_TYP_437_I7_D: "Array of points on the right (List 1D: players; List 2D: points data filled in according to customized points types)",
  T_49_META_TYP_438_I1_D: "Grouped players array",
  T_49_META_TYP_438_I2_D: "Grouped Ranking Array",
  T_49_META_TYP_438_I3_D: "Array of grouped scores",
  T_49_META_TYP_438_I4_D: "Array of point type names",
  T_49_META_TYP_438_I5_D: "Grouped colors array",
  T_49_META_TYP_438_I6_D: "Array of players' points (corresponding to their order when not grouped)",
  T_49_META_TYP_442_I1_D: "Left Score",
  T_49_META_TYP_442_I10_D: "Right death icon",
  T_49_META_TYP_442_I2_D: "Right Score",
  T_49_META_TYP_442_I3_D: "Number of survivors on the left",
  T_49_META_TYP_442_I4_D: "Survivors on the right",
  T_49_META_TYP_442_I5_D: "Left Dead",
  T_49_META_TYP_442_I6_D: "Right Deaths",
  T_49_META_TYP_442_I7_D: "Left survivor icon",
  T_49_META_TYP_442_I8_D: "Right Survival Icon",
  T_49_META_TYP_442_I9_D: "Left Dead Icon",
  T_49_META_TYP_444_I0_D: "English",
  T_49_META_TYP_444_I1_D: "Simplified Chinese",
  T_49_META_TYP_444_I10_D: "French",
  T_49_META_TYP_444_I11_D: "German",
  T_49_META_TYP_444_I12_D: "Turkish",
  T_49_META_TYP_444_I13_D: "Hindi",
  T_49_META_TYP_444_I14_D: "Japanese",
  T_49_META_TYP_444_I15_D: "Romanian",
  T_49_META_TYP_444_I16_D: "Romanian",
  T_49_META_TYP_444_I17_D: "Burmese",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "Bengali",
  T_49_META_TYP_444_I2_D: "Traditional Chinese",
  T_49_META_TYP_444_I3_D: "Thai",
  T_49_META_TYP_444_I4_D: "Vietnamese",
  T_49_META_TYP_444_I5_D: "Indonesian",
  T_49_META_TYP_444_I6_D: "Chinese (Simplified)",
  T_49_META_TYP_444_I7_D: "Spanish",
  T_49_META_TYP_444_I8_D: "Russian",
  T_49_META_TYP_444_I9_D: "Korean",
  T_49_META_TYP_51_I0_D: "Normal Zombie",
  T_49_META_TYP_51_I1_D: "Axe Zombie",
  T_49_META_TYP_51_I10_D: "Fly Bomb Bee",
  T_49_META_TYP_51_I11_D: "Zombie Dragon",
  T_49_META_TYP_51_I2_D: "Tossing Zombie",
  T_49_META_TYP_51_I3_D: "Self-Explode Zombie",
  T_49_META_TYP_51_I4_D: "Tyrant Zombie",
  T_49_META_TYP_51_I5_D: "Throw Red Zombie",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Tank Zombie",
  T_49_META_TYP_51_I8_D: "Drill Zombie",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Explosion Delay",
  T_49_META_TYP_56_I11_D: "Explosion Range",
  T_49_META_TYP_56_I12_D: "Explosion Damage",
  T_49_META_TYP_56_I13_D: "Burning Time",
  T_49_META_TYP_56_I14_D: "Burning Damage",
  T_49_META_TYP_56_I15_D: "Burning Damage Interval",
  T_49_META_TYP_56_I17_D: "Vehicle Pilot",
  T_49_META_TYP_56_I18_D: "All passengers on the vehicle",
  T_49_META_TYP_56_I19_D: "Vehicle Skin ID",
  T_49_META_TYP_56_I20_D: "Prioritize Player Configuration",
  T_49_META_TYP_56_I21_D: "Max. HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Whether to teleport manually or automatically (default is manual)",
  T_49_META_TYP_58_I0_D: "Type of buff generated",
  T_49_META_TYP_58_I1_D: "The time in seconds from when the buff is picked up to when the next buff is generated.",
  T_49_META_TYP_59_I0_D: "Motion Type",
  T_49_META_TYP_59_I1_D: "Motion Value X",
  T_49_META_TYP_59_I2_D: "Motion Value Y",
  T_49_META_TYP_59_I3_D: "Motion Value Z",
  T_49_META_TYP_59_I4_D: "Movement Duration",
  T_49_META_TYP_59_I5_D: "Stop Duration",
  T_49_META_TYP_59_I6_D: "Disable Reciprocating",
  T_49_META_TYP_60_I0_D: "Loot weapon points",
  T_49_META_TYP_61_I0_D: "Bound Store",
  T_49_META_TYP_61_I1_D: "Setting the trigger range",
  T_49_META_TYP_61_I2_D: "Model Visibility",
  T_49_META_TYP_62_I0_D: "Velocity XZ",
  T_49_META_TYP_62_I1_D: "Velocity Y",
  T_49_META_TYP_64_I0_D: "Music component type",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Path Point",
  T_49_META_TYP_68_I0_D: "AI's current blood level",
  T_49_META_TYP_68_I1_D: "AI's current maximum blood level",
  T_49_META_TYP_68_I10_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_68_I11_D: "Whether the AI is currently invincible",
  T_49_META_TYP_68_I12_D: "Percentage of damage dealt to the AI when it takes damage, can be reduced or increased",
  T_49_META_TYP_68_I13_D: "Type of AI",
  T_49_META_TYP_68_I14_D: "Whether to automatically search for enemies",
  T_49_META_TYP_68_I15_D: "0 is auto attack, 1 is defense attack, 2 is no attack at all.",
  T_49_META_TYP_68_I16_D: "Path ID",
  T_49_META_TYP_68_I17_D: "Chase Target",
  T_49_META_TYP_68_I18_D: "Attack Target",
  T_49_META_TYP_68_I19_D: "AI's birth point coordinates",
  T_49_META_TYP_68_I2_D: "Get the entity of the AI's team.",
  T_49_META_TYP_68_I20_D: "The team's camp number",
  T_49_META_TYP_68_I4_D: "Can only modify the attack power of normal attacks, skill attacks don't count.",
  T_49_META_TYP_68_I7_D: "AI's free movement range, can only modify the base value, if there is extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I8_D: "AI's range to detect enemies, can only modify the base value, if there is an extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I9_D: "True movement speed, if there is a skill acceleration it will be multiplied by it.",
  T_49_META_TYP_70_I0_D: "ID of the target entity that the formula works on, used by internal implementations, invisible to the player.",
  T_49_META_TYP_70_I1_D: "ID of the target entity property on which the formula works, used by internal implementations, not visible to the player",
  T_49_META_TYP_70_I2_D: "Minimum value allowed",
  T_49_META_TYP_70_I3_D: "Maximum value allowed",
  T_49_META_TYP_70_I4_D: "Base Coefficient",
  T_49_META_TYP_70_I5_D: "Pre-Accumulator",
  T_49_META_TYP_70_I6_D: "Multiplier",
  T_49_META_TYP_70_I7_D: "Multiply Accumulate",
  T_49_META_TYP_70_I8_D: "Post-Accumulator",
  T_49_META_TYP_71_I0_D: "Shop item number",
  T_49_META_TYP_71_I1_D: "Price",
  T_49_META_TYP_71_I10_D: "Is Purchasable",
  T_49_META_TYP_71_I2_D: "Money Type",
  T_49_META_TYP_71_I3_D: "Overall limit",
  T_49_META_TYP_71_I4_D: "Current overall limit",
  T_49_META_TYP_71_I5_D: "Shop item name",
  T_49_META_TYP_71_I6_D: "Shop Item Description",
  T_49_META_TYP_71_I7_D: "Shop Item List",
  T_49_META_TYP_71_I8_D: "ItemCounts",
  T_49_META_TYP_71_I9_D: "Resource path, empty by default",
  T_49_META_TYP_72_I1_D: "Shop Items",
  T_49_META_TYP_73_I1_D: "Shelfs",
  T_49_META_TYP_74_I0_D: "Weapon",
  T_49_META_TYP_74_I1_D: "Helmet",
  T_49_META_TYP_74_I2_D: "Vest",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "One Way",
  T_49_META_TYP_75_I1_D: "Back And Forth",
  T_49_META_TYP_76_I0_D: "Patrols only, no attacks on targets along the way",
  T_49_META_TYP_76_I1_D: "Patrol While Attack",
  T_49_META_TYP_79_I0_D: "Weapon Attack Power",
  T_49_META_TYP_79_I1_D: "Attack Range",
  T_49_META_TYP_79_I10_D: "Bullet Spread Start Count",
  T_49_META_TYP_79_I11_D: "Weapon ID",
  T_49_META_TYP_79_I12_D: "Minimum wait time in seconds between shots, multiple bullets may be fired per shot depending on shot type",
  T_49_META_TYP_79_I13_D: "The player who owns the weapon",
  T_49_META_TYP_79_I14_D: "Is Consume Ammo",
  T_49_META_TYP_79_I15_D: "Dual wielding type (0 not dual wielding 1 and self 2 and any weapon)",
  T_49_META_TYP_79_I16_D: "Armor damage factor",
  T_49_META_TYP_79_I17_D: "Player movement speed effects",
  T_49_META_TYP_79_I18_D: "Damage percentage for hitting the torso",
  T_49_META_TYP_79_I19_D: "Percentage of damage that hits the head",
  T_49_META_TYP_79_I2_D: "The length of time to wait between bullets, in seconds.",
  T_49_META_TYP_79_I20_D: "Damage percentage for hitting limbs",
  T_49_META_TYP_79_I21_D: "Extra Damage Ratio (Vehicle, Oil Drum, Ice Wall)",
  T_49_META_TYP_79_I22_D: "Visible On Back",
  T_49_META_TYP_79_I23_D: "Extra damage for hitting the ground",
  T_49_META_TYP_79_I24_D: "Ammo per Shot",
  T_49_META_TYP_79_I25_D: "Bullet change speed (base speed * factor)",
  T_49_META_TYP_79_I26_D: "Current Ammo Count",
  T_49_META_TYP_79_I27_D: "Gunskin ID",
  T_49_META_TYP_79_I28_D: "When player configuration is prioritized, the gun skin configuration on the player overrides the gun skin property of the weapon itself",
  T_49_META_TYP_79_I29_D: "When writing in the gun skin's properties for a weapon, the weapon's base value is affected by the gun skin",
  T_49_META_TYP_79_I3_D: "Ammo Mag Size",
  T_49_META_TYP_79_I30_D: "Diffusion Increase Speed (0.1 = 10% expansion for each additional burst of collision)",
  T_49_META_TYP_79_I31_D: "Diffusion recovery speed",
  T_49_META_TYP_79_I32_D: "Player speed effect when firing",
  T_49_META_TYP_79_I33_D: "Diffusion size in case of movement (1.5 = 1.5 * basic collimator size)",
  T_49_META_TYP_79_I34_D: "Weapon Type",
  T_49_META_TYP_79_I36_D: "Fire Type",
  T_49_META_TYP_79_I37_D: "Is Single Shot",
  T_49_META_TYP_79_I38_D: "Is Silenced",
  T_49_META_TYP_79_I39_D: "ADS Sensitivity Multiplier",
  T_49_META_TYP_79_I4_D: "Initial Mag Count",
  T_49_META_TYP_79_I5_D: "Armor Penetration",
  T_49_META_TYP_79_I6_D: "Full Damage Distance",
  T_49_META_TYP_79_I7_D: "Min. Damage Distance",
  T_49_META_TYP_79_I8_D: "Min. Damage",
  T_49_META_TYP_79_I9_D: "The number of bullets that can be fired before the scattering begins",
  T_49_META_TYP_80_I1_D: "When true, manual disable is disabled.",
  T_49_META_TYP_80_I2_D: "Bound shop entities",
  T_49_META_TYP_80_I4_D: "Bound Money List",
  T_49_META_TYP_80_I5_D: "Bound Wallet ID",
  T_49_META_TYP_80_I6_D: "The type of the current UI player request target",
  T_49_META_TYP_80_I7_D: "Requested Item List",
  T_49_META_TYP_81_I0_D: "Random Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Bullet Buff",
  T_49_META_TYP_81_I3_D: "Armor Buff",
  T_49_META_TYP_82_I1_D: "Button icon",
  T_49_META_TYP_82_I3_D: "Position relative to the anchor point",
  T_49_META_TYP_83_I1_D: "TriggerPlayerID",
  T_49_META_TYP_83_I2_D: "Passed parameters",
  T_49_META_TYP_86_I0_D: "Min",
  T_49_META_TYP_86_I1_D: "Max",
  T_49_META_TYP_86_I2_D: "Base coefficient, multiplied by the original value before all calculations are performed.",
  T_49_META_TYP_86_I3_D: "Pre-accumulator, accumulates before multiplication, participates in multiplication calculations",
  T_49_META_TYP_86_I4_D: "Consecutive multipliers, for example (reduced to 90%, strengthened to 110%) have the effect of Value*90%*110%.",
  T_49_META_TYP_86_I5_D: "The effect of a multiplication accumulator, e.g. (add 10%, add 5%) is Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post accumulator, not involved in multiplication calculations, stacked at the end",
  T_49_META_TYP_88_I0_D: "Base type, the most basic in-game currency, the type of pricing for general shop items in the current version",
  T_49_META_TYP_89_I0_D: "Only base currency is available in the current version",
  T_49_META_TYP_89_I1_D: "Amount of currency",
  T_49_META_TYP_89_I2_D: "Currency icon",
  T_49_META_TYP_89_I3_D: "Currency icon color",
  T_49_META_TYP_90_I0_D: "The contents of the wallet are a bunch of currencies",
  T_49_META_TYP_92_I0_D: "Square Wooden Crate",
  T_49_META_TYP_92_I1_D: "Long Wooden Crate",
  T_49_META_TYP_92_I10_D: "Turret",
  T_49_META_TYP_92_I100_D: "Stairs",
  T_49_META_TYP_92_I101_D: "Stair Landing B",
  T_49_META_TYP_92_I102_D: "Stair Landing A",
  T_49_META_TYP_92_I103_D: "Phone Booth",
  T_49_META_TYP_92_I104_D: "BIS Themed Wall",
  T_49_META_TYP_92_I105_D: "BIS Themed Flower Bed",
  T_49_META_TYP_92_I106_D: "Vending Machine",
  T_49_META_TYP_92_I107_D: "Monster Entities",
  T_49_META_TYP_92_I108_D: "Unit Generator",
  T_49_META_TYP_92_I109_D: "Sports Car",
  T_49_META_TYP_92_I11_D: "Guardhouse",
  T_49_META_TYP_92_I110_D: "Tuk Tuk",
  T_49_META_TYP_92_I111_D: "Destructible Wooden Crate",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motorbike",
  T_49_META_TYP_92_I114_D: "Monster Truck",
  T_49_META_TYP_92_I115_D: "Coin Generator",
  T_49_META_TYP_92_I116_D: "Stair Landing C",
  T_49_META_TYP_92_I117_D: "Sign",
  T_49_META_TYP_92_I118_D: "Fence",
  T_49_META_TYP_92_I119_D: "Jersey Machine",
  T_49_META_TYP_92_I12_D: "Two-Story House",
  T_49_META_TYP_92_I121_D: "Concrete Pillar",
  T_49_META_TYP_92_I122_D: "Loot Soccer Item Box",
  T_49_META_TYP_92_I123_D: "Oil Drum",
  T_49_META_TYP_92_I124_D: "Low-Gravity Area",
  T_49_META_TYP_92_I125_D: "Weapon",
  T_49_META_TYP_92_I126_D: "Fence B",
  T_49_META_TYP_92_I127_D: "Small House A",
  T_49_META_TYP_92_I128_D: "Damaged Truck",
  T_49_META_TYP_92_I129_D: "Basic Sphere",
  T_49_META_TYP_92_I13_D: "Sand Sculpture",
  T_49_META_TYP_92_I130_D: "Basic Cone",
  T_49_META_TYP_92_I131_D: "Basic Cylinder",
  T_49_META_TYP_92_I132_D: "Consumable Generator",
  T_49_META_TYP_92_I133_D: "Custom Water Body",
  T_49_META_TYP_92_I134_D: "Arrow",
  T_49_META_TYP_92_I135_D: "Dyed Block",
  T_49_META_TYP_92_I136_D: "Dyed Oil Drum",
  T_49_META_TYP_92_I137_D: "Text",
  T_49_META_TYP_92_I138_D: "Icon",
  T_49_META_TYP_92_I139_D: "Ice Doll",
  T_49_META_TYP_92_I14_D: "Fountain",
  T_49_META_TYP_92_I140_D: "Capsule Trigger",
  T_49_META_TYP_92_I141_D: "Sphere Collision Trigger",
  T_49_META_TYP_92_I142_D: "Reflective Solid Color Basic Block 1",
  T_49_META_TYP_92_I143_D: "Bumper Car Manufacturer",
  T_49_META_TYP_92_I144_D: "Checkered Amusement Park Block",
  T_49_META_TYP_92_I145_D: "Large Screen",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Giant Lollipop",
  T_49_META_TYP_92_I148_D: "Food Truck B",
  T_49_META_TYP_92_I15_D: "Cherry Blossom",
  T_49_META_TYP_92_I16_D: "One-Story House",
  T_49_META_TYP_92_I17_D: "Three-Story House",
  T_49_META_TYP_92_I18_D: "Banana Tree",
  T_49_META_TYP_92_I19_D: "Toilet",
  T_49_META_TYP_92_I2_D: "Bush-Covered Long Wooden Crate",
  T_49_META_TYP_92_I20_D: "Fence",
  T_49_META_TYP_92_I21_D: "Destructible Container",
  T_49_META_TYP_92_I22_D: "Destructible Fence",
  T_49_META_TYP_92_I23_D: "Tire",
  T_49_META_TYP_92_I24_D: "Bumper Car",
  T_49_META_TYP_92_I25_D: "Amphibious Vehicle",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Trash Can",
  T_49_META_TYP_92_I28_D: "Medical Tent",
  T_49_META_TYP_92_I29_D: "Garage",
  T_49_META_TYP_92_I3_D: "Haystack",
  T_49_META_TYP_92_I30_D: "Painted Wall",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Iron Platform",
  T_49_META_TYP_92_I33_D: "Container House",
  T_49_META_TYP_92_I34_D: "Trailer",
  T_49_META_TYP_92_I35_D: "Wall A",
  T_49_META_TYP_92_I36_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I37_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I38_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I39_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I4_D: "Wrecked Car",
  T_49_META_TYP_92_I40_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Buff Generator",
  T_49_META_TYP_92_I47_D: "Propeller Mechanisms",
  T_49_META_TYP_92_I48_D: "Pan Loot",
  T_49_META_TYP_92_I49_D: "Cube Loot",
  T_49_META_TYP_92_I5_D: "Wrecked Bus",
  T_49_META_TYP_92_I50_D: "Circle Loot",
  T_49_META_TYP_92_I51_D: "Mallet Machine",
  T_49_META_TYP_92_I52_D: "Moving Board",
  T_49_META_TYP_92_I53_D: "Moving Target",
  T_49_META_TYP_92_I54_D: "Retractable Wall",
  T_49_META_TYP_92_I55_D: "Loot Point Weapon Component",
  T_49_META_TYP_92_I56_D: "Loot Point Bullet Component",
  T_49_META_TYP_92_I57_D: "Loot Point Expendable Item Component",
  T_49_META_TYP_92_I58_D: "Loot Point Thrown Item Component",
  T_49_META_TYP_92_I59_D: "Loot Point Multiplier Component",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Loot Point Armor Component",
  T_49_META_TYP_92_I61_D: "I Pipe",
  T_49_META_TYP_92_I62_D: "T Pipe",
  T_49_META_TYP_92_I63_D: "Cross Pipe",
  T_49_META_TYP_92_I64_D: "Elbow Pipe",
  T_49_META_TYP_92_I65_D: "Giant Mushroom Cluster",
  T_49_META_TYP_92_I66_D: "Drying Rack",
  T_49_META_TYP_92_I67_D: "Plank Bridge",
  T_49_META_TYP_92_I68_D: "Lattice Screen",
  T_49_META_TYP_92_I69_D: "Concrete Column",
  T_49_META_TYP_92_I7_D: "Shipping Container B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Dead Wood",
  T_49_META_TYP_92_I72_D: "Stone Lantern",
  T_49_META_TYP_92_I73_D: "Streetlight",
  T_49_META_TYP_92_I74_D: "Solar Panel",
  T_49_META_TYP_92_I75_D: "Air Conditioner",
  T_49_META_TYP_92_I76_D: "Square",
  T_49_META_TYP_92_I77_D: "Slope",
  T_49_META_TYP_92_I78_D: "Food Truck",
  T_49_META_TYP_92_I79_D: "Death or Invincibility Trigger",
  T_49_META_TYP_92_I8_D: "Shipping Container C",
  T_49_META_TYP_92_I80_D: "Checkpoint",
  T_49_META_TYP_92_I81_D: "End Position",
  T_49_META_TYP_92_I82_D: "Dice",
  T_49_META_TYP_92_I83_D: "Bench",
  T_49_META_TYP_92_I84_D: "Bus Stop",
  T_49_META_TYP_92_I85_D: "Dog House",
  T_49_META_TYP_92_I86_D: "Ad Board",
  T_49_META_TYP_92_I87_D: "Refinery Tank",
  T_49_META_TYP_92_I88_D: "Graffiti Wall",
  T_49_META_TYP_92_I89_D: "Stable",
  T_49_META_TYP_92_I9_D: "Cabin",
  T_49_META_TYP_92_I90_D: "Stone Arch Bridge",
  T_49_META_TYP_92_I91_D: "Patio Set With Umbrella",
  T_49_META_TYP_92_I92_D: "Finish Banner",
  T_49_META_TYP_92_I93_D: "Fortress",
  T_49_META_TYP_92_I94_D: "Monster Spawn Point",
  T_49_META_TYP_92_I95_D: "Mark",
  T_49_META_TYP_92_I97_D: "Custom Trigger",
  T_49_META_TYP_92_I98_D: "Double Door",
  T_49_META_TYP_92_I99_D: "Barricade",
  T_49_META_TYP_94_I0_D: "Add",
  T_49_META_TYP_94_I1_D: "Multiply",
  T_49_META_TYP_95_I0_D: "Money Type",
  T_49_META_TYP_95_I1_D: "Amount of currency",
  T_49_META_TYP_96_I0_D: "Get Wallet",
  T_49_META_TYP_96_I1_D: "Display position (anchor is top right corner)",
  T_49_META_TYP_97_I0_D: "Position in the world coordinate system",
  T_49_META_TYP_97_I1_D: "Rotation angle in the world coordinate system, XYZ components are pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I10_D: "Local coordinate axis x-axis orientation",
  T_49_META_TYP_97_I11_D: "Local axis z-axis orientation",
  T_49_META_TYP_97_I2_D: "Zoom size in the world coordinate system",
  T_49_META_TYP_97_I3_D: "Parent node of this node",
  T_49_META_TYP_97_I4_D: "Rotation in the world coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I5_D: "Position in local coordinate system",
  T_49_META_TYP_97_I6_D: "Rotation in the local coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I7_D: "Rotation angle in the local coordinate system, with XYZ components for pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I8_D: "Scaling dimension in the local coordinate system",
  T_49_META_TYP_97_I9_D: "Local coordinate axis y-axis orientation",
  T_49_META_TYP_99_I0_D: "Radius of the soccer ball",
  T_49_META_TYP_99_I1_D: "Friction coefficient at normal condition",
  T_49_META_TYP_99_I2_D: "Impact Friction",
  T_49_META_TYP_99_I3_D: "Min. Shooting Angle",
  T_49_META_TYP_99_I4_D: "Min. Elevation Angle",
  T_49_META_TYP_99_I5_D: "Reset Time",
  T_49_META_TYP_99_I6_D: "Max. Shooting Angle",
  T_49_META_TYP_99_I7_D: "Reset Position",
  T_49_META_TYPE_0_D: "Object, the root of the type hierarchy",
  T_49_META_TYPE_1_D: "A container for a set of data in a list",
  T_49_META_TYPE_10_D: "Entity base component, all components will combine this component",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Morph Object",
  T_49_META_TYPE_1010_D: "Timer Info",
  T_49_META_TYPE_1011_D: "Opening Banner",
  T_49_META_TYPE_1012_D: "Banner entities start in two-team rounds, and modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1013_D: "General round start banner entity, modifying entity properties affects display content on corresponding UIs",
  T_49_META_TYPE_1014_D: "Team round score banner entity, modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1015_D: "Checkpoint Manager entity, modifying the entity properties will affect the display on the corresponding UI.",
  T_49_META_TYPE_1016_D: "End of round display entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1017_D: "If there are two teams at the start of the round, display the two teams' rivalry banner",
  T_49_META_TYPE_1018_D: "Score of the round between the two teams",
  T_49_META_TYPE_1019_D: "The final result is a tie",
  T_49_META_TYPE_102_D: "Resurrection source type: death, fall down",
  T_49_META_TYPE_1020_D: "Round count entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1021_D: "Phase countdown entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1022_D: "Match information subheading entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1023_D: "Two teams match information entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1024_D: "Team match information UI entity, modify the entity property to affect the display content on the corresponding UI",
  T_49_META_TYPE_1027_D: "Describes the type of the type and returns that type when Typeof is used",
  T_49_META_TYPE_1028_D: "Camp information entity, modify the entity properties to affect the display content of the corresponding UI.",
  T_49_META_TYPE_1029_D: "The icon hint information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_103_D: "Enumeration of item slots",
  T_49_META_TYPE_1030_D: "Short version of the two teams' match information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1031_D: "Timing prompt UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1032_D: "Floating word prompt entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1033_D: "Round switching entity, including current round settlement and next round start information, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1035_D: "Open scoreboard button UI entity, modifying entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1036_D: "Infected mode, display the UI of current zombie level.",
  T_49_META_TYPE_1037_D: "Add points animation UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1038_D: "Infected mode zombie UI effects",
  T_49_META_TYPE_1039_D: "Countdown prompt entity, modifying the entity properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_104_D: "Jersey Style",
  T_49_META_TYPE_1040_D: "UI Card Selection Panel",
  T_49_META_TYPE_1041_D: "UI Identity Notification",
  T_49_META_TYPE_1042_D: "UI Countdown 5s",
  T_49_META_TYPE_1043_D: "UI Title Banner",
  T_49_META_TYPE_1044_D: "UI Built-In Switch",
  T_49_META_TYPE_1045_D: "UI Skill Button",
  T_49_META_TYPE_105_D: "Football Goal",
  T_49_META_TYPE_106_D: "Aiming aid type",
  T_49_META_TYPE_107_D: "Entities that can be targeted and hit, but not necessarily harmed",
  T_49_META_TYPE_108_D: "Integer types, 64-bit signed integers",
  T_49_META_TYPE_109_D: "The chat channel entity is a container that contains its channel ID and players.",
  T_49_META_TYPE_11_D: "Global entity, unique for the entire game",
  T_49_META_TYPE_110_D: "Idle chat channel",
  T_49_META_TYPE_111_D: "Behavior types",
  T_49_META_TYPE_112_D: "Player Behavior Status Type",
  T_49_META_TYPE_113_D: "Drum Music",
  T_49_META_TYPE_114_D: "Lead1 Music",
  T_49_META_TYPE_115_D: "Lead2 Music",
  T_49_META_TYPE_116_D: "Lead3 Music",
  T_49_META_TYPE_117_D: "Drumbeat music component type",
  T_49_META_TYPE_118_D: "Faction",
  T_49_META_TYPE_119_D: "Attackable options",
  T_49_META_TYPE_12_D: "Combat entities, can attack, take hits, kill, etc.",
  T_49_META_TYPE_120_D: "UI Progress Bar",
  T_49_META_TYPE_121_D: "Interval between waves",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumeration of skybox base types",
  T_49_META_TYPE_124_D: "Claim Range",
  T_49_META_TYPE_125_D: "Can modify the base appearance of objects, such as mapping and transparency",
  T_49_META_TYPE_126_D: "Health Bar",
  T_49_META_TYPE_127_D: "How to move objects",
  T_49_META_TYPE_128_D: "Morphable Object",
  T_49_META_TYPE_129_D: "Loot Ammo Type",
  T_49_META_TYPE_13_D: "UI Widget Entity",
  T_49_META_TYPE_130_D: "Loot Consumable Type",
  T_49_META_TYPE_131_D: "Loot Armor Type",
  T_49_META_TYPE_132_D: "Loot Throwable Type",
  T_49_META_TYPE_133_D: "Loot Scope Type",
  T_49_META_TYPE_134_D: "Loot Weapon Type",
  T_49_META_TYPE_135_D: "Generates ammo drops of the selected type",
  T_49_META_TYPE_136_D: "Generates a consumable drop of the selected type.",
  T_49_META_TYPE_137_D: "Generates a selected type of projectile drop",
  T_49_META_TYPE_138_D: "Spawns a scope drop of the selected type",
  T_49_META_TYPE_139_D: "Generates the selected type of armor drop.",
  T_49_META_TYPE_14_D: "In-game player entities, one per user",
  T_49_META_TYPE_140_D: "Wave",
  T_49_META_TYPE_141_D: "Loot Soccer Type",
  T_49_META_TYPE_142_D: "Loot Soccer Item Box",
  T_49_META_TYPE_143_D: "Lead1 music component type",
  T_49_META_TYPE_144_D: "Lead2 Music Component Type",
  T_49_META_TYPE_145_D: "Lead3 Music Component Type",
  T_49_META_TYPE_146_D: "Key Music Component Type",
  T_49_META_TYPE_147_D: "Multiple preset camera types available, as well as custom camera types",
  T_49_META_TYPE_148_D: "Camera components",
  T_49_META_TYPE_149_D: "Localization Key",
  T_49_META_TYPE_15_D: "In-game team entities, one per team",
  T_49_META_TYPE_150_D: "Oil Drum",
  T_49_META_TYPE_151_D: "Quaternion is a special four-dimensional vector used only to represent rotations",
  T_49_META_TYPE_152_D: "Low-Gravity Area",
  T_49_META_TYPE_153_D: "Entity containers that generate entities of the corresponding type at the location.",
  T_49_META_TYPE_154_D: "Dual-Wield Weapon Type",
  T_49_META_TYPE_155_D: "Helmet entity",
  T_49_META_TYPE_156_D: "Body armor",
  T_49_META_TYPE_157_D: "Camera Transition Type",
  T_49_META_TYPE_158_D: "Text prompt UI",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Level object entities",
  T_49_META_TYPE_160_D: "Texture Types",
  T_49_META_TYPE_161_D: "Un Replaceable Texture VFX",
  T_49_META_TYPE_162_D: "Type List",
  T_49_META_TYPE_163_D: "Type or Type List",
  T_49_META_TYPE_164_D: "Component is the base class of all entity components or specific component classes.",
  T_49_META_TYPE_165_D: "Collision box component",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "Special effect entity represents a displayed special effect (deleted, reusable).",
  T_49_META_TYPE_17_D: "Level Object List",
  T_49_META_TYPE_170_D: "Indicates whether visibility can be set",
  T_49_META_TYPE_171_D: "Mushroom",
  T_49_META_TYPE_172_D: "Ammo",
  T_49_META_TYPE_173_D: "Backpack",
  T_49_META_TYPE_174_D: "Grenade component",
  T_49_META_TYPE_175_D: "Freezing Grenade",
  T_49_META_TYPE_176_D: "Weapon Generator",
  T_49_META_TYPE_177_D: "Motion mode of the camera when there is an obstruction between the camera and the object it is following",
  T_49_META_TYPE_178_D: "Camera's imaging style when rendering a screen",
  T_49_META_TYPE_179_D: "Basic Sphere",
  T_49_META_TYPE_18_D: "(Deprecated, please do not use)",
  T_49_META_TYPE_180_D: "refers to a property of a component",
  T_49_META_TYPE_181_D: "Types used to describe mesh assets",
  T_49_META_TYPE_182_D: "A type used to describe a material asset",
  T_49_META_TYPE_183_D: "A type to describe a texture asset",
  T_49_META_TYPE_184_D: "Bridge rendering component for rendering with built-in model resources",
  T_49_META_TYPE_185_D: "Custom rendering component for rendering with custom model resources",
  T_49_META_TYPE_186_D: "A blank object component that can be used in conjunction with a renderer component, collider component, etc.",
  T_49_META_TYPE_187_D: "Container",
  T_49_META_TYPE_188_D: "Basic Cylinder",
  T_49_META_TYPE_189_D: "List of localized strings",
  T_49_META_TYPE_19_D: "A list template, where the type of content can be specified via T.",
  T_49_META_TYPE_190_D: "Two Team Score Panel",
  T_49_META_TYPE_191_D: "Tactical thrown weapon that blinds enemies within a certain range for a short period of time.",
  T_49_META_TYPE_192_D: "When used, it creates smoke that obscures events, which is a useful tool for interrupting enemy attacks.",
  T_49_META_TYPE_193_D: "Multi-Team Result Panel",
  T_49_META_TYPE_194_D: "Sensor mines that can be placed on the ground and will explode when an enemy approaches, be careful not to step on them yourself",
  T_49_META_TYPE_195_D: "Tween Campaign Playing Style",
  T_49_META_TYPE_197_D: "Playable Components",
  T_49_META_TYPE_198_D: "Item Base",
  T_49_META_TYPE_199_D: "Auxiliary equipment for aerial combat, but you need to keep an eye on the energy consumption at all times",
  T_49_META_TYPE_2_D: "Boolean types, to indicate true, false, or yes/no",
  T_49_META_TYPE_20_D: "A built-in enumeration of UI types, which is automatically generated by the type system.",
  T_49_META_TYPE_200_D: "Jailbreak area",
  T_49_META_TYPE_201_D: "Areas where you can swim after entering",
  T_49_META_TYPE_202_D: "ColliderID",
  T_49_META_TYPE_203_D: "Tween Movement",
  T_49_META_TYPE_204_D: "Shoes fitted with technological power-ups that allow you to jump in the air in two stages",
  T_49_META_TYPE_205_D: "A glider that can fly in the sky, use it to land from a high place to move farther away",
  T_49_META_TYPE_206_D: "Skateboard",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "List of Playables",
  T_49_META_TYPE_209_D: "Playable or List of Playables",
  T_49_META_TYPE_21_D: "Built-in UI entities, which encapsulate specific functionality.",
  T_49_META_TYPE_210_D: "Trajectory Animation is an animation that simulates Trajectory movement.",
  T_49_META_TYPE_211_D: "Coordinate System",
  T_49_META_TYPE_212_D: "One object follows another object",
  T_49_META_TYPE_213_D: "An object's front face is always facing the other object.",
  T_49_META_TYPE_214_D: "An ID that describes a gallery sprite asset",
  T_49_META_TYPE_215_D: "results of a competition",
  T_49_META_TYPE_216_D: "Dictionary data container, the data elements are a pair of Key, Value.",
  T_49_META_TYPE_217_D: "Dictionary data template, can be specified by T1, T2 type of content",
  T_49_META_TYPE_218_D: "A type of light source that emits light of equal intensity in all directions from the position of the light source.",
  T_49_META_TYPE_219_D: "Motorcycle Carrier",
  T_49_META_TYPE_22_D: "Custom UIs, created by the player through the UI editor.",
  T_49_META_TYPE_220_D: "Assault vehicle (tricycle) carrier",
  T_49_META_TYPE_221_D: "Amphibious/Machine Gun Motorcycle Vehicle",
  T_49_META_TYPE_222_D: "Four-wheeled vehicle",
  T_49_META_TYPE_224_D: "Skill Type List",
  T_49_META_TYPE_225_D: "Artificial Intelligence Turret made of high-tech materials that actively searches for and attacks enemies within a certain range.",
  T_49_META_TYPE_226_D: "Turret generated by using turret consumable.",
  T_49_META_TYPE_227_D: "Custom UI widgets type enumeration",
  T_49_META_TYPE_23_D: "An enumeration of the level's object types, which is automatically generated by the system based on the type.",
  T_49_META_TYPE_231_D: "Repair Kit",
  T_49_META_TYPE_233_D: "Progress Circle",
  T_49_META_TYPE_234_D: "Landmine Created",
  T_49_META_TYPE_235_D: "Gloo Wall",
  T_49_META_TYPE_236_D: "Ice Wall Created",
  T_49_META_TYPE_237_D: "Hook Gun",
  T_49_META_TYPE_238_D: "Rainbow Paint Gun",
  T_49_META_TYPE_239_D: "Spray Rifle",
  T_49_META_TYPE_24_D: "Current system-defined damage types",
  T_49_META_TYPE_240_D: "Entities are the carriers of all components, components must be attached to entities to produce instances",
  T_49_META_TYPE_241_D: "Power Hook Gun",
  T_49_META_TYPE_242_D: "Score Bar",
  T_49_META_TYPE_243_D: "Clothing slots",
  T_49_META_TYPE_244_D: "Text entity represents a displayed text",
  T_49_META_TYPE_245_D: "Icon entity represents a displayed icon",
  T_49_META_TYPE_246_D: "Spray Color",
  T_49_META_TYPE_247_D: "Player UI type",
  T_49_META_TYPE_248_D: "General UI switch entity",
  T_49_META_TYPE_249_D: "Switch Equip Slot",
  T_49_META_TYPE_25_D: "Phases of the game, such as game start, game preparation, game end, etc.",
  T_49_META_TYPE_250_D: "Effects entity represents a displayed effect",
  T_49_META_TYPE_2500_D: "The player's birth point",
  T_49_META_TYPE_2501_D: "Triggers for triggering the player's (or other object's) entry and exit events",
  T_49_META_TYPE_2502_D: "Death or invulnerability triggers that control whether the player is dead or invulnerable effects when entering based on properties",
  T_49_META_TYPE_2503_D: "Race mode checkpoints",
  T_49_META_TYPE_2504_D: "Typically used in Race Mode to recognize when a player has entered a specified finish line. This is a specific trigger, custom triggers will be opened later, this endpoint is just a wrapper for custom triggers.",
  T_49_META_TYPE_2505_D: "Fence around the birth point, close it to leave the birth point",
  T_49_META_TYPE_2507_D: "Turret",
  T_49_META_TYPE_2508_D: "Monster Spawn",
  T_49_META_TYPE_2509_D: "Instances of the type can be generated on demand",
  T_49_META_TYPE_251_D: "Effect Container",
  T_49_META_TYPE_2510_D: "Player birth area (rectangle)",
  T_49_META_TYPE_252_D: "Spray Result UI",
  T_49_META_TYPE_253_D: "Hint Button",
  T_49_META_TYPE_254_D: "Heartbeat Effect",
  T_49_META_TYPE_255_D: "Timestamp Localization String",
  T_49_META_TYPE_256_D: "Rigidbody Type",
  T_49_META_TYPE_257_D: "Rigid body components",
  T_49_META_TYPE_258_D: "Timestamp Format Style Type",
  T_49_META_TYPE_259_D: "Tips",
  T_49_META_TYPE_26_D: "Rounds in a game, often a small game with several phases.",
  T_49_META_TYPE_260_D: "Progress Skill Button",
  T_49_META_TYPE_261_D: "Unique ID",
  T_49_META_TYPE_262_D: "Weapon Skin ID",
  T_49_META_TYPE_263_D: "Clothing ID",
  T_49_META_TYPE_264_D: "Consumable ID, when the version only has the weapon ID",
  T_49_META_TYPE_265_D: "UI panel entity",
  T_49_META_TYPE_267_D: "UI scroll view entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_268_D: "A switch with three states, with the option to keep the original logic except for on and off.",
  T_49_META_TYPE_269_D: "The player's equipment.",
  T_49_META_TYPE_270_D: "Entity or Prefab ID",
  T_49_META_TYPE_271_D: "UI panel entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_272_D: "Gender enumeration",
  T_49_META_TYPE_273_D: "Minimap",
  T_49_META_TYPE_274_D: "Icon displayed on the mini-map to follow the target",
  T_49_META_TYPE_275_D: "Individual part nodes in the skeleton",
  T_49_META_TYPE_276_D: "Nodes used to access skinned rigs",
  T_49_META_TYPE_277_D: "Client-side camera ray detection",
  T_49_META_TYPE_278_D: "Pixel blocks displayed on the mini-map, representing the collision size of the object at that location.",
  T_49_META_TYPE_279_D: "Color Drum",
  T_49_META_TYPE_28_D: "Reset at the beginning of each round.",
  T_49_META_TYPE_280_D: "Sphere Trigger",
  T_49_META_TYPE_281_D: "Capsule Trigger",
  T_49_META_TYPE_282_D: "Type describing the asset configuration ID, used to indicate that the parent package comes with the asset configuration ID, which needs to be parsed through the configuration table before loading",
  T_49_META_TYPE_283_D: "Describe the type of asset, used to indicate the identifier of the asset, can be loaded directly.",
  T_49_META_TYPE_284_D: "Indicates a humanoid model resource, which can be replaced with a player character.",
  T_49_META_TYPE_285_D: "A list or dictionary that can be traversed in a loop.",
  T_49_META_TYPE_286_D: "ID to describe the script asset",
  T_49_META_TYPE_287_D: "to describe the ID of a static script asset",
  T_49_META_TYPE_288_D: "to describe the ID of a custom UI asset",
  T_49_META_TYPE_289_D: "ID for describing the body of a preconfigured asset",
  T_49_META_TYPE_29_D: "Special effects",
  T_49_META_TYPE_290_D: "Behavior Tree",
  T_49_META_TYPE_291_D: "Behavior Tree Node Type",
  T_49_META_TYPE_292_D: "Behavior Tree Custom Node",
  T_49_META_TYPE_293_D: "Behavior Tree Attachable",
  T_49_META_TYPE_294_D: "UI layout entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_295_D: "State",
  T_49_META_TYPE_296_D: "Animation Clip",
  T_49_META_TYPE_297_D: "Animation Controller",
  T_49_META_TYPE_298_D: "Loop Type",
  T_49_META_TYPE_3_D: "Integer types, 32-bit signed integers",
  T_49_META_TYPE_30_D: "Icon",
  T_49_META_TYPE_300_D: "UI3DContainer entity, UI edited by the player via the UI Editor",
  T_49_META_TYPE_301_D: "AI Skill Type",
  T_49_META_TYPE_302_D: "Enumeration of equipment slots.",
  T_49_META_TYPE_303_D: "Corresponds to the Id column in BuffData.csv, please check with GPP before adding new items.",
  T_49_META_TYPE_304_D: "Buff Type List",
  T_49_META_TYPE_305_D: "Behavior Tree Node Status",
  T_49_META_TYPE_306_D: "Add buffs, remove buffs, and get a list of buffs already added.",
  T_49_META_TYPE_307_D: "Gloo Maker",
  T_49_META_TYPE_308_D: "Special Item ID Type",
  T_49_META_TYPE_309_D: "Thrown Object Props",
  T_49_META_TYPE_31_D: "Sound Effects",
  T_49_META_TYPE_310_D: "Crossbow",
  T_49_META_TYPE_311_D: "Grenade Base",
  T_49_META_TYPE_312_D: "Throwable props",
  T_49_META_TYPE_313_D: "Grenade DeIce Wall",
  T_49_META_TYPE_314_D: "Managing Animation Controllers and Resources",
  T_49_META_TYPE_315_D: "Player Backpack",
  T_49_META_TYPE_316_D: "UITexture entity, the UI edited by the player through the UI editor",
  T_49_META_TYPE_317_D: "Rigid body motion constraints, each of which can be used in combination",
  T_49_META_TYPE_318_D: "Attachment",
  T_49_META_TYPE_319_D: "Fill type enumeration",
  T_49_META_TYPE_32_D: "Player state type",
  T_49_META_TYPE_320_D: "Fill direction",
  T_49_META_TYPE_321_D: "Entities that can be target-assisted",
  T_49_META_TYPE_322_D: "Damaged Body Part Type",
  T_49_META_TYPE_323_D: "UIProfileInfo entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_324_D: "Several different effects of rigid body forces. Note that this only works for Dynamic types.",
  T_49_META_TYPE_325_D: "to describe the ID of a widget in a custom UI asset",
  T_49_META_TYPE_326_D: "Player profile information",
  T_49_META_TYPE_327_D: "Configure dressing according to each component",
  T_49_META_TYPE_328_D: "Behavior Tree ID",
  T_49_META_TYPE_329_D: "Seat Type",
  T_49_META_TYPE_33_D: "Sort by: ascending ignore zero value, descending, ascending",
  T_49_META_TYPE_330_D: "Self-relative movement",
  T_49_META_TYPE_331_D: "Bezier Curve",
  T_49_META_TYPE_332_D: "Loopable component",
  T_49_META_TYPE_333_D: "Font Type",
  T_49_META_TYPE_334_D: "Vehicle Skin ID",
  T_49_META_TYPE_335_D: "The sound entity represents a playing sound effect.",
  T_49_META_TYPE_336_D: "Sound Effect List",
  T_49_META_TYPE_337_D: "Sound Effect or Sound Effect List",
  T_49_META_TYPE_338_D: "Player behavior property synchronization entity",
  T_49_META_TYPE_339_D: "Equipment Accessory",
  T_49_META_TYPE_34_D: "Item ID",
  T_49_META_TYPE_340_D: "Bot Difficulty Type",
  T_49_META_TYPE_341_D: "Dictionary of integers",
  T_49_META_TYPE_342_D: "Timer objects",
  T_49_META_TYPE_343_D: "Flying Daggers (pickable)",
  T_49_META_TYPE_344_D: "Throwing Knife",
  T_49_META_TYPE_345_D: "Weapon Type",
  T_49_META_TYPE_346_D: "Ammo Type",
  T_49_META_TYPE_347_D: "Frame Self Relative",
  T_49_META_TYPE_348_D: "Function pointer to a function instance, used to implement dummy functions or delegate mechanism.",
  T_49_META_TYPE_349_D: "A handle to a concurrent program, which can be used to perform some handle operations.",
  T_49_META_TYPE_350_D: "Vehicle enumeration",
  T_49_META_TYPE_351_D: "Describes the type of the object",
  T_49_META_TYPE_352_D: "UIToggle entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_353_D: "MedKit",
  T_49_META_TYPE_354_D: "Inhaler",
  T_49_META_TYPE_355_D: "Horizaline",
  T_49_META_TYPE_356_D: "Airdrops, will start dropping from a high place after the preparation time is over",
  T_49_META_TYPE_357_D: "Descriptive colors for objects, such as borders, surfaces, etc. (deleted, reusable)",
  T_49_META_TYPE_358_D: "Refers to an event",
  T_49_META_TYPE_359_D: "Player controller with physics effects to apply forces.",
  T_49_META_TYPE_360_D: "Launch Pad",
  T_49_META_TYPE_361_D: "Folded cannon, when unfolded it can be used to launch people out, be careful not to launch yourself out of the safe zone!",
  T_49_META_TYPE_362_D: "Snowball fight! Punch it!",
  T_49_META_TYPE_363_D: "Shop request purchase",
  T_49_META_TYPE_364_D: "AnimationTrigger",
  T_49_META_TYPE_365_D: "Animation Trigger UI Component",
  T_49_META_TYPE_366_D: "Batch Combine Render",
  T_49_META_TYPE_367_D: "Top Compass",
  T_49_META_TYPE_368_D: "Custom character resource ID",
  T_49_META_TYPE_369_D: "Custom animation resource ID",
  T_49_META_TYPE_370_D: "Information displayed at the start of a round",
  T_49_META_TYPE_371_D: "At the end of each round, the results are displayed.",
  T_49_META_TYPE_372_D: "Player Stance Types",
  T_49_META_TYPE_373_D: "Collection ID, used for resource information collection",
  T_49_META_TYPE_374_D: "Follow Health Bar",
  T_49_META_TYPE_375_D: "Monster target type",
  T_49_META_TYPE_376_D: "Defense tower attack target type",
  T_49_META_TYPE_377_D: "Alias to refer to player entity, vehicle entity type",
  T_49_META_TYPE_378_D: "to describe the ID of an audio asset",
  T_49_META_TYPE_379_D: "ID to describe the configuration table asset",
  T_49_META_TYPE_38_D: "UI Empty Widget entity, UI edited by the player through the UI editor.",
  T_49_META_TYPE_380_D: "ID to describe the effects asset",
  T_49_META_TYPE_381_D: "ID to describe the Animation Controller asset",
  T_49_META_TYPE_382_D: "How knockdown status is handled",
  T_49_META_TYPE_383_D: "Surface or decorations on the map itself",
  T_49_META_TYPE_384_D: "Items",
  T_49_META_TYPE_385_D: "Character Skill ID",
  T_49_META_TYPE_386_D: "Skill ID List",
  T_49_META_TYPE_387_D: "UITouchPad entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_388_D: "Backpack Skin ID",
  T_49_META_TYPE_389_D: "Joystick entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_39_D: "UI image entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_390_D: "Hierarchical",
  T_49_META_TYPE_391_D: "Custom UI or Widget",
  T_49_META_TYPE_392_D: "Placeable out-of-zone objects",
  T_49_META_TYPE_393_D: "Entities with PhysicalCCT or Rigidbody component",
  T_49_META_TYPE_394_D: "Mathematical constants",
  T_49_META_TYPE_395_D: "Entities with PhysicalCCT or PlayerCCT components can move along with them.",
  T_49_META_TYPE_396_D: "Mid-Game Exit Configuration",
  T_49_META_TYPE_397_D: "Components used to describe collision shapes",
  T_49_META_TYPE_398_D: "String or Localization String",
  T_49_META_TYPE_399_D: "Character Controller with Physical Effects, for FF characters only.",
  T_49_META_TYPE_4_D: "Floating-point type, 32-bit single-precision floating-point number",
  T_49_META_TYPE_40_D: "UI Text entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_400_D: "How to perform the attack behavior",
  T_49_META_TYPE_401_D: "Fire Type",
  T_49_META_TYPE_402_D: "Social Button Widget",
  T_49_META_TYPE_403_D: "Social Button Types",
  T_49_META_TYPE_404_D: "Social Button Styles",
  T_49_META_TYPE_405_D: "Layout Sort Type",
  T_49_META_TYPE_406_D: "Can be triggered to go over obstacles",
  T_49_META_TYPE_407_D: "Platform Type",
  T_49_META_TYPE_408_D: "Base Data Alias",
  T_49_META_TYPE_409_D: "Error code enumeration",
  T_49_META_TYPE_41_D: "UI button entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_410_D: "Alias that refers to a player entity or Transform entity type",
  T_49_META_TYPE_411_D: "Helicopter Carrier",
  T_49_META_TYPE_412_D: "Vehicle component, which is an extension of the Carrier component.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limits the range of camera rotation angles",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona Chat Window UI",
  T_49_META_TYPE_417_D: "Particle entity component",
  T_49_META_TYPE_418_D: "Member status enumeration",
  T_49_META_TYPE_419_D: "Gun Skin Type",
  T_49_META_TYPE_42_D: "UI input entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_420_D: "Vehicle Skin Types",
  T_49_META_TYPE_421_D: "Skin",
  T_49_META_TYPE_422_D: "Backpack Skin Types",
  T_49_META_TYPE_423_D: "Persona ID",
  T_49_META_TYPE_424_D: "Fog effect base type",
  T_49_META_TYPE_425_D: "Particle asset ID",
  T_49_META_TYPE_426_D: "A type of light source that emits a cone of light in the negative Y-axis direction from the light source, defaulting to the ground.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Clothing information to be retained when the player transforms into another character.",
  T_49_META_TYPE_429_D: "Player or NPC entities",
  T_49_META_TYPE_43_D: "List of element types that must be player entities",
  T_49_META_TYPE_430_D: "Random Number Generator",
  T_49_META_TYPE_431_D: "Motion objects moving along a customized path",
  T_49_META_TYPE_432_D: "Custom Curve Path Waypoints",
  T_49_META_TYPE_433_D: "Custom curve path waypoint types",
  T_49_META_TYPE_434_D: "Custom Curve Paths",
  T_49_META_TYPE_435_D: "List of unique player identifiers",
  T_49_META_TYPE_436_D: "Error code list",
  T_49_META_TYPE_437_D: "Two teams match details UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_438_D: "Multi-team match details UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_439_D: "Combine",
  T_49_META_TYPE_44_D: "A list of entities whose element types must be team entities",
  T_49_META_TYPE_440_D: "Timeline",
  T_49_META_TYPE_441_D: "Timeline Resource ID",
  T_49_META_TYPE_442_D: "New two-team match information short version entity component, supports fully customizable headcount display",
  T_49_META_TYPE_443_D: "Dialog stream asset ID",
  T_49_META_TYPE_444_D: "Language Type",
  T_49_META_TYPE_45_D: "Bool List",
  T_49_META_TYPE_46_D: "Int List",
  T_49_META_TYPE_47_D: "Float List",
  T_49_META_TYPE_48_D: "String List",
  T_49_META_TYPE_49_D: "Vector3 List",
  T_49_META_TYPE_5_D: "String type, value is text content",
  T_49_META_TYPE_50_D: "A list of entities whose element types must be entities",
  T_49_META_TYPE_51_D: "Zombie Types",
  T_49_META_TYPE_53_D: "Common Level Object",
  T_49_META_TYPE_54_D: "Destructible Object",
  T_49_META_TYPE_55_D: "General Spawn Point",
  T_49_META_TYPE_56_D: "Vehicle",
  T_49_META_TYPE_57_D: "Players can be teleported to a specific location upon entry",
  T_49_META_TYPE_58_D: "Buffs can be generated on demand",
  T_49_META_TYPE_59_D: "Moving Platform",
  T_49_META_TYPE_6_D: "Three-dimensional vectors, which can represent spatial coordinates or spatial directions",
  T_49_META_TYPE_60_D: "Generates a weapon drop of the selected type.",
  T_49_META_TYPE_61_D: "Entering the trigger range opens the Bound Shop.",
  T_49_META_TYPE_62_D: "Bouncy Dice",
  T_49_META_TYPE_63_D: "Players step on them and they will be bounced to a specific location.",
  T_49_META_TYPE_64_D: "Players will make a sound when stepping on them",
  T_49_META_TYPE_65_D: "Basic Scalable",
  T_49_META_TYPE_66_D: "Custom Path",
  T_49_META_TYPE_67_D: "Path Point",
  T_49_META_TYPE_68_D: "AI monster entities, such as zombies",
  T_49_META_TYPE_69_D: "Large numbers are high precision floating point numbers",
  T_49_META_TYPE_7_D: "Numbers are type aliases that refer to integer, 64-bit integer, or floating-point types",
  T_49_META_TYPE_70_D: "Property formulas are used to calculate entity property values, only some player properties and weapon properties are supported for now.",
  T_49_META_TYPE_71_D: "Only used for entities sold in the shop, the concept of shop items is different from that of items purchased.",
  T_49_META_TYPE_72_D: "Contains several shop items.",
  T_49_META_TYPE_73_D: "Contains several shelves.",
  T_49_META_TYPE_74_D: "Item ID",
  T_49_META_TYPE_75_D: "Come Back",
  T_49_META_TYPE_76_D: "Patrol style",
  T_49_META_TYPE_77_D: "A generator entity that can generate and refresh objects.",
  T_49_META_TYPE_78_D: "A unit entity that can be used by the unit generator to absorb and generate units in batches.",
  T_49_META_TYPE_79_D: "Weapon",
  T_49_META_TYPE_8_D: "Conditionals are special Bool types",
  T_49_META_TYPE_80_D: "UI of the shop",
  T_49_META_TYPE_81_D: "Buff Type",
  T_49_META_TYPE_82_D: "UI Heartbeat",
  T_49_META_TYPE_83_D: "Interaction Button",
  T_49_META_TYPE_84_D: "Rankable entity, capable of being ranked",
  T_49_META_TYPE_85_D: "Scoreable entity, has its own score",
  T_49_META_TYPE_86_D: "Property formula factor type",
  T_49_META_TYPE_87_D: "Describes the type of RGBA color, the range of value is 0~255 for each channel.",
  T_49_META_TYPE_88_D: "Currency type, currently only the base currency type",
  T_49_META_TYPE_89_D: "Currency entity, which describes the type and amount of currency.",
  T_49_META_TYPE_9_D: "A set of conditions",
  T_49_META_TYPE_90_D: "Wallet entities are containers for a bunch of currency entities",
  T_49_META_TYPE_91_D: "Indicates an integer or integer array type.",
  T_49_META_TYPE_92_D: "Dynamic Create Level Object Type",
  T_49_META_TYPE_93_D: "Entities with formulable properties",
  T_49_META_TYPE_94_D: "Property modification",
  T_49_META_TYPE_95_D: "Coin Generator",
  T_49_META_TYPE_96_D: "Wallet",
  T_49_META_TYPE_97_D: "Position rotation and scaling, supports parent-child structure",
  T_49_META_TYPE_98_D: "List all available types",
  T_49_META_TYPE_99_D: "Football"
};
export {
  _ as default
};
